
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5Uorw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fe742ddc5d68e908$export$2e2bcd8739ae039);

var $byeh6 = parcelRequire("byeh6");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lrmdv = parcelRequire("lrmdv");
const $fe742ddc5d68e908$var$HorizontalNavJiraInner = ({ queries: { horizontalNavQuery: horizontalNavQuery } })=>{
    /*
   * Keep this component as small as possible! Ideally, it is so small that all it does is call usePreloadedQuery,
   * spread JiraHorizontalNavigationContent and the response into into JiraHorizontalNavigationContent.
   *
   * This means we don't run into the issue of having to import the compiled query into mocks, which means you can't add
   * @relay_test_operation to the query in the test/storybook, which can create hard-to-solve mock issues like this one:
   * https://hello.atlassian.net/wiki/x/FzuK1w
   * */ const data = (0, $j4oe4.usePreloadedQuery)((0, $byeh6.default), horizontalNavQuery);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lrmdv.default), {
        queryRef: data
    });
};
var $fe742ddc5d68e908$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($fe742ddc5d68e908$var$HorizontalNavJiraInner);

});
parcelRegister("byeh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $82bde2de23c60ccc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<25637c34c77ecbacbdb193525c6b35dc>>
 * @relayHash 803bd2411b5ccfb7091d5aac3095a48a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6d9f5406464f687f1985513ff8a0101826fc3041b4f0dee81c75ab40777cf9e2

var $7KZsS = parcelRequire("7KZsS");

var $gpGBt = parcelRequire("gpGBt");

var $811y8 = parcelRequire("811y8");

var $37Ewn = parcelRequire("37Ewn");
const $82bde2de23c60ccc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "teamsConnected",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6d9f5406464f687f1985513ff8a0101826fc3041b4f0dee81c75ab40777cf9e2",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $7KZsS.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $811y8.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $gpGBt.default)
            }
        }
    };
}();
$82bde2de23c60ccc$var$node.hash = "cfedd5347d81ca2f36fa810c25c638f4";
(0, $37Ewn.PreloadableQueryRegistry).set($82bde2de23c60ccc$var$node.params.id, $82bde2de23c60ccc$var$node);
var $82bde2de23c60ccc$export$2e2bcd8739ae039 = $82bde2de23c60ccc$var$node;

});

parcelRegister("lrmdv", function(module, exports) {

$parcel$export(module.exports, "default", () => $764fbefd2071dabb$export$2e2bcd8739ae039);

var $kqz3K = parcelRequire("kqz3K");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $iX5t3 = parcelRequire("iX5t3");

var $5bzWA = parcelRequire("5bzWA");

var $c6cN5 = parcelRequire("c6cN5");

var $1KdDN = parcelRequire("1KdDN");

var $9NAa8 = parcelRequire("9NAa8");

var $iEYnI = parcelRequire("iEYnI");

var $3O0A9 = parcelRequire("3O0A9");

var $hWbfz = parcelRequire("hWbfz");
function $764fbefd2071dabb$export$d2542992df1e054(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
const $764fbefd2071dabb$var$JiraHorizontalNavigationContentComponent = ({ queryRef: queryRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $kqz3K.default), queryRef);
    const project = data.jira_projectByIdOrKey;
    const [isFullscreen] = (0, $5bzWA.useIsFullscreen)();
    const setMostRecentlyViewedBoard = (0, $c6cN5.useSetMostRecentlyViewedBoard)();
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('jfp-magma-concurrent-board-perf-3')) $764fbefd2071dabb$export$d2542992df1e054(()=>{
            if (data?.jira?.containerNavigation?.scopeId && project?.softwareBoardCount && project.softwareBoardCount > 0) setMostRecentlyViewedBoard?.(data.jira.containerNavigation.scopeId, project?.__id);
        });
        else if (data?.jira?.containerNavigation?.scopeId && project?.softwareBoardCount && project.softwareBoardCount > 0) setMostRecentlyViewedBoard?.(data.jira.containerNavigation.scopeId, project?.__id);
    }, [
        setMostRecentlyViewedBoard,
        data?.jira?.containerNavigation?.scopeId,
        project?.__id,
        project?.softwareBoardCount
    ]);
    // Some routes with invalid project scope or scope Id request for horizontal navigation
    // E.g. JSM projects do not support horizontal navigation, but connect app routes in JSM will request for it
    // These cases are unprocessable and return a dedicated 422 error, so we can skip rendering and return null
    if (data.jira?.containerNavigation?.extensions?.[0]?.statusCode === 422) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, project && (0, $7jTnu.fg)('jira_custom_templates_ux') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NAa8.CustomTemplateProjectBanner), {
        projectFragment: project
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3O0A9.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iEYnI.default), {
        projectFragment: project,
        queryFragment: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "HorizontalNavTabContentErrorBoundary",
        packageName: "jiraHorizontalNav",
        fallback: (0, $iX5t3.TabsSkeleton)
    }, !isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hWbfz.default), {
        projectFragment: project,
        queryFragment: data
    }) : null)));
};
const $764fbefd2071dabb$var$JiraHorizontalNavigationContent = /*#__PURE__*/ (0, $eJOHy.memo)($764fbefd2071dabb$var$JiraHorizontalNavigationContentComponent);
var $764fbefd2071dabb$export$2e2bcd8739ae039 = $764fbefd2071dabb$var$JiraHorizontalNavigationContent;

});
parcelRegister("kqz3K", function(module, exports) {

$parcel$export(module.exports, "default", () => $d69048efbb0fe9af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a86618c278da68f77dfd7cea3a0d726e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d69048efbb0fe9af$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "containerNavigationInput"
        },
        {
            "kind": "RootArgument",
            "name": "projectIdOrKey"
        },
        {
            "kind": "RootArgument",
            "name": "withProject"
        }
    ],
    "kind": "Fragment",
    "name": "JiraHorizontalNavigationContent",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabsContent_query"
        },
        {
            "kind": "FragmentSpread",
            "name": "NavHeader_query"
        },
        {
            "condition": "withProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "idOrKey",
                            "variableName": "projectIdOrKey"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "TabsContent_project"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "NavHeader_project"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "CustomTemplateProjectBanner"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "softwareBoardCount"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "containerNavigationInput"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "containerNavigation",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scopeId"
                                    }
                                ],
                                "type": "JiraContainerNavigation"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "extensions",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "statusCode"
                                            }
                                        ]
                                    }
                                ],
                                "type": "QueryError"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira.containerNavigation"
                }
            ]
        }
    ],
    "type": "Query"
};
$d69048efbb0fe9af$var$node.hash = "9a87f5d323bf1da69997ea76a7a24c06";
var $d69048efbb0fe9af$export$2e2bcd8739ae039 = $d69048efbb0fe9af$var$node;

});

parcelRegister("5bzWA", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $c5e933a3117521b9$export$d397eccea5f37b0a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $c5e933a3117521b9$export$d397eccea5f37b0a = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>state.isFullscreen
});

});
parcelRegister("fZsy4", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $00171a4137f359c3$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $00171a4137f359c3$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $00171a4137f359c3$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $00171a4137f359c3$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $00171a4137f359c3$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4BzWx = parcelRequire("4BzWx");
const $00171a4137f359c3$export$539e68c09584883a = 240;
const $00171a4137f359c3$export$b92df8810d2fcd01 = 0;
const $00171a4137f359c3$export$47a4b4760f306fb9 = 400;
const $00171a4137f359c3$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $00171a4137f359c3$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        },
        previewPanel: {
            width: $00171a4137f359c3$export$47a4b4760f306fb9
        }
    }
};
const $00171a4137f359c3$export$b8cdfd44cddaf07 = (0, $GtRbT.createStore)({
    initialState: $00171a4137f359c3$var$initialState,
    actions: $4BzWx.actions,
    name: 'JiraLayoutStore'
});
const $00171a4137f359c3$export$6136bc3b9858cff4 = (0, $iJq0l.createHook)($00171a4137f359c3$export$b8cdfd44cddaf07, {
    selector: null
});
const $00171a4137f359c3$var$detailPanelWidthStore = (0, $GtRbT.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $00171a4137f359c3$export$95fd7b6da3b9bbb0 = (0, $iJq0l.createHook)($00171a4137f359c3$var$detailPanelWidthStore);
const $00171a4137f359c3$export$99e05a60cac05e86 = (0, $iJq0l.createActionsHook)($00171a4137f359c3$var$detailPanelWidthStore);

});
parcelRegister("4BzWx", function(module, exports) {

$parcel$export(module.exports, "actions", () => $106bfd5c0a8dc2d4$export$e324594224ef24da);

var $iK07n = parcelRequire("iK07n");

var $iCv0U = parcelRequire("iCv0U");

var $71bAj = parcelRequire("71bAj");

var $5BHLU = parcelRequire("5BHLU");

var $kF3cb = parcelRequire("kF3cb");

var $3rHRj = parcelRequire("3rHRj");

var $eFmzH = parcelRequire("eFmzH");
const $106bfd5c0a8dc2d4$export$e324594224ef24da = {
    setIsChromeless: // global
    $71bAj.setIsChromeless,
    setIsFullscreen: $5BHLU.setIsFullscreen,
    showBanner: // banner
    $iK07n.showBanner,
    dismissCurrentBanner: $iK07n.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $kF3cb.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $3rHRj.setRightSidebarState,
    openRightSidebar: $3rHRj.openRightSidebar,
    closeRightSidebar: $3rHRj.closeRightSidebar,
    closeAllRightSidebar: $3rHRj.closeAllRightSidebar,
    closeCurrentRightSidebar: $3rHRj.closeCurrentRightSidebar,
    minimiseRightSidebar: $3rHRj.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $iCv0U.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $iCv0U.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $iCv0U.removeBottomRightCornerPortal,
    setPreviewPanelState: // preview panel
    $eFmzH.setPreviewPanelState
};

});
parcelRegister("iK07n", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $f576dda57f9ab932$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $f576dda57f9ab932$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f576dda57f9ab932$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $f576dda57f9ab932$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($f576dda57f9ab932$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("iCv0U", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $d6992d5ac6ea80d0$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $d6992d5ac6ea80d0$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $d6992d5ac6ea80d0$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d6992d5ac6ea80d0$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $d6992d5ac6ea80d0$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $d6992d5ac6ea80d0$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("71bAj", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $3013b300b3f3be1a$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $3013b300b3f3be1a$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("5BHLU", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $49bc45ba37aeb566$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $49bc45ba37aeb566$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("kF3cb", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $03b023977e84cb41$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $03b023977e84cb41$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("3rHRj", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $38d64587782ceabb$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $38d64587782ceabb$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $38d64587782ceabb$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $38d64587782ceabb$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $38d64587782ceabb$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $38d64587782ceabb$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $38d64587782ceabb$export$c8dafe074328c4ca);

var $cSmYj = parcelRequire("cSmYj");
const $38d64587782ceabb$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $38d64587782ceabb$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $38d64587782ceabb$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $38d64587782ceabb$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $38d64587782ceabb$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $38d64587782ceabb$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $38d64587782ceabb$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $38d64587782ceabb$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $38d64587782ceabb$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $38d64587782ceabb$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $38d64587782ceabb$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $38d64587782ceabb$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});

parcelRegister("eFmzH", function(module, exports) {

$parcel$export(module.exports, "setPreviewPanelState", () => $64e9612ff0fed2ac$export$ba6353031892dd17);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $64e9612ff0fed2ac$export$ba6353031892dd17 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                previewPanel: {
                    ...content.previewPanel,
                    ...newState
                }
            }
        });
    };

});




parcelRegister("c6cN5", function(module, exports) {

$parcel$export(module.exports, "useSetMostRecentlyViewedBoard", () => $4b51a3e4c8fe59ab$export$3c43491dc3e7b6a8);

var $3se94 = parcelRequire("3se94");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $4SjAP = parcelRequire("4SjAP");

var $kqd31 = parcelRequire("kqd31");
const $4b51a3e4c8fe59ab$export$d1b013dc8403efee = 'setMostRecentlyViewedBoard';
const $4b51a3e4c8fe59ab$export$b8b9d90f9e5bd72b = 'horizontalNavSoftware';
const $4b51a3e4c8fe59ab$export$d57b6b390e78d90f = 'Navigation';
const $4b51a3e4c8fe59ab$export$3c43491dc3e7b6a8 = ()=>{
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $3se94.default));
    const onError = (0, $eJOHy.useCallback)((error)=>{
        (0, $gYnSx.default)({
            meta: {
                id: $4b51a3e4c8fe59ab$export$d1b013dc8403efee,
                packageName: $4b51a3e4c8fe59ab$export$b8b9d90f9e5bd72b,
                teamName: $4b51a3e4c8fe59ab$export$d57b6b390e78d90f
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, []);
    return (0, $eJOHy.useCallback)((id, projectRelayId)=>{
        commitMutation({
            variables: {
                id: id
            },
            onError: onError,
            updater: (store, data)=>{
                if (!data?.jira?.setMostRecentlyViewedBoard?.success || !projectRelayId) return;
                const parentRecord = store.get(projectRelayId);
                const newBoardDataId = (0, $kqd31.default)({
                    id: data?.jira?.setMostRecentlyViewedBoard?.board?.id
                }, 'JiraBoard');
                const newBoardRecord = newBoardDataId && store.get(newBoardDataId);
                if (parentRecord && newBoardRecord) parentRecord.setLinkedRecord(newBoardRecord, 'mostRecentlyViewedBoard');
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.setMostRecentlyViewedBoard ?? {};
                if (errors) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    !error.statusCode?.toString().startsWith('4') && onError(error);
                }
            }
        });
    }, [
        commitMutation,
        onError
    ]);
};

});
parcelRegister("3se94", function(module, exports) {

$parcel$export(module.exports, "default", () => $42e683a8ab5cb220$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a2587a8feb5ed65f63719a9f78f154d>>
 * @relayHash e4b9571054871d36ce4a62f8dfc3a347
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 460e3bc3e7ed3d8d27b904af0f9749ba9913444eb0c65d55e5522990c53522ff
const $42e683a8ab5cb220$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v3 = {
        "concreteType": "JiraBoard",
        "kind": "LinkedField",
        "name": "board",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setMostRecentlyViewedBoardMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetMostRecentlyViewedBoardPayload",
                            "kind": "LinkedField",
                            "name": "setMostRecentlyViewedBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setMostRecentlyViewedBoardMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetMostRecentlyViewedBoardPayload",
                            "kind": "LinkedField",
                            "name": "setMostRecentlyViewedBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v2 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "460e3bc3e7ed3d8d27b904af0f9749ba9913444eb0c65d55e5522990c53522ff",
            "metadata": {},
            "name": "setMostRecentlyViewedBoardMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$42e683a8ab5cb220$var$node.hash = "4cedd313a6b84b6c272b36ea0fb2a5e6";
var $42e683a8ab5cb220$export$2e2bcd8739ae039 = $42e683a8ab5cb220$var$node;

});

parcelRegister("4SjAP", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $354f7d6d59497f5a$export$10c788363424e94e);
class $354f7d6d59497f5a$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}

});


parcelRegister("9NAa8", function(module, exports) {

$parcel$export(module.exports, "CustomTemplateProjectBanner", () => $36f2644cebcbb8fb$export$659f09fccafc59ca);

var $aaw5M = parcelRequire("aaw5M");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3cMgR = parcelRequire("3cMgR");

var $kZSpL = parcelRequire("kZSpL");

var $lRq8t = parcelRequire("lRq8t");

var $3hPxr = parcelRequire("3hPxr");
const $36f2644cebcbb8fb$var$isBannerSupported = ()=>{
    if (false) return true;
    if (typeof window !== 'undefined') return window.__SPA__;
    return false;
};
const $36f2644cebcbb8fb$export$659f09fccafc59ca = ({ projectFragment: projectFragment })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $aaw5M.default), projectFragment);
    return data.isLiveTemplate === true && $36f2644cebcbb8fb$var$isBannerSupported() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kZSpL.JiraBanner), {
        appearance: "announcement",
        messageId: "horizontal-nav.ui.content.banner",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $3hPxr.default).customTemplateProjectBannerMessage)));
};

});
parcelRegister("aaw5M", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba13cff7107f85d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53e84c22517867c880da6c976b95643a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ba13cff7107f85d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CustomTemplateProjectBanner",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isLiveTemplate"
        }
    ],
    "type": "JiraProject"
};
$6ba13cff7107f85d$var$node.hash = "8fa4edcc596948b7b940eaf11aa2562a";
var $6ba13cff7107f85d$export$2e2bcd8739ae039 = $6ba13cff7107f85d$var$node;

});

parcelRegister("kZSpL", function(module, exports) {

$parcel$export(module.exports, "JiraBanner", () => $735e5a31d4bea264$export$23eaf79dd14ebe6e);

var $eJOHy = parcelRequire("eJOHy");

var $7mS2i = parcelRequire("7mS2i");

var $SyPNn = parcelRequire("SyPNn");

var $j2tD5 = parcelRequire("j2tD5");
const $735e5a31d4bea264$export$23eaf79dd14ebe6e = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j2tD5.ChoreographerBanner), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7mS2i.default), rest);
};

});
parcelRegister("j2tD5", function(module, exports) {

$parcel$export(module.exports, "ChoreographerBanner", () => $bc0a43425df5d870$export$d77caaec2153a90b);

var $7mS2i = parcelRequire("7mS2i");

var $1pkzT = parcelRequire("1pkzT");
const $bc0a43425df5d870$export$d77caaec2153a90b = (0, $1pkzT.withChoreographedRender)((0, $7mS2i.default));

});


parcelRegister("3hPxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c5fb73a28061f0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $60c5fb73a28061f0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    defaultViewRedirectFlagTitle: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-title",
        "defaultMessage": "We've taken you to the default view"
    },
    defaultViewRedirectFlagDescription: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-description",
        "defaultMessage": "The view you're trying to access has been removed."
    },
    customTemplateProjectBannerMessage: {
        "id": "jira-horizontal-nav.custom-template-project-banner-message",
        "defaultMessage": "This project is saved as a custom template. Project settings changes will apply to the template."
    },
    projectNavigation: {
        "id": "jira-horizontal-nav.project-navigation",
        "defaultMessage": "Project navigation"
    }
});

});


parcelRegister("iEYnI", function(module, exports) {

$parcel$export(module.exports, "default", () => $74beb965c7bda118$export$2e2bcd8739ae039);

var $dsAJR = parcelRequire("dsAJR");

var $5wSJj = parcelRequire("5wSJj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ln6Iy = parcelRequire("ln6Iy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $1sZnn = parcelRequire("1sZnn");

var $6R5QV = parcelRequire("6R5QV");

var $lJuT9 = parcelRequire("lJuT9");
const $74beb965c7bda118$var$NavHeader = ({ queryFragment: queryFragment, projectFragment: projectFragment = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const data = (0, $j4oe4.useFragment)((0, $5wSJj.default), queryFragment);
    const projectData = (0, $j4oe4.useFragment)((0, $dsAJR.default), projectFragment);
    // a user board can only exist outside of a project
    if (data.jira.jiraBoard?.__typename === 'JiraBoard' && !projectData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJuT9.UserBoardHeader), {
        boardFragment: data.jira.jiraBoard
    });
    // from this point, we only support project scope
    if (!projectData) return null;
    if ((0, $7jTnu.fg)('issue_terminology_refresh_change_boarding_modal')) {
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'projectOrIssuePage',
            action: 'viewed'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'projectOrIssueScreen');
    }
    const board = data.jira.jiraBoard ?? projectData?.mostRecentlyViewedBoard;
    // softwareBoardCount >= 1 condition ensures boardless projects have the correct header (ie ProjectHeader)
    if (board && projectData.projectType === (0, $ln6Iy.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) && projectData.projectStyle === (0, $ln6Iy.COMPANY_MANAGED_PROJECT) && projectData.softwareBoardCount && projectData.softwareBoardCount >= 1) // @ts-expect-error Expecting board to be a JiraBoard type
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1sZnn.HorizontalNavBoardHeader), {
        boardFragment: board,
        projectFragment: projectData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6R5QV.ProjectHeader), {
        queryFragment: data,
        projectFragment: projectData
    });
};
var $74beb965c7bda118$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($74beb965c7bda118$var$NavHeader);

});
parcelRegister("dsAJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ace55c9ce17dcff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cb3d49ec1361822d0b50dc23ab66269c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7ace55c9ce17dcff$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTMPBoardRoute"
        }
    ],
    "kind": "Fragment",
    "name": "NavHeader_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "HorizontalNavBoardHeader_project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectStyle"
            },
            "action": "THROW",
            "path": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        },
        {
            "condition": "isTMPBoardRoute",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "mostRecentlyViewedBoard",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "HorizontalNavBoardHeader_board"
                                }
                            ],
                            "type": "JiraBoard"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$7ace55c9ce17dcff$var$node.hash = "e6f2c3a6daae909edfe8b5a8b679337c";
var $7ace55c9ce17dcff$export$2e2bcd8739ae039 = $7ace55c9ce17dcff$var$node;

});

parcelRegister("5wSJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b88a2671123dc35a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<991301e4ae06f83b6b953ffeb227d1f0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b88a2671123dc35a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "boardId"
        },
        {
            "kind": "RootArgument",
            "name": "withBoard"
        }
    ],
    "kind": "Fragment",
    "name": "NavHeader_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_query"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "withBoard",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "id",
                                        "variableName": "boardId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "jiraBoard",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "UserBoardHeader_board"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "HorizontalNavBoardHeader_board"
                                            }
                                        ],
                                        "type": "JiraBoard"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$b88a2671123dc35a$var$node.hash = "40f4384a6241e1becab27e3bdaca23ec";
var $b88a2671123dc35a$export$2e2bcd8739ae039 = $b88a2671123dc35a$var$node;

});

parcelRegister("1sZnn", function(module, exports) {

$parcel$export(module.exports, "HorizontalNavBoardHeader", () => $c5fea459f31c0b5e$export$a50d1fe8d7279a5c);

var $k7g06 = parcelRequire("k7g06");

var $diTnc = parcelRequire("diTnc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");


var $5bzWA = parcelRequire("5bzWA");


var $l0R1i = parcelRequire("l0R1i");

var $4xbv3 = parcelRequire("4xbv3");

var $9Ovhp = parcelRequire("9Ovhp");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $1715R = parcelRequire("1715R");

var $ljjv4 = parcelRequire("ljjv4");

var $g7LSl = parcelRequire("g7LSl");
const $c5fea459f31c0b5e$export$a50d1fe8d7279a5c = ({ boardFragment: boardFragment, projectFragment: projectFragment = null })=>{
    const [isFullscreen] = (0, $5bzWA.useIsFullscreen)();
    const board = (0, $j4oe4.useFragment)((0, $diTnc.default), boardFragment);
    const project = (0, $j4oe4.useFragment)((0, $k7g06.default), projectFragment);
    const toBoardType = (jiraBoardType)=>{
        if (jiraBoardType === 'SCRUM') return 0, $987928229d6d4941$export$b75edebf0c64f31e;
        if (jiraBoardType === 'KANBAN') return 0, $987928229d6d4941$export$eff0efe8746a33f;
    };
    const boardData = (0, $eJOHy.useMemo)(()=>{
        if (board?.__typename !== 'JiraBoard') return null;
        const isPublicBoard = !!board.name;
        return isPublicBoard ? {
            id: board?.boardId?.toString(),
            dataId: board?.__id,
            admins: {
                users: [],
                groups: []
            },
            name: board.name,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            type: toBoardType(board.boardType),
            favourite: board.favouriteValue?.isFavourite ?? false,
            canEdit: !!board.canEdit
        } : {
            id: board?.boardId?.toString(),
            dataId: board?.__id,
            admins: {
                users: [],
                groups: []
            },
            canEdit: !!board.canEdit,
            isPrivate: true
        };
    }, [
        board
    ]);
    const showTeamButton = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('team-connection-visibility-in-jira') && (0, $epTsa.expVal)('team_and_container_m1', 'isEnabled', false);
    const analyticsData = (0, $eJOHy.useMemo)(()=>({
            navigationContainer: (0, $95eb6070d868c1b7$export$b83d0ee9325a2d0a)
        }), []);
    if (board == null || board.__typename !== 'JiraBoard' || board.boardId == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ovhp.default), {
        title: board.name,
        isLoading: board == null,
        extraComponentsClose: [
            showTeamButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g7LSl.NavigationTeamButton), {
                key: "TeamButton",
                projectFragment: project ?? null,
                scope: "board"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
                key: "BoardActions",
                attributes: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l0R1i.BoardActions), {
                key: "BoardActions",
                board: boardData,
                projectFragment: project ?? null,
                isBoardFavorite: board.favouriteValue?.isFavourite ?? undefined
            }))
        ],
        extraComponentsFar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1715R.ExtraComponentsFar), {
            projectFragment: project ?? null
        }),
        testId: "horizontal-nav-header.ui.board-header.header",
        extraComponentsAbove: !isFullscreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ljjv4.HorizontalNavProjectBreadcrumbs), {
            projectFragment: project ?? null,
            shouldShowProjectName: true
        })
    });
};

});
parcelRegister("k7g06", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeeeb330baa66cde$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e2cdcef8dcfebdff39ba9650da81044>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aeeeb330baa66cde$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "isTMPBoardRoute"
        }
    ],
    "kind": "Fragment",
    "name": "HorizontalNavBoardHeader_project",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "NavigationTeamButton_project"
                }
            ]
        },
        {
            "condition": "isTMPBoardRoute",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_navigationBoardActionMenu_BoardActions"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "extraComponentsFar_horizontalNav"
        },
        {
            "kind": "FragmentSpread",
            "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
        }
    ],
    "type": "JiraProject"
};
$aeeeb330baa66cde$var$node.hash = "0182ef8ea67e2047a2c73a62c74cf453";
var $aeeeb330baa66cde$export$2e2bcd8739ae039 = $aeeeb330baa66cde$var$node;

});

parcelRegister("diTnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1800a8337a894f29$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<739dfc853bfad69d6e306d8e6203605d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1800a8337a894f29$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "HorizontalNavBoardHeader_board",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardId"
            },
            "action": "THROW",
            "path": "boardId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "ScalarField",
            "name": "canEdit"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardType"
            },
            "action": "THROW",
            "path": "boardType"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                    },
                    "action": "THROW",
                    "path": "favouriteValue.isFavourite"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                    },
                    "action": "THROW",
                    "path": "__id"
                }
            ]
        }
    ],
    "type": "JiraBoard"
};
$1800a8337a894f29$var$node.hash = "2bee90c92c0551f1635f4463f247385b";
var $1800a8337a894f29$export$2e2bcd8739ae039 = $1800a8337a894f29$var$node;

});

const $987928229d6d4941$export$b75edebf0c64f31e = 'scrum';
const $987928229d6d4941$export$eff0efe8746a33f = 'kanban';
const $987928229d6d4941$export$aca095bc476d426f = 'simple';

const $95eb6070d868c1b7$export$2ee9e5a3556c1e43 = 'sidebar';
const $95eb6070d868c1b7$export$793ed84f5e13fedc = 'top';
const $95eb6070d868c1b7$export$f1c9dd0f5207dd5e = 'tab';
const $95eb6070d868c1b7$export$b83d0ee9325a2d0a = 'projectTitle';

parcelRegister("l0R1i", function(module, exports) {

$parcel$export(module.exports, "BoardActions", () => $38de4a7dd36ab52f$export$bb50bc4d1176eb2f);

var $fRKRb = parcelRequire("fRKRb");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $NByNW = parcelRequire("NByNW");

var $Ay1uj = parcelRequire("Ay1uj");

var $4MicW = parcelRequire("4MicW");

var $4F5bb = parcelRequire("4F5bb");

var $7saMl = parcelRequire("7saMl");
var $f58rc = parcelRequire("f58rc");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $3cMgR = parcelRequire("3cMgR");

var $bu8Y7 = parcelRequire("bu8Y7");

var $9Wqfs = parcelRequire("9Wqfs");

var $lRq8t = parcelRequire("lRq8t");

var $8QGVd = parcelRequire("8QGVd");


var $1OC2y = parcelRequire("1OC2y");

var $8Btof = parcelRequire("8Btof");

var $6Hwhu = parcelRequire("6Hwhu");

var $cNe2t = parcelRequire("cNe2t");

var $kEUB1 = parcelRequire("kEUB1");

var $83DiZ = parcelRequire("83DiZ");

var $7jTnu = parcelRequire("7jTnu");

var $aMOdH = parcelRequire("aMOdH");

var $1T6m6 = parcelRequire("1T6m6");

var $QaFzq = parcelRequire("QaFzq");

var $1302Y = parcelRequire("1302Y");

var $286cZ = parcelRequire("286cZ");

var $fAZgY = parcelRequire("fAZgY");

var $9cReq = parcelRequire("9cReq");
const $38de4a7dd36ab52f$export$bb50bc4d1176eb2f = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'), ({ board: board, projectFragment: projectFragment, placement: placement, isBoardFavorite: isBoardFavorite = false, isParentProjectStarred: isParentProjectStarred, forceOpen: forceOpen = false, iconButtonSpacing: iconButtonSpacing = 'default' })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(forceOpen);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent } = (0, $1OC2y.useProjectsAnalyticsL3)();
    const { sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent: sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent } = (0, $8Btof.useProjectsAnalyticsL4)();
    const project = (0, $j4oe4.useFragment)((0, $fRKRb.default), projectFragment);
    const tenantId = (0, $kEUB1.useCloudId)();
    const boardARI = (0, $bu8Y7.JiraSoftwareBoardAri).create({
        siteId: tenantId,
        boardId: board?.id.toString() ?? ''
    }).toString();
    const [showDeleteModal, setShowDeleteModal] = (0, $eJOHy.useState)(false);
    const boardId = board?.id || '';
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const route = (0, $QaFzq.useRoute)();
    const isBacklogUrl = (0, $8QGVd.isBacklogRoute)(route.name);
    const openModal = ()=>{
        setShowDeleteModal(true);
        sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
            recent: !isParentProjectStarred,
            starred: isParentProjectStarred ?? false,
            boardId: Number(boardId),
            itemId: (0, $bc40578f06d7846b$export$a68d619e7022f2c3),
            projectId: project?.projectId ?? '',
            projectType: project?.projectType
        });
    };
    const handleBoardDelete = ()=>{
        if (!board?.dataId) return;
        setShowDeleteModal(false);
        push(`/browse/${project?.projectKey}`);
    };
    const handleModalCancel = ()=>{
        setShowDeleteModal(false);
    };
    const IconButton = (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? (0, $aMOdH.ThemedIconButton) : (0, $Ay1uj.default);
    const onBoardDeleteFailed = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $eJOHy.useCallback)(()=>setShowDeleteModal(false), []) : ()=>setShowDeleteModal(false);
    const onTriggerClick = (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $eJOHy.useCallback)(()=>{
        setIsOpen(!isOpen);
        sendMeatBallDropDownOnBoardsAnalyticsEvent({
            recent: !isParentProjectStarred,
            starred: isParentProjectStarred ?? false,
            boardId: Number(boardId),
            projectId: project?.projectId ?? '',
            projectType: project?.projectType
        });
    }, [
        isOpen,
        sendMeatBallDropDownOnBoardsAnalyticsEvent,
        isParentProjectStarred,
        boardId,
        project?.projectId,
        project?.projectType
    ]) : ()=>{
        setIsOpen(!isOpen);
        sendMeatBallDropDownOnBoardsAnalyticsEvent({
            recent: !isParentProjectStarred,
            starred: isParentProjectStarred ?? false,
            boardId: Number(boardId),
            projectId: project?.projectId ?? '',
            projectType: project?.projectType
        });
    };
    const onClose = (0, $fAZgY.useCallbackWithCondition)(()=>setIsOpen(false), [], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    if (!project?.projectKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: placement ?? 'bottom-start',
        testId: "navigation-board-action-menu.ui.popup",
        messageId: "navigation-board-action-menu.ui.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Hwhu.FavoriteToggleButton), {
                entityId: boardARI,
                entityTypeName: "JiraBoard",
                defaultIsStarred: isBoardFavorite,
                onClick: ()=>sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
                        recent: !isParentProjectStarred,
                        starred: isParentProjectStarred ?? false,
                        itemId: isBoardFavorite ? (0, $bc40578f06d7846b$export$7ae7abcf2c19d3e5) : (0, $bc40578f06d7846b$export$78fd0bd637fe1684),
                        boardId: Number(boardId),
                        projectId: project?.projectId ?? '',
                        projectType: project?.projectType
                    })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)",
                    spacing: "spacious"
                }),
                "aria-label": formatMessage((0, $9cReq.default).boardSettingsLabel),
                href: $38de4a7dd36ab52f$var$getJSWCMPBoardSettingsUrl(project?.projectKey, boardId, isBacklogUrl),
                onClick: ()=>{
                    sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
                        recent: !isParentProjectStarred,
                        starred: isParentProjectStarred ?? false,
                        boardId: Number(boardId),
                        itemId: (0, $bc40578f06d7846b$export$192d610b0b7719f4),
                        projectId: project?.projectId ?? '',
                        projectType: project?.projectType
                    });
                }
            }, formatMessage((0, $9cReq.default).boardSettingsLabel))), board?.canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
                hasSeparator: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4MicW))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon-accent-red, #C9372C)"
                }),
                onClick: openModal
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                color: "color.text.danger"
            }, formatMessage((0, $9cReq.default).deleteBoardLabel))))), board && board.canEdit && showDeleteModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Wqfs.default), {
                board: board,
                // eslint-disable-next-line jira/deprecations/no-base-url
                baseUrl: "",
                onBoardDeleteFailed: onBoardDeleteFailed,
                onBoardDeleted: handleBoardDelete,
                onCancel: handleModalCancel
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IconButton, {
                ...triggerProps,
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage((0, $9cReq.default).dropdownIconLabel),
                appearance: "subtle",
                spacing: (0, $7jTnu.fg)('jira-project-theming-m2-bug-fixes') ? iconButtonSpacing : 'default',
                onClick: onTriggerClick,
                isSelected: isOpen,
                testId: "navigation-board-action-menu.ui.dropdown"
            }),
        shouldRenderToParent: true
    });
});
function $38de4a7dd36ab52f$var$getJSWCMPBoardSettingsUrl(projectKey, boardId, isBacklogUrl) {
    const query = isBacklogUrl ? '?from-backlog=1' : '';
    return `${(0, $1T6m6.getBoardSettingsUrl)((0, $1T6m6.getBoardUrl)(projectKey, boardId, true))}/filter${query}`;
}

});
parcelRegister("fRKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d592eac7946540c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<caaf1222eee2525329079525fc89c17d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d592eac7946540c9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_navigationBoardActionMenu_BoardActions",
    "selections": [
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$d592eac7946540c9$var$node.hash = "c4890e10b4a9bc525d38501ea5a616a3";
var $d592eac7946540c9$export$2e2bcd8739ae039 = $d592eac7946540c9$var$node;

});

parcelRegister("4MicW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32784ef133e6e682f32ae3035edbf69e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37a9c4cf545b6d17$var$_react = $37a9c4cf545b6d17$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $37a9c4cf545b6d17$var$_baseNew = $37a9c4cf545b6d17$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $37a9c4cf545b6d17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37a9c4cf545b6d17$var$DeleteIcon = (props)=>/*#__PURE__*/ $37a9c4cf545b6d17$var$_react.default.createElement($37a9c4cf545b6d17$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$37a9c4cf545b6d17$var$DeleteIcon.displayName = 'DeleteIcon';
var $37a9c4cf545b6d17$var$_default = module.exports.default = $37a9c4cf545b6d17$var$DeleteIcon;

});

parcelRegister("bu8Y7", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $85c9740b1cb0c1f8$export$fcd404066e55a7a8);

var $5SaHf = parcelRequire("5SaHf");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira-software/board/manifest.ts
var $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $5SaHf.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $5SaHf.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $85c9740b1cb0c1f8$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $85c9740b1cb0c1f8$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("5SaHf", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $011a7d14b4d4d4ec$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $011a7d14b4d4d4ec$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $011a7d14b4d4d4ec$export$d716ba4f5572ec86 = "jira-software", $011a7d14b4d4d4ec$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("9Wqfs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c57a00c72036028f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $BwaQq = parcelRequire("BwaQq");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");


var $55zw4 = parcelRequire("55zw4");

var $i6aaC = parcelRequire("i6aaC");

var $G61cz = parcelRequire("G61cz");

var $csIDH = parcelRequire("csIDH");
// eslint-disable-next-line jira/react/no-class-components
class $c57a00c72036028f$var$DeleteModal extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onBoardDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $G61cz.default)((0, $55zw4.default));
        this.store.dispatch((0, $i6aaC.setAppProps)(this.props));
        this.store.dispatch((0, $i6aaC.getActiveSprints)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $csIDH.default), null)));
    }
}
var $c57a00c72036028f$export$2e2bcd8739ae039 = (0, $BwaQq.AnalyticsSource)('deleteBoard', (0, $466f60259c330878$export$1171103ea9083ffa))($c57a00c72036028f$var$DeleteModal);

});
parcelRegister("aP411", function(module, exports) {

$parcel$export(module.exports, "default", () => $02914045d75bc0a9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $02914045d75bc0a9$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $02914045d75bc0a9$var$appStyles = null;
var $02914045d75bc0a9$export$2e2bcd8739ae039 = $02914045d75bc0a9$var$AppStyle;

});

// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("55zw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d935b7d2eddd5790$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $i5MPC = parcelRequire("i5MPC");

var $5KtTM = parcelRequire("5KtTM");
var // @ts-expect-error - TS2769 - No overload matches this call.
$d935b7d2eddd5790$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $i5MPC.default), (0, $5KtTM.default));

});
parcelRegister("i5MPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f34796173529b03$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");


var $1dJZq = parcelRequire("1dJZq");

var $jbabP = parcelRequire("jbabP");

var $i6aaC = parcelRequire("i6aaC");

var $4TMFo = parcelRequire("4TMFo");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0f34796173529b03$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $i6aaC.DELETE_BOARD)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $4TMFo.getBaseUrl)(state);
        const board = (0, $4TMFo.getBoard)(state);
        return (0, $jbabP.default)(baseUrl, board.id).mergeMap(()=>{
            (0, $4TMFo.getOnBoardDeleted)(state)(board);
            return (0, $7kixv.Observable).of((0, $i6aaC.boardDeleted)());
        }).catch((error)=>{
            (0, $1dJZq.logSafeErrorWithoutCustomerData)(error, 'directories.boards-v2.delete-modal.ops.delete-board', (0, $dc9f02a5ae63ae66$export$f1a2e76e49f3534e));
            const reason = error.statusCode === 404 ? 'board-not-found' : 'unknown';
            (0, $4TMFo.getOnBoardDeleteFailed)(state)(board, reason);
            return (0, $7kixv.Observable).of((0, $i6aaC.deleteBoardFailed)({
                reason: reason
            }));
        });
    });

});
const $dc9f02a5ae63ae66$export$f1a2e76e49f3534e = 'directories.boards.error';

parcelRegister("1dJZq", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerData", () => $49730048a5415a49$export$c77be5886e7f1d9e);

var $eSnSE = parcelRequire("eSnSE");
const $49730048a5415a49$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, $eSnSE.default).safeErrorWithoutCustomerData(location, message || error.message, error);
const $49730048a5415a49$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, $eSnSE.default).safeErrorWithoutCustomerData(location, message || error.message, error);

});

parcelRegister("jbabP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca52d1789fdf57e9$export$2e2bcd8739ae039);

var $1K8u5 = parcelRequire("1K8u5");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ca52d1789fdf57e9$export$2e2bcd8739ae039 = (baseUrl, boardId)=>{
    const url = `/rest/agile/1.0/board/${boardId}`;
    const options = {
        method: 'delete'
    };
    return (0, $1K8u5.default)(url, options);
};

});
parcelRegister("1K8u5", function(module, exports) {

$parcel$export(module.exports, "default", () => $51ec3aff262c37e1$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("c1D7V");
parcelRequire("llumX");
parcelRequire("1o2WJ");
parcelRequire("6cJUr");

var $6uWhG = parcelRequire("6uWhG");

var $1oMOM = parcelRequire("1oMOM");

var $ee0TI = parcelRequire("ee0TI");

var $1uIew = parcelRequire("1uIew");

var $i4YfB = parcelRequire("i4YfB");

var $3WOLx = parcelRequire("3WOLx");
const $51ec3aff262c37e1$var$noContentStatus = 204;
const $51ec3aff262c37e1$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $51ec3aff262c37e1$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$51ec3aff262c37e1$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6uWhG.setMark)(`BEGIN_${key}`);
    }
    return (0, $7kixv.Observable).of(url).mergeMap(()=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $iWqim.merge)((0, $iWqim.merge)((0, $1oMOM.defaultOptions), opts), (0, $3WOLx.makeObservabilityHeaders)()))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6uWhG.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $ee0TI.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $1uIew.default)(status, str, traceId);
                else throw new (0, $1uIew.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $51ec3aff262c37e1$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $7kixv.Observable).of(null);
        return response.json();
    });
}
var $51ec3aff262c37e1$export$2e2bcd8739ae039 = $51ec3aff262c37e1$var$fetchJson$;

});


parcelRegister("i6aaC", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $76e165d216c71d1e$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $76e165d216c71d1e$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS", () => $76e165d216c71d1e$export$590db52f99257537);
$parcel$export(module.exports, "getActiveSprints", () => $76e165d216c71d1e$export$2893b8608d2a6d6a);
$parcel$export(module.exports, "ACTIVE_SPRINTS_RETRIEVED", () => $76e165d216c71d1e$export$215dde409662413);
$parcel$export(module.exports, "activeSprintsRetrieved", () => $76e165d216c71d1e$export$12dcad2fd94d0a72);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS_FAILED", () => $76e165d216c71d1e$export$14cf35077b6f85f7);
$parcel$export(module.exports, "getActiveSprintsFailed", () => $76e165d216c71d1e$export$694c6ee523cd87cb);
$parcel$export(module.exports, "DELETE_BOARD", () => $76e165d216c71d1e$export$a68d619e7022f2c3);
$parcel$export(module.exports, "deleteBoard", () => $76e165d216c71d1e$export$fc0ef3a3a9b2b3cd);
$parcel$export(module.exports, "DELETE_BOARD_FAILED", () => $76e165d216c71d1e$export$8cad23f5fe7e6ff3);
$parcel$export(module.exports, "deleteBoardFailed", () => $76e165d216c71d1e$export$983279b2aa6031b0);
$parcel$export(module.exports, "BOARD_DELETED", () => $76e165d216c71d1e$export$aea8ac0fecc03cf6);
$parcel$export(module.exports, "boardDeleted", () => $76e165d216c71d1e$export$d6d2ce109de8e68b);
const $76e165d216c71d1e$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $76e165d216c71d1e$export$cfda7627848a58cd = (payload)=>({
        type: $76e165d216c71d1e$export$8aefe701a6f431e0,
        payload: payload
    });
const $76e165d216c71d1e$export$590db52f99257537 = 'state.GET_ACTIVE_SPRINTS';
const $76e165d216c71d1e$export$2893b8608d2a6d6a = ()=>({
        type: $76e165d216c71d1e$export$590db52f99257537
    });
const $76e165d216c71d1e$export$215dde409662413 = 'state.ACTIVE_SPRINTS_RETRIEVED';
const $76e165d216c71d1e$export$12dcad2fd94d0a72 = (payload)=>({
        type: $76e165d216c71d1e$export$215dde409662413,
        payload: payload
    });
const $76e165d216c71d1e$export$14cf35077b6f85f7 = 'state.GET_ACTIVE_SPRINTS_FAILED';
const $76e165d216c71d1e$export$694c6ee523cd87cb = ()=>({
        type: $76e165d216c71d1e$export$14cf35077b6f85f7
    });
const $76e165d216c71d1e$export$a68d619e7022f2c3 = 'state.DELETE_BOARD';
const $76e165d216c71d1e$export$fc0ef3a3a9b2b3cd = ()=>({
        type: $76e165d216c71d1e$export$a68d619e7022f2c3
    });
const $76e165d216c71d1e$export$8cad23f5fe7e6ff3 = 'state.DELETE_BOARD_FAILED';
const $76e165d216c71d1e$export$983279b2aa6031b0 = (payload)=>({
        type: $76e165d216c71d1e$export$8cad23f5fe7e6ff3,
        payload: payload
    });
const $76e165d216c71d1e$export$aea8ac0fecc03cf6 = 'state.BOARD_DELETED';
const $76e165d216c71d1e$export$d6d2ce109de8e68b = ()=>({
        type: $76e165d216c71d1e$export$aea8ac0fecc03cf6
    });

});

parcelRegister("4TMFo", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $d78c44282fa01a48$export$f654b28f82155665);
$parcel$export(module.exports, "getBoard", () => $d78c44282fa01a48$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "getOnInitialised", () => $d78c44282fa01a48$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnBoardDeleted", () => $d78c44282fa01a48$export$3efb56c7750e8ce1);
$parcel$export(module.exports, "getOnBoardDeleteFailed", () => $d78c44282fa01a48$export$311506722a7438bc);
$parcel$export(module.exports, "getOnCancel", () => $d78c44282fa01a48$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $d78c44282fa01a48$export$906c0d65e4ece39d);
$parcel$export(module.exports, "getSprintInformation", () => $d78c44282fa01a48$export$4e64490e97fad74a);
const $d78c44282fa01a48$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
const $d78c44282fa01a48$export$2223f2dfcfd77cef = (state)=>state.appProps.board;
const $d78c44282fa01a48$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $d78c44282fa01a48$export$3efb56c7750e8ce1 = (state)=>state.appProps.onBoardDeleted;
const $d78c44282fa01a48$export$311506722a7438bc = (state)=>state.appProps.onBoardDeleteFailed;
const $d78c44282fa01a48$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $d78c44282fa01a48$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $d78c44282fa01a48$export$4e64490e97fad74a = (state)=>state.sprintInformation;

});


parcelRegister("5KtTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8af70837cc6bb8a$export$2e2bcd8739ae039);
parcelRequire("cBiei");
parcelRequire("9BkTq");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");



var $1dJZq = parcelRequire("1dJZq");

var $03Bz6 = parcelRequire("03Bz6");

var $i6aaC = parcelRequire("i6aaC");

var $4TMFo = parcelRequire("4TMFo");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c8af70837cc6bb8a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $i6aaC.GET_ACTIVE_SPRINTS)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $4TMFo.getBaseUrl)(state);
        const board = (0, $4TMFo.getBoard)(state);
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2339 - Property 'type' does not exist on type 'Board'.
        const shouldSkipCheckingActiveSprints = board.isPrivate || board.type !== (0, $987928229d6d4941$export$b75edebf0c64f31e);
        if (shouldSkipCheckingActiveSprints) {
            (0, $4TMFo.getOnInitialised)(state)();
            return (0, $7kixv.Observable).of((0, $i6aaC.activeSprintsRetrieved)([]));
        }
        return (0, $7kixv.Observable).fromPromise((0, $03Bz6.default)(baseUrl, board.id)).mergeMap((sprints)=>{
            (0, $4TMFo.getOnInitialised)(state)();
            return (0, $7kixv.Observable).of((0, $i6aaC.activeSprintsRetrieved)(sprints));
        })// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ActiveSprintsRetrievedAction> | Observable<GetActiveSprintsFailedAction>' is not assignable to parameter of type '(err: any, caught: Observable<ActiveSprintsRetrievedAction>) => ObservableInput<ActiveSprintsRetrievedAction>'.
        .catch((error)=>{
            if (error.statusCode === 404) return (0, $7kixv.Observable).of((0, $i6aaC.activeSprintsRetrieved)([]));
            (0, $1dJZq.logSafeErrorWithoutCustomerData)(error, 'directories.boards-v2.delete-modal.ops.get-active-sprints', (0, $dc9f02a5ae63ae66$export$f1a2e76e49f3534e));
            return (0, $7kixv.Observable).of((0, $i6aaC.getActiveSprintsFailed)());
        });
    });

});
parcelRegister("03Bz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d389876c4ca627fe$export$2e2bcd8739ae039);

var $jje8P = parcelRequire("jje8P");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d389876c4ca627fe$export$2e2bcd8739ae039 = async (baseUrl, boardId)=>{
    const activeSprints = await (0, $jje8P.default)(baseUrl, boardId);
    return activeSprints.values;
};

});
parcelRegister("jje8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $48ce5890180dbcff$export$2e2bcd8739ae039);

var $b5RwB = parcelRequire("b5RwB");

var $1Ozm9 = parcelRequire("1Ozm9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48ce5890180dbcff$export$2e2bcd8739ae039 = (baseUrl, boardId)=>{
    const params = (0, $b5RwB.stringify)({
        state: 'active'
    });
    return (0, $1Ozm9.default)(`/rest/agile/1.0/board/${boardId}/sprint?${params}`);
};

});




parcelRegister("G61cz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb4652d616bdb8da$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $dYsG4 = parcelRequire("dYsG4");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bb4652d616bdb8da$export$2e2bcd8739ae039 = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'directories/boards-v2/delete-modal',
        rootReducer: $dYsG4.default,
        rootEpic: rootEpic
    });

});
parcelRegister("dYsG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a380f8d34f3189$export$2e2bcd8739ae039);

var $i6aaC = parcelRequire("i6aaC");
const $07a380f8d34f3189$var$defaultState = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    sprintInformation: undefined,
    isDeleteInProgress: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07a380f8d34f3189$export$2e2bcd8739ae039 = (state = $07a380f8d34f3189$var$defaultState, action)=>{
    switch(action.type){
        case 0, $i6aaC.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $i6aaC.DELETE_BOARD:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $i6aaC.DELETE_BOARD_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $i6aaC.ACTIVE_SPRINTS_RETRIEVED:
            return {
                ...state,
                sprintInformation: {
                    sprints: action.payload
                }
            };
        case 0, $i6aaC.GET_ACTIVE_SPRINTS_FAILED:
            return {
                ...state,
                sprintInformation: {
                    error: true
                }
            };
        case 0, $i6aaC.GET_ACTIVE_SPRINTS:
        case 0, $i6aaC.BOARD_DELETED:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("csIDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de5a333ac8f356d$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $idGBm = parcelRequire("idGBm");

var $gnQAk = parcelRequire("gnQAk");

var $i6aaC = parcelRequire("i6aaC");

var $4TMFo = parcelRequire("4TMFo");

var $2lKGI = parcelRequire("2lKGI");

var $dXndk = parcelRequire("dXndk");
const $2de5a333ac8f356d$var$mapStateToProps = (state)=>({
        Content: $2lKGI.default,
        board: (0, $4TMFo.getBoard)(state),
        sprintInformation: (0, $4TMFo.getSprintInformation)(state),
        deleteInProgress: (0, $4TMFo.isDeleteInProgress)(state),
        onCancel: (0, $4TMFo.getOnCancel)(state)
    });
var $2de5a333ac8f356d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $idGBm.injectIntlV2), (0, $gnQAk.connect)($2de5a333ac8f356d$var$mapStateToProps, {
    onDelete: (0, $i6aaC.deleteBoard)
}))(// @ts-expect-error - Argument of type 'typeof DeleteBoardsModal' is not assignable to parameter of type 'ComponentType<{ intl: IntlShapeV2 | IntlShape | undefined; }>'.
(0, $dXndk.default));

});
parcelRegister("idGBm", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $c35e98ccc24112a8$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $eJOHy = parcelRequire("eJOHy");

var $cjwij = parcelRequire("cjwij");

var $lRq8t = parcelRequire("lRq8t");
const $c35e98ccc24112a8$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $c35e98ccc24112a8$var$getDisplayName(Component) {
    if ($c35e98ccc24112a8$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($c35e98ccc24112a8$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $c35e98ccc24112a8$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $lRq8t.default)();
        const intlRef = (0, $eJOHy.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$c35e98ccc24112a8$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cjwij)))(WithIntl, WrappedComponent);
};

});

parcelRegister("2lKGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e63b2d91b7c97f$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $4TMFo = parcelRequire("4TMFo");

var $5EVym = parcelRequire("5EVym");
const $d8e63b2d91b7c97f$var$mapStateToProps = (state)=>({
        board: (0, $4TMFo.getBoard)(state),
        sprintInformation: (0, $4TMFo.getSprintInformation)(state)
    });
var // @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Props>>' is not assignable to parameter of type 'ComponentType<Matching<{ board: Board; sprintInformation: SprintInformation | undefined; } & {}, WithIntlProps<Props>>>'.
$d8e63b2d91b7c97f$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($d8e63b2d91b7c97f$var$mapStateToProps, {})((0, $5EVym.default));

});
parcelRegister("5EVym", function(module, exports) {

$parcel$export(module.exports, "default", () => $47b2d28127361a21$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $3cMgR = parcelRequire("3cMgR");

var $7jTnu = parcelRequire("7jTnu");

var $kDaaB = parcelRequire("kDaaB");

var $idGBm = parcelRequire("idGBm");

var $545Q1 = parcelRequire("545Q1");
// eslint-disable-next-line jira/react/no-class-components
class $47b2d28127361a21$var$Content extends (0, $eJOHy.Component) {
    renderContentForPrivateBoard() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).privateBoardMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).privateBoardMessage)));
    }
    renderLearnMoreLink(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "p"
        }, formatMessage((0, $545Q1.default).activeSprintsRecommendation, {
            boardName: board.name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "em"
        }, (0, $7jTnu.fg)('replace-anchor-with-link__jira-cosmos') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: "https://confluence.atlassian.com/jirasoftwarecloud/running-sprints-in-a-scrum-project-764478111.html"
        }, formatMessage((0, $545Q1.default).link)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            href: "https://confluence.atlassian.com/jirasoftwarecloud/running-sprints-in-a-scrum-project-764478111.html"
        }, formatMessage((0, $545Q1.default).link)))));
    }
    renderContentForNoSprints(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).noSprintsMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).noSprintsMessage, {
            boardName: board.name
        })));
    }
    renderContentForSingleSprint(board, sprint) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).singleSprintMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).singleSprintMessage,
            // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            values: {
                sprintName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                    href: sprint.url
                }, sprint.name)
            }
        })), this.renderLearnMoreLink(board));
    }
    renderContentForMultipleSprints(board, sprints) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).multipleSprintsMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).multipleSprintsMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, sprints.map(({ name: name, url: url }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
                key: index
            }, (0, $7jTnu.fg)('replace-anchor-with-link__jira-cosmos') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                href: url
            }, name) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                href: url
            }, name)))), this.renderLearnMoreLink(board));
    }
    renderContentForSprintRetrievalError(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).retrievalFailedMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).retrievalFailedMessage, {
            boardName: board.name
        })), this.renderLearnMoreLink(board));
    }
    render() {
        const { board: board, sprintInformation: sprintInformation } = this.props;
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
        if (board.isPrivate) return this.renderContentForPrivateBoard();
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'SprintInformation'.
        if (sprintInformation.error) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForSprintRetrievalError(board);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length === 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForSingleSprint(board, sprintInformation.sprints[0]);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length > 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForMultipleSprints(board, sprintInformation.sprints);
        // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForNoSprints(board);
    }
}
var $47b2d28127361a21$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($47b2d28127361a21$var$Content);

});
parcelRegister("545Q1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b94325d82a5ef70$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5b94325d82a5ef70$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    singleSprintMessage: {
        "id": "directories.boards-v2.delete-modal.content.single-sprint-message",
        "defaultMessage": "This board contains issues from {sprintName}, and that sprint is currently active."
    },
    multipleSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.multiple-sprints-message",
        "defaultMessage": "This board contains issues from these active sprints:"
    },
    retrievalFailedMessage: {
        "id": "directories.boards-v2.delete-modal.content.retrieval-failed-message",
        "defaultMessage": "Just a heads up, we're having trouble getting information about active sprints. Issues on {boardName} might be part of one."
    },
    activeSprintsRecommendation: {
        "id": "directories.boards-v2.delete-modal.content.active-sprints-recommendation",
        "defaultMessage": "We recommend completing or deleting active sprints before deleting {boardName}."
    },
    noSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.no-sprints-message",
        "defaultMessage": "Deleting {boardName} doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    privateBoardMessage: {
        "id": "directories.boards-v2.delete-modal.content.private-board-message",
        "defaultMessage": "Deleting this board doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    link: {
        "id": "directories.boards-v2.delete-modal.content.link",
        "defaultMessage": "Learn more about running sprints."
    },
    singleSprintMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.single-sprint-message-issue-terminology-refresh-m4",
        "defaultMessage": "This board contains work items from {sprintName}, and that sprint is currently active."
    },
    multipleSprintsMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.multiple-sprints-message-issue-terminology-refresh-m4",
        "defaultMessage": "This board contains work items from these active sprints:"
    },
    retrievalFailedMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.retrieval-failed-message-issue-terminology-refresh-m4",
        "defaultMessage": "Just a heads up, we're having trouble getting information about active sprints. Work items on {boardName} might be part of one."
    },
    noSprintsMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.no-sprints-message-issue-terminology-refresh-m4",
        "defaultMessage": "Deleting {boardName} doesn't affect the work items on the board. And, it won't complete or delete any active sprints."
    },
    privateBoardMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.private-board-message-issue-terminology-refresh-m4",
        "defaultMessage": "Deleting this board doesn't affect the work items on the board. And, it won't complete or delete any active sprints."
    }
});

});



parcelRegister("dXndk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c40e6d7fd4cf37bf$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $bu8Y7 = parcelRequire("bu8Y7");

var $jtIA2 = parcelRequire("jtIA2");

var $fgJkD = parcelRequire("fgJkD");

var $2ZGUP = parcelRequire("2ZGUP");

var $6zXPf = parcelRequire("6zXPf");

var $kEUB1 = parcelRequire("kEUB1");

var $kqd31 = parcelRequire("kqd31");

var $fKOQa = parcelRequire("fKOQa");

var $kj7UG = parcelRequire("kj7UG");
function $c40e6d7fd4cf37bf$var$DeleteBoardsModal(props) {
    const { Content: Content, board: board, sprintInformation: sprintInformation, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    const tenantId = (0, $kEUB1.useCloudId)();
    const { deleteBoard: deleteBoard } = (0, $fKOQa.useDeleteBoard)();
    if (!sprintInformation) return null;
    const onCancelOrNoop = !deleteInProgress ? onCancel : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    const heading = board.isPrivate ? formatMessage((0, $kj7UG.default).deletePrivateBoard) : // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
    formatMessage((0, $kj7UG.default).deleteBoard, {
        boardName: board.name
    });
    const handleDelete = ()=>{
        const boardARI = (0, $bu8Y7.JiraSoftwareBoardAri).create({
            siteId: tenantId,
            boardId: board.id.toString() ?? ''
        }).toString();
        const dataId = (0, $kqd31.default)({
            id: boardARI
        }, 'JiraBoard');
        onDelete();
        if (dataId) deleteBoard(dataId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "delete-boards-modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtIA2.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "danger",
        onClick: (0, $6zXPf.getWillShowNav4)() ? handleDelete : onDelete,
        isDisabled: deleteInProgress
    }, formatMessage((0, $kj7UG.default).deleteCaption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: deleteInProgress
    }, formatMessage((0, $kj7UG.default).cancel)))));
}
$c40e6d7fd4cf37bf$var$DeleteBoardsModal.defaultProps = {
    deleteInProgress: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $c40e6d7fd4cf37bf$export$2e2bcd8739ae039 = $c40e6d7fd4cf37bf$var$DeleteBoardsModal;

});
parcelRegister("jtIA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b00c14168b4301$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $iM63C = parcelRequire("iM63C");
// eslint-disable-next-line jira/react/no-class-components
class $d1b00c14168b4301$var$ViewTracker extends (0, $eJOHy.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $d1b00c14168b4301$var$ViewTrackerWithAnalytics = (0, $dUaMU.default)({
    componentName: 'view-tracker'
})((0, $4J0ad.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $iM63C.PAGE_EVENT_ACTION)
        }).fire()
})($d1b00c14168b4301$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d1b00c14168b4301$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d1b00c14168b4301$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    });

});

parcelRegister("fgJkD", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $dfae8fefc4710a7e$export$1fa217be60c2f188);

var $eJOHy = parcelRequire("eJOHy");

var $aC4Bh = parcelRequire("aC4Bh");

var $4aSRi = parcelRequire("4aSRi");
const $dfae8fefc4710a7e$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $4aSRi.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    (0, $eJOHy.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        shouldReturnFocus: returnFocus,
        ...rest,
        messageId: rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog',
        messageType: rest.messageType ?? 'transactional'
    });
};

});
parcelRegister("4aSRi", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $0b2a666031d89d51$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $0b2a666031d89d51$export$217308a4ece853b2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gnlW1 = parcelRequire("gnlW1");

var $4CmBA = parcelRequire("4CmBA");

var $ik5fE = parcelRequire("ik5fE");
const $0b2a666031d89d51$var$Store = (0, $GtRbT.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $gnlW1.initialState,
    actions: $4CmBA.actions
});
const $0b2a666031d89d51$export$3cf2e4b6d3541465 = (0, $iJq0l.createActionsHook)($0b2a666031d89d51$var$Store);
const $0b2a666031d89d51$export$217308a4ece853b2 = (0, $iJq0l.createStateHook)($0b2a666031d89d51$var$Store, {
    selector: (0, $ik5fE.getReturnFocusTo)
});

});
parcelRegister("gnlW1", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $155a858c98d12eaf$export$d4c72bab9d6cc13a);
const $155a858c98d12eaf$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("4CmBA", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d6a92026239e37f0$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d6a92026239e37f0$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $d6a92026239e37f0$export$e324594224ef24da = {
    setReturnFocusTo: $d6a92026239e37f0$export$b263d1e638b131c2
};

});

parcelRegister("ik5fE", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $c992da1452d2469a$export$d5f8692765ccd209);
const $c992da1452d2469a$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});



parcelRegister("fKOQa", function(module, exports) {

$parcel$export(module.exports, "useDeleteBoard", () => $310233bfb980cc12$export$abd16ada93ebfa6a);

var $j4oe4 = parcelRequire("j4oe4");
const $310233bfb980cc12$export$16ded94db5ddbcd7 = ({ environment: environment })=>{
    const deleteBoard = (boardDataId)=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            store.delete(boardDataId);
        });
    };
    return {
        deleteBoard: deleteBoard
    };
};
const $310233bfb980cc12$export$abd16ada93ebfa6a = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return $310233bfb980cc12$export$16ded94db5ddbcd7({
        environment: environment
    });
};

});

parcelRegister("kj7UG", function(module, exports) {

$parcel$export(module.exports, "default", () => $575994af172f506a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $575994af172f506a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    deleteBoard: {
        "id": "directories.boards-v2.delete-modal.delete-board",
        "defaultMessage": "Delete {boardName}"
    },
    deletePrivateBoard: {
        "id": "directories.boards-v2.delete-modal.delete-private-board",
        "defaultMessage": "Delete board"
    },
    cancel: {
        "id": "directories.boards-v2.delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    deleteCaption: {
        "id": "directories.boards-v2.delete-modal.delete-caption",
        "defaultMessage": "Delete"
    }
});

});




parcelRegister("8QGVd", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $94656fa01dfef750$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $94656fa01dfef750$export$bcb853db5e3e8054);
const $94656fa01dfef750$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $94656fa01dfef750$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

const $bc40578f06d7846b$export$f06dfcec5ff912e = 'meatballDropdown';
const $bc40578f06d7846b$export$7ae7abcf2c19d3e5 = 'removeFromStarred';
const $bc40578f06d7846b$export$78fd0bd637fe1684 = 'addToStarred';
const $bc40578f06d7846b$export$c540230986f848f6 = 'addPeople';
const $bc40578f06d7846b$export$44d67b522cbcce6d = 'projects';
const $bc40578f06d7846b$export$3cc9ab700c406a19 = 'projectSettings';
const $bc40578f06d7846b$export$dc23a793cf9e9de8 = 'archiveProject';
const $bc40578f06d7846b$export$a68d619e7022f2c3 = 'deleteBoard';
const $bc40578f06d7846b$export$22748439827110a4 = 'deleteProject';
const $bc40578f06d7846b$export$192d610b0b7719f4 = 'boardSettings';
const $bc40578f06d7846b$export$a65812b4aab631bb = 'alertSettings';
const $bc40578f06d7846b$export$36b5d4d0cb4e437 = 'moveInSidebar';
const $bc40578f06d7846b$export$ca6db12118be69a1 = 'schemas';
const $bc40578f06d7846b$export$f2eca6cf19c9a973 = 'reports';
const $bc40578f06d7846b$export$147264622218a553 = 'dataManager';
const $bc40578f06d7846b$export$ee52916f9ebd8000 = 'adapters';
const $bc40578f06d7846b$export$83d40997eb7cc5b7 = 'assetsGlobalConfiguration';
const $bc40578f06d7846b$export$5c09fa42f8d45ed8 = 'dismissRecommendation';
const $bc40578f06d7846b$export$de9ad1ebeca97ec1 = 'newDiscoveryProject';
const $bc40578f06d7846b$export$27e4092edca7bb97 = 'jwmSampleProject';
const $bc40578f06d7846b$export$ce0bea1467165424 = 'whyAmISeeingThis';
const $bc40578f06d7846b$export$98d08638c2a90c44 = 'starredAndRecentProjects';
const $bc40578f06d7846b$export$ed36b1ade72db400 = 'starredProjectsOnly';
const $bc40578f06d7846b$export$f8a73cc0211412ca = 'mostRecentProjectOnly';
const $bc40578f06d7846b$export$3e2efdbdb3eed97e = 'moreProjects';
const $bc40578f06d7846b$export$2de7e56f66635690 = 'viewAllProjects';
const $bc40578f06d7846b$export$e338c40e64df0640 = 'projectsSearch';
const $bc40578f06d7846b$export$5ff59e4f08b9b299 = 'moveToTop';
const $bc40578f06d7846b$export$9964b4a63620a911 = 'moveUp';
const $bc40578f06d7846b$export$2692a384035c5ef7 = 'moveDown';
const $bc40578f06d7846b$export$a5a45050b97fca24 = 'moveToBottom';

parcelRegister("1OC2y", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL3", () => $2cddfe1614034325$export$619b8904be99ed7c);

var $eJOHy = parcelRequire("eJOHy");






var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $ujg1l = parcelRequire("ujg1l");

const $2cddfe1614034325$export$619b8904be99ed7c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18)
        }), []);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on boards
    const sendMeatBallDropDownOnBoardsAnalyticsEvent = (0, $eJOHy.useCallback)(({ recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$9bd6c21d500ae611),
            itemId: (0, $bc40578f06d7846b$export$f06dfcec5ff912e),
            projectId: projectId,
            parentItemId: boardId,
            parentItemType: (0, $6bf6536f83c22cfe$export$9b8283d5878d2491),
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendChangeViewViewOptionAnalyticsEvent = (0, $eJOHy.useCallback)(({ itemId: itemId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$17bca95234dea43b),
            itemId: itemId,
            parentItemId: (0, $6bf6536f83c22cfe$export$119dad133da0b4a)
        };
        (0, $gCeeo.fireUIAnalytics)(event, (0, $16a7021d28f78da7$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent,
        sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent
    };
};

});
const $bfc89d778f76f56d$export$6dd9406e478a1fe2 = 'navigationItem';
const $bfc89d778f76f56d$export$b887e88d8d0739f6 = 'button';
const $bfc89d778f76f56d$export$64fed82162bd367 = 'dropdownItem';
const $bfc89d778f76f56d$export$b0a8b257f1f878a2 = 'searchInput';

const $493796f3bdee881c$export$4165a3d0da3bd147 = 'fixedItem';
const $493796f3bdee881c$export$95b0c331af13d819 = 'fixedItemButton';
const $493796f3bdee881c$export$74712b62056d422e = 'fixedItemAction';
const $493796f3bdee881c$export$3ac911b122986477 = 'customItem';
const $493796f3bdee881c$export$9bd6c21d500ae611 = 'customItemButton';
const $493796f3bdee881c$export$5374c2c2d3ece55e = 'customItemAction';
const $493796f3bdee881c$export$56981f28056f258e = 'customItemDropdownAction';
const $493796f3bdee881c$export$17bca95234dea43b = 'fixedItemDropdownAction';

const $6bf6536f83c22cfe$export$9b8283d5878d2491 = 'board';
const $6bf6536f83c22cfe$export$c3d83ca6855fa0d0 = 'app';
const $6bf6536f83c22cfe$export$c1c49903035a02df = 'filter';
const $6bf6536f83c22cfe$export$6deee0e4f2fb784e = 'defaultFilter';
const $6bf6536f83c22cfe$export$4695c1a423ffe431 = 'dashboard';
const $6bf6536f83c22cfe$export$5828682c822c26e7 = 'queue';
const $6bf6536f83c22cfe$export$fe791c4fa892e400 = 'project';
const $6bf6536f83c22cfe$export$c303e491e026ebc6 = 'plan';
const $6bf6536f83c22cfe$export$509e83d3c8d91279 = 'appSubpage';
const $6bf6536f83c22cfe$export$a2e7d1d0a3d169f4 = 'asset';
const $6bf6536f83c22cfe$export$b56168d831461ce2 = 'operation';
const $6bf6536f83c22cfe$export$499a3e77858b7713 = 'translationGroup';
const $6bf6536f83c22cfe$export$bb8a37ab8d9ba82b = 'roadmap';
const $6bf6536f83c22cfe$export$9a778ca616c24a93 = 'projectRecommendation';
const $6bf6536f83c22cfe$export$9cbb0f231a0ab7ea = 'overview';
const $6bf6536f83c22cfe$export$119dad133da0b4a = 'changeView';

const $4fdd5d9c1b32dd60$export$265c523d1a8f25cf = '1';
const $4fdd5d9c1b32dd60$export$fe3b012b0224e4e1 = '2';
const $4fdd5d9c1b32dd60$export$f9db6a58b4aabd18 = '3';
const $4fdd5d9c1b32dd60$export$35ac629b8b943d5a = '4';

parcelRegister("ujg1l", function(module, exports) {

$parcel$export(module.exports, "getSectionByStarredOrRecent", () => $9ade126550411160$export$542854f16c0127e7);

var $a9aec = parcelRequire("a9aec");
const $9ade126550411160$export$542854f16c0127e7 = ({ starred: starred, recent: recent })=>{
    if (starred) return 0, $a9aec.SECTION_ITEM_STARRED;
    if (recent) return 0, $a9aec.SECTION_ITEM_RECENT;
    return '';
};

});
parcelRegister("a9aec", function(module, exports) {

$parcel$export(module.exports, "SECTION_ITEM_RECENT", () => $db3f586753213871$export$ed5276b2863990a4);
$parcel$export(module.exports, "SECTION_ITEM_STARRED", () => $db3f586753213871$export$73b9e2753c0313a);
$parcel$export(module.exports, "SECTION_ITEM_YOUR_WORK", () => $db3f586753213871$export$a7cdcfc40ede2092);
$parcel$export(module.exports, "SECTION_ITEM_APPS", () => $db3f586753213871$export$31b95a89c6fecef5);
$parcel$export(module.exports, "SECTION_ITEM_PLANS", () => $db3f586753213871$export$b8d778ecbc8de386);
$parcel$export(module.exports, "SECTION_ITEM_PROJECTS", () => $db3f586753213871$export$31111a67d393221);
$parcel$export(module.exports, "SECTION_ITEM_FILTERS", () => $db3f586753213871$export$15cffe8e769011f4);
$parcel$export(module.exports, "SECTION_ITEM_DASHBOARDS", () => $db3f586753213871$export$573d88e8f19dee53);
$parcel$export(module.exports, "SECTION_ITEM_OPERATIONS", () => $db3f586753213871$export$4d8d544db40ea55b);
$parcel$export(module.exports, "SECTION_ITEM_TEAMS", () => $db3f586753213871$export$ee4743a74ca6b2b4);
$parcel$export(module.exports, "SECTION_ITEM_ASSETS", () => $db3f586753213871$export$935694b184853c59);
$parcel$export(module.exports, "SECTION_ITEM_MORE", () => $db3f586753213871$export$b0aa6b1b7598bca0);
$parcel$export(module.exports, "SECTION_ITEM_CUSTOMIZE_SIDEBAR", () => $db3f586753213871$export$60a8edfaff189e32);
$parcel$export(module.exports, "SECTION_ITEM_OVERVIEW", () => $db3f586753213871$export$c15c267765b7c087);
$parcel$export(module.exports, "SECTION_ITEM_ROADMAPS", () => $db3f586753213871$export$1e1623e43a47b758);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_ASSETS", () => $db3f586753213871$export$be1ee97c6c39a7a0);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_GOALS", () => $db3f586753213871$export$340dfb7166bc7df6);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_CONFLUENCE", () => $db3f586753213871$export$68f5347447985678);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_LOOM", () => $db3f586753213871$export$1d6ac45ce8d48696);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_TEAMS", () => $db3f586753213871$export$73432842fefef2ac);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_PROJECTS", () => $db3f586753213871$export$3023d22f41447712);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_OPSGENIE", () => $db3f586753213871$export$3cc2573a8cf93a99);
$parcel$export(module.exports, "SECTION_ITEM_MAP", () => $db3f586753213871$export$1a73d7f5e6997c6d);

var $h4Bzb = parcelRequire("h4Bzb");
const $db3f586753213871$export$ed5276b2863990a4 = 'recent';
const $db3f586753213871$export$73b9e2753c0313a = 'starred';
const $db3f586753213871$export$a01a58e0d3083eac = 'yourApps';
const $db3f586753213871$export$a7cdcfc40ede2092 = 'yourWork';
const $db3f586753213871$export$31b95a89c6fecef5 = 'apps';
const $db3f586753213871$export$b8d778ecbc8de386 = 'plans';
const $db3f586753213871$export$31111a67d393221 = 'projects';
const $db3f586753213871$export$15cffe8e769011f4 = 'filters';
const $db3f586753213871$export$573d88e8f19dee53 = 'dashboards';
const $db3f586753213871$export$4d8d544db40ea55b = 'operations';
const $db3f586753213871$export$ee4743a74ca6b2b4 = 'teams';
const $db3f586753213871$export$935694b184853c59 = 'assets';
const $db3f586753213871$export$b0aa6b1b7598bca0 = 'more';
const $db3f586753213871$export$60a8edfaff189e32 = 'customiseSidebar';
const $db3f586753213871$export$c15c267765b7c087 = 'overviews';
const $db3f586753213871$export$e52ffdfdd2f167e7 = 'communication';
const $db3f586753213871$export$61feca79c347b0c7 = 'goals';
const $db3f586753213871$export$1e1623e43a47b758 = 'roadmaps';
const $db3f586753213871$export$99cd56faa69bbbb6 = 'customerService';
const $db3f586753213871$export$f3045e909a12df36 = 'customerHubs';
const $db3f586753213871$export$f780439bdf7412c6 = 'customerServiceAnalytics';
const $db3f586753213871$export$be1ee97c6c39a7a0 = 'assetsGlobalAppShortcut';
const $db3f586753213871$export$340dfb7166bc7df6 = 'goalsGlobalAppShortcut';
const $db3f586753213871$export$68f5347447985678 = 'confluenceGlobalAppShortcut';
const $db3f586753213871$export$1d6ac45ce8d48696 = 'loomGlobalAppShortcut';
const $db3f586753213871$export$73432842fefef2ac = 'teamsGlobalAppShortcut';
const $db3f586753213871$export$3023d22f41447712 = 'projectsGlobalAppShortcut';
const $db3f586753213871$export$3cc2573a8cf93a99 = 'opsgenieGlobalAppShortcut';
const $db3f586753213871$export$1a73d7f5e6997c6d = {
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).APPS]: $db3f586753213871$export$31b95a89c6fecef5,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).ASSETS]: $db3f586753213871$export$935694b184853c59,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).DASHBOARDS]: $db3f586753213871$export$573d88e8f19dee53,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).FILTERS]: $db3f586753213871$export$15cffe8e769011f4,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).OPERATIONS]: $db3f586753213871$export$4d8d544db40ea55b,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).PLANS]: $db3f586753213871$export$b8d778ecbc8de386,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).PROJECTS]: $db3f586753213871$export$31111a67d393221,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).RECENT]: $db3f586753213871$export$ed5276b2863990a4,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).STARRED]: $db3f586753213871$export$73b9e2753c0313a,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).TEAMS]: $db3f586753213871$export$ee4743a74ca6b2b4,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GOALS]: $db3f586753213871$export$61feca79c347b0c7,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).OVERVIEWS]: $db3f586753213871$export$c15c267765b7c087,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).COMMUNICATION]: $db3f586753213871$export$e52ffdfdd2f167e7,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).ROADMAPS]: $db3f586753213871$export$1e1623e43a47b758,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE]: $db3f586753213871$export$99cd56faa69bbbb6,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_HUBS]: $db3f586753213871$export$f3045e909a12df36,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $db3f586753213871$export$f780439bdf7412c6,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS]: $db3f586753213871$export$340dfb7166bc7df6,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS]: $db3f586753213871$export$be1ee97c6c39a7a0,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE]: $db3f586753213871$export$68f5347447985678,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM]: $db3f586753213871$export$1d6ac45ce8d48696,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS]: $db3f586753213871$export$73432842fefef2ac,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS]: $db3f586753213871$export$3023d22f41447712,
    [(0, $h4Bzb.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE]: $db3f586753213871$export$3cc2573a8cf93a99
};

});


const $16a7021d28f78da7$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $16a7021d28f78da7$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';
const $16a7021d28f78da7$export$8ebfc84e07851700 = 'moreProjectsSearch';


parcelRegister("8Btof", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL4", () => $696f8389ac5d4d5f$export$cc7d25cb07e1eb10);

var $eJOHy = parcelRequire("eJOHy");






var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $ujg1l = parcelRequire("ujg1l");
const $696f8389ac5d4d5f$export$cc7d25cb07e1eb10 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const commonAttributes = (0, $eJOHy.useMemo)(()=>({
            level: (0, $4fdd5d9c1b32dd60$export$35ac629b8b943d5a)
        }), []);
    // actions inside meatball menu on boards
    const sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ itemId: itemId, recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: boardId,
            parentItemType: (0, $6bf6536f83c22cfe$export$9b8283d5878d2491),
            projectId: projectId,
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $eJOHy.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $493796f3bdee881c$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $6bf6536f83c22cfe$export$fe791c4fa892e400),
            projectId: projectId,
            projectType: projectType,
            section: (0, $ujg1l.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $gCeeo.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent: sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent
    };
};

});

parcelRegister("6Hwhu", function(module, exports) {

$parcel$export(module.exports, "FavoriteToggleButton", () => $a01ae8b753a38de5$export$b01f3062fe4ad89b);

var $eJOHy = parcelRequire("eJOHy");

var $gGgaG = parcelRequire("gGgaG");

var $aaIe7 = parcelRequire("aaIe7");

var $7saMl = parcelRequire("7saMl");

var $3cMgR = parcelRequire("3cMgR");

var $beI5n = parcelRequire("beI5n");

var $lRq8t = parcelRequire("lRq8t");

var $6naEG = parcelRequire("6naEG");

var $3LdGv = parcelRequire("3LdGv");
const $a01ae8b753a38de5$var$UnstarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))), {
    label: "",
    color: "currentColor",
    spacing: "spacious"
});
const $a01ae8b753a38de5$var$StarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
    label: "",
    color: "var(--ds-icon-accent-yellow, #B38600)",
    spacing: "spacious"
});
const $a01ae8b753a38de5$export$b01f3062fe4ad89b = ({ entityId: entityId, entityTypeName: entityTypeName, defaultIsStarred: defaultIsStarred = false, name: name, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isStarred, setIsStarred] = (0, $eJOHy.useState)(defaultIsStarred);
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $beI5n.useChangeFavorite)();
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        setIsStarred((prevIsStarred)=>!prevIsStarred);
        onClick?.();
    }, [
        onClick
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isStarred !== defaultIsStarred) changeFavoriteMutation({
            id: entityId,
            typename: entityTypeName,
            value: isStarred
        });
    }, [
        entityId,
        entityTypeName,
        isStarred,
        defaultIsStarred,
        changeFavoriteMutation
    ]);
    const handleOnClickWithStopPropagation = (0, $6naEG.useStopPropagation)(handleOnClick);
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        iconBefore: $a01ae8b753a38de5$var$StarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $3LdGv.default).removeFromStarredWithName, {
            name: name
        }) : formatMessage((0, $3LdGv.default).removeFromStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text"
    }, formatMessage((0, $3LdGv.default).removeFromStarred))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        iconBefore: $a01ae8b753a38de5$var$UnstarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $3LdGv.default).addToStarredWithName, {
            name: name
        }) : formatMessage((0, $3LdGv.default).addToStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text"
    }, formatMessage((0, $3LdGv.default).addToStarred)));
};

});
parcelRegister("gGgaG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c24d1cda47746043$var$_react = $c24d1cda47746043$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c24d1cda47746043$var$_baseNew = $c24d1cda47746043$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c24d1cda47746043$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c24d1cda47746043$var$StarStarredIcon = (props)=>/*#__PURE__*/ $c24d1cda47746043$var$_react.default.createElement($c24d1cda47746043$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$c24d1cda47746043$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $c24d1cda47746043$var$_default = module.exports.default = $c24d1cda47746043$var$StarStarredIcon;

});

parcelRegister("beI5n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $37b7ccfff905baa2$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $37b7ccfff905baa2$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $37b7ccfff905baa2$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $37b7ccfff905baa2$export$cfa169f3278459e8);

var $lJqEJ = parcelRequire("lJqEJ");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $gYnSx = parcelRequire("gYnSx");

var $8oKDI = parcelRequire("8oKDI");

var $gCeeo = parcelRequire("gCeeo");

var $kEUB1 = parcelRequire("kEUB1");

var $kqd31 = parcelRequire("kqd31");

var $5QYf0 = parcelRequire("5QYf0");

var $8Umc4 = parcelRequire("8Umc4");

var $aMJA4 = parcelRequire("aMJA4");

var $ayzwX = parcelRequire("ayzwX");

var $By8f4 = parcelRequire("By8f4");
const $37b7ccfff905baa2$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $37b7ccfff905baa2$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $37b7ccfff905baa2$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $37b7ccfff905baa2$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $eJOHy.createContext)($37b7ccfff905baa2$export$b212ddc707077772);
// supports project types only for now
const $37b7ccfff905baa2$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const commitUpdate = (0, $eJOHy.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $aMJA4.PROJECTS_ITEM_TYPE)) (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $kqd31.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $37b7ccfff905baa2$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $37b7ccfff905baa2$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $eJOHy.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $eJOHy.useCallback)((item)=>{
        setItems($37b7ccfff905baa2$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $eJOHy.useCallback)((item, analyticsEvent)=>{
        setItems($37b7ccfff905baa2$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $eJOHy.useCallback)((item, analyticsId, error)=>{
        setItems($37b7ccfff905baa2$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $By8f4.errorFlag)());
        (0, $gYnSx.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $eJOHy.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $ayzwX.default)(item);
                const typename = (0, $5QYf0.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $8Umc4.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $lJqEJ.default));
    const changeFavoriteMutation = (0, $eJOHy.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $kqd31.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $5QYf0.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $8Umc4.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $eJOHy.useCallback)((item)=>{
        setItems($37b7ccfff905baa2$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $eJOHy.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $5QYf0.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $8Umc4.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $kqd31.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $5QYf0.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $8Umc4.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $eJOHy.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b7ccfff905baa2$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $37b7ccfff905baa2$export$f227cdfbb355444a = $37b7ccfff905baa2$export$a5d258b9665ce94b.Consumer;
const $37b7ccfff905baa2$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b7ccfff905baa2$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $37b7ccfff905baa2$export$cfa169f3278459e8 = ()=>(0, $eJOHy.useContext)($37b7ccfff905baa2$export$a5d258b9665ce94b);

});
parcelRegister("lJqEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f558064ead53275$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $6f558064ead53275$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6f558064ead53275$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $6f558064ead53275$export$2e2bcd8739ae039 = $6f558064ead53275$var$node;

});

parcelRegister("8oKDI", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $250d353c2bab97a6$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $250d353c2bab97a6$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $250d353c2bab97a6$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $250d353c2bab97a6$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $250d353c2bab97a6$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $250d353c2bab97a6$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $250d353c2bab97a6$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $250d353c2bab97a6$export$8e68286aef4c3a8b = (ari)=>$250d353c2bab97a6$var$ARI_REG_EXP.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $250d353c2bab97a6$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $250d353c2bab97a6$export$24b47820a324e614 = (ari)=>{
    if ($250d353c2bab97a6$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $250d353c2bab97a6$export$e2789192113e8b07 = (ari, defaultValue = '')=>$250d353c2bab97a6$export$24b47820a324e614(ari) ?? defaultValue;
const $250d353c2bab97a6$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($250d353c2bab97a6$export$8e68286aef4c3a8b(ari)) {
        const parts = $250d353c2bab97a6$var$ARI_REG_EXP.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $250d353c2bab97a6$export$3d8d7031a11613fd = (ari)=>{
    const config = $250d353c2bab97a6$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("5QYf0", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $60086272c670daaa$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $60086272c670daaa$export$717886a1047f1287);

var $2BUDW = parcelRequire("2BUDW");

var $bu8Y7 = parcelRequire("bu8Y7");

var $27lFN = parcelRequire("27lFN");

var $4NoAT = parcelRequire("4NoAT");

var $3mjHQ = parcelRequire("3mjHQ");

var $3osLr = parcelRequire("3osLr");
function $60086272c670daaa$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $60086272c670daaa$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $60086272c670daaa$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $60086272c670daaa$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $60086272c670daaa$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $3osLr.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $4NoAT.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $27lFN.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $3mjHQ.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $bu8Y7.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $2BUDW.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $60086272c670daaa$var$assertUnreachable(typename);
    }
};
const $60086272c670daaa$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $60086272c670daaa$var$assertUnreachable(typename);
    }
};
const $60086272c670daaa$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $60086272c670daaa$var$favoriteAriToId(typename, id),
        type: $60086272c670daaa$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $60086272c670daaa$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $60086272c670daaa$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});
parcelRegister("2BUDW", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $1e6af9a211751f7e$export$555c8ae00f64ebff);

var $7OueV = parcelRequire("7OueV");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira-servicedesk/queue/manifest.ts
var $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $7OueV.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $7OueV.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $1e6af9a211751f7e$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $1e6af9a211751f7e$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("7OueV", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $5b04a8e3ed2a9dde$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $5b04a8e3ed2a9dde$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $5b04a8e3ed2a9dde$export$704112eeb385ceab = "jira-servicedesk", $5b04a8e3ed2a9dde$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("27lFN", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAri", () => $18ad0c083fb9a182$export$b7d4016f0f5da5b8);

var $lScrX = parcelRequire("lScrX");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/dashboard/manifest.ts
var $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $lScrX.JiraDashboardAriResourceOwner),
    resourceType: (0, $lScrX.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $18ad0c083fb9a182$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $18ad0c083fb9a182$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("lScrX", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $fec84c706c93f2bd$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $fec84c706c93f2bd$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $fec84c706c93f2bd$export$62c1deae25c41d24 = "jira", $fec84c706c93f2bd$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("3mjHQ", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAri", () => $2722b66e28c1c3b7$export$6d2eb3641569f26);

var $6LPOd = parcelRequire("6LPOd");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/plan/manifest.ts
var $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6LPOd.JiraPlanAriResourceOwner),
    resourceType: (0, $6LPOd.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $2722b66e28c1c3b7$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $2722b66e28c1c3b7$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("6LPOd", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $4edf520e7fc401d3$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $4edf520e7fc401d3$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $4edf520e7fc401d3$export$bfd26af3c5e1b90d = "jira", $4edf520e7fc401d3$export$d6abe08eb30f433d = "plan";

});



parcelRegister("8Umc4", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $f8b4daedecded9d4$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $f8b4daedecded9d4$export$eb04bf805f6b8fb2);

var $eJOHy = parcelRequire("eJOHy");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $f8b4daedecded9d4$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $f8b4daedecded9d4$var$favoritePubSub = new $f8b4daedecded9d4$var$FavoritePubSub();
const $f8b4daedecded9d4$export$229a24253fb568e1 = $f8b4daedecded9d4$var$favoritePubSub.publish;
const $f8b4daedecded9d4$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $eJOHy.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$f8b4daedecded9d4$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("aMJA4", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $f0683f65a0acafa7$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $f0683f65a0acafa7$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $f0683f65a0acafa7$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $f0683f65a0acafa7$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $f0683f65a0acafa7$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $f0683f65a0acafa7$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $f0683f65a0acafa7$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $f0683f65a0acafa7$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $f0683f65a0acafa7$export$2d63a9c2e78633c8);
const $f0683f65a0acafa7$export$aade82542e73ffc8 = 'boards';
const $f0683f65a0acafa7$export$a448ebfa10cebc74 = 'filters';
const $f0683f65a0acafa7$export$f8099f229527572c = 'dashboards';
const $f0683f65a0acafa7$export$8e58083dcbb878d = 'issues';
const $f0683f65a0acafa7$export$2fd44a6cb58b66cb = 'plans';
const $f0683f65a0acafa7$export$8e2cd98172988d7e = 'projects';
const $f0683f65a0acafa7$export$6b0c8e47d2c7f1d9 = 'queues';
const $f0683f65a0acafa7$export$9c8cfad65800ddfb = [
    $f0683f65a0acafa7$export$aade82542e73ffc8,
    $f0683f65a0acafa7$export$f8099f229527572c,
    $f0683f65a0acafa7$export$a448ebfa10cebc74,
    $f0683f65a0acafa7$export$8e58083dcbb878d,
    $f0683f65a0acafa7$export$2fd44a6cb58b66cb,
    $f0683f65a0acafa7$export$8e2cd98172988d7e,
    $f0683f65a0acafa7$export$6b0c8e47d2c7f1d9
];
const $f0683f65a0acafa7$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("ayzwX", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb247c6ff9b78be8$export$2e2bcd8739ae039);

var $hz0hv = parcelRequire("hz0hv");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cb247c6ff9b78be8$export$2e2bcd8739ae039 = async (request)=>(0, $hz0hv.updateFavorite)(request);

});
parcelRegister("hz0hv", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $8db6e70766c67090$export$8c2f00130cc945dc);

var $jGzN3 = parcelRequire("jGzN3");
const $8db6e70766c67090$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $jGzN3.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $jGzN3.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("By8f4", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $f3b3cf3c0fd288e5$export$b9a7f1ebeaa76953);

var $bYxGO = parcelRequire("bYxGO");
const $f3b3cf3c0fd288e5$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $bYxGO.default)
    });

});
parcelRegister("bYxGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b97d317b0fde95f0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b97d317b0fde95f0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("6naEG", function(module, exports) {

$parcel$export(module.exports, "useStopPropagation", () => $021cd548567896d7$export$f7bb512e68bcecd9);

var $eJOHy = parcelRequire("eJOHy");
const $021cd548567896d7$export$f7bb512e68bcecd9 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
onEvent)=>(0, $eJOHy.useCallback)((e, ...args)=>{
        try {
            onEvent?.(e, ...args);
        } finally{
            e?.stopPropagation();
        }
    }, [
        onEvent
    ]);

});

parcelRegister("3LdGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e474b4faf2fbb323$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e474b4faf2fbb323$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred",
        "defaultMessage": "Add to starred"
    },
    removeFromStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred",
        "defaultMessage": "Remove from starred"
    },
    addToStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name",
        "defaultMessage": "Add \"{name}\" to starred"
    },
    removeFromStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name",
        "defaultMessage": "Remove \"{name}\" from starred"
    }
});

});


parcelRegister("cNe2t", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $63f31f3205cf35fe$export$2da4be1e3f9adef3);

var $eJOHy = parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $SyPNn = parcelRequire("SyPNn");

var $cYafw = parcelRequire("cYafw");
const $63f31f3205cf35fe$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYafw.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.Popup), rest);
};

});
parcelRegister("cYafw", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $888aaeaeeadda171$export$8ecc19d18d3df807);

var $kJsb4 = parcelRequire("kJsb4");

var $gL5G0 = parcelRequire("gL5G0");
const $888aaeaeeadda171$export$8ecc19d18d3df807 = (0, $gL5G0.withChoreographedToggle)((0, $kJsb4.Popup), 'isOpen', 'content');

});


parcelRegister("aMOdH", function(module, exports) {

$parcel$export(module.exports, "ThemedButtonWrapper", () => $8b8e8a6a97695c51$export$269674ad0c604d30);
$parcel$export(module.exports, "ThemedButtonNew", () => $8b8e8a6a97695c51$export$15536ee0f9ee7c0b);
$parcel$export(module.exports, "ThemedIconButton", () => $8b8e8a6a97695c51$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkButton", () => $8b8e8a6a97695c51$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $8b8e8a6a97695c51$export$a1ab08e79d264ec8);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $5bY40 = parcelRequire("5bY40");
var $6K3F5 = parcelRequire("6K3F5");

var $1uv7v = parcelRequire("1uv7v");

var $7jTnu = parcelRequire("7jTnu");

var $6XJko = parcelRequire("6XJko");

var $1302Y = parcelRequire("1302Y");
const $8b8e8a6a97695c51$export$269674ad0c604d30 = ({ children: children })=>(0, $1302Y.getIsSoftwareThemingEnabled)() || (0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            $8b8e8a6a97695c51$var$overrideStyles,
            $8b8e8a6a97695c51$var$wrapperStyles
        ]
    }, children) : children;
const $8b8e8a6a97695c51$export$15536ee0f9ee7c0b = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b8e8a6a97695c51$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        ...props,
        ref: ref
    }))));
const $8b8e8a6a97695c51$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b8e8a6a97695c51$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        ...props,
        ref: ref
    }))));
const $8b8e8a6a97695c51$export$b0b5aeed52623827 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b8e8a6a97695c51$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5bY40.default), {
        ...props,
        ref: ref
    }))));
const $8b8e8a6a97695c51$export$a1ab08e79d264ec8 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b8e8a6a97695c51$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K3F5.default), {
        ...props,
        ref: ref
    }))));
const $8b8e8a6a97695c51$var$overrideStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold': (0, $1uv7v.Tokens).COLOR_BACKGROUND_BRAND_BOLD,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-hovered': (0, $1uv7v.Tokens).COLOR_BACKGROUND_BRAND_BOLD_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-pressed': (0, $1uv7v.Tokens).COLOR_BACKGROUND_BRAND_BOLD_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-disabled': (0, $1uv7v.Tokens).COLOR_BACKGROUND_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected': (0, $1uv7v.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-hovered': (0, $1uv7v.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-pressed': (0, $1uv7v.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral': (0, $1uv7v.Tokens).COLOR_BACKGROUND_NEUTRAL,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-hovered': (0, $1uv7v.Tokens).COLOR_BACKGROUND_NEUTRAL_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-pressed': (0, $1uv7v.Tokens).COLOR_BACKGROUND_NEUTRAL_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-hovered': (0, $1uv7v.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-pressed': (0, $1uv7v.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon-subtle': (0, $1uv7v.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon': (0, $1uv7v.Tokens).COLOR_TEXT,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link': (0, $1uv7v.Tokens).COLOR_LINK,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link-pressed': (0, $1uv7v.Tokens).COLOR_LINK_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text': (0, $1uv7v.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-disabled': (0, $1uv7v.Tokens).COLOR_TEXT_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-inverse': (0, $1uv7v.Tokens).COLOR_TEXT_INVERSE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-selected': (0, $1uv7v.Tokens).COLOR_TEXT_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-subtle': (0, $1uv7v.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border': (0, $1uv7v.Tokens).COLOR_BORDER,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border-selected': (0, $1uv7v.Tokens).COLOR_BORDER_SELECTED
});
const $8b8e8a6a97695c51$var$wrapperStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex'
});

});
parcelRegister("1302Y", function(module, exports) {

$parcel$export(module.exports, "getIsSoftwareThemingEnabled", () => $02571dfd61e26a65$export$a505f57c5130832f);
$parcel$export(module.exports, "getIsSoftwareThemingM2Enabled", () => $02571dfd61e26a65$export$4fa2eaefe7d59f41);
$parcel$export(module.exports, "getIsSoftwareThemingM2EnabledNoExposure", () => $02571dfd61e26a65$export$8a1bc0266a614408);

var $6zXPf = parcelRequire("6zXPf");

var $epTsa = parcelRequire("epTsa");
const $02571dfd61e26a65$export$a505f57c5130832f = ()=>(0, $6zXPf.getWillShowNav4)() && (0, $epTsa.expVal)('jira_theming_milestone_1', 'isEnabled', false);
const $02571dfd61e26a65$export$4fa2eaefe7d59f41 = ()=>$02571dfd61e26a65$export$a505f57c5130832f() && (0, $epTsa.expVal)('jira_theming_milestone_2', 'isEnabled', false);
const $02571dfd61e26a65$export$8a1bc0266a614408 = ()=>{
    if (!$02571dfd61e26a65$export$a505f57c5130832f()) return false;
    const [expConfig] = (0, $epTsa.UNSAFE_noExposureExp)('jira_theming_milestone_2');
    return expConfig.get('isEnabled', false);
};

});


parcelRegister("1T6m6", function(module, exports) {

$parcel$export(module.exports, "getBoardSettingsHref", () => $fbafacc962018516$export$8d54870ff0bbaead);
$parcel$export(module.exports, "isSelected", () => $fbafacc962018516$export$e4d153b3e021fb47);
$parcel$export(module.exports, "getBoardUrl", () => $fbafacc962018516$export$505a9f131607d070);
$parcel$export(module.exports, "getJSMBoardUrl", () => $fbafacc962018516$export$3416b472014eed93);
$parcel$export(module.exports, "getJSMCalendarUrl", () => $fbafacc962018516$export$16e1d659b389d4ae);
$parcel$export(module.exports, "getUserBoardUrl", () => $fbafacc962018516$export$45f8e28589795b6f);
$parcel$export(module.exports, "getBoardSettingsUrl", () => $fbafacc962018516$export$222cc43a27cdf5b1);
function $fbafacc962018516$export$8d54870ff0bbaead(view, location) {
    if (!$fbafacc962018516$var$isServiceDeskLocation(location)) {
        const basePath = location.pathname.slice(0, location.pathname.lastIndexOf('/'));
        const query = location.search ? location.search : '';
        return `${basePath}/${view}${query}`;
    }
    return `${location.pathname}?config=${view}`;
}
function $fbafacc962018516$export$e4d153b3e021fb47(view, _ = '', pathConfig = '') {
    return pathConfig === view;
}
function $fbafacc962018516$export$505a9f131607d070(projectKey, boardId, isCMPBoard) {
    return `/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${boardId}`;
}
function $fbafacc962018516$export$3416b472014eed93(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}`;
}
function $fbafacc962018516$export$16e1d659b389d4ae(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}/calendar`;
}
function $fbafacc962018516$export$45f8e28589795b6f(accountId, boardId) {
    return `/jira/people/${accountId}/boards/${boardId}`;
}
function $fbafacc962018516$export$222cc43a27cdf5b1(ordinaryBoardUrl) {
    return `${ordinaryBoardUrl}/settings`;
}
function $fbafacc962018516$var$isServiceDeskLocation(location) {
    return location.pathname.includes('/servicedesk');
}

});

parcelRegister("QaFzq", function(module, exports) {

$parcel$export(module.exports, "useRoute", () => $57ba212b9ebdebd8$export$3f79f0b98112cf57);

var $kfvK2 = parcelRequire("kfvK2");
const $57ba212b9ebdebd8$export$3f79f0b98112cf57 = (0, $kfvK2.createRouterSelector)((state)=>state.route);

});

parcelRegister("286cZ", function(module, exports) {

$parcel$export(module.exports, "memoWithCondition", () => $cea01c3b12e620fb$export$26f85cb52df6fa94);

var $eJOHy = parcelRequire("eJOHy");

var $f2JN3 = parcelRequire("f2JN3");
const $cea01c3b12e620fb$export$26f85cb52df6fa94 = (condition, Component, propsAreEqual)=>{
    return (0, $f2JN3.componentWithCondition)(condition, /*#__PURE__*/ (0, $eJOHy.memo)(Component, propsAreEqual), Component);
};

});

parcelRegister("9cReq", function(module, exports) {

$parcel$export(module.exports, "default", () => $128070dd19f44f46$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $128070dd19f44f46$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    boardSettingsLabel: {
        "id": "navigation-board-action-menu.board-settings-label",
        "defaultMessage": "Board settings"
    },
    deleteBoardLabel: {
        "id": "navigation-board-action-menu.delete-board-label",
        "defaultMessage": "Delete board"
    },
    dropdownIconLabel: {
        "id": "navigation-board-action-menu.dropdown-icon-label",
        "defaultMessage": "Board actions"
    }
});

});


parcelRegister("9Ovhp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b513bf94d7988b1$export$2e2bcd8739ae039);
/* BaseHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lTqUW = parcelRequire("lTqUW");

var $1MP4r = parcelRequire("1MP4r");
const $6b513bf94d7988b1$var$BaseHeader = ({ title: title, withInlineEdit: withInlineEdit, onConfirm: onConfirm, onValidate: onValidate, id: id, icon: icon, extraComponentsClose: extraComponentsClose, extraComponentsFar: extraComponentsFar, extraComponentsAbove: extraComponentsAbove, isLoading: isLoading = false, testId: testId })=>{
    const WrapperElement = extraComponentsAbove ? (0, $8nu6j.default) : (0, $eJOHy.Fragment);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrapperElement, null, extraComponentsAbove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        xcss: $6b513bf94d7988b1$var$extraComponentsAboveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6b513bf94d7988b1$var$breadcrumbSkeletonStyles,
        testId: "navigation-kit-header.extra-component-above-skeleton-1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6b513bf94d7988b1$var$breadcrumbSkeletonStyles,
        testId: "navigation-kit-header.extra-component-above-skeleton-2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $6b513bf94d7988b1$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTqUW.IconSkeleton), {
        "data-testid": "business-horizontal-nav.common.ui.header.icon-skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6b513bf94d7988b1$var$titleSkeletonStyles,
        testId: "business-horizontal-nav.common.ui.header.title-skeleton"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrapperElement, null, extraComponentsAbove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $6b513bf94d7988b1$var$extraComponentsAboveStyles
    }, extraComponentsAbove), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $6b513bf94d7988b1$var$headerWrapperStyles,
        testId: testId
    }, icon, withInlineEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MP4r.EditableTitle), {
        key: id,
        title: title,
        onConfirm: onConfirm,
        onValidate: onValidate
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6b513bf94d7988b1$var$titleContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6b513bf94d7988b1$var$Title, null, title)), extraComponentsClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: "start"
    }, extraComponentsClose), extraComponentsFar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: "end",
        space: "space.100",
        xcss: $6b513bf94d7988b1$var$extraComponentsFarStyles
    }, extraComponentsFar)));
};
var $6b513bf94d7988b1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($6b513bf94d7988b1$var$BaseHeader);
const $6b513bf94d7988b1$var$headerWrapperStyles = (0, $1DXK0.xcss)({
    justifyContent: 'flex-start',
    gap: 'space.075',
    alignItems: 'center',
    minWidth: "var(--ds-space-0, 0px)",
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    height: "var(--ds-space-400, 32px)"
});
const $6b513bf94d7988b1$var$titleSkeletonStyles = (0, $1DXK0.xcss)({
    boxSizing: 'border-box',
    height: "var(--ds-space-300, 24px)",
    width: '200px',
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $6b513bf94d7988b1$var$breadcrumbSkeletonStyles = (0, $1DXK0.xcss)({
    boxSizing: 'border-box',
    height: "var(--ds-space-300, 24px)",
    width: '90px',
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $6b513bf94d7988b1$var$extraComponentsFarStyles = (0, $1DXK0.xcss)({
    alignSelf: 'end',
    marginLeft: 'auto'
});
const $6b513bf94d7988b1$var$extraComponentsAboveStyles = (0, $1DXK0.xcss)({
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: "var(--ds-space-0, 0px)",
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $6b513bf94d7988b1$var$titleContainerStyles = (0, $1DXK0.xcss)({
    display: 'grid'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b513bf94d7988b1$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _11c8lodh _19pkidpf _syazfrbu _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lTqUW", function(module, exports) {

$parcel$export(module.exports, "ProjectIcon", () => $50dc293c5a2437d6$export$219c8b8c393795b3);
$parcel$export(module.exports, "IconSkeleton", () => $50dc293c5a2437d6$export$777a4901c1708535);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $50dc293c5a2437d6$var$iconStylesCompiledStyles = null;
const $50dc293c5a2437d6$export$219c8b8c393795b3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _vchhusvi _4t3igktf _1bsbgktf",
            __cmplp.className
        ])
    });
});
const $50dc293c5a2437d6$export$777a4901c1708535 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _vchhusvi _4t3igktf _1bsbgktf _bfhkn82g",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1MP4r", function(module, exports) {

$parcel$export(module.exports, "EditableTitle", () => $0665efefa01186e8$export$f9d7171ad5f156a8);
/* EditableTitle.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/choreographer/message-id-by-folder-structure */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6FuZ5 = parcelRequire("6FuZ5");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $cNe2t = parcelRequire("cNe2t");

var $jYYNE = parcelRequire("jYYNE");

var $6Cjp7 = parcelRequire("6Cjp7");
const $0665efefa01186e8$var$renderReadView = (title, triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("h1", {
        ...triggerProps,
        className: (0, $hcewu.default)([
            "_1e0c11p5 _k48pmoej"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0665efefa01186e8$var$ReadView, {
        "data-testid": "horizontal-nav-header.common.ui.read-view"
    }, title));
const $0665efefa01186e8$export$f9d7171ad5f156a8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ title: title, onConfirm: onConfirm, onValidate: onValidate })=>{
    const [editValue, setEditValue] = (0, $eJOHy.useState)(title);
    const [error, setError] = (0, $eJOHy.useState)('');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $jYYNE.inlineEditTitleEditViewEntryPoint), {});
    const readViewTrigger = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const editProjectNameGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $6Cjp7.default).editProjectNameGalaxia : (0, $6Cjp7.default).editProjectName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0665efefa01186e8$var$inlineEditTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6FuZ5.default), {
        isRequired: true,
        ...(0, $7jTnu.fg)('jfp_a11y_autodev_bus_project_name_edit_label') && {
            editLabel: formatMessage(editProjectNameGalaxia)
        },
        defaultValue: editValue,
        onEdit: ()=>setError(''),
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                id: "navigation-kit-header.inline-edit-title-edit-view",
                packageName: "jiraNavigationKitHeaderInlineEditTitleEditView",
                entryPointReferenceSubject: entryPointReferenceSubject,
                runtimeProps: {
                    errorMessage: errorMessage,
                    fieldProps: {
                        ...fieldProps,
                        defaultValue: editValue ?? '',
                        value: undefined
                    }
                },
                fallback: $0665efefa01186e8$var$renderReadView(title),
                errorFallback: ()=>$0665efefa01186e8$var$renderReadView(title)
            }),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                ref: readViewTrigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
                messageId: "navigation-kit-inline-edit-title.ui.jira-popup",
                messageType: "transactional",
                isOpen: error !== '',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                        xcss: $0665efefa01186e8$var$errorPopupStyles
                    }, error),
                placement: "right",
                trigger: (triggerProps)=>$0665efefa01186e8$var$renderReadView(editValue, triggerProps)
            })),
        onConfirm: (newValue)=>{
            const value = newValue.trim();
            setEditValue(value);
            onConfirm(value);
        },
        validate: (newValue)=>onValidate(title ?? '', newValue.trim())
    }));
});
const $0665efefa01186e8$var$errorPopupStyles = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    padding: 'space.200'
});
const $0665efefa01186e8$var$headingStyles = null;
const $0665efefa01186e8$var$inlineEditTitleStyles = (0, $1DXK0.xcss)({
    // Negative margin is added here to make the inline edit field fit in the
    // header without needing to modify the header height
    marginTop: 'space.negative.200',
    marginBottom: 'space.negative.100',
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0665efefa01186e8$var$ReadView = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _11c8lodh _syazfrbu _19pk12x7 _otyr12x7 _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6FuZ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e487e87e8a09dc$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $6svxr = parcelRequire("6svxr");

var $3L3Os = parcelRequire("3L3Os");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");

var $6fs4r = parcelRequire("6fs4r");

var $JpPJd = parcelRequire("JpPJd");

var $bMFcf = parcelRequire("bMFcf");

var $bVPmc = parcelRequire("bVPmc");
const $62e487e87e8a09dc$var$fieldStyles = null;
const $62e487e87e8a09dc$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $62e487e87e8a09dc$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $eJOHy.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $eJOHy.useState)(startWithEditViewOpen);
    const timerRef = (0, $eJOHy.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $bMFcf.default)(isEditing, isEditingState);
    const onCancel = (0, $eJOHy.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $eJOHy.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$62e487e87e8a09dc$var$analyticsAttributes
    });
    const onCancelClick = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $eJOHy.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $eJOHy.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $eJOHy.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bVPmc.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3L3Os.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $gt9Am.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $eGOwo.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $hcewu.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $JpPJd.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $62e487e87e8a09dc$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)($62e487e87e8a09dc$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $62e487e87e8a09dc$export$2e2bcd8739ae039 = $62e487e87e8a09dc$var$InlineEdit;

});
parcelRegister("6svxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b792a43640ff13ce$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
parcelRequire("8GOss");

var $gl2vi = parcelRequire("gl2vi");

var $h8JmM = parcelRequire("h8JmM");

var $3L3Os = parcelRequire("3L3Os");

var $cDJ0f = parcelRequire("cDJ0f");

var $lP4Q7 = parcelRequire("lP4Q7");

var $igDjg = parcelRequire("igDjg");
const $b792a43640ff13ce$var$fieldWrapperStyles = null;
function $b792a43640ff13ce$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $b792a43640ff13ce$var$isFunction(x) {
    return typeof x === 'function';
}
function $b792a43640ff13ce$var$usePreviousRef(current) {
    const ref = (0, $eJOHy.useRef)(current);
    // will be updated on the next render
    (0, $eJOHy.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $b792a43640ff13ce$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $b792a43640ff13ce$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eJOHy.useContext)((0, $3L3Os.FormContext));
    const isDisabled = (0, $eJOHy.useContext)((0, $3L3Os.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $b792a43640ff13ce$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $b792a43640ff13ce$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$b792a43640ff13ce$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eJOHy.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $b792a43640ff13ce$var$usePreviousRef(state);
    (0, $eJOHy.useEffect)(()=>{
        typeof $igDjg;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $b792a43640ff13ce$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($b792a43640ff13ce$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $gl2vi.useId)();
    const fieldId = (0, $eJOHy.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $hcewu.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cDJ0f.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lP4Q7.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8JmM.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("h8JmM", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $32369bd40dc5a2d5$export$3c4232819458a302);

var $eJOHy = parcelRequire("eJOHy");
const $32369bd40dc5a2d5$export$3c4232819458a302 = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);

});

parcelRegister("3L3Os", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $b42d4fbe800f0292$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $b42d4fbe800f0292$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $b42d4fbe800f0292$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kOCbD = parcelRequire("kOCbD");

var $dPWTT = parcelRequire("dPWTT");

var $d3vFW = parcelRequire("d3vFW");
const $b42d4fbe800f0292$export$c24727297075ec6a = /*#__PURE__*/ (0, $eJOHy.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $b42d4fbe800f0292$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
function $b42d4fbe800f0292$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eJOHy.useRef)(null);
    const onSubmitRef = (0, $eJOHy.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eJOHy.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $kOCbD.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($d3vFW)))(values, name, value);
                    }
                }
            }
        });
        (0, $dPWTT.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eJOHy.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eJOHy.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eJOHy.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eJOHy.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b42d4fbe800f0292$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($b42d4fbe800f0292$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("kOCbD", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f276193df2f288e0$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f276193df2f288e0$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f276193df2f288e0$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f276193df2f288e0$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f276193df2f288e0$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f276193df2f288e0$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f276193df2f288e0$export$f681a8129d2e9d28);

var $fpB9r = parcelRequire("fpB9r");

var $2unhp = parcelRequire("2unhp");
//      
var $f276193df2f288e0$var$charCodeOfDot = ".".charCodeAt(0);
var $f276193df2f288e0$var$reEscapeChar = /\\(\\)?/g;
var $f276193df2f288e0$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f276193df2f288e0$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f276193df2f288e0$var$charCodeOfDot) result.push("");
    string.replace($f276193df2f288e0$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f276193df2f288e0$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f276193df2f288e0$var$keysCache = {};
var $f276193df2f288e0$var$keysRegex = /[.[\]]+/;
var $f276193df2f288e0$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f276193df2f288e0$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f276193df2f288e0$var$keysCache[key] = key.split($f276193df2f288e0$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f276193df2f288e0$var$keysCache[key] = $f276193df2f288e0$var$stringToPath(key);
    }
    return $f276193df2f288e0$var$keysCache[key];
};
//      
var $f276193df2f288e0$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f276193df2f288e0$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f276193df2f288e0$var$_toPropertyKey(arg) {
    var key = $f276193df2f288e0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f276193df2f288e0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f276193df2f288e0$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $2unhp.default)(current, [
                key
            ].map($f276193df2f288e0$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $fpB9r.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f276193df2f288e0$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f276193df2f288e0$var$setInRecursor(state, 0, $f276193df2f288e0$var$toPath(key), value1, destroyArrays);
};
var $f276193df2f288e0$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f276193df2f288e0$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f276193df2f288e0$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f276193df2f288e0$export$c52e5867d5879e24(values, name);
    var error = $f276193df2f288e0$export$c52e5867d5879e24(errors, name);
    if (error && error[$f276193df2f288e0$export$735bebc8ffabf28a]) error = error[$f276193df2f288e0$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f276193df2f288e0$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f276193df2f288e0$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f276193df2f288e0$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f276193df2f288e0$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f276193df2f288e0$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f276193df2f288e0$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f276193df2f288e0$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f276193df2f288e0$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f276193df2f288e0$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f276193df2f288e0$var$subscriptionFilter(result, state, previousState, subscription, $f276193df2f288e0$export$41e855cb628c1b55, $f276193df2f288e0$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f276193df2f288e0$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f276193df2f288e0$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f276193df2f288e0$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f276193df2f288e0$var$subscriptionFilter(result, state, previousState, subscription, $f276193df2f288e0$export$f1ff97b9d1c7a3c3, $f276193df2f288e0$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f276193df2f288e0$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f276193df2f288e0$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f276193df2f288e0$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f276193df2f288e0$export$83d89fbfd8236492 = "4.20.10";
var $f276193df2f288e0$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f276193df2f288e0$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f276193df2f288e0$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f276193df2f288e0$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f276193df2f288e0$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f276193df2f288e0$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f276193df2f288e0$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f276193df2f288e0$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f276193df2f288e0$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f276193df2f288e0$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $fpB9r.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $fpB9r.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $fpB9r.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $fpB9r.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $fpB9r.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f276193df2f288e0$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f276193df2f288e0$export$e6bdf135a54e021b,
                    shallowEqual: $f276193df2f288e0$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $fpB9r.default)({}, state.formState.values)); // clone to avoid writing
            if ($f276193df2f288e0$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f276193df2f288e0$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f276193df2f288e0$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $fpB9r.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f276193df2f288e0$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f276193df2f288e0$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f276193df2f288e0$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f276193df2f288e0$export$735bebc8ffabf28a]) {
                    var existing = $f276193df2f288e0$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f276193df2f288e0$export$735bebc8ffabf28a] = error[$f276193df2f288e0$export$735bebc8ffabf28a];
                    merged = $f276193df2f288e0$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f276193df2f288e0$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f276193df2f288e0$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f276193df2f288e0$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f276193df2f288e0$var$notify(fieldSubscriber, fieldState, lastFieldState, $f276193df2f288e0$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f276193df2f288e0$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $fpB9r.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f276193df2f288e0$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f276193df2f288e0$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f276193df2f288e0$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f276193df2f288e0$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f276193df2f288e0$var$notify(state.subscribers, nextFormState, lastFormState, $f276193df2f288e0$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $fpB9r.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f276193df2f288e0$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $fpB9r.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $fpB9r.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f276193df2f288e0$export$c52e5867d5879e24(formState.values, key), $f276193df2f288e0$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f276193df2f288e0$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f276193df2f288e0$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f276193df2f288e0$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f276193df2f288e0$export$c52e5867d5879e24(state.formState.values, name) === $f276193df2f288e0$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f276193df2f288e0$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f276193df2f288e0$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $fpB9r.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $fpB9r.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $fpB9r.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f276193df2f288e0$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f276193df2f288e0$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $fpB9r.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f276193df2f288e0$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f276193df2f288e0$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f276193df2f288e0$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f276193df2f288e0$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("dPWTT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12dba3049b97319$export$2e2bcd8739ae039);

var $kOCbD = parcelRequire("kOCbD");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $a12dba3049b97319$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $a12dba3049b97319$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($a12dba3049b97319$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $a12dba3049b97319$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $kOCbD.getIn)(errors, input.name);
    });
};
//      
var $a12dba3049b97319$var$noop = function noop() {};
var $a12dba3049b97319$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $a12dba3049b97319$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $a12dba3049b97319$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $a12dba3049b97319$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $a12dba3049b97319$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($a12dba3049b97319$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$a12dba3049b97319$export$2e2bcd8739ae039 = $a12dba3049b97319$var$createDecorator;

});

parcelRegister("d3vFW", function(module, exports) {

var $j4TC7 = parcelRequire("j4TC7");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $981420477fbe9257$var$set(object, path, value) {
    return object == null ? object : $j4TC7(object, path, value);
}
module.exports = $981420477fbe9257$var$set;

});


parcelRegister("lP4Q7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f003b759d66377bb$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $f003b759d66377bb$var$requiredIndicatorStyles = null;
function $f003b759d66377bb$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $hcewu.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("JpPJd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd77e55f5b6541b9$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $entZ3 = parcelRequire("entZ3");

var $laG04 = parcelRequire("laG04");
const $bd77e55f5b6541b9$var$buttonsContainerStyles = null;
const $bd77e55f5b6541b9$var$buttonWrapperBaseStyles = null;
const $bd77e55f5b6541b9$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                tabIndex: -1,
                className: (0, $hcewu.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($entZ3))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                tabIndex: -1,
                className: (0, $hcewu.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($laG04))),
                            size: "small"
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd77e55f5b6541b9$export$2e2bcd8739ae039 = $bd77e55f5b6541b9$var$Buttons;

});
parcelRegister("entZ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a77a78d359015cce$var$_react = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a77a78d359015cce$var$_checkMark = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("lwpci")));

var $a77a78d359015cce$var$_check = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("2kdvq")));
function $a77a78d359015cce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a77a78d359015cce$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a77a78d359015cce$var$_react.default.createElement($a77a78d359015cce$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $a77a78d359015cce$var$_check.default
    }, props));
$a77a78d359015cce$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $a77a78d359015cce$var$_default = module.exports.default = $a77a78d359015cce$var$CheckMarkIcon;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("2kdvq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b17ecff78f4ff04$var$_react = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1b17ecff78f4ff04$var$_checkMark = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("lwpci")));
function $1b17ecff78f4ff04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1b17ecff78f4ff04$var$CheckIcon = (props)=>/*#__PURE__*/ $1b17ecff78f4ff04$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $1b17ecff78f4ff04$var$_checkMark.default
    }));
$1b17ecff78f4ff04$var$CheckIcon.displayName = 'CheckIcon';
var $1b17ecff78f4ff04$var$_default = module.exports.default = $1b17ecff78f4ff04$var$CheckIcon;

});



parcelRegister("bMFcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc8979cc798952aa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $cc8979cc798952aa$var$usePrevious = (value)=>{
    const ref = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $cc8979cc798952aa$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $eJOHy.useRef)(null);
    const editViewRef = (0, $eJOHy.useRef)();
    const preventFocusOnEditButtonRef = (0, $eJOHy.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $cc8979cc798952aa$var$usePrevious(shouldBeEditing);
    (0, $eJOHy.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $cc8979cc798952aa$export$2e2bcd8739ae039 = $cc8979cc798952aa$var$useButtonFocusHook;

});

parcelRegister("bVPmc", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c6797058a2257d$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $46R8N = parcelRequire("46R8N");
const $63c6797058a2257d$var$readViewContainerStyles = null;
const $63c6797058a2257d$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $63c6797058a2257d$var$readViewWrapperStyles = null;
const $63c6797058a2257d$var$readViewFitContainerWidthStyles = null;
const $63c6797058a2257d$var$DRAG_THRESHOLD = 5;
const $63c6797058a2257d$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $eJOHy.useRef)(0);
    const startY = (0, $eJOHy.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $63c6797058a2257d$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $63c6797058a2257d$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                xcss: $63c6797058a2257d$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $hcewu.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$63c6797058a2257d$export$2e2bcd8739ae039 = $63c6797058a2257d$var$ReadView;

});


parcelRegister("ciFJV", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $a303ea90dc94fcd0$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $a303ea90dc94fcd0$export$5f13515bd3a35325);

var $eJOHy = parcelRequire("eJOHy");

var $5uU9O = parcelRequire("5uU9O");
const $a303ea90dc94fcd0$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $eJOHy.useRef)(null);
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eJOHy.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $a303ea90dc94fcd0$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $5uU9O.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $5uU9O.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $a303ea90dc94fcd0$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("5uU9O", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $c2dcdcc6b465938f$export$15257a36a7e3f9d6);
function $c2dcdcc6b465938f$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("cBavF", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $75ab809c2125a8a7$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $75ab809c2125a8a7$export$54db9e88249c9162);

var $eJOHy = parcelRequire("eJOHy");

var $snbGZ = parcelRequire("snbGZ");

var $5GSFM = parcelRequire("5GSFM");
const $75ab809c2125a8a7$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $snbGZ.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GSFM.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $75ab809c2125a8a7$export$54db9e88249c9162 = (0, $5GSFM.InternalEntryPointContainer);

});
parcelRegister("snbGZ", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $ad7cb4b936d42fec$export$3cd1c81e13390c49);

var $eJOHy = parcelRequire("eJOHy");
const $ad7cb4b936d42fec$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $eJOHy.useState)(subject.getValue);
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed) return null;
    return entryPointReference;
};

});

parcelRegister("5GSFM", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $3534dc73cb841369$export$5d4dc37edd8a3adb);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $16sa1 = parcelRequire("16sa1");
const $3534dc73cb841369$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});


parcelRegister("bbdV2", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $8ca00ab1031880fd$export$338256068bc140fb);

var $eJOHy = parcelRequire("eJOHy");

var $hrKgE = parcelRequire("hrKgE");

var $7jTnu = parcelRequire("7jTnu");

var $3LuvQ = parcelRequire("3LuvQ");

var $aeX2M = parcelRequire("aeX2M");

var $9xjtP = parcelRequire("9xjtP");

var $4A4Zy = parcelRequire("4A4Zy");
const $8ca00ab1031880fd$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $3LuvQ.DEFAULT_OPTIONS))=>{
    // TODO: break tests on instability (stableEntryPointParams!==entryPointParams)
    // prevents {} from from triggering updates
    const stableEntryPointParams = (0, $hrKgE.useShallowStableReference)(entryPointParams, (0, $7jTnu.fg)('jfp_magma_entrypoint-stability'));
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $9xjtP.useEntryPointLoadManager)(entryPoint, stableEntryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $4A4Zy.useMetricLogger)(metric);
    const entryPointActions = (0, $aeX2M.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $eJOHy.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("hrKgE", function(module, exports) {

$parcel$export(module.exports, "useShallowStableReference", () => $06a9fa47a6e96bcb$export$cb8a85c49e39f60);
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions */ 
var $eJOHy = parcelRequire("eJOHy");

var $j5V5L = parcelRequire("j5V5L");
const $06a9fa47a6e96bcb$var$STABLE_EMPTY_OBJECT = Object.freeze({});
const $06a9fa47a6e96bcb$var$STABLE_EMPTY_ARRAY = Object.freeze([]);
const $06a9fa47a6e96bcb$export$419c5efa1812e327 = ()=>$06a9fa47a6e96bcb$var$STABLE_EMPTY_OBJECT;
const $06a9fa47a6e96bcb$export$d81919e21b7bcda0 = ()=>$06a9fa47a6e96bcb$var$STABLE_EMPTY_ARRAY;
const $06a9fa47a6e96bcb$export$abf22ef229d645f7 = (value)=>Object.keys(value).length === 0 ? $06a9fa47a6e96bcb$var$STABLE_EMPTY_OBJECT : value;
const $06a9fa47a6e96bcb$export$540f03090e93e8f6 = (value)=>value.length === 0 ? $06a9fa47a6e96bcb$var$STABLE_EMPTY_ARRAY : value;
function $06a9fa47a6e96bcb$export$cb8a85c49e39f60(props, isEnabled = true) {
    const ref = (0, $eJOHy.useRef)(props);
    if (!isEnabled) return props;
    if (!(0, $j5V5L.default)(props, ref.current)) ref.current = props;
    return ref.current;
}

});

parcelRegister("3LuvQ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $e82a6aa1e9c0eb22$export$93ca5d3f8675ae4c);
const $e82a6aa1e9c0eb22$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("aeX2M", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $85e8a52a8265740a$export$90681c8c3a56f09a);

var $eJOHy = parcelRequire("eJOHy");

var $7oY9g = parcelRequire("7oY9g");

var $3LuvQ = parcelRequire("3LuvQ");
const $85e8a52a8265740a$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $85e8a52a8265740a$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $3LuvQ.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $3LuvQ.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $eJOHy.useRef)();
    const preloadMaxAgeTimeout = (0, $eJOHy.useRef)();
    const preloadLastRequested = (0, $eJOHy.useRef)(0);
    const cancelPreload = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $7oY9g.default)($85e8a52a8265740a$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $eJOHy.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7oY9g.default)($85e8a52a8265740a$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $eJOHy.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("9xjtP", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $447bc9b48f37e295$export$bfae318f9651db2f);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5HFSX = parcelRequire("5HFSX");

var $8aUoh = parcelRequire("8aUoh");
const $447bc9b48f37e295$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $5HFSX.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $eJOHy.useRef)(true);
    const removeInactiveLoadsIdleCallback = (0, $eJOHy.useRef)(null);
    const entryPointReferenceQueue = (0, $eJOHy.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $8aUoh.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $eJOHy.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        $447bc9b48f37e295$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
        removeInactiveLoadsIdleCallback.current = $447bc9b48f37e295$var$callWhenIdle(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $8aUoh.removeAll)(currentQueue) : (0, $8aUoh.removeInactiveLoads)(currentQueue);
        });
    }, [
        setEntryPointReference
    ]);
    const load = (0, $eJOHy.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $8aUoh.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $eJOHy.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $eJOHy.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $447bc9b48f37e295$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $8aUoh.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    return {
        entryPointReferenceSubject: (0, $eJOHy.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $447bc9b48f37e295$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $447bc9b48f37e295$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("8aUoh", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $e779802cdcfaaa06$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $e779802cdcfaaa06$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $e779802cdcfaaa06$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $e779802cdcfaaa06$export$322c8997d351da6a);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");
const $e779802cdcfaaa06$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $e779802cdcfaaa06$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $e779802cdcfaaa06$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $e779802cdcfaaa06$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $eJOHy.useRef)(null);
    const subscribers = (0, $eJOHy.useRef)();
    const unsub = (0, $eJOHy.useRef)(null);
    const subscribe = (0, $eJOHy.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $eJOHy.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $aQK2r.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($e779802cdcfaaa06$var$isReactAsyncJSResourceReference(entryPoint?.root)) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $eJOHy.useCallback)(()=>value.current, []);
    (0, $eJOHy.useEffect)(()=>()=>{
            subscribers.current?.clear();
            unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $e779802cdcfaaa06$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("4A4Zy", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $d8d6f61443a51422$export$f291ec7cea728e1);

var $eJOHy = parcelRequire("eJOHy");
const $d8d6f61443a51422$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $eJOHy.useRef)(0);
    const loadStartTime = (0, $eJOHy.useRef)(0);
    const startMetric = (0, $eJOHy.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $eJOHy.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("jYYNE", function(module, exports) {

$parcel$export(module.exports, "inlineEditTitleEditViewEntryPoint", () => $b62e19186ac95e77$export$6adaa323774f44e4);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $b62e19186ac95e77$export$6adaa323774f44e4 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dGDB6")).then((module)=>module.InlineEditTitleEditViewEntryPoint), {
        moduleId: "55d1ca2e",
        moduleName: "InlineEditTitleEditView",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dGDB6", function(module, exports) {

let $9f6de9d96872604f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9f6de9d96872604f$var$load("bWMh7").then(()=>parcelRequire('5tdkd'));

});


parcelRegister("6Cjp7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dc03a8d45331f7e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6dc03a8d45331f7e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    editProjectName: {
        "id": "horizontal.nav.header.editable.title.edit.project.name",
        "defaultMessage": "Project name"
    },
    editProjectNameGalaxia: {
        "id": "horizontal.nav.header.editable.title.edit.project.name-galaxia",
        "defaultMessage": "Space name"
    }
});

});



parcelRegister("1715R", function(module, exports) {

$parcel$export(module.exports, "ExtraComponentsFar", () => $b91e592935911174$export$e21e0ccc96f4edd);

var $25QOc = parcelRequire("25QOc");

var $eJOHy = parcelRequire("eJOHy");

var $lT9x0 = parcelRequire("lT9x0");

var $j4oe4 = parcelRequire("j4oe4");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");

var $5bzWA = parcelRequire("5bzWA");

var $cECwI = parcelRequire("cECwI");

var $hih5V = parcelRequire("hih5V");

var $4DtHG = parcelRequire("4DtHG");

var $945lE = parcelRequire("945lE");

var $4Ig6r = parcelRequire("4Ig6r");
const $b91e592935911174$export$e21e0ccc96f4edd = ({ projectFragment: projectFragment })=>{
    const [isFullscreen] = (0, $5bzWA.useIsFullscreen)();
    const { name: currentRouteName } = (0, $hih5V.useCurrentRoute)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const componentsToShow = [];
    const project = (0, $j4oe4.useFragment)((0, $25QOc.default), projectFragment);
    const hasFullscreenButton = (0, $945lE.SUPPORTED_ROUTES).includes(currentRouteName);
    const canEditProjectConfig = project?.canEditProjectConfig?.canPerform ?? false;
    const shouldShowAutomation = !isAnonymous && project && canEditProjectConfig;
    const isSimplified = project?.projectStyle === (0, $ln6Iy.TEAM_MANAGED_PROJECT);
    if (isFullscreen) {
        if (hasFullscreenButton && (0, $7jTnu.fg)('blu-5747-fullscreen-in-nav-header')) {
            componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $945lE.HeaderFullscreenButton), {
                key: "fullscreen"
            }));
            return componentsToShow;
        }
        return null;
    }
    let projectShareContext = null;
    if (project) projectShareContext = {
        avatarUrl: project?.avatar?.large ?? '',
        id: Number(project.projectId),
        isSimplified: isSimplified,
        key: project.key,
        name: project.name,
        style: project.projectStyle === (0, $ln6Iy.TEAM_MANAGED_PROJECT) ? (0, $ln6Iy.ProjectStyle).NEXT_GEN : (0, $ln6Iy.ProjectStyle).CLASSIC,
        type: project?.projectType ?? ''
    };
    if (hasFullscreenButton && (0, $7jTnu.fg)('blu-5747-fullscreen-in-nav-header')) componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $945lE.HeaderFullscreenButton), {
        key: "fullscreen"
    }));
    if (projectShareContext && !isAnonymous) componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), {
        key: "share-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "ccEcoBoardBacklogShare"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4DtHG.ShareButton), {
        data: projectShareContext,
        key: "Share"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lT9x0.EngagementSpotlight), {
        name: "ccEcoBoardBacklogShare"
    })));
    if (shouldShowAutomation) componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Ig6r.AutomationButton), {
        key: "automation"
    }));
    return componentsToShow;
};

});
parcelRegister("25QOc", function(module, exports) {

$parcel$export(module.exports, "default", () => $72600aec7b9df22f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6388d6addc3201cb95f9624f0c643121>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $72600aec7b9df22f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "extraComponentsFar_horizontalNav",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ],
    "type": "JiraProject"
};
$72600aec7b9df22f$var$node.hash = "5e95b8ebdc04c45245fa22575f910961";
var $72600aec7b9df22f$export$2e2bcd8739ae039 = $72600aec7b9df22f$var$node;

});

parcelRegister("cECwI", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $1be319143530f4ed$export$bf7b5d502f6d6d3b);

var $lvKO5 = parcelRequire("lvKO5");
const $1be319143530f4ed$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("4DtHG", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $922cba265e7df3da$export$e980dfbc2840e8bc);

var $eJOHy = parcelRequire("eJOHy");

var $dAv2D = parcelRequire("dAv2D");

var $bu8Y7 = parcelRequire("bu8Y7");

var $3osLr = parcelRequire("3osLr");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");


var $akZFZ = parcelRequire("akZFZ");

var $cJEMq = parcelRequire("cJEMq");

var $64uMB = parcelRequire("64uMB");

var $la2MJ = parcelRequire("la2MJ");

var $kEUB1 = parcelRequire("kEUB1");

var $6XJko = parcelRequire("6XJko");

var $dOdb3 = parcelRequire("dOdb3");

var $dVdVw = parcelRequire("dVdVw");
const $922cba265e7df3da$var$ShareButtonInner = ({ data: data })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isUserBoard = 'isProjectBoard' in data && data.isProjectBoard === false;
    const integrationType = (0, $64uMB.integrationTypes).BOARD;
    const objectAri = isUserBoard ? (0, $bu8Y7.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(data.id)
    }).toString() : (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(data.id)
    }).toString();
    const [{ onDialogClose: onDialogClose, poSpotlightShareButtonId: poSpotlightShareButtonId }] = (0, $akZFZ.useProjectShareButton)();
    const contentType = `${data.name}_${integrationType}`;
    // move back inline when cleaning up jira-project-theming-m2-bug-fixes
    const getIconColor = (0, $eJOHy.useCallback)((isSelected)=>{
        if ((0, $7jTnu.fg)('jira-project-theming-m2-bug-fixes')) return isSelected ? 'currentColor' : "var(--ds-icon-subtle, #626F86)";
        return (0, $6XJko.isVisualRefreshEnabled)() ? "var(--ds-icon-subtle, #626F86)" : 'currentColor';
    }, []);
    const renderCustomTriggerButton = (0, $eJOHy.useCallback)(({ onClick: onClick, isSelected: isSelected }, { ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
            ...triggerProps,
            onClick: onClick,
            isSelected: isSelected,
            id: "po-spotlight-share-button",
            "data-vc": "share-button",
            appearance: (0, $6XJko.isVisualRefreshEnabled)() ? 'default' : 'subtle',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAv2D))), {
                spacing: "spacious",
                label: formatMessage((0, $dVdVw.messages).shareFormTitle),
                color: getIconColor(isSelected)
            })
        }), [
        formatMessage,
        getIconColor
    ]);
    const [isFirstHovered, setIsFirstHovered] = (0, $eJOHy.useState)(false);
    const shareButtonRef = (0, $eJOHy.useRef)(null);
    const handleIconHover = (0, $eJOHy.useCallback)(()=>{
        setIsFirstHovered(true);
        shareButtonRef?.current?.focus();
    }, []);
    // GALILEO-1454 START
    const fireJpdRoadmapOnTimelineSpotlightTrigger = (0, $dOdb3.useFireJpdRoadmapOnTimelineSpotlightTrigger)();
    const handleShareDialogClose = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7jTnu.fg)('grw-880_jpd_roadmap_on_jira_timeline_killswitch')) fireJpdRoadmapOnTimelineSpotlightTrigger();
        onDialogClose?.();
    }, [
        fireJpdRoadmapOnTimelineSpotlightTrigger,
        onDialogClose
    ]);
    // GALILEO-1454 END
    return isFirstHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: shareButtonRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $la2MJ.ShareButton), {
        integrationType: integrationType,
        productId: "jira",
        subProductId: "jira-software",
        shareTitle: data.name,
        shareContentType: contentType,
        objectAri: objectAri,
        poSpotlightShareButtonId: poSpotlightShareButtonId,
        shareFormTitle: formatMessage((0, $dVdVw.messages).shareFormTitle),
        shareFormHelperMessage: formatMessage((0, $dVdVw.messages).shareHelperMessage),
        renderCustomTriggerButton: renderCustomTriggerButton,
        onDialogClose: handleShareDialogClose
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAv2D))), {
            spacing: "spacious",
            label: formatMessage((0, $dVdVw.messages).shareFormTitle),
            color: (0, $6XJko.isVisualRefreshEnabled)() ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
        }),
        appearance: (0, $6XJko.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onMouseEnter: handleIconHover,
        onFocus: handleIconHover
    });
};
const $922cba265e7df3da$export$e980dfbc2840e8bc = ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akZFZ.ProjectShareContainer), {
        scope: (0, $54053908446ae943$export$f86c4708a4b1ecd4)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($922cba265e7df3da$var$ShareButtonInner, {
        data: data
    }));

});
parcelRegister("dAv2D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e46b7569d180ef1$var$_react = $9e46b7569d180ef1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9e46b7569d180ef1$var$_share = $9e46b7569d180ef1$var$_interopRequireDefault((parcelRequire("iePme")));

var $9e46b7569d180ef1$var$_share2 = $9e46b7569d180ef1$var$_interopRequireDefault((parcelRequire("4jCd5")));
function $9e46b7569d180ef1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e46b7569d180ef1$var$ShareIcon = (props)=>/*#__PURE__*/ $9e46b7569d180ef1$var$_react.default.createElement($9e46b7569d180ef1$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $9e46b7569d180ef1$var$_share2.default
    }, props));
$9e46b7569d180ef1$var$ShareIcon.Name = 'ShareIconMigration';
var $9e46b7569d180ef1$var$_default = module.exports.default = $9e46b7569d180ef1$var$ShareIcon;

});
parcelRegister("4jCd5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32469378f409d14d$var$_react = $32469378f409d14d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $32469378f409d14d$var$_share = $32469378f409d14d$var$_interopRequireDefault((parcelRequire("iePme")));
function $32469378f409d14d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $32469378f409d14d$var$ShareIcon = (props)=>/*#__PURE__*/ $32469378f409d14d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $32469378f409d14d$var$_share.default
    }));
$32469378f409d14d$var$ShareIcon.displayName = 'ShareIcon';
var $32469378f409d14d$var$_default = module.exports.default = $32469378f409d14d$var$ShareIcon;

});


const $54053908446ae943$export$f86c4708a4b1ecd4 = 'project-share-button-global';

parcelRegister("akZFZ", function(module, exports) {

$parcel$export(module.exports, "ProjectShareContainer", () => $3630bfaa821ae6bc$export$44b5323fa87de475);
$parcel$export(module.exports, "useProjectShareButton", () => $3630bfaa821ae6bc$export$5abd9014d277b249);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $3630bfaa821ae6bc$export$44b5323fa87de475 = (0, $6E16M.createContainer)();
const $3630bfaa821ae6bc$var$initialState = {
    integrationType: '',
    productId: 'jira',
    subProductId: undefined,
    shareLink: undefined,
    shareTitle: '',
    shareContentType: '',
    shareFormTitle: undefined,
    objectAri: '',
    shareIntegrations: undefined,
    copyTooltipText: undefined,
    onDialogClose: undefined,
    onTriggerButtonClick: undefined,
    shareFormHelperMessage: undefined,
    shareFieldsFooter: undefined,
    poSpotlightShareButtonId: undefined
};
const $3630bfaa821ae6bc$var$Store = (0, $GtRbT.createStore)({
    containedBy: $3630bfaa821ae6bc$export$44b5323fa87de475,
    initialState: $3630bfaa821ae6bc$var$initialState,
    actions: {
        setContext: (context)=>({ setState: setState })=>{
                setState({
                    ...$3630bfaa821ae6bc$var$initialState,
                    ...context
                });
            },
        clearContext: ()=>({ setState: setState })=>{
                setState($3630bfaa821ae6bc$var$initialState);
            }
    },
    name: 'project-share-button'
});
const $3630bfaa821ae6bc$export$5abd9014d277b249 = (0, $iJq0l.createHook)($3630bfaa821ae6bc$var$Store);

});

parcelRegister("cJEMq", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $a37d1ebc6d556273$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cA0Y2 = parcelRequire("cA0Y2");
const $a37d1ebc6d556273$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a37d1ebc6d556273$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a37d1ebc6d556273$var$CustomButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $cA0Y2.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("64uMB", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $5b22545d0f98b1bc$export$a7359bcfb0ca8e98);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $5b22545d0f98b1bc$export$f7109619a5e9e0d6);
const $5b22545d0f98b1bc$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments',
    DEPENDENCIES: 'dependencies',
    INCREMENT: 'increment',
    QUEUE: 'queue'
};
const $5b22545d0f98b1bc$export$f7109619a5e9e0d6 = 'growthShareButton';

});

parcelRegister("la2MJ", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $0aa25fa4ffdb1f12$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButton", () => $0aa25fa4ffdb1f12$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "default", () => $0aa25fa4ffdb1f12$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $dAv2D = parcelRequire("dAv2D");

var $lRq8t = parcelRequire("lRq8t");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $1KdDN = parcelRequire("1KdDN");

var $lQyw6 = parcelRequire("lQyw6");

var $25akk = parcelRequire("25akk");
const $0aa25fa4ffdb1f12$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAv2D))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $lQyw6.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $lQyw6.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0aa25fa4ffdb1f12$var$ShareButtonBase = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("euYvT")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $0aa25fa4ffdb1f12$export$e980dfbc2840e8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $25akk.ShareButtonAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0aa25fa4ffdb1f12$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0aa25fa4ffdb1f12$var$ShareButtonBase, props))));
var $0aa25fa4ffdb1f12$export$2e2bcd8739ae039 = $0aa25fa4ffdb1f12$export$e980dfbc2840e8bc;

});
parcelRegister("lQyw6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e033b89304d7d864$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e033b89304d7d864$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("25akk", function(module, exports) {

$parcel$export(module.exports, "ShareButtonAnalyticsWrapper", () => $33efcf856c361e33$export$e86cfe752403a1e4);

var $eJOHy = parcelRequire("eJOHy");

var $eUaD0 = parcelRequire("eUaD0");

var $kQnVX = parcelRequire("kQnVX");

var $gZTP9 = parcelRequire("gZTP9");

var $7jTnu = parcelRequire("7jTnu");

var $2aY2d = parcelRequire("2aY2d");

var $f2JN3 = parcelRequire("f2JN3");

var $4xbv3 = parcelRequire("4xbv3");

var $ln6Iy = parcelRequire("ln6Iy");
const $33efcf856c361e33$var$BaseShareButtonAnalyticsWrapper = ({ children: children })=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const projectKey = data?.projectKey || '';
    const projectType = data?.projectType;
    const projectStyle = data?.simplified ? (0, $ln6Iy.TEAM_MANAGED_PROJECT) : (0, $ln6Iy.COMPANY_MANAGED_PROJECT);
    const userLocation = (0, $kQnVX.getUserLocation)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const isProjectAdmin = data?.isProjectAdmin || false;
    const analyticsData = (0, $eJOHy.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eUaD0.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children));
};
const $33efcf856c361e33$export$e86cfe752403a1e4 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jsw-smart-access-extended-analytics-enabled'), $33efcf856c361e33$var$BaseShareButtonAnalyticsWrapper, (0, $eJOHy.Fragment));

});
parcelRegister("2aY2d", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $8ba7ca521b299ffc$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $8ba7ca521b299ffc$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $8ba7ca521b299ffc$export$a85f6b5857d2176);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $dZRaT = parcelRequire("dZRaT");
const $8ba7ca521b299ffc$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $dZRaT.projectContextResourceWithCache), customContext);
    const updateCache = (0, $eJOHy.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $8ba7ca521b299ffc$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $8ba7ca521b299ffc$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $8ba7ca521b299ffc$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $8ba7ca521b299ffc$export$8f31c2503e1efa93();
    return children(projectContext);
};

});


parcelRegister("euYvT", function(module, exports) {

let $a8e2ceb65100aefe$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a8e2ceb65100aefe$var$load("kNFvF"),
    $a8e2ceb65100aefe$var$load("ffQaD"),
    $a8e2ceb65100aefe$var$load("kvRbA"),
    $a8e2ceb65100aefe$var$load("lJGjE")
]).then(()=>parcelRequire('k0hQy'));

});


parcelRegister("dOdb3", function(module, exports) {

$parcel$export(module.exports, "useHasJpd", () => $3e295612753821d3$export$885c04e01732e451);
$parcel$export(module.exports, "useFireJpdRoadmapOnTimelineSpotlightTrigger", () => $3e295612753821d3$export$251f5afd4b360688);
$parcel$export(module.exports, "useResetJpdRoadmapOnTimelineSpotlightTrigger", () => $3e295612753821d3$export$858259b849b74419);
$parcel$export(module.exports, "pickIssuesToConvert", () => $3e295612753821d3$export$8bc7e05763b0e01);
$parcel$export(module.exports, "useOpenCrossFlow", () => $3e295612753821d3$export$f6033fcc5716710c);

var $eJOHy = parcelRequire("eJOHy");

var $6X7AJ = parcelRequire("6X7AJ");
var $dNnxZ = parcelRequire("dNnxZ");

var $izzcG = parcelRequire("izzcG");

var $b9nqM = parcelRequire("b9nqM");

var $kfvK2 = parcelRequire("kfvK2");

var $5V25X = parcelRequire("5V25X");

var $7jTnu = parcelRequire("7jTnu");

const $3e295612753821d3$export$885c04e01732e451 = ()=>{
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    return licensedProducts['jira-product-discovery'] === true;
};
const $3e295612753821d3$export$e4406211eb6a241e = ()=>{
    const timelineRoutes = new Set([
        'classic-business-timeline',
        'software-timeline',
        'software-timeline-classic'
    ]);
    return (0, $kfvK2.useIsActiveRoute)(timelineRoutes);
};
const $3e295612753821d3$export$251f5afd4b360688 = ()=>{
    const isTimelineRoute = $3e295612753821d3$export$e4406211eb6a241e();
    const { fireTrigger: fireTrigger } = (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: (0, $6292b56922e6bced$export$6672f7663a94639)
    });
    const triggerSpotlight = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7jTnu.fg)('grw-880_jpd_roadmap_on_jira_timeline_killswitch')) {
            if (isTimelineRoute) fireTrigger({
                isActive: true
            });
        }
    }, [
        fireTrigger,
        isTimelineRoute
    ]);
    return triggerSpotlight;
};
const $3e295612753821d3$export$858259b849b74419 = ()=>{
    const { fireTrigger: fireTrigger } = (0, $5V25X.useFirePostOfficeTrigger)({
        triggerId: (0, $6292b56922e6bced$export$6672f7663a94639)
    });
    const triggerSpotlight = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7jTnu.fg)('grw-880_jpd_roadmap_on_jira_timeline_killswitch')) fireTrigger({
            isActive: false
        });
    }, [
        fireTrigger
    ]);
    return triggerSpotlight;
};
const $3e295612753821d3$var$sortIssuesEpicFirst = (a, b)=>{
    if (a.issueType === 'epic' && b.issueType === 'task') return -1;
    if (a.issueType === 'task' && b.issueType === 'epic') return 1;
    return 0;
};
const $3e295612753821d3$export$7d33d0f6a9facb15 = '4';
const $3e295612753821d3$export$2d2b9a257f1cc7e0 = '2';
const $3e295612753821d3$var$sortIssuesInProgressFirst = (a, b)=>{
    if (a.status.categoryId === $3e295612753821d3$export$7d33d0f6a9facb15 && b.status.categoryId === $3e295612753821d3$export$2d2b9a257f1cc7e0) return -1;
    if (a.status.categoryId === $3e295612753821d3$export$2d2b9a257f1cc7e0 && b.status.categoryId === $3e295612753821d3$export$7d33d0f6a9facb15) return 1;
    return 0;
};
const $3e295612753821d3$var$sortIssues = (a, b)=>{
    let result = $3e295612753821d3$var$sortIssuesEpicFirst(a, b);
    if (result === 0) result = $3e295612753821d3$var$sortIssuesInProgressFirst(a, b);
    if (result === 0) result = b.id.localeCompare(a.id);
    return result;
};
const $3e295612753821d3$export$8bc7e05763b0e01 = (issues, maxCount = 5)=>{
    return issues.sort($3e295612753821d3$var$sortIssues).slice(0, maxCount);
};
const $3e295612753821d3$export$f6033fcc5716710c = (inwardIssues)=>{
    const crossFlow = (0, $6X7AJ.useCrossFlow)();
    const templateId = 'jpd.product-roadmap';
    const inwardIssueIds = inwardIssues.map(({ id: id })=>id);
    const extensions = (0, $izzcG.createProvisioningApiExtensions)({
        actions: {
            primary: {
                behaviour: (0, $izzcG.Behaviours).LAND,
                prompt: (0, $izzcG.Prompts).NEXT,
                options: {
                    targetTab: (0, $izzcG.TargetTabs).SAME,
                    urlParams: {
                        templateId: templateId,
                        inwardIssueIds: inwardIssueIds.join(',')
                    }
                }
            }
        },
        jobName: 'jira-timeline-jpd-roadmap',
        jobParams: {
            inwardIssueIds: inwardIssueIds
        }
    });
    return (0, $eJOHy.useCallback)(()=>{
        crossFlow.isEnabled && crossFlow.apiV1.open({
            journey: (0, $6X7AJ.Journeys).GET_STARTED,
            targetProduct: (0, $dNnxZ.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'recJpdOnJiraTimelineMoreSettings',
            sourceContext: 'jpdRoadmapButton',
            extensions: extensions,
            v1: true
        });
    }, [
        crossFlow,
        extensions
    ]);
};

});
parcelRegister("b9nqM", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $e7b633a490276fcc$export$54d534cc91e54850);

var $lvKO5 = parcelRequire("lvKO5");
const $e7b633a490276fcc$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("5V25X", function(module, exports) {

$parcel$export(module.exports, "TriggerContextProvider", () => $6825a94eb84405ab$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $6825a94eb84405ab$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $6825a94eb84405ab$export$83b33e5fe4cce64);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $6825a94eb84405ab$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $6825a94eb84405ab$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6825a94eb84405ab$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($6825a94eb84405ab$var$initialActiveTriggerState);
const $6825a94eb84405ab$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($6825a94eb84405ab$var$initialTriggerDispatchState);
const $6825a94eb84405ab$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $eJOHy.useState)($6825a94eb84405ab$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $eJOHy.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $eJOHy.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $eJOHy.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($6825a94eb84405ab$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($6825a94eb84405ab$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
const $6825a94eb84405ab$export$454c1d7c35958f5e = ()=>(0, $eJOHy.useContext)($6825a94eb84405ab$var$TriggerContext);
const $6825a94eb84405ab$export$23cbf084e08bdb93 = ()=>(0, $eJOHy.useContext)($6825a94eb84405ab$var$TriggerDispatchContext);
const $6825a94eb84405ab$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6825a94eb84405ab$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $6825a94eb84405ab$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6825a94eb84405ab$export$23cbf084e08bdb93();
    const fireTrigger = (0, $eJOHy.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};

});

const $6292b56922e6bced$export$6672f7663a94639 = 'jpd-roadmap-on-timeline-spotlight-trigger';


parcelRegister("dVdVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $34b1a7a69c65a791$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $34b1a7a69c65a791$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    shareFormTitle: {
        "id": "horizontal-nav-header.common.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareHelperMessage: {
        "id": "horizontal-nav-header.common.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("945lE", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_ROUTES", () => $552bedd499598e71$export$f183fe8f38c8cf4f);
$parcel$export(module.exports, "HeaderFullscreenButton", () => $552bedd499598e71$export$ca813c374edd850d);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $faaK9 = parcelRequire("faaK9");

var $5bzWA = parcelRequire("5bzWA");

var $kfvK2 = parcelRequire("kfvK2");
const $552bedd499598e71$export$f183fe8f38c8cf4f = [
    'software-boards',
    'software-timeline-classic',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-user-board',
    'software-backlog',
    'software-timeline',
    'classic-business-timeline',
    'classic-business-board',
    'connect-project',
    'connect-general',
    'forge-spa-project',
    'forge-spa-global'
];
const $552bedd499598e71$export$ca813c374edd850d = ()=>{
    const [isFullscreen, { setIsFullscreen: setIsFullscreen }] = (0, $5bzWA.useIsFullscreen)();
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = (0, $kfvK2.addRouteListener)((state)=>{
            // The board settings page is /jira/software/c/projects/TEST/boards/81/?config=filter
            // which matches the RAPIDBOARD_BOARD route, but we want to exclude it from fullscreen
            const isOnBoardConfig = state.route.name === 'rapidboard-board' && !!state.query.config;
            if (isFullscreen && !$552bedd499598e71$export$f183fe8f38c8cf4f.includes(state.route.name) || isOnBoardConfig) setIsFullscreen(false);
        });
        return ()=>unsubscribe();
    }, [
        isFullscreen,
        setIsFullscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "jira-horizontal-nav-header-fullscreen-button",
        packageName: "jira-horizontal-nav-header",
        teamName: "Jira Cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $faaK9.default), {
        key: "fullscreen",
        "data-vc": "horizontal-nav-header-fullscreen-button",
        testId: "horizontal-nav-header.ui.fullscreen-button.fullscreen-button",
        withContainerStyles: false
    }));
};

});
parcelRegister("faaK9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e726d9d83560134$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $bx2Et = parcelRequire("bx2Et");

const $3e726d9d83560134$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle, isHidden: isHidden })=>{
    const [isFullscreenState, setIsFullscreenState] = (0, $eJOHy.useState)(isFullscreenProp ?? defaultFullscreen);
    const isFullscreen = isFullscreenProp ?? isFullscreenState;
    const handleToggle = (0, $eJOHy.useCallback)((wasFullscreen, globalStyle)=>{
        onToggle(wasFullscreen, globalStyle);
        setIsFullscreenState(!wasFullscreen);
    }, [
        onToggle,
        setIsFullscreenState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bx2Et.default), {
        testId: testId,
        onToggle: handleToggle,
        getCustomRefs: getCustomRefs,
        analyticsAttributes: analyticsAttributes,
        withContainerStyles: withContainerStyles,
        defaultFullscreen: defaultFullscreen,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: renderAsResponsiveButton,
        shouldRenderContent: shouldRenderContent,
        isSubtle: isSubtle,
        isHidden: isHidden
    });
};
$3e726d9d83560134$var$FullscreenButton.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    getCustomRefs: ()=>[],
    analyticsAttributes: {}
};
var $3e726d9d83560134$export$2e2bcd8739ae039 = $3e726d9d83560134$var$FullscreenButton;

});
parcelRegister("bx2Et", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdd97173f5c583f2$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $1hBh4 = parcelRequire("1hBh4");

var $3qmlA = parcelRequire("3qmlA");

var $k71qx = parcelRequire("k71qx");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $3IF6p = parcelRequire("3IF6p");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $5bzWA = parcelRequire("5bzWA");

var $6zXPf = parcelRequire("6zXPf");

var $gCeeo = parcelRequire("gCeeo");

var $cJEMq = parcelRequire("cJEMq");

var $7yc9S = parcelRequire("7yc9S");

var $6XJko = parcelRequire("6XJko");

var $8ze4a = parcelRequire("8ze4a");
const $fdd97173f5c583f2$var$removeFullScreenStyle = (customRefs)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.getElementById('fullscreen-global-style')?.remove();
    if (customRefs) customRefs.forEach((ref)=>{
        if (ref !== null) ref.classList.remove('fullscreen');
    });
};
let $fdd97173f5c583f2$var$globalStyleNew = null;
const $fdd97173f5c583f2$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false, isHidden: isHidden })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const customRefElements = (0, $eJOHy.useRef)(null);
    const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, $5bzWA.useIsFullscreen)();
    let globalStyleOld = null;
    if ((0, $7jTnu.fg)('blu-5747-fullscreen-in-nav-header')) {
        if (!false) {
            if ((0, $7jTnu.fg)('jfp-magma-stability-check-jsw-board')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            $fdd97173f5c583f2$var$globalStyleNew = document.createElement('style');
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            globalStyleOld = document.createElement('style');
        }
    } else if ((0, $7jTnu.fg)('jfp-magma-stability-check-jsw-board')) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $fdd97173f5c583f2$var$globalStyleNew = document.createElement('style');
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    globalStyleOld = document.createElement('style');
    const isFullscreen = (0, $6zXPf.getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
    const handleKeysInFullScreen = (0, $eJOHy.useCallback)((e)=>{
        // Ignore if it looks like the user is typing something
        if (e.target instanceof HTMLElement && ([
            'INPUT',
            'TEXTAREA',
            'SELECT'
        ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
        // Prevent shortcuts
        const shortcutKeysToPrevent = [
            '/',
            // search
            'h' // help
        ];
        if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
        const navigationShortcuts = [
            '1',
            '2',
            '3',
            '4' // number keys
        ];
        if (!(0, $6zXPf.getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
            // In Nav4 these keyboard shortcuts are rendered by the tab navigation
            // so they are not available in fullscreen mode
            onToggle(true, ((0, $7jTnu.fg)('jfp-magma-stability-check-jsw-board') ? $fdd97173f5c583f2$var$globalStyleNew : globalStyleOld) ?? undefined);
            const customRefs = customRefElements.current;
            $fdd97173f5c583f2$var$removeFullScreenStyle(customRefs);
        }
    }, // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $7jTnu.fg)('jfp-magma-stability-check-jsw-board') ? [
        onToggle
    ] : [
        globalStyleOld,
        onToggle
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isFullscreen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.addEventListener('keydown', handleKeysInFullScreen, true);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.removeEventListener('keydown', handleKeysInFullScreen, true);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
    }, [
        isFullscreen,
        handleKeysInFullScreen
    ]);
    const createFullScreenStyle = (0, $eJOHy.useCallback)(()=>{
        const customElements = customRefElements.current;
        const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }"; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const hiddenStylesNode = document.createTextNode(hiddenStyles);
        if ((0, $7jTnu.fg)('jfp-magma-stability-check-jsw-board')) {
            if ($fdd97173f5c583f2$var$globalStyleNew) {
                $fdd97173f5c583f2$var$globalStyleNew.id = 'fullscreen-global-style';
                $fdd97173f5c583f2$var$globalStyleNew.appendChild(hiddenStylesNode);
            }
        } else if (globalStyleOld) {
            globalStyleOld.id = 'fullscreen-global-style';
            globalStyleOld.appendChild(hiddenStylesNode);
        }
        if (customElements) customElements.forEach((ref)=>{
            if (ref !== null) ref.classList.add('fullscreen');
        });
        if ((0, $7jTnu.fg)('jfp-magma-stability-check-jsw-board')) {
            if ($fdd97173f5c583f2$var$globalStyleNew) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.head?.appendChild($fdd97173f5c583f2$var$globalStyleNew);
        } else if (globalStyleOld) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head?.appendChild(globalStyleOld);
    }, // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $7jTnu.fg)('jfp-magma-stability-check-jsw-board') ? [] : [
        globalStyleOld
    ]);
    const onClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        if ((0, $6zXPf.getWillShowNav4)()) {
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreenLayout
            };
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            setIsFullScreenLayout(!isFullscreenLayout);
            onToggle(!isFullscreenLayout);
        } else {
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreen
            };
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            onToggle(isFullscreen, ((0, $7jTnu.fg)('jfp-magma-stability-check-jsw-board') ? $fdd97173f5c583f2$var$globalStyleNew : globalStyleOld) ?? undefined);
            if (isFullscreen) $fdd97173f5c583f2$var$removeFullScreenStyle(customElements);
            else createFullScreenStyle();
        }
    }, // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $7jTnu.fg)('jfp-magma-stability-check-jsw-board') ? [
        createFullScreenStyle,
        extraAnalyticsAttributes,
        getCustomRefs,
        isFullscreen,
        isFullscreenLayout,
        onToggle,
        setIsFullScreenLayout
    ] : [
        createFullScreenStyle,
        extraAnalyticsAttributes,
        getCustomRefs,
        globalStyleOld,
        isFullscreen,
        isFullscreenLayout,
        onToggle,
        setIsFullScreenLayout
    ]);
    (0, $eJOHy.useEffect)(()=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        if (isFullscreen) createFullScreenStyle();
        else $fdd97173f5c583f2$var$removeFullScreenStyle(customElements);
        return ()=>$fdd97173f5c583f2$var$removeFullScreenStyle(customElements);
    }, [
        createFullScreenStyle,
        getCustomRefs,
        isFullscreen
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (defaultFullscreen) createFullScreenStyle();
         // Empty dependency array to only apply fullscreen styling once (on mount).
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // remove this useEffect when cleaning up blu-5747-fullscreen-in-nav-header
    (0, $eJOHy.useEffect)(()=>{
        // exit fullscreen mode when moving to a different page
        return ()=>{
            if ((0, $6zXPf.getWillShowNav4)() && !(0, $7jTnu.fg)('blu-5747-fullscreen-in-nav-header')) setIsFullScreenLayout(false);
        }; // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderButtonWithTooltip = (0, $eJOHy.useCallback)(()=>{
        if ((0, $6XJko.isVisualRefreshEnabled)()) {
            if ((0, $7jTnu.fg)('blu-5747-fullscreen-in-nav-header')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                    xcss: $fdd97173f5c583f2$var$KeyboardShortcutContainer
                }, formatMessage(isFullscreen ? (0, $8ze4a.default).exitFullScreen : (0, $8ze4a.default).enterFullScreen), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                    xcss: $fdd97173f5c583f2$var$KeyboardShortcut
                }, formatMessage((0, $8ze4a.default).fullScreenShortcut))),
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                onClick: onClick,
                "aria-keyshortcuts": "Z",
                iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3qmlA))), {
                    label: formatMessage((0, $8ze4a.default).exitFullScreen),
                    spacing: "spacious",
                    color: "var(--ds-icon-subtle, #626F86)"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1hBh4))), {
                    label: formatMessage((0, $8ze4a.default).enterFullScreen),
                    spacing: "spacious",
                    color: "var(--ds-icon-subtle, #626F86)"
                }),
                appearance: isSubtle ? 'subtle' : 'default',
                "aria-hidden": isHidden,
                tabIndex: isHidden ? -1 : 0
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                label: isFullscreen ? formatMessage((0, $8ze4a.default).exitFullScreen) : formatMessage((0, $8ze4a.default).enterFullScreen),
                onClick: onClick,
                icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($3qmlA))) : (0, (/*@__PURE__*/$parcel$interopDefault($1hBh4))),
                appearance: isSubtle ? 'subtle' : 'default',
                isTooltipDisabled: false,
                "aria-hidden": isHidden,
                tabIndex: isHidden ? -1 : 0
            });
        }
        if (renderAsResponsiveButton && !(0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7yc9S.ResponsiveButton), {
            label: isFullscreen ? formatMessage((0, $8ze4a.default).exitFullScreen) : formatMessage((0, $8ze4a.default).enterFullScreen),
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($3qmlA))) : (0, (/*@__PURE__*/$parcel$interopDefault($1hBh4))),
            onClick: onClick,
            testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button',
            "aria-hidden": isHidden,
            tabIndex: isHidden ? -1 : 0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage(isFullscreen ? (0, $8ze4a.default).exitFullScreen : (0, $8ze4a.default).enterFullScreen),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            appearance: "subtle",
            onClick: onClick,
            iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3qmlA))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $8ze4a.default).exitFullScreen),
                spacing: "spacious"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1hBh4))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $8ze4a.default).enterFullScreen),
                spacing: "spacious"
            }),
            "aria-hidden": isHidden,
            tabIndex: isHidden ? -1 : 0
        }));
    }, [
        formatMessage,
        isFullscreen,
        isHidden,
        isSubtle,
        onClick,
        renderAsResponsiveButton,
        testId,
        withContainerStyles
    ]);
    const keyMap = (0, $eJOHy.useMemo)(()=>({
            z: {
                callback: ()=>{
                    setIsFullScreenLayout(!isFullscreenLayout);
                }
            }
        }), [
        isFullscreenLayout,
        setIsFullScreenLayout
    ]);
    if (!shouldRenderContent) return null;
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fdd97173f5c583f2$var$FullscreenButtonContainer, {
        "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
    }, renderButtonWithTooltip(), (0, $6zXPf.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), {
        keyMap: keyMap
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderButtonWithTooltip(), (0, $6zXPf.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), {
        keyMap: keyMap
    }));
};
var $fdd97173f5c583f2$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $fdd97173f5c583f2$var$FullscreenButton;
const $fdd97173f5c583f2$var$FullscreenButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _1e0c116y _bfhk1bhr _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $fdd97173f5c583f2$var$KeyboardShortcutContainer = (0, $1DXK0.xcss)({
    display: 'flex',
    lineHeight: 'space.200',
    alignItems: 'center',
    paddingBottom: 'space.025',
    paddingTop: 'space.025'
});
const $fdd97173f5c583f2$var$KeyboardShortcut = (0, $1DXK0.xcss)({
    border: `1px solid ${"var(--ds-text-inverse, #FFFFFF)"}`,
    borderRadius: '2px',
    marginLeft: 'space.050',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingRight: 'space.100',
    paddingLeft: 'space.100',
    lineHeight: 'space.200'
});

});
parcelRegister("1hBh4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef44ae728b7e983$var$_react = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0ef44ae728b7e983$var$_growDiagonal = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("XhTSt")));

var $0ef44ae728b7e983$var$_actualSize = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("2F5b6")));
function $0ef44ae728b7e983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ef44ae728b7e983$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0ef44ae728b7e983$var$_react.default.createElement($0ef44ae728b7e983$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $0ef44ae728b7e983$var$_actualSize.default
    }, props));
$0ef44ae728b7e983$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $0ef44ae728b7e983$var$_default = module.exports.default = $0ef44ae728b7e983$var$GrowDiagonalIcon;

});
parcelRegister("XhTSt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fa3a459488ae98c9a4dea821f09e885>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b23656b9dea9ae5$var$_react = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0b23656b9dea9ae5$var$_baseNew = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0b23656b9dea9ae5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b23656b9dea9ae5$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0b23656b9dea9ae5$var$_react.default.createElement($0b23656b9dea9ae5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0b23656b9dea9ae5$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $0b23656b9dea9ae5$var$_default = module.exports.default = $0b23656b9dea9ae5$var$GrowDiagonalIcon;

});

parcelRegister("2F5b6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f036d580202d537$var$_react = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1f036d580202d537$var$_growDiagonal = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("XhTSt")));
function $1f036d580202d537$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f036d580202d537$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $1f036d580202d537$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $1f036d580202d537$var$_growDiagonal.default
    }));
$1f036d580202d537$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $1f036d580202d537$var$_default = module.exports.default = $1f036d580202d537$var$MediaServicesActualSizeIcon;

});


parcelRegister("3qmlA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1977529ed36a56b31b9b9f03121ff6d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27e52280fe3bc4ab$var$_react = $27e52280fe3bc4ab$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $27e52280fe3bc4ab$var$_shrinkDiagonal = $27e52280fe3bc4ab$var$_interopRequireDefault((parcelRequire("idu5j")));

var $27e52280fe3bc4ab$var$_fitToPage = $27e52280fe3bc4ab$var$_interopRequireDefault((parcelRequire("8lWE8")));
function $27e52280fe3bc4ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27e52280fe3bc4ab$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $27e52280fe3bc4ab$var$_react.default.createElement($27e52280fe3bc4ab$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $27e52280fe3bc4ab$var$_fitToPage.default
    }, props));
$27e52280fe3bc4ab$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $27e52280fe3bc4ab$var$_default = module.exports.default = $27e52280fe3bc4ab$var$ShrinkDiagonalIcon;

});
parcelRegister("idu5j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5830a86fa64b71ea84cc4eb2a6e1075>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d430c71ad3f6d10b$var$_react = $d430c71ad3f6d10b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d430c71ad3f6d10b$var$_baseNew = $d430c71ad3f6d10b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d430c71ad3f6d10b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d430c71ad3f6d10b$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $d430c71ad3f6d10b$var$_react.default.createElement($d430c71ad3f6d10b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$d430c71ad3f6d10b$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $d430c71ad3f6d10b$var$_default = module.exports.default = $d430c71ad3f6d10b$var$ShrinkDiagonalIcon;

});

parcelRegister("8lWE8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $614dc6da480803f7$var$_react = $614dc6da480803f7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $614dc6da480803f7$var$_shrinkDiagonal = $614dc6da480803f7$var$_interopRequireDefault((parcelRequire("idu5j")));
function $614dc6da480803f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $614dc6da480803f7$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $614dc6da480803f7$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props, {
        newIcon: $614dc6da480803f7$var$_shrinkDiagonal.default
    }));
$614dc6da480803f7$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $614dc6da480803f7$var$_default = module.exports.default = $614dc6da480803f7$var$MediaServicesFitToPageIcon;

});


parcelRegister("3IF6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4ee5f40705d91a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $kvNWh = parcelRequire("kvNWh");

var $676Hn = parcelRequire("676Hn");

var $b2ThO = parcelRequire("b2ThO");

var $dM9A7 = parcelRequire("dM9A7");

var $2ZGUP = parcelRequire("2ZGUP");

var $iUli2 = parcelRequire("iUli2");
let $ac4ee5f40705d91a$var$shortcutsCount = 0;
let $ac4ee5f40705d91a$var$subscription = null;
const $ac4ee5f40705d91a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eJOHy.useContext)((0, $2ZGUP.ShortcutRegistryContext)) || (0, $dM9A7.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const addKeyMap = (0, $eJOHy.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $iUli2.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $ac4ee5f40705d91a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $ac4ee5f40705d91a$var$shortcutsCount -= 1;
            if ($ac4ee5f40705d91a$var$subscription && $ac4ee5f40705d91a$var$shortcutsCount === 0) {
                $ac4ee5f40705d91a$var$subscription.unsubscribe();
                $ac4ee5f40705d91a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $ac4ee5f40705d91a$var$subscription = $ac4ee5f40705d91a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $b2ThO.default)().subscribe((0, $676Hn.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac4ee5f40705d91a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $kvNWh.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac4ee5f40705d91a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("kvNWh", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $28efcafdf90afd66$export$a33a81f1fc5458ad);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $hWeHP = parcelRequire("hWeHP");

var $gCeeo = parcelRequire("gCeeo");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $28efcafdf90afd66$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $28efcafdf90afd66$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$28efcafdf90afd66$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $jGzN3.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $gYnSx.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $28efcafdf90afd66$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $hWeHP.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $28efcafdf90afd66$export$b62f67be35e65859
    }
});
const $28efcafdf90afd66$export$a33a81f1fc5458ad = (0, $iJq0l.createHook)($28efcafdf90afd66$var$Store);

});

parcelRegister("676Hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $29a82f2f140805e4$export$2e2bcd8739ae039);

var $b2ThO = parcelRequire("b2ThO");

var $dM9A7 = parcelRequire("dM9A7");
const $29a82f2f140805e4$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$29a82f2f140805e4$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $dM9A7.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $b2ThO.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($29a82f2f140805e4$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $b2ThO.flush)();
    }
};

});
parcelRegister("b2ThO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb63e776564d4094$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $bb63e776564d4094$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("hnYRz");
parcelRequire("llumX");
parcelRequire("lVRem");
parcelRequire("1o2WJ");
parcelRequire("8rm0O");
parcelRequire("9Zsih");
parcelRequire("lf3vd");

var $aBrUN = parcelRequire("aBrUN");
const $bb63e776564d4094$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $bb63e776564d4094$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb63e776564d4094$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$bb63e776564d4094$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb63e776564d4094$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$bb63e776564d4094$var$isEditable(e.target) && !$bb63e776564d4094$var$ignoredKeys[e.key]);
const $bb63e776564d4094$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $bb63e776564d4094$var$key$;
const $bb63e776564d4094$var$flush$ = new (0, $6WhQS.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bb63e776564d4094$export$2e2bcd8739ae039 = ()=>{
    if (!$bb63e776564d4094$var$key$) {
        $bb63e776564d4094$var$key$ = false ? new (0, $6WhQS.Subject)() : (0, $7kixv.Observable).fromEvent(document, 'keydown').filter($bb63e776564d4094$var$isRelevantKeyEvent).filter($bb63e776564d4094$export$25d1b8252b4c49b7).map((0, $aBrUN.toKeyWithModifiers));
        const sequence$ = $bb63e776564d4094$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $bb63e776564d4094$var$key$ = $bb63e776564d4094$var$key$.debounceTime(1000).startWith(null).merge($bb63e776564d4094$var$flush$).switchMapTo(sequence$);
    }
    return $bb63e776564d4094$var$key$;
};
const $bb63e776564d4094$export$4909b86c8034bf73 = ()=>{
    $bb63e776564d4094$var$flush$.next();
};

});


parcelRegister("iUli2", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $0344ad6591542af9$export$77477772a9b904da);

var $eSnSE = parcelRequire("eSnSE");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");
const $0344ad6591542af9$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $7jTnu.fg)('log-hotkey-analytics')) (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $0344ad6591542af9$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $0344ad6591542af9$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});


parcelRegister("7yc9S", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $a458327b28182879$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $a458327b28182879$export$50fd17babcd996ef);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $5bY40 = parcelRequire("5bY40");
var $6K3F5 = parcelRequire("6K3F5");

var $6djmC = parcelRequire("6djmC");

var $880Uc = parcelRequire("880Uc");
var $3FUYM = parcelRequire("3FUYM");

var $k71qx = parcelRequire("k71qx");

var $aMOdH = parcelRequire("aMOdH");

const $a458327b28182879$export$47e82d861696e68c = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, isThemed: isThemed, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $3FUYM.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $eJOHy.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $880Uc.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $029c63ef7ef2c3b4$export$9c51afe8741be906)}.collapsed`,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $880Uc.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $029c63ef7ef2c3b4$export$9c51afe8741be906)}.expanded`,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $a458327b28182879$export$50fd17babcd996ef = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, isThemed: isThemed, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $3FUYM.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $eJOHy.useState)(mediaQueryBreakpoint?.matches);
    const IconButtonComponent = isThemed ? (0, $aMOdH.ThemedLinkIconButton) : (0, $6K3F5.default);
    const ButtonComponent = isThemed ? (0, $aMOdH.ThemedLinkButton) : (0, $5bY40.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $880Uc.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IconButtonComponent, {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $029c63ef7ef2c3b4$export$9c51afe8741be906)}.collapsed`,
        href: restProps.href,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $880Uc.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ButtonComponent, {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $029c63ef7ef2c3b4$export$9c51afe8741be906)}.expanded`,
        href: restProps.href,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});

});
parcelRegister("880Uc", function(module, exports) {

$parcel$export(module.exports, "Show", () => $f800bab042621a59$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $1DXK0 = parcelRequire("1DXK0");

var $j14qM = parcelRequire("j14qM");
function $f800bab042621a59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f800bab042621a59$var$showAboveQueries = (0, $j14qM.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$showBelowQueries = (0, $j14qM.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $f800bab042621a59$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f800bab042621a59$var$defaultHiddenStyles,
            above && $f800bab042621a59$var$showAboveQueries[above],
            below && $f800bab042621a59$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("j14qM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $58139abb853d4481$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $58139abb853d4481$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $fvncH = parcelRequire("fvncH");

var $6efFi = parcelRequire("6efFi");
const $58139abb853d4481$export$918f8818cfbbeb2c = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $58139abb853d4481$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("fvncH", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $5a3422a08c082ecc$export$2d293d9871c38e91);
const $5a3422a08c082ecc$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $5a3422a08c082ecc$export$2d293d9871c38e91 = Object.keys($5a3422a08c082ecc$export$e5ee4fe8b989fd09);
const $5a3422a08c082ecc$export$b7ed752a57b4177b = $5a3422a08c082ecc$export$2d293d9871c38e91[0];

});



parcelRegister("3FUYM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $8c445bfa813c22a0$export$49e55ae2c03d6045);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $4pr1y = parcelRequire("4pr1y");

var $6efFi = parcelRequire("6efFi");
const $8c445bfa813c22a0$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $6efFi.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $8c445bfa813c22a0$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $eJOHy.useRef)(listener);
    (0, $eJOHy.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $8c445bfa813c22a0$var$queries[queryString];
    (0, $4pr1y.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $4eDgu.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

const $029c63ef7ef2c3b4$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("8ze4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $126561fb03bf1dab$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $126561fb03bf1dab$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    enterFullScreen: {
        "id": "platform.fullscreen-button.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "platform.fullscreen-button.exit-full-screen",
        "defaultMessage": "Exit full screen"
    },
    fullScreenShortcut: {
        "id": "platform.fullscreen-button.full-screen-shortcut",
        "defaultMessage": "Z"
    }
});

});




parcelRegister("4Ig6r", function(module, exports) {

$parcel$export(module.exports, "AutomationButton", () => $e78b7bca2210fadb$export$bf7bacbbcbf7d755);

var $eJOHy = parcelRequire("eJOHy");

var $dtpha = parcelRequire("dtpha");

var $k71qx = parcelRequire("k71qx");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $lRq8t = parcelRequire("lRq8t");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cJEMq = parcelRequire("cJEMq");

var $ciFJV = parcelRequire("ciFJV");

var $6XJko = parcelRequire("6XJko");

var $2VUCc = parcelRequire("2VUCc");

var $gbkk9 = parcelRequire("gbkk9");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $lqoXH = parcelRequire("lqoXH");
const $e78b7bca2210fadb$export$bf7bacbbcbf7d755 = ()=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const projectIdOrKey = (0, $2VUCc.useProjectIdOrKey)() ?? '';
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $gbkk9.automationMenuContentEntrypoint), (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey
        }), [
        cloudId,
        projectIdOrKey
    ]));
    const buttonTrigger = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const handleClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), []);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            onClose: handleClose
        }), [
        handleClose
    ]);
    const content = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "horizontal-nav-header-automation",
            packageName: "@atlassian/jira-horizontal-nav-header",
            runtimeProps: runtimeProps
        }), [
        entryPointReferenceSubject,
        runtimeProps
    ]);
    // move back inline when cleaning up jira-project-theming-m2-bug-fixes
    const iconColor = (0, $eJOHy.useMemo)(()=>{
        if ((0, $7jTnu.fg)('jira-project-theming-m2-bug-fixes')) return isOpen ? 'currentColor' : "var(--ds-icon-subtle, #626F86)";
        return (0, $6XJko.isVisualRefreshEnabled)() ? "var(--ds-icon-subtle, #626F86)" : 'currentColor';
    }, [
        isOpen
    ]);
    const trigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $lqoXH.default).automationButton),
            position: "top"
        }, (0, $7jTnu.fg)('jfp-magma-stability-horizontal-nav') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e78b7bca2210fadb$var$ThemedButtonStable, {
            triggerProps: triggerProps,
            buttonTrigger: buttonTrigger,
            setIsOpen: setIsOpen,
            isOpen: isOpen,
            iconColor: iconColor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
            ...triggerProps,
            ref: (element)=>{
                buttonTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            onClick: ()=>{
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'automationBolt',
                    action: 'opened'
                });
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
                setIsOpen(!isOpen);
            },
            appearance: (0, $6XJko.isVisualRefreshEnabled)() ? 'default' : 'subtle',
            isSelected: isOpen,
            "data-vc": "automation-menu-button",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
                label: formatMessage((0, $lqoXH.default).automationButton),
                color: iconColor,
                spacing: "spacious"
            })
        })), [
        buttonTrigger,
        createAnalyticsEvent,
        formatMessage,
        iconColor,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-end",
        messageId: "horizontal-nav.ui.content.header.extra-components-far.automation-button.popup",
        messageType: "transactional",
        content: content,
        trigger: trigger,
        shouldRenderToParent: true
    });
};
const $e78b7bca2210fadb$var$ThemedButtonStable = ({ triggerProps: triggerProps, buttonTrigger: buttonTrigger, setIsOpen: setIsOpen, isOpen: isOpen, iconColor: iconColor })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'automationBolt',
            action: 'opened'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent);
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen,
        setIsOpen
    ]);
    const ref = (0, $eJOHy.useCallback)((element)=>{
        buttonTrigger(element);
        if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
    }, [
        buttonTrigger,
        triggerProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        ...triggerProps,
        ref: ref,
        onClick: onClick,
        appearance: (0, $6XJko.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        isSelected: isOpen,
        "data-vc": "automation-menu-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
            label: formatMessage((0, $lqoXH.default).automationButton),
            color: iconColor,
            spacing: "spacious"
        })
    });
};

});
parcelRegister("dtpha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf1970ee03bcd13$var$_react = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cf1970ee03bcd13$var$_baseNew = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9cf1970ee03bcd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf1970ee03bcd13$var$AutomationIcon = (props)=>/*#__PURE__*/ $9cf1970ee03bcd13$var$_react.default.createElement($9cf1970ee03bcd13$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$9cf1970ee03bcd13$var$AutomationIcon.displayName = 'AutomationIcon';
var $9cf1970ee03bcd13$var$_default = module.exports.default = $9cf1970ee03bcd13$var$AutomationIcon;

});

parcelRegister("2VUCc", function(module, exports) {

$parcel$export(module.exports, "useProjectIdOrKey", () => $631bdd4fa2ceeea2$export$12b007aa97244648);
$parcel$export(module.exports, "getConnection", () => $631bdd4fa2ceeea2$export$26b2f38d0fc342a3);
$parcel$export(module.exports, "getStoreEdges", () => $631bdd4fa2ceeea2$export$137f3eb02a91737e);
$parcel$export(module.exports, "getAnalyticsTabOrder", () => $631bdd4fa2ceeea2$export$58da6593ae071994);

var $kqd31 = parcelRequire("kqd31");

var $kfvK2 = parcelRequire("kfvK2");

var $bBtQo = parcelRequire("bBtQo");

const $631bdd4fa2ceeea2$export$12b007aa97244648 = (0, $kfvK2.createRouterSelector)((state)=>(0, $bBtQo.getProjectIdOrKey)(state.match, state.query));
const $631bdd4fa2ceeea2$export$26b2f38d0fc342a3 = (store, containerNavigationId)=>{
    const dataId = (0, $kqd31.default)({
        id: containerNavigationId
    }, 'JiraContainerNavigation');
    return dataId && store.get(dataId)?.getLinkedRecord('navigationItems', {
        first: (0, $928056a84d2eedae$export$4653cda61a4943d6)
    });
};
const $631bdd4fa2ceeea2$export$137f3eb02a91737e = (store, containerNavigationId)=>{
    const connection = $631bdd4fa2ceeea2$export$26b2f38d0fc342a3(store, containerNavigationId);
    if (!connection) return undefined;
    return connection.getLinkedRecords('edges');
};
const $631bdd4fa2ceeea2$export$58da6593ae071994 = (store, containerNavigationId)=>{
    const edges = $631bdd4fa2ceeea2$export$137f3eb02a91737e(store, containerNavigationId);
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.getLinkedRecord('node');
        const tabId = node?.getValue('appId');
        return {
            itemType: String(node?.getValue('typeKey')).toLowerCase(),
            itemId: tabId ? String(tabId) : undefined,
            // relay will have already updated the changed item, exclude the new default to restore the original values
            defaultTab: Boolean(node?.getValue('isDefault'))
        };
    });
};

});
const $928056a84d2eedae$export$4653cda61a4943d6 = 75;


parcelRegister("gbkk9", function(module, exports) {

$parcel$export(module.exports, "automationMenuContentEntrypoint", () => $52c783c01210f76e$export$4606319c52466ef3);

var $6nWaA = parcelRequire("6nWaA");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $52c783c01210f76e$export$4606319c52466ef3 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1Cu52")).then((module)=>module.AutomationPopupMenuContent), {
        moduleId: "21f1ab04",
        moduleName: "AutomationPopupMenuContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectIdOrKey: projectIdOrKey })=>{
        return {
            queries: {
                mainQuery: {
                    parameters: $6nWaA.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("6nWaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8cf87c263f98293$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3db9d4bc8d19d19d9cfe37c02c44f0d6>>
 * @relayHash f760e3b2d740a1f6e9c4d2cb3cc89946
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26cbceefe67b9367507439f022ac920e1087387c6a303ca20df7285fc00ce6fc
const $a8cf87c263f98293$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "26cbceefe67b9367507439f022ac920e1087387c6a303ca20df7285fc00ce6fc",
        "metadata": {},
        "name": "AutomationPopupMenuContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a8cf87c263f98293$export$2e2bcd8739ae039 = $a8cf87c263f98293$var$node;

});

parcelRegister("1Cu52", function(module, exports) {

let $12e0ac60b0185d8f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $12e0ac60b0185d8f$var$load("kNFvF"),
    $12e0ac60b0185d8f$var$load("ffQaD"),
    $12e0ac60b0185d8f$var$load("kvRbA"),
    $12e0ac60b0185d8f$var$load("3WwWG")
]).then(()=>parcelRequire('8NGrc'));

});


parcelRegister("lqoXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b207b28fd24ed4a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9b207b28fd24ed4a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    automationButton: {
        "id": "horizontal-nav-header.extra-components-far.automation-button.automation-button",
        "defaultMessage": "Automation"
    }
});

});



parcelRegister("ljjv4", function(module, exports) {

$parcel$export(module.exports, "HorizontalNavProjectBreadcrumbs", () => $5bf09c98646dee67$export$da30c3ec9be0517b);

var $5HGlV = parcelRequire("5HGlV");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $fE5VD = parcelRequire("fE5VD");
var $16YBi = parcelRequire("16YBi");

var $lRq8t = parcelRequire("lRq8t");

var $ghL3O = parcelRequire("ghL3O");
const $5bf09c98646dee67$var$createProjectUrl = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
const $5bf09c98646dee67$export$da30c3ec9be0517b = ({ projectFragment: projectFragment, shouldShowProjectName: shouldShowProjectName = false })=>{
    const project = (0, $j4oe4.useFragment)((0, $5HGlV.default), projectFragment);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1tke1tcg _nwukvy9e _1o8h13fh"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16YBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE5VD.default), {
        href: "/jira/projects",
        text: formatMessage((0, $ghL3O.default).projectsTitle)
    }), shouldShowProjectName && project && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE5VD.default), {
        href: $5bf09c98646dee67$var$createProjectUrl(project?.key),
        text: project?.name
    })));
};
const $5bf09c98646dee67$var$breadcrumbStyles = null;

});
parcelRegister("5HGlV", function(module, exports) {

$parcel$export(module.exports, "default", () => $def84af6a7767863$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d8c448f51169523f40ef830f3470245>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $def84af6a7767863$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraProject"
};
$def84af6a7767863$var$node.hash = "ed2f4bc001a364f753ffebfa5a1fa48e";
var $def84af6a7767863$export$2e2bcd8739ae039 = $def84af6a7767863$var$node;

});

parcelRegister("fE5VD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b72a7004145e65$export$2e2bcd8739ae039);
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k71qx = parcelRequire("k71qx");

var $gGiEK = parcelRequire("gGiEK");

var $3hIIz = parcelRequire("3hIIz");
const $e7b72a7004145e65$var$itemWrapperStyles = null;
const $e7b72a7004145e65$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $e7b72a7004145e65$var$ICON_WIDTH_ESTIMATE = 24;
const $e7b72a7004145e65$var$staticItemStyles = null;
const $e7b72a7004145e65$var$staticItemWithTruncationStyles = null;
const $e7b72a7004145e65$var$staticItemWithoutTruncationStyles = null;
const $e7b72a7004145e65$var$BreadcrumbsItem = /*#__PURE__*/ (0, $eJOHy.memo)(({ analyticsContext: analyticsContext, component: component, href: // `createAnalyticsEvent` should be here, but throws errors on render since
// it ends up being spread on a DOM element at the very end
href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: // This is overridden by the `buttonRef` below
ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, // I believe there is only `createAnalyticsEvent` left on here, but leaving
// it here to allow this to be a patch and not a major
...rest })=>{
    const buttonRef = (0, $eJOHy.useRef)(null);
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $e7b72a7004145e65$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $e7b72a7004145e65$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $3hIIz.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
    // This should be a part of staticItemStyles but it requires the !important flag to prevent the padding from being overridden by the button styles
    // compiled treats `${token(xxx)} !important` differently when concat !important in es2019 and esm built files
    // the padding and font weight were not sourced correctly in the esm build
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$e7b72a7004145e65$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gGiEK.default), {
        ...rest,
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: buttonRef,
        target: target,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        className: (0, $hcewu.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _ect41gqc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        children: showTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e7b72a7004145e65$export$2e2bcd8739ae039 = $e7b72a7004145e65$var$BreadcrumbsItem;

});
parcelRegister("gGiEK", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c2c146912d95f1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $goZPP = parcelRequire("goZPP");

var $3Vuhz = parcelRequire("3Vuhz");
const $59c2c146912d95f1$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $59c2c146912d95f1$var$noop = (0, $3Vuhz.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $59c2c146912d95f1$var$Step = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $59c2c146912d95f1$var$noop, target: target, testId: testId, // Button does not take `createAnalyticsEvent`, but it is spread on anyway
...props }, ref)=>{
    const handleClicked = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$59c2c146912d95f1$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $59c2c146912d95f1$export$2e2bcd8739ae039 = $59c2c146912d95f1$var$Step;

});

parcelRegister("3hIIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $12abc2621123c61b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
function $12abc2621123c61b$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $eJOHy.useState)((0, $eGOwo.fg)('platform_fix_unnessesary_re-renders_in_breadcrumbs') ? Boolean(shouldCheckWidth) : true);
    const [showTooltip, setShowTooltip] = (0, $eJOHy.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $eJOHy.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("16YBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a75e9d112109680f$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $3Vuhz = parcelRequire("3Vuhz");

var $eGOwo = parcelRequire("eGOwo");

var $5zaE1 = parcelRequire("5zaE1");

var $lK2OT = parcelRequire("lK2OT");
const $a75e9d112109680f$var$defaultMaxItems = 8;
const $a75e9d112109680f$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $a75e9d112109680f$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $a75e9d112109680f$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children;
const $a75e9d112109680f$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $a75e9d112109680f$var$noop = (0, $3Vuhz.default);
const $a75e9d112109680f$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $a75e9d112109680f$var$breadcrumbStyles = null;
const $a75e9d112109680f$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $a75e9d112109680f$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $a75e9d112109680f$var$noop, analyticsContext: analyticsContext, label: label = $a75e9d112109680f$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $a75e9d112109680f$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $eJOHy.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $eJOHy.useState)(false);
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $a75e9d112109680f$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($a75e9d112109680f$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    const focusFirstRevealedMemoized = (0, $eJOHy.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($a75e9d112109680f$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $lK2OT.useOnRevealed)((0, $eGOwo.fg)('jfp-magma-stability-platform-3') ? focusFirstRevealedMemoized : focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$a75e9d112109680f$var$analyticsAttributes
    });
    const childrenArray = $a75e9d112109680f$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray; // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5zaE1.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("nav", {
        "aria-label": label,
        ref: (0, $gyJTO.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
            "data-testid": testId,
            className: (0, $hcewu.default)([
                "_1e0c1txw _1n261g80 _syaz1wmz _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $a75e9d112109680f$var$Breadcrumbs = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)($a75e9d112109680f$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $a75e9d112109680f$export$2e2bcd8739ae039 = $a75e9d112109680f$var$Breadcrumbs;

});
parcelRegister("5zaE1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6688da12dd77b66c$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $3Vuhz = parcelRequire("3Vuhz");
const $6688da12dd77b66c$var$noop = (0, $3Vuhz.default);
const $6688da12dd77b66c$var$itemWrapperStyles = null;
const $6688da12dd77b66c$var$staticItemStyles = null;
const $6688da12dd77b66c$var$EllipsisItem = /*#__PURE__*/ (0, $eJOHy.memo)(({ label: label, onClick: onClick = $6688da12dd77b66c$var$noop, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
            appearance: "subtle-link",
            "aria-label": label,
            onClick: onClick,
            spacing: "none",
            testId: testId,
            className: (0, $hcewu.default)([
                "_1rjc1tvq _k48p1hhk _vwz41txs"
            ]),
            children: "\u2026"
        })
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6688da12dd77b66c$export$2e2bcd8739ae039 = $6688da12dd77b66c$var$EllipsisItem;

});

parcelRegister("lK2OT", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $25cf5f56d1847350$export$e9c4922b2ecf808a);

var $eJOHy = parcelRequire("eJOHy");

var $aNllK = parcelRequire("aNllK");
function $25cf5f56d1847350$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $aNllK.default)(isExpanded);
    (0, $eJOHy.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("ghL3O", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac0603447586b4bd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ac0603447586b4bd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectsTitle: {
        "id": "horizontal-nav-header.breadcrumbs.project",
        "defaultMessage": "Projects"
    }
});

});


parcelRegister("g7LSl", function(module, exports) {

$parcel$export(module.exports, "NavigationTeamButton", () => $d9d5cee4ae7a1694$export$df0da44d232d7c73);

var $lJH71 = parcelRequire("lJH71");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $f5xSu = parcelRequire("f5xSu");

var $1KdDN = parcelRequire("1KdDN");

var $4xbv3 = parcelRequire("4xbv3");

var $g9Vr6 = parcelRequire("g9Vr6");

var $epTsa = parcelRequire("epTsa");

var $cECwI = parcelRequire("cECwI");

var $286cZ = parcelRequire("286cZ");

var $7jTnu = parcelRequire("7jTnu");
const $d9d5cee4ae7a1694$export$df0da44d232d7c73 = (0, $286cZ.memoWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-horizontal-nav'), ({ scope: scope, projectFragment: projectFragment })=>{
    const project = (0, $j4oe4.useFragment)((0, $lJH71.default), projectFragment);
    const attributes = (0, $eJOHy.useMemo)(()=>({
            scope: scope
        }), [
        scope
    ]);
    if (project?.id && project?.teamsConnected === undefined && (0, $epTsa.expVal)('team-bi-directional-container-connection', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d9d5cee4ae7a1694$var$M2TeamButtonComponent, {
        projectId: project.id,
        attributes: attributes
    });
    if (project?.teamsConnected?.totalCount == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jira-horizontal-nav-header-team-button",
        packageName: "jira-horizontal-nav",
        fallback: "unmount",
        teamName: "Jira Cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "horizontal-nav-header",
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5xSu.TeamButtonComponent), {
        numberOfTeams: project.teamsConnected.totalCount,
        containerId: project.id,
        Wrapper: $d9d5cee4ae7a1694$var$CustomWrapper
    })));
});
const $d9d5cee4ae7a1694$var$M2TeamButtonComponent = ({ projectId: projectId, attributes: attributes })=>{
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    if (isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jira-horizontal-nav-header-team-button",
        packageName: "jira-horizontal-nav",
        fallback: "unmount",
        teamName: "Jira Cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "horizontal-nav-header",
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5xSu.TeamButtonComponent), {
        numberOfTeams: 1,
        containerId: projectId,
        orgId: orgId,
        Wrapper: $d9d5cee4ae7a1694$var$CustomWrapper
    })));
};
const $d9d5cee4ae7a1694$var$CustomWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_fsjd4zrn _nwukvy9e _2hwx12x7"
        ])
    }, children);
const $d9d5cee4ae7a1694$var$wrapperStyle = null;

});
parcelRegister("lJH71", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd9a8de4b907f7e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b817b117a8785cafd7776154f5047087>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dd9a8de4b907f7e8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "NavigationTeamButton_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                    "kind": "LinkedField",
                    "name": "teamsConnected",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$dd9a8de4b907f7e8$var$node.hash = "3b9f9c19a3b51f50bca5f46f2c43543d";
var $dd9a8de4b907f7e8$export$2e2bcd8739ae039 = $dd9a8de4b907f7e8$var$node;

});

parcelRegister("f5xSu", function(module, exports) {

$parcel$export(module.exports, "TeamButtonComponent", () => $7d2dd878b64541c5$export$e396067aa8e1cdf9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $101p7 = parcelRequire("101p7");

var $eGOwo = parcelRequire("eGOwo");

var $bskNA = parcelRequire("bskNA");

var $b8OI0 = parcelRequire("b8OI0");

var $b275c = parcelRequire("b275c");

var $3Ekb4 = parcelRequire("3Ekb4");

var $3kdRB = parcelRequire("3kdRB");

var $6KBVc = parcelRequire("6KBVc");

var $bXZkV = parcelRequire("bXZkV");

var $knY1C = parcelRequire("knY1C");

var $a8Dqb = parcelRequire("a8Dqb");

var $konD1 = parcelRequire("konD1");

var $5lxWX = parcelRequire("5lxWX");

var $hzPqr = parcelRequire("hzPqr");
const $7d2dd878b64541c5$export$1ec70ef85047a4d5 = ({ numberOfTeams: numberOfTeams, containerId: containerId, Wrapper: Wrapper = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment })=>{
    const { fireEvent: fireEvent } = (0, $b275c.usePeopleTeamAnalyticsEvents)();
    const triggerRef = (0, $eJOHy.useRef)(null);
    const { isTeamBiDirectionalEnabled: isExperimentEnabled } = (0, $a8Dqb.useTeamBiDirectionalExp)();
    const handleButtonClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        const element = event.currentTarget;
        const isExpanded = isExperimentEnabled ? element.getAttribute('aria-expanded') === 'true' : true;
        if (isExpanded) {
            const result = analyticsEvent?.context.find((item)=>item.attributes && item.attributes.scope !== undefined);
            fireEvent('ui.teamButton.clicked', {
                teamsCount: numberOfTeams ?? 0,
                scope: result?.attributes?.scope ?? '',
                version: isExperimentEnabled ? 'm2' : 'm1'
            });
        }
    }, [
        fireEvent,
        numberOfTeams,
        isExperimentEnabled
    ]);
    const getTriggerProps = (0, $eJOHy.useCallback)((triggerProps)=>{
        if (!isExperimentEnabled) return triggerProps;
        const setRef = (node)=>{
            triggerRef.current = node;
            if (typeof triggerProps.ref === 'function') triggerProps.ref(node);
            else if (triggerProps.ref) triggerProps.ref.current = node;
        };
        return {
            ...triggerProps,
            ref: setRef
        };
    }, [
        isExperimentEnabled
    ]);
    const onFocusTrigger = (0, $eJOHy.useCallback)(()=>{
        setTimeout(()=>{
            if (triggerRef.current) triggerRef.current.focus();
        }, 0);
    }, [
        triggerRef
    ]);
    const entryPointProps = {
        // Remove as part of M1 FG cleanup
        ...isExperimentEnabled ? {} : {
            containerId: containerId
        },
        onModalCloseComplete: onFocusTrigger
    };
    const entryPointPropsMemoized = (0, $eJOHy.useMemo)(()=>({
            // Remove as part of M1 FG cleanup
            ...isExperimentEnabled ? {} : {
                containerId: containerId
            },
            onModalCloseComplete: onFocusTrigger
        }), [
        isExperimentEnabled,
        containerId,
        onFocusTrigger
    ]);
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hzPqr.TeamButtonTrigger), {
                triggerProps: getTriggerProps(triggerProps),
                // numberOfTeams will never be undefined/0 as we check for the below.
                numberOfTeams: numberOfTeams ?? 0,
                onClick: handleButtonClick
            })
        });
    const triggerMemoized = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hzPqr.TeamButtonTrigger), {
                triggerProps: getTriggerProps(triggerProps),
                // numberOfTeams will never be undefined/0 as we check for the below.
                numberOfTeams: numberOfTeams ?? 0,
                onClick: handleButtonClick
            })
        }), [
        Wrapper,
        getTriggerProps,
        numberOfTeams,
        handleButtonClick
    ]);
    if (numberOfTeams === undefined) return null;
    if (numberOfTeams === 0 && !isExperimentEnabled) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $101p7.FlagsProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bskNA.ModalContextProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b8OI0.PopupTrigger), {
                entryPoint: (0, $knY1C.asyncTeamSelectorEntryPoint),
                entryPointProps: (0, $eGOwo.fg)('jfp-magma-stability-platform-3') ? entryPointPropsMemoized : entryPointProps,
                entryPointParams: {
                    containerId: containerId
                },
                trigger: (0, $eGOwo.fg)('jfp-magma-stability-platform-3') ? triggerMemoized : trigger,
                fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $konD1.default), {}),
                placement: "bottom-start",
                strategy: "absolute",
                popupComponent: (0, $3Ekb4.default)
            })
        })
    });
};
const $7d2dd878b64541c5$export$e396067aa8e1cdf9 = (props)=>{
    const { containerId: containerId, orgId: orgId } = props;
    const containerType = (0, $5lxWX.getContainerType)(containerId);
    const isExperimentEnabled = (0, $6KBVc.isTeamBiDirectionalEnabled)(containerType);
    if (isExperimentEnabled) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bXZkV.TeamSelectorProvider), {
        containerId: containerId,
        containerType: containerType,
        // cloudId is guaranteed to be a string as we will always receive a valid containerId
        cloudId: (0, $3kdRB.getSiteId)(containerId) || '',
        // orgId will always be available if isTeamBiDirectionalEnabled is true
        orgId: orgId || '',
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($7d2dd878b64541c5$export$1ec70ef85047a4d5, {
            ...props
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($7d2dd878b64541c5$export$1ec70ef85047a4d5, {
        ...props
    });
};

});
parcelRegister("b275c", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamAnalyticsEvents", () => $c2edc7c4fcef70ce$export$48acf7e27d4331f);
$parcel$export(module.exports, "useTeamsExperienceTracker", () => $c2edc7c4fcef70ce$export$5792e6ebc464482e);

var $eJOHy = parcelRequire("eJOHy");

var $izv17 = parcelRequire("izv17");

var $hTguo = parcelRequire("hTguo");

var $hwXck = parcelRequire("hwXck");

var $2HWoD = parcelRequire("2HWoD");
const $c2edc7c4fcef70ce$export$48acf7e27d4331f = ()=>{
    const [{ eventAttributes: injectedEventAttributes }, { setEventAttributes: setEventAttributes }] = (0, $izv17.usePeopleTeamsAnalyticsSubcontext)();
    const { fireEvent: fireEvent } = (0, $hwXck.useAnalyticsEvents)();
    const fireEventWithSubcontextAttributesInjected = (0, $eJOHy.useCallback)((...params)=>{
        const [event, attributes] = params;
        const eventWithSubcontextAttributes = {
            ...attributes,
            ...injectedEventAttributes
        };
        // @ts-ignore allow injecting subcontext attributes
        fireEvent(event, eventWithSubcontextAttributes);
    }, [
        fireEvent,
        injectedEventAttributes
    ]);
    return {
        fireEvent: fireEventWithSubcontextAttributesInjected,
        setInjectedEventAttributes: setEventAttributes
    };
};
const $c2edc7c4fcef70ce$export$b72f2eb2a11f7b8 = ()=>(0, $2HWoD.useAnalyticsEventsWithTags)();
const $c2edc7c4fcef70ce$export$5792e6ebc464482e = ()=>{
    const { fireEvent: fireEvent } = $c2edc7c4fcef70ce$export$48acf7e27d4331f();
    const fireExperienceEvent = (0, $eJOHy.useCallback)((action, subject, attributes)=>{
        // @ts-ignore TODO: we may need to declare the keys to a const in the types file so we can do a check here
        fireEvent(`operational.${subject.replace(/[\/-]/g, '_')}.${action}`, {
            ...attributes,
            source: 'clientMetrics'
        });
    }, [
        fireEvent
    ]);
    const experienceTracker = (0, $eJOHy.useMemo)(()=>(0, $hTguo.createTeamsExperienceTracker)(fireExperienceEvent), [
        fireExperienceEvent
    ]);
    return experienceTracker;
};

});
parcelRegister("izv17", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamsAnalyticsSubcontext", () => $15871a71fb0d22af$export$86448e866930ba8d);
$parcel$export(module.exports, "useInjectedEventAttribute", () => $15871a71fb0d22af$export$831917a198e22e70);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $15871a71fb0d22af$var$initialState = {
    eventAttributes: {}
};
const $15871a71fb0d22af$var$actions = {
    setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
            const existingEventAttributes = getState().eventAttributes;
            const newEventAttributes = {
                ...existingEventAttributes,
                ...eventAttributes
            };
            Object.keys(newEventAttributes).forEach((keyString)=>{
                const key = keyString;
                if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
            });
            setState({
                eventAttributes: newEventAttributes
            });
        }
};
const $15871a71fb0d22af$var$AnalyticsSubcontextStore = (0, $GtRbT.createStore)({
    initialState: $15871a71fb0d22af$var$initialState,
    actions: $15871a71fb0d22af$var$actions
});
const $15871a71fb0d22af$export$86448e866930ba8d = (0, $iJq0l.createHook)($15871a71fb0d22af$var$AnalyticsSubcontextStore);
const $15871a71fb0d22af$export$831917a198e22e70 = (key, value)=>{
    const { setEventAttributes: setEventAttributes } = $15871a71fb0d22af$export$86448e866930ba8d()[1];
    (0, $eJOHy.useEffect)(()=>{
        setEventAttributes({
            [key]: value
        });
        return ()=>setEventAttributes({
                [key]: undefined
            });
    }, [
        key,
        value,
        setEventAttributes
    ]);
};

});

parcelRegister("hTguo", function(module, exports) {

$parcel$export(module.exports, "createTeamsExperienceTracker", () => $5a2d7002120bf9e6$export$c0c885a04612b38d);

var $4eDgu = parcelRequire("4eDgu");

var $kFT2B = parcelRequire("kFT2B");

var $df3q3 = parcelRequire("df3q3");
function $5a2d7002120bf9e6$export$c0c885a04612b38d(fireExperienceEvent, options) {
    const tracker = new (0, $kFT2B.TeamsExperienceTracker)({
        isNetworkOfflineError: (0, $df3q3.isNetworkError)
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = (0, $df3q3.computePerformanceAttributes)(event);
            const errorAttributes = (0, $df3q3.computeErrorAttributes)(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: !!options?.isStandalone,
                hasBrowseUsersPermission: !!options?.hasBrowseUsersPermission
            });
            fireExperienceEvent(event.action, event.name, finalErrorDetails);
            if (event.action === 'taskFail' && options?.logErrorMessage) options.logErrorMessage(`taskFail:${event.name}`, finalErrorDetails);
        }
    });
    (0, $4eDgu.bindAll)(window, [
        {
            type: 'unload',
            listener: ()=>tracker.abort({
                    reason: 'Abort due to Window unloading',
                    attributes: {
                        cause: 'WINDOW_UNLOAD'
                    }
                })
        },
        {
            type: 'pagehide',
            listener: ()=>{
                tracker.abort({
                    reason: 'Window unloading',
                    attributes: {
                        cause: 'PAGE_HIDE'
                    }
                });
            }
        }
    ]);
    return tracker;
}

});
parcelRegister("kFT2B", function(module, exports) {

$parcel$export(module.exports, "TeamsExperienceTracker", () => $245d0a1d53a85be3$export$9e9a48cf2c297bd1);

var $87Obl = parcelRequire("87Obl");

var $9yf1e = parcelRequire("9yf1e");
class $245d0a1d53a85be3$export$9e9a48cf2c297bd1 extends (0, $87Obl.ExperienceTracker) {
    _errorNameInIgnoredList(error) {
        const name = error && error.constructor.name;
        return this._ignoredErrors.includes(name) ? name : undefined;
    }
    constructor(options){
        super(options), // error names here will also be sent in the attribute `cause`
        this._ignoredErrors = [
            'SentryIgnoreError'
        ];
    }
    stopOnError({ name: name, error: error }) {
        if ((0, $9yf1e.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $9yf1e.isErrorStatusCode)((0, $9yf1e.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        const ignoredErrorName = this._errorNameInIgnoredList(error);
        if (ignoredErrorName) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: ignoredErrorName
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error
        });
    }
}

});
parcelRegister("9yf1e", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $f17e707a8724afa5$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $f17e707a8724afa5$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $f17e707a8724afa5$export$9677d7c364ada66c);
var $f17e707a8724afa5$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $f17e707a8724afa5$export$cde1786a482f9a1c(error) {
    return $f17e707a8724afa5$export$9677d7c364ada66c(401, error) || $f17e707a8724afa5$export$9677d7c364ada66c(403, error);
}
function $f17e707a8724afa5$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}

});


parcelRegister("df3q3", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $4e39c67d84eaac8b$export$476aa014e2fd89d5);
$parcel$export(module.exports, "computeErrorAttributes", () => $4e39c67d84eaac8b$export$5e7501d1cb9a5aa0);
$parcel$export(module.exports, "computePerformanceAttributes", () => $4e39c67d84eaac8b$export$b978343735080139);

var $bq2fr = parcelRequire("bq2fr");
function $4e39c67d84eaac8b$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}
function $4e39c67d84eaac8b$export$5e7501d1cb9a5aa0(event) {
    const attributes = {};
    if ($4e39c67d84eaac8b$var$isFailEvent(event)) attributes.failError = event.error;
    if ($4e39c67d84eaac8b$var$isAbortEvent(event)) attributes.abortReason = event.reason;
    return attributes;
}
function $4e39c67d84eaac8b$export$b978343735080139(event) {
    if ($4e39c67d84eaac8b$var$isStopEvent(event)) {
        const duration = event.duration;
        const latencySlo = event.attributes && $4e39c67d84eaac8b$var$hasLatencySLO(event.attributes) && event.attributes['latencySlo'];
        if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
        return {
            sloSatisfied: duration <= latencySlo,
            taskDuration: duration,
            latencySlo: latencySlo
        };
    }
    return {};
}
function $4e39c67d84eaac8b$var$isStopEvent(e) {
    return (0, $bq2fr.isStop)(e);
}
function $4e39c67d84eaac8b$var$isFailEvent(e) {
    return e.action === 'taskFail';
}
function $4e39c67d84eaac8b$var$isAbortEvent(e) {
    return e.action === 'taskAbort';
}
function $4e39c67d84eaac8b$var$hasLatencySLO(attributes) {
    return Object(attributes).hasOwnProperty('latencySlo');
}

});
parcelRegister("bq2fr", function(module, exports) {

$parcel$export(module.exports, "isStop", () => $9cb259e8198ec504$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $9cb259e8198ec504$export$57069f5b2ecc9128);
const $9cb259e8198ec504$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $9cb259e8198ec504$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});



parcelRegister("hwXck", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $54ae0d1177a6c2f7$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c3d283871d950ad96ce62ded8c21524b>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $7Scov = parcelRequire("7Scov");

var $vMA5y = parcelRequire("vMA5y");
const $54ae0d1177a6c2f7$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEvent = (0, $eJOHy.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $vMA5y.default)(...params));
        event.fire((0, $7Scov.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("7Scov", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $07fb16ac90cdab0d$export$3f072f06b90c3985);

var $bgewf = parcelRequire("bgewf");
const $07fb16ac90cdab0d$export$3f072f06b90c3985 = (0, $bgewf.FabricChannel).peopleTeams;

});

parcelRegister("vMA5y", function(module, exports) {

$parcel$export(module.exports, "default", () => $bec38e9a27c6954a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f6bdf2649443a00944d1014ec7e17d50>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ const $bec38e9a27c6954a$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $bec38e9a27c6954a$export$2e2bcd8739ae039 = $bec38e9a27c6954a$var$createEventPayload;

});


parcelRegister("2HWoD", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEventsWithTags", () => $58c2b65235845463$export$e8e0cef07f76dd91);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $7Scov = parcelRequire("7Scov");

var $vMA5y = parcelRequire("vMA5y");
const $58c2b65235845463$export$e8e0cef07f76dd91 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEventWithTags = (0, $eJOHy.useCallback)((tags, ...params)=>{
        const event = createAnalyticsEvent((0, $vMA5y.default)(...params));
        if (event.payload) event.payload.tags = tags;
        event.fire((0, $7Scov.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEventWithTags: fireEventWithTags
    };
};

});


parcelRegister("3Ekb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e605d98421cfb1f0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $e605d98421cfb1f0$var$popupStyles = (0, $1DXK0.xcss)({
    zIndex: '1',
    backgroundColor: 'color.background.neutral.subtle'
});
const $e605d98421cfb1f0$var$PopupComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'data-testid': testId, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        ...props,
        ref: ref,
        xcss: $e605d98421cfb1f0$var$popupStyles,
        testId: testId
    }));
var $e605d98421cfb1f0$export$2e2bcd8739ae039 = $e605d98421cfb1f0$var$PopupComponent;

});

parcelRegister("3kdRB", function(module, exports) {

$parcel$export(module.exports, "getTeamId", () => $c4b985a9d3f53b76$export$e8eac31981efe1fb);
$parcel$export(module.exports, "getTeamProfileUrl", () => $c4b985a9d3f53b76$export$782629dc0d11ee5c);
$parcel$export(module.exports, "getSiteId", () => $c4b985a9d3f53b76$export$3ae2d1e732b25194);
$parcel$export(module.exports, "getTeamAri", () => $c4b985a9d3f53b76$export$4182db567773f894);

var $gtr2v = parcelRequire("gtr2v");
var $3cO0K = parcelRequire("3cO0K");
var $bRGBj = parcelRequire("bRGBj");
var $3osLr = parcelRequire("3osLr");

var $cuF7F = parcelRequire("cuF7F");
const $c4b985a9d3f53b76$export$e8eac31981efe1fb = (teamAri)=>{
    let teamId;
    const isIdentityTeamsAri = (0, $bRGBj.IdentityTeamAri).check(teamAri);
    if (isIdentityTeamsAri) {
        const identityTeamId = (0, $bRGBj.IdentityTeamAri).parse(teamAri).teamId;
        if (identityTeamId !== 'unidentified') teamId = identityTeamId;
        else (0, $cuF7F.logErrorMessage)('Team ID has value "unidentified" in getTeamId', {
            teamAri: teamAri
        });
    } else (0, $cuF7F.logErrorMessage)('Cannot parse IdentityTeamARI in getTeamId', {
        teamAri: teamAri
    });
    return teamId;
};
const $c4b985a9d3f53b76$export$782629dc0d11ee5c = (containerAri, teamAri)=>{
    let teamProfileUrl;
    const productPath = (0, $3cO0K.ConfluenceSpaceAri).check(containerAri) ? 'wiki' : (0, $3osLr.JiraProjectAri).check(containerAri) ? 'jira' : undefined;
    let teamId;
    teamId = $c4b985a9d3f53b76$export$e8eac31981efe1fb(teamAri);
    if (productPath && teamId) teamProfileUrl = `${window.location.origin}/${productPath}/people/team/${teamId}`;
    else (0, $cuF7F.logErrorMessage)('Cannot create teamProfileUrl in getTeamProfileUrl', {
        containerAri: containerAri,
        teamAri: teamAri
    });
    return teamProfileUrl;
};
const $c4b985a9d3f53b76$export$3ae2d1e732b25194 = (containerAri)=>{
    const siteId = (0, $gtr2v.AnyAri).check(containerAri) && (0, $gtr2v.AnyAri).parse(containerAri).cloudId;
    if (!siteId) {
        (0, $cuF7F.logErrorMessage)('Cannot parse containerAri in getSiteId', {
            containerAri: containerAri
        });
        return;
    }
    return siteId;
};
const $c4b985a9d3f53b76$export$4182db567773f894 = (teamId)=>{
    try {
        return (0, $bRGBj.IdentityTeamAri).create({
            teamId: teamId
        }).toString();
    } catch (error) {
        (0, $cuF7F.logErrorMessage)('Cannot create IdentityTeamAri in getTeamAri', {
            teamId: teamId
        });
    }
};

});
parcelRegister("3cO0K", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSpaceAri", () => $2559493dd2753c38$export$4e1bd9257e1b7213);

var $eHAIw = parcelRequire("eHAIw");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/confluence/space/manifest.ts
var $2559493dd2753c38$var$confluenceSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $eHAIw.ConfluenceSpaceAriResourceOwner),
    resourceType: (0, $eHAIw.ConfluenceSpaceAriResourceType),
    resourceIdSlug: "{spaceId}",
    resourceIdSegmentFormats: {
        spaceId: /[0-9]+/
    }
};
// src/confluence/space/index.ts
var $2559493dd2753c38$export$4e1bd9257e1b7213 = class _ConfluenceSpaceAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
    get siteId() {
        return this._siteId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2559493dd2753c38$var$confluenceSpaceAriStaticOpts.qualifier,
            platformQualifier: $2559493dd2753c38$var$confluenceSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2559493dd2753c38$var$confluenceSpaceAriStaticOpts.resourceOwner,
            resourceType: $2559493dd2753c38$var$confluenceSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.spaceId}`,
            resourceIdSegmentValues: {
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $2559493dd2753c38$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $2559493dd2753c38$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            spaceId: this.spaceId
        };
    }
};

});
parcelRegister("eHAIw", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSpaceAriResourceOwner", () => $ab419016e23a4660$export$204c4c730af505ce);
$parcel$export(module.exports, "ConfluenceSpaceAriResourceType", () => $ab419016e23a4660$export$7c78a678ea7a8ac7);
// src/confluence/space/types.ts
var $ab419016e23a4660$export$204c4c730af505ce = "confluence", $ab419016e23a4660$export$7c78a678ea7a8ac7 = "space";

});


parcelRegister("bRGBj", function(module, exports) {

$parcel$export(module.exports, "IdentityTeamAri", () => $8a35b0966dbaf62a$export$33bbb2d79e520118);

var $kVLBp = parcelRequire("kVLBp");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/identity/team/manifest.ts
var $8a35b0966dbaf62a$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $kVLBp.IdentityTeamAriResourceOwner),
    resourceType: (0, $kVLBp.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $8a35b0966dbaf62a$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._teamId = opts.resourceIdSegmentValues.teamId;
    }
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $8a35b0966dbaf62a$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $8a35b0966dbaf62a$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $8a35b0966dbaf62a$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $8a35b0966dbaf62a$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $8a35b0966dbaf62a$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $8a35b0966dbaf62a$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
};

});
parcelRegister("kVLBp", function(module, exports) {

$parcel$export(module.exports, "IdentityTeamAriResourceOwner", () => $f3ce0e57608bce25$export$49beddf48ffb3f35);
$parcel$export(module.exports, "IdentityTeamAriResourceType", () => $f3ce0e57608bce25$export$b2079a2a841afe32);
// src/identity/team/types.ts
var $f3ce0e57608bce25$export$49beddf48ffb3f35 = "identity", $f3ce0e57608bce25$export$b2079a2a841afe32 = "team";

});


parcelRegister("cuF7F", function(module, exports) {

$parcel$export(module.exports, "logException", () => $942c417009f131df$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $942c417009f131df$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $942c417009f131df$export$386587bcf05ee8ea);

var $kP1cg = parcelRequire("kP1cg");
const $942c417009f131df$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $942c417009f131df$export$f86b2a1a2ce291b3 = (0, $kP1cg.logExceptionWithPackageContext)($942c417009f131df$var$packageContext);
const $942c417009f131df$export$ece28f5cfa04608 = (0, $kP1cg.logErrorMessageWithPackageContext)($942c417009f131df$var$packageContext);
const $942c417009f131df$export$386587bcf05ee8ea = (0, $kP1cg.logInfoMessageWithPackageContext)($942c417009f131df$var$packageContext);
const $942c417009f131df$export$9edc7d6f1c33ddc = (0, $kP1cg.createErrorHandlerWithPackageContext)($942c417009f131df$var$packageContext);

});
parcelRegister("kP1cg", function(module, exports) {

$parcel$export(module.exports, "logException", () => $950c0743f70e539d$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $950c0743f70e539d$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $950c0743f70e539d$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $950c0743f70e539d$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $950c0743f70e539d$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $950c0743f70e539d$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $950c0743f70e539d$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $950c0743f70e539d$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $356Lx = parcelRequire("356Lx");
function $950c0743f70e539d$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $950c0743f70e539d$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $356Lx.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $950c0743f70e539d$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $950c0743f70e539d$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $356Lx.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $950c0743f70e539d$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $950c0743f70e539d$export$ece28f5cfa04608(message, context = {}) {
    $950c0743f70e539d$var$logMessage('error', message, context).catch(()=>{});
}
function $950c0743f70e539d$export$386587bcf05ee8ea(message, context = {}) {
    $950c0743f70e539d$var$logMessage('info', message, context).catch(()=>{});
}
const $950c0743f70e539d$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $950c0743f70e539d$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $950c0743f70e539d$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $950c0743f70e539d$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $950c0743f70e539d$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $950c0743f70e539d$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $950c0743f70e539d$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $950c0743f70e539d$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $950c0743f70e539d$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$950c0743f70e539d$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $950c0743f70e539d$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $356Lx.getSentryClient)();
    sentryClient.withScope((scope)=>{
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("356Lx", function(module, exports) {

$parcel$export(module.exports, "sentryClient", () => $d6fe0b5616dbf418$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $d6fe0b5616dbf418$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $d6fe0b5616dbf418$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $d6fe0b5616dbf418$export$d8bd0edf6c978788);

var $b0bYt = parcelRequire("b0bYt");

var $6ceSs = parcelRequire("6ceSs");
let $d6fe0b5616dbf418$export$ac71c212168fcd2b;
const $d6fe0b5616dbf418$export$7d446c6f4e54de82 = (client)=>{
    $d6fe0b5616dbf418$export$ac71c212168fcd2b = client;
};
const $d6fe0b5616dbf418$export$f553e8b08ef59d31 = async ()=>{
    if (!$d6fe0b5616dbf418$export$ac71c212168fcd2b) await $d6fe0b5616dbf418$export$d8bd0edf6c978788({});
    return $d6fe0b5616dbf418$export$ac71c212168fcd2b;
};
async function $d6fe0b5616dbf418$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $d6fe0b5616dbf418$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $6ceSs.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $d6fe0b5616dbf418$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $b0bYt.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $d6fe0b5616dbf418$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("9vXJM"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
    }
}
function $d6fe0b5616dbf418$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("b0bYt", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $3bfcaf52858a3244$export$6faa4a850bc4d0ce);

var $lopBx = parcelRequire("lopBx");
const $3bfcaf52858a3244$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $3bfcaf52858a3244$export$68c35ed3898e185a = '5988845';
const $3bfcaf52858a3244$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $3bfcaf52858a3244$export$97db6664a1e55fa6 = '47';
const $3bfcaf52858a3244$var$SENTRY_COMMERCIAL_DSN = `https://${$3bfcaf52858a3244$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$3bfcaf52858a3244$export$68c35ed3898e185a}`;
const $3bfcaf52858a3244$var$SENTRY_FEDRAMP_DSN = `https://${$3bfcaf52858a3244$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$3bfcaf52858a3244$export$97db6664a1e55fa6}`;
const $3bfcaf52858a3244$export$6faa4a850bc4d0ce = (0, $lopBx.isFedRamp)() ? $3bfcaf52858a3244$var$SENTRY_FEDRAMP_DSN : $3bfcaf52858a3244$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("6ceSs", function(module, exports) {

$parcel$export(module.exports, "initialiseSentry", () => $d6feef4366a3b41b$export$357606956af25316);

var $3Cktb = parcelRequire("3Cktb");

var $356Lx = parcelRequire("356Lx");
const $d6feef4366a3b41b$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $d6feef4366a3b41b$export$357606956af25316(client, options) {
    if (0, $356Lx.sentryClient) return;
    if (!client) return;
    (0, $356Lx.setSentryClient)(client);
    const sentryConfig = (0, $3Cktb.getSentryConfig)(options);
    (0, $356Lx.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $d6feef4366a3b41b$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("3Cktb", function(module, exports) {

$parcel$export(module.exports, "getSentryConfig", () => $fd3d2aa688325677$export$5580e6304e95c792);

var $b0bYt = parcelRequire("b0bYt");
const $fd3d2aa688325677$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $b0bYt.SENTRY_DSN),
    attachStacktrace: true
};
function $fd3d2aa688325677$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$fd3d2aa688325677$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("9vXJM", function(module, exports) {

let $6ed558e4c4924f7b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ed558e4c4924f7b$var$load("94M02").then(()=>parcelRequire('497YX'));

});





parcelRegister("6KBVc", function(module, exports) {

$parcel$export(module.exports, "isTeamBiDirectionalEnabled", () => $ae916dc5213e7206$export$444827debf3aeb22);

var $59rsN = parcelRequire("59rsN");
const $ae916dc5213e7206$export$444827debf3aeb22 = (containerType, fireExperimentExposure = false)=>{
    if ((0, $59rsN.default).initializeCompleted()) return containerType === 'Jira' && (0, $59rsN.default).checkGate('team-bi-directional-container-connection-gate') && (0, $59rsN.default).getExperimentValue('team-bi-directional-container-connection', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    }) || containerType === 'Confluence' && (0, $59rsN.default).getExperimentValue('edit-team-connection-from-confluence', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    });
    return false;
};

});

parcelRegister("bXZkV", function(module, exports) {

$parcel$export(module.exports, "TeamSelectorProvider", () => $4a8db0ca5b32d925$export$71d1921e4d5a0198);
$parcel$export(module.exports, "useTeamSelectorContext", () => $4a8db0ca5b32d925$export$1e7dbad964b23e80);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $4a8db0ca5b32d925$var$TeamSelectorContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    cloudId: '',
    orgId: '',
    containerId: ''
});
function $4a8db0ca5b32d925$export$71d1921e4d5a0198({ children: children, cloudId: cloudId, orgId: orgId, containerId: containerId, containerType: containerType }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4a8db0ca5b32d925$var$TeamSelectorContext.Provider, {
        value: {
            cloudId: cloudId,
            orgId: orgId,
            containerId: containerId,
            containerType: containerType
        },
        children: children
    });
}
const $4a8db0ca5b32d925$export$1e7dbad964b23e80 = ()=>(0, $eJOHy.useContext)($4a8db0ca5b32d925$var$TeamSelectorContext);

});

parcelRegister("knY1C", function(module, exports) {

$parcel$export(module.exports, "asyncTeamSelectorEntryPoint", () => $a581e2d5ad29721a$export$735620207607ea13);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $lT6h7 = parcelRequire("lT6h7");
const $a581e2d5ad29721a$var$fetchPolicy = 'network-only';

const $a581e2d5ad29721a$export$735620207607ea13 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("exT7T")).then(({ AsyncTeamSelectorWithQuery: AsyncTeamSelectorWithQuery })=>AsyncTeamSelectorWithQuery), {
        moduleId: "be449799",
        moduleName: "AsyncTeamSelector",
        priority: "interaction",
        moduleId: 'team-selector-entrypoint'
    }),
    getPreloadProps: ({ containerId: containerId })=>({
            queries: {
                getTeamsForContainerQuery: {
                    parameters: $lT6h7.default,
                    variables: {
                        containerId: containerId
                    },
                    options: {
                        fetchPolicy: $a581e2d5ad29721a$var$fetchPolicy
                    }
                }
            },
            extraProps: {
                containerId: containerId
            }
        })
});

});
parcelRegister("lT6h7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d536c61c3936537$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0abfe75f87727625472ca1040fa857bd>>
 * @relayHash a5822def1b8d2a45a02bc5ec3978395f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9fe29aba3388dd2cef2edce3e631712f20a2200a38874c6924ce95d61e1464e1
const $6d536c61c3936537$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "consistentRead",
            "value": true
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "containerId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AsyncTeamSelectorQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                            "kind": "LinkedField",
                            "name": "teamConnectedToContainerInverse",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "TeamCard_team"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "TeamItem_team"
                                                        }
                                                    ],
                                                    "type": "TeamV2"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "AsyncManageTeams"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AsyncTeamSelectorQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                            "kind": "LinkedField",
                            "name": "teamConnectedToContainerInverse",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "smallAvatarImageUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "smallHeaderImageUrl"
                                                        },
                                                        {
                                                            "concreteType": "TeamMemberConnectionV2",
                                                            "kind": "LinkedField",
                                                            "name": "members",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TeamMemberV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "member",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "hasNextPage"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        }
                                                    ],
                                                    "type": "TeamV2"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9fe29aba3388dd2cef2edce3e631712f20a2200a38874c6924ce95d61e1464e1",
            "metadata": {},
            "name": "AsyncTeamSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6d536c61c3936537$var$node.hash = "10fc2cbf2c01fe8383ceb0cfa1df2b97";
var $6d536c61c3936537$export$2e2bcd8739ae039 = $6d536c61c3936537$var$node;

});

parcelRegister("exT7T", function(module, exports) {

let $a96ee8b3c270e392$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a96ee8b3c270e392$var$load("kNFvF"),
    $a96ee8b3c270e392$var$load("76n7a"),
    $a96ee8b3c270e392$var$load("l253H"),
    $a96ee8b3c270e392$var$load("ffQaD"),
    $a96ee8b3c270e392$var$load("kvRbA"),
    $a96ee8b3c270e392$var$load("8tQvk")
]).then(()=>parcelRequire('lMLlh'));

});


parcelRegister("a8Dqb", function(module, exports) {

$parcel$export(module.exports, "useTeamBiDirectionalExp", () => $44f76645ca60a360$export$bfdf61bc95e5d014);

var $6KBVc = parcelRequire("6KBVc");

var $bXZkV = parcelRequire("bXZkV");
const $44f76645ca60a360$export$bfdf61bc95e5d014 = ()=>{
    const { containerType: containerType } = (0, $bXZkV.useTeamSelectorContext)();
    const isTeamBiDirectionalEnabled = (0, $6KBVc.isTeamBiDirectionalEnabled)(containerType);
    return {
        isTeamBiDirectionalEnabled: isTeamBiDirectionalEnabled
    };
};

});

parcelRegister("konD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c06483fe8658852$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YEko = parcelRequire("6YEko");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $a8Dqb = parcelRequire("a8Dqb");

var $g7EjG = parcelRequire("g7EjG");
const $8c06483fe8658852$var$loadingContainerStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    width: '320px',
    display: 'block',
    alignItems: 'center',
    justifyContent: 'center'
});
const $8c06483fe8658852$var$styles = {
    headerSkeleton: "_ca0qv47k _n3tdu2gc _19bvpxbi _u5f3pxbi",
    badgeSkeleton: "_2rkoiti9 _4t3i7vkz _1bsb1tcg",
    titleSkeleton: "_2rko1q77 _4t3i7vkz _1bsb1lit"
};
const $8c06483fe8658852$var$TeamSelectorSkeleton = ()=>{
    const { isTeamBiDirectionalEnabled: isTeamBiDirectionalEnabled } = (0, $a8Dqb.useTeamBiDirectionalExp)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        testId: "testId-team-selector-skeleton",
        xcss: $8c06483fe8658852$var$loadingContainerStyles,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
                xcss: $8c06483fe8658852$var$styles.headerSkeleton,
                spread: "space-between",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                        xcss: $8c06483fe8658852$var$styles.titleSkeleton,
                        backgroundColor: "color.background.neutral"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                        xcss: $8c06483fe8658852$var$styles.badgeSkeleton,
                        backgroundColor: "color.background.neutral"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                isList: true,
                children: [
                    ...Array(3)
                ].map((_, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $g7EjG.ItemSkeleton), {}, index))
            }),
            isTeamBiDirectionalEnabled && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g7EjG.ItemSkeleton), {
                    showControl: false
                })
            })
        ]
    });
};
var $8c06483fe8658852$export$2e2bcd8739ae039 = $8c06483fe8658852$var$TeamSelectorSkeleton;

});
parcelRegister("g7EjG", function(module, exports) {

$parcel$export(module.exports, "ItemSkeleton", () => $1bb34c2ad24d32d5$export$84345645841732c3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
const $1bb34c2ad24d32d5$var$styles = {
    containerWrapperSkeleton: "_4cvr1h6o _1p57utpp _syaz1fxt _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi",
    containerIconSkeleton: "_2rkoiti9 _4t3i1tcg _1bsb1tcg _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    labelSkeleton: "_2rko1q77 _1rjc1b66 _4t3irdoj _1bsb1osq",
    controlSkeleton: "_2rkogqwt _4t3i1crf _1bsb1crf"
};
const $1bb34c2ad24d32d5$export$84345645841732c3 = ({ showControl: showControl = true })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        space: "space.100",
        xcss: $1bb34c2ad24d32d5$var$styles.containerWrapperSkeleton,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $1bb34c2ad24d32d5$var$styles.containerIconSkeleton,
                backgroundColor: "color.background.neutral"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $1bb34c2ad24d32d5$var$styles.labelSkeleton,
                backgroundColor: "color.background.neutral"
            }),
            showControl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $1bb34c2ad24d32d5$var$styles.controlSkeleton,
                backgroundColor: "color.background.neutral"
            })
        ]
    });
};

});


parcelRegister("5lxWX", function(module, exports) {

$parcel$export(module.exports, "getContainerType", () => $b0050ba1f8cfd199$export$acc6f3e19803b3dc);

var $3cO0K = parcelRequire("3cO0K");
var $3osLr = parcelRequire("3osLr");
var $cilND = parcelRequire("cilND");
const $b0050ba1f8cfd199$export$acc6f3e19803b3dc = (containerAri)=>{
    const isConfluenceSpace = (0, $3cO0K.ConfluenceSpaceAri).check(containerAri);
    const isJiraProject = (0, $3osLr.JiraProjectAri).check(containerAri);
    const isLoomSpace = (0, $cilND.LoomSpaceAri).check(containerAri);
    if (isConfluenceSpace) return 'Confluence';
    if (isJiraProject) return 'Jira';
    if (isLoomSpace) return 'Loom';
};

});
parcelRegister("cilND", function(module, exports) {

$parcel$export(module.exports, "LoomSpaceAri", () => $8f38137074ad9b97$export$d1493cc5b72a4537);

var $lVtN2 = parcelRequire("lVtN2");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/loom/space/manifest.ts
var $8f38137074ad9b97$var$loomSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $lVtN2.LoomSpaceAriResourceOwner),
    resourceType: (0, $lVtN2.LoomSpaceAriResourceType),
    resourceIdSlug: "activation/{activationId}/{spaceId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        spaceId: /[0-9]+/
    }
};
// src/loom/space/index.ts
var $8f38137074ad9b97$export$d1493cc5b72a4537 = class _LoomSpaceAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $8f38137074ad9b97$var$loomSpaceAriStaticOpts.qualifier,
            platformQualifier: $8f38137074ad9b97$var$loomSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $8f38137074ad9b97$var$loomSpaceAriStaticOpts.resourceOwner,
            resourceType: $8f38137074ad9b97$var$loomSpaceAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.spaceId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $8f38137074ad9b97$var$loomSpaceAriStaticOpts);
        return new _LoomSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $8f38137074ad9b97$var$loomSpaceAriStaticOpts);
        return new _LoomSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            spaceId: this.spaceId
        };
    }
};

});
parcelRegister("lVtN2", function(module, exports) {

$parcel$export(module.exports, "LoomSpaceAriResourceOwner", () => $ff660784c4ea89ce$export$4d15ef33e3a923ce);
$parcel$export(module.exports, "LoomSpaceAriResourceType", () => $ff660784c4ea89ce$export$ccb8092d14ea132d);
// src/loom/space/types.ts
var $ff660784c4ea89ce$export$4d15ef33e3a923ce = "loom", $ff660784c4ea89ce$export$ccb8092d14ea132d = "space";

});



parcelRegister("hzPqr", function(module, exports) {

$parcel$export(module.exports, "TeamButtonTrigger", () => $00681321e83f66b7$export$3fe916959ce1a733);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lT9x0 = parcelRequire("lT9x0");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $dcLzM = parcelRequire("dcLzM");

var $eALjj = parcelRequire("eALjj");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $b275c = parcelRequire("b275c");

var $a8Dqb = parcelRequire("a8Dqb");

var $h3TYL = parcelRequire("h3TYL");
const $00681321e83f66b7$var$engagementId = 'team-button-onboarding';
const $00681321e83f66b7$var$buttonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    display: 'flex',
    alignItems: 'center',
    height: '32px',
    width: '32px',
    justifyContent: 'center',
    color: 'color.text.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $00681321e83f66b7$var$buttonStylesWithNumber = (0, $1DXK0.xcss)({
    width: '56px'
});
const $00681321e83f66b7$export$3fe916959ce1a733 = ({ triggerProps: triggerProps, numberOfTeams: numberOfTeams, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireEvent: fireEvent } = (0, $b275c.usePeopleTeamAnalyticsEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { isTeamBiDirectionalEnabled: isTeamBiDirectionalEnabled } = (0, $a8Dqb.useTeamBiDirectionalExp)();
    (0, $eJOHy.useEffect)(()=>{
        const result = createAnalyticsEvent({})?.context.find((item)=>item.attributes && item.attributes.scope !== undefined);
        fireEvent('ui.teamButton.viewed', {
            teamsCount: numberOfTeams,
            scope: result?.attributes?.scope ?? '',
            version: isTeamBiDirectionalEnabled ? 'm2' : 'm1'
        });
    }, [
        createAnalyticsEvent,
        fireEvent,
        isTeamBiDirectionalEnabled,
        numberOfTeams
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bQP4O.default), {
        ...triggerProps,
        onClick: onClick,
        xcss: [
            $00681321e83f66b7$var$buttonStyles,
            numberOfTeams !== 1 && $00681321e83f66b7$var$buttonStylesWithNumber
        ],
        testId: "team-button-trigger",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eALjj))), {
                color: "currentColor",
                label: formatMessage((0, $h3TYL.default).iconLabel)
            }),
            numberOfTeams > 1 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                as: "span",
                paddingInlineStart: "space.100",
                children: numberOfTeams
            }),
            numberOfTeams === 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                as: "span",
                paddingInlineStart: "space.050",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                    color: "currentColor",
                    label: formatMessage((0, $h3TYL.default).addTeamIconLabel)
                })
            })
        ]
    });
    if (!isTeamBiDirectionalEnabled) return content;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $54CI2.default), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $guChT.default), {
                name: $00681321e83f66b7$var$engagementId,
                children: content
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lT9x0.EngagementSpotlight), {
                name: $00681321e83f66b7$var$engagementId
            })
        ]
    });
};

});
parcelRegister("h3TYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $7691d7d1d7f7d32e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7691d7d1d7f7d32e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    iconLabel: {
        id: 'team-button-trigger.icon.label',
        defaultMessage: 'Team button',
        description: 'Label for the team button icon'
    },
    addTeamIconLabel: {
        id: 'team-button-trigger.add-team-icon.label',
        defaultMessage: 'Add team',
        description: 'Label for the add team icon'
    }
});

});





parcelRegister("6R5QV", function(module, exports) {

$parcel$export(module.exports, "ProjectHeader", () => $8837678c0e0e1861$export$69277e177204bdfd);

var $57iYG = parcelRequire("57iYG");

var $4OVt5 = parcelRequire("4OVt5");

var $jQITz = parcelRequire("jQITz");

var $gaI6Z = parcelRequire("gaI6Z");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $5bzWA = parcelRequire("5bzWA");


var $lTqUW = parcelRequire("lTqUW");

var $bS07j = parcelRequire("bS07j");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $fRoln = parcelRequire("fRoln");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $9Ovhp = parcelRequire("9Ovhp");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $1715R = parcelRequire("1715R");

var $kA2cA = parcelRequire("kA2cA");

var $ljjv4 = parcelRequire("ljjv4");

var $g7LSl = parcelRequire("g7LSl");

var $demTA = parcelRequire("demTA");
const $8837678c0e0e1861$export$69277e177204bdfd = (props)=>{
    const { queryFragment: queryFragment, projectFragment: projectFragment } = props;
    const data = (0, $j4oe4.useFragment)((0, $gaI6Z.default), queryFragment);
    const project = (0, $j4oe4.useFragment)((0, $jQITz.default), projectFragment);
    const analyticsData = (0, $eJOHy.useMemo)(()=>({
            navigationContainer: (0, $95eb6070d868c1b7$export$b83d0ee9325a2d0a)
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8837678c0e0e1861$var$ProjectHeaderInner, {
        ...props,
        queryFragment: data,
        projectFragment: project
    }));
};
const $8837678c0e0e1861$var$ProjectHeaderInner = ({ queryFragment: queryFragment, projectFragment: projectFragment })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isFullscreen] = (0, $5bzWA.useIsFullscreen)();
    const { updateProjectName: updateProjectName, validateProjectName: validateProjectName } = (0, $kA2cA.useRenameProject)();
    const { hasSoftwareTheming: hasSoftwareTheming } = (0, $1302Y.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kUoGK.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false
    };
    const data = (0, $j4oe4.useFragment)((0, $4OVt5.default), queryFragment);
    const project = (0, $j4oe4.useFragment)((0, $57iYG.default), projectFragment);
    const isBusinessProject = project.projectType === 'BUSINESS';
    const isSoftwareProject = project.projectType === 'SOFTWARE';
    const withInlineEdit = isBusinessProject;
    const isCorePremiumUserSeat = data.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM';
    const canEditProjectConfig = project?.canEditProjectConfig?.canPerform ?? false;
    const hasChangeTheme = canEditProjectConfig && (hasSoftwareTheming || isBusinessProject);
    const icon = (0, $eJOHy.useMemo)(()=>{
        const avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8837678c0e0e1861$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $demTA.default), {
            projectRef: project
        }));
        if (withInlineEdit) return avatar;
        if (!project?.avatar?.large) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTqUW.ProjectIcon), {
            "data-testid": "horizontal-nav-header.ui.project-header.project-icon",
            "data-vc": "horizontal-nav-project-icon",
            src: project.avatar.large,
            alt: ""
        });
    }, [
        project,
        withInlineEdit
    ]);
    const handleProjectActionDropDownClick = (0, $eJOHy.useCallback)(()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'projectActionsDropdown', {}), [
        createAnalyticsEvent
    ]);
    const onUpdateProjectName = (0, $eJOHy.useCallback)((name)=>updateProjectName(Number(project?.projectId), name), [
        project?.projectId,
        updateProjectName
    ]);
    let headerProps = {};
    if (withInlineEdit && project?.projectId) {
        const inlineEditProps = {
            withInlineEdit: true,
            onConfirm: onUpdateProjectName,
            onValidate: validateProjectName,
            id: Number(project.projectId)
        };
        headerProps = canEditProjectConfig ? inlineEditProps : {};
    }
    const showTeamButton = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('team-connection-visibility-in-jira') && (0, $epTsa.expVal)('team_and_container_m1', 'isEnabled', false);
    const extraComponentsClose = (0, $eJOHy.useMemo)(()=>{
        if (!project) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showTeamButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g7LSl.NavigationTeamButton), {
            projectFragment: project,
            scope: "project"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bS07j.ProjectActionMenu), {
            "data-testid": "horizontal-nav-header.ui.project-header.project-action-menu",
            key: "ProjectActions",
            projectKey: project.key,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            additionalMenuItems: hasChangeTheme && !!project.projectId && !(0, $7jTnu.fg)('project_theming_m2_fast_follow_2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fRoln.ThemePicker), {
                projectId: Number(project.projectId),
                withAdaptiveColorTheme: isSoftwareProject && (0, $1302Y.getIsSoftwareThemingEnabled)(),
                /*
       * Render the theme picker popup inside a portal, this ensures it appears above other
       * elements, even when nested deep inside a container.
       * This SHOULD NOT be changed as it will cause the popup to be
       * rendered inside the parent container, which will cause it to appear behind other elements.
       */ shouldRenderToParent: false
            }),
            withThemedTrigger: true,
            onClick: handleProjectActionDropDownClick,
            shouldRenderToParent: (0, $7jTnu.fg)('blu-7153_shouldrendertoparent_with_prereq')
        }));
    }, [
        project,
        showTeamButton,
        isCorePremiumUserSeat,
        hasChangeTheme,
        isSoftwareProject,
        handleProjectActionDropDownClick
    ]);
    if (!project) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ovhp.default), {
        title: project.name,
        ...headerProps,
        icon: icon,
        isLoading: project == null,
        extraComponentsClose: extraComponentsClose,
        testId: "horizontal-nav-header.ui.project-header.header",
        extraComponentsFar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1715R.ExtraComponentsFar), {
            projectFragment: project
        }),
        extraComponentsAbove: !isFullscreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ljjv4.HorizontalNavProjectBreadcrumbs), {
            projectFragment: project
        })
    });
};
const $8837678c0e0e1861$var$iconStyles = (0, $1DXK0.xcss)({
    width: '20px',
    height: '20px',
    boxSizing: 'border-box'
});

});
parcelRegister("57iYG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bda4a19d47d75fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f97863cc435b31a11fe6745855512d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5bda4a19d47d75fb$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ProjectHeader_inner_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectAvatar"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "NavigationTeamButton_project"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "extraComponentsFar_horizontalNav"
        },
        {
            "kind": "FragmentSpread",
            "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
        }
    ],
    "type": "JiraProject"
};
$5bda4a19d47d75fb$var$node.hash = "470801e5fae5e2ecdc7e34a5f0a614a1";
var $5bda4a19d47d75fb$export$2e2bcd8739ae039 = $5bda4a19d47d75fb$var$node;

});

parcelRegister("4OVt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $83b0c4a21068dae2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d7b22ff370d9e9a7a741a37c508a145>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $83b0c4a21068dae2$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "ProjectHeader_inner_query",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraWorkManagementLicensing",
                        "kind": "LinkedField",
                        "name": "jwmLicensing",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "currentUserSeatEdition"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$83b0c4a21068dae2$var$node.hash = "6b10db5d77a3ec3bb1e3665b0de46b2f";
var $83b0c4a21068dae2$export$2e2bcd8739ae039 = $83b0c4a21068dae2$var$node;

});

parcelRegister("jQITz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a68fd2c03cc7e3db$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<718f44a9e92e1d7dd77b78909d0471cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a68fd2c03cc7e3db$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectHeader_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_inner_project"
        }
    ],
    "type": "JiraProject"
};
$a68fd2c03cc7e3db$var$node.hash = "78893912e046c1d6733f1058dcb592a0";
var $a68fd2c03cc7e3db$export$2e2bcd8739ae039 = $a68fd2c03cc7e3db$var$node;

});

parcelRegister("gaI6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e27b9d4a619f7f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc8a0e19e9b9d644207c1ba1389c2482>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0e27b9d4a619f7f0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectHeader_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_inner_query"
        }
    ],
    "type": "Query"
};
$0e27b9d4a619f7f0$var$node.hash = "d1740bc312d925b4121b692ded4c84ed";
var $0e27b9d4a619f7f0$export$2e2bcd8739ae039 = $0e27b9d4a619f7f0$var$node;

});

parcelRegister("bS07j", function(module, exports) {

$parcel$export(module.exports, "ProjectActionMenu", () => $38a903ab1d7ae22b$export$b71a0a4e7f29cfd6);

var $eJOHy = parcelRequire("eJOHy");

var $NByNW = parcelRequire("NByNW");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $6zXPf = parcelRequire("6zXPf");

var $cJEMq = parcelRequire("cJEMq");

var $7jTnu = parcelRequire("7jTnu");

var $6XJko = parcelRequire("6XJko");

var $dEoQI = parcelRequire("dEoQI");

var $ce73j = parcelRequire("ce73j");
const $38a903ab1d7ae22b$var$CustomTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const triggerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
            label: formatMessage((0, $ce73j.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-project-action-menu.ui.themed-button"
    });
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $ce73j.default).moreActions),
        hideTooltipOnClick: true
    }, triggerButton) : triggerButton;
});
const $38a903ab1d7ae22b$export$b71a0a4e7f29cfd6 = ({ additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, withThemedTrigger: withThemedTrigger = false, projectKey: projectKey, onClick: onClick, shouldRenderToParent: shouldRenderToParent, projectName: projectName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dEoQI.EntryPointContent), {
        ...(0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
        additionalMenuItems: additionalMenuItems,
        onClick: onClick,
        isCorePremiumUserSeat: isCorePremiumUserSeat,
        CustomTrigger: withThemedTrigger && (0, $6zXPf.getWillShowNav4)() ? $38a903ab1d7ae22b$var$CustomTrigger : undefined,
        projectKey: projectKey,
        shouldRenderToParent: shouldRenderToParent
    });
};

});
parcelRegister("dEoQI", function(module, exports) {

$parcel$export(module.exports, "EntryPointContent", () => $fabe5cda70e02c8e$export$912f81dce8d58e46);

var $eJOHy = parcelRequire("eJOHy");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $efhF3 = parcelRequire("efhF3");

var $i0Ev8 = parcelRequire("i0Ev8");

var $gcYED = parcelRequire("gcYED");
const $fabe5cda70e02c8e$export$912f81dce8d58e46 = ({ CustomTrigger: CustomTrigger, onClick: onClick, additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, projectKey: projectKey, shouldRenderToParent: shouldRenderToParent, projectName: projectName })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $efhF3.projectActionMenuEntryPoint), (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]));
    const buttonTriggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const content = (0, $eJOHy.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "project-actions-menu-popup-content",
            packageName: "jira-navigation-apps-project-action-menu",
            runtimeProps: (0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1') ? // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $eJOHy.useMemo)(()=>({
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    additionalMenuItems: additionalMenuItems,
                    isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
                    contentProps: contentProps
                }), [
                contentProps
            ]) : {
                isCorePremiumUserSeat: isCorePremiumUserSeat,
                additionalMenuItems: additionalMenuItems,
                isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
                contentProps: contentProps
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gcYED.Skeleton), null)
        }), [
        entryPointReferenceSubject,
        additionalMenuItems,
        isCorePremiumUserSeat,
        isProjectMenuReorderingEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0Ev8.MenuContainer), {
        ...(0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        content: content,
        CustomTrigger: CustomTrigger,
        onClick: onClick,
        buttonTriggerRef: buttonTriggerRef,
        shouldRenderToParent: shouldRenderToParent
    });
};

});
parcelRegister("efhF3", function(module, exports) {

$parcel$export(module.exports, "projectActionMenuEntryPoint", () => $f137ce769a6a6e13$export$30ec6de22da54fa0);

var $huuzO = parcelRequire("huuzO");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");
const $f137ce769a6a6e13$var$fetchPolicy = 'network-only';

const $f137ce769a6a6e13$export$30ec6de22da54fa0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("86B38")).then((module)=>module.AsyncMenuWithQuery), {
        moduleId: "eb74dcae",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>{
        const projectActionMenuQuery = {
            parameters: (0, $huuzO.default),
            variables: {
                cloudId: cloudId,
                projectKey: projectKey
            },
            options: {
                fetchPolicy: $f137ce769a6a6e13$var$fetchPolicy
            }
        };
        return {
            queries: {
                projectActionMenuQuery: projectActionMenuQuery
            }
        };
    }
});

});
parcelRegister("huuzO", function(module, exports) {

$parcel$export(module.exports, "default", () => $72a5c7cd3356ba54$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d360e49d5eb693192c7fbc1eac496f85>>
 * @relayHash a9a48f3ed05422d23cacd580dcce751d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e05d6d8357d9d7fabad007766bd445c51b79afe818cc226061c1c9209b8fd76e
const $72a5c7cd3356ba54$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e05d6d8357d9d7fabad007766bd445c51b79afe818cc226061c1c9209b8fd76e",
        "metadata": {},
        "name": "async_AsyncMenuContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $72a5c7cd3356ba54$export$2e2bcd8739ae039 = $72a5c7cd3356ba54$var$node;

});

parcelRegister("86B38", function(module, exports) {

let $5e6b9f89b1d907e6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5e6b9f89b1d907e6$var$load("7jMMG").then(()=>parcelRequire('6RVGd'));

});


parcelRegister("i0Ev8", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $3a1ab3ba3bb2ee1c$export$b286f91cddfedb5a);

var $eJOHy = parcelRequire("eJOHy");

var $6zXPf = parcelRequire("6zXPf");

var $he6m3 = parcelRequire("he6m3");

var $hih5V = parcelRequire("hih5V");

var $cNe2t = parcelRequire("cNe2t");

var $7jTnu = parcelRequire("7jTnu");

var $6Vosf = parcelRequire("6Vosf");
const $3a1ab3ba3bb2ee1c$export$b286f91cddfedb5a = ({ content: content, CustomTrigger: CustomTrigger, onClick: onClick, onClose: onCloseCustom, buttonTriggerRef: buttonTriggerRef, shouldRenderToParent: shouldRenderToParent = true, projectName: projectName })=>{
    const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, $he6m3.useOpenable)();
    const route = (0, $hih5V.useCurrentRoute)();
    const handleClose = (0, $eJOHy.useCallback)((e)=>{
        try {
            onCloseCustom?.(e);
        } finally{
            onClose();
        }
    }, [
        onCloseCustom,
        onClose
    ]);
    const onClickHandler = (0, $eJOHy.useCallback)(()=>{
        onToggle();
        onClick?.();
    }, [
        onClick,
        onToggle
    ]);
    const trigger = (triggerProps)=>{
        const { ref: ref, ...restTriggerProps } = triggerProps;
        return CustomTrigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CustomTrigger, {
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Vosf.MenuTriggerButton), {
            ...(0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
                name: projectName
            } : {},
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-start",
        messageId: "navigation-project-action-menu.ui.menu-container.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: // eslint-disable-next-line no-nested-ternary
        (0, $6zXPf.getWillShowNav4)() ? route.name.includes('legacy') ? false : shouldRenderToParent : true,
        strategy: (0, $6zXPf.getWillShowNav4)() ? 'absolute' : 'fixed'
    });
};

});
parcelRegister("he6m3", function(module, exports) {

$parcel$export(module.exports, "useOpenable", () => $40c5fa9f2d8d08c0$export$e07f550759260fd7);

var $eJOHy = parcelRequire("eJOHy");
const $40c5fa9f2d8d08c0$export$e07f550759260fd7 = (initialState = false)=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(initialState);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $eJOHy.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    const onToggle = (0, $eJOHy.useCallback)(()=>setIsOpen((value)=>!value), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen,
        onToggle: onToggle,
        setIsOpen: setIsOpen
    };
};

});

parcelRegister("6Vosf", function(module, exports) {

$parcel$export(module.exports, "MenuTriggerButton", () => $dda383502f47ef3e$export$a24e6f6ddd974e33);

var $eJOHy = parcelRequire("eJOHy");

var $NByNW = parcelRequire("NByNW");

var $Ay1uj = parcelRequire("Ay1uj");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $c5ZPx = parcelRequire("c5ZPx");
const $dda383502f47ef3e$export$a24e6f6ddd974e33 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                ...iconProps,
                color: "var(--ds-icon, #44546F)",
                size: "small"
            }),
        label: (0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar') ? formatMessage((0, $c5ZPx.default).projectActionsMenuName, {
            name: name
        }) : formatMessage((0, $c5ZPx.default).projectActionsMenu),
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle",
        testId: "navigation-project-action-menu.ui.menu-container.themed-button",
        ...(0, $6XJko.isVisualRefreshEnabled)() ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $c5ZPx.default).projectActionsMenu),
                hideTooltipOnClick: true
            }
        } : {}
    });
});

});
parcelRegister("c5ZPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c00dd7908288fb54$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c00dd7908288fb54$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectActionsMenu: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu",
        "defaultMessage": "More actions"
    },
    projectActionsMenuName: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu-name",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("gcYED", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $8d45d921416e6533$export$8f31e4c4a37b8e9c);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");
var $2bMVP = parcelRequire("2bMVP");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $5Q9JR = parcelRequire("5Q9JR");
const $8d45d921416e6533$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8d45d921416e6533$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
        minWidth: (0, $5Q9JR.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $8d45d921416e6533$var$projectTileSkeleton
    }))));
const $8d45d921416e6533$var$wrapperStyles = (0, $1DXK0.xcss)({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $5Q9JR.MENU_GROUP_MIN_WIDTH)}px`
});
const $8d45d921416e6533$var$projectTileSkeleton = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-600, 48px)",
    flex: 1
});

});
parcelRegister("5Q9JR", function(module, exports) {

$parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", () => $15777f70405f0cfb$export$47f3715a07cde7e8);
$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $15777f70405f0cfb$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "GLOBAL_APP_MENU_IDS_AS_STRINGS", () => $15777f70405f0cfb$export$de634ec0f98ab74b);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", () => $15777f70405f0cfb$export$6a976dc7193b8a18);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_AND_ICON_MAP", () => $15777f70405f0cfb$export$5034ad0032cd499d);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING", () => $15777f70405f0cfb$export$b66ae8c18ec95bc6);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING", () => $15777f70405f0cfb$export$da92a6698d96e3f2);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $15777f70405f0cfb$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $15777f70405f0cfb$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $15777f70405f0cfb$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $15777f70405f0cfb$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $15777f70405f0cfb$export$89de709e88232646);

var $m9SlP = parcelRequire("m9SlP");

var $bGbhe = parcelRequire("bGbhe");

var $cYbWd = parcelRequire("cYbWd");

var $i5stJ = parcelRequire("i5stJ");

var $5SdQs = parcelRequire("5SdQs");

var $KDB2z = parcelRequire("KDB2z");

var $iBgxn = parcelRequire("iBgxn");

var $9qes7 = parcelRequire("9qes7");

var $gGrKE = parcelRequire("gGrKE");

var $3XKBx = parcelRequire("3XKBx");

var $8IWdQ = parcelRequire("8IWdQ");

var $5gg6I = parcelRequire("5gg6I");

var $jMxiN = parcelRequire("jMxiN");

var $a9xgI = parcelRequire("a9xgI");

var $9kug7 = parcelRequire("9kug7");

var $lmJ87 = parcelRequire("lmJ87");

var $l5gdO = parcelRequire("l5gdO");

var $aaIe7 = parcelRequire("aaIe7");

var $eALjj = parcelRequire("eALjj");

var $gNUuP = parcelRequire("gNUuP");

var $3MZ1E = parcelRequire("3MZ1E");

var $gHGhi = parcelRequire("gHGhi");

var $i2pAY = parcelRequire("i2pAY");

var $iePme = parcelRequire("iePme");

var $h4Bzb = parcelRequire("h4Bzb");

var $hpiqf = parcelRequire("hpiqf");

var $hEgdr = parcelRequire("hEgdr");

var $8IuE5 = parcelRequire("8IuE5");
const $15777f70405f0cfb$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $15777f70405f0cfb$export$d57b6b390e78d90f = 'jira-cosmos';
const $15777f70405f0cfb$export$47f3715a07cde7e8 = 250;
const $15777f70405f0cfb$export$421b92818c76ee2d = Object.values((0, $h4Bzb.CONFIGURABLE_MENU_ID));
const $15777f70405f0cfb$export$f5a7bd7eb586e4e8 = $15777f70405f0cfb$export$421b92818c76ee2d;
const $15777f70405f0cfb$export$c52c93cc28495ab0 = Object.values((0, $h4Bzb.GLOBAL_APP_MENU_ID));
const $15777f70405f0cfb$export$de634ec0f98ab74b = $15777f70405f0cfb$export$c52c93cc28495ab0;
const $15777f70405f0cfb$export$6a976dc7193b8a18 = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: {
        message: (0, $hEgdr.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bGbhe)))
    },
    [(0, $8IuE5.L1_MENU_ID).GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9qes7)))
    },
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: {
        message: (0, $hEgdr.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($m9SlP)))
    },
    [(0, $8IuE5.L1_MENU_ID).PLANS]: {
        message: (0, $hEgdr.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($l5gdO)))
    },
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: {
        message: (0, $hEgdr.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lmJ87)))
    },
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: {
        message: (0, $hEgdr.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z)))
    },
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $hEgdr.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5SdQs)))
    },
    [(0, $8IuE5.L1_MENU_ID).COMMUNICATION]: {
        message: (0, $hEgdr.default).communication,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iePme)))
    },
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $hEgdr.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBgxn)))
    },
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: {
        message: (0, $hEgdr.default).operations,
        Icon: (0, $hpiqf.default)
    },
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cYbWd)))
    },
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eALjj)))
    },
    [(0, $8IuE5.L1_MENU_ID).RECENT]: {
        message: (0, $hEgdr.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i5stJ)))
    },
    [(0, $8IuE5.L1_MENU_ID).STARRED]: {
        message: (0, $hEgdr.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $hEgdr.default).customerService,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gGrKE)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $hEgdr.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3XKBx)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $hEgdr.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i2pAY)))
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (0, $3MZ1E.AssetsIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (0, $gHGhi.GoalsIcon)
    },
    // App Shortcuts for Platform Component
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $hEgdr.default).confluence,
        Icon: (0, $8IWdQ.ConfluenceIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $hEgdr.default).loom,
        Icon: (0, $5gg6I.LoomIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $hEgdr.default).projects,
        Icon: (0, $a9xgI.ProjectsIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (0, $jMxiN.TeamsIcon)
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $hEgdr.default).opsgenie,
        Icon: (0, $9kug7.OpsgenieIcon)
    }
};
const $15777f70405f0cfb$export$5034ad0032cd499d = {
    message: (0, $hEgdr.default).forYou,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNUuP)))
};
const $15777f70405f0cfb$export$b66ae8c18ec95bc6 = {
    message: (0, $hEgdr.default).forYou.defaultMessage
};
const $15777f70405f0cfb$export$da92a6698d96e3f2 = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: {
        message: (0, $hEgdr.default).apps.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GOALS]: {
        message: (0, $hEgdr.default).goals.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: {
        message: (0, $hEgdr.default).roadmaps.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).PLANS]: {
        message: (0, $hEgdr.default).plans.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: {
        message: (0, $hEgdr.default).projects.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: {
        message: (0, $hEgdr.default).filters.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $hEgdr.default).dashboards.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $hEgdr.default).overviews.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).COMMUNICATION]: {
        message: (0, $hEgdr.default).communication.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: {
        message: (0, $hEgdr.default).operations.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: {
        message: (0, $hEgdr.default).assets.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: {
        message: (0, $hEgdr.default).teams.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).RECENT]: {
        message: (0, $hEgdr.default).recent.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).STARRED]: {
        message: (0, $hEgdr.default).starred.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $hEgdr.default).customerService.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $hEgdr.default).customerHubs.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $hEgdr.default).customerServiceAnalytics.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $hEgdr.default).assets.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $hEgdr.default).goals.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $hEgdr.default).confluence.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $hEgdr.default).loom.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $hEgdr.default).projects.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $hEgdr.default).teams.defaultMessage
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $hEgdr.default).opsgenie.defaultMessage
    }
};
const $15777f70405f0cfb$export$9fcc53f3b36e0949 = 240; // in pixels
const $15777f70405f0cfb$export$6621cd553335536a = 320; // in pixels
const $15777f70405f0cfb$export$2eb8dda9e83d33ff = false;
const $15777f70405f0cfb$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $15777f70405f0cfb$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $15777f70405f0cfb$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $15777f70405f0cfb$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $15777f70405f0cfb$export$89de709e88232646 = 25;

});
parcelRegister("hpiqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb87aad819ab5509$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9mydb = parcelRequire("9mydb");

var $2HwUT = parcelRequire("2HwUT");

var $7jTnu = parcelRequire("7jTnu");
const $fb87aad819ab5509$var$OperationsIcon = ({ ...props })=>{
    if ((0, $7jTnu.fg)('nav4_operations_icon_update')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9mydb))), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2HwUT))), props);
};
var $fb87aad819ab5509$export$2e2bcd8739ae039 = $fb87aad819ab5509$var$OperationsIcon;

});

parcelRegister("hEgdr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc397343fd47548$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bcc397343fd47548$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    overviews: {
        "id": "navigation-apps-sidebar-nav4-common.common.overviews",
        "defaultMessage": "Overviews"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    },
    customerService: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-service",
        "defaultMessage": "Customer service"
    },
    customerHubs: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-hubs",
        "defaultMessage": "Customer hubs"
    },
    customerServiceAnalytics: {
        "id": "navigation-apps-sidebar-nav4-common.common.customerServiceAnalytics",
        "defaultMessage": "Insights"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-common.common.forYou",
        "defaultMessage": "For you"
    },
    confluence: {
        "id": "navigation-apps-sidebar-nav4-common.common.confluence",
        "defaultMessage": "Confluence"
    },
    loom: {
        "id": "navigation-apps-sidebar-nav4-common.common.loom",
        "defaultMessage": "Loom"
    },
    opsgenie: {
        "id": "navigation-apps-sidebar-nav4-common.common.opsgenie",
        "defaultMessage": "Opsgenie"
    },
    communication: {
        "id": "navigation-apps-sidebar-nav4-common.common.communication",
        "defaultMessage": "Communications"
    }
});

});

parcelRegister("8IuE5", function(module, exports) {

$parcel$export(module.exports, "L1_MENU_ID", () => $63cd73d0cb684b2a$export$918aea3cf024d90b);

var $h4Bzb = parcelRequire("h4Bzb");
const $63cd73d0cb684b2a$var$OPERATIONS_MENU_ID = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $63cd73d0cb684b2a$export$bb47524d7f3cb1f8 = {
    ...(0, $h4Bzb.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $63cd73d0cb684b2a$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $h4Bzb.CONFIGURABLE_MENU_ID),
    ...$63cd73d0cb684b2a$var$OPERATIONS_MENU_ID
};

});




parcelRegister("ce73j", function(module, exports) {

$parcel$export(module.exports, "default", () => $fac621ca9c21a200$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fac621ca9c21a200$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectSettings: {
        "id": "navigation-project-action-menu.project-settings",
        "defaultMessage": "Project settings"
    },
    moreActions: {
        "id": "navigation-project-action-menu.more-actions",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("fRoln", function(module, exports) {

$parcel$export(module.exports, "ThemePicker", () => $836e6cd8f8305bee$export$75505f096a733fb9);

var $eJOHy = parcelRequire("eJOHy");

var $cNe2t = parcelRequire("cNe2t");

var $3osLr = parcelRequire("3osLr");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $8Uqf3 = parcelRequire("8Uqf3");

var $bILK0 = parcelRequire("bILK0");

var $7qGN1 = parcelRequire("7qGN1");

var $6z8y4 = parcelRequire("6z8y4");

var $hih5V = parcelRequire("hih5V");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $96Zbc = parcelRequire("96Zbc");

var $kEUB1 = parcelRequire("kEUB1");

var $55gll = parcelRequire("55gll");

var $1dbbB = parcelRequire("1dbbB");

var $j2Sb8 = parcelRequire("j2Sb8");

var $5f6Mn = parcelRequire("5f6Mn");

var $lAf34 = parcelRequire("lAf34");

var $jh6EV = parcelRequire("jh6EV");
const $836e6cd8f8305bee$var$SOURCE_NAME = 'projectThemePicker';
const $836e6cd8f8305bee$var$messages = (0, $7qGN1.defineMessages)({
    errorFlagTitle: {
        "id": "business-theme-components.theme-picker.error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    errorFlagDescription: {
        "id": "business-theme-components.theme-picker.error-flag-description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
    }
});
const $836e6cd8f8305bee$export$bb0d35c1fc48487f = {
    id: 'open-theme-picker-error',
    type: 'error',
    title: $836e6cd8f8305bee$var$messages.errorFlagTitle,
    description: $836e6cd8f8305bee$var$messages.errorFlagDescription,
    isAutoDismiss: true,
    messageId: 'project-theme-components.ui.theme-picker.popup-entrypoint-error-flag.error.open-theme-picker-error',
    messageType: 'transactional'
};
const $836e6cd8f8305bee$export$75505f096a733fb9 = /*#__PURE__*/ (0, $eJOHy.memo)(({ projectId: projectId, withAdaptiveColorTheme: withAdaptiveColorTheme, shouldRenderToParent: shouldRenderToParent = true })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const route = (0, $hih5V.useCurrentRoute)();
    const projectAri = (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $lAf34.backgroundPickerPopupContentEntryPoint), (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectAri: projectAri
        }), [
        cloudId,
        projectAri
    ]));
    const startExperience = (0, $8Uqf3.useExperienceStart)((0, $55gll.VIEW_THEME_PICKER_EXPERIENCE));
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const [flagShown, setFlagShown] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isThemePickerOpen, setIsThemePickerOpen] = (0, $eJOHy.useState)(false);
    const toggleThemePicker = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_, analyticsEvent)=>{
        // If we are about to open the theme picker, start the experience
        if (!isThemePickerOpen) startExperience();
        setIsThemePickerOpen((oldValue)=>!oldValue);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent ?? createAnalyticsEvent({}), 'button clicked', 'themePickerButton');
        setFlagShown(false);
    }, [
        isThemePickerOpen,
        startExperience,
        setIsThemePickerOpen,
        createAnalyticsEvent
    ]);
    const renderNudgeWrapper = (0, $eJOHy.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $96Zbc.BackgroundColourNudgeAsync), null, children), []);
    const buttonTrigger = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isThemePickerOpen);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            onOpenChange: setIsThemePickerOpen,
            withAdaptiveColorTheme: withAdaptiveColorTheme
        }), [
        setIsThemePickerOpen,
        withAdaptiveColorTheme
    ]);
    const trigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5f6Mn.ThemePickerButtonItem), {
            ...triggerProps,
            isSelected: isThemePickerOpen,
            testId: "project-theme-components.ui.theme-picker.trigger",
            ref: (element)=>{
                buttonTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            onClick: toggleThemePicker
        }), [
        buttonTrigger,
        isThemePickerOpen,
        toggleThemePicker
    ]);
    const errorFallback = (0, $eJOHy.useCallback)(({ error: error })=>{
        if (!flagShown) {
            showFlag($836e6cd8f8305bee$export$bb0d35c1fc48487f);
            setFlagShown(true);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1dbbB.ExperienceFailed), {
            experience: (0, $55gll.VIEW_THEME_PICKER_EXPERIENCE),
            error: error
        });
    }, [
        flagShown,
        showFlag
    ]);
    const content = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "background-picker-popup-content",
            packageName: "@atlassian/jira-project-theme-components",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jh6EV.ThemePickerSkeleton), null),
            errorFallback: errorFallback,
            runtimeProps: runtimeProps
        }), [
        errorFallback,
        entryPointReferenceSubject,
        runtimeProps
    ]);
    const onCloseHandler = (0, $eJOHy.useCallback)(()=>setIsThemePickerOpen(false), [
        setIsThemePickerOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6z8y4.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: $836e6cd8f8305bee$var$SOURCE_NAME,
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isThemePickerOpen,
        onClose: onCloseHandler,
        shouldRenderToParent: route.name.includes('legacy') ? false : shouldRenderToParent,
        content: content,
        trigger: trigger,
        placement: "right-start",
        id: (0, $j2Sb8.THEME_PICKER_ELEMENT_ID),
        messageId: "project-theme-components.ui.theme-picker.popup.theme-picker",
        messageType: "transactional"
    })));
});

});
parcelRegister("6z8y4", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $0e38737f31212e98$export$bd61ee610c74db6c);

var $eJOHy = parcelRequire("eJOHy");

var $keu3i = parcelRequire("keu3i");

var $dZidf = parcelRequire("dZidf");
const $0e38737f31212e98$export$bd61ee610c74db6c = (0, $dZidf.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $keu3i.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
});

});
parcelRegister("keu3i", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $80a581cbcefc9920$export$7212b6b01271f5d1);

var $eJOHy = parcelRequire("eJOHy");

var $cUxaS = parcelRequire("cUxaS");
const $80a581cbcefc9920$var$TIMEOUT = 500;
const $80a581cbcefc9920$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $eJOHy.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $cUxaS.useLeftSidebarState)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $80a581cbcefc9920$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("cUxaS", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $2ce27f19e394981e$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $2ce27f19e394981e$export$900f29014a48fb23);

var $eJOHy = parcelRequire("eJOHy");

var $dzLcO = parcelRequire("dzLcO");

var $iJq0l = parcelRequire("iJq0l");

var $fZsy4 = parcelRequire("fZsy4");
const $2ce27f19e394981e$var$useSweetStateLeftSidebarState = (0, $iJq0l.createHook)((0, $fZsy4.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $2ce27f19e394981e$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $2ce27f19e394981e$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $2ce27f19e394981e$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $dzLcO.usePageLayoutResize)();
    return (0, $eJOHy.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("dzLcO", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $599f2c8065b963c5$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $599f2c8065b963c5$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $599f2c8065b963c5$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $599f2c8065b963c5$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebar", () => $599f2c8065b963c5$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $599f2c8065b963c5$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $599f2c8065b963c5$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $599f2c8065b963c5$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $599f2c8065b963c5$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $599f2c8065b963c5$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $599f2c8065b963c5$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $599f2c8065b963c5$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $599f2c8065b963c5$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $599f2c8065b963c5$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $599f2c8065b963c5$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $599f2c8065b963c5$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $599f2c8065b963c5$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $599f2c8065b963c5$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dwrVI = parcelRequire("dwrVI");
var $MH11l = parcelRequire("MH11l");
var $4ETgJ = parcelRequire("4ETgJ");
var $57Dtq = parcelRequire("57Dtq");
var $dCyxH = parcelRequire("dCyxH");
var $d4u9R = parcelRequire("d4u9R");
var $gL49i = parcelRequire("gL49i");
var $kqCKo = parcelRequire("kqCKo");
var $016Wa = parcelRequire("016Wa");
var $c4lEJ = parcelRequire("c4lEJ");
var $gm5Vk = parcelRequire("gm5Vk");
var $8Qi2K = parcelRequire("8Qi2K");

var $1AIob = parcelRequire("1AIob");
var $cQCzs = parcelRequire("cQCzs");
var $dh7KV = parcelRequire("dh7KV");
var $lQuPF = parcelRequire("lQuPF");
var $4ZYlE = parcelRequire("4ZYlE");
var $9Qwez = parcelRequire("9Qwez");
var $7zHjm = parcelRequire("7zHjm");

var $6zXPf = parcelRequire("6zXPf");
function $599f2c8065b963c5$export$6d1402fb58384e4f(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ZYlE.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gL49i.default), props);
}
function $599f2c8065b963c5$export$3b4e64e77073e307(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cQCzs.Banner), {
        height: props.height,
        testId: props.testId,
        id: props.id
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dwrVI.default), props);
}
function $599f2c8065b963c5$export$8a421bddecb2bf5b(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7zHjm.TopNav), {
        height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4lEJ.default), props);
}
function $599f2c8065b963c5$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $6zXPf.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ETgJ.default), props);
}
function $599f2c8065b963c5$export$43ae342508cf8cc9(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Qwez.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dCyxH.default), props);
}
function $599f2c8065b963c5$export$3cabf771c4f2de(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Qwez.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $57Dtq.default), props);
}
function $599f2c8065b963c5$export$861edd1ccea2f746(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dh7KV.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d4u9R.default), props);
}
function $599f2c8065b963c5$export$7c6e2c02157bb7d2(props) {
    return (0, $6zXPf.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MH11l.default), props);
}
function $599f2c8065b963c5$export$84d58c19c21f637f(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AIob.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $016Wa.default), props);
}
function $599f2c8065b963c5$export$364a989a35814102(props) {
    return (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lQuPF.Panel), {
        xcss: $599f2c8065b963c5$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kqCKo.default), props);
}
const $599f2c8065b963c5$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $6zXPf.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gm5Vk.useCustomSkipLink)(id, title, index);
const $599f2c8065b963c5$export$94561f6055639ef7 = ()=>(0, $6zXPf.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8Qi2K.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $599f2c8065b963c5$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $599f2c8065b963c5$export$10c7104037a7af62 = ()=>(0, $6zXPf.getWillShowNav4)() ? $599f2c8065b963c5$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8Qi2K.usePageLayoutResize)();
const $599f2c8065b963c5$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $599f2c8065b963c5$export$991ef8098f87814a = (0, $7326b3b2ac0b6dee$export$ed7cc0d417ee89e);
const $599f2c8065b963c5$export$7eaf986ecb4d5cac = (0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd);
const $599f2c8065b963c5$export$e95b388ca8c92019 = (0, $7326b3b2ac0b6dee$export$f897e1ed9f8ed251);
const $599f2c8065b963c5$export$2ab8b83eed76656c = (0, $7326b3b2ac0b6dee$export$750459958906793);
const $599f2c8065b963c5$export$ac017575d43f5da = (0, $7326b3b2ac0b6dee$export$b44ab66843c05a69);
const $599f2c8065b963c5$export$d697087c06fd5e25 = (0, $7326b3b2ac0b6dee$export$aeff86a16f13529);

});
parcelRegister("dwrVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $525c4887a338725b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $lHwek = parcelRequire("lHwek");

var $5OLbt = parcelRequire("5OLbt");
var $6iDQ8 = parcelRequire("6iDQ8");

var $f4uL3 = parcelRequire("f4uL3");

var $bJSJd = parcelRequire("bJSJd");
const $525c4887a338725b$var$bannerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $7326b3b2ac0b6dee$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $7326b3b2ac0b6dee$export$238d30785c4bca84)
});
const $525c4887a338725b$var$bannerFixedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $7326b3b2ac0b6dee$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $525c4887a338725b$var$Banner = (props)=>{
    const { children: children, height: height = (0, $7326b3b2ac0b6dee$export$be83e7118304b28e), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $lHwek.resolveDimension)((0, $7326b3b2ac0b6dee$export$bcd94a6a792e7f96), height, shouldPersistHeight);
    (0, $eJOHy.useEffect)(()=>{
        (0, $5OLbt.default)({
            [(0, $7326b3b2ac0b6dee$export$bcd94a6a792e7f96)]: bannerHeight
        });
        return ()=>{
            (0, $5OLbt.default)({
                [(0, $7326b3b2ac0b6dee$export$bcd94a6a792e7f96)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $6iDQ8.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $f4uL3.default), null, ({ className: className })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                $525c4887a338725b$var$bannerStyles,
                isFixed && $525c4887a338725b$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $lHwek.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bJSJd.default), {
            variableName: (0, $7326b3b2ac0b6dee$export$bcd94a6a792e7f96),
            value: bannerHeight
        }), children));
};
var $525c4887a338725b$export$2e2bcd8739ae039 = $525c4887a338725b$var$Banner;

});
// dimension vars
const $7326b3b2ac0b6dee$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $7326b3b2ac0b6dee$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $7326b3b2ac0b6dee$export$c103b605cd368aed = 'rightSidebarWidth';
const $7326b3b2ac0b6dee$export$fa34f417972d6341 = 'rightPanelWidth';
const $7326b3b2ac0b6dee$export$3a6a779d9181047c = 'topNavigationHeight';
const $7326b3b2ac0b6dee$export$bcd94a6a792e7f96 = 'bannerHeight';
const $7326b3b2ac0b6dee$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $7326b3b2ac0b6dee$export$344062f7cfc9528e = 'left-panel';
const $7326b3b2ac0b6dee$export$c7139cc2d6110b5f = 'right-panel';
const $7326b3b2ac0b6dee$export$238d30785c4bca84 = 'banner';
const $7326b3b2ac0b6dee$export$bec6dca2e63de4ae = 'top-navigation';
const $7326b3b2ac0b6dee$export$d1213e82613ff4df = 'content';
const $7326b3b2ac0b6dee$export$be83e7118304b28e = 56;
const $7326b3b2ac0b6dee$export$4a98ee0bd1ae362 = 56;
const $7326b3b2ac0b6dee$export$539e68c09584883a = 240;
const $7326b3b2ac0b6dee$export$b92df8810d2fcd01 = 280;
const $7326b3b2ac0b6dee$export$c3e41153b9288bcf = 368;
const $7326b3b2ac0b6dee$export$c4d6152f86ea28f6 = 368;
const $7326b3b2ac0b6dee$export$46acf8758e9e2636 = 20;
const $7326b3b2ac0b6dee$export$70740f5ad8360a78 = 16;
const $7326b3b2ac0b6dee$export$991d5285ad765a3d = 240;
const $7326b3b2ac0b6dee$export$6949d4f32b161684 = 200;
const $7326b3b2ac0b6dee$export$d6e7e8af042815bb = 350;
const $7326b3b2ac0b6dee$export$3749e1104328fde4 = 300;
const $7326b3b2ac0b6dee$export$1074d925b0b82be5 = 200;
const $7326b3b2ac0b6dee$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $7326b3b2ac0b6dee$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $7326b3b2ac0b6dee$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $7326b3b2ac0b6dee$export$70c702a8c5895f03 = 'data-grab-area-line';
const $7326b3b2ac0b6dee$export$48a43f91e4becf4e = 'data-grab-area';
const $7326b3b2ac0b6dee$export$dac2fb31a9f6844d = 'data-resize-button';
const $7326b3b2ac0b6dee$export$9ecd22db14e6c70e = 'data-resize-control';
const $7326b3b2ac0b6dee$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $7326b3b2ac0b6dee$export$206a08f7f8beb554 = 'Skip to:';
const $7326b3b2ac0b6dee$export$659ee746b31b360d = 'data-layout-container';
const $7326b3b2ac0b6dee$export$f963aecf2d4465bd = `var(--${$7326b3b2ac0b6dee$export$cbfb0f5b2869b17b}, 0px)`;
const $7326b3b2ac0b6dee$export$750459958906793 = `var(--${$7326b3b2ac0b6dee$export$fa34f417972d6341}, 0px)`;
const $7326b3b2ac0b6dee$export$f897e1ed9f8ed251 = `var(--${$7326b3b2ac0b6dee$export$a30f2e00489a8957}, 0px)`;
const $7326b3b2ac0b6dee$export$b44ab66843c05a69 = `var(--${$7326b3b2ac0b6dee$export$c103b605cd368aed}, 0px)`;
const $7326b3b2ac0b6dee$export$aeff86a16f13529 = `var(--${$7326b3b2ac0b6dee$export$3a6a779d9181047c}, 0px)`;
const $7326b3b2ac0b6dee$export$ed7cc0d417ee89e = `var(--${$7326b3b2ac0b6dee$export$bcd94a6a792e7f96}, 0px)`;
const $7326b3b2ac0b6dee$export$d2fa14f05b61e66 = `var(--${$7326b3b2ac0b6dee$export$b6744d31294864fd}, ${$7326b3b2ac0b6dee$export$991d5285ad765a3d}px)`;

parcelRegister("lHwek", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $c71025ec7c105ce7$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $c71025ec7c105ce7$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $c71025ec7c105ce7$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $c71025ec7c105ce7$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $c71025ec7c105ce7$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $c71025ec7c105ce7$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $c71025ec7c105ce7$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $c71025ec7c105ce7$export$218ece2c32b7db0e);


var $knK15 = parcelRequire("knK15");
const $c71025ec7c105ce7$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $knK15.default)().getItem((0, $7326b3b2ac0b6dee$export$451e84a45a9e4a75)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $knK15.default)().setItem((0, $7326b3b2ac0b6dee$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $c71025ec7c105ce7$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $knK15.default)().getItem((0, $7326b3b2ac0b6dee$export$451e84a45a9e4a75)) || '{}');
    return storageValue[key];
};
const $c71025ec7c105ce7$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $knK15.default)().getItem((0, $7326b3b2ac0b6dee$export$451e84a45a9e4a75)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $knK15.default)().setItem((0, $7326b3b2ac0b6dee$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $c71025ec7c105ce7$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $c71025ec7c105ce7$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $c71025ec7c105ce7$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)}`), 10) || 0;
};
const $c71025ec7c105ce7$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $7326b3b2ac0b6dee$export$539e68c09584883a)) / (maxWidth - (0, $7326b3b2ac0b6dee$export$539e68c09584883a));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $c71025ec7c105ce7$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $7326b3b2ac0b6dee$export$5253dd9707b8c3ba)]: slotName
    });
const $c71025ec7c105ce7$export$218ece2c32b7db0e = (slotName)=>`[${0, $7326b3b2ac0b6dee$export$5253dd9707b8c3ba}='${slotName}']`;

});
parcelRegister("knK15", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b5b04d7bf48d1c$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $c6b5b04d7bf48d1c$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $c6b5b04d7bf48d1c$var$safeLocalStorage = ()=>{
    if ($c6b5b04d7bf48d1c$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $c6b5b04d7bf48d1c$export$2e2bcd8739ae039 = $c6b5b04d7bf48d1c$var$safeLocalStorage;

});


parcelRegister("5OLbt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5822d7464b26ec74$export$2e2bcd8739ae039);

var $lHwek = parcelRequire("lHwek");
const $5822d7464b26ec74$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $lHwek.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $lHwek.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $5822d7464b26ec74$export$2e2bcd8739ae039 = $5822d7464b26ec74$var$publishGridState;

});

parcelRegister("6iDQ8", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $2c45fd90828da84d$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $2c45fd90828da84d$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $2c45fd90828da84d$export$89d9323301efc7d6);

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");
const $2c45fd90828da84d$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $eJOHy.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $3Vuhz.default),
    unregisterSkipLink: (0, $3Vuhz.default)
});
const $2c45fd90828da84d$export$c9d9cb2ee9590f87 = ()=>(0, $eJOHy.useContext)($2c45fd90828da84d$export$4c5cc3b14c7678a);
const $2c45fd90828da84d$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $2c45fd90828da84d$export$c9d9cb2ee9590f87();
    (0, $eJOHy.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("f4uL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d515994db3b7865$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

const $7d515994db3b7865$var$focusStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $7d515994db3b7865$var$sidebarFocusStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $7d515994db3b7865$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1NIU8.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($7d515994db3b7865$var$sidebarFocusStyles) : css($7d515994db3b7865$var$focusStyles)
        }));
};
var $7d515994db3b7865$export$2e2bcd8739ae039 = $7d515994db3b7865$var$SlotFocusRing;

});
var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';


parcelRegister("bJSJd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d90ad87fc94df85$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6efFi = parcelRequire("6efFi");
/**
 * Hoists slot dimension styles to the root element.
 */ const $1d90ad87fc94df85$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $6efFi.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)("style", {
        children: style
    }));
};
var $1d90ad87fc94df85$export$2e2bcd8739ae039 = $1d90ad87fc94df85$var$SlotDimensions;

});


parcelRegister("MH11l", function(module, exports) {

$parcel$export(module.exports, "default", () => $26e8e3621a2da4bf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

const $26e8e3621a2da4bf$var$contentStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $7326b3b2ac0b6dee$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $26e8e3621a2da4bf$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": testId,
        css: $26e8e3621a2da4bf$var$contentStyles
    }, children);
};
var $26e8e3621a2da4bf$export$2e2bcd8739ae039 = $26e8e3621a2da4bf$var$Content;

});

parcelRegister("4ETgJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7836597591c7494a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $lHwek = parcelRequire("lHwek");

var $5OLbt = parcelRequire("5OLbt");
var $6iDQ8 = parcelRequire("6iDQ8");

var $f4uL3 = parcelRequire("f4uL3");

var $bJSJd = parcelRequire("bJSJd");
const $7836597591c7494a$var$leftPanelStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $7326b3b2ac0b6dee$export$344062f7cfc9528e)
});
const $7836597591c7494a$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $7836597591c7494a$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $7326b3b2ac0b6dee$export$c4d6152f86ea28f6), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $lHwek.resolveDimension)((0, $7326b3b2ac0b6dee$export$cbfb0f5b2869b17b), width, shouldPersistWidth);
    (0, $eJOHy.useEffect)(()=>{
        (0, $5OLbt.default)({
            [(0, $7326b3b2ac0b6dee$export$cbfb0f5b2869b17b)]: leftPanelWidth
        });
        return ()=>{
            (0, $5OLbt.default)({
                [(0, $7326b3b2ac0b6dee$export$cbfb0f5b2869b17b)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $6iDQ8.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $f4uL3.default), null, ({ className: className })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                $7836597591c7494a$var$leftPanelStyles,
                isFixed && $7836597591c7494a$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $lHwek.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bJSJd.default), {
            variableName: (0, $7326b3b2ac0b6dee$export$cbfb0f5b2869b17b),
            value: leftPanelWidth
        }), children));
};
var $7836597591c7494a$export$2e2bcd8739ae039 = $7836597591c7494a$var$LeftPanel;

});

parcelRegister("57Dtq", function(module, exports) {

$parcel$export(module.exports, "default", () => $628102a282bb545a$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $eRny2 = parcelRequire("eRny2");


var $3FUYM = parcelRequire("3FUYM");



var $lHwek = parcelRequire("lHwek");

var $5OLbt = parcelRequire("5OLbt");
var $8Qi2K = parcelRequire("8Qi2K");
var $6iDQ8 = parcelRequire("6iDQ8");

var $l3kTr = parcelRequire("l3kTr");

var $1OxvL = parcelRequire("1OxvL");

var $g5yc0 = parcelRequire("g5yc0");

var $hip7q = parcelRequire("hip7q");

var $bJSJd = parcelRequire("bJSJd");
const $628102a282bb545a$var$openBackdropStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $7bb4c1736002a04a$export$486ab785e4bac3c6)})`,
    opacity: 1
});
const $628102a282bb545a$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $7326b3b2ac0b6dee$export$3749e1104328fde4)}ms ${(0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $628102a282bb545a$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $eJOHy.useRef)();
    const mouseOverEventRef = (0, $eJOHy.useRef)();
    const leftSideBarRef = (0, $eJOHy.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $eJOHy.useContext)((0, $8Qi2K.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, hasInit: hasInit } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $eJOHy.useRef)(isLocked);
    const mouseXRef = (0, $eJOHy.useRef)(0);
    const handlerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $7326b3b2ac0b6dee$export$539e68c09584883a));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $lHwek.resolveDimension)((0, $7326b3b2ac0b6dee$export$b6744d31294864fd), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $7326b3b2ac0b6dee$export$46acf8758e9e2636);
    else leftSidebarWidthOnMount = (0, $lHwek.resolveDimension)((0, $7326b3b2ac0b6dee$export$a30f2e00489a8957), _width, !width || !collapsedStateOverrideOpen && (0, $lHwek.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $eJOHy.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $lHwek.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $lHwek.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $7326b3b2ac0b6dee$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $7326b3b2ac0b6dee$export$b6744d31294864fd], (0, $7326b3b2ac0b6dee$export$539e68c09584883a)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $7326b3b2ac0b6dee$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $7326b3b2ac0b6dee$export$b6744d31294864fd], (0, $7326b3b2ac0b6dee$export$539e68c09584883a)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $7326b3b2ac0b6dee$export$46acf8758e9e2636);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed,
            hasInit: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $5OLbt.default)({
                [(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $7326b3b2ac0b6dee$export$b6744d31294864fd)]: lastLeftSidebarWidth
            });
            (0, $lHwek.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $7326b3b2ac0b6dee$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $7326b3b2ac0b6dee$export$dac2fb31a9f6844d)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $7326b3b2ac0b6dee$export$1074d925b0b82be5));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $6iDQ8.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $7326b3b2ac0b6dee$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $7326b3b2ac0b6dee$export$dac2fb31a9f6844d)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $7326b3b2ac0b6dee$export$1074d925b0b82be5));
    };
    const mobileMediaQuery = (0, $3FUYM.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $eJOHy.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $eJOHy.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $3FUYM.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $7326b3b2ac0b6dee$export$46acf8758e9e2636),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $7326b3b2ac0b6dee$export$539e68c09584883a)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $eRny2.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    /**
   * We use both the state and our effect-based ref to protect animation until initialized fully
   */ const isReady = hasInit && notFirstRun.current;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $628102a282bb545a$var$hiddenBackdropStyles,
            isFlyoutOpen && $628102a282bb545a$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $g5yc0.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bJSJd.default), {
        variableName: (0, $7326b3b2ac0b6dee$export$a30f2e00489a8957),
        value: isReady ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $7326b3b2ac0b6dee$export$70740f5ad8360a78)
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1OxvL.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hip7q.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !isReady && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $l3kTr.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $628102a282bb545a$export$2e2bcd8739ae039 = $628102a282bb545a$var$LeftSidebar;

});
const $eeb70e8c0a60dc66$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eeb70e8c0a60dc66$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eeb70e8c0a60dc66$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eeb70e8c0a60dc66$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

parcelRegister("8Qi2K", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $a0bc8bfcc4417665$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $a0bc8bfcc4417665$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $a0bc8bfcc4417665$export$94561f6055639ef7);

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");
const $a0bc8bfcc4417665$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $a0bc8bfcc4417665$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $3Vuhz.default),
    collapseLeftSidebar: (0, $3Vuhz.default),
    leftSidebarState: $a0bc8bfcc4417665$var$leftSidebarState,
    setLeftSidebarState: (0, $3Vuhz.default),
    toggleLeftSidebar: (0, $3Vuhz.default)
});
const $a0bc8bfcc4417665$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $eJOHy.useContext)($a0bc8bfcc4417665$export$aa5a712eea4c2ae8);
    return context;
};
const $a0bc8bfcc4417665$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $eJOHy.useContext)($a0bc8bfcc4417665$export$aa5a712eea4c2ae8);
    (0, $eJOHy.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("l3kTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $05636d957534b768$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $4eDgu = parcelRequire("4eDgu");

var $bRPNB = parcelRequire("bRPNB");

var $3FUYM = parcelRequire("3FUYM");


var $lHwek = parcelRequire("lHwek");

var $8Qi2K = parcelRequire("8Qi2K");

var $3qW9p = parcelRequire("3qW9p");

var $EPlSR = parcelRequire("EPlSR");

var $fAPrM = parcelRequire("fAPrM");
function $05636d957534b768$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $05636d957534b768$var$cssSelector = {
    [(0, $7326b3b2ac0b6dee$export$9ecd22db14e6c70e)]: true
};
const $05636d957534b768$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $05636d957534b768$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $05636d957534b768$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $05636d957534b768$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $eJOHy.useContext)((0, $8Qi2K.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $eJOHy.useRef)(leftSidebarState[0, $7326b3b2ac0b6dee$export$a30f2e00489a8957]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $eJOHy.useRef)(0);
    const keyboardEventTimeout = (0, $eJOHy.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $eJOHy.useState)(false);
    const unbindEvents = (0, $eJOHy.useRef)(null);
    const mobileMediaQuery = (0, $3FUYM.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $eJOHy.useRef)(leftSidebarState);
    (0, $eJOHy.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $eJOHy.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $7326b3b2ac0b6dee$export$a30f2e00489a8957] - (0, $lHwek.getLeftPanelWidth)();
        unbindEvents.current = (0, $4eDgu.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $7326b3b2ac0b6dee$export$46acf8758e9e2636));
                        document.documentElement.style.setProperty(`--${(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $7326b3b2ac0b6dee$export$802bb2c050f3db5c), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $7326b3b2ac0b6dee$export$802bb2c050f3db5c));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $eJOHy.useState)(()=>(0, $bRPNB.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $lHwek.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $7326b3b2ac0b6dee$export$46acf8758e9e2636) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $7326b3b2ac0b6dee$export$46acf8758e9e2636));
            document.documentElement.style.setProperty(`--${(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $7326b3b2ac0b6dee$export$802bb2c050f3db5c));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $7326b3b2ac0b6dee$export$6949d4f32b161684)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)}`, `${(0, $7326b3b2ac0b6dee$export$46acf8758e9e2636)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $7326b3b2ac0b6dee$export$6949d4f32b161684) && sidebarWidth.current < (0, $7326b3b2ac0b6dee$export$539e68c09584883a)) {
            document.documentElement.style.setProperty(`--${(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)}`, `${(0, $7326b3b2ac0b6dee$export$539e68c09584883a)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)]: (0, $7326b3b2ac0b6dee$export$539e68c09584883a),
                lastLeftSidebarWidth: (0, $7326b3b2ac0b6dee$export$539e68c09584883a)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $lHwek.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $7326b3b2ac0b6dee$export$539e68c09584883a)) {
                width = (0, $7326b3b2ac0b6dee$export$539e68c09584883a);
                document.documentElement.style.setProperty(`--${(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)}`, `${(0, $7326b3b2ac0b6dee$export$539e68c09584883a) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $7326b3b2ac0b6dee$export$539e68c09584883a);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $eJOHy.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $1NIU8.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $eJOHy.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $lHwek.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $lHwek.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ...$05636d957534b768$var$cssSelector,
        css: [
            $05636d957534b768$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $05636d957534b768$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fAPrM.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3qW9p.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $EPlSR.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1NIU8.Global), {
        styles: $05636d957534b768$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$05636d957534b768$export$2e2bcd8739ae039 = $05636d957534b768$var$ResizeControl;

});
parcelRegister("3qW9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $67b724fc7d92a4a9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");


function $67b724fc7d92a4a9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $67b724fc7d92a4a9$var$varLineColor = '--ds-line';
const $67b724fc7d92a4a9$var$grabAreaStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$67b724fc7d92a4a9$var$varLineColor]: `var(--ds-border-selected, ${(0, $7bb4c1736002a04a$export$215b7063051591f1)})`
    }
});
const $67b724fc7d92a4a9$var$grabAreaCollapsedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $67b724fc7d92a4a9$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $67b724fc7d92a4a9$var$grabAreaLineSelector = {
    [(0, $7326b3b2ac0b6dee$export$70c702a8c5895f03)]: true
};
const $67b724fc7d92a4a9$var$grabAreaSelector = {
    [(0, $7326b3b2ac0b6dee$export$48a43f91e4becf4e)]: true
};
const $67b724fc7d92a4a9$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $1NIU8.jsx)("button", {
        ...$67b724fc7d92a4a9$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $67b724fc7d92a4a9$var$grabAreaStyles,
            isLeftSidebarCollapsed && $67b724fc7d92a4a9$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $67b724fc7d92a4a9$var$lineStyles,
        ...$67b724fc7d92a4a9$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$67b724fc7d92a4a9$export$2e2bcd8739ae039 = $67b724fc7d92a4a9$var$GrabArea;

});

parcelRegister("EPlSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c6f6116f161fe7a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
                                                                                                                                                 * @jsxRuntime classic
                                                                                                                                                 * @jsx jsx
                                                                                                                                                 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $dB1eP = parcelRequire("dB1eP");


var $34ZNB = parcelRequire("34ZNB");

var $6efFi = parcelRequire("6efFi");


function $8c6f6116f161fe7a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c6f6116f161fe7a$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $8c6f6116f161fe7a$var$mobileStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles -- Ignored via go/DSP-18766
    [(0, $6efFi.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $8c6f6116f161fe7a$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    boxShadow: `0 0 0 1px ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)}`,
    color: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $34ZNB.durations).small}ms linear,
    color ${(0, $34ZNB.durations).small}ms linear,
    opacity ${(0, $34ZNB.durations).medium}ms ${(0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a)})`,
        color: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $7bb4c1736002a04a$export$215b7063051591f1)})`,
        color: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
        opacity: 1
    }
});
const $8c6f6116f161fe7a$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $8c6f6116f161fe7a$var$preventDefault = (event)=>event.preventDefault();
const $8c6f6116f161fe7a$var$cssSelector = {
    [(0, $7326b3b2ac0b6dee$export$dac2fb31a9f6844d)]: true
};
const $8c6f6116f161fe7a$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $1NIU8.jsx)("button", {
        ...$8c6f6116f161fe7a$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $8c6f6116f161fe7a$var$resizeIconButtonStyles,
            $8c6f6116f161fe7a$var$mobileStyles,
            !isLeftSidebarCollapsed && $8c6f6116f161fe7a$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $8c6f6116f161fe7a$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
        label: "",
        color: "currentColor",
        size: "small"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $8c6f6116f161fe7a$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8c6f6116f161fe7a$export$2e2bcd8739ae039 = $8c6f6116f161fe7a$var$ResizeButton;

});

parcelRegister("fAPrM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2ca4cb6560af57$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $2MAiC = parcelRequire("2MAiC");
const $4e2ca4cb6560af57$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $4e2ca4cb6560af57$var$direction = 'to left';
const $4e2ca4cb6560af57$var$transitionDuration = '0.22s';
const $4e2ca4cb6560af57$var$shadowStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$4e2ca4cb6560af57$var$direction}, ${$4e2ca4cb6560af57$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $4e2ca4cb6560af57$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)
});
const $4e2ca4cb6560af57$var$draggingStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$4e2ca4cb6560af57$var$direction}, ${$4e2ca4cb6560af57$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $4e2ca4cb6560af57$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $2MAiC.default)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": testId,
        css: [
            $4e2ca4cb6560af57$var$shadowStyles,
            isDragging && $4e2ca4cb6560af57$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4e2ca4cb6560af57$export$2e2bcd8739ae039 = $4e2ca4cb6560af57$var$Shadow;

});
parcelRegister("2MAiC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2547ffd36d529525$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $2547ffd36d529525$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $7326b3b2ac0b6dee$export$802bb2c050f3db5c)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $2547ffd36d529525$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $eJOHy.useState)($2547ffd36d529525$var$getIsDragging);
    (0, $eJOHy.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($2547ffd36d529525$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $7326b3b2ac0b6dee$export$802bb2c050f3db5c)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $2547ffd36d529525$export$2e2bcd8739ae039 = $2547ffd36d529525$var$useIsSidebarDragging;

});



parcelRegister("1OxvL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8eb927c036b2e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $kk5YU = parcelRequire("kk5YU");

var $6efFi = parcelRequire("6efFi");


var $2MAiC = parcelRequire("2MAiC");
function $bc8eb927c036b2e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bc8eb927c036b2e8$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $1NIU8.css)((0, $kk5YU.prefersReducedMotion)());
const $bc8eb927c036b2e8$var$mobileStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $6efFi.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $7326b3b2ac0b6dee$export$70740f5ad8360a78)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $7326b3b2ac0b6dee$export$ed7cc0d417ee89e)} + ${(0, $7326b3b2ac0b6dee$export$aeff86a16f13529)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $7326b3b2ac0b6dee$export$3749e1104328fde4)}ms ${(0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)} 0s`
    }
});
const $bc8eb927c036b2e8$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $6efFi.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $7326b3b2ac0b6dee$export$d6e7e8af042815bb)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $7326b3b2ac0b6dee$export$d6e7e8af042815bb),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $7326b3b2ac0b6dee$export$3749e1104328fde4)}ms ${(0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $7326b3b2ac0b6dee$export$3749e1104328fde4)}ms ${(0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $bc8eb927c036b2e8$var$fixedInnerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $7326b3b2ac0b6dee$export$f897e1ed9f8ed251)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $7326b3b2ac0b6dee$export$ed7cc0d417ee89e)} + ${(0, $7326b3b2ac0b6dee$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $7326b3b2ac0b6dee$export$3749e1104328fde4)}ms ${(0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)} 0s`
});
const $bc8eb927c036b2e8$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $7326b3b2ac0b6dee$export$d2fa14f05b61e66)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $bc8eb927c036b2e8$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $bc8eb927c036b2e8$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $bc8eb927c036b2e8$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $2MAiC.default)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            // mobile viewport styles
            $bc8eb927c036b2e8$var$mobileStyles,
            isFlyoutOpen && $bc8eb927c036b2e8$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $bc8eb927c036b2e8$var$staticInnerStyles,
            isFixed && $bc8eb927c036b2e8$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $bc8eb927c036b2e8$var$fixedInnerFlyoutStyles,
            isDragging && $bc8eb927c036b2e8$var$draggingStyles,
            $bc8eb927c036b2e8$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bc8eb927c036b2e8$export$2e2bcd8739ae039 = $bc8eb927c036b2e8$var$LeftSidebarInner;

});

parcelRegister("g5yc0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72e599d602b7552$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $kk5YU = parcelRequire("kk5YU");

var $6efFi = parcelRequire("6efFi");


var $2MAiC = parcelRequire("2MAiC");

var $lHwek = parcelRequire("lHwek");

var $8Qi2K = parcelRequire("8Qi2K");

var $f4uL3 = parcelRequire("f4uL3");
function $f72e599d602b7552$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $f72e599d602b7552$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $1NIU8.css)((0, $kk5YU.prefersReducedMotion)());
const $f72e599d602b7552$var$mobileStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $6efFi.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $7326b3b2ac0b6dee$export$70740f5ad8360a78),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $7326b3b2ac0b6dee$export$3749e1104328fde4)}ms ${(0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $7326b3b2ac0b6dee$export$d6e7e8af042815bb),
            content: "''"
        }
    }
});
const $f72e599d602b7552$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $6efFi.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $f72e599d602b7552$var$outerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $7326b3b2ac0b6dee$export$f897e1ed9f8ed251),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $7326b3b2ac0b6dee$export$3749e1104328fde4)}ms ${(0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $f72e599d602b7552$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $f72e599d602b7552$var$fixedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $7326b3b2ac0b6dee$export$f897e1ed9f8ed251)}`,
        content: "''"
    }
});
const $f72e599d602b7552$var$flyoutStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $7326b3b2ac0b6dee$export$d2fa14f05b61e66)
});
const $f72e599d602b7552$var$flyoutFixedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $7326b3b2ac0b6dee$export$46acf8758e9e2636)
});
const $f72e599d602b7552$var$selector = (0, $lHwek.getPageLayoutSlotSelector)('left-sidebar');
const $f72e599d602b7552$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $2MAiC.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $eJOHy.useContext)((0, $8Qi2K.SidebarResizeContext));
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $f4uL3.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                // mobile viewport styles
                $f72e599d602b7552$var$mobileStyles,
                isFlyoutOpen && $f72e599d602b7552$var$mobileFlyoutStyles,
                // generic styles
                $f72e599d602b7552$var$outerStyles,
                isFixed && $f72e599d602b7552$var$fixedStyles,
                isFlyoutOpen && $f72e599d602b7552$var$flyoutStyles,
                isFlyoutOpen && isFixed && $f72e599d602b7552$var$flyoutFixedStyles,
                isDragging && $f72e599d602b7552$var$draggingStyles,
                $f72e599d602b7552$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$f72e599d602b7552$var$selector
        }, children));
};
const $f72e599d602b7552$var$LeftSidebarOuter = /*#__PURE__*/ (0, $eJOHy.forwardRef)($f72e599d602b7552$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f72e599d602b7552$export$2e2bcd8739ae039 = $f72e599d602b7552$var$LeftSidebarOuter;

});

parcelRegister("hip7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a833f3414c34913$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $kk5YU = parcelRequire("kk5YU");


var $1dnUQ = parcelRequire("1dnUQ");
function $4a833f3414c34913$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $4a833f3414c34913$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $1NIU8.css)((0, $kk5YU.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $4a833f3414c34913$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    opacity: 0,
    transition: 'opacity 0ms linear, visibility 0ms linear',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $7326b3b2ac0b6dee$export$3749e1104328fde4) - 100}ms`,
    visibility: 'hidden'
});
const $4a833f3414c34913$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $4a833f3414c34913$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $4a833f3414c34913$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $1dnUQ.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $4a833f3414c34913$var$resizableChildrenWrapperStyles,
            isHidden && $4a833f3414c34913$var$hideLeftSidebarContentsStyles,
            $4a833f3414c34913$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId,
        tabIndex: isHidden ? -1 : 0
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $4a833f3414c34913$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4a833f3414c34913$export$2e2bcd8739ae039 = $4a833f3414c34913$var$ResizableChildrenWrapper;

});
parcelRegister("1dnUQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $62a7f3a56159a227$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $62a7f3a56159a227$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $7326b3b2ac0b6dee$export$5e5e1875c3fd8f4f)) === 'true';
};
const $62a7f3a56159a227$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $eJOHy.useState)($62a7f3a56159a227$var$getIsCollapsing);
    (0, $eJOHy.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($62a7f3a56159a227$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $7326b3b2ac0b6dee$export$5e5e1875c3fd8f4f)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $62a7f3a56159a227$export$2e2bcd8739ae039 = $62a7f3a56159a227$var$useIsSidebarCollapsing;

});



parcelRegister("dCyxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9adaa6f2a2a0d4ca$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $lHwek = parcelRequire("lHwek");

var $5OLbt = parcelRequire("5OLbt");
var $6iDQ8 = parcelRequire("6iDQ8");

var $1OxvL = parcelRequire("1OxvL");

var $g5yc0 = parcelRequire("g5yc0");

var $bJSJd = parcelRequire("bJSJd");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $9adaa6f2a2a0d4ca$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $lHwek.resolveDimension)((0, $7326b3b2ac0b6dee$export$a30f2e00489a8957), width, shouldPersistWidth);
    (0, $eJOHy.useEffect)(()=>{
        (0, $5OLbt.default)({
            [(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)]: leftSidebarWidth
        });
        return ()=>{
            (0, $5OLbt.default)({
                [(0, $7326b3b2ac0b6dee$export$a30f2e00489a8957)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $6iDQ8.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $g5yc0.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bJSJd.default), {
        variableName: (0, $7326b3b2ac0b6dee$export$a30f2e00489a8957),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1OxvL.default), {
        isFixed: isFixed
    }, children));
};
var $9adaa6f2a2a0d4ca$export$2e2bcd8739ae039 = $9adaa6f2a2a0d4ca$var$LeftSidebarWithoutResize;

});

parcelRegister("d4u9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d125cc488cd8329$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $kk5YU = parcelRequire("kk5YU");



var $2MAiC = parcelRequire("2MAiC");

var $lHwek = parcelRequire("lHwek");

var $8Qi2K = parcelRequire("8Qi2K");
var $6iDQ8 = parcelRequire("6iDQ8");

var $f4uL3 = parcelRequire("f4uL3");
function $1d125cc488cd8329$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $1d125cc488cd8329$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $1NIU8.css)((0, $kk5YU.prefersReducedMotion)());
const $1d125cc488cd8329$var$mainStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $7326b3b2ac0b6dee$export$3749e1104328fde4)}ms ${(0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)} 0s`
});
const $1d125cc488cd8329$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $1d125cc488cd8329$var$flyoutStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $7326b3b2ac0b6dee$export$b6744d31294864fd)}, ${(0, $7326b3b2ac0b6dee$export$991d5285ad765a3d)}px) + ${(0, $7326b3b2ac0b6dee$export$46acf8758e9e2636)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $1d125cc488cd8329$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $6iDQ8.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $2MAiC.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $eJOHy.useContext)((0, $8Qi2K.SidebarResizeContext));
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $f4uL3.default), null, ({ className: className })=>/*#__PURE__*/ (0, $1NIU8.jsx)("main", {
            "data-testid": testId,
            css: [
                $1d125cc488cd8329$var$mainStyles,
                isDragging && $1d125cc488cd8329$var$draggingStyles,
                isFlyoutOpen && !isFixed && $1d125cc488cd8329$var$flyoutStyles,
                $1d125cc488cd8329$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $lHwek.getPageLayoutSlotSelector)('main')
        }, children));
};
var $1d125cc488cd8329$export$2e2bcd8739ae039 = $1d125cc488cd8329$var$Main;

});

parcelRegister("gL49i", function(module, exports) {

$parcel$export(module.exports, "default", () => $48bd6468dfbd12b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6efFi = parcelRequire("6efFi");


var $iurFu = parcelRequire("iurFu");
var $aO4Xv = parcelRequire("aO4Xv");

var $4cY60 = parcelRequire("4cY60");
const $48bd6468dfbd12b9$var$pageLayoutSelector = {
    [(0, $7326b3b2ac0b6dee$export$659ee746b31b360d)]: true
};
const $48bd6468dfbd12b9$var$gridTemplateAreasMobile = `
${''}
  "${(0, $7326b3b2ac0b6dee$export$344062f7cfc9528e)} ${(0, $7326b3b2ac0b6dee$export$238d30785c4bca84)}"
  ${''}
  "${(0, $7326b3b2ac0b6dee$export$344062f7cfc9528e)} ${(0, $7326b3b2ac0b6dee$export$bec6dca2e63de4ae)}"
  ${''}
  "${(0, $7326b3b2ac0b6dee$export$344062f7cfc9528e)} ${(0, $7326b3b2ac0b6dee$export$d1213e82613ff4df)}"
 `;
const $48bd6468dfbd12b9$var$gridTemplateAreas = `
${''}
  "${(0, $7326b3b2ac0b6dee$export$344062f7cfc9528e)} ${(0, $7326b3b2ac0b6dee$export$238d30785c4bca84)} ${(0, $7326b3b2ac0b6dee$export$c7139cc2d6110b5f)}"
  ${''}
  "${(0, $7326b3b2ac0b6dee$export$344062f7cfc9528e)} ${(0, $7326b3b2ac0b6dee$export$bec6dca2e63de4ae)} ${(0, $7326b3b2ac0b6dee$export$c7139cc2d6110b5f)}"
${''}
  "${(0, $7326b3b2ac0b6dee$export$344062f7cfc9528e)} ${(0, $7326b3b2ac0b6dee$export$d1213e82613ff4df)} ${(0, $7326b3b2ac0b6dee$export$c7139cc2d6110b5f)}"
 `;
const $48bd6468dfbd12b9$var$gridStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $48bd6468dfbd12b9$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)} minmax(0, 1fr) ${(0, $7326b3b2ac0b6dee$export$750459958906793)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $7326b3b2ac0b6dee$export$ed7cc0d417ee89e)} ${(0, $7326b3b2ac0b6dee$export$aeff86a16f13529)} auto`,
    outline: 'none'
});
const $48bd6468dfbd12b9$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $6efFi.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $48bd6468dfbd12b9$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $48bd6468dfbd12b9$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $7326b3b2ac0b6dee$export$206a08f7f8beb554), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aO4Xv.SkipLinksController), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4cY60.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ...$48bd6468dfbd12b9$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $48bd6468dfbd12b9$var$gridStyles,
            $48bd6468dfbd12b9$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $iurFu.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $48bd6468dfbd12b9$export$2e2bcd8739ae039 = $48bd6468dfbd12b9$var$PageLayout;

});
parcelRegister("iurFu", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $4561d24a6a39ac0b$export$850bd1bba41f1448);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $3Vuhz = parcelRequire("3Vuhz");

var $kk5YU = parcelRequire("kk5YU");

var $3FUYM = parcelRequire("3FUYM");


var $lHwek = parcelRequire("lHwek");

var $8Qi2K = parcelRequire("8Qi2K");
const $4561d24a6a39ac0b$var$handleDataAttributesAndCb = (callback = (0, $3Vuhz.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $7326b3b2ac0b6dee$export$5e5e1875c3fd8f4f));
    callback(leftSidebarState);
};
const $4561d24a6a39ac0b$var$leftSidebarSelector = (0, $lHwek.getPageLayoutSlotCSSSelector)('left-sidebar');
const $4561d24a6a39ac0b$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $eJOHy.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $eJOHy.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $eJOHy.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $eJOHy.useRef)(null);
    const mobileMediaQuery = (0, $3FUYM.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $eJOHy.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $7326b3b2ac0b6dee$export$46acf8758e9e2636),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $4561d24a6a39ac0b$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $7326b3b2ac0b6dee$export$539e68c09584883a));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $4561d24a6a39ac0b$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($4561d24a6a39ac0b$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $kk5YU.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $4eDgu.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $eJOHy.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $7326b3b2ac0b6dee$export$46acf8758e9e2636),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $4561d24a6a39ac0b$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $7326b3b2ac0b6dee$export$5e5e1875c3fd8f4f), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $7326b3b2ac0b6dee$export$46acf8758e9e2636),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $4561d24a6a39ac0b$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($4561d24a6a39ac0b$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $kk5YU.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $4eDgu.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $eJOHy.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $eJOHy.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $eJOHy.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Qi2K.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("aO4Xv", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $de99e1f231aa3558$export$da7be99d6a868f3d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $6iDQ8 = parcelRequire("6iDQ8");
const $de99e1f231aa3558$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $7326b3b2ac0b6dee$export$5253dd9707b8c3ba)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $de99e1f231aa3558$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $eJOHy.useState)([]);
    const registerSkipLink = (0, $eJOHy.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($de99e1f231aa3558$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $eJOHy.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6iDQ8.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("4cY60", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $35aefea09e0dadc0$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $1NIU8 = parcelRequire("1NIU8");

var $eJ9f5 = parcelRequire("eJ9f5");

var $kk5YU = parcelRequire("kk5YU");



var $6iDQ8 = parcelRequire("6iDQ8");
function $35aefea09e0dadc0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $35aefea09e0dadc0$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $1NIU8.css)((0, $kk5YU.prefersReducedMotion)());
const $35aefea09e0dadc0$var$skipLinkStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)}, 0 2px 10px ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $eeb70e8c0a60dc66$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $35aefea09e0dadc0$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $35aefea09e0dadc0$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $35aefea09e0dadc0$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $35aefea09e0dadc0$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $35aefea09e0dadc0$var$assignIndex(num + 1, arr);
};
const $35aefea09e0dadc0$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $6iDQ8.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $35aefea09e0dadc0$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $7326b3b2ac0b6dee$export$659ee746b31b360d)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $7326b3b2ac0b6dee$export$206a08f7f8beb554);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $35aefea09e0dadc0$var$skipLinkStyles,
            $35aefea09e0dadc0$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $1NIU8.jsx)("p", {
        css: $35aefea09e0dadc0$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $1NIU8.jsx)("ol", {
        css: $35aefea09e0dadc0$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $1NIU8.jsx)($35aefea09e0dadc0$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle)))));
};
const $35aefea09e0dadc0$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $35aefea09e0dadc0$var$handleBlur);
};
const $35aefea09e0dadc0$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $35aefea09e0dadc0$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $35aefea09e0dadc0$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("li", {
        css: $35aefea09e0dadc0$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJ9f5.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $35aefea09e0dadc0$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("kqCKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2edce79adca616da$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $lHwek = parcelRequire("lHwek");

var $5OLbt = parcelRequire("5OLbt");
var $6iDQ8 = parcelRequire("6iDQ8");

var $f4uL3 = parcelRequire("f4uL3");

var $bJSJd = parcelRequire("bJSJd");
const $2edce79adca616da$var$baseStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $7326b3b2ac0b6dee$export$c7139cc2d6110b5f)
});
const $2edce79adca616da$var$fixedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $7326b3b2ac0b6dee$export$750459958906793),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $2edce79adca616da$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $7326b3b2ac0b6dee$export$c3e41153b9288bcf), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $lHwek.resolveDimension)((0, $7326b3b2ac0b6dee$export$fa34f417972d6341), width, shouldPersistWidth);
    (0, $eJOHy.useEffect)(()=>{
        (0, $5OLbt.default)({
            [(0, $7326b3b2ac0b6dee$export$fa34f417972d6341)]: rightPanelWidth
        });
        return ()=>{
            (0, $5OLbt.default)({
                [(0, $7326b3b2ac0b6dee$export$fa34f417972d6341)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $6iDQ8.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $f4uL3.default), null, ({ className: className })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                $2edce79adca616da$var$baseStyles,
                isFixed && $2edce79adca616da$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $lHwek.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bJSJd.default), {
            variableName: (0, $7326b3b2ac0b6dee$export$fa34f417972d6341),
            value: rightPanelWidth
        }), children));
};
var $2edce79adca616da$export$2e2bcd8739ae039 = $2edce79adca616da$var$RightPanel;

});

parcelRegister("016Wa", function(module, exports) {

$parcel$export(module.exports, "default", () => $173b8ec6fb0e87ca$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $lHwek = parcelRequire("lHwek");

var $5OLbt = parcelRequire("5OLbt");
var $6iDQ8 = parcelRequire("6iDQ8");

var $f4uL3 = parcelRequire("f4uL3");

var $bJSJd = parcelRequire("bJSJd");
function $173b8ec6fb0e87ca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $173b8ec6fb0e87ca$var$fixedInnerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $7326b3b2ac0b6dee$export$b44ab66843c05a69),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $7326b3b2ac0b6dee$export$ed7cc0d417ee89e)} + ${(0, $7326b3b2ac0b6dee$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $7326b3b2ac0b6dee$export$750459958906793)})`
});
const $173b8ec6fb0e87ca$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $173b8ec6fb0e87ca$var$outerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    width: (0, $7326b3b2ac0b6dee$export$b44ab66843c05a69)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $173b8ec6fb0e87ca$var$fixedOuterStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $7326b3b2ac0b6dee$export$b44ab66843c05a69),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $173b8ec6fb0e87ca$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $7326b3b2ac0b6dee$export$b92df8810d2fcd01), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $lHwek.resolveDimension)((0, $7326b3b2ac0b6dee$export$c103b605cd368aed), width, shouldPersistWidth);
    (0, $eJOHy.useEffect)(()=>{
        (0, $5OLbt.default)({
            [(0, $7326b3b2ac0b6dee$export$c103b605cd368aed)]: rightSidebarWidth
        });
        return ()=>{
            (0, $5OLbt.default)({
                [(0, $7326b3b2ac0b6dee$export$c103b605cd368aed)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $6iDQ8.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $f4uL3.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            "data-testid": testId,
            css: [
                $173b8ec6fb0e87ca$var$outerStyles,
                isFixed && $173b8ec6fb0e87ca$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $lHwek.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bJSJd.default), {
            variableName: (0, $7326b3b2ac0b6dee$export$c103b605cd368aed),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                isFixed && $173b8ec6fb0e87ca$var$fixedInnerStyles,
                !isFixed && $173b8ec6fb0e87ca$var$staticInnerStyles
            ]
        }, children)));
};
var $173b8ec6fb0e87ca$export$2e2bcd8739ae039 = $173b8ec6fb0e87ca$var$RightSidebar;

});

parcelRegister("c4lEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9adf0812949cc519$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $lHwek = parcelRequire("lHwek");

var $5OLbt = parcelRequire("5OLbt");
var $6iDQ8 = parcelRequire("6iDQ8");

var $f4uL3 = parcelRequire("f4uL3");

var $bJSJd = parcelRequire("bJSJd");
const $9adf0812949cc519$var$topNavigationStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $7326b3b2ac0b6dee$export$aeff86a16f13529),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $7326b3b2ac0b6dee$export$bec6dca2e63de4ae)
});
const $9adf0812949cc519$var$fixedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $7326b3b2ac0b6dee$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $7326b3b2ac0b6dee$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $9adf0812949cc519$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $7326b3b2ac0b6dee$export$4a98ee0bd1ae362), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $lHwek.resolveDimension)((0, $7326b3b2ac0b6dee$export$3a6a779d9181047c), height, shouldPersistHeight);
    (0, $eJOHy.useEffect)(()=>{
        (0, $5OLbt.default)({
            [(0, $7326b3b2ac0b6dee$export$3a6a779d9181047c)]: topNavigationHeight
        });
        return ()=>{
            (0, $5OLbt.default)({
                [(0, $7326b3b2ac0b6dee$export$3a6a779d9181047c)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $6iDQ8.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $f4uL3.default), null, ({ className: className })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                $9adf0812949cc519$var$topNavigationStyles,
                isFixed && $9adf0812949cc519$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $lHwek.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bJSJd.default), {
            variableName: (0, $7326b3b2ac0b6dee$export$3a6a779d9181047c),
            value: topNavigationHeight
        }), children));
};
var $9adf0812949cc519$export$2e2bcd8739ae039 = $9adf0812949cc519$var$TopNavigation;

});

parcelRegister("gm5Vk", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $beabc69535c36748$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6iDQ8 = parcelRequire("6iDQ8");
const $beabc69535c36748$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $6iDQ8.useSkipLinks)();
    (0, $eJOHy.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("1AIob", function(module, exports) {

$parcel$export(module.exports, "Aside", () => $7f6620e368bb4235$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aNllK = parcelRequire("aNllK");

var $eGOwo = parcelRequire("eGOwo");

var $6efFi = parcelRequire("6efFi");

var $13z4V = parcelRequire("13z4V");

var $2SN4F = parcelRequire("2SN4F");

var $ebZBs = parcelRequire("ebZBs");

var $bvM7a = parcelRequire("bvM7a");

var $ipWav = parcelRequire("ipWav");

var $glIca = parcelRequire("glIca");

var $69FLM = parcelRequire("69FLM");
const $7f6620e368bb4235$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $7f6620e368bb4235$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $7f6620e368bb4235$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $7f6620e368bb4235$var$getResizeBounds() {
    return $7f6620e368bb4235$var$asideWidthResizeBounds;
}
const $7f6620e368bb4235$var$styles = {
    root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
    fixedContentArea: "_1reo1wug _18m91wug _152timx3 _165teqxy _13wn1if8",
    fullHeight: "_4t3i1osq"
};
function $7f6620e368bb4235$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixedProp, defaultWidth: defaultWidth = 330, label: label = 'Aside', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $eJOHy.useContext)((0, $ebZBs.DangerouslyHoistSlotSizes));
    const id = (0, $ipWav.useLayoutId)({
        providedId: providedId
    });
    const isFixed = (0, $eGOwo.fg)('platform_dst_nav4_disable_is_fixed_prop') ? true : isFixedProp;
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $13z4V.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $eJOHy.useRef)(null);
    const [width, setWidth] = (0, $eJOHy.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $aNllK.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $eJOHy.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $eJOHy.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$7f6620e368bb4235$var$asideWidthSlotBounds.min}, ${width}px, ${$7f6620e368bb4235$var$asideWidthSlotBounds.max})`;
    (0, $69FLM.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $eGOwo.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        panelId: (0, $2SN4F.asidePanelSplitterId),
        cssVar: $7f6620e368bb4235$var$panelSplitterResizingVar
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("aside", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $hcewu.default)([
            $7f6620e368bb4235$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $2SN4F.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvM7a.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $2SN4F.UNSAFE_asideLayoutVar),
                value: "0px",
                mediaQuery: (0, $6efFi.media).above.md,
                responsiveValue: (0, $eGOwo.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$7f6620e368bb4235$var$panelSplitterResizingVar}, ${asideVariableWidth})` : asideVariableWidth
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $glIca.PanelSplitterProvider), {
                panelId: (0, $2SN4F.asidePanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $7f6620e368bb4235$var$getResizeBounds,
                resizingCssVar: $7f6620e368bb4235$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-testid": testId ? `${testId}--inner` : undefined,
                    className: (0, $hcewu.default)([
                        $7f6620e368bb4235$var$styles.fullHeight,
                        isFixed && $7f6620e368bb4235$var$styles.fixedContentArea
                    ]),
                    children: children
                })
            })
        ]
    });
}

});
parcelRegister("13z4V", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $59b510d920ed22f7$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinkInternal", () => $59b510d920ed22f7$export$707b94c26b8b75aa);
$parcel$export(module.exports, "useSkipLink", () => $59b510d920ed22f7$export$89d9323301efc7d6);

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");
const $59b510d920ed22f7$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $eJOHy.createContext)({
    registerSkipLink: (0, $3Vuhz.default),
    unregisterSkipLink: (0, $3Vuhz.default)
});
const $59b510d920ed22f7$var$useSkipLinks = ()=>(0, $eJOHy.useContext)($59b510d920ed22f7$export$4c5cc3b14c7678a);
const $59b510d920ed22f7$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $59b510d920ed22f7$var$useSkipLinks();
    (0, $eJOHy.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
const $59b510d920ed22f7$export$89d9323301efc7d6 = (/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex)=>{
    $59b510d920ed22f7$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("2SN4F", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", () => $8935fee090ff0810$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $8935fee090ff0810$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $8935fee090ff0810$export$db0c2e1d744fb281);
$parcel$export(module.exports, "bannerMountedVar", () => $8935fee090ff0810$export$515a0b1baafe906c);
$parcel$export(module.exports, "topNavMountedVar", () => $8935fee090ff0810$export$60ef3a7b1ed42328);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $8935fee090ff0810$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $8935fee090ff0810$export$5db28b16b6e686bc);
$parcel$export(module.exports, "asidePanelSplitterId", () => $8935fee090ff0810$export$de580d653bac8ad9);
$parcel$export(module.exports, "panelPanelSplitterId", () => $8935fee090ff0810$export$3452dcb65711af44);
$parcel$export(module.exports, "UNSAFE_topNavVar", () => $8935fee090ff0810$export$855f5a09f5c99ac);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $8935fee090ff0810$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $8935fee090ff0810$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $8935fee090ff0810$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $8935fee090ff0810$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $8935fee090ff0810$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $8935fee090ff0810$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $8935fee090ff0810$export$166d8fd766c3eb92);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $8935fee090ff0810$export$951bf5156e86d974 = '--n_sNvw';
const $8935fee090ff0810$export$594e6a30db7c057e = '--n_asDw';
const $8935fee090ff0810$export$db0c2e1d744fb281 = '--n_pnlW';
const $8935fee090ff0810$export$515a0b1baafe906c = '--n_bnrM';
const $8935fee090ff0810$export$60ef3a7b1ed42328 = '--n_tNvM';
const $8935fee090ff0810$export$1216dacffd1e9e65 = '--n_sNvlw';
const $8935fee090ff0810$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $8935fee090ff0810$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $8935fee090ff0810$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $8935fee090ff0810$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $8935fee090ff0810$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $8935fee090ff0810$export$855f5a09f5c99ac = '--topNavigationHeight';
const $8935fee090ff0810$export$26354f9814213292 = '--bannerHeight';
const $8935fee090ff0810$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $8935fee090ff0810$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $8935fee090ff0810$export$753bf7651b25db91 = '--rightPanelWidth';
const $8935fee090ff0810$export$6460bd6a2446260 = `calc(var(${$8935fee090ff0810$export$26354f9814213292}, 0px) + var(${$8935fee090ff0810$export$855f5a09f5c99ac}, 0px))`;
const $8935fee090ff0810$export$3055529fab2b4edf = `var(${$8935fee090ff0810$export$6bfc931a04ec5741}, 0px)`;
const $8935fee090ff0810$export$166d8fd766c3eb92 = `calc(var(${$8935fee090ff0810$export$bbbace2ff0c7ae1b}, 0px) + var(${$8935fee090ff0810$export$753bf7651b25db91}, 0px))`;
const $8935fee090ff0810$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};

});

parcelRegister("ebZBs", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $950f2d4811532d9c$export$66e2c1a0115af861);

var $eJOHy = parcelRequire("eJOHy");
const $950f2d4811532d9c$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);

});

parcelRegister("bvM7a", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $13c885c2e4ec7d2d$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $13c885c2e4ec7d2d$export$9f45a1325e3cdfb8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4ZYlE = parcelRequire("4ZYlE");
const $13c885c2e4ec7d2d$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $gt9Am.jsx)("style", {
        children: `#${(0, $4ZYlE.gridRootId)} { ${variableName}: ${value}px }`
    });
const $13c885c2e4ec7d2d$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $13c885c2e4ec7d2d$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$13c885c2e4ec7d2d$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$13c885c2e4ec7d2d$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $gt9Am.jsx)("style", {
        children: style
    }));
};

});
parcelRegister("4ZYlE", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $35662df064400350$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $35662df064400350$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $l3ndk = parcelRequire("l3ndk");

var $67ZHb = parcelRequire("67ZHb");

var $fTgAk = parcelRequire("fTgAk");

var $5s5AP = parcelRequire("5s5AP");

var $ebZBs = parcelRequire("ebZBs");

var $7AQlJ = parcelRequire("7AQlJ");

var $5e0Tz = parcelRequire("5e0Tz");

var $aMfGb = parcelRequire("aMfGb");
const $35662df064400350$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $35662df064400350$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $35662df064400350$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        var child;
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aMfGb.SideNavVisibilityProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5e0Tz.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7AQlJ.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5s5AP.TopNavStartProvider), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l3ndk.OpenLayerObserver), {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ebZBs.DangerouslyHoistSlotSizes).Provider, {
                            value: UNSAFE_dangerouslyHoistSlotSizes,
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fTgAk.SkipLinksProvider), {
                                children: [
                                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ZHb.SkipLinksContainer), {
                                        label: skipLinksLabel,
                                        testId: testId
                                    }),
                                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                        ref: ref,
                                        className: (0, $hcewu.default)([
                                            $35662df064400350$var$styles.root,
                                            xcss
                                        ]),
                                        id: $35662df064400350$export$a6d827031bcb31d1,
                                        "data-testid": testId,
                                        children: children
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("l3ndk", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", () => $e4759b39cab74da2$export$97afddda23bcd287);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $7UPzw = parcelRequire("7UPzw");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $e4759b39cab74da2$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $e4759b39cab74da2$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $e4759b39cab74da2$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $e4759b39cab74da2$var$createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The `onClose` listeners for each namespace.
	 * Each layer provides an `onClose` callback. **When the layer is open**, its `onClose`
	 * callback is registered in this set.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerCloseListenerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($e4759b39cab74da2$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $e4759b39cab74da2$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * If a namespace is provided, the count for that namespace is returned.
	 * Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace } = {}) {
        if (namespace) return namespaceToLayerCloseListenerRegistry.get(namespace)?.size ?? 0;
        // A specific namespace was not requested, so we return the sum across all namespaces.
        return $e4759b39cab74da2$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $e4759b39cab74da2$var$noNamespaceSymbol;
        const listenersForNamespace = $e4759b39cab74da2$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace }) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onClose` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onClose`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped() {
            listener();
        }
        const namespace = providedNamespace ?? $e4759b39cab74da2$var$noNamespaceSymbol;
        const listenersForNamespace = $e4759b39cab74da2$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerCloseListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerCloseListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerCloseListenerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach((listener)=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $e4759b39cab74da2$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $eJOHy.useState)(()=>$e4759b39cab74da2$var$createInternalAPI());
    const parentContext = (0, $eJOHy.useContext)((0, $7UPzw.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $8GOss.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7UPzw.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

});

parcelRegister("67ZHb", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", () => $b7bd55c890a035bb$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5qJVF = parcelRequire("5qJVF");

var $4RSgW = parcelRequire("4RSgW");

var $Gfr58 = parcelRequire("Gfr58");
const $b7bd55c890a035bb$var$styles = {
    root: "_zulp1b66 _2rkoglpi _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    skipLinkList: "_zulp1b66 _1e0c1txw _2lx21bp4 _1x8w11lx _2mzuglyw _1pfhze3t _bozgze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ const $b7bd55c890a035bb$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $b7bd55c890a035bb$var$isOnlyWhitespaceRegex = /^\s*$/;
const $b7bd55c890a035bb$export$fce25a0c32fbc1e1 = ({ label: label, testId: testId })=>{
    const sortedSkipLinks = (0, $4RSgW.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    const isEmptyLabel = $b7bd55c890a035bb$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        onKeyDown: $b7bd55c890a035bb$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $hcewu.default)([
            $b7bd55c890a035bb$var$styles.root
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                weight: "bold",
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
                className: (0, $hcewu.default)([
                    $b7bd55c890a035bb$var$styles.skipLinkList
                ]),
                children: sortedSkipLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $Gfr58.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
};

});
parcelRegister("4RSgW", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", () => $ba1cb04d1e90ff85$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $ba1cb04d1e90ff85$export$b0b0d4fc1b356759);

var $eJOHy = parcelRequire("eJOHy");
const $ba1cb04d1e90ff85$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $eJOHy.createContext)([]);
const $ba1cb04d1e90ff85$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $ba1cb04d1e90ff85$var$assignIndex(num + 1, arr);
};
const $ba1cb04d1e90ff85$var$sortSkipLinks = (arr)=>{
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
        const listIndex = $ba1cb04d1e90ff85$var$assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIdx
    ].sort((a, b)=>a.listIndex - b.listIndex);
};
const $ba1cb04d1e90ff85$export$b0b0d4fc1b356759 = ()=>{
    const skipLinksData = (0, $eJOHy.useContext)($ba1cb04d1e90ff85$export$e9ab38ce6147d3d2);
    return (0, $eJOHy.useMemo)(()=>{
        return $ba1cb04d1e90ff85$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("Gfr58", function(module, exports) {

$parcel$export(module.exports, "SkipLink", () => $57a7e0150fd8adea$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $lL4G9 = parcelRequire("lL4G9");
const $57a7e0150fd8adea$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $57a7e0150fd8adea$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, $4eDgu.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
const $57a7e0150fd8adea$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate })=>{
    const href = `#${id}`;
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        const target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate?.();
        $57a7e0150fd8adea$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        className: (0, $hcewu.default)([
            $57a7e0150fd8adea$var$styles.skipLinkListItem
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lL4G9.default), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: onClick,
            children: children
        })
    });
};

});


parcelRegister("fTgAk", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", () => $2aee1337265c0f5f$export$fe514f9f7b03d46f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $13z4V = parcelRequire("13z4V");

var $4RSgW = parcelRequire("4RSgW");
const $2aee1337265c0f5f$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $2aee1337265c0f5f$export$fe514f9f7b03d46f = ({ children: children })=>{
    const [links, setLinks] = (0, $eJOHy.useState)([]);
    const registerSkipLink = (0, $eJOHy.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($2aee1337265c0f5f$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $eJOHy.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $eJOHy.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $13z4V.SkipLinksContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4RSgW.SkipLinksDataContext).Provider, {
            value: links,
            children: children
        })
    });
};

});

parcelRegister("5s5AP", function(module, exports) {

$parcel$export(module.exports, "TopNavStartProvider", () => $9179902709a6a10c$export$bc9d0ad0bce43e75);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $20qbW = parcelRequire("20qbW");
const $9179902709a6a10c$export$bc9d0ad0bce43e75 = ({ children: children })=>{
    const [element, setElement] = (0, $eJOHy.useState)(null);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $20qbW.TopNavStartElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $20qbW.TopNavStartAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("7AQlJ", function(module, exports) {

$parcel$export(module.exports, "SideNavElementProvider", () => $ceeb10850436eb2c$export$85c1ff84bbf6e6dc);
$parcel$export(module.exports, "useSideNavRef", () => $ceeb10850436eb2c$export$fa4d0cff03b1ea4f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $ceeb10850436eb2c$var$SideNavRefContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    current: null
});
function $ceeb10850436eb2c$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $eJOHy.useRef)(null);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ceeb10850436eb2c$var$SideNavRefContext.Provider, {
        value: sideNavRef,
        children: children
    });
}
function $ceeb10850436eb2c$export$fa4d0cff03b1ea4f() {
    return (0, $eJOHy.useContext)($ceeb10850436eb2c$var$SideNavRefContext);
}

});

parcelRegister("5e0Tz", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $75caa6756517e085$export$ceb8e60e9790fc0f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kyFWW = parcelRequire("kyFWW");
const $75caa6756517e085$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $eJOHy.useState)(null);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kyFWW.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kyFWW.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("aMfGb", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", () => $94c0e6fcdd7c1715$export$aac8e996360f6ad9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k7eMS = parcelRequire("k7eMS");
const $94c0e6fcdd7c1715$export$aac8e996360f6ad9 = ({ children: children })=>{
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $eJOHy.useState)(null);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k7eMS.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k7eMS.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};

});



parcelRegister("ipWav", function(module, exports) {

$parcel$export(module.exports, "useSkipLinkId", () => $712e89131f143fef$export$fa3cfac0c8e29c5c);
$parcel$export(module.exports, "useLayoutId", () => $712e89131f143fef$export$110c3550c7c1c9aa);

var $gl2vi = parcelRequire("gl2vi");
function $712e89131f143fef$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $gl2vi.useId)();
    return uniqueId;
}
function $712e89131f143fef$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = $712e89131f143fef$export$fa3cfac0c8e29c5c();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});

parcelRegister("glIca", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $c07108ffb562461d$export$f662bfb764348932);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7INb9 = parcelRequire("7INb9");
const $c07108ffb562461d$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
    const portalRef = (0, $eJOHy.useRef)(null);
    const context = (0, $eJOHy.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled,
            portalRef: portalRef
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        portalRef,
        panelRef,
        isEnabled
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7INb9.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};

});
parcelRegister("7INb9", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", () => $57826b51e45ca4c9$export$7a4054f2c546f2cd);

var $eJOHy = parcelRequire("eJOHy");
const $57826b51e45ca4c9$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});


parcelRegister("69FLM", function(module, exports) {

$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $9ca1c4e8deaeea3c$export$d4931ecf0fbcc8fc);

var $eJOHy = parcelRequire("eJOHy");

var $dROq6 = parcelRequire("dROq6");

var $bGx3v = parcelRequire("bGx3v");

var $2bY1m = parcelRequire("2bY1m");
function $9ca1c4e8deaeea3c$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $eJOHy.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $dROq6.combine)((0, $bGx3v.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $2bY1m.isPanelSplitterDragData)(source.data)) return;
                /**
					 * Copies the resizing width value to the `<html>` element.
					 *
					 * Required to reflect the live width of the side navigation.
					 *
					 * Used by:
					 *   - Legacy `--leftSidebarWidth` variable
					 *   - Panel slot max-width constraint
					 *
					 * When the legacy `--leftSidebarWidth` variable is no longer needed,
					 * we could consider writing to the `Panel` element instead.
					 */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isEnabled) return;
        /**
		 * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
		 * if the component unmounts during a drag.
		 */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("2bY1m", function(module, exports) {

$parcel$export(module.exports, "isPanelSplitterDragData", () => $02ab32c60ee19b3c$export$e239b3966b677000);
$parcel$export(module.exports, "PanelSplitter", () => $02ab32c60ee19b3c$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4eDgu = parcelRequire("4eDgu");

var $aQK2r = parcelRequire("aQK2r");

var $8GOss = parcelRequire("8GOss");

var $gl2vi = parcelRequire("gl2vi");

var $4X7Tx = parcelRequire("4X7Tx");

var $gjgfe = parcelRequire("gjgfe");

var $dROq6 = parcelRequire("dROq6");

var $bGx3v = parcelRequire("bGx3v");
parcelRequire("eBU4b");
var $kedJ1 = parcelRequire("kedJ1");
parcelRequire("92EV7");
var $4AiYj = parcelRequire("4AiYj");
parcelRequire("ltpqI");
var $e9xFe = parcelRequire("e9xFe");

var $6fs4r = parcelRequire("6fs4r");

var $7INb9 = parcelRequire("7INb9");

var $9EnlU = parcelRequire("9EnlU");

var $368JL = parcelRequire("368JL");

var $jY1vu = parcelRequire("jY1vu");

var $a2Ijy = parcelRequire("a2Ijy");
const $02ab32c60ee19b3c$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $02ab32c60ee19b3c$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _d0aluf7j _1gavfnf5 _vp7gaqb7 _30l3aqb7 _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h16c2"
};
const $02ab32c60ee19b3c$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $02ab32c60ee19b3c$var$panelSplitterDragDataSymbol = Symbol('panel-splitter-drag-data');
function $02ab32c60ee19b3c$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [$02ab32c60ee19b3c$var$panelSplitterDragDataSymbol]: true
    };
}
function $02ab32c60ee19b3c$export$e239b3966b677000(data) {
    return data[$02ab32c60ee19b3c$var$panelSplitterDragDataSymbol] === true;
}
function $02ab32c60ee19b3c$var$getTextDirection(element) {
    const { direction: direction } = window.getComputedStyle(element);
    return direction === 'rtl' ? 'rtl' : 'ltr';
}
const $02ab32c60ee19b3c$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panel: panel, portal: portal, resizingCssVar: resizingCssVar, position: position })=>{
    const splitterRef = (0, $eJOHy.useRef)(null);
    const labelId = (0, $gl2vi.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $eJOHy.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $eJOHy.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $gjgfe.useOpenLayerObserver)();
    (0, $eJOHy.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $8GOss.default)(splitter, 'Splitter ref must be set');
        return (0, $dROq6.combine)((0, $kedJ1.blockDraggingToIFrames)({
            element: splitter
        }), (0, $bGx3v.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $4AiYj.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $e9xFe.preventUnhandled).start();
            },
            getInitialData () {
                const initialWidth = (0, $jY1vu.getPixelWidth)(panel);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $02ab32c60ee19b3c$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $02ab32c60ee19b3c$var$getTextDirection(panel)
                });
            },
            onDragStart ({ source: source }) {
                (0, $8GOss.default)($02ab32c60ee19b3c$export$e239b3966b677000(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                });
                // Close any open layers when the user starts resizing
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                (0, $8GOss.default)($02ab32c60ee19b3c$export$e239b3966b677000(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds, direction: direction } = source.data;
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ const targetWidth = (0, $jY1vu.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panel.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source }) {
                (0, $8GOss.default)($02ab32c60ee19b3c$export$e239b3966b677000(source.data));
                (0, $e9xFe.preventUnhandled).stop();
                (0, $8GOss.default)($02ab32c60ee19b3c$export$e239b3966b677000(source.data));
                const finalWidth = (0, $jY1vu.getPixelWidth)(panel);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        panelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $4X7Tx.default)(onResizeStart);
    const onResizeEndStableRef = (0, $4X7Tx.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $eJOHy.useState)(()=>(0, $a2Ijy.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $eJOHy.useCallback)((event)=>{
        const value = parseInt(event.target.value);
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $eJOHy.useRef)(null);
    const handleSliderFocus = (0, $eJOHy.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $9EnlU.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $9EnlU.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $4eDgu.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $9EnlU.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $9EnlU.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $eJOHy.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $eJOHy.useMemo)(()=>`${(0, $368JL.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $hcewu.default)([
            $02ab32c60ee19b3c$var$containerStyles.root,
            position === 'start' && $02ab32c60ee19b3c$var$containerStyles.positionStart,
            position === 'end' && $02ab32c60ee19b3c$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ref: splitterRef,
            "data-testid": testId,
            className: (0, $hcewu.default)([
                $02ab32c60ee19b3c$var$grabAreaStyles.root
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                            type: "range",
                            value: rangeInputValue,
                            step: 20,
                            min: rangeInputBounds.min,
                            max: rangeInputBounds.max,
                            "aria-valuetext": ariaValueText,
                            "aria-labelledby": labelId,
                            onChange: handleSliderInputChange,
                            onFocus: handleSliderFocus,
                            onBlur: handleSliderBlur
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            id: labelId,
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        $02ab32c60ee19b3c$var$lineStyles.root
                    ])
                })
            ]
        })
    }), portal);
};
const $02ab32c60ee19b3c$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>{
    const [panel, setPanel] = (0, $eJOHy.useState)(null);
    const [portal, setPortal] = (0, $eJOHy.useState)(null);
    const context = (0, $eJOHy.useContext)((0, $7INb9.PanelSplitterContext));
    (0, $8GOss.default)(context, 'Panel splitter context not set');
    const { panelRef: panelRef, portalRef: portalRef, isEnabled: isEnabled, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, position: position } = context;
    /**
   * **Explanation**
   *
   * _How React Suspense works_
   *
   * When a component is suspended:
   *
   * - it is _not_ "unmounted" and effects are _not_ cleaned up
   * - refs to react managed elements are cleared
   * - react adds `display:none !important` as an inline style to hide the element
   * - state is preserved
   *
   * When a suspended component is resumed:
   * - `display:none !important` inline style is removed
   * - it will re-render (without the refs set)
   * - refs will be set
   * - `useEffect` will _not_ re-run
   *
   * [More details](https://x.com/alexandereardon/status/1944617494569992440)
   *
   * _What does this mean for the panel splitter?_
   *
   * - The panel splitter renders into content into a react managed element (eg managed by Aside)
   * - When UI is suspended the portal ref is cleared
   * - After a suspense, we will get a render with cleared refs
   * - 🔥 This is problematic if we want to portal into that ref during the render
   *
   * _Approach: initial render_
   *
   * - We cannot portal the panel splitter until after the refs are initially set
   * - Effects run after refs being set. In an effect we set the ref values (which are populated),
   *   trigger a re-render and then portal into the refs.
   *
   * _Approach: suspense_
   *
   * - We put the refs into react `state` after every render
   * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
   *   when components are suspended / resumed.
   * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
   *   to continue to portal into.
   *
   * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
   *
   * - The `portalRef` is set high in the tree, so a re-render will cause a
   *   large amount of components to re-render (eg the whole sidebar)
   * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
   * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
   *   (just in the `<PanelSplitter>`)
   */ // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>{
        // Don't need to do anything
        if (!isEnabled) return;
        // It is safe to access refs in useEffect, even with Suspense
        const panelEl = panelRef.current;
        const portalEl = portalRef.current;
        (0, $8GOss.default)(panelEl, 'panelRef not set');
        (0, $8GOss.default)(portalEl, 'portal element not set');
        // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
        // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($02ab32c60ee19b3c$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        position: position
    });
};

});
parcelRegister("gjgfe", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", () => $f2e2c9b7315cf100$export$750f5b0d6c51617e);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $7UPzw = parcelRequire("7UPzw");
function $f2e2c9b7315cf100$export$750f5b0d6c51617e() {
    const context = (0, $eJOHy.useContext)((0, $7UPzw.OpenLayerObserverContext));
    (0, $8GOss.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    const publicAPI = (0, $eJOHy.useMemo)(()=>({
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        }), [
        context.getCount,
        context.onChange,
        context.closeLayers
    ]);
    return publicAPI;
}

});

parcelRegister("eBU4b", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => (parcelRequire("kedJ1")).blockDraggingToIFrames);

var $kedJ1 = parcelRequire("kedJ1");

});
parcelRegister("kedJ1", function(module, exports) {

$parcel$export(module.exports, "blockDraggingToIFrames", () => $aae84d661d772e4c$export$6ae1d8fab001518c);

var $lMeHP = parcelRequire("lMeHP");

var $bGF1c = parcelRequire("bGF1c");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $aae84d661d772e4c$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
let $aae84d661d772e4c$var$isActive = false;
/**
 * Start blocking dragging to iframes. Only to be called once a drag has started.
 */ function $aae84d661d772e4c$var$tryStart() {
    // There can technically be multiple registrations on the same element.
    // Adding a guard to ensure that only one registration does the blocking.
    if ($aae84d661d772e4c$var$isActive) return;
    $aae84d661d772e4c$var$isActive = true;
    // At this stage, we are also not watching for new iframe elements being added to the page
    // (we _could_ do that as a future change)
    const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$aae84d661d772e4c$var$setStyle(iframe, {
            property: 'pointer-events',
            rule: 'none',
            priority: 'important'
        }));
    // Not returning the cleanup function.
    // This code will clean itself up when the interaction ends in `onDrop()`.
    // Once a drag has started we are blocking iframes until the interaction is finished.
    const cleanup = (0, $bGF1c.combine)(...iframeCleanups, // We only need this monitor for listening to the drop
    // as our monitor in `blockDraggingToIFrames()` will only
    // call this function when the drag has started
    (0, $lMeHP.monitorForElements)({
        onDrop () {
            cleanup();
        }
    }), function release() {
        $aae84d661d772e4c$var$isActive = false;
    });
}
function $aae84d661d772e4c$export$6ae1d8fab001518c({ element: element }) {
    return (0, $lMeHP.monitorForElements)({
        onGenerateDragPreview ({ source: source }) {
            // only starting if we are dragging the provided element
            if (source.element === element) $aae84d661d772e4c$var$tryStart();
        }
    });
}

});


parcelRegister("92EV7", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("4AiYj")).disableNativeDragPreview);

var $4AiYj = parcelRequire("4AiYj");

});
parcelRegister("4AiYj", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $0bfe61f995bf123d$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $0bfe61f995bf123d$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $0bfe61f995bf123d$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $0bfe61f995bf123d$var$tinyTransparentImage) nativeSetDragImage($0bfe61f995bf123d$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("ltpqI", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("e9xFe")).preventUnhandled);

var $e9xFe = parcelRequire("e9xFe");

});
parcelRegister("e9xFe", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $fd5ed4da28822088$export$453c0582481cc59d);

var $4eDgu = parcelRequire("4eDgu");

var $bOMk0 = parcelRequire("bOMk0");
function $fd5ed4da28822088$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $fd5ed4da28822088$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $fd5ed4da28822088$var$start() {
    $fd5ed4da28822088$var$cleanup();
    $fd5ed4da28822088$var$unbindEvents = (0, $4eDgu.bindAll)(window, [
        {
            type: 'dragover',
            listener: $fd5ed4da28822088$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $fd5ed4da28822088$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $fd5ed4da28822088$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $fd5ed4da28822088$var$cleanup
        },
        ...(0, $bOMk0.getBindingsForBrokenDrags)({
            onDragEnd: $fd5ed4da28822088$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $fd5ed4da28822088$var$cleanup() {
    $fd5ed4da28822088$var$unbindEvents?.();
    $fd5ed4da28822088$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $fd5ed4da28822088$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $fd5ed4da28822088$var$cleanup();
}
const $fd5ed4da28822088$export$453c0582481cc59d = {
    start: $fd5ed4da28822088$var$start,
    stop: $fd5ed4da28822088$var$stop
};

});


parcelRegister("9EnlU", function(module, exports) {

$parcel$export(module.exports, "convertResizeBoundToPixels", () => $10408c60978b81ea$export$3d412b3011b66f82);
function $10408c60978b81ea$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("368JL", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $4de8d5bd7179addd$export$b5423678cdf09f5);
function $4de8d5bd7179addd$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("jY1vu", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $d42b3580f10fea6b$export$e360234971cb95b8);
$parcel$export(module.exports, "getPixelWidth", () => $d42b3580f10fea6b$export$d942790ad00c41f9);
const $d42b3580f10fea6b$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
const $d42b3580f10fea6b$export$d942790ad00c41f9 = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});

parcelRegister("a2Ijy", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $ae96fabdaba6cc6d$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $ae96fabdaba6cc6d$var$resizeCallbackDebounceTimeMs = 500;
function $ae96fabdaba6cc6d$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $ae96fabdaba6cc6d$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});




parcelRegister("cQCzs", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $62dfb8bbbdf7a315$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $13z4V = parcelRequire("13z4V");

var $2SN4F = parcelRequire("2SN4F");

var $ebZBs = parcelRequire("ebZBs");

var $bvM7a = parcelRequire("bvM7a");

var $ipWav = parcelRequire("ipWav");
const $62dfb8bbbdf7a315$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat"
};
function $62dfb8bbbdf7a315$export$3b4e64e77073e307({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = (0, $eGOwo.fg)('platform_dst_nav4_banner_default_height') ? 48 : 64, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $eJOHy.useContext)((0, $ebZBs.DangerouslyHoistSlotSizes));
    const id = (0, $ipWav.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 height.
   */ (0, $13z4V.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $hcewu.default)([
            $62dfb8bbbdf7a315$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvM7a.HoistCssVarToLocalGrid), {
                variableName: (0, $2SN4F.bannerMountedVar),
                value: height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvM7a.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $2SN4F.UNSAFE_bannerVar),
                value: height
            }),
            children
        ]
    });
}

});

parcelRegister("dh7KV", function(module, exports) {

$parcel$export(module.exports, "Main", () => $33201ffeb5eb20dd$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $13z4V = parcelRequire("13z4V");

var $ipWav = parcelRequire("ipWav");

var $3fT4U = parcelRequire("3fT4U");
const $33201ffeb5eb20dd$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152timx3 _165teqxy _13wn1if8",
    containPaint: "_njlp1t7j"
};
function $33201ffeb5eb20dd$export$861edd1ccea2f746({ children: children, isFixed: isFixedProp, xcss: xcss, skipLinkLabel: skipLinkLabel = 'Main Content', testId: testId, id: providedId }) {
    const id = (0, $ipWav.useLayoutId)({
        providedId: providedId
    });
    const isFixed = (0, $eGOwo.fg)('platform_dst_nav4_disable_is_fixed_prop') ? true : isFixedProp;
    (0, $13z4V.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            id: id,
            "data-layout-slot": true,
            className: (0, $hcewu.default)([
                $33201ffeb5eb20dd$var$mainElementStyles.root,
                isFixed && $33201ffeb5eb20dd$var$mainElementStyles.fixedContentArea,
                (0, $eGOwo.fg)('platform_dst_nav4_layering_in_main_slot_fixes') && $33201ffeb5eb20dd$var$mainElementStyles.containPaint,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3fT4U.MainStickyContext).Provider, {
                value: Boolean(isFixed),
                children: children
            })
        })
    });
}

});
parcelRegister("3fT4U", function(module, exports) {

$parcel$export(module.exports, "MainStickyContext", () => $f80b17acfe199b91$export$3b369e2c6c1ec840);

var $eJOHy = parcelRequire("eJOHy");
const $f80b17acfe199b91$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);

});


parcelRegister("lQuPF", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $bb060d5a73d8b8a0$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $6efFi = parcelRequire("6efFi");

var $13z4V = parcelRequire("13z4V");

var $2SN4F = parcelRequire("2SN4F");

var $ebZBs = parcelRequire("ebZBs");

var $bvM7a = parcelRequire("bvM7a");

var $ipWav = parcelRequire("ipWav");

var $glIca = parcelRequire("glIca");

var $7AQlJ = parcelRequire("7AQlJ");

var $69FLM = parcelRequire("69FLM");
const $bb060d5a73d8b8a0$var$panelSplitterResizingVar = '--n_pnlRsz';
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ const $bb060d5a73d8b8a0$var$fallbackResizeMinWidth = 400;
const $bb060d5a73d8b8a0$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
    border: "_191wglyw _16qs1cd0 _1w6ezgxb _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw",
    oldMobileWidth: "_1bsb1adv",
    newMobileWidth: "_1bsb1dxx"
};
function $bb060d5a73d8b8a0$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = (0, $eGOwo.fg)('platform_design_system_nav4_panel_default_border') }) {
    const dangerouslyHoistSlotSizes = (0, $eJOHy.useContext)((0, $ebZBs.DangerouslyHoistSlotSizes));
    const id = (0, $ipWav.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $13z4V.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $eJOHy.useRef)(null);
    const [width, setWidth] = (0, $eJOHy.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $eJOHy.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $eJOHy.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $7AQlJ.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ const minWidth = Math.min(defaultWidth, $bb060d5a73d8b8a0$var$fallbackResizeMinWidth);
    /**
   * Returns the bounds for resizing, evaluated lazily when needed.
   *
   * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
   * and the panel's slot bounds use a complex CSS expression.
   */ const getResizeBounds = (0, $eJOHy.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
        /**
     * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     */ const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${(0, $2SN4F.sideNavLiveWidthVar)}, 0px)) / 2), 1px)`
    };
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $69FLM.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $eGOwo.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        cssVar: $bb060d5a73d8b8a0$var$panelSplitterResizingVar,
        panelId: (0, $2SN4F.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $hcewu.default)([
            $bb060d5a73d8b8a0$var$styles.root,
            defaultWidth === 0 && $bb060d5a73d8b8a0$var$styles.hidden,
            hasBorder && $bb060d5a73d8b8a0$var$styles.border,
            (0, $eGOwo.fg)('platform_design_system_nav4_panel_mobile_width_fix') ? $bb060d5a73d8b8a0$var$styles.newMobileWidth : $bb060d5a73d8b8a0$var$styles.oldMobileWidth,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $2SN4F.panelVar)]: panelVariableWidth,
            '--minWidth': (0, $eGOwo.fg)('platform_design_system_nav4_panel_mobile_width_fix') ? `${minWidth}px` : undefined
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvM7a.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $2SN4F.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, $6efFi.media).above.lg,
                responsiveValue: (0, $eGOwo.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$bb060d5a73d8b8a0$var$panelSplitterResizingVar}, ${panelVariableWidth})` : panelVariableWidth
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $glIca.PanelSplitterProvider), {
                panelId: (0, $2SN4F.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: getResizeBounds,
                resizingCssVar: $bb060d5a73d8b8a0$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $bb060d5a73d8b8a0$var$styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}

});

parcelRegister("9Qwez", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $406c6d91abd411ba$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4eDgu = parcelRequire("4eDgu");

var $aQK2r = parcelRequire("aQK2r");

var $gyJTO = parcelRequire("gyJTO");

var $7jn0p = parcelRequire("7jn0p");
var $gjgfe = parcelRequire("gjgfe");

var $eGOwo = parcelRequire("eGOwo");

var $bGx3v = parcelRequire("bGx3v");

var $6efFi = parcelRequire("6efFi");

var $13z4V = parcelRequire("13z4V");

var $20qbW = parcelRequire("20qbW");

var $2SN4F = parcelRequire("2SN4F");

var $ebZBs = parcelRequire("ebZBs");

var $bvM7a = parcelRequire("bvM7a");

var $ipWav = parcelRequire("ipWav");

var $glIca = parcelRequire("glIca");

var $69FLM = parcelRequire("69FLM");

var $7AQlJ = parcelRequire("7AQlJ");


var $kyFWW = parcelRequire("kyFWW");

var $ceCqR = parcelRequire("ceCqR");

var $7si67 = parcelRequire("7si67");

var $a3nzS = parcelRequire("a3nzS");

var $9Sckd = parcelRequire("9Sckd");

var $k7eMS = parcelRequire("k7eMS");
const $406c6d91abd411ba$var$panelSplitterResizingVar = '--n_snvRsz';
const $406c6d91abd411ba$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $406c6d91abd411ba$var$getResizeBounds() {
    return $406c6d91abd411ba$var$widthResizeBounds;
}
const $406c6d91abd411ba$var$openLayerObserverSideNavNamespace = 'side-nav';
const $406c6d91abd411ba$var$styles = {
    root: "_nd5l1b6c _bfhk1bhr _16qs1cd0 _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    oldBorder: "_t51zzgxb",
    newBorder: "_191wglyw _t51zglyw _p5clzgxb",
    newBorderFlyoutOpen: "_p5clglyw",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $406c6d91abd411ba$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, id: providedId }) {
    const id = (0, $ipWav.useLayoutId)({
        providedId: providedId
    });
    const expandSideNav = (0, $ceCqR.useExpandSideNav)();
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ const synchronouslyExpandSideNav = (0, $eJOHy.useCallback)(()=>{
        (0, $aQK2r.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $13z4V.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    const sideNavState = (0, $eJOHy.useContext)((0, $k7eMS.SideNavVisibilityState));
    const setSideNavState = (0, $eJOHy.useContext)((0, $k7eMS.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $7si67.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $eJOHy.useState)(defaultCollapsed);
    const [width, setWidth] = (0, $eJOHy.useState)(defaultWidth);
    const clampedWidth = `clamp(${$406c6d91abd411ba$var$widthResizeBounds.min}, ${width}px, ${$406c6d91abd411ba$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $eJOHy.useContext)((0, $ebZBs.DangerouslyHoistSlotSizes));
    const navRef = (0, $eJOHy.useRef)(null);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ const sharedRef = (0, $7AQlJ.useSideNavRef)();
    const mergedRef = (0, $gyJTO.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $eJOHy.useContext)((0, $kyFWW.SideNavToggleButtonElement));
    const topNavStartElement = (0, $eJOHy.useContext)((0, $20qbW.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $gjgfe.useOpenLayerObserver)();
    const flyoutStateRef = (0, $eJOHy.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const updateFlyoutState = (0, $eJOHy.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'open'
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $8b23ddd9ac8df64b$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount({
                    namespace: $406c6d91abd411ba$var$openLayerObserverSideNavNamespace
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibility = (0, $9Sckd.useToggleSideNav)();
    (0, $eJOHy.useEffect)(()=>{
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed'
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    const handleExpand = (0, $eJOHy.useCallback)(({ screen: screen })=>{
        onExpand?.({
            screen: screen
        });
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState
    ]);
    const handleCollapse = (0, $eJOHy.useCallback)(({ screen: screen })=>{
        onCollapse?.({
            screen: screen
        });
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $a3nzS.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $eJOHy.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $4eDgu.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $eJOHy.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        /**
     * The expected URL fragment used by the side nav skip link.
     */ const skipLinkUrlFragment = `#${id}`;
        return (0, $4eDgu.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibility();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibility
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $4eDgu.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $4eDgu.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $4eDgu.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $4eDgu.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $bGx3v.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $4eDgu.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $4eDgu.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: $406c6d91abd411ba$var$openLayerObserverSideNavNamespace
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $69FLM.useResizingWidthCssVarOnRootElement)({
        isEnabled: true,
        cssVar: $406c6d91abd411ba$var$panelSplitterResizingVar,
        panelId: (0, $2SN4F.sideNavPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $2SN4F.sideNavVar)]: clampedWidth
        },
        ref: mergedRef,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $406c6d91abd411ba$var$styles.root,
            (0, $eGOwo.fg)('platform_design_system_nav4_sidenav_border') ? $406c6d91abd411ba$var$styles.newBorder : $406c6d91abd411ba$var$styles.oldBorder,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $406c6d91abd411ba$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $406c6d91abd411ba$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $406c6d91abd411ba$var$styles.hiddenMobileAndDesktop,
            sideNavState?.flyout === 'open' && $406c6d91abd411ba$var$styles.flyoutOpen,
            sideNavState?.flyout === 'open' && (0, $eGOwo.fg)('platform_design_system_nav4_sidenav_border') && $406c6d91abd411ba$var$styles.newBorderFlyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && $406c6d91abd411ba$var$styles.flyoutAnimateClosed
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvM7a.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $2SN4F.sideNavLiveWidthVar),
                value: "0px",
                mediaQuery: (0, $6efFi.media).above.md,
                responsiveValue: isExpandedOnDesktop ? `var(${$406c6d91abd411ba$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvM7a.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $2SN4F.UNSAFE_sideNavLayoutVar),
                value: `var(${(0, $2SN4F.sideNavLiveWidthVar)})`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $glIca.PanelSplitterProvider), {
                panelId: (0, $2SN4F.sideNavPanelSplitterId),
                panelRef: navRef,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $406c6d91abd411ba$var$getResizeBounds,
                resizingCssVar: $406c6d91abd411ba$var$panelSplitterResizingVar,
                isEnabled: isExpandedOnDesktop && !isFlyoutVisible,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $406c6d91abd411ba$var$styles.flexContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}
function $406c6d91abd411ba$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, id: id }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7jn0p.OpenLayerObserverNamespaceProvider), {
        namespace: $406c6d91abd411ba$var$openLayerObserverSideNavNamespace,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($406c6d91abd411ba$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            id: id,
            children: children
        })
    });
}

});
parcelRegister("7jn0p", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $d63f4ad161a8be65$export$327d0d2a7ae6f7cc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $bKvRZ = parcelRequire("bKvRZ");

var $5aMjU = parcelRequire("5aMjU");
function $d63f4ad161a8be65$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $5aMjU.useOpenLayerObserverNamespace)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $8GOss.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bKvRZ.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}

});

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $8b23ddd9ac8df64b$export$a7801e29f563faad = 400;

parcelRegister("ceCqR", function(module, exports) {

$parcel$export(module.exports, "useExpandSideNav", () => $39139fa3334c84f0$export$e44b4744d8ff971a);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $k7eMS = parcelRequire("k7eMS");
function $39139fa3334c84f0$export$e44b4744d8ff971a() {
    const setSideNavState = (0, $eJOHy.useContext)((0, $k7eMS.SetSideNavVisibilityState));
    const expandSideNav = (0, $eJOHy.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $8GOss.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $8GOss.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}

});

parcelRegister("a3nzS", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $0e3e81e25db26ce2$export$1904b8f2577aba9a);

var $eJOHy = parcelRequire("eJOHy");

var $aNllK = parcelRequire("aNllK");
function $0e3e81e25db26ce2$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $eJOHy.useRef)(onExpand);
    const onCollapseRef = (0, $eJOHy.useRef)(onCollapse);
    (0, $eJOHy.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $aNllK.default)(isExpandedOnDesktop);
    (0, $eJOHy.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop'
        });
        else onCollapseRef.current?.({
            screen: 'desktop'
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    const previousIsExpandedOnMobile = (0, $aNllK.default)(isExpandedOnMobile);
    (0, $eJOHy.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile'
        });
        else onCollapseRef.current?.({
            screen: 'mobile'
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}

});


parcelRegister("7zHjm", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $22074c686df4c0e2$export$41d0d88a6b0e456f);
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $13z4V = parcelRequire("13z4V");

var $1CltT = parcelRequire("1CltT");

var $ccegE = parcelRequire("ccegE");

var $2SN4F = parcelRequire("2SN4F");

var $ebZBs = parcelRequire("ebZBs");

var $bvM7a = parcelRequire("bvM7a");

var $ipWav = parcelRequire("ipWav");
const $22074c686df4c0e2$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i1dgc _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi _1j8b18ax"
};
function $22074c686df4c0e2$export$41d0d88a6b0e456f({ children: children, xcss: xcss, height: height = 48, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, UNSAFE_theme: UNSAFE_theme }) {
    const dangerouslyHoistSlotSizes = (0, $eJOHy.useContext)((0, $ebZBs.DangerouslyHoistSlotSizes));
    const id = (0, $ipWav.useLayoutId)({
        providedId: providedId
    });
    (0, $13z4V.useSkipLink)(id, skipLinkLabel);
    const customTheme = (0, $ccegE.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1CltT.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("header", {
            id: id,
            "data-layout-slot": true,
            className: (0, $hcewu.default)([
                $22074c686df4c0e2$var$styles.root,
                xcss
            ]),
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvM7a.HoistCssVarToLocalGrid), {
                    variableName: (0, $2SN4F.topNavMountedVar),
                    value: height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvM7a.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $2SN4F.UNSAFE_topNavVar),
                    value: height
                }),
                children
            ]
        })
    });
}

});
parcelRegister("ccegE", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $01499bbcaf9eb1c1$export$c0c5f5b297b77726);

var $eJOHy = parcelRequire("eJOHy");

var $8HPCF = parcelRequire("8HPCF");
function $01499bbcaf9eb1c1$export$c0c5f5b297b77726(theme) {
    const value = (0, $eJOHy.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $8HPCF.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("8HPCF", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", () => $ef10ba051f0dcceb$export$3986d75fe2da3239);

var $7xGCb = parcelRequire("7xGCb");

var $ep9wj = parcelRequire("ep9wj");

var $jd8tW = parcelRequire("jd8tW");

var $d8TcJ = parcelRequire("d8TcJ");

var $l9Ro5 = parcelRequire("l9Ro5");

var $lwPZB = parcelRequire("lwPZB");
function $ef10ba051f0dcceb$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $ef10ba051f0dcceb$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $ef10ba051f0dcceb$var$buttonStyles = {
    light: {
        [(0, $ep9wj.themedButtonBackground)]: 'transparent',
        [(0, $ep9wj.themedButtonBackgroundHovered)]: (0, $l9Ro5.palette).Neutral200A,
        [(0, $ep9wj.themedButtonBackgroundPressed)]: (0, $l9Ro5.palette).Neutral300A,
        [(0, $ep9wj.themedButtonBorder)]: (0, $l9Ro5.palette).Neutral300A,
        [(0, $ep9wj.themedButtonSelectedBackground)]: (0, $l9Ro5.palette).Neutral300A,
        [(0, $ep9wj.themedButtonSelectedBackgroundHovered)]: (0, $l9Ro5.palette).Neutral400A,
        [(0, $ep9wj.themedButtonSelectedBackgroundPressed)]: (0, $l9Ro5.palette).Neutral500A,
        [(0, $ep9wj.themedButtonDisabledText)]: (0, $l9Ro5.palette).Neutral400A,
        [(0, $ep9wj.themedButtonDisabledBackground)]: (0, $l9Ro5.palette).Neutral100A
    },
    dark: {
        [(0, $ep9wj.themedButtonBackground)]: 'transparent',
        [(0, $ep9wj.themedButtonBackgroundHovered)]: (0, $l9Ro5.palette).DarkNeutral200A,
        [(0, $ep9wj.themedButtonBackgroundPressed)]: (0, $l9Ro5.palette).DarkNeutral300A,
        [(0, $ep9wj.themedButtonBorder)]: (0, $l9Ro5.palette).DarkNeutral300A,
        [(0, $ep9wj.themedButtonSelectedBackground)]: (0, $l9Ro5.palette).DarkNeutral300A,
        [(0, $ep9wj.themedButtonSelectedBackgroundHovered)]: (0, $l9Ro5.palette).DarkNeutral400A,
        [(0, $ep9wj.themedButtonSelectedBackgroundPressed)]: (0, $l9Ro5.palette).DarkNeutral500A,
        [(0, $ep9wj.themedButtonDisabledText)]: (0, $l9Ro5.palette).DarkNeutral400A,
        [(0, $ep9wj.themedButtonDisabledBackground)]: (0, $l9Ro5.palette).DarkNeutral100A
    }
};
const $ef10ba051f0dcceb$var$logoStyles = {
    light: {
        [(0, $7xGCb.themedLogoIcon)]: (0, $l9Ro5.palette).DarkNeutral0,
        [(0, $7xGCb.themedLogoText)]: (0, $l9Ro5.palette).DarkNeutral0
    },
    dark: {
        [(0, $7xGCb.themedLogoIcon)]: (0, $l9Ro5.palette).Neutral0,
        [(0, $7xGCb.themedLogoText)]: (0, $l9Ro5.palette).Neutral0
    }
};
function $ef10ba051f0dcceb$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $d8TcJ.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $d8TcJ.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $jd8tW.getTextColor)(backgroundRgb);
    const colorMode = (0, $jd8tW.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $jd8tW.getTextColor)(highlightRgb);
    return {
        backgroundColor: $ef10ba051f0dcceb$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$ef10ba051f0dcceb$var$buttonStyles[colorMode],
        ...$ef10ba051f0dcceb$var$logoStyles[colorMode],
        ...$ef10ba051f0dcceb$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $lwPZB.themedSearchBorder)]: $ef10ba051f0dcceb$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $lwPZB.themedSearchBorderFocused)]: $ef10ba051f0dcceb$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ [(0, $ep9wj.themedButtonPrimaryBackground)]: $ef10ba051f0dcceb$var$toRGBString(highlightRgb),
        [(0, $ep9wj.themedButtonPrimaryBackgroundHovered)]: $ef10ba051f0dcceb$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        [(0, $ep9wj.themedButtonPrimaryBackgroundPressed)]: $ef10ba051f0dcceb$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        [(0, $ep9wj.themedButtonPrimaryText)]: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $ef10ba051f0dcceb$var$selectedBackgroundRGBA = {
    light: (0, $l9Ro5.paletteRgba).Neutral300A,
    dark: (0, $l9Ro5.paletteRgba).DarkNeutral300A
};
function $ef10ba051f0dcceb$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $ef10ba051f0dcceb$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $jd8tW.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        [(0, $ep9wj.themedButtonSelectedText)]: (0, $jd8tW.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        [(0, $ep9wj.themedButtonSelectedBorder)]: (0, $jd8tW.isLight)(blendedBackground) ? (0, $l9Ro5.palette).Neutral1100 : (0, $l9Ro5.palette).DarkNeutral1100
    };
}

});
parcelRegister("jd8tW", function(module, exports) {

$parcel$export(module.exports, "isLight", () => $f2c0406521b9127a$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $f2c0406521b9127a$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $f2c0406521b9127a$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $f2c0406521b9127a$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $f2c0406521b9127a$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $f2c0406521b9127a$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $f2c0406521b9127a$var$linearizeRGBChannel(normal.r),
        g: $f2c0406521b9127a$var$linearizeRGBChannel(normal.g),
        b: $f2c0406521b9127a$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $f2c0406521b9127a$var$flipLuminance = 0.179129;
function $f2c0406521b9127a$export$44af652f4cca9039(color) {
    return $f2c0406521b9127a$var$relativeLuminanceW3C(color) >= $f2c0406521b9127a$var$flipLuminance;
}
function $f2c0406521b9127a$export$5573a5bab3e074b5(backgroundColor) {
    if ($f2c0406521b9127a$var$relativeLuminanceW3C(backgroundColor) >= $f2c0406521b9127a$var$flipLuminance) return 'light';
    return 'dark';
}
const $f2c0406521b9127a$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $f2c0406521b9127a$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $f2c0406521b9127a$export$5573a5bab3e074b5(backgroundColor);
    return $f2c0406521b9127a$var$textColor[colorMode];
}
function $f2c0406521b9127a$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("d8TcJ", function(module, exports) {

$parcel$export(module.exports, "parseHex", () => $a9a66506d4858ab0$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $a9a66506d4858ab0$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $a9a66506d4858ab0$export$103711ef09c6edec(color) {
    if (!$a9a66506d4858ab0$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("l9Ro5", function(module, exports) {

$parcel$export(module.exports, "palette", () => $549ba51d60aadfe0$export$eaad8caa32d2521d);
$parcel$export(module.exports, "paletteRgba", () => $549ba51d60aadfe0$export$c9b84419dae66a82);
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ const $549ba51d60aadfe0$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
const $549ba51d60aadfe0$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});







parcelRegister("dZidf", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $b09755e6dde7543f$export$ee1cb2a8280d8710);

var $eJOHy = parcelRequire("eJOHy");

var $2eOKX = parcelRequire("2eOKX");

var $2QUmO = parcelRequire("2QUmO");
const $b09755e6dde7543f$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $2eOKX.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $2QUmO.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("2QUmO", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $602ff2c1b8bdf3ea$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $602ff2c1b8bdf3ea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $602ff2c1b8bdf3ea$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $602ff2c1b8bdf3ea$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$602ff2c1b8bdf3ea$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $602ff2c1b8bdf3ea$export$2e2bcd8739ae039 = $602ff2c1b8bdf3ea$var$withInjectedProps;

});



parcelRegister("96Zbc", function(module, exports) {

$parcel$export(module.exports, "BackgroundColourNudgeAsync", () => $c53823e8e34942b9$export$a3dbb521061a599a);

var $eJOHy = parcelRequire("eJOHy");

var $kMreM = parcelRequire("kMreM");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c53823e8e34942b9$var$BackgroundColourNudgeLazy = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("jlQjR")).then((exportedModule)=>exportedModule.BackgroundColourNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges-jwm-background-color/src/index.tsx"
});
const $c53823e8e34942b9$export$a3dbb521061a599a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kMreM.OnboardingNudgeErrorBoundary), {
        id: (0, $90edc6fabc8ce084$export$eb0b199de90a7ec2),
        fallback: children,
        attributes: {
            nudgeId: (0, $90edc6fabc8ce084$export$eb0b199de90a7ec2)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "background-colour-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c53823e8e34942b9$var$BackgroundColourNudgeLazy, null, children)));
$c53823e8e34942b9$export$a3dbb521061a599a.displayName = 'BackgroundColourNudgeAsync';

});
parcelRegister("kMreM", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $373b41d996461548$export$3915a8814b99f0b);

var $eJOHy = parcelRequire("eJOHy");

var $hLlIx = parcelRequire("hLlIx");

var $9ycBx = parcelRequire("9ycBx");
const $373b41d996461548$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hLlIx.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $9ycBx.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("hLlIx", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $8e7d43321aea4f70$export$9171acf2e93b7d4d);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $eYe3w = parcelRequire("eYe3w");
const $8e7d43321aea4f70$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $eYe3w.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("eYe3w", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $638881997835b97e$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $638881997835b97e$export$807be5f3f1ea996);

var $eJOHy = parcelRequire("eJOHy");

var $7Jk3f = parcelRequire("7Jk3f");
const $638881997835b97e$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7Jk3f.isLoaderError)(error)
    });
const $638881997835b97e$export$807be5f3f1ea996 = (attributes = {})=>(0, $eJOHy.useCallback)((error)=>({
            ...attributes,
            ...$638881997835b97e$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});


parcelRegister("9ycBx", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $9b4ef256583f1ea3$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $9b4ef256583f1ea3$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $9b4ef256583f1ea3$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $9b4ef256583f1ea3$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $9b4ef256583f1ea3$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $9b4ef256583f1ea3$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $9b4ef256583f1ea3$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $9b4ef256583f1ea3$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $9b4ef256583f1ea3$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $9b4ef256583f1ea3$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $9b4ef256583f1ea3$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $9b4ef256583f1ea3$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $9b4ef256583f1ea3$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $9b4ef256583f1ea3$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $9b4ef256583f1ea3$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $9b4ef256583f1ea3$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $9b4ef256583f1ea3$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $9b4ef256583f1ea3$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $9b4ef256583f1ea3$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $9b4ef256583f1ea3$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $9b4ef256583f1ea3$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $9b4ef256583f1ea3$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $9b4ef256583f1ea3$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $9b4ef256583f1ea3$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $9b4ef256583f1ea3$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $9b4ef256583f1ea3$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $9b4ef256583f1ea3$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $9b4ef256583f1ea3$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $9b4ef256583f1ea3$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $9b4ef256583f1ea3$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $9b4ef256583f1ea3$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $9b4ef256583f1ea3$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $9b4ef256583f1ea3$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $9b4ef256583f1ea3$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $9b4ef256583f1ea3$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $9b4ef256583f1ea3$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $9b4ef256583f1ea3$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $9b4ef256583f1ea3$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $9b4ef256583f1ea3$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $9b4ef256583f1ea3$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $9b4ef256583f1ea3$export$9048315f2c03fd9d);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $9b4ef256583f1ea3$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $9b4ef256583f1ea3$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $9b4ef256583f1ea3$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $9b4ef256583f1ea3$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $9b4ef256583f1ea3$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $9b4ef256583f1ea3$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $9b4ef256583f1ea3$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $9b4ef256583f1ea3$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $9b4ef256583f1ea3$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $9b4ef256583f1ea3$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $9b4ef256583f1ea3$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $9b4ef256583f1ea3$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $9b4ef256583f1ea3$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $9b4ef256583f1ea3$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $9b4ef256583f1ea3$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $9b4ef256583f1ea3$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $9b4ef256583f1ea3$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $9b4ef256583f1ea3$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $9b4ef256583f1ea3$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $9b4ef256583f1ea3$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $9b4ef256583f1ea3$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $9b4ef256583f1ea3$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $9b4ef256583f1ea3$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $9b4ef256583f1ea3$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $9b4ef256583f1ea3$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $9b4ef256583f1ea3$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $9b4ef256583f1ea3$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $9b4ef256583f1ea3$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $9b4ef256583f1ea3$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $9b4ef256583f1ea3$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $9b4ef256583f1ea3$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $9b4ef256583f1ea3$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $9b4ef256583f1ea3$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $9b4ef256583f1ea3$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $9b4ef256583f1ea3$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $9b4ef256583f1ea3$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $9b4ef256583f1ea3$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $9b4ef256583f1ea3$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $9b4ef256583f1ea3$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $9b4ef256583f1ea3$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $9b4ef256583f1ea3$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $9b4ef256583f1ea3$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $9b4ef256583f1ea3$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $9b4ef256583f1ea3$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $9b4ef256583f1ea3$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $9b4ef256583f1ea3$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $9b4ef256583f1ea3$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $9b4ef256583f1ea3$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $9b4ef256583f1ea3$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $9b4ef256583f1ea3$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $9b4ef256583f1ea3$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $9b4ef256583f1ea3$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $9b4ef256583f1ea3$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $9b4ef256583f1ea3$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $9b4ef256583f1ea3$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $9b4ef256583f1ea3$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $9b4ef256583f1ea3$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $9b4ef256583f1ea3$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $9b4ef256583f1ea3$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $9b4ef256583f1ea3$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $9b4ef256583f1ea3$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $9b4ef256583f1ea3$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $9b4ef256583f1ea3$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $9b4ef256583f1ea3$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $9b4ef256583f1ea3$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $9b4ef256583f1ea3$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $9b4ef256583f1ea3$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $9b4ef256583f1ea3$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $9b4ef256583f1ea3$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $9b4ef256583f1ea3$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $9b4ef256583f1ea3$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $9b4ef256583f1ea3$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $9b4ef256583f1ea3$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $9b4ef256583f1ea3$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $9b4ef256583f1ea3$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $9b4ef256583f1ea3$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $9b4ef256583f1ea3$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $9b4ef256583f1ea3$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $9b4ef256583f1ea3$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $9b4ef256583f1ea3$export$5980f41aa657f9c7);

var $ljej9 = parcelRequire("ljej9");
const $9b4ef256583f1ea3$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $9b4ef256583f1ea3$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $9b4ef256583f1ea3$export$2b3151a089bc8780 = 'jlove-makkuro';
const $9b4ef256583f1ea3$export$6826d33e9a2c0119 = 320;
const $9b4ef256583f1ea3$export$b580da85daad7757 = 'root';
const $9b4ef256583f1ea3$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $9b4ef256583f1ea3$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $9b4ef256583f1ea3$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $9b4ef256583f1ea3$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $9b4ef256583f1ea3$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $9b4ef256583f1ea3$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $9b4ef256583f1ea3$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $9b4ef256583f1ea3$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $9b4ef256583f1ea3$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $9b4ef256583f1ea3$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $9b4ef256583f1ea3$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $9b4ef256583f1ea3$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $9b4ef256583f1ea3$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $9b4ef256583f1ea3$export$cbeb719208f32c8a = $9b4ef256583f1ea3$var$completeJswTaskName('add-columns-task');
const $9b4ef256583f1ea3$export$88c918f2cfaff86 = $9b4ef256583f1ea3$var$completeJswTaskName('create-project-task');
const $9b4ef256583f1ea3$export$abbbea7c37c93cb5 = $9b4ef256583f1ea3$var$completeJswTaskName('create-issue-task');
const $9b4ef256583f1ea3$export$2a0253cb20f48a8 = $9b4ef256583f1ea3$var$completeJswTaskName('create-issue-task-simplified');
const $9b4ef256583f1ea3$export$f97428bb4b1991ec = $9b4ef256583f1ea3$var$completeJswTaskName('invite-teammates-task');
const $9b4ef256583f1ea3$export$45eaf4204fcc7 = $9b4ef256583f1ea3$var$completeJswTaskName('invite-teammates-video-task');
const $9b4ef256583f1ea3$export$af57685e201438e8 = $9b4ef256583f1ea3$var$completeJswTaskName('capture-integrations-task');
const $9b4ef256583f1ea3$export$d6c67e9aab4e2b26 = $9b4ef256583f1ea3$var$completeJswTaskName('find-help-task');
const $9b4ef256583f1ea3$export$3de8c242d2b82f26 = $9b4ef256583f1ea3$var$completeJswTaskName('set-up-board-task');
const $9b4ef256583f1ea3$export$a01fa44f793dbfac = $9b4ef256583f1ea3$var$completeJswTaskName('get-mobile-app-task');
const $9b4ef256583f1ea3$export$6a4507e462fd41da = $9b4ef256583f1ea3$var$completeJswTaskName('map-out-your-project-goals');
const $9b4ef256583f1ea3$export$e64c1dced6ac4458 = $9b4ef256583f1ea3$var$completeJswTaskName('identify-small-chunks-of-work');
const $9b4ef256583f1ea3$export$63b0e55f9c6454ac = $9b4ef256583f1ea3$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $9b4ef256583f1ea3$export$c1effb1c8979fe22 = $9b4ef256583f1ea3$var$completeJswTaskName('monitor-manage-risk');
const $9b4ef256583f1ea3$export$d97d31d934dbb194 = $9b4ef256583f1ea3$var$completeJswTaskName('premium-reverse-trial-task');
const $9b4ef256583f1ea3$export$cafb5bd13b02056b = $9b4ef256583f1ea3$var$completeJswTaskName('premium-edition-overview-task');
const $9b4ef256583f1ea3$export$e55c18b809946e72 = $9b4ef256583f1ea3$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $9b4ef256583f1ea3$export$de5640b9ae8140a7 = $9b4ef256583f1ea3$var$completeJswTaskName('standard-edition-overview-task');
const $9b4ef256583f1ea3$export$540b5c3c4b6ce459 = $9b4ef256583f1ea3$var$completeJswTaskName('advanced-roadmaps-task');
const $9b4ef256583f1ea3$export$6f71dff531ff592 = $9b4ef256583f1ea3$var$completeJswTaskName('change-control-task');
const $9b4ef256583f1ea3$export$83255ab79e45f34f = $9b4ef256583f1ea3$var$completeJswTaskName('automations-task');
const $9b4ef256583f1ea3$export$b57d172af9ad7647 = $9b4ef256583f1ea3$var$completeJswTaskName('site-administrations-task');
const $9b4ef256583f1ea3$export$ff4c933c1fe90b68 = $9b4ef256583f1ea3$var$completeJswTaskName('user-management-task');
const $9b4ef256583f1ea3$export$3e2776d61f3662dc = $9b4ef256583f1ea3$var$completeJswTaskName('scrum-onboarding-task');
const $9b4ef256583f1ea3$export$9048315f2c03fd9d = $9b4ef256583f1ea3$var$completeJswTaskName('customize-site-name-task');
const $9b4ef256583f1ea3$export$4145c2cec2da6f9b = $9b4ef256583f1ea3$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $9b4ef256583f1ea3$export$4957a1ad203cf6dd = $9b4ef256583f1ea3$var$completeJswTaskName('try-atlassian-university-task');
const $9b4ef256583f1ea3$export$190b5dd0a1322552 = $9b4ef256583f1ea3$var$completeJswTaskName('calendar-view-task');
const $9b4ef256583f1ea3$export$501166b25f254aab = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-project-summary-task');
const $9b4ef256583f1ea3$export$94ad6507a703f4eb = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-create-sample-project-task');
const $9b4ef256583f1ea3$export$be1c522400a1bd7c = $9b4ef256583f1ea3$var$completeJwmTaskName('background-color-task');
const $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5 = $9b4ef256583f1ea3$var$completeJwmTaskName('calendar-task');
const $9b4ef256583f1ea3$export$f3b53199b07af2a1 = $9b4ef256583f1ea3$var$completeJwmTaskName('timeline-task');
const $9b4ef256583f1ea3$export$d37415ffddcf2142 = $9b4ef256583f1ea3$var$completeJwmTaskName('build-form-task');
const $9b4ef256583f1ea3$export$2ae00586da7cb606 = $9b4ef256583f1ea3$var$completeJwmTaskName('feedback-task');
const $9b4ef256583f1ea3$export$b86266e6594a97bb = $9b4ef256583f1ea3$var$completeJwmTaskName('feedback-sample-project-task');
const $9b4ef256583f1ea3$export$20bc3dc137ac1c38 = $9b4ef256583f1ea3$var$completeJwmTaskName('create-your-own-project-task');
const $9b4ef256583f1ea3$export$77071b77e2801b18 = $9b4ef256583f1ea3$var$completeJwmTaskName('jwm-create-project-task');
const $9b4ef256583f1ea3$export$9c89f946f05d884a = $9b4ef256583f1ea3$var$completeJwmTaskName('share-project-task');
const $9b4ef256583f1ea3$export$b52a7c936684cfc5 = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-import');
const $9b4ef256583f1ea3$export$b5555f24061f9fb = $9b4ef256583f1ea3$var$completeJwmTaskName('summary-and-reports-task');
const $9b4ef256583f1ea3$export$ff25449f34b8abf = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $9b4ef256583f1ea3$export$3380e677209260fe = $9b4ef256583f1ea3$var$completeJwmTaskName('trello-crossflow-key-differences');
const $9b4ef256583f1ea3$export$7a2fcaad1564e6b7 = $9b4ef256583f1ea3$var$completeJwmTaskName('get-started-list-task');
const $9b4ef256583f1ea3$export$da23b72d32bfad9e = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $9b4ef256583f1ea3$export$4b064659282e0238 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $9b4ef256583f1ea3$export$3ab51851f6d823e = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $9b4ef256583f1ea3$export$e4a1a37a9a1350ad = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $9b4ef256583f1ea3$export$b7f7da5e795f0327 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $9b4ef256583f1ea3$export$80a401c1aa47a377 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $9b4ef256583f1ea3$export$934ac7a251b26dc7 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $9b4ef256583f1ea3$export$4634f6395df3ebbe = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $9b4ef256583f1ea3$export$768fb41107a1e8d7 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $9b4ef256583f1ea3$export$d797a81bace17184 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $9b4ef256583f1ea3$export$746102c94db9df1f = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $9b4ef256583f1ea3$export$5f1efd797d65e349 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $9b4ef256583f1ea3$export$cccc812ccafbf11f = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $9b4ef256583f1ea3$export$64822db87abd8a47 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $9b4ef256583f1ea3$export$64f764d8be495c82 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $9b4ef256583f1ea3$export$24eae23dc1c68bbd = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $9b4ef256583f1ea3$export$50fa92eba6f82feb = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $9b4ef256583f1ea3$export$4155d22fe3f14cd6 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $9b4ef256583f1ea3$export$76813cbead887191 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $9b4ef256583f1ea3$export$90aab2ff89daf770 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $9b4ef256583f1ea3$export$a2bc0cbad2e6e605 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $9b4ef256583f1ea3$export$f90872a1280728bb = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $9b4ef256583f1ea3$export$bce644e96518cbd2 = $9b4ef256583f1ea3$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $9b4ef256583f1ea3$export$241aaebffac0a3e5 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $9b4ef256583f1ea3$export$79759e9e62fb9312 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $9b4ef256583f1ea3$export$992d1e0dce255d19 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $9b4ef256583f1ea3$export$d28c1b0e5b3e768 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $9b4ef256583f1ea3$export$ca714ee197bed4ec = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $9b4ef256583f1ea3$export$faae55ceea4b6073 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $9b4ef256583f1ea3$export$200bc24cd120667e = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $9b4ef256583f1ea3$export$a0d784a48b4e886c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $9b4ef256583f1ea3$export$baf5bd09b4b33b8a = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $9b4ef256583f1ea3$export$4702007eedbca8ab = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $9b4ef256583f1ea3$export$aa9d2d635ea63898 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $9b4ef256583f1ea3$export$2ea449225c1f6cac = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $9b4ef256583f1ea3$export$deb8b557e735e26a = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $9b4ef256583f1ea3$export$d45754df44e4c309 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $9b4ef256583f1ea3$export$78b2913b550edbb = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $9b4ef256583f1ea3$export$71243272608c58ab = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $9b4ef256583f1ea3$export$39a08f215c33bc39 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $9b4ef256583f1ea3$export$d2377f6a6fa3b49c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $9b4ef256583f1ea3$export$befa8f6533309779 = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $9b4ef256583f1ea3$export$736b40db8701ba6c = $9b4ef256583f1ea3$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $9b4ef256583f1ea3$export$11eff6ae2f70b67b = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $9b4ef256583f1ea3$export$fb2d23e5315a67a9 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $9b4ef256583f1ea3$export$32e794bb49d60b6 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $9b4ef256583f1ea3$export$fed256238b27db06 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $9b4ef256583f1ea3$export$132eecb4d35a590d = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $9b4ef256583f1ea3$export$2579c51cadd45eca = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $9b4ef256583f1ea3$export$4b1a0cefa966ea0 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $9b4ef256583f1ea3$export$f6558daacc312a65 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $9b4ef256583f1ea3$export$925efa2e24e86b88 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $9b4ef256583f1ea3$export$40454d3e062dcd44 = $9b4ef256583f1ea3$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $9b4ef256583f1ea3$export$99b0e09ff6f00490 = $9b4ef256583f1ea3$var$completeJsmTaskName('customize-your-request-types-task');
const $9b4ef256583f1ea3$export$2a82344eb273eeff = $9b4ef256583f1ea3$var$completeJsmTaskName('review-your-channels-task');
const $9b4ef256583f1ea3$export$1de5766b7e640d6b = $9b4ef256583f1ea3$var$completeJsmTaskName('invite-your-team-task');
const $9b4ef256583f1ea3$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $9b4ef256583f1ea3$export$c8ab6996f562d0db = (0, $ljej9.toAccountId)('accountId');
const $9b4ef256583f1ea3$export$2b5f951ad8e70cfe = $9b4ef256583f1ea3$var$completeJswTaskName('kanban-onboarding-task');
const $9b4ef256583f1ea3$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $9b4ef256583f1ea3$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $9b4ef256583f1ea3$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $9b4ef256583f1ea3$export$38fbac7a5bf4aa33 = [
    $9b4ef256583f1ea3$export$2a82344eb273eeff,
    $9b4ef256583f1ea3$export$99b0e09ff6f00490,
    $9b4ef256583f1ea3$export$1de5766b7e640d6b
];
const $9b4ef256583f1ea3$export$7578902c7f420a3 = [
    $9b4ef256583f1ea3$export$88c918f2cfaff86,
    $9b4ef256583f1ea3$export$6a4507e462fd41da,
    $9b4ef256583f1ea3$export$e64c1dced6ac4458,
    $9b4ef256583f1ea3$export$63b0e55f9c6454ac,
    $9b4ef256583f1ea3$export$c1effb1c8979fe22,
    $9b4ef256583f1ea3$export$cbeb719208f32c8a,
    $9b4ef256583f1ea3$export$abbbea7c37c93cb5,
    $9b4ef256583f1ea3$export$2a0253cb20f48a8,
    $9b4ef256583f1ea3$export$f97428bb4b1991ec,
    $9b4ef256583f1ea3$export$d6c67e9aab4e2b26,
    $9b4ef256583f1ea3$export$3de8c242d2b82f26,
    $9b4ef256583f1ea3$export$a01fa44f793dbfac,
    $9b4ef256583f1ea3$export$45eaf4204fcc7,
    $9b4ef256583f1ea3$export$af57685e201438e8,
    $9b4ef256583f1ea3$export$d97d31d934dbb194,
    $9b4ef256583f1ea3$export$cafb5bd13b02056b,
    $9b4ef256583f1ea3$export$e55c18b809946e72,
    $9b4ef256583f1ea3$export$de5640b9ae8140a7,
    $9b4ef256583f1ea3$export$540b5c3c4b6ce459,
    $9b4ef256583f1ea3$export$6f71dff531ff592,
    $9b4ef256583f1ea3$export$83255ab79e45f34f,
    $9b4ef256583f1ea3$export$b57d172af9ad7647,
    $9b4ef256583f1ea3$export$ff4c933c1fe90b68,
    $9b4ef256583f1ea3$export$77071b77e2801b18,
    $9b4ef256583f1ea3$export$94ad6507a703f4eb,
    $9b4ef256583f1ea3$export$501166b25f254aab,
    $9b4ef256583f1ea3$export$be1c522400a1bd7c,
    $9b4ef256583f1ea3$export$2aa6e7b6e24a04f5,
    $9b4ef256583f1ea3$export$f3b53199b07af2a1,
    $9b4ef256583f1ea3$export$d37415ffddcf2142,
    $9b4ef256583f1ea3$export$2ae00586da7cb606,
    $9b4ef256583f1ea3$export$9c89f946f05d884a,
    $9b4ef256583f1ea3$export$20bc3dc137ac1c38,
    $9b4ef256583f1ea3$export$b52a7c936684cfc5,
    $9b4ef256583f1ea3$export$b5555f24061f9fb,
    $9b4ef256583f1ea3$export$ff25449f34b8abf,
    $9b4ef256583f1ea3$export$3380e677209260fe,
    $9b4ef256583f1ea3$export$b86266e6594a97bb,
    $9b4ef256583f1ea3$export$3e2776d61f3662dc,
    $9b4ef256583f1ea3$export$2b5f951ad8e70cfe,
    $9b4ef256583f1ea3$export$9048315f2c03fd9d,
    $9b4ef256583f1ea3$export$4145c2cec2da6f9b,
    $9b4ef256583f1ea3$export$4957a1ad203cf6dd,
    $9b4ef256583f1ea3$export$7a2fcaad1564e6b7,
    $9b4ef256583f1ea3$export$190b5dd0a1322552,
    $9b4ef256583f1ea3$export$da23b72d32bfad9e,
    $9b4ef256583f1ea3$export$4b064659282e0238,
    $9b4ef256583f1ea3$export$3ab51851f6d823e,
    $9b4ef256583f1ea3$export$e4a1a37a9a1350ad,
    $9b4ef256583f1ea3$export$b7f7da5e795f0327,
    $9b4ef256583f1ea3$export$80a401c1aa47a377,
    $9b4ef256583f1ea3$export$934ac7a251b26dc7,
    $9b4ef256583f1ea3$export$4634f6395df3ebbe,
    $9b4ef256583f1ea3$export$768fb41107a1e8d7,
    $9b4ef256583f1ea3$export$d797a81bace17184,
    $9b4ef256583f1ea3$export$746102c94db9df1f,
    $9b4ef256583f1ea3$export$5f1efd797d65e349,
    $9b4ef256583f1ea3$export$cccc812ccafbf11f,
    $9b4ef256583f1ea3$export$64822db87abd8a47,
    $9b4ef256583f1ea3$export$64f764d8be495c82,
    $9b4ef256583f1ea3$export$24eae23dc1c68bbd,
    $9b4ef256583f1ea3$export$50fa92eba6f82feb,
    $9b4ef256583f1ea3$export$4155d22fe3f14cd6,
    $9b4ef256583f1ea3$export$76813cbead887191,
    $9b4ef256583f1ea3$export$90aab2ff89daf770,
    $9b4ef256583f1ea3$export$a2bc0cbad2e6e605,
    $9b4ef256583f1ea3$export$f90872a1280728bb,
    $9b4ef256583f1ea3$export$bce644e96518cbd2,
    $9b4ef256583f1ea3$export$241aaebffac0a3e5,
    $9b4ef256583f1ea3$export$f9dfc43b5b31c4b7,
    $9b4ef256583f1ea3$export$79759e9e62fb9312,
    $9b4ef256583f1ea3$export$992d1e0dce255d19,
    $9b4ef256583f1ea3$export$d28c1b0e5b3e768,
    $9b4ef256583f1ea3$export$ca714ee197bed4ec,
    $9b4ef256583f1ea3$export$faae55ceea4b6073,
    $9b4ef256583f1ea3$export$200bc24cd120667e,
    $9b4ef256583f1ea3$export$a0d784a48b4e886c,
    $9b4ef256583f1ea3$export$baf5bd09b4b33b8a,
    $9b4ef256583f1ea3$export$4702007eedbca8ab,
    $9b4ef256583f1ea3$export$aa9d2d635ea63898,
    $9b4ef256583f1ea3$export$2ea449225c1f6cac,
    $9b4ef256583f1ea3$export$deb8b557e735e26a,
    $9b4ef256583f1ea3$export$d45754df44e4c309,
    $9b4ef256583f1ea3$export$78b2913b550edbb,
    $9b4ef256583f1ea3$export$71243272608c58ab,
    $9b4ef256583f1ea3$export$39a08f215c33bc39,
    $9b4ef256583f1ea3$export$d2377f6a6fa3b49c,
    $9b4ef256583f1ea3$export$befa8f6533309779,
    $9b4ef256583f1ea3$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $9b4ef256583f1ea3$export$11eff6ae2f70b67b,
    $9b4ef256583f1ea3$export$fb2d23e5315a67a9,
    $9b4ef256583f1ea3$export$32e794bb49d60b6,
    $9b4ef256583f1ea3$export$fed256238b27db06,
    $9b4ef256583f1ea3$export$132eecb4d35a590d,
    $9b4ef256583f1ea3$export$2579c51cadd45eca,
    $9b4ef256583f1ea3$export$4b1a0cefa966ea0,
    $9b4ef256583f1ea3$export$f6558daacc312a65,
    $9b4ef256583f1ea3$export$925efa2e24e86b88,
    $9b4ef256583f1ea3$export$40454d3e062dcd44
];
const $9b4ef256583f1ea3$export$5980f41aa657f9c7 = [
    'SAM1'
];

});


// JWM Background Colour tour
const $90edc6fabc8ce084$export$eb0b199de90a7ec2 = 'backgroundColorNudge';

parcelRegister("jlQjR", function(module, exports) {

let $e1689008fa2c1977$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e1689008fa2c1977$var$load("76n7a"),
    $e1689008fa2c1977$var$load("l253H"),
    $e1689008fa2c1977$var$load("WfAnm")
]).then(()=>parcelRequire('hcuB5'));

});


parcelRegister("55gll", function(module, exports) {

$parcel$export(module.exports, "VIEW_THEME_PICKER_EXPERIENCE", () => $1191a8f52007dae7$export$9a8c95b97c1ee885);
const $1191a8f52007dae7$export$47a1a20f3722c8ce = {
    experience: 'viewThemePicker',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $1191a8f52007dae7$export$9a8c95b97c1ee885 = {
    experience: 'viewThemePicker',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};

});

parcelRegister("1dbbB", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $5004d1aab9c870c6$export$606da7704d8eaf06);
$parcel$export(module.exports, "ExperienceFailed", () => $5004d1aab9c870c6$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceSuccess", () => $5004d1aab9c870c6$export$4962f3898bd5c829);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $1uIew = parcelRequire("1uIew");
const $5004d1aab9c870c6$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, teamName: teamName })=>{
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: experience
    });
    const onFail = (0, $eJOHy.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $1uIew.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $gYnSx.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: analyticsSource,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        analyticsSource,
        teamName
    ]);
    return onFail;
};
const $5004d1aab9c870c6$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $eJOHy.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $5004d1aab9c870c6$export$606da7704d8eaf06(experience);
    (0, $eJOHy.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $5004d1aab9c870c6$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $eJOHy.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));

});

parcelRegister("j2Sb8", function(module, exports) {

$parcel$export(module.exports, "CREATE_CUSTOM_BACKGROUND_EXPERIENCE", () => $fe13b1fb6576f1cd$export$46e0706742711dad);
$parcel$export(module.exports, "UPDATE_ALT_TEXT_EXPERIENCE", () => $fe13b1fb6576f1cd$export$678653f2c10961c5);
$parcel$export(module.exports, "DELETE_CUSTOM_BACKGROUND_EXPERIENCE", () => $fe13b1fb6576f1cd$export$f84f0c56982ddf9a);
$parcel$export(module.exports, "THEME_PICKER_ELEMENT_ID", () => $fe13b1fb6576f1cd$export$8dde8522a4856b87);
const $fe13b1fb6576f1cd$export$91a4460f34f2ee75 = {
    experience: 'createCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $fe13b1fb6576f1cd$export$46e0706742711dad = {
    experience: 'createCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $fe13b1fb6576f1cd$export$3b5b01b3ae53bee3 = {
    experience: 'updateCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $fe13b1fb6576f1cd$export$678653f2c10961c5 = {
    experience: 'updateCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $fe13b1fb6576f1cd$export$da5da525dec4b73a = {
    experience: 'deleteCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $fe13b1fb6576f1cd$export$f84f0c56982ddf9a = {
    experience: 'deleteCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $fe13b1fb6576f1cd$export$8dde8522a4856b87 = 'background-picker-popup-wrapper';

});

parcelRegister("5f6Mn", function(module, exports) {

$parcel$export(module.exports, "ThemePickerButtonItem", () => $155203e7358eb6a6$export$27d1624818d3e0be);

var $eJOHy = parcelRequire("eJOHy");

var $dB1eP = parcelRequire("dB1eP");

var $heseR = parcelRequire("heseR");

var $7saMl = parcelRequire("7saMl");

var $jdqdp = parcelRequire("jdqdp");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $kUoGK = parcelRequire("kUoGK");

var $3AlAh = parcelRequire("3AlAh");
const $155203e7358eb6a6$export$27d1624818d3e0be = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, isSelected: isSelected, testId: testId, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { hasSoftwareTheming: hasSoftwareTheming } = (0, $7jTnu.fg)('jira-theming-discoverability') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kUoGK.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($heseR))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious",
            size: "small"
        }),
        onClick: onClick,
        testId: testId,
        isSelected: isSelected,
        ref: ref,
        ...props
    }, formatMessage((0, $3AlAh.default).setProjectBackgroundMenuItem), hasSoftwareTheming && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $3AlAh.default).newLozengeLabel))));
}));

});
parcelRegister("heseR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7b72e4cfb1948d4b5694556923ff149>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c8b9a611c30fcf17$var$_react = $c8b9a611c30fcf17$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c8b9a611c30fcf17$var$_paintBucket = $c8b9a611c30fcf17$var$_interopRequireDefault((parcelRequire("50CQu")));

var $c8b9a611c30fcf17$var$_backgroundColor = $c8b9a611c30fcf17$var$_interopRequireDefault((parcelRequire("8kJOj")));
function $c8b9a611c30fcf17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PaintBucketIcon.
 * This component is PaintBucketIcon, with `UNSAFE_fallbackIcon` set to "EditorBackgroundColorIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c8b9a611c30fcf17$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $c8b9a611c30fcf17$var$_react.default.createElement($c8b9a611c30fcf17$var$_paintBucket.default, Object.assign({
        LEGACY_fallbackIcon: $c8b9a611c30fcf17$var$_backgroundColor.default
    }, props));
$c8b9a611c30fcf17$var$PaintBucketIcon.Name = 'PaintBucketIconMigration';
var $c8b9a611c30fcf17$var$_default = module.exports.default = $c8b9a611c30fcf17$var$PaintBucketIcon;

});
parcelRegister("50CQu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83080ad07e1bfea64637edcdcb5973cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a5b15c863db925d$var$_react = $3a5b15c863db925d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3a5b15c863db925d$var$_baseNew = $3a5b15c863db925d$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3a5b15c863db925d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a5b15c863db925d$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $3a5b15c863db925d$var$_react.default.createElement($3a5b15c863db925d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.655.095 13.78 8.22a.75.75 0 0 1 0 1.06l-5.616 5.617a2 2 0 0 1-2.828 0L.604 10.164a2 2 0 0 1 0-2.828L5.689 2.25 4.595 1.155zM6.75 3.31 2.06 8h9.38zm4.69 6.19H2.06l4.336 4.335a.5.5 0 0 0 .708 0z" clip-rule="evenodd"/><path fill="currentcolor" d="M14.5 12a.75.75 0 0 0-.654.383v.002l-.003.003-.007.013-.026.046a16 16 0 0 0-.36.695 8 8 0 0 0-.283.642c-.068.176-.167.457-.167.716a1.5 1.5 0 0 0 3 0c0-.259-.1-.54-.167-.716a8 8 0 0 0-.284-.642 16 16 0 0 0-.36-.695l-.025-.046-.007-.013-.002-.004-.001-.001A.75.75 0 0 0 14.5 12"/>`
    }, props));
$3a5b15c863db925d$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $3a5b15c863db925d$var$_default = module.exports.default = $3a5b15c863db925d$var$PaintBucketIcon;

});

parcelRegister("8kJOj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6113b9fdbe92a267$var$_react = $6113b9fdbe92a267$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $6113b9fdbe92a267$var$_paintBucket = $6113b9fdbe92a267$var$_interopRequireDefault((parcelRequire("50CQu")));
function $6113b9fdbe92a267$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6113b9fdbe92a267$var$EditorBackgroundColorIcon = (props)=>/*#__PURE__*/ $6113b9fdbe92a267$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
    }, props, {
        newIcon: $6113b9fdbe92a267$var$_paintBucket.default
    }));
$6113b9fdbe92a267$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
var $6113b9fdbe92a267$var$_default = module.exports.default = $6113b9fdbe92a267$var$EditorBackgroundColorIcon;

});


parcelRegister("kUoGK", function(module, exports) {

$parcel$export(module.exports, "getSoftwareThemedRoutes", () => $792c5cf1d308dd5d$export$8b0967e3892c7b59);
$parcel$export(module.exports, "useSoftwareProjectTheming", () => $792c5cf1d308dd5d$export$4c26676caf6bb553);

var $eJOHy = parcelRequire("eJOHy");

var $kfvK2 = parcelRequire("kfvK2");

var $2aY2d = parcelRequire("2aY2d");

var $ln6Iy = parcelRequire("ln6Iy");

var $1302Y = parcelRequire("1302Y");

var $epTsa = parcelRequire("epTsa");

var $hbF3h = parcelRequire("hbF3h");

var $i7yNt = parcelRequire("i7yNt");
const $792c5cf1d308dd5d$var$defaultValues = {
    hasSoftwareTheming: false,
    isSoftwareFullTheming: false,
    isSoftwareProject: false
};
const $792c5cf1d308dd5d$export$c4b7ea2942f2d0e = (0, $kfvK2.createRouterSelector)((state)=>state.route.name);
const $792c5cf1d308dd5d$export$8838ccecebb0c319 = (0, $kfvK2.createRouterSelector)((state)=>state.match.url);
const $792c5cf1d308dd5d$export$52b606e2ebcbaae2 = ()=>{
    if (!(0, $1302Y.getIsSoftwareThemingEnabled)()) return $792c5cf1d308dd5d$var$defaultValues;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const currentRoute = $792c5cf1d308dd5d$export$c4b7ea2942f2d0e();
    const isSoftwareProject = projectData?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    if (!isSoftwareProject) return $792c5cf1d308dd5d$var$defaultValues;
    // temporarily disable theming for calendar
    // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) return {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: isSoftwareProject
    };
    const isM2Enabled = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)();
    const hasSoftwareTheming = isM2Enabled ? isSoftwareProject && (0, $i7yNt.SOFTWARE_THEME_ROUTES_M2).has(currentRoute) && (0, $1302Y.getIsSoftwareThemingM2Enabled)() // Only fire exposure if we are on a themed route
     : isSoftwareProject && (0, $i7yNt.SOFTWARE_THEME_ROUTES).has(currentRoute) && !isSoftwareCalendarRoute;
    const isSoftwareFullTheming = isM2Enabled ? hasSoftwareTheming && (0, $i7yNt.SOFTWARE_FULL_THEME_ROUTES_M2).has(currentRoute) : hasSoftwareTheming && (0, $i7yNt.SOFTWARE_FULL_THEME_ROUTES).has(currentRoute);
    return {
        hasSoftwareTheming: hasSoftwareTheming,
        isSoftwareFullTheming: isSoftwareFullTheming,
        isSoftwareProject: isSoftwareProject
    };
};
const $792c5cf1d308dd5d$export$8b0967e3892c7b59 = ()=>{
    const allThemedSoftwareProjectRoutes = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() ? (0, $i7yNt.SOFTWARE_THEME_ROUTES_M2) : (0, $i7yNt.SOFTWARE_THEME_ROUTES);
    const fullThemedSoftwareProjectRoutes = (0, $1302Y.getIsSoftwareThemingM2EnabledNoExposure)() ? (0, $i7yNt.SOFTWARE_FULL_THEME_ROUTES_M2) : (0, $i7yNt.SOFTWARE_FULL_THEME_ROUTES);
    // Enable theming for the shared routes no matter which milestone we are in
    allThemedSoftwareProjectRoutes.add('project-pages');
    allThemedSoftwareProjectRoutes.add('project-components');
    fullThemedSoftwareProjectRoutes.add('project-pages');
    return {
        allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes,
        fullThemedSoftwareProjectRoutes: fullThemedSoftwareProjectRoutes
    };
};
const $792c5cf1d308dd5d$var$useSoftwareProjectThemingSimplified = ()=>{
    const currentRoute = $792c5cf1d308dd5d$export$c4b7ea2942f2d0e();
    const currentUrl = $792c5cf1d308dd5d$export$8838ccecebb0c319();
    const { allThemedSoftwareProjectRoutes: allThemedSoftwareProjectRoutes, fullThemedSoftwareProjectRoutes: fullThemedSoftwareProjectRoutes } = $792c5cf1d308dd5d$export$8b0967e3892c7b59();
    const isSoftwareProject = allThemedSoftwareProjectRoutes.has(currentRoute) && (currentUrl.includes('/jira/software/projects/') || currentUrl.includes('/jira/software/c/projects/') || currentRoute === 'issue');
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    return (0, $eJOHy.useMemo)(()=>{
        if (!isSoftwareProject || !(0, $1302Y.getIsSoftwareThemingEnabled)()) return $792c5cf1d308dd5d$var$defaultValues;
        // temporarily disable theming for calendar
        // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
        if (isSoftwareCalendarRoute && !(0, $1302Y.getIsSoftwareThemingM2Enabled)()) return {
            hasSoftwareTheming: false,
            isSoftwareFullTheming: false,
            isSoftwareProject: isSoftwareProject
        };
        return {
            hasSoftwareTheming: allThemedSoftwareProjectRoutes.has(currentRoute),
            isSoftwareFullTheming: fullThemedSoftwareProjectRoutes.has(currentRoute),
            isSoftwareProject: isSoftwareProject
        };
    }, [
        isSoftwareProject,
        isSoftwareCalendarRoute,
        allThemedSoftwareProjectRoutes,
        currentRoute,
        fullThemedSoftwareProjectRoutes
    ]);
};
const $792c5cf1d308dd5d$export$4c26676caf6bb553 = (0, $hbF3h.functionWithCondition)(()=>(0, $epTsa.expVal)('performance_improvement_in_use_project_theme', 'isEnabled', false), $792c5cf1d308dd5d$var$useSoftwareProjectThemingSimplified, $792c5cf1d308dd5d$export$52b606e2ebcbaae2);

});
parcelRegister("i7yNt", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES", () => $686f9881c0e0ac79$export$891915f6cf3ec6e7);
$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES_M2", () => $686f9881c0e0ac79$export$1c7e7f18d2f498fe);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES", () => $686f9881c0e0ac79$export$4edc7739f219df7c);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES_M2", () => $686f9881c0e0ac79$export$587ac1561f46cfdc);
// consolidate the software themed routes to src/packages/platform/project-theme/page-container/src/controllers/project-theme/constants.tsx
// when we migrate the software project theming to business
const $686f9881c0e0ac79$export$671a416a5ddfe0ea = new Set([
    'issue',
    'software-backlog',
    'rapidboard-backlog',
    'software-timeline',
    'software-timeline-classic',
    'software-issue-navigator',
    'issue-navigator-classic'
]);
const $686f9881c0e0ac79$export$891915f6cf3ec6e7 = new Set([
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic'
]);
const $686f9881c0e0ac79$export$7a3cdcc7c971b71e = new Set([
    'issue',
    'software-timeline',
    'software-timeline-classic',
    'software-issue-navigator',
    'issue-navigator-classic'
]);
const $686f9881c0e0ac79$export$1c7e7f18d2f498fe = new Set([
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic',
    'software-backlog',
    'rapidboard-backlog',
    'project-pages',
    'software-form-classic',
    'software-form',
    'software-form-builder-classic',
    'software-form-builder'
]);
const $686f9881c0e0ac79$export$4edc7739f219df7c = new Set([
    ...$686f9881c0e0ac79$export$671a416a5ddfe0ea,
    ...$686f9881c0e0ac79$export$891915f6cf3ec6e7
]);
const $686f9881c0e0ac79$export$587ac1561f46cfdc = new Set([
    ...$686f9881c0e0ac79$export$7a3cdcc7c971b71e,
    ...$686f9881c0e0ac79$export$1c7e7f18d2f498fe
]);

});


parcelRegister("3AlAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $53bca77c5ddaa57e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $53bca77c5ddaa57e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    setProjectBackgroundMenuItem: {
        "id": "business-theme-components.theme-picker-button-item.set-project-background-menu-item",
        "defaultMessage": "Set project background"
    },
    newLozengeLabel: {
        "id": "business-theme-components.theme-picker-button-item.new",
        "defaultMessage": "new"
    }
});

});


parcelRegister("lAf34", function(module, exports) {

$parcel$export(module.exports, "backgroundPickerPopupContentEntryPoint", () => $4229ef45001c4aa3$export$e02fb03d7ff1aabe);

var $4yXDx = parcelRequire("4yXDx");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");
const $4229ef45001c4aa3$var$fetchPolicy = 'network-only';

const $4229ef45001c4aa3$export$e02fb03d7ff1aabe = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1q8SY")).then((module)=>module.BackgroundPickerPopupContent), {
        moduleId: "e1737386",
        moduleName: "PopupContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectAri: projectAri })=>{
        const popupContentQuery = {
            parameters: (0, $4yXDx.default),
            variables: {
                cloudId: cloudId,
                entityId: projectAri,
                durationInSeconds: 900,
                imageCount: 50
            },
            options: {
                fetchPolicy: $4229ef45001c4aa3$var$fetchPolicy
            }
        };
        return {
            queries: {
                popupContentQuery: popupContentQuery
            }
        };
    }
});

});
parcelRegister("4yXDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8371146dbd1ef127$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1eec08a1b9cd2f19b712f2fe945c8db>>
 * @relayHash 3a2c90542de719ac05d9234999cdbf6a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c4f567c86a7d3ab3c313ddb063766710ea036f75f9aebef277cfcde84b5aacb
const $8371146dbd1ef127$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8c4f567c86a7d3ab3c313ddb063766710ea036f75f9aebef277cfcde84b5aacb",
        "metadata": {},
        "name": "PopupContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8371146dbd1ef127$export$2e2bcd8739ae039 = $8371146dbd1ef127$var$node;

});

parcelRegister("1q8SY", function(module, exports) {

let $108f1cae189fef7a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $108f1cae189fef7a$var$load("ffQaD"),
    $108f1cae189fef7a$var$load("kvRbA"),
    $108f1cae189fef7a$var$load("6hXHC")
]).then(()=>parcelRequire('glBPU'));

});


parcelRegister("jh6EV", function(module, exports) {

$parcel$export(module.exports, "ThemePickerSkeleton", () => $4705f752d7481569$export$c3dc17aa42c33254);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");
const $4705f752d7481569$export$c3dc17aa42c33254 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $4705f752d7481569$var$skeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "medium"
    }));
const $4705f752d7481569$var$skeletonStyles = (0, $1DXK0.xcss)({
    width: '346px',
    height: '240px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});


parcelRegister("kA2cA", function(module, exports) {

$parcel$export(module.exports, "useRenameProject", () => $7f862513b9da0a72$export$b7c373d314ddf2d4);

var $7x7nj = parcelRequire("7x7nj");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3osLr = parcelRequire("3osLr");

var $7H1ye = parcelRequire("7H1ye");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kEUB1 = parcelRequire("kEUB1");

var $kqd31 = parcelRequire("kqd31");

var $2p6me = parcelRequire("2p6me");
const $7f862513b9da0a72$export$b7c373d314ddf2d4 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $7x7nj.default));
    const updateProjectName = (0, $eJOHy.useCallback)((projectId, name)=>{
        if (!projectId) return;
        const newName = name.trim();
        const nameUpdater = (store)=>{
            const ari = (0, $3osLr.JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            });
            const relayDataId = (0, $kqd31.default)({
                id: ari
            }, 'JiraProject');
            if (!relayDataId) return;
            const project = store.get(relayDataId);
            if (project) project.setValue(newName, 'name');
        };
        commitMutation({
            variables: {
                cloudId: cloudId,
                projectIdOrKey: String(projectId),
                name: newName
            },
            optimisticUpdater: nameUpdater,
            updater: (store, response)=>{
                if (response?.jira?.updateProjectName?.success) nameUpdater(store);
            },
            onCompleted: (response)=>{
                const { success: success, errors: errors } = response?.jira?.updateProjectName ?? {};
                const error = errors?.find((e)=>e.message);
                if (success) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectName updated');
                else if (error) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectName update failed', {
                    error: error
                });
            }
        });
    }, [
        commitMutation,
        cloudId,
        createAnalyticsEvent
    ]);
    const validate = async (title, newValue)=>{
        try {
            const { errors: errors } = await (0, $7H1ye.get)(newValue);
            if (errors.projectName) {
                // There's an error if the value is being updated to an existing project
                // name, but we can skip this if the value is the current project name
                if (newValue === title) return undefined;
                return errors.projectName;
            }
            return undefined;
        } catch  {
            return formatMessage((0, $2p6me.default).updateProjectNameError);
        }
    };
    return {
        updateProjectName: updateProjectName,
        validateProjectName: validate
    };
};

});
parcelRegister("7x7nj", function(module, exports) {

$parcel$export(module.exports, "default", () => $abdaec92cfd61fa0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32f9a62e16ee97abad9b6bce0f869388>>
 * @relayHash 8c9db70971a948f9ab739dd426a6a254
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a78e8e6a76a67b8b61e1768b5930f5d44cac440c88d67026b4869d026d70386
const $abdaec92cfd61fa0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "name"
                },
                {
                    "kind": "Variable",
                    "name": "projectIdOrKey",
                    "variableName": "projectIdOrKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "renameProjectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateNameMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectName",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "renameProjectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateNameMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectName",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8a78e8e6a76a67b8b61e1768b5930f5d44cac440c88d67026b4869d026d70386",
            "metadata": {},
            "name": "renameProjectMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$abdaec92cfd61fa0$var$node.hash = "4eb2a9d3f2e1dbb64dd9331c62625de5";
var $abdaec92cfd61fa0$export$2e2bcd8739ae039 = $abdaec92cfd61fa0$var$node;

});

parcelRegister("7H1ye", function(module, exports) {

$parcel$export(module.exports, "get", () => $9b6d9bce5542221c$export$3988ae62b71be9a3);

var $jGzN3 = parcelRequire("jGzN3");
const $9b6d9bce5542221c$export$a5b7a8c3b1c6e775 = (projectName)=>`/rest/simplified/latest/project/validate?projectName=${encodeURIComponent(projectName)}`;
const $9b6d9bce5542221c$export$3988ae62b71be9a3 = (projectKey, abortSignal)=>{
    const url = $9b6d9bce5542221c$export$a5b7a8c3b1c6e775(projectKey);
    return (0, $jGzN3.performGetRequest)(url, {
        signal: abortSignal
    });
};

});

parcelRegister("2p6me", function(module, exports) {

$parcel$export(module.exports, "default", () => $424fdd3d3bfd0b34$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $424fdd3d3bfd0b34$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    updateProjectNameError: {
        "id": "horizontal-nav-common.services.rename-project.update-project-name-error",
        "defaultMessage": "We couldn't update your project name. Try again."
    }
});

});


parcelRegister("demTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $503023151c702076$export$2e2bcd8739ae039);

var $7jyDf = parcelRequire("7jyDf");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lTqUW = parcelRequire("lTqUW");

var $6uIRL = parcelRequire("6uIRL");
const $503023151c702076$var$ProjectAvatar = ({ projectRef: projectRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $7jyDf.default), projectRef);
    if (data?.projectType === 'BUSINESS') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6uIRL.NavigationKitAvatarPopup), {
        canEdit: data?.canEditProjectConfig?.canPerform ?? false,
        projectId: Number(data?.projectId),
        selectedAvatarUrl: data?.avatar?.large ?? ''
    });
    if (!data.avatar) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTqUW.ProjectIcon), {
        src: `${data.avatar.large}?size=xlarge`,
        alt: "",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "horizontal-nav.ui.content.project-avatar",
        "data-vc": "jira-horizontal-nav-project-icon"
    });
};
var $503023151c702076$export$2e2bcd8739ae039 = $503023151c702076$var$ProjectAvatar;

});
parcelRegister("7jyDf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7c6f206e5acc377$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08604d5776b50fb6002cfdeffab34bbc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f7c6f206e5acc377$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectAvatar",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ],
    "type": "JiraProject"
};
$f7c6f206e5acc377$var$node.hash = "bf24cf4ceac2f687267bc6a885231cc1";
var $f7c6f206e5acc377$export$2e2bcd8739ae039 = $f7c6f206e5acc377$var$node;

});

parcelRegister("6uIRL", function(module, exports) {

$parcel$export(module.exports, "NavigationKitAvatarPopup", () => $aa46b15d7981b724$export$500ef2645bac918e);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $lRq8t = parcelRequire("lRq8t");

var $cxVxi = parcelRequire("cxVxi");

var $cNe2t = parcelRequire("cNe2t");

var $dvItQ = parcelRequire("dvItQ");

var $h4EFR = parcelRequire("h4EFR");
const $aa46b15d7981b724$export$500ef2645bac918e = ({ canEdit: canEdit, projectId: projectId, selectedAvatarUrl: selectedAvatarUrl })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onAvatarClick = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(true);
    }, [
        setIsOpen
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const selectedAvatarId = Number(selectedAvatarUrl.substring(selectedAvatarUrl.lastIndexOf('/') + 1));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $h4EFR.navigationKitAvatarPopupContentEntrypoint), {});
    const entrypointTrigger = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            onClose: onClose,
            projectId: projectId,
            selectedAvatarId: selectedAvatarId,
            selectedAvatarUrl: selectedAvatarUrl
        }), [
        onClose,
        projectId,
        selectedAvatarId,
        selectedAvatarUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        messageId: "horizontal-nav.ui.content.header.project-header.project-avatar.navigation-kit-avatar-popup.jira-popup.popup",
        messageType: "transactional",
        placement: "bottom-start",
        role: "dialog",
        label: formatMessage((0, $dvItQ.default).title),
        isOpen: isOpen,
        onClose: onClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                id: "navigation-kit-avatar.popup-content",
                packageName: "jiraNavigationKitAvatarPopupContent",
                entryPointReferenceSubject: entryPointReferenceSubject,
                runtimeProps: runtimeProps
            }),
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                ref: entrypointTrigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cxVxi.EditableAvatar), {
                avatarUrl: selectedAvatarUrl,
                canEdit: canEdit,
                onClick: onAvatarClick,
                triggerProps: triggerProps
            }));
        }
    });
};

});
parcelRegister("cxVxi", function(module, exports) {

$parcel$export(module.exports, "EditableAvatar", () => $6544587ce188c095$export$fd3a492e0b2eddae);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $lNdOF = parcelRequire("lNdOF");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $lTqUW = parcelRequire("lTqUW");

var $bJscI = parcelRequire("bJscI");

var $2IJv4 = parcelRequire("2IJv4");
const $6544587ce188c095$var$EditIconWithTransparentBackground = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6544587ce188c095$var$iconBackgroundStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lNdOF))), {
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $6544587ce188c095$var$ProjectAvatar = ({ src: src, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTqUW.ProjectIcon), {
        "data-testid": testId && `${testId}--image`,
        "data-vc": "editable-avatar-project",
        src: src,
        alt: ""
    });
const $6544587ce188c095$var$EditableAvatarOld = (props)=>{
    const { avatarUrl: avatarUrl, canEdit: canEdit, triggerProps: triggerProps = {}, onClick: onClick } = props;
    const [isHover, setIsHover] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false)
    }, canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $2IJv4.default).editIconLabel),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $6544587ce188c095$var$editableAvatarContainerStyles
        }, isHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $6544587ce188c095$var$iconButtonWrapperStyles,
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            appearance: "subtle",
            icon: $6544587ce188c095$var$EditIconWithTransparentBackground,
            label: formatMessage((0, $2IJv4.default).editIconLabel),
            spacing: "compact",
            ...triggerProps,
            onClick: onClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6544587ce188c095$var$ProjectAvatar, {
            src: avatarUrl ? `${avatarUrl}?size=xlarge` : avatarUrl,
            testId: "navigation-apps-sidebar-inline-config-project-header.ui.editable-avatar.project-icon-editable"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6544587ce188c095$var$ProjectAvatar, {
        src: avatarUrl ? `${avatarUrl}?size=xlarge` : avatarUrl,
        testId: "navigation-apps-sidebar-inline-config-project-header.ui.editable-avatar.project-icon"
    })));
};
const $6544587ce188c095$var$EditableAvatarNew = (props)=>{
    const { avatarUrl: avatarUrl, canEdit: canEdit, triggerProps: triggerProps = {}, onClick: onClick } = props;
    const [isHover, setIsHover] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false)
    }, canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $2IJv4.default).editIconLabel),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $6544587ce188c095$var$editableAvatarContainerStyles
        }, isHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $6544587ce188c095$var$iconButtonWrapperStyles,
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            appearance: "subtle",
            icon: $6544587ce188c095$var$EditIconWithTransparentBackground,
            label: formatMessage((0, $2IJv4.default).editIconLabel),
            spacing: "compact",
            ...triggerProps,
            onClick: onClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6544587ce188c095$var$ProjectAvatar, {
            src: avatarUrl ? `${avatarUrl}?size=xlarge` : avatarUrl,
            testId: "navigation-apps-sidebar-inline-config-project-header.ui.editable-avatar.project-icon-editable"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6544587ce188c095$var$ProjectAvatar, {
        src: avatarUrl ? `${avatarUrl}?size=xlarge` : avatarUrl,
        testId: "navigation-apps-sidebar-inline-config-project-header.ui.editable-avatar.project-icon"
    }));
};
const $6544587ce188c095$export$fd3a492e0b2eddae = (0, $bJscI.componentWithFG)('jira_fix_non_interactive_elements_eslint', $6544587ce188c095$var$EditableAvatarNew, $6544587ce188c095$var$EditableAvatarOld);
const $6544587ce188c095$var$iconBackgroundStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.pressed',
    borderRadius: '2px'
});
const $6544587ce188c095$var$editableAvatarContainerStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $6544587ce188c095$var$iconButtonWrapperStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    zIndex: 'card',
    left: "var(--ds-space-negative-025, -2px)",
    top: "var(--ds-space-negative-025, -2px)"
});

});
parcelRegister("lNdOF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d8183d86255e266d89dc1fd99bbc4dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdd8e4308e7da87e$var$_react = $fdd8e4308e7da87e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fdd8e4308e7da87e$var$_edit = $fdd8e4308e7da87e$var$_interopRequireDefault((parcelRequire("gTr6H")));

var $fdd8e4308e7da87e$var$_editFilled = $fdd8e4308e7da87e$var$_interopRequireDefault((parcelRequire("5InvN")));
function $fdd8e4308e7da87e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fdd8e4308e7da87e$var$EditIcon = (props)=>/*#__PURE__*/ $fdd8e4308e7da87e$var$_react.default.createElement($fdd8e4308e7da87e$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $fdd8e4308e7da87e$var$_editFilled.default
    }, props));
$fdd8e4308e7da87e$var$EditIcon.Name = 'EditIconMigration';
var $fdd8e4308e7da87e$var$_default = module.exports.default = $fdd8e4308e7da87e$var$EditIcon;

});
parcelRegister("gTr6H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c6cf489c8bf4fc$var$_react = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c4c6cf489c8bf4fc$var$_baseNew = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c4c6cf489c8bf4fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c6cf489c8bf4fc$var$EditIcon = (props)=>/*#__PURE__*/ $c4c6cf489c8bf4fc$var$_react.default.createElement($c4c6cf489c8bf4fc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$c4c6cf489c8bf4fc$var$EditIcon.displayName = 'EditIcon';
var $c4c6cf489c8bf4fc$var$_default = module.exports.default = $c4c6cf489c8bf4fc$var$EditIcon;

});

parcelRegister("5InvN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42934ccb2fe03455$var$_react = $42934ccb2fe03455$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $42934ccb2fe03455$var$_edit = $42934ccb2fe03455$var$_interopRequireDefault((parcelRequire("gTr6H")));
function $42934ccb2fe03455$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $42934ccb2fe03455$var$EditFilledIcon = (props)=>/*#__PURE__*/ $42934ccb2fe03455$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $42934ccb2fe03455$var$_edit.default
    }));
$42934ccb2fe03455$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $42934ccb2fe03455$var$_default = module.exports.default = $42934ccb2fe03455$var$EditFilledIcon;

});


parcelRegister("2IJv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da3385dc9f63e6a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2da3385dc9f63e6a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    editIconLabel: {
        "id": "navigation-apps-sidebar-inline-config-project-header.editable-avatar.edit-icon-label",
        "defaultMessage": "Edit project icon"
    }
});

});


parcelRegister("dvItQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5558960609447858$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5558960609447858$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "navigation-kit-avatar.title",
        "defaultMessage": "Select an avatar"
    },
    close: {
        "id": "navigation-kit-avatar.close",
        "defaultMessage": "Close avatar selection"
    },
    error: {
        "id": "navigation-kit-avatar.error",
        "defaultMessage": "Error updating project avatar."
    },
    cancelUpload: {
        "id": "navigation-kit-avatar.cancel-upload",
        "defaultMessage": "Cancel"
    },
    submitUpload: {
        "id": "navigation-kit-avatar.submit-upload",
        "defaultMessage": "Submit"
    },
    uploadImageErrorMessage: {
        "id": "navigation-kit-avatar.upload-image-error-message",
        "defaultMessage": "We couldn't upload the image. Check your connection and try again."
    },
    updateAvatarErrorMessage: {
        "id": "navigation-kit-avatar.update-avatar-error-message",
        "defaultMessage": "We couldn't save the changes. Check your connection and try again."
    },
    imageUrlInvalidError: {
        "id": "navigation-kit-avatar.image-url-invalid-error",
        "defaultMessage": "Could not load image, the url is invalid."
    },
    imageFormatInvalidError: {
        "id": "navigation-kit-avatar.image-format-invalid-error",
        "defaultMessage": "Could not load image, the format is invalid."
    },
    imageSizeTooLargeError: {
        "id": "navigation-kit-avatar.image-size-too-large-error",
        "defaultMessage": "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    selectImageToUploadOrDragAndDrop: {
        "id": "navigation-kit-avatar.select-image-to-upload-or-drag-and-drop",
        "defaultMessage": "<link>Select an image to upload</link> or drag and drop it here"
    }
});

});

parcelRegister("h4EFR", function(module, exports) {

$parcel$export(module.exports, "navigationKitAvatarPopupContentEntrypoint", () => $00fbfe477eaccfa9$export$6c49070d2ac14f7c);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $00fbfe477eaccfa9$export$6c49070d2ac14f7c = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("97l16")).then((module)=>module.NavigationKitAvatarPopupContentEntryPoint), {
        moduleId: "48abd2fb",
        moduleName: "NavigationKitAvatarPopupContent",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("97l16", function(module, exports) {

let $6a351204f300d9d6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6a351204f300d9d6$var$load("76n7a"),
    $6a351204f300d9d6$var$load("l253H"),
    $6a351204f300d9d6$var$load("ffQaD"),
    $6a351204f300d9d6$var$load("kvRbA"),
    $6a351204f300d9d6$var$load("6occq")
]).then(()=>parcelRequire('awsar'));

});





parcelRegister("lJuT9", function(module, exports) {

$parcel$export(module.exports, "UserBoardHeader", () => $3e3393c197e245e5$export$adc7514276e418cb);

var $hwH9T = parcelRequire("hwH9T");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $9Ovhp = parcelRequire("9Ovhp");

var $4DtHG = parcelRequire("4DtHG");

var $945lE = parcelRequire("945lE");
const $3e3393c197e245e5$export$adc7514276e418cb = ({ boardFragment: boardFragment })=>{
    const boardData = (0, $j4oe4.useFragment)((0, $hwH9T.default), boardFragment);
    const extraComponentsFar = (0, $eJOHy.useMemo)(()=>{
        const board = {
            id: boardData.boardId,
            name: boardData.name,
            type: boardData.boardType === 'SCRUM' ? 'scrum' : 'kanban',
            isProjectBoard: false
        };
        const components = [];
        if ((0, $7jTnu.fg)('blu-5747-fullscreen-in-nav-header')) components.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $945lE.HeaderFullscreenButton), {
            key: "fullscreen"
        }));
        components.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4DtHG.ShareButton), {
            key: "share",
            data: board
        }));
        return components;
    }, [
        boardData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ovhp.default), {
        testId: "horizontal-nav-header.ui.user-board-header",
        title: boardData.name,
        extraComponentsClose: [],
        extraComponentsFar: extraComponentsFar
    });
};

});
parcelRegister("hwH9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $20064a45727d23d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<daca393877d4cdc54117aeb3cb333c2f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $20064a45727d23d3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "UserBoardHeader_board",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardId"
            },
            "action": "THROW",
            "path": "boardId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardType"
            },
            "action": "THROW",
            "path": "boardType"
        }
    ],
    "type": "JiraBoard"
};
$20064a45727d23d3$var$node.hash = "8e9eefe98b582988ed6ecfcea8baeeac";
var $20064a45727d23d3$export$2e2bcd8739ae039 = $20064a45727d23d3$var$node;

});



parcelRegister("3O0A9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5584c89ff38000df$export$2e2bcd8739ae039);
/* NavWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aewX5 = parcelRequire("aewX5");
var $1DXK0 = parcelRequire("1DXK0");

var $6FOAB = parcelRequire("6FOAB");

var $iX5t3 = parcelRequire("iX5t3");

var $1uv7v = parcelRequire("1uv7v");

var $5bzWA = parcelRequire("5bzWA");

var $kUoGK = parcelRequire("kUoGK");

var $1KdDN = parcelRequire("1KdDN");

var $1302Y = parcelRequire("1302Y");
const $5584c89ff38000df$var$NavWrapper = ({ children: children })=>{
    const [isFullscreen] = (0, $5bzWA.useIsFullscreen)();
    const { isSoftwareProject: isSoftwareProject } = (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kUoGK.useSoftwareProjectTheming)() : {
        isSoftwareProject: false
    };
    return /*#__PURE__*/ $eJOHy.createElement((0, $6FOAB.default), {
        name: "jira-horizontal-nav"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $1KdDN.JSErrorBoundary), {
        id: "HorizontalNavErrorBoundary",
        packageName: "jiraHorizontalNav",
        fallback: (0, $iX5t3.HorizontalNavSkeleton)
    }, /*#__PURE__*/ $eJOHy.createElement("header", {
        id: "ak-project-view-navigation",
        "data-testid": "horizontal-nav.ui.content.horizontal-nav",
        ...false ? {
            'data-ssr-placeholder': 'project-view-navigation'
        } : {
            'data-ssr-placeholder-replace': 'project-view-navigation'
        },
        className: (0, $hcewu.default)([
            !isSoftwareProject && "_11q71iew _vchhusvi _kqswh2mm _1kt9f705 _1cs8stnw _kfgt1osq _1mp41osq _m9csad7r _1aukidpf _qnecidpf"
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $aewX5.default), {
        gap: "space.050",
        alignItems: "end",
        xcss: [
            $5584c89ff38000df$var$contentStyles,
            !isFullscreen && $5584c89ff38000df$var$minHeightStyle,
            !isSoftwareProject && $5584c89ff38000df$var$relativePositionStyle
        ]
    }, children))));
};
var $5584c89ff38000df$export$2e2bcd8739ae039 = $5584c89ff38000df$var$NavWrapper;
const $5584c89ff38000df$var$minHeightStyle = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    minHeight: `${(0, $1uv7v.NAV4_HORIZONTAL_NAV_HEIGHT)}px`
});
const $5584c89ff38000df$var$contentStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.150'
});
// Delete headerStyles when business projects are migrated to the new theming
const $5584c89ff38000df$var$headerStyles = null;
// Delete relativePositionStyle when business projects are migrated to the new theming
const $5584c89ff38000df$var$relativePositionStyle = (0, $1DXK0.xcss)({
    position: 'relative'
});

});
parcelRegister("aewX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f21aa3b401eee46$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $gF73L = parcelRequire("gF73L");

var $1DXK0 = parcelRequire("1DXK0");
function $5f21aa3b401eee46$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5f21aa3b401eee46$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $5f21aa3b401eee46$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $5f21aa3b401eee46$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $5f21aa3b401eee46$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $5f21aa3b401eee46$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $5f21aa3b401eee46$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $5f21aa3b401eee46$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $5f21aa3b401eee46$var$baseStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$5f21aa3b401eee46$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$5f21aa3b401eee46$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$5f21aa3b401eee46$var$gridTemplateRowsVar})`
});
const $5f21aa3b401eee46$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $5f21aa3b401eee46$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $eJOHy.useMemo)(()=>({
            [$5f21aa3b401eee46$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$5f21aa3b401eee46$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$5f21aa3b401eee46$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $5f21aa3b401eee46$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $gF73L.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $gF73L.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $gF73L.spaceStylesMap).rowGap[rowGap],
            alignItems && $5f21aa3b401eee46$var$alignItemsMap[alignItems],
            alignContent && $5f21aa3b401eee46$var$alignContentMap[alignContent],
            justifyContent && $5f21aa3b401eee46$var$justifyContentMap[justifyContent],
            autoFlow && $5f21aa3b401eee46$var$gridAutoFlowMap[autoFlow],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$5f21aa3b401eee46$var$Grid.displayName = 'Grid';
var $5f21aa3b401eee46$export$2e2bcd8739ae039 = $5f21aa3b401eee46$var$Grid;

});


parcelRegister("hWbfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $59be116205a586e6$export$2e2bcd8739ae039);

var $11c7k = parcelRequire("11c7k");

var $9TbvA = parcelRequire("9TbvA");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $ayBWV = parcelRequire("ayBWV");

var $iX5t3 = parcelRequire("iX5t3");

var $lN96w = parcelRequire("lN96w");

var $bILK0 = parcelRequire("bILK0");


var $aMd82 = parcelRequire("aMd82");

var $cAELL = parcelRequire("cAELL");



var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $fh5pZ = parcelRequire("fh5pZ");

var $6se2r = parcelRequire("6se2r");

var $8Km6P = parcelRequire("8Km6P");

var $7jTnu = parcelRequire("7jTnu");

var $IPH39 = parcelRequire("IPH39");

var $aDktR = parcelRequire("aDktR");

var $3hPxr = parcelRequire("3hPxr");
const $59be116205a586e6$var$TabsContent = ({ queryFragment: queryFragment, projectFragment: projectFragment = null })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hasFoundErrorRef = (0, $eJOHy.useRef)(false);
    const urlFromLocation = (0, $IPH39.useRelativeURLFromLocation)();
    const data = (0, $j4oe4.useFragment)((0, $9TbvA.default), queryFragment);
    const projectData = (0, $j4oe4.useFragment)((0, $11c7k.default), projectFragment);
    const { data: shortcutsData, loading: loading } = (0, $aMd82.useShortcutsData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        if ((0, $7jTnu.fg)('jira_client_side_error_handled_track_event')) {
            if (!hasFoundErrorRef.current) {
                hasFoundErrorRef.current = true;
                const statusCode = error && 'statusCode' in error ? Number(error.statusCode) : 0;
                const flagDetails = (0, $6se2r.getFlagDetails)(statusCode);
                (0, $bILK0.showFlag)(flagDetails);
                if ((0, $lN96w.HANDLED_STATUS_CODES).includes(statusCode)) {
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'clientSideError handled', {
                        statusCode: statusCode,
                        // It's important to get the relative url from a hook rather than
                        // by calling getRouterState at this point because any redirections
                        // that occur before this callback is run may cause the atlOrigin
                        // query param to be lost.
                        originTrace: (0, $IPH39.getOriginAnalyticsAttributes)(urlFromLocation),
                        ...(0, $IPH39.getProjectAttributes)(urlFromLocation)
                    });
                    return;
                }
                throw error;
            }
        } else {
            const statusCode = error && 'statusCode' in error ? Number(error.statusCode) : 0;
            const flagDetails = (0, $6se2r.getFlagDetails)(statusCode);
            (0, $bILK0.showFlag)(flagDetails);
            if ((0, $lN96w.HANDLED_STATUS_CODES).includes(statusCode)) return;
            throw error;
        }
    }, [
        createAnalyticsEvent,
        urlFromLocation
    ]);
    const containerNavigation = data.jira.containerNavigation?.__typename === 'JiraContainerNavigation' ? data.jira.containerNavigation : null;
    const navigationItems = containerNavigation ? containerNavigation?.navigationItems : null;
    (0, $eJOHy.useEffect)(()=>{
        const containerNavigationQueryError = data.jira.containerNavigation?.__typename === 'QueryError' ? data.jira.containerNavigation : null;
        if (navigationItems?.errors && navigationItems?.errors?.length > 0) {
            const error = navigationItems.errors[0];
            handleError(new (0, $ayBWV.QueryError)(error));
        } else if (containerNavigationQueryError) handleError(new (0, $ayBWV.QueryError)(containerNavigationQueryError));
        else if (navigationItems?.edges == null) handleError(new Error('navigationItems.edges failed to load'));
        else // reset error state
        hasFoundErrorRef.current = false;
    }, [
        containerNavigation?.navigationItems,
        data,
        handleError,
        navigationItems?.edges,
        navigationItems?.errors
    ]);
    const attributes = (0, $eJOHy.useMemo)(()=>({
            projectType: (projectData?.projectType ?? '').toLowerCase(),
            navigationContainer: (0, $95eb6070d868c1b7$export$f1c9dd0f5207dd5e),
            navigationLayer: (0, $002870cfa80d64f4$export$33d8c916a600c5e9),
            tabIds: navigationItems?.edges?.map((edge)=>edge?.node?.id) ?? []
        }), [
        projectData?.projectType,
        navigationItems?.edges
    ]);
    const renderWithTab = (0, $eJOHy.useCallback)((tabData)=>tabData.typeKey === 'PAGES' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Km6P.PagesSpotlightEntrypointContainer), {
            tabData: tabData
        }) : null, []);
    return containerNavigation && navigationItems && !navigationItems.errors && navigationItems?.edges ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "horizontalNavJiraTabsContent",
        containerType: (0, $5ab686e904cbfbb7$export$fe791c4fa892e400),
        containerId: projectData?.projectId ?? '',
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cAELL.ShortcutsContainer), {
        data: shortcutsData,
        loading: loading,
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fh5pZ.ContainerNavigationTabs), {
        containerFragment: data.jira.containerNavigation,
        tabsDescriptor: (0, $aDktR.JIRA_TABS),
        label: formatMessage((0, $3hPxr.default).projectNavigation),
        renderWithTab: renderWithTab
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        key: projectData?.projectId ?? ''
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iX5t3.TabsSkeleton), null);
};
var $59be116205a586e6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($59be116205a586e6$var$TabsContent);

});
parcelRegister("11c7k", function(module, exports) {

$parcel$export(module.exports, "default", () => $86300843c7db44af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39573effa1e570b3c0fd3e77351ee0aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $86300843c7db44af$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabsContent_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        }
    ],
    "type": "JiraProject"
};
$86300843c7db44af$var$node.hash = "abf520acd7725543508b669e38084bfa";
var $86300843c7db44af$export$2e2bcd8739ae039 = $86300843c7db44af$var$node;

});

parcelRegister("9TbvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $77c8665ff60d4c80$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b0a007f5bf10cbd113fda096d9d1392>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $77c8665ff60d4c80$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "containerNavigationInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "TabsContent_query",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "input",
                                        "variableName": "containerNavigationInput"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "containerNavigation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ContainerNavigationTabs_container"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "first",
                                                        "variableName": "first"
                                                    }
                                                ],
                                                "concreteType": "JiraNavigationItemConnection",
                                                "kind": "LinkedField",
                                                "name": "navigationItems",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraNavigationItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "kind": "ScalarField",
                                                                                "name": "id"
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.containerNavigation.navigationItems.edges.node.id"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.containerNavigation.navigationItems.edges.node"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": v1 /*: any*/ 
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraContainerNavigation"
                                    },
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v1 /*: any*/ ,
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.containerNavigation"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$77c8665ff60d4c80$var$node.hash = "b84967efe9fe4129379add71246146c1";
var $77c8665ff60d4c80$export$2e2bcd8739ae039 = $77c8665ff60d4c80$var$node;

});

parcelRegister("ayBWV", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $55a23efa34f2488b$export$83dcbdfe8cbc1e17);
const $55a23efa34f2488b$export$f215947b3d76a6b7 = 'QueryError';
class $55a23efa34f2488b$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});

parcelRegister("lN96w", function(module, exports) {

$parcel$export(module.exports, "VIEW_JIRA_HORIZONTAL_NAVIGATION_EXPERIENCE", () => $fe2f78f7e7e47f1b$export$416a2d57dd33ec31);
$parcel$export(module.exports, "HANDLED_STATUS_CODES", () => $fe2f78f7e7e47f1b$export$ad73a344b1bd5415);
const $fe2f78f7e7e47f1b$export$416a2d57dd33ec31 = {
    experience: 'viewHorizontalNavigation',
    analyticsSource: 'jiraHorizontalNav'
};
const $fe2f78f7e7e47f1b$export$ad73a344b1bd5415 = [
    401,
    403,
    404
];

});

// TopNav or sidebar
const $002870cfa80d64f4$export$17ff3f7e02c6ac22 = 'global';
const $002870cfa80d64f4$export$33d8c916a600c5e9 = 'container';

parcelRegister("aMd82", function(module, exports) {

$parcel$export(module.exports, "useShortcutsData", () => $fda164b635a286f8$export$47d387d66bf16cb);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $5ddA0 = parcelRequire("5ddA0");

var $bo7Z6 = parcelRequire("bo7Z6");

var $7LOZ4 = parcelRequire("7LOZ4");

var $6ypIq = parcelRequire("6ypIq");
const $fda164b635a286f8$var$transformShortcutsMemo = (0, $LFmXM.default)((a, b)=>(0, $6ypIq.transformShortcuts)(a, b));
const $fda164b635a286f8$var$emptyData = [];
const $fda164b635a286f8$export$47d387d66bf16cb = (customContext)=>{
    const canEdit = (0, $7LOZ4.useCanEditShortcuts)(customContext);
    const { data: data, loading: loading, error: error } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $5ddA0.staticSidebarShortcutsResource), customContext);
    const items = (0, $eJOHy.useMemo)(()=>data && $fda164b635a286f8$var$transformShortcutsMemo(data, canEdit), [
        data,
        canEdit
    ]); // canEdit should be the same for all shortcuts per person, per project
    return {
        data: items || $fda164b635a286f8$var$emptyData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("7LOZ4", function(module, exports) {

$parcel$export(module.exports, "useCanEditShortcuts", () => $5dd4297e12979648$export$cf4f3a9f01fdc8a7);

var $eJOHy = parcelRequire("eJOHy");

var $dSkLG = parcelRequire("dSkLG");

var $jMi5s = parcelRequire("jMi5s");
const $5dd4297e12979648$export$cf4f3a9f01fdc8a7 = (customContext)=>{
    const { data: data } = (0, $dSkLG.useProjectSidebarNavigation)(customContext);
    return (0, $eJOHy.useMemo)(()=>data && (0, $jMi5s.getCanEditShortcuts)(data), [
        data
    ]) || false;
};

});
parcelRegister("jMi5s", function(module, exports) {

$parcel$export(module.exports, "getCanEditShortcuts", () => $705d62279e9d9d35$export$c64b03ccce2c3de);
const $705d62279e9d9d35$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS || false;
const $705d62279e9d9d35$export$c64b03ccce2c3de = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.permissionInfo ? $705d62279e9d9d35$var$isProjectOrJiraAdmin(jiraWorkManagementNavData.permissionInfo) : false;
        case 'jira_software':
            return jiraSoftwareNavData?.permissionInfo ? $705d62279e9d9d35$var$isProjectOrJiraAdmin(jiraSoftwareNavData.permissionInfo) : false;
        case 'jira_service_management':
            return jiraServiceManagementNavData?.permissionInfo ? $705d62279e9d9d35$var$isProjectOrJiraAdmin(jiraServiceManagementNavData.permissionInfo) : false;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.permissionInfo ? $705d62279e9d9d35$var$isProjectOrJiraAdmin(jiraProductDiscoveryNavData.permissionInfo) : false;
        case null:
            return false;
        default:
            return false;
    }
};

});


parcelRegister("6ypIq", function(module, exports) {

$parcel$export(module.exports, "transformShortcuts", () => $27bb1136b70a1781$export$1fc4378e3ea910d0);
const $27bb1136b70a1781$var$getShortcutIcon = (type)=>{
    if (type == null || type === 'unknown' || type === 'unsupported') return 'shortcut';
    if (type === 'github') return 'repos';
    return type;
};
const $27bb1136b70a1781$export$1fc4378e3ea910d0 = (arrayOfShortcuts, canEditOld)=>{
    if (arrayOfShortcuts && Array.isArray(arrayOfShortcuts)) {
        const links = [];
        const repos = [];
        arrayOfShortcuts.forEach((shortcut)=>{
            const shortcutIcon = $27bb1136b70a1781$var$getShortcutIcon(shortcut.dvcsType);
            const s = {
                id: shortcut.type == null ? `com.atlassian.jira.jira-projects-plugin:project.shortcut.default.link.${shortcut.id}` : `com.atlassian.jira.jira-projects-plugin:${shortcut.type}.${shortcut.id}`,
                name: shortcut.name,
                icon: shortcutIcon,
                url: shortcut.url,
                selected: false,
                section: false,
                separator: false,
                showDot: false,
                hasLandingPage: false,
                canEdit: canEditOld,
                showSync: false,
                canDismiss: false,
                sortable: false,
                target: '_blank'
            };
            shortcut.type === 'source.code.link' ? repos.push(s) : links.push(s);
        });
        return repos.concat(links);
    }
    return [];
};

});


parcelRegister("cAELL", function(module, exports) {

$parcel$export(module.exports, "ShortcutsContainer", () => $5da15c6ef649e71f$export$df449cf702d8e0fd);
$parcel$export(module.exports, "useShortcutItems", () => $5da15c6ef649e71f$export$2c1990af0fa688a3);

var $eJOHy = parcelRequire("eJOHy");

var $8rAKL = parcelRequire("8rAKL");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $cIvIU = parcelRequire("cIvIU");
const $5da15c6ef649e71f$var$renderShortcutIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
        spacing: "spacious",
        label: "shortcut"
    });
const $5da15c6ef649e71f$export$fb9705de59d96855 = (item)=>({ setState: setState, getState: getState })=>{
        const { shortcutType: shortcutType } = item;
        const state = getState();
        const index = state.data.map((i)=>i.shortcutType).lastIndexOf(shortcutType);
        const newItem = {
            before: $5da15c6ef649e71f$var$renderShortcutIcon,
            ...item,
            target: '_blank',
            canEdit: true,
            itemType: 'shortcut'
        };
        // Append new item to same shortcuts group
        if (index === -1) // @ts-expect-error - TS2322 - Type 'ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'. | TS2322 - Type '{ target: string; canEdit: boolean; itemType: string; before: React.ComponentType<Record<any, any>> | (() => JSX.Element); href?: string | undefined; icon?: string | undefined; ... 6 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'.
        setState({
            data: [
                ...state.data,
                newItem
            ]
        });
        else setState({
            // @ts-expect-error - TS2322 - Type '(ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; })[]' is not assignable to type 'ShortcutItem[]'.
            data: [
                ...state.data.slice(0, index + 1),
                newItem,
                ...state.data.slice(index + 1)
            ]
        });
    };
const $5da15c6ef649e71f$export$8d8542dbbc23fe1a = (id)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.filter((existingItem)=>existingItem.id !== id);
        setState({
            data: newItems
        });
    };
const $5da15c6ef649e71f$export$60832f4899fbf6a1 = (item)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>existingItem.id !== item.id ? existingItem : item);
        setState({
            data: newItems
        });
    };
const $5da15c6ef649e71f$export$8c896bccb18e1db1 = (items)=>({ setState: setState, getState: getState })=>{
        if (!items.length) return;
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>items.find((item)=>item.id === existingItem.id) || existingItem);
        setState({
            data: newItems
        });
    };
const $5da15c6ef649e71f$export$ed2a7beca2c9674 = (data, loading)=>({ setState: setState, getState: getState })=>{
        const items = (data || []).map((0, $cIvIU.getItemFromLink));
        const state = getState();
        return setState({
            ...state,
            loading: loading,
            data: items,
            oldData: items,
            isLoaded: true
        });
    };
const $5da15c6ef649e71f$export$e324594224ef24da = {
    addItem: $5da15c6ef649e71f$export$fb9705de59d96855,
    deleteItem: $5da15c6ef649e71f$export$8d8542dbbc23fe1a,
    editItem: $5da15c6ef649e71f$export$60832f4899fbf6a1,
    editItems: $5da15c6ef649e71f$export$8c896bccb18e1db1,
    updateContainer: $5da15c6ef649e71f$export$ed2a7beca2c9674
};
const $5da15c6ef649e71f$export$d4c72bab9d6cc13a = {
    data: [],
    oldData: null,
    loading: false,
    isLoaded: false
};
/**
 * Instance
 */ const $5da15c6ef649e71f$var$Store = (0, $GtRbT.createStore)({
    name: 'shortcuts',
    initialState: $5da15c6ef649e71f$export$d4c72bab9d6cc13a,
    actions: $5da15c6ef649e71f$export$e324594224ef24da
});
var $5da15c6ef649e71f$export$2e2bcd8739ae039 = $5da15c6ef649e71f$var$Store;
const $5da15c6ef649e71f$export$df449cf702d8e0fd = (0, $6E16M.createContainer)($5da15c6ef649e71f$var$Store, {
    onInit: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($5da15c6ef649e71f$export$e324594224ef24da.updateContainer(data, loading));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($5da15c6ef649e71f$export$e324594224ef24da.updateContainer(data, loading));
        }
});
const $5da15c6ef649e71f$export$2c1990af0fa688a3 = (0, $iJq0l.createHook)($5da15c6ef649e71f$var$Store);

});
parcelRegister("cIvIU", function(module, exports) {

$parcel$export(module.exports, "getItemFromLink", () => $c1890ef03ab56a5b$export$60d4c4ef6da272ad);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $5Zpxg = parcelRequire("5Zpxg");

var $1ilzu = parcelRequire("1ilzu");

var $12dl7 = parcelRequire("12dl7");

var $lhaOC = parcelRequire("lhaOC");

var $lgMTT = parcelRequire("lgMTT");
const $c1890ef03ab56a5b$var$getLinkParts = (linkId)=>linkId.split(':')[1].split('.');
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const $c1890ef03ab56a5b$var$SizedBitBucketIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.BitbucketIcon), {
        ...props,
        size: "small"
    });
const $c1890ef03ab56a5b$export$16b26cd5e98d9100 = (iconName)=>{
    switch(iconName){
        case 'bitbucket':
            return $c1890ef03ab56a5b$var$SizedBitBucketIcon;
        case 'github':
        case 'repos':
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($12dl7));
        default:
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($lhaOC));
    }
};
const $c1890ef03ab56a5b$export$3cec694c50bc695d = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))($c1890ef03ab56a5b$var$getLinkParts(linkId));
const $c1890ef03ab56a5b$export$d37d2882f5261346 = (linkId)=>linkId;
const $c1890ef03ab56a5b$export$92a97f8239a551c5 = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($5Zpxg)))($c1890ef03ab56a5b$var$getLinkParts(linkId)).join('.');
const $c1890ef03ab56a5b$export$60d4c4ef6da272ad = (link)=>{
    const { id: linkId, icon: icon } = link;
    const id = $c1890ef03ab56a5b$export$3cec694c50bc695d(linkId);
    const shortcutType = $c1890ef03ab56a5b$export$92a97f8239a551c5(linkId);
    const target = link.target ?? '_blank';
    const Icon = $c1890ef03ab56a5b$export$16b26cd5e98d9100(icon);
    return {
        id: id,
        icon: icon,
        legacyId: linkId,
        target: target,
        shortcutType: shortcutType,
        text: link.name,
        before: Icon,
        href: link.url,
        canEdit: link.canEdit,
        showSync: link.showSync,
        itemType: 'shortcut'
    };
};

});
parcelRegister("5Zpxg", function(module, exports) {

var $1FqKq = parcelRequire("1FqKq");
/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */ function $45c67513b17c435f$var$initial(array) {
    var length = array == null ? 0 : array.length;
    return length ? $1FqKq(array, 0, -1) : [];
}
module.exports = $45c67513b17c435f$var$initial;

});

parcelRegister("12dl7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c105351b55ee0ad$var$_react = $0c105351b55ee0ad$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $0c105351b55ee0ad$var$_angleBrackets = $0c105351b55ee0ad$var$_interopRequireDefault((parcelRequire("8lO5P")));
function $0c105351b55ee0ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0c105351b55ee0ad$var$BitbucketReposIcon = (props)=>/*#__PURE__*/ $0c105351b55ee0ad$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 5v14h14V5zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/><path d="M9.23 8.31 6.3 11.26a1.06 1.06 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L8.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.02 1.02 0 0 0-.73-.3c-.27 0-.53.1-.73.31m4.06 0a1.05 1.05 0 0 0 0 1.48L15.5 12l-2.2 2.22a1.05 1.05 0 0 0 0 1.48c.4.41 1.06.41 1.46 0l2.93-2.95a1.05 1.05 0 0 0 0-1.48l-2.93-2.96a1.03 1.03 0 0 0-1.46 0"/></g></svg>`
    }, props, {
        newIcon: $0c105351b55ee0ad$var$_angleBrackets.default
    }));
$0c105351b55ee0ad$var$BitbucketReposIcon.displayName = 'BitbucketReposIcon';
var $0c105351b55ee0ad$var$_default = module.exports.default = $0c105351b55ee0ad$var$BitbucketReposIcon;

});
parcelRegister("8lO5P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6147244ca1278d21$var$_react = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6147244ca1278d21$var$_baseNew = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6147244ca1278d21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6147244ca1278d21$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $6147244ca1278d21$var$_react.default.createElement($6147244ca1278d21$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$6147244ca1278d21$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $6147244ca1278d21$var$_default = module.exports.default = $6147244ca1278d21$var$AngleBracketsIcon;

});




const $5ab686e904cbfbb7$export$fe791c4fa892e400 = 'project';
const $5ab686e904cbfbb7$export$b83d0ee9325a2d0a = 'projectTitle';

parcelRegister("fh5pZ", function(module, exports) {

$parcel$export(module.exports, "ContainerNavigationTabs", () => $e570296cd47ee0c3$export$90f95fd237a475b3);

var $17y8C = parcelRequire("17y8C");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $guChT = parcelRequire("guChT");

var $13z4V = parcelRequire("13z4V");
var $ipWav = parcelRequire("ipWav");

var $kfvK2 = parcelRequire("kfvK2");
var $83DiZ = parcelRequire("83DiZ");

var $5uoNn = parcelRequire("5uoNn");

var $fy9Lw = parcelRequire("fy9Lw");

var $6fFb3 = parcelRequire("6fFb3");

var $7jTnu = parcelRequire("7jTnu");

var $axSHs = parcelRequire("axSHs");

var $991ot = parcelRequire("991ot");

var $2l4Rc = parcelRequire("2l4Rc");
const $e570296cd47ee0c3$export$45d76561a5302f2b = (0, $kfvK2.createRouterSelector)((state)=>state.location);
/**
 * The logic in this hook determines the selected tab in the horizontal navigation and
 * redirects the user to the not found page if the selected tab is not found.
 *
 * There are a few caveats to this logic:
 * - We do not want to redirect to the not found page if the user is on the browse page.
 * - We do not want to redirect to the not found page if the user just removed the tab
 *   they were on and redirection to the default tab is yet to happen.
 *
 * For this reason, we only recalculate the selected tab id when the route or the navigation container has changed.
 */ const $e570296cd47ee0c3$var$useSelectedTabId = (containerData)=>{
    const prevUrl = (0, $eJOHy.useRef)(null);
    const { replace: replace } = (0, $83DiZ.useRouterActions)();
    const location = $e570296cd47ee0c3$export$45d76561a5302f2b();
    const currentUrl = (0, $7jTnu.fg)('blu-7656-personal-boards-decode-url') ? decodeURIComponent(location.pathname) + location.search : location.pathname + location.search;
    const selectedTabIdRef = (0, $eJOHy.useRef)(null);
    const notFoundUrl = `${containerData.scopeUrl}/not-found`;
    // if the current URL or the container has changed, reset the selected tab id
    if (prevUrl.current !== currentUrl) {
        selectedTabIdRef.current = null;
        prevUrl.current = currentUrl;
    }
    // if the selected tab id hasn't been set yet, try to find it
    if (selectedTabIdRef.current == null && containerData?.navigationItems?.edges && location.pathname !== notFoundUrl) {
        let fullMatchResult = null;
        let partialMatchResult = null;
        const sortedItems = containerData.navigationItems.edges.flatMap((edge)=>{
            const url = edge?.node.url;
            if (!url) return [];
            const id = edge.node.id;
            const item = {
                url: url,
                id: id
            };
            // consider URLs of nested apps
            if (edge.node.typeKey === 'APP') {
                const sections = edge.node.sections;
                if (sections) {
                    const appItems = [];
                    sections.forEach((section)=>{
                        section?.links?.forEach((link)=>{
                            if (link?.url) appItems.push({
                                url: link.url,
                                id: id
                            });
                        });
                    });
                    return [
                        item,
                        ...appItems
                    ];
                }
            }
            return item;
        }).sort((a, b)=>{
            if (!a.url || !b.url) return 0;
            return a.url.length - b.url.length;
        });
        const legacySelectedItem = new URLSearchParams(location.search).get('selectedItem');
        // check for matches of the tab url with the current url
        for (const item of sortedItems){
            // in case of legacy pages, we only check for the selectedItem query param
            if (legacySelectedItem) {
                const itemQueryParams = new URLSearchParams(item.url.split('?')[1]);
                if (itemQueryParams.get('selectedItem') === legacySelectedItem) {
                    fullMatchResult = item.id;
                    break;
                }
                continue;
            }
            // if the url is a full match, return straight away
            if (item.url === currentUrl) {
                fullMatchResult = item.id;
                break;
            }
            // if the start of the path matches, store the id and continue checking
            if (item.url && currentUrl.startsWith(item.url)) partialMatchResult = item.id;
        }
        selectedTabIdRef.current = fullMatchResult ?? partialMatchResult;
    }
    const selectedTabId = selectedTabIdRef.current;
    const shouldRedirectToNotFound = !selectedTabId && location.pathname !== notFoundUrl && !location.pathname.startsWith('/browse/');
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRedirectToNotFound) replace(notFoundUrl);
    }, [
        shouldRedirectToNotFound,
        notFoundUrl,
        replace
    ]);
    return selectedTabId;
};
const $e570296cd47ee0c3$export$90f95fd237a475b3 = ({ containerFragment: containerFragment, tabsDescriptor: tabsDescriptor, label: label, renderWithTab: renderWithTab })=>{
    const [itemWithRename, setItemWithRename] = (0, $eJOHy.useState)(null);
    const tabListRef = (0, $eJOHy.useRef)(null);
    const containerData = (0, $j4oe4.useFragment)((0, $17y8C.default), containerFragment);
    const selectedTabId = $e570296cd47ee0c3$var$useSelectedTabId(containerData);
    const onAddItem = (0, $eJOHy.useCallback)(({ id: id, typeKey: typeKey })=>{
        if (typeKey === 'APP' || !containerData?.navigationItems?.edges) // ignore apps
        return;
        // check whether there is already a tab with the same typeKey
        const hasItemOfType = containerData.navigationItems.edges.some((edge)=>edge?.node.typeKey === typeKey);
        // if an item with the same typeKey already exists, trigger the rename form for it
        if (hasItemOfType) setItemWithRename(id);
    }, [
        containerData?.navigationItems?.edges
    ]);
    const { isOptedIn: isOptedIn } = (0, $axSHs.useIsProjectPagesOptedIn)();
    const { tabsAndIds: tabsAndIds, droppableTabs: droppableTabs } = (0, $eJOHy.useMemo)(()=>{
        const tabsAll = Array.from(containerData?.navigationItems?.edges ?? []).filter(Boolean);
        const tabs = isOptedIn ? tabsAll : tabsAll.filter((edge)=>!edge?.node?.id.endsWith('/pages'));
        const tabElements = tabs?.map((edge, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
                key: edge.node.id
            }, (0, $7jTnu.fg)('jfp-magma-stability-horizontal-nav') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e570296cd47ee0c3$var$NavigationItemTabStable, {
                position: index,
                tabFragment: edge.node,
                containerFragment: containerData,
                beforeItemId: index === 0 ? null : tabs[index - 1]?.node?.id,
                afterItemId: index === tabs.length - 1 ? null : tabs[index + 1]?.node?.id,
                tabsDescriptor: tabsDescriptor,
                isRenaming: edge.node.id === itemWithRename,
                setItemWithRename: setItemWithRename,
                id: edge.node.id
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2l4Rc.NavigationItemTab), {
                position: index,
                tabFragment: edge.node,
                containerFragment: containerData,
                beforeItemId: index === 0 ? null : tabs[index - 1]?.node?.id,
                afterItemId: index === tabs.length - 1 ? null : tabs[index + 1]?.node?.id,
                tabsDescriptor: tabsDescriptor,
                isRenaming: edge.node.id === itemWithRename,
                onRenamingChange: (isRenaming)=>setItemWithRename(isRenaming ? edge.node.id : null)
            }), renderWithTab?.(edge.node)));
        return {
            tabsAndIds: tabs?.map((edge, index)=>({
                    id: edge?.node?.id,
                    tab: tabElements[index]
                })) ?? [],
            droppableTabs: tabs.map((tab)=>({
                    id: tab.node.id,
                    typeKey: tab.node.typeKey,
                    appId: tab.node.appId,
                    dataId: tab.node.__id
                }))
        };
    }, [
        containerData,
        itemWithRename,
        tabsDescriptor,
        renderWithTab,
        isOptedIn
    ]);
    (0, $991ot.useDroppableTabList)(droppableTabs, containerData.id ?? '', containerData.scopeId ?? '');
    const projectNavigationId = (0, $ipWav.useSkipLinkId)();
    (0, $13z4V.useSkipLink)(projectNavigationId, label, 3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6fFb3.TabShortcutsContextProvider), {
        navigationName: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5uoNn.TabListWithAnalytics), {
        id: projectNavigationId,
        ref: tabListRef,
        label: label,
        addTab: containerData.canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
            name: "container-navigation-tabs-add-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fy9Lw.default), {
            containerFragment: containerData,
            tabsDescriptor: tabsDescriptor,
            onAddItem: onAddItem
        })),
        selectedTabId: selectedTabId,
        tabs: tabsAndIds
    }));
};
const $e570296cd47ee0c3$var$NavigationItemTabStable = ({ position: position, tabFragment: tabFragment, containerFragment: containerFragment, beforeItemId: beforeItemId, afterItemId: afterItemId, tabsDescriptor: tabsDescriptor, isRenaming: isRenaming, id: id, setItemWithRename: setItemWithRename })=>{
    const onRenamingChange = (0, $eJOHy.useCallback)((isRename)=>setItemWithRename(isRename ? id : null), [
        id,
        setItemWithRename
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2l4Rc.NavigationItemTab), {
        position: position,
        tabFragment: tabFragment,
        containerFragment: containerFragment,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        tabsDescriptor: tabsDescriptor,
        isRenaming: isRenaming,
        onRenamingChange: onRenamingChange
    });
};

});
parcelRegister("17y8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c05c42330672b25$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51db2945011148e7fcd4e9af07a51299>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4c05c42330672b25$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "ContainerNavigationTabs_container",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "NavigationItemTab_container"
            },
            {
                "kind": "FragmentSpread",
                "name": "AddTab_container"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": v0 /*: any*/ ,
                        "action": "THROW",
                        "path": "id"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "canEdit"
                        },
                        "action": "THROW",
                        "path": "canEdit"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "scopeUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "scopeId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "first",
                                "variableName": "first"
                            }
                        ],
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "navigationItems",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraNavigationItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "navigationItems.edges.node.id"
                                                },
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appId"
                                                        },
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "NavigationItemTab_tab"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "navigationItems.edges.node"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraContainerNavigation"
            }
        ],
        "type": "JiraContainerNavigationResult",
        "abstractKey": "__isJiraContainerNavigationResult"
    };
}();
$4c05c42330672b25$var$node.hash = "109e1b7e3cf26fe989509a4a6ab41afc";
var $4c05c42330672b25$export$2e2bcd8739ae039 = $4c05c42330672b25$var$node;

});

parcelRegister("5uoNn", function(module, exports) {

$parcel$export(module.exports, "TabListWithAnalytics", () => $0d638cd62671a306$export$3bb2a319997eb2f8);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $l7wEr = parcelRequire("l7wEr");




var $iyTaR = parcelRequire("iyTaR");

var $23wTQ = parcelRequire("23wTQ");

var $2Of18 = parcelRequire("2Of18");

var $1qb7e = parcelRequire("1qb7e");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");
const $0d638cd62671a306$export$3bb2a319997eb2f8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ addTab: addTab, id: id, label: label, selectedTabId: selectedTabId, tabs: tabs }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analytics = (0, $fAZgY.useMemoWithCondition)(()=>({
            itemType: 'more',
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage,
            navigationLayer: (0, $002870cfa80d64f4$export$33d8c916a600c5e9),
            navigationContainer: (0, $95eb6070d868c1b7$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), [], ()=>(0, $7jTnu.fg)('jfp-magma-stability-horizontal-nav'));
    const triggerAnalytics = (0, $l7wEr.useNavigationItemAnalyticsWithContext)(analytics);
    const onMoreClick = (0, $eJOHy.useCallback)(({ overflowingTabCount: overflowingTabCount })=>{
        triggerAnalytics({
            childCount: overflowingTabCount
        });
    }, [
        triggerAnalytics
    ]);
    const onMoreContentChanged = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(({ overflowingTabIds: overflowingTabIds, visibleTabIds: visibleTabIds })=>{
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'horizontalNavJiraTabsContent changed', {
                hiddenTabIds: overflowingTabIds,
                visibleTabIds: visibleTabIds
            });
        }, 300), [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Of18.OnboardingSpotlightMaybe), {
        spotlight: (0, $1qb7e.Nav4OnboardingComponentNames).TAB_NAV_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $23wTQ.default), {
        addTab: addTab,
        id: id,
        label: label,
        onMoreClick: onMoreClick,
        onMoreContentChanged: onMoreContentChanged,
        ref: ref,
        selectedTabId: selectedTabId,
        tabs: tabs
    }));
});

});
parcelRegister("l7wEr", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalyticsWithContext", () => $219caabad66ea2cc$export$38dbad9cfa07995);
$parcel$export(module.exports, "useNavigationItemAnalytics", () => $219caabad66ea2cc$export$444d136efe970fd3);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $219caabad66ea2cc$export$38dbad9cfa07995 = (analytics)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((context)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        const { childCount: childCount } = context ?? {};
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'projectNavigationTab', {
            ...analytics,
            childCount: childCount ?? analytics.childCount
        });
    }, [
        analytics,
        createAnalyticsEvent
    ]);
};
const $219caabad66ea2cc$export$444d136efe970fd3 = (analytics)=>{
    const triggerAnalytics = $219caabad66ea2cc$export$38dbad9cfa07995(analytics);
    return (0, $eJOHy.useCallback)(()=>{
        triggerAnalytics();
    }, [
        triggerAnalytics
    ]);
};

});

const $107c403b1827dc68$export$d2aa6c54a5925f01 = 'v3';
const $107c403b1827dc68$export$2bd315ece9f68967 = 'v4';

parcelRegister("iyTaR", function(module, exports) {

$parcel$export(module.exports, "getNav4Rollout", () => $de9022033aff0d17$export$84a05d3b37ec5d2);

var $3ZJvm = parcelRequire("3ZJvm");

var $9hKkF = parcelRequire("9hKkF");

var $26U8a = parcelRequire("26U8a");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $8LbXh = parcelRequire("8LbXh");

var $lgw54 = parcelRequire("lgw54");

var $f4RbK = parcelRequire("f4RbK");

var $grglD = parcelRequire("grglD");

var $lrIjf = parcelRequire("lrIjf");
const $de9022033aff0d17$export$84a05d3b37ec5d2 = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJvm)))([
    [
        ()=>!(0, $7jTnu.fg)('jira_nav4'),
        (0, (/*@__PURE__*/$parcel$interopDefault($9hKkF)))((0, $8LbXh.NAV4_ROLLOUT_NONE))
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_dogfooding'),
        (0, $f4RbK.getNav4RolloutForDogfooding)
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_eap'),
        (0, $grglD.getNav4RolloutForEap)
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_beta_existing-customers'),
        (0, $lgw54.getNav4RolloutForBetaCohort)('existing-customers')
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_beta_sandboxes'),
        (0, $lgw54.getNav4RolloutForBetaCohort)('sandboxes')
    ],
    [
        ()=>(0, $epTsa.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false),
        (0, $lgw54.getNav4RolloutForBetaCohort)('free-customers')
    ],
    [
        ()=>(0, $epTsa.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false),
        (0, $lgw54.getNav4RolloutForBetaCohort)('new-customers')
    ],
    [
        ()=>(0, $epTsa.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false),
        (0, $lgw54.getNav4RolloutForBetaCohort)('new-customers-x')
    ],
    // Break up cond for easier testing.
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($26U8a))),
        (0, $lrIjf.getNav4RolloutForGaAndBeyond)
    ]
]);

});
parcelRegister("8LbXh", function(module, exports) {

$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $8b7cc1a01a020390$export$3b602cac1f385c06);
$parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", () => $8b7cc1a01a020390$export$e748a16828d2f61f);
const $8b7cc1a01a020390$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $8b7cc1a01a020390$export$e748a16828d2f61f = {
    stage: 'mobile'
};

});

parcelRegister("lgw54", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForBetaCohort", () => $319abb71143623a2$export$d0b7d7e3a8d0a0c9);

var $nK7ig = parcelRequire("nK7ig");
const $319abb71143623a2$export$d0b7d7e3a8d0a0c9 = (cohort)=>()=>cohort !== 'existing-customers' ? {
            stage: 'beta',
            cohort: cohort
        } : {
            stage: 'beta',
            cohort: cohort,
            isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
        };

});

parcelRegister("f4RbK", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForDogfooding", () => $050075f20fb5392b$export$f1e751a9a9d68fb5);

var $3ZJvm = parcelRequire("3ZJvm");

var $26U8a = parcelRequire("26U8a");

var $7jTnu = parcelRequire("7jTnu");

var $nK7ig = parcelRequire("nK7ig");
const $050075f20fb5392b$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
            stage: 'dogfooding',
            phase: phase,
            isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
        } : {
            stage: 'dogfooding',
            phase: phase
        };
const $050075f20fb5392b$export$f1e751a9a9d68fb5 = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJvm)))([
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_dogfooding_phase-2'),
        $050075f20fb5392b$var$dogfoodingPhase(2)
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_dogfooding_phase-1'),
        $050075f20fb5392b$var$dogfoodingPhase(1)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($26U8a))),
        $050075f20fb5392b$var$dogfoodingPhase(3)
    ]
]);

});

parcelRegister("grglD", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForEap", () => $094feec34cb9e06d$export$42dd8c002a342b8);

var $nK7ig = parcelRequire("nK7ig");
const $094feec34cb9e06d$export$42dd8c002a342b8 = ()=>({
        stage: 'eap',
        isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
    });

});

parcelRegister("lrIjf", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForGaAndBeyond", () => $cdb71e5e4666ce0e$export$99bed161b1040362);

var $3ZJvm = parcelRequire("3ZJvm");

var $9hKkF = parcelRequire("9hKkF");

var $26U8a = parcelRequire("26U8a");

var $7jTnu = parcelRequire("7jTnu");

var $fYeTG = parcelRequire("fYeTG");

var $nK7ig = parcelRequire("nK7ig");

var $8LbXh = parcelRequire("8LbXh");
const $cdb71e5e4666ce0e$export$99bed161b1040362 = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJvm)))([
    // Later GA phases eclipse earlier phases.
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_ga_phase-3'),
        ()=>({
                stage: 'ga',
                phase: 3
            })
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_ga_phase-2'),
        ()=>({
                stage: 'ga',
                phase: 2,
                isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_ga_phase-1-5'),
        ()=>({
                stage: 'ga',
                phase: 1.5,
                isAdmin: (0, $nK7ig.getIsAdmin)(),
                isTenantOptOut: (0, $nK7ig.getIsNav4TenantOptOut)(),
                isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_ga_phase-1'),
        ()=>({
                stage: 'ga',
                phase: 1,
                isAdmin: (0, $nK7ig.getIsAdmin)(),
                isTenantOptIn: (0, $nK7ig.getIsNav4TenantOptIn)(),
                isUserOptIn: (0, $nK7ig.getIsNav4UserOptIn)(),
                isUserOptOut: (0, $nK7ig.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $7jTnu.fg)('jira_nav4_ga_sandboxes'),
        ()=>({
                stage: 'ga',
                cohort: 'sandboxes',
                isUserOptIn: (0, $nK7ig.getIsNav4UserOptIn)()
            })
    ],
    [
        ()=>(0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)(),
        (0, (/*@__PURE__*/$parcel$interopDefault($9hKkF)))((0, $8LbXh.NAV4_ROLLOUT_MOBILE))
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($26U8a))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9hKkF)))((0, $8LbXh.NAV4_ROLLOUT_NONE))
    ]
]);

});


parcelRegister("23wTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $69416ed3a7603a3e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $82KGI = parcelRequire("82KGI");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");


var $fhrsC = parcelRequire("fhrsC");

var $crL7m = parcelRequire("crL7m");

var $ecMty = parcelRequire("ecMty");

var $1NkjX = parcelRequire("1NkjX");

var $iI00c = parcelRequire("iI00c");
const $69416ed3a7603a3e$var$calculateOverflowTabs = (tabContainer, showMoreButton, selectedTabIndex)=>{
    const overflowTabs = new Set();
    if (tabContainer.current == null) return overflowTabs;
    // All the tabs fit in the container, no need to calculate overflow.
    if (tabContainer.current.scrollWidth <= tabContainer.current.offsetWidth) return overflowTabs;
    // Show the more button as it takes up space in the tab list. This ensures we
    // calculate the tab container width correctly below.
    const resetMoreButtonStyles = showMoreButton();
    // Calculate the tab container width by subtracting padding from the tab container offset width.
    const tabContainerComputedStyle = window.getComputedStyle(tabContainer.current);
    const tabContainerPadding = parseFloat(tabContainerComputedStyle.paddingLeft) + parseFloat(tabContainerComputedStyle.paddingRight);
    const tabContainerWidth = tabContainer.current.offsetWidth - tabContainerPadding;
    const tabs = tabContainer.current.children;
    const selectedTabWidth = tabs[selectedTabIndex]?.offsetWidth || 0;
    const selectedTabGap = selectedTabIndex === -1 ? 0 : (0, $995807b180d1b2d0$export$b61e6f89a9db76de);
    const availableWidth = tabContainerWidth - selectedTabWidth - selectedTabGap;
    let tabsWidth = 0;
    let gapCount = 0;
    for(let i = 0; i < tabs.length; i++){
        // Skip the selected tab, as it should always be visible. Its width and gap are already accounted for above.
        if (i === selectedTabIndex) continue;
        tabsWidth += tabs[i].offsetWidth;
        if (tabsWidth > availableWidth - (0, $995807b180d1b2d0$export$b61e6f89a9db76de) * gapCount) overflowTabs.add(i);
        gapCount++;
    }
    resetMoreButtonStyles();
    return overflowTabs;
};
const $69416ed3a7603a3e$var$initialOverflowState = {
    mustRecalculateOverflowTabs: false,
    overflowTabs: new Set(),
    overflowedTabs: new Set()
};
const $69416ed3a7603a3e$var$overflowReducer = (state, action)=>{
    switch(action.type){
        case 'SET_MUST_RECALCULATE':
            return {
                ...state,
                mustRecalculateOverflowTabs: true,
                overflowTabs: new Set()
            };
        case 'SET_OVERFLOW_TABS':
            return {
                ...state,
                mustRecalculateOverflowTabs: false,
                overflowTabs: action.payload,
                overflowedTabs: new Set([
                    ...state.overflowedTabs,
                    ...action.payload
                ])
            };
        default:
            return state;
    }
};
const $69416ed3a7603a3e$var$TabList = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ addTab: addTab, id: id, label: label, onMoreClick: onMoreClick, onMoreContentChanged: onMoreContentChanged = ()=>{}, selectedTabId: selectedTabId, tabs: tabs }, ref)=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $eJOHy.useState)(false);
    const navRef = (0, $eJOHy.useRef)(null);
    const internalTabContainerRef = (0, $eJOHy.useRef)(null);
    const tabContainerRef = (0, $82KGI.useMergeRefs)([
        ref,
        internalTabContainerRef
    ]);
    const moreButtonWrapperRef = (0, $eJOHy.useRef)(null);
    const [{ mustRecalculateOverflowTabs: mustRecalculateOverflowTabs, overflowTabs: overflowTabs, overflowedTabs: overflowedTabs }, dispatch] = (0, $eJOHy.useReducer)($69416ed3a7603a3e$var$overflowReducer, $69416ed3a7603a3e$var$initialOverflowState);
    const selectedTabIndex = tabs.findIndex(({ id: id })=>id === selectedTabId);
    const overflowingTabCount = overflowTabs.size;
    const hasOverflowTabs = overflowingTabCount > 0;
    const debouncedCalculateOverflowTabs = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            dispatch({
                type: 'SET_MUST_RECALCULATE'
            });
        }, 300, {
            leading: true
        }), []);
    (0, $eJOHy.useLayoutEffect)(()=>{
        debouncedCalculateOverflowTabs();
    }, [
        debouncedCalculateOverflowTabs,
        selectedTabId,
        tabs
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (mustRecalculateOverflowTabs) {
            const showMoreButton = ()=>{
                if (moreButtonWrapperRef.current != null) moreButtonWrapperRef.current.style.display = 'block';
                return ()=>{
                    if (moreButtonWrapperRef.current != null) moreButtonWrapperRef.current.removeAttribute('style');
                };
            };
            dispatch({
                type: 'SET_OVERFLOW_TABS',
                payload: $69416ed3a7603a3e$var$calculateOverflowTabs(internalTabContainerRef, showMoreButton, selectedTabIndex)
            });
        }
    }, [
        mustRecalculateOverflowTabs,
        selectedTabIndex
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const resizeObserver = new ResizeObserver(debouncedCalculateOverflowTabs);
        if (navRef.current) resizeObserver.observe(navRef.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        debouncedCalculateOverflowTabs
    ]);
    const onMoreTabClick = (0, $eJOHy.useCallback)(()=>{
        setIsMoreOpen((prev)=>!prev);
        if (onMoreClick) onMoreClick({
            overflowingTabCount: overflowingTabCount
        });
    }, [
        onMoreClick,
        overflowingTabCount
    ]);
    const { overflowingTabs: overflowingTabs, overflowingTabIds: overflowingTabIds, visibleTabs: visibleTabs, visibleTabIds: visibleTabIds } = (0, $eJOHy.useMemo)(()=>{
        const visibleTabs = [];
        const overflowingTabs = [];
        const overflowingTabIds = [];
        const visibleTabIds = [];
        tabs.forEach(({ tab: tab, id: id }, index)=>{
            const tabContent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fhrsC.TabProvider), {
                id: id,
                isOverflowing: overflowTabs.has(index),
                hasOverflowed: overflowedTabs.has(index),
                isSelected: id === selectedTabId,
                children: tab
            }, id);
            if (overflowTabs.has(index)) {
                overflowingTabs.push(tabContent);
                overflowingTabIds.push(id);
            } else {
                visibleTabs.push(tabContent);
                visibleTabIds.push(id);
            }
        });
        return {
            overflowingTabs: overflowingTabs,
            overflowingTabIds: overflowingTabIds,
            visibleTabs: visibleTabs,
            visibleTabIds: visibleTabIds
        };
    }, [
        overflowedTabs,
        overflowTabs,
        selectedTabId,
        tabs
    ]);
    // overflowingTabIds flickers between empty and non-empty array
    // therefore using useDeferredValue to un-flicker the value as well as JSON.stringify
    // to ensure the effect is triggered based on the value of overflowingTabIds and not the reference.
    const overflowingTabIdsStr = (0, $eJOHy.useDeferredValue)(JSON.stringify(overflowingTabIds));
    (0, $eJOHy.useEffect)(()=>{
        onMoreContentChanged({
            overflowingTabIds: overflowingTabIds,
            visibleTabIds: visibleTabIds
        });
    }, [
        overflowingTabIdsStr
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const closeMore = (0, $eJOHy.useCallback)(()=>setIsMoreOpen(false), []);
    const renderPopupContent = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NkjX.MoreMenuContents), {
            close: closeMore,
            selectedTabId: selectedTabId,
            children: overflowingTabs
        });
    }, [
        closeMore,
        overflowingTabs,
        selectedTabId
    ]);
    const renderPopupTrigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ref: moreButtonWrapperRef,
            className: (0, $hcewu.default)([
                $69416ed3a7603a3e$var$styles.moreButtonWrapper,
                !hasOverflowTabs && $69416ed3a7603a3e$var$styles.moreButtonWrapperHidden
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iI00c.MoreTrigger), {
                onClick: onMoreTabClick,
                count: overflowingTabCount,
                ...triggerProps,
                isOpen: isMoreOpen
            })
        }), [
        hasOverflowTabs,
        isMoreOpen,
        onMoreTabClick,
        overflowingTabCount
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $crL7m.default), {
        id: id,
        ref: navRef,
        label: label,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ecMty.default), {
                ref: tabContainerRef,
                children: visibleTabs
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                content: renderPopupContent,
                isOpen: isMoreOpen,
                onClose: closeMore,
                placement: "bottom-end",
                testId: "navigation-kit-ui-tab-list.ui.more-popup",
                trigger: renderPopupTrigger,
                shouldRenderToParent: (0, $eGOwo.fg)('should-render-to-parent-should-be-true-nav')
            }),
            addTab && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $69416ed3a7603a3e$var$styles.addTabWrapper
                ]),
                children: addTab
            })
        ]
    });
});
const $69416ed3a7603a3e$var$styles = {
    addTabWrapper: "_16jlidpf _1o9zidpf _i0dl1wug _1rjc1b66 _1e0c1txw",
    moreButtonWrapper: "_16jlidpf _1o9zidpf _i0dl1wug",
    moreButtonWrapperHidden: "_1e0cglyw"
};
var $69416ed3a7603a3e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($69416ed3a7603a3e$var$TabList);

});
const $995807b180d1b2d0$export$d1b9ea3245b6a5de = 3;
const $995807b180d1b2d0$export$d07bba395c9390f1 = 32;
const $995807b180d1b2d0$export$29911ec08ab2ca2d = 5;
const $995807b180d1b2d0$export$b61e6f89a9db76de = 4;
const $995807b180d1b2d0$export$7fd2e391116c6ef5 = 9;
const $995807b180d1b2d0$export$e1633e494d305bfb = 'MORE';
const $995807b180d1b2d0$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $995807b180d1b2d0$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $995807b180d1b2d0$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $995807b180d1b2d0$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $995807b180d1b2d0$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $995807b180d1b2d0$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $995807b180d1b2d0$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $995807b180d1b2d0$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $995807b180d1b2d0$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $995807b180d1b2d0$export$8dd437f6d09d567 = '--horizontal-navigation-color-background-neutral-selected';
const $995807b180d1b2d0$export$cf26c31143daa350 = '--hn-yjlbv';

parcelRegister("fhrsC", function(module, exports) {

$parcel$export(module.exports, "TabProvider", () => $4f9970e7f5f378e9$export$c0b2172d40e0c73a);
$parcel$export(module.exports, "useTabContext", () => $4f9970e7f5f378e9$export$5a3bad273ac578e0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $4f9970e7f5f378e9$var$TabContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $4f9970e7f5f378e9$export$c0b2172d40e0c73a = ({ children: children, id: id, isOverflowing: isOverflowing, hasOverflowed: hasOverflowed, isSelected: isSelected })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            id: id,
            isOverflowing: isOverflowing,
            hasOverflowed: hasOverflowed,
            isSelected: isSelected
        }), [
        id,
        isOverflowing,
        hasOverflowed,
        isSelected
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4f9970e7f5f378e9$var$TabContext.Provider, {
        value: value,
        children: children
    });
};
const $4f9970e7f5f378e9$export$5a3bad273ac578e0 = ()=>{
    const context = (0, $eJOHy.useContext)($4f9970e7f5f378e9$var$TabContext);
    if (!context) throw new Error('useTab must be used within a TabProvider');
    return context;
};

});

parcelRegister("crL7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2f2173f46c6a82e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $a2f2173f46c6a82e$var$ResponsiveNav = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, label: label, id: id }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("nav", {
        "aria-label": label,
        ref: ref,
        id: id,
        className: (0, $hcewu.default)([
            $a2f2173f46c6a82e$var$styles.root
        ]),
        children: children
    }));
const $a2f2173f46c6a82e$var$styles = {
    root: "_zulp1y44 _1e0c1txw _kqswh2mm _1ul9idpf _19bvpxbi _u5f3pxbi _1s6km7gv _1kt9b3bt _1cs8stnw _19woidpf _kfgtt94y _qnecidpf _oounidpf"
};
var $a2f2173f46c6a82e$export$2e2bcd8739ae039 = $a2f2173f46c6a82e$var$ResponsiveNav;

});

parcelRegister("ecMty", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ffa1060f9f2cb03$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $0ffa1060f9f2cb03$var$TabWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>{
    if ((0, $eGOwo.fg)('jfp_a11y_team_board_missing_unordered_list_mark-up')) return /*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ref: ref,
        className: (0, $hcewu.default)([
            $0ffa1060f9f2cb03$var$styles.root,
            $0ffa1060f9f2cb03$var$listStyles.ulRoot
        ]),
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        className: (0, $hcewu.default)([
            $0ffa1060f9f2cb03$var$styles.root
        ]),
        children: children
    });
});
const $0ffa1060f9f2cb03$var$styles = {
    root: "_zulp1y44 _1reo15vq _18m915vq _vchhusvi _1e0c1txw _2lx2vrvc _1n261q9c _4t3izwfg _otyrze3t _18u0xmi2 _2hwxxmi2 _19pkze3t _n3tdze3t _19bvutpp _u5f3utpp _ca0qze3t"
};
const $0ffa1060f9f2cb03$var$listStyles = {
    ulRoot: "_2mzuglyw"
};
var $0ffa1060f9f2cb03$export$2e2bcd8739ae039 = $0ffa1060f9f2cb03$var$TabWrapper;

});

parcelRegister("1NkjX", function(module, exports) {

$parcel$export(module.exports, "MoreMenuContents", () => $793d5eb2a1ad87b8$export$acf06d2aac619450);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $aIjmF = parcelRequire("aIjmF");
const $793d5eb2a1ad87b8$export$acf06d2aac619450 = ({ children: children, close: close, selectedTabId: selectedTabId })=>{
    const menuContentsRef = (0, $eJOHy.useRef)(null);
    const previousSelectedTabId = (0, $eJOHy.useRef)(selectedTabId);
    (0, $eJOHy.useEffect)(()=>{
        if (selectedTabId !== previousSelectedTabId.current && close) close();
        else previousSelectedTabId.current = selectedTabId;
    }, [
        selectedTabId,
        close
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!menuContentsRef.current) return;
        (0, $aIjmF.autoScrollForElements)({
            element: menuContentsRef.current
        });
    }, []);
    if ((0, $eGOwo.fg)('jfp_a11y_team_board_missing_unordered_list_mark-up')) return /*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ref: menuContentsRef,
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjct94y _c71lyly2 _18m91wug _2mzuglyw"
        ]),
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: menuContentsRef,
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: (0, $hcewu.default)([
            "_1rjct94y _c71lyly2 _18m91wug"
        ]),
        children: children
    });
};
const $793d5eb2a1ad87b8$var$moreMenuContentsStyles = null;
const $793d5eb2a1ad87b8$var$moreMenuContentsUlStyles = null;

});
parcelRegister("aIjmF", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $c0447705cceebafd$export$4b66ee8317094cdb);

var $bGx3v = parcelRequire("bGx3v");

var $e5OX3 = parcelRequire("e5OX3");
const $c0447705cceebafd$var$api = (0, $e5OX3.makeApi)({
    monitor: (0, $bGx3v.monitorForElements)
});
const $c0447705cceebafd$export$4b66ee8317094cdb = $c0447705cceebafd$var$api.autoScroll;
const $c0447705cceebafd$export$c9168f41de61f525 = $c0447705cceebafd$var$api.autoScrollWindow;

});
parcelRegister("e5OX3", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $24eab05605d213de$export$b8fa21320a811083);

var $dROq6 = parcelRequire("dROq6");
parcelRequire("hOCz6");
var $6Z6g4 = parcelRequire("6Z6g4");

var $fftUG = parcelRequire("fftUG");

var $3P3tr = parcelRequire("3P3tr");

var $9j2mN = parcelRequire("9j2mN");
function $24eab05605d213de$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $dROq6.combine)((0, $3P3tr.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $6Z6g4.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $6Z6g4.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $9j2mN.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $fftUG.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("hOCz6", function(module, exports) {

$parcel$export(module.exports, "once", () => (parcelRequire("6Z6g4")).once);

var $6Z6g4 = parcelRequire("6Z6g4");

});

parcelRegister("fftUG", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $d1030e6e1449d633$export$5cff7ac265db316a);
parcelRequire("9QxkX");
var $eNpGE = parcelRequire("eNpGE");

var $c9EXM = parcelRequire("c9EXM");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $d1030e6e1449d633$var$schedulers = new Map();
function $d1030e6e1449d633$export$5cff7ac265db316a(monitor) {
    const scheduler = $d1030e6e1449d633$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $d1030e6e1449d633$var$makeScheduler(monitor);
    $d1030e6e1449d633$var$schedulers.set(monitor, created);
    return created;
}
function $d1030e6e1449d633$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $eNpGE.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $c9EXM.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $c9EXM.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("9QxkX", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("eNpGE")).getElementFromPointWithoutHoneypot);

var $eNpGE = parcelRequire("eNpGE");

});

parcelRegister("c9EXM", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $a23e9e6251c2c7ae$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $a23e9e6251c2c7ae$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $a23e9e6251c2c7ae$export$13ae770ed39b71ea);
const $a23e9e6251c2c7ae$var$ledger = new Map();
const $a23e9e6251c2c7ae$var$requested = new Set();
function $a23e9e6251c2c7ae$export$8c764c3f2fc3d2d2(element) {
    $a23e9e6251c2c7ae$export$1cb7cbb266b6f6fa(element);
    const entry = $a23e9e6251c2c7ae$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $a23e9e6251c2c7ae$var$ledger.set(element, fresh);
    return fresh;
}
function $a23e9e6251c2c7ae$export$1cb7cbb266b6f6fa(element) {
    $a23e9e6251c2c7ae$var$requested.add(element);
}
function $a23e9e6251c2c7ae$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $a23e9e6251c2c7ae$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $a23e9e6251c2c7ae$var$ledger.forEach((_, element)=>{
        if (!$a23e9e6251c2c7ae$var$requested.has(element)) $a23e9e6251c2c7ae$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $a23e9e6251c2c7ae$var$requested.clear();
}
function $a23e9e6251c2c7ae$export$13ae770ed39b71ea() {
    $a23e9e6251c2c7ae$var$ledger.clear();
}

});


parcelRegister("3P3tr", function(module, exports) {

$parcel$export(module.exports, "selector", () => $f6a1f9b48cb20ee6$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $f6a1f9b48cb20ee6$export$4ec12fb57dfebd53);
const $f6a1f9b48cb20ee6$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $f6a1f9b48cb20ee6$export$aea217a45095ce11 = `[${$f6a1f9b48cb20ee6$export$4b152ab55cad4fd6}="true"]`;
function $f6a1f9b48cb20ee6$export$4ec12fb57dfebd53(element) {
    element.setAttribute($f6a1f9b48cb20ee6$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($f6a1f9b48cb20ee6$export$4b152ab55cad4fd6);
}

});

parcelRegister("9j2mN", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $2b6fd94ad307d6a1$export$233199807749476d);

var $lmVE7 = parcelRequire("lmVE7");

var $c9EXM = parcelRequire("c9EXM");

var $3P3tr = parcelRequire("3P3tr");

var $qLxmx = parcelRequire("qLxmx");
function $2b6fd94ad307d6a1$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $2b6fd94ad307d6a1$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$2b6fd94ad307d6a1$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $3P3tr.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $2b6fd94ad307d6a1$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $c9EXM.markAndGetEngagement)(element);
    const config = (0, $lmVE7.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $qLxmx.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $2b6fd94ad307d6a1$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $c9EXM.markAndGetEngagement)(element);
        const config = (0, $lmVE7.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $qLxmx.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $2b6fd94ad307d6a1$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $2b6fd94ad307d6a1$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$2b6fd94ad307d6a1$var$isScrollingAvailable(remainder)) return;
    $2b6fd94ad307d6a1$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("lmVE7", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $38982e7d63c9dd3e$export$e96028ec7ff9d079);
const $38982e7d63c9dd3e$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $38982e7d63c9dd3e$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $38982e7d63c9dd3e$export$e96028ec7ff9d079(provided) {
    return {
        ...$38982e7d63c9dd3e$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $38982e7d63c9dd3e$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("qLxmx", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $3bdf57893fa68d93$export$6cfa6dfe6898b98f);

var $iztXk = parcelRequire("iztXk");

var $b7xcZ = parcelRequire("b7xcZ");

var $jzhbx = parcelRequire("jzhbx");

var $dii7x = parcelRequire("dii7x");

var $5o9jp = parcelRequire("5o9jp");

var $9zUln = parcelRequire("9zUln");
function $3bdf57893fa68d93$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $3bdf57893fa68d93$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $3bdf57893fa68d93$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $b7xcZ.edges).reduce((map, edge)=>{
        const hitbox = (0, $jzhbx.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $b7xcZ.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $5o9jp.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $9zUln.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $iztXk.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $dii7x.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $dii7x.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $dii7x.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $dii7x.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("iztXk", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $c53a7e6dbe56d62b$export$ccd6d9407403fcad);
const $c53a7e6dbe56d62b$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("b7xcZ", function(module, exports) {

$parcel$export(module.exports, "edges", () => $182654dd0a611870$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $182654dd0a611870$export$7fc144124ccf8292);
const $182654dd0a611870$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $182654dd0a611870$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("jzhbx", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $265697c1b551eb64$export$b9a449c20abb0e9);

var $eodmz = parcelRequire("eodmz");

var $8RSm7 = parcelRequire("8RSm7");
function $265697c1b551eb64$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $eodmz.axisLookup)[axis];
        const side = (0, $8RSm7.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $265697c1b551eb64$export$b9a449c20abb0e9 = {
    top: $265697c1b551eb64$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $265697c1b551eb64$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $265697c1b551eb64$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $265697c1b551eb64$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("eodmz", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $df627247da8c4728$export$42e42cdab35a2b96);
const $df627247da8c4728$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $df627247da8c4728$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $df627247da8c4728$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $df627247da8c4728$var$vertical,
        crossAxis: $df627247da8c4728$var$horizontal
    },
    horizontal: {
        mainAxis: $df627247da8c4728$var$horizontal,
        crossAxis: $df627247da8c4728$var$vertical
    }
};

});

parcelRegister("8RSm7", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $35cf3d4ff0f87f72$export$a45c0cd714a4dbaa);
const $35cf3d4ff0f87f72$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("dii7x", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $4c3d9a9aa81f4c30$export$470a2ff46db8cee8);

var $eodmz = parcelRequire("eodmz");

var $1NJXT = parcelRequire("1NJXT");

var $8RSm7 = parcelRequire("8RSm7");
// We want a consistent scroll speed across devices, regardless of framerate
function $4c3d9a9aa81f4c30$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $4c3d9a9aa81f4c30$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $eodmz.axisLookup)[axis];
    const side = (0, $8RSm7.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $1NJXT.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $1NJXT.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $4c3d9a9aa81f4c30$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $4c3d9a9aa81f4c30$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $4c3d9a9aa81f4c30$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $1NJXT.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $8RSm7.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("1NJXT", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $f33af4a0dbb2125f$export$1a29de000a332d74);
function $f33af4a0dbb2125f$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("5o9jp", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $b5693d0276cf297b$export$7120fdbd90bd1292);
function $b5693d0276cf297b$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("9zUln", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $d50ffa5fc30325d7$export$cda7a9d4399bf2e3);
function $d50ffa5fc30325d7$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});






parcelRegister("iI00c", function(module, exports) {

$parcel$export(module.exports, "MoreTrigger", () => $1ddfae9385897cdc$export$8220169239c5b5cd);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $7q9BG = parcelRequire("7q9BG");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");


var $krCQX = parcelRequire("krCQX");
var $fhrsC = parcelRequire("fhrsC");

var $6RtEe = parcelRequire("6RtEe");
const $1ddfae9385897cdc$var$ThemedBadge = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
        ...props,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color: `var(${(0, $995807b180d1b2d0$export$cf26c31143daa350)}, ${"var(--ds-text-subtle, #44546F)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            backgroundColor: `var(${(0, $995807b180d1b2d0$export$be4d7e23cb48401e)}, ${"var(--ds-background-neutral, #091E420F)"})`
        }
    });
};
const $1ddfae9385897cdc$export$8220169239c5b5cd = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ count: count, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fhrsC.TabProvider), {
        id: (0, $995807b180d1b2d0$export$e1633e494d305bfb),
        isOverflowing: false,
        isSelected: false,
        hasOverflowed: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $krCQX.default), {
            ...rest,
            ref: ref,
            name: formatMessage((0, $6RtEe.default).moreTabWithBadge),
            "aria-label": formatMessage((0, $6RtEe.default).moreTabsWithBadgeLabel, {
                tabCount: count
            }),
            type: "dropdown-trigger",
            isMoreMenu: true,
            isChevronHidden: true,
            testId: "navigation-kit-ui-tab-list.ui.more-trigger.more-tab",
            elemAfter: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    ' ',
                    // no wrapper is required for count > 9 as the badge will always contain 9+ so will be the same width
                    count > (0, $995807b180d1b2d0$export$7fd2e391116c6ef5) ? /*#__PURE__*/ (0, $gt9Am.jsx)($1ddfae9385897cdc$var$ThemedBadge, {
                        max: (0, $995807b180d1b2d0$export$7fd2e391116c6ef5),
                        children: count
                    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                        as: "span",
                        xcss: $1ddfae9385897cdc$var$moreDigitBadgeWrapperStyles,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)($1ddfae9385897cdc$var$ThemedBadge, {
                            max: (0, $995807b180d1b2d0$export$7fd2e391116c6ef5),
                            children: count
                        })
                    })
                ]
            })
        })
    });
});
const $1ddfae9385897cdc$var$moreDigitBadgeWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    minWidth: "var(--ds-space-250, 20px)"
});

});
parcelRegister("krCQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb5e174de7ddaf30$export$2e2bcd8739ae039);

var $9WrRY = parcelRequire("9WrRY");

var $fhrsC = parcelRequire("fhrsC");
var $fb5e174de7ddaf30$export$2e2bcd8739ae039 = (0, $9WrRY.default);

});
parcelRegister("9WrRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec4b12959af6798$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aIBSh = parcelRequire("aIBSh");

var $l5gYB = parcelRequire("l5gYB");
const $4ec4b12959af6798$var$OuterTab = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, outerRef)=>{
    if (props.type === 'dropdown-trigger') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aIBSh.default), {
        ...props,
        ref: outerRef
    });
    if (props.type === 'anchor' || props.type === 'router-link' || props.type === undefined) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l5gYB.default), {
        ...props,
        ref: outerRef
    });
    return null;
}));
var $4ec4b12959af6798$export$2e2bcd8739ae039 = $4ec4b12959af6798$var$OuterTab;

});
parcelRegister("aIBSh", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f30f608e7dc6ff$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $82KGI = parcelRequire("82KGI");

var $5lAAn = parcelRequire("5lAAn");

var $dB1eP = parcelRequire("dB1eP");

var $7saMl = parcelRequire("7saMl");
var $1PYwQ = parcelRequire("1PYwQ");

var $6djmC = parcelRequire("6djmC");

var $4EPZb = parcelRequire("4EPZb");

var $jnlkW = parcelRequire("jnlkW");

var $ee2GE = parcelRequire("ee2GE");

var $fwPAA = parcelRequire("fwPAA");

var $4vgZf = parcelRequire("4vgZf");

var $hf6se = parcelRequire("hf6se");

var $JzSjQ = parcelRequire("JzSjQ");

var $knCBc = parcelRequire("knCBc");

var $fhrsC = parcelRequire("fhrsC");

var $968u0 = parcelRequire("968u0");
const $74f30f608e7dc6ff$var$HeadingWhenSelected = ({ isSelected: isSelected, children: children })=>{
    /* eslint-disable-next-line @atlaskit/design-system/use-heading */ return isSelected ? /*#__PURE__*/ (0, $gt9Am.jsx)($74f30f608e7dc6ff$var$HeadingWrapper, {
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
};
const $74f30f608e7dc6ff$export$471d16b0e03bf864 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ elemAfter: elemAfter, elemBefore: elemBefore, handleDrag: handleDrag, isChevronHidden: isChevronHidden = false, isDraggable: isDraggable = false, isMoreMenu: isMoreMenu, isOpen: isOpen = false, isRenaming: isRenaming, name: name, onClick: onClick, onRenameCancel: onRenameCancel, onRenameComplete: onRenameComplete, position: position, renderMenu: renderMenu, testId: testId, ...buttonPassthroughProps }, outerRef)=>{
    const { id: id, isSelected: isSelected, isOverflowing: isOverflowing } = (0, $fhrsC.useTabContext)();
    const elementRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $82KGI.useMergeRefs)([
        outerRef,
        elementRef
    ]);
    const isActive = isOpen || isSelected;
    const [isMenuOpen, setIsMenuOpen] = (0, $eJOHy.useState)(false);
    const { closestEdge: closestEdge, isActiveDropZone: isActiveDropZone, dragState: dragState, isDragging: isDragging } = (0, $968u0.useDraggableTabs)({
        isDragEnabled: isDraggable,
        isDropEnabled: true,
        position: position,
        id: id,
        handleDrag: handleDrag,
        isSelected: isSelected,
        isOverflowing: isOverflowing,
        isMoreMenu: isMoreMenu,
        elementRef: elementRef
    });
    const hasMenu = renderMenu != null;
    const rightChevron = isChevronHidden ? undefined : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
        color: "currentColor",
        spacing: "spacious",
        label: "",
        size: "small"
    });
    const downChevron = isChevronHidden ? undefined : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
        color: "currentColor",
        spacing: "spacious",
        label: "",
        size: "small"
    });
    if (isOverflowing) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fwPAA.default), {
            isOverflowing: true,
            isOpen: isMenuOpen,
            isSelected: isActive,
            hasMenu: hasMenu,
            isRenaming: isRenaming,
            children: [
                isRenaming ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1PYwQ.default), {
                    component: (0, $hf6se.RenameMenuItemComponent),
                    iconBefore: elemBefore,
                    iconAfter: elemAfter ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                        alignBlock: "center",
                        children: [
                            elemAfter,
                            rightChevron
                        ]
                    }) : rightChevron,
                    ref: mergedRefs,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $JzSjQ.default), {
                                defaultValue: name,
                                onCancel: onRenameCancel,
                                onConfirm: onRenameComplete
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jnlkW.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                alignBlock: "center",
                                children: [
                                    elemAfter,
                                    rightChevron
                                ]
                            }) : rightChevron,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7saMl.default), {
                    ...buttonPassthroughProps,
                    ref: mergedRefs,
                    onClick: onClick,
                    testId: testId,
                    "aria-current": isSelected ? 'page' : undefined,
                    iconBefore: elemBefore,
                    iconAfter: elemAfter ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                        alignBlock: "center",
                        children: [
                            elemAfter,
                            rightChevron
                        ]
                    }) : rightChevron,
                    isSelected: isActive,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: name
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jnlkW.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                alignBlock: "center",
                                children: [
                                    elemAfter,
                                    rightChevron
                                ]
                            }) : rightChevron,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }),
                hasMenu && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4vgZf.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_zulp1b66 _kqswstnw _1e0c1txw _4cvr1h6o _1xi21jfw _154iu2gc"
                        ]),
                        children: renderMenu != null && renderMenu({
                            isOverflowing: isOverflowing,
                            isOpen: isMenuOpen,
                            setIsOpen: setIsMenuOpen
                        })
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fwPAA.default), {
        isSelected: isActive,
        isOpen: isMenuOpen,
        hasMenu: hasMenu,
        isRenaming: isRenaming,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $knCBc.default), {
            isSelected: isActive,
            isDragging: isDragging,
            ref: mergedRefs,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-testid": "navigation-kit-ui-tab.ui.dropdown-trigger-tab.tab-button",
                    className: (0, $hcewu.default)([
                        "_1ul91ris",
                        isActiveDropZone && "_bfhk1af1"
                    ]),
                    children: isRenaming ? /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                        "data-delegated-focus-ring": true,
                        "data-testid": testId,
                        className: (0, $hcewu.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _19itglyw _1e0c1txw _kqswh2mm _1q51pxbi _y4tize3t _85i5pxbi _bozg1b66 _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vwz4n7od _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _bfhk18uv _80omtlke _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                            isMoreMenu && "_3ll11ked _12gy1yx7 _1ux11yx7 _1vg51yx7 _1qdthppw",
                            isSelected && "_syaz1yx7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ee2GE.default), {
                                elementBefore: elemBefore
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $JzSjQ.default), {
                                defaultValue: name,
                                onCancel: onRenameCancel,
                                onConfirm: onRenameComplete
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4EPZb.default), {
                                elemAfter: elemAfter ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                    alignBlock: "center",
                                    children: [
                                        elemAfter,
                                        downChevron
                                    ]
                                }) : downChevron,
                                closestEdge: closestEdge,
                                dragState: dragState,
                                name: name
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($74f30f608e7dc6ff$var$HeadingWhenSelected, {
                        isSelected: isSelected,
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("button", {
                            ...buttonPassthroughProps,
                            "data-delegated-focus-ring": true,
                            "data-testid": testId,
                            type: "button",
                            onClick: onClick,
                            "aria-current": isSelected ? 'page' : undefined,
                            className: (0, $hcewu.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _19itglyw _1e0c1txw _kqswh2mm _1q51pxbi _y4tize3t _85i5pxbi _bozg1b66 _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vwz4n7od _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _bfhk18uv _80omtlke _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                                isMoreMenu && "_3ll11ked _12gy1yx7 _1ux11yx7 _1vg51yx7 _1qdthppw",
                                isSelected && "_syaz1yx7"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ee2GE.default), {
                                    elementBefore: elemBefore
                                }),
                                name,
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4EPZb.default), {
                                    elemAfter: elemAfter ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                        alignBlock: "center",
                                        children: [
                                            elemAfter,
                                            downChevron
                                        ]
                                    }) : downChevron,
                                    closestEdge: closestEdge,
                                    dragState: dragState,
                                    name: name
                                })
                            ]
                        })
                    })
                }),
                hasMenu && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4vgZf.default), {
                    children: renderMenu != null && renderMenu({
                        isOpen: isMenuOpen,
                        setIsOpen: setIsMenuOpen
                    })
                })
            ]
        })
    });
}));
const $74f30f608e7dc6ff$var$boxStyles = null;
const $74f30f608e7dc6ff$var$boxHighlightedStyles = null;
const $74f30f608e7dc6ff$var$currentTabLabelStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $74f30f608e7dc6ff$var$HeadingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz4n7od",
            __cmplp.className
        ])
    });
});
const $74f30f608e7dc6ff$var$tabStyles = null;
const $74f30f608e7dc6ff$var$overflowItemWrapperStyles = null;
const $74f30f608e7dc6ff$var$overflowNameWrapperStyles = null;
const $74f30f608e7dc6ff$var$actionItemsWrapperStyles = null;
/**
 * Although these variables are used in the Badge, they are defined here so they can change on tab
 * hover/focus/active states.
 */ const $74f30f608e7dc6ff$var$moreButtonBadgeStyles = null;
var $74f30f608e7dc6ff$export$2e2bcd8739ae039 = $74f30f608e7dc6ff$export$471d16b0e03bf864;

});
parcelRegister("4EPZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cf4217852c51d66$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aQK2r = parcelRequire("aQK2r");

var $aMdh8 = parcelRequire("aMdh8");

var $igtYB = parcelRequire("igtYB");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");


var $a5OKP = parcelRequire("a5OKP");
const $3cf4217852c51d66$var$DropIndicator = ({ closestEdge: closestEdge, testId: testId })=>(closestEdge && /*#__PURE__*/ (0, $gt9Am.jsx)($3cf4217852c51d66$var$DropIndicatorWrapper, {
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
            edge: closestEdge,
            gap: `${(0, $995807b180d1b2d0$export$b61e6f89a9db76de)}px`
        })
    })) ?? null;
const $3cf4217852c51d66$export$905ab40ac2179daa = ({ elemAfter: elemAfter, name: name })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": "navigation-kit-ui-tab-common.ui.after-elements.drag-preview",
        className: (0, $hcewu.default)([
            "_zulp1b66 _h7al1vdr _1e0c1txw _4cvr1h6o _13lipd34 _qrwqpd34 _syaz1f7t _bfhk1h36 _ca0qidpf _u5f3u2gc _n3tdidpf _19bv1b66 _4t3izwfg _qdn51txw",
            !(0, $a5OKP.isSafari)() && "_139e1smy"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                color: "currentColor",
                label: "",
                LEGACY_size: "small"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                children: name
            }),
            elemAfter && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $3cf4217852c51d66$var$elemAfterContainerStyle,
                children: elemAfter
            })
        ]
    });
const $3cf4217852c51d66$var$AfterElements = ({ elemAfter: elemAfter, closestEdge: closestEdge, dragState: dragState, name: name })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            elemAfter && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $3cf4217852c51d66$var$elemAfterContainerStyle,
                children: elemAfter
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($3cf4217852c51d66$var$DropIndicator, {
                testId: "navigation-kit-ui-tab-common.ui.after-elements.drag-indicator",
                closestEdge: closestEdge
            }),
            dragState && dragState.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).createPortal(/*#__PURE__*/ (0, $gt9Am.jsx)($3cf4217852c51d66$export$905ab40ac2179daa, {
                elemAfter: elemAfter,
                name: name
            }), dragState.container) : null
        ]
    });
const $3cf4217852c51d66$var$elemAfterContainerStyle = (0, $1DXK0.xcss)({
    display: 'flex'
});
const $3cf4217852c51d66$var$tiltStyles = null;
const $3cf4217852c51d66$var$previewStyles = null;
var $3cf4217852c51d66$export$2e2bcd8739ae039 = $3cf4217852c51d66$var$AfterElements;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cf4217852c51d66$var$DropIndicatorWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154i1b66 _1ltvidpf _1bsb1osq _4t3imslj _z1i310m9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("igtYB", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $1b026ba11abe5d11$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $1b026ba11abe5d11$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $c4cfI = parcelRequire("c4cfI");

var $kStpA = parcelRequire("kStpA");
function $1b026ba11abe5d11$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4cfI.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $kStpA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$1b026ba11abe5d11$export$2e2bcd8739ae039 = $1b026ba11abe5d11$export$62ed72bc21f6b8a6;

});
parcelRegister("c4cfI", function(module, exports) {

$parcel$export(module.exports, "Line", () => $3ab834a64f4d0661$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kStpA = parcelRequire("kStpA");
const $3ab834a64f4d0661$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $3ab834a64f4d0661$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $3ab834a64f4d0661$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $3ab834a64f4d0661$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $3ab834a64f4d0661$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $3ab834a64f4d0661$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $kStpA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $kStpA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $3ab834a64f4d0661$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $3ab834a64f4d0661$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $hcewu.default)([
            $3ab834a64f4d0661$var$baseStyles.root,
            $3ab834a64f4d0661$var$orientationStyles[orientation],
            $3ab834a64f4d0661$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$3ab834a64f4d0661$export$2e2bcd8739ae039 = $3ab834a64f4d0661$export$17d680238e50603e;

});
parcelRegister("kStpA", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $45c9411149522a1b$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $45c9411149522a1b$export$45db03aa04b685e3);
const $45c9411149522a1b$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $45c9411149522a1b$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});



parcelRegister("a5OKP", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $6f077cede1297457$export$95df08bae54cb4df);
const $6f077cede1297457$export$95df08bae54cb4df = ()=>{
    if (typeof navigator !== 'undefined') /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return false;
};

});


parcelRegister("jnlkW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f4e0fcac06174a6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $f58rc = parcelRequire("f58rc");

var $igtYB = parcelRequire("igtYB");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");


var $a5OKP = parcelRequire("a5OKP");
const $8f4e0fcac06174a6$var$DropIndicator = ({ closestEdge: closestEdge })=>closestEdge ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": "navigation-kit-ui-tab-common.ui.after-elements-more-item.drag-indicator",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $igtYB.DropIndicator), {
            edge: closestEdge
        })
    }) : null;
const $8f4e0fcac06174a6$export$905ab40ac2179daa = ({ elemBefore: elemBefore, elemAfter: elemAfter, name: name })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: [
            $8f4e0fcac06174a6$var$previewStyles,
            !(0, $a5OKP.isSafari)() && $8f4e0fcac06174a6$var$tiltStyles
        ],
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
            iconBefore: elemBefore,
            iconAfter: elemAfter,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                children: name
            })
        })
    });
const $8f4e0fcac06174a6$var$AfterElementsMoreItem = ({ elemBefore: elemBefore, elemAfter: elemAfter, closestEdge: closestEdge, dragState: dragState, name: name })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($8f4e0fcac06174a6$var$DropIndicator, {
                closestEdge: closestEdge
            }),
            dragState && dragState.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).createPortal(/*#__PURE__*/ (0, $gt9Am.jsx)($8f4e0fcac06174a6$export$905ab40ac2179daa, {
                elemBefore: elemBefore,
                elemAfter: elemAfter,
                name: name
            }), dragState.container) : null
        ]
    });
const $8f4e0fcac06174a6$var$tiltStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    rotate: `${(0, $995807b180d1b2d0$export$29911ec08ab2ca2d)}deg`
});
const $8f4e0fcac06174a6$var$previewStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface'
});
var $8f4e0fcac06174a6$export$2e2bcd8739ae039 = $8f4e0fcac06174a6$var$AfterElementsMoreItem;

});

parcelRegister("ee2GE", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ec932ec636d1f6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $80ec932ec636d1f6$var$BeforeTab = ({ elementBefore: elementBefore })=>elementBefore ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
            xcss: $80ec932ec636d1f6$var$elementBeforeStyles,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'var(--display-icon-before, flex)'
            },
            children: elementBefore
        })
    }) : null;
const $80ec932ec636d1f6$var$elementBeforeStyles = (0, $1DXK0.xcss)({
    inlineSize: "var(--ds-space-300, 24px)",
    blockSize: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    justifyContent: 'center'
});
var $80ec932ec636d1f6$export$2e2bcd8739ae039 = $80ec932ec636d1f6$var$BeforeTab;

});

parcelRegister("fwPAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $272bd8f9135c3d0d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $272bd8f9135c3d0d$var$MenuContainerWrapper = ({ isSelected: isSelected, isOpen: isOpen, hasMenu: hasMenu, children: children, isOverflowing: isOverflowing, isRenaming: isRenaming })=>{
    const [delayedIsOpen, setDelayedIsOpen] = (0, $eJOHy.useState)(isOpen);
    (0, $eJOHy.useEffect)(()=>{
        if (!isOpen) window.setTimeout(()=>{
            // we need the menu trigger to stick around to allow focus to return to it when it is closed
            setDelayedIsOpen(false);
        }, 500);
        else setDelayedIsOpen(true);
    }, [
        isOpen,
        setDelayedIsOpen
    ]);
    const isOpenOrDelayed = isOpen || delayedIsOpen;
    const withMenu = hasMenu && !isRenaming;
    const withPeekMenu = withMenu && (isSelected || isOverflowing);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_qdn51txw _1ifwglyw",
            withMenu && isOpen && "_qdn5glyw _1ifw1ule",
            withMenu && "_15y3glyw _1k7x1ule",
            withPeekMenu && "_1v2gglyw _y07k1ule",
            withPeekMenu && isOpenOrDelayed && "_qdn5glyw _1ifw1ule"
        ]),
        children: children
    });
};
const $272bd8f9135c3d0d$var$wrapperTabStyles = null;
const $272bd8f9135c3d0d$var$showingMenuStyles = null;
const $272bd8f9135c3d0d$var$focusMenuStyles = null;
const $272bd8f9135c3d0d$var$hoverMenuStyles = null;
var $272bd8f9135c3d0d$export$2e2bcd8739ae039 = $272bd8f9135c3d0d$var$MenuContainerWrapper;

});

parcelRegister("4vgZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2d02af88a0e2158$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c2d02af88a0e2158$var$MenuWrapper = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1e0c16ua _2hwx1b66"
        ]),
        children: children
    });
const $c2d02af88a0e2158$var$menuWrapperStyles = null;
var $c2d02af88a0e2158$export$2e2bcd8739ae039 = $c2d02af88a0e2158$var$MenuWrapper;

});

parcelRegister("hf6se", function(module, exports) {

$parcel$export(module.exports, "RenameMenuItemComponent", () => $5fae443eaeae41ed$export$26e03447880d5bba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $5fae443eaeae41ed$export$26e03447880d5bba = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1a37ugt7 _1cwg1i6y"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ...props,
            children: children
        })
    });
const $5fae443eaeae41ed$var$tabRenamingStyles = null;

});

parcelRegister("JzSjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e41720b76ea3891a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $3L3Os = parcelRequire("3L3Os");

var $l1vID = parcelRequire("l1vID");
const $e41720b76ea3891a$var$TabRenameForm = ({ defaultValue: defaultValue, onCancel: onCancel, onConfirm: onConfirm })=>{
    const [value, setValue] = (0, $eJOHy.useState)(defaultValue);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const inputRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        setTimeout(()=>{
            // automatically focus and select the text of the input on mount
            inputRef.current?.focus();
            inputRef.current?.select();
        }, 0);
    }, []);
    const handleSubmitAndBlur = ()=>{
        if (value === defaultValue || value.trim() === '') {
            onCancel?.();
            return;
        }
        onConfirm?.(value.trim());
    };
    const handleChange = (e)=>{
        setValue(e.target.value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Escape') {
            e.stopPropagation();
            onCancel?.();
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3L3Os.default), {
        onSubmit: handleSubmitAndBlur,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("form", {
                ...formProps,
                className: (0, $hcewu.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-value": value,
                    className: (0, $hcewu.default)([
                        "_1e0c1n7u _4cvr1h6o _ckog1yjy _aetrzxco _uy7x15vq _1qjl1jtm"
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                        "aria-label": formatMessage((0, $l1vID.default).tabNameInputLabel),
                        autoComplete: "off",
                        "data-delegated-focus-ring": true,
                        maxLength: 80,
                        name: "tab-name",
                        onBlur: handleSubmitAndBlur,
                        onChange: handleChange,
                        onKeyDown: handleKeyDown,
                        ref: inputRef,
                        required: true,
                        /*
         * We set the size to 1 to ensure the input will not be wider than the
         * text it contains. Without this the input width will be the default width
         * based on the user agent.
         */ size: 1,
                        type: "text",
                        value: value,
                        className: (0, $hcewu.default)([
                            "_11q7glyw _19itglyw _11c81kw7 _nd5l1yjy _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4bfu18uv _1hms1kw7 _ajmmnqa1 _syaz1kw7 _o5721kw7 _nt751r31 _49pcglyw _1hvw1o36"
                        ])
                    })
                })
            })
    });
};
const $e41720b76ea3891a$var$formStyles = null;
/**
 * This allows the input to grow & shrink as the user types in it.
 * See: https://css-tricks.com/auto-growing-inputs-textareas/
 *
 * This can be replaced by the `field-sizing: content;` property when/if it
 * becomes available in browsers.
 * See: https://developer.mozilla.org/en-US/docs/Web/CSS/field-sizing
 */ const $e41720b76ea3891a$var$inputSizerStyles = null;
const $e41720b76ea3891a$var$inputStyles = null;
var $e41720b76ea3891a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($e41720b76ea3891a$var$TabRenameForm);

});
parcelRegister("l1vID", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcaac80622bced1c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bcaac80622bced1c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tabNameInputLabel: {
        id: 'navigation-kit-ui-tab-list.tab-rename-form.tab-name-input-label',
        defaultMessage: 'Tab name',
        description: 'This text is used as aria-label text for the input element in the tab rename form'
    }
});

});


parcelRegister("knCBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cd5b84cddf8f8be$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $5cd5b84cddf8f8be$var$TabWrapper = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isSelected: isSelected = false, isDragging: isDragging = false }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_kqswh2mm _1pbykb7n"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ref: ref,
            className: (0, $hcewu.default)([
                "_2rkoiti9 _1rjc1b66 _19bv12x7 _u5f312x7 _1e0c1txw _kqswh2mm _1kz6zwfg _vchhusvi _uhwn1ris _4cvr1h6o _2lx21sbv _1cwg1i6y _y31iugt7 _ixiwstnw _1wtq12x7 _1j2w12x7 _9di1ze3t _l3ja1wug _1boqb3bt _1kmz1l7b _4tpu1yx7 _x2d61mrw",
                isDragging && "_tzy41kuy",
                isSelected && "_18postnw _19do12x7 _32rx12x7 _1x88ze3t _15l21wug _aetrb3bt _1qdg1l7b _1hfk1yx7 _1bqq1mrw"
            ]),
            children: children
        })
    });
}));
const $5cd5b84cddf8f8be$var$wrapperTabStyles = null;
const $5cd5b84cddf8f8be$var$selectedWrapperTabStyles = null;
/*
	This container is used to ensure that the outline is above the tab underline by creating a new stacking context
	around the tab wrapper (which has the ::after pseudo-element inside it).
*/ const $5cd5b84cddf8f8be$var$containerStyles = null;
const $5cd5b84cddf8f8be$var$draggingTabStyles = null;
var $5cd5b84cddf8f8be$export$2e2bcd8739ae039 = $5cd5b84cddf8f8be$var$TabWrapper;

});

parcelRegister("968u0", function(module, exports) {

$parcel$export(module.exports, "useDraggableTabs", () => $ba8a0a9f885e6e00$export$9fa04411e270c5cb);

var $eJOHy = parcelRequire("eJOHy");

var $3nrCN = parcelRequire("3nrCN");

var $dROq6 = parcelRequire("dROq6");

var $bGx3v = parcelRequire("bGx3v");
parcelRequire("5gUDt");
var $kkJqK = parcelRequire("kkJqK");
parcelRequire("aHiGM");
var $eh3wh = parcelRequire("eh3wh");
function $ba8a0a9f885e6e00$export$9fa04411e270c5cb({ isDragEnabled: isDragEnabled, isDropEnabled: isDropEnabled = true, position: position, id: id, handleDrag: handleDrag, isSelected: isSelected, isOverflowing: isOverflowing, isMoreMenu: isMoreMenu, elementRef: elementRef }) {
    const [isActiveDropZone, setIsActiveDropZone] = (0, $eJOHy.useState)(false);
    const [closestEdge, setClosestEdge] = (0, $eJOHy.useState)(null);
    const [dragState, setDragState] = (0, $eJOHy.useState)({
        type: 'idle'
    });
    (0, $eJOHy.useEffect)(()=>{
        const element = elementRef.current;
        if (!element) return;
        // the more menu is configured differently,
        // and works as a single drop zone that cannot be dragged
        if (isMoreMenu) return (0, $bGx3v.dropTargetForElements)({
            element: element,
            canDrop: (args)=>args.source.data.type === 'tab',
            getIsSticky: ()=>true,
            getData: ()=>({
                    id: id,
                    position: position,
                    isMoreMenu: isMoreMenu
                }),
            onDragEnter: ()=>{
                setIsActiveDropZone(true);
            },
            onDragLeave: ()=>{
                setIsActiveDropZone(false);
            },
            onDrop: ()=>{
                setIsActiveDropZone(false);
            }
        });
        return (0, $dROq6.combine)((0, $bGx3v.draggable)({
            element: element,
            onGenerateDragPreview ({ location: location, nativeSetDragImage: nativeSetDragImage }) {
                (0, $eh3wh.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $kkJqK.preserveOffsetOnSource)({
                        element: element,
                        input: location.current.input
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'preview',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'dragging'
                            });
                    }
                });
            },
            canDrag: ()=>isDragEnabled,
            onDragStart: handleDrag,
            onDrag: ()=>{
                setDragState({
                    type: 'dragging'
                });
            },
            onDrop: ()=>{
                setDragState({
                    type: 'idle'
                });
            },
            getInitialData () {
                return {
                    position: position,
                    id: id,
                    type: 'tab',
                    isOverflowing: isOverflowing
                };
            }
        }), (0, $bGx3v.dropTargetForElements)({
            element: element,
            canDrop: (args)=>args.source.data.type === 'tab' && isDropEnabled,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: dataElement })=>{
                const data = {
                    id: id,
                    position: position,
                    isMoreMenu: isMoreMenu,
                    isOverflowing: isOverflowing
                };
                return (0, $3nrCN.attachClosestEdge)(data, {
                    input: input,
                    element: dataElement,
                    allowedEdges: isOverflowing ? [
                        'top',
                        'bottom'
                    ] : [
                        'left',
                        'right'
                    ]
                });
            },
            onDrag ({ source: source, self: self }) {
                if (source.data.id !== id) setClosestEdge((0, $3nrCN.extractClosestEdge)(self.data));
            },
            onDragLeave: ()=>{
                setClosestEdge(null);
            },
            onDrop: ()=>{
                setClosestEdge(null);
            }
        }));
    }, [
        isDragEnabled,
        isOverflowing,
        position,
        id,
        isSelected,
        elementRef,
        handleDrag,
        isMoreMenu,
        isDropEnabled
    ]);
    const isDragging = Boolean(dragState && dragState.type === 'dragging');
    return {
        closestEdge: closestEdge,
        isActiveDropZone: isActiveDropZone,
        dragState: dragState,
        isDragging: isDragging
    };
}

});
parcelRegister("3nrCN", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $d7df9ca07492ea22$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $d7df9ca07492ea22$export$945a571f3b658bf);
const $d7df9ca07492ea22$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $d7df9ca07492ea22$var$uniqueKey = Symbol('closestEdge');
function $d7df9ca07492ea22$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $d7df9ca07492ea22$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$d7df9ca07492ea22$var$uniqueKey]: addClosestEdge
    };
}
function $d7df9ca07492ea22$export$945a571f3b658bf(userData) {
    return userData[$d7df9ca07492ea22$var$uniqueKey] ?? null;
}

});

parcelRegister("5gUDt", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => (parcelRequire("kkJqK")).preserveOffsetOnSource);

var $kkJqK = parcelRequire("kkJqK");

});
parcelRegister("kkJqK", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => $95623d57ab7781e3$export$8830e7ac6eee750e);
function $95623d57ab7781e3$export$8830e7ac6eee750e({ element: element, input: input }) {
    return function getOffset({ container: container }) {
        /**
		 * **Android**
		 *
		 * This function won't do anything 😅.
		 * The drag preview will _always_ be under the center of the users pointer.
		 * There is no harm in calling this function though 🧘.
		 *
		 * **iOS and iPadOS**
		 *
		 * The drag preview is lifted in the expected position and then slides under
		 * the users pointer.
		 * This is more pleasing than immediately putting the center of the drag preview
		 * under the users pointer.
		 * With this function the drag preview looks like it is popping out
		 * of the UI and then it shifts under the users pointer as the drag is occurring ✨
		 */ const sourceRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const offsetX = Math.min(// difference
        input.clientX - sourceRect.x, // don't let the difference be more than the width of the container,
        // otherwise the pointer will be off the preview
        containerRect.width);
        const offsetY = Math.min(// difference
        input.clientY - sourceRect.y, // don't let the difference be more than the height of the container,
        // otherwise the pointer will be off the preview
        containerRect.height);
        return {
            x: offsetX,
            y: offsetY
        };
    };
}

});


parcelRegister("aHiGM", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("eh3wh")).setCustomNativeDragPreview);

var $eh3wh = parcelRequire("eh3wh");

});
parcelRegister("eh3wh", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $873d376f67ddeb9b$export$52d889c66db0f96e);

var $lMeHP = parcelRequire("lMeHP");

var $72Sl2 = parcelRequire("72Sl2");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $873d376f67ddeb9b$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $873d376f67ddeb9b$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $873d376f67ddeb9b$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $2ec8d9a2d82c6656$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $72Sl2.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $lMeHP.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $2ec8d9a2d82c6656$export$7d0a15ee70427305 = 2147483647;





parcelRegister("l5gYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fba2fc537a52625f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $c9uTK = parcelRequire("c9uTK");

var $82KGI = parcelRequire("82KGI");

var $1PYwQ = parcelRequire("1PYwQ");
var $f58rc = parcelRequire("f58rc");

var $4EPZb = parcelRequire("4EPZb");

var $jnlkW = parcelRequire("jnlkW");

var $ee2GE = parcelRequire("ee2GE");

var $fwPAA = parcelRequire("fwPAA");

var $4vgZf = parcelRequire("4vgZf");

var $hf6se = parcelRequire("hf6se");

var $JzSjQ = parcelRequire("JzSjQ");

var $knCBc = parcelRequire("knCBc");

var $fhrsC = parcelRequire("fhrsC");

var $968u0 = parcelRequire("968u0");
const $fba2fc537a52625f$var$NonInteractiveTab = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: Component, children: children, isRenaming: isRenaming, isSelected: isSelected }, outerRef)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: isRenaming ? undefined : 0,
        ref: outerRef,
        "data-testid": "navigation-kit-ui-tab.ui.link-tab.non-interactive-tab",
        "aria-current": "page",
        "data-delegated-focus-ring": true,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _1e0c1txw _1q51pxbi _y4ti1b66 _85i5pxbi _bozgze3t _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
            isSelected && "_syaz1yx7"
        ]),
        children: children
    })));
const $fba2fc537a52625f$export$6a360a5612cb30b8 = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, elemAfter: elemAfter, elemBefore: elemBefore, handleDrag: handleDrag, href: href, isDraggable: isDraggable = false, isRenaming: isRenaming, name: name, onClick: onClick, onRenameCancel: onRenameCancel, onRenameComplete: onRenameComplete, position: position, renderMenu: renderMenu, testId: testId, type: type }, outerRef)=>{
    const { id: id, isSelected: isSelected, isOverflowing: isOverflowing } = (0, $fhrsC.useTabContext)();
    const elementRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $82KGI.useMergeRefs)([
        outerRef,
        elementRef
    ]);
    const [isMenuOpen, setIsMenuOpen] = (0, $eJOHy.useState)(false);
    const { closestEdge: closestEdge, dragState: dragState, isDragging: isDragging } = (0, $968u0.useDraggableTabs)({
        isDragEnabled: isDraggable && !isRenaming,
        isDropEnabled: true,
        position: position,
        id: id,
        handleDrag: handleDrag,
        isSelected: isSelected,
        isOverflowing: isOverflowing,
        elementRef: elementRef
    });
    const hasMenu = renderMenu != null;
    if (isOverflowing) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fwPAA.default), {
            isOverflowing: true,
            isOpen: isMenuOpen,
            isSelected: isSelected,
            hasMenu: hasMenu,
            isRenaming: isRenaming,
            children: [
                isRenaming ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1PYwQ.default), {
                    component: (0, $hf6se.RenameMenuItemComponent),
                    iconAfter: elemAfter,
                    iconBefore: elemBefore,
                    ref: mergedRefs,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $JzSjQ.default), {
                                defaultValue: name,
                                onCancel: onRenameCancel,
                                onConfirm: onRenameComplete
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jnlkW.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $f58rc.default), {
                    testId: "navigation-kit-ui-tab.ui.link-tab.link-item",
                    ref: mergedRefs,
                    href: href,
                    "aria-current": isSelected ? 'page' : undefined,
                    className: className,
                    onClick: onClick,
                    iconBefore: elemBefore,
                    iconAfter: elemAfter,
                    isSelected: isSelected,
                    UNSAFE_isDraggable: isDraggable,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: name
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jnlkW.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }),
                hasMenu && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4vgZf.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_zulp1b66 _kqswstnw _1e0c1txw _4cvr1h6o _1xi2pxbi _154iu2gc"
                        ]),
                        children: renderMenu != null && renderMenu({
                            isOverflowing: isOverflowing,
                            isOpen: isMenuOpen,
                            setIsOpen: setIsMenuOpen
                        })
                    })
                })
            ]
        })
    });
    const renderTabContent = ()=>{
        const inside = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ee2GE.default), {
                    elementBefore: elemBefore
                }),
                isRenaming ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $JzSjQ.default), {
                    defaultValue: name,
                    onCancel: onRenameCancel,
                    onConfirm: onRenameComplete
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    children: name
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4EPZb.default), {
                    elemAfter: elemAfter,
                    closestEdge: closestEdge,
                    dragState: dragState,
                    name: name
                })
            ]
        });
        if (isSelected || isRenaming) return /*#__PURE__*/ (0, $gt9Am.jsx)($fba2fc537a52625f$var$NonInteractiveTab, {
            as: isRenaming ? 'div' : 'h2',
            isRenaming: Boolean(isRenaming),
            isSelected: isSelected,
            children: inside
        });
        if (type === 'anchor') return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
            href: href,
            className: (0, $hcewu.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _1e0c1txw _1q51pxbi _y4ti1b66 _85i5pxbi _bozgze3t _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                className
            ]),
            onClick: onClick,
            "data-testid": "navigation-kit-ui-tab.ui.link-tab.tab-anchor",
            draggable: "false",
            "data-delegated-focus-ring": true,
            children: inside
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c9uTK.Link), {
            "data-delegated-focus-ring": true,
            "data-testid": "navigation-kit-ui-tab.ui.link-tab",
            to: href,
            prefetch: "hover",
            className: (0, $hcewu.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _1e0c1txw _1q51pxbi _y4ti1b66 _85i5pxbi _bozgze3t _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                className
            ]),
            onClick: onClick,
            draggable: "false",
            children: inside
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: mergedRefs,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fwPAA.default), {
            isSelected: isSelected,
            isOpen: isMenuOpen,
            hasMenu: hasMenu,
            isRenaming: isRenaming,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $knCBc.default), {
                isSelected: isSelected,
                isDragging: isDragging,
                children: [
                    renderTabContent(),
                    hasMenu && renderMenu != null && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4vgZf.default), {
                        children: renderMenu({
                            isOverflowing: isOverflowing,
                            isOpen: isMenuOpen,
                            setIsOpen: setIsMenuOpen
                        })
                    }, "menu")
                ]
            })
        })
    });
}));
/* eslint-enable @atlaskit/design-system/no-unsafe-style-overrides */ /* eslint-enable @atlaskit/ui-styling-standard/no-classname-prop */ const $fba2fc537a52625f$var$currentTabLabelStyles = null;
const $fba2fc537a52625f$var$tabStyles = null;
const $fba2fc537a52625f$var$overflowItemWrapperStyles = null;
const $fba2fc537a52625f$var$overflowNameWrapperStyles = null;
const $fba2fc537a52625f$var$actionItemsWrapperStyles = null;
var $fba2fc537a52625f$export$2e2bcd8739ae039 = $fba2fc537a52625f$export$6a360a5612cb30b8;

});



parcelRegister("6RtEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c485bb3cc6d85930$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c485bb3cc6d85930$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    moreTabWithBadge: {
        id: 'navigation-kit-ui-tab-list.more-trigger.more-tab-with-badge',
        defaultMessage: 'More',
        description: 'When the navigation links do not fit on the screen we show a "More [5]" tab which is a dropdown menu containing all the tabs that do not fit in the screen.'
    },
    moreTabsWithBadgeLabel: {
        id: 'navigation-kit-ui-tab-list.more-trigger.more-tabs-with-badge-label',
        defaultMessage: '{tabCount} more {tabCount, plural, one {tab} other {tabs}}',
        description: 'Accessible label for the More button that indicates it shows additional tabs that do not fit on the screen.'
    }
});

});



parcelRegister("2Of18", function(module, exports) {

$parcel$export(module.exports, "OnboardingSpotlightMaybe", () => $32e9311523cdc66f$export$77e61d078c8501ca);

var $eJOHy = parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $7jTnu = parcelRequire("7jTnu");
function $32e9311523cdc66f$export$77e61d078c8501ca({ children: children, spotlight: spotlight }) {
    if (!(0, $7jTnu.fg)('blu-2735_nav4_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return spotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: spotlight
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
}

});

parcelRegister("1qb7e", function(module, exports) {

$parcel$export(module.exports, "Nav4OnboardingComponentNames", () => $7e33c213883ad026$export$f813aeb3fcf8b623);
$parcel$export(module.exports, "COMPONENT_TAP_TRAIT_MAP", () => $7e33c213883ad026$export$c1a4e03cc30032f5);
const $7e33c213883ad026$export$f813aeb3fcf8b623 = {
    GLOBAL_MODAL: 'nav4GlobalOnboardingModal',
    JIRA_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4SidebarToggleOnboardingSpotlight',
    // CONFLUENCE_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4ConfluenceSidebarToggleOnboardingSpotlight', // TODO: Spotlight has not been implemented in Confluence yet so this may change
    SIDEBAR_PROJECT_SPOTLIGHT: 'nav4SidebarProjectsOnboardingSpotlight',
    TAB_NAV_SPOTLIGHT: 'nav4TabNavigationOnboardingSpotlight',
    ATLAS_GLOBAL_MODAL: 'nav4AtlasGlobalOnboardingModal',
    ATLAS_GLOBAL_MODAL2: 'nav4AtlasGlobalOnboardingModal2'
};
const $7e33c213883ad026$export$c1a4e03cc30032f5 = {
    nav4GlobalOnboardingModal: 'jira-platform_ui_nav4globalonboardingmodal_dismissed_jiraatlassianonboardingnav4_changed',
    nav4SidebarToggleOnboardingSpotlight: 'jira-platform_ui_nav4sidebartoggleonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    // nav4ConfluenceSidebarToggleOnboardingSpotlight: '', // TODO: Add when Confluence spotlight is implemented
    nav4SidebarProjectsOnboardingSpotlight: 'jira-platform_ui_nav4sidebarprojectsonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4TabNavigationOnboardingSpotlight: 'jira-platform_ui_nav4tabnavigationonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4AtlasGlobalOnboardingModal: 'townsquare_ui_atlassianhomeonboardingnav4_dismissed_teamcentral_changed'
};

});


parcelRegister("fy9Lw", function(module, exports) {

$parcel$export(module.exports, "default", () => $52daf26e3afcde47$export$2e2bcd8739ae039);

var $lF4Y5 = parcelRequire("lF4Y5");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7rjYb = parcelRequire("7rjYb");

var $7jTnu = parcelRequire("7jTnu");

var $cBavF = parcelRequire("cBavF");

var $ciFJV = parcelRequire("ciFJV");

var $bbdV2 = parcelRequire("bbdV2");



var $de0p1 = parcelRequire("de0p1");

var $9g5z1 = parcelRequire("9g5z1");

var $aDTxb = parcelRequire("aDTxb");
const $52daf26e3afcde47$var$AddTab = ({ containerFragment: containerFragment, tabsDescriptor: tabsDescriptor, onAddItem: onAddItem })=>{
    const containerData = (0, $j4oe4.useFragment)((0, $lF4Y5.default), containerFragment);
    const scopeId = containerData.scopeId ?? '';
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $eJOHy.useState)(false);
    const onOpenChange = (0, $eJOHy.useCallback)(()=>{
        setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent);
    }, []);
    const closeMenu = (0, $eJOHy.useCallback)(()=>{
        setIsDropdownMenuOpen(false);
    }, []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $aDTxb.addTabContentEntryPoint), (0, $eJOHy.useMemo)(()=>({
            scopeId: scopeId,
            first: (0, $928056a84d2eedae$export$4653cda61a4943d6)
        }), [
        scopeId
    ]));
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isDropdownMenuOpen);
    const trigger = ({ isSelected: isMenuOpen, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $de0p1.default), {
            onClick: (event)=>{
                onClick && onClick(event);
            },
            isSelected: isDropdownMenuOpen,
            ...triggerProps,
            ref: (element)=>{
                triggerRef(element);
                typeof triggerProps.triggerRef === 'function' && triggerProps.triggerRef(element);
            },
            testId: "navigation-kit-add-tab.ui.trigger"
        });
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            onAddItem: onAddItem,
            onClose: closeMenu,
            tabsDescriptor: tabsDescriptor
        }), [
        closeMenu,
        onAddItem,
        tabsDescriptor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: trigger,
        placement: "bottom-start",
        testId: "navigation-kit-add-tab.ui.dropdown-menu",
        isOpen: isDropdownMenuOpen,
        onOpenChange: onOpenChange,
        shouldRenderToParent: (0, $7jTnu.fg)('should-render-to-parent-should-be-true-navigation')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $52daf26e3afcde47$var$addTabContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "navigation-kit-add-tab-content",
        packageName: "jiraNavigationKitAddTab",
        runtimeProps: runtimeProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9g5z1.LoadingSkeleton), null)
    })));
};
var $52daf26e3afcde47$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($52daf26e3afcde47$var$AddTab);
const $52daf26e3afcde47$var$addTabContentWrapperStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $29bf7a2ab3eb3842$export$5e641a5f03919b38)}px`
});

});
parcelRegister("lF4Y5", function(module, exports) {

$parcel$export(module.exports, "default", () => $168a93c0da68b0ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44ed7ddeaad1fa52a71d05534d04501a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $168a93c0da68b0ab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AddTab_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "scopeId"
                    },
                    "action": "THROW",
                    "path": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$168a93c0da68b0ab$var$node.hash = "5c730fc8f652490d6ab22bf4e7225d95";
var $168a93c0da68b0ab$export$2e2bcd8739ae039 = $168a93c0da68b0ab$var$node;

});

const $29bf7a2ab3eb3842$export$5e641a5f03919b38 = 600;
const $29bf7a2ab3eb3842$export$7a5cc88a67fa13ae = 'APP';
const $29bf7a2ab3eb3842$export$d57b6b390e78d90f = 'Navigation';

parcelRegister("de0p1", function(module, exports) {

$parcel$export(module.exports, "default", () => $359b5e2e1af506ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kMmrb = parcelRequire("kMmrb");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $cJEMq = parcelRequire("cJEMq");

var $8cXOn = parcelRequire("8cXOn");
const $359b5e2e1af506ef$var$AddTabTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ presentational: presentational, noTooltip: noTooltip, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        spacing: "none",
        appearance: "subtle",
        role: presentational ? 'presentation' : undefined,
        name: formatMessage((0, $8cXOn.default).addTabTriggerLabel),
        ref: ref,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMmrb))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: formatMessage((0, $8cXOn.default).addTabTriggerLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $359b5e2e1af506ef$var$boxStyles
    }, noTooltip ? button : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $8cXOn.default).addTabTriggerLabel),
        hideTooltipOnMouseDown: true
    }, button));
});
var $359b5e2e1af506ef$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($359b5e2e1af506ef$var$AddTabTrigger);
const $359b5e2e1af506ef$var$boxStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '0',
    position: 'relative',
    alignSelf: 'center'
});

});
parcelRegister("8cXOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c56538a8855252f3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c56538a8855252f3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addTabTriggerLabel: {
        "id": "navigation-kit-add-tab.add-tab-trigger.add-tab-trigger-label",
        "defaultMessage": "Add to navigation"
    }
});

});


parcelRegister("9g5z1", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $0ee8f38df2bf5c0b$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jUgeq = parcelRequire("jUgeq");
var $2bMVP = parcelRequire("2bMVP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

const $0ee8f38df2bf5c0b$export$44c18d210d5de37b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0ee8f38df2bf5c0b$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0ee8f38df2bf5c0b$var$skeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0ee8f38df2bf5c0b$var$listSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
        minWidth: 280
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0ee8f38df2bf5c0b$var$titleSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ee8f38df2bf5c0b$var$Skeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0ee8f38df2bf5c0b$var$titleSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ee8f38df2bf5c0b$var$Skeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
        hasIcon: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0ee8f38df2bf5c0b$var$detailsSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ee8f38df2bf5c0b$var$SkeletonPreview, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ee8f38df2bf5c0b$var$Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ee8f38df2bf5c0b$var$Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ee8f38df2bf5c0b$var$SkeletonButton, null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0ee8f38df2bf5c0b$var$Skeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1b66 _bfhkn82g _1bsbmgvx _4t3ipxbi",
            __cmplp.className
        ])
    });
});
const $0ee8f38df2bf5c0b$var$SkeletonPreview = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $0ee8f38df2bf5c0b$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbp3fh _4t3in0hr",
            __cmplp.className
        ])
    });
});
const $0ee8f38df2bf5c0b$var$SkeletonButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $0ee8f38df2bf5c0b$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbo7ol _4t3ixy5q",
            __cmplp.className
        ])
    });
});
const $0ee8f38df2bf5c0b$var$skeletonWrapperStyles = (0, $1DXK0.xcss)({
    height: '100%',
    display: 'flex',
    flexDirection: 'row'
});
const $0ee8f38df2bf5c0b$var$titleSkeletonWrapperStyles = (0, $1DXK0.xcss)({
    height: '42px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingInlineStart: 'space.250'
});
const $0ee8f38df2bf5c0b$var$listSkeletonWrapperStyles = (0, $1DXK0.xcss)({
    paddingBlockStart: 'space.100',
    blockSize: '100%',
    inlineSize: '280px'
});
const $0ee8f38df2bf5c0b$var$detailsSkeletonWrapperStyles = (0, $1DXK0.xcss)({
    alignItems: 'start',
    backgroundColor: 'elevation.surface.sunken',
    blockSize: '100%',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width.0',
    borderInlineStartWidth: 'border.width',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200',
    inlineSize: '320px',
    justifyContent: 'start',
    padding: 'space.500'
});
const $0ee8f38df2bf5c0b$var$wrapperStyles = (0, $1DXK0.xcss)({
    boxSizing: 'border-box',
    color: 'color.text',
    blockSize: '385px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $29bf7a2ab3eb3842$export$5e641a5f03919b38)}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});

parcelRegister("aDTxb", function(module, exports) {

$parcel$export(module.exports, "addTabContentEntryPoint", () => $4cf16a126496f084$export$196d3b4618d24c77);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $hn5tj = parcelRequire("hn5tj");

const $4cf16a126496f084$export$196d3b4618d24c77 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hkAMY")), {
        moduleId: "6cee7023",
        moduleName: "AddTabContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ scopeId: scopeId, first: first })=>({
            queries: {
                mainQuery: {
                    parameters: (0, $hn5tj.default),
                    variables: {
                        first: first,
                        containerNavigationInput: {
                            scopeId: scopeId
                        }
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("hn5tj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c0398fd02b09488$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<85560f14a2c1a71d0c7dc4fd4884919a>>
 * @relayHash f84ccf2ded04668e2e31e188f70e9484
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 507bbb3ea7ceceedb8ccfda00f5c3ffecb8c763884a6d06aca12a44641dadaef
const $3c0398fd02b09488$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "containerNavigationInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "scopeId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v9 /*: any*/ 
        ]
    }, v11 = [
        v8 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v9 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AddTabContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.containerNavigation.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.containerNavigation.scopeId"
                                                },
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemTypeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "addableNavigationItemTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraNavigationItemTypeEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v3 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node.id"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v6 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node.typeKey"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraAppNavigationItemType"
                                                                                },
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": "ViewItem_item"
                                                                                },
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": "appItem_horizontalNavAddTab"
                                                                                },
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": "AddTabDetails_item"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.containerNavigation.addableNavigationItemTypes.edges"
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.containerNavigation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AddTabContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "addableNavigationItemTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItemType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "label"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItemType"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v11 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v11 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "507bbb3ea7ceceedb8ccfda00f5c3ffecb8c763884a6d06aca12a44641dadaef",
            "metadata": {},
            "name": "AddTabContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3c0398fd02b09488$var$node.hash = "41079ddf0412e6da3b6d9525a2b7f747";
var $3c0398fd02b09488$export$2e2bcd8739ae039 = $3c0398fd02b09488$var$node;

});

parcelRegister("hkAMY", function(module, exports) {

let $c9e0d771f2df25f0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c9e0d771f2df25f0$var$load("bSCNR").then(()=>parcelRequire('eC9dN'));

});



parcelRegister("6fFb3", function(module, exports) {

$parcel$export(module.exports, "TabShortcutsContextProvider", () => $11f11e3d1338356c$export$8b136156551d140a);
$parcel$export(module.exports, "useTabShortcuts", () => $11f11e3d1338356c$export$4b7664145fd3fd6f);

var $eJOHy = parcelRequire("eJOHy");

var $80xRm = parcelRequire("80xRm");

var $bcitO = parcelRequire("bcitO");

var $epTsa = parcelRequire("epTsa");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $1Zcfy = parcelRequire("1Zcfy");

var $ezGpi = parcelRequire("ezGpi");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $6vkP1 = parcelRequire("6vkP1");
const $11f11e3d1338356c$export$eb842c33bb500fce = /*#__PURE__*/ (0, $eJOHy.createContext)({
    /**
   * Registers a tab with TabShortcutsContextProvider so it can be assigned a keyboard shortcut
   * returns a function to deregister.
   */ // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    registerTab: (_)=>()=>{}
});
const $11f11e3d1338356c$export$8b136156551d140a = ({ navigationName: navigationName, children: children })=>{
    const projectNavigationGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $6vkP1.messages).projectNavigationGalaxia : (0, $6vkP1.messages).projectNavigation;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [rawTabs, setRawTabs] = (0, $eJOHy.useState)([]);
    const registerTab = (0, $eJOHy.useCallback)((newTab)=>{
        setRawTabs((existingTabs)=>[
                ...existingTabs,
                newTab
            ]);
        return ()=>{
            setRawTabs((existingTabs)=>existingTabs.filter((tab)=>tab.index !== newTab.index));
        };
    }, [
        setRawTabs
    ]);
    /**
   * Generate a keyMap from the rawTabs. The tabs may be out of order, and there may be gaps in the index (some tabs will return null before they get to register)
   * so we sort first and use our own index for the trigger key.
   */ const generateKeyMap = (0, $fAZgY.useCallbackWithCondition)(()=>{
        const keyMap = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(rawTabs, 'index').slice(0, 9).forEach((tab, index)=>{
            keyMap[String(index + 1)] = {
                callback: tab.callback,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                    ...(0, $6vkP1.messages).goTo,
                    values: {
                        label: tab.label
                    }
                }),
                registerInCommandPalette: {
                    id: `tab${index + 1}-${tab.label}`,
                    name: formatMessage((0, $6vkP1.messages).goTo, {
                        label: tab.label
                    }),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bcitO))), {
                                spacing: "spacious",
                                label: ""
                            })
                    },
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).containerNavigation
                }
            };
        });
        return keyMap;
    }, [
        formatMessage,
        rawTabs
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-horizontal-nav'));
    const valueMemo = (0, $eJOHy.useMemo)(()=>({
            registerTab: registerTab
        }), [
        registerTab
    ]);
    const keyMap = (0, $fAZgY.useMemoWithCondition)(()=>generateKeyMap(), [
        generateKeyMap
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-horizontal-nav'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($11f11e3d1338356c$export$eb842c33bb500fce.Provider, {
        value: valueMemo
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ezGpi.CommandShortcuts), {
        keyMap: keyMap,
        label: navigationName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, navigationName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), projectNavigationGalaxia)
    }));
};
const $11f11e3d1338356c$export$4b7664145fd3fd6f = ()=>{
    const context = (0, $eJOHy.useContext)($11f11e3d1338356c$export$eb842c33bb500fce);
    if (!context) throw new Error('useTabShortcuts must be used within a TabShortcutsContextProvider');
    return context;
};

});
parcelRegister("80xRm", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $4ppQ2 = parcelRequire("4ppQ2");

var $l76qh = parcelRequire("l76qh");

var $eA1it = parcelRequire("eA1it");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5d48969fb93c8520$var$sortBy = $l76qh(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $eA1it(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $eA1it(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $4ppQ2(collection, $72Qfa(iteratees, 1), []);
});
module.exports = $5d48969fb93c8520$var$sortBy;

});
parcelRegister("4ppQ2", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $5BbSa = parcelRequire("5BbSa");

var $1lM9j = parcelRequire("1lM9j");

var $k0Eii = parcelRequire("k0Eii");

var $1QISL = parcelRequire("1QISL");

var $cUaWv = parcelRequire("cUaWv");

var $6c1m2 = parcelRequire("6c1m2");

var $d7YnM = parcelRequire("d7YnM");

var $4sprp = parcelRequire("4sprp");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $335d8a321b94e157$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $lylkU(iteratees, function(iteratee) {
        if ($4sprp(iteratee)) return function(value) {
            return $5BbSa(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $d7YnM
    ];
    var index = -1;
    iteratees = $lylkU(iteratees, $cUaWv($1lM9j));
    var result = $k0Eii(collection, function(value, key, collection) {
        var criteria = $lylkU(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $1QISL(result, function(object, other) {
        return $6c1m2(object, other, orders);
    });
}
module.exports = $335d8a321b94e157$var$baseOrderBy;

});
parcelRegister("k0Eii", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");

var $7H30b = parcelRequire("7H30b");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e9131047aaeaff47$var$baseMap(collection, iteratee) {
    var index = -1, result = $7H30b(collection) ? Array(collection.length) : [];
    $c3u3c(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e9131047aaeaff47$var$baseMap;

});

parcelRegister("1QISL", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $158d7678f0c45464$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $158d7678f0c45464$var$baseSortBy;

});

parcelRegister("6c1m2", function(module, exports) {

var $boN2o = parcelRequire("boN2o");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $4824ea093db12906$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $boN2o(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $4824ea093db12906$var$compareMultiple;

});
parcelRegister("boN2o", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $84c7f970dc532949$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9D78T(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9D78T(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $84c7f970dc532949$var$compareAscending;

});




parcelRegister("bcitO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $826f266802ea1177$var$_react = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $826f266802ea1177$var$_arrowRight = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("ePxSL")));

var $826f266802ea1177$var$_arrowRight2 = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("WCqcH")));
function $826f266802ea1177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $826f266802ea1177$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $826f266802ea1177$var$_react.default.createElement($826f266802ea1177$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $826f266802ea1177$var$_arrowRight2.default
    }, props));
$826f266802ea1177$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $826f266802ea1177$var$_default = module.exports.default = $826f266802ea1177$var$ArrowRightIcon;

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("WCqcH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b0338a1f0c13ece$var$_react = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $0b0338a1f0c13ece$var$_arrowRight = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("ePxSL")));
function $0b0338a1f0c13ece$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0b0338a1f0c13ece$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $0b0338a1f0c13ece$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $0b0338a1f0c13ece$var$_arrowRight.default
    }));
$0b0338a1f0c13ece$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $0b0338a1f0c13ece$var$_default = module.exports.default = $0b0338a1f0c13ece$var$ArrowRightIcon;

});


parcelRegister("1Zcfy", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $9047f4ba14bb7637$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $9047f4ba14bb7637$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $9047f4ba14bb7637$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $9047f4ba14bb7637$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $9047f4ba14bb7637$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $9047f4ba14bb7637$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $9047f4ba14bb7637$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $9047f4ba14bb7637$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $9047f4ba14bb7637$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $9047f4ba14bb7637$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $9047f4ba14bb7637$export$16b06d29ef8f802b = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["containerNavigation"] = "container-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    COMMAND_PALETTE_SECTIONS["forge"] = "forge";
    return COMMAND_PALETTE_SECTIONS;
}({});
const $9047f4ba14bb7637$export$156ebd2354e25466 = 'issueActions';
const $9047f4ba14bb7637$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $9047f4ba14bb7637$export$9f646ab88e1d2b14 = 'commandPalette';
var $9047f4ba14bb7637$export$abf26cc5daebd2c8 = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["containerNavigation"] = 2] = "containerNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["forge"] = 9] = "forge";
    return COMMAND_PALETTE_SECTIONS_PRIORITY;
}({});
var $9047f4ba14bb7637$export$12514ca8899b0521 = /*#__PURE__*/ function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    return COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY;
}({});
var $9047f4ba14bb7637$export$5fa0bcf59f933c21 = /*#__PURE__*/ function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    return COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY;
}({});
var $9047f4ba14bb7637$export$7d9743be0b7d862f = /*#__PURE__*/ function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    return COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY;
}({});
var $9047f4ba14bb7637$export$b4e1633c86db2b70 = /*#__PURE__*/ function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    return COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY;
}({});
var $9047f4ba14bb7637$export$5e5a87aac5d9771f = /*#__PURE__*/ function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    return COMMAND_PALETTE_HELP_PRIORITY;
}({});

});

parcelRegister("ezGpi", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $1e305c509eaf0223$export$7ff7e4fe85a5960a);

var $eJOHy = parcelRequire("eJOHy");

var $fWwfy = parcelRequire("fWwfy");

var $73jrx = parcelRequire("73jrx");

var $hf4h9 = parcelRequire("hf4h9");

var $3IF6p = parcelRequire("3IF6p");
const $1e305c509eaf0223$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eJOHy.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $hf4h9.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eJOHy.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $73jrx.RegisterCommands), {
        registrationId: (0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("fWwfy", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $67a434ec4fcbe6f3$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $67a434ec4fcbe6f3$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $67a434ec4fcbe6f3$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE',
    FORGE: 'FORGE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $67a434ec4fcbe6f3$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $67a434ec4fcbe6f3$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.COPY_URL,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.DESCRIPTION,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.LOG_WORK,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.PARENT,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.QUICK_ADD,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.QUICK_SEARCH,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.SHORTCUTS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.STATUS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.STORY_POINTS,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $67a434ec4fcbe6f3$export$689de18177335e39.THEME_MODE,
        teamName: $67a434ec4fcbe6f3$var$teams.Deliveroo
    }
};

});

parcelRegister("73jrx", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $54ccbd2a3c61da6a$export$cd555833c78729f1);

var $eJOHy = parcelRequire("eJOHy");

var $3DnU9 = parcelRequire("3DnU9");
const $54ccbd2a3c61da6a$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3DnU9.RegisterCommandsWithRegistry), props);

});
parcelRegister("3DnU9", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $c82e68fcec934ed3$export$b8955a01360d2876);

var $cQKVu = parcelRequire("cQKVu");
function $c82e68fcec934ed3$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $cQKVu.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("cQKVu", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $6d5c9742963ffdc5$export$8a824ae164ff968d);

var $eJOHy = parcelRequire("eJOHy");

var $iTb6Y = parcelRequire("iTb6Y");
function $6d5c9742963ffdc5$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $iTb6Y.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $eJOHy.useRef)(commands);
    (0, $eJOHy.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("iTb6Y", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $bd9364f64b41cfe5$export$880fc01e31710b27);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");
function $bd9364f64b41cfe5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $g51Bg.useActionsCommandPalette)();
    const subscribe = (0, $eJOHy.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("g51Bg", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $b0966e39df9c724a$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $b0966e39df9c724a$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $b0966e39df9c724a$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $b0966e39df9c724a$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $b0966e39df9c724a$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $b0966e39df9c724a$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $b0966e39df9c724a$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $b0966e39df9c724a$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $b0966e39df9c724a$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $b0966e39df9c724a$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $b0966e39df9c724a$export$bbc05723eb144e03);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $2OtIa = parcelRequire("2OtIa");

var $1kl5C = parcelRequire("1kl5C");
const $b0966e39df9c724a$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $b0966e39df9c724a$var$store = (0, $GtRbT.createStore)({
    initialState: $b0966e39df9c724a$var$initialState,
    actions: $1kl5C.actions,
    name: 'commandPalette'
});
const $b0966e39df9c724a$export$6b58f9610017fbb7 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store);
const $b0966e39df9c724a$export$72aa7bc7c6a83c36 = (0, $iJq0l.createActionsHook)($b0966e39df9c724a$var$store);
const $b0966e39df9c724a$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $b0966e39df9c724a$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $b0966e39df9c724a$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $2OtIa.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $2OtIa.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $2OtIa.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $b0966e39df9c724a$export$1f90c8f89f98110e = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: $b0966e39df9c724a$export$56f06313122d0aac
});
const $b0966e39df9c724a$export$cc979be9b69236df = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $b0966e39df9c724a$export$a18633b655403b12 = (0, $iJq0l.createStateHook)($b0966e39df9c724a$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $b0966e39df9c724a$export$af8fd8cd4b048315 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $b0966e39df9c724a$export$4372697329bd9cbe = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $b0966e39df9c724a$export$7422170a403e909 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $b0966e39df9c724a$export$282aa48e4a3afada = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $b0966e39df9c724a$export$96819dfb22ad05d3 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $b0966e39df9c724a$export$a40e8ae3e53feab0 = (0, $4MchI.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $2OtIa.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $b0966e39df9c724a$export$f893891deedab3c6 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: $b0966e39df9c724a$export$a40e8ae3e53feab0
});
const $b0966e39df9c724a$export$bbc05723eb144e03 = (0, $iJq0l.createHook)($b0966e39df9c724a$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("2OtIa", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $94a7203ed38fd013$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $94a7203ed38fd013$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $94a7203ed38fd013$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $94a7203ed38fd013$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $94a7203ed38fd013$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $94a7203ed38fd013$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $94a7203ed38fd013$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $94a7203ed38fd013$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $94a7203ed38fd013$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $94a7203ed38fd013$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $94a7203ed38fd013$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $94a7203ed38fd013$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $94a7203ed38fd013$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $94a7203ed38fd013$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $94a7203ed38fd013$export$c3d20e8c1e93a572);

var $eJOHy = parcelRequire("eJOHy");

var $jhs3c = parcelRequire("jhs3c");

var $4Wnht = parcelRequire("4Wnht");

var $cMTOh = parcelRequire("cMTOh");

var $hf4h9 = parcelRequire("hf4h9");
const $94a7203ed38fd013$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $94a7203ed38fd013$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$94a7203ed38fd013$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $94a7203ed38fd013$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $94a7203ed38fd013$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $94a7203ed38fd013$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $94a7203ed38fd013$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $94a7203ed38fd013$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $94a7203ed38fd013$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $94a7203ed38fd013$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $94a7203ed38fd013$export$389b0273703d5c48(sections)
    };
};
const $94a7203ed38fd013$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $94a7203ed38fd013$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$94a7203ed38fd013$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$94a7203ed38fd013$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$94a7203ed38fd013$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $94a7203ed38fd013$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $94a7203ed38fd013$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $94a7203ed38fd013$export$daa5beabdf8d9fc3 = (event)=>(0, $4Wnht.isMacOs)() ? event.metaKey : event.ctrlKey;
const $94a7203ed38fd013$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $hf4h9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $hf4h9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $hf4h9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $94a7203ed38fd013$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $94a7203ed38fd013$export$fa1c95a5ffa92036 = (str)=>(0, $jhs3c.createHash)().update(str).digest('hex');
const $94a7203ed38fd013$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $94a7203ed38fd013$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $94a7203ed38fd013$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $94a7203ed38fd013$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("4Wnht", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $54e7240a1362d417$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $54e7240a1362d417$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $54e7240a1362d417$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $54e7240a1362d417$export$fe66dae91c68619b = ()=>$54e7240a1362d417$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("cMTOh", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $8120698a127d7ee3$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $8120698a127d7ee3$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $8120698a127d7ee3$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $8120698a127d7ee3$export$894e19fc96687503);
// EVENT TYPES
const $8120698a127d7ee3$export$a1562d08625f5d7e = 'UI';
const $8120698a127d7ee3$export$947dac6c72b26f81 = 'TRACK';
const $8120698a127d7ee3$export$f1d537d508d2945a = 'SCREEN';
const $8120698a127d7ee3$export$12346a674644c156 = 'OPERATIONAL';
var $8120698a127d7ee3$export$1ee9d153576afd13 = /*#__PURE__*/ function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    return SHORTCUT_ELEMENT_TYPES;
}({});
const $8120698a127d7ee3$export$894e19fc96687503 = 250;

});

parcelRegister("hf4h9", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $1ef2266e5ff751a8$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $1ef2266e5ff751a8$export$904b2a0e38a1bef3);
var $1ef2266e5ff751a8$export$f041b1b117ab382f = /*#__PURE__*/ function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
    return CommandActionType;
}({});
const $1ef2266e5ff751a8$export$3e448fd53031e13c = Object.values($1ef2266e5ff751a8$export$f041b1b117ab382f);
const $1ef2266e5ff751a8$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("1kl5C", function(module, exports) {

$parcel$export(module.exports, "actions", () => $fa5d3433a241f524$export$e324594224ef24da);

var $jvwCK = parcelRequire("jvwCK");

var $aXKmr = parcelRequire("aXKmr");

var $bpkMB = parcelRequire("bpkMB");

var $h6i8k = parcelRequire("h6i8k");

var $4Wnht = parcelRequire("4Wnht");

var $gYnSx = parcelRequire("gYnSx");

var $cMTOh = parcelRequire("cMTOh");

var $hf4h9 = parcelRequire("hf4h9");

var $2OtIa = parcelRequire("2OtIa");

var $1tIH1 = parcelRequire("1tIH1");

var $aJbE4 = parcelRequire("aJbE4");

var $7RhQ7 = parcelRequire("7RhQ7");
const $fa5d3433a241f524$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $fa5d3433a241f524$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        if (!getState().isOpen) (0, $h6i8k.default)('command-palette-opened');
        setState({
            commandPaletteSessionId: (0, $aXKmr.v4)(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $fa5d3433a241f524$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$fa5d3433a241f524$var$rootCommands
        });
    };
const $fa5d3433a241f524$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, $aXKmr.v4)() : '',
            ...!isOpen ? $fa5d3433a241f524$var$rootCommands : {}
        });
    };
const $fa5d3433a241f524$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $fa5d3433a241f524$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $fa5d3433a241f524$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $fa5d3433a241f524$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $fa5d3433a241f524$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $fa5d3433a241f524$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $fa5d3433a241f524$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $cMTOh.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $fa5d3433a241f524$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $fa5d3433a241f524$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $fa5d3433a241f524$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $2OtIa.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $fa5d3433a241f524$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $h6i8k.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $gYnSx.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $bpkMB.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $fa5d3433a241f524$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $1tIH1.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $2OtIa.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        (0, $7RhQ7.setEventAttribute)(analyticsAttributes);
        const currentCommandAction = (0, $2OtIa.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $2OtIa.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $hf4h9.CommandActionType).PERFORM;
        if (command.mode) newState.shouldForceSearchValue = true;
        if (shouldLoadChildren) {
            (0, $h6i8k.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $aJbE4.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $hf4h9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $cMTOh.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $4Wnht.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $h6i8k.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $cMTOh.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $gYnSx.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $bpkMB.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $fa5d3433a241f524$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $fa5d3433a241f524$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $fa5d3433a241f524$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $fa5d3433a241f524$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $fa5d3433a241f524$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $fa5d3433a241f524$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $fa5d3433a241f524$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $fa5d3433a241f524$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $fa5d3433a241f524$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $fa5d3433a241f524$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $fa5d3433a241f524$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $fa5d3433a241f524$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $fa5d3433a241f524$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $fa5d3433a241f524$export$e324594224ef24da = {
    open: $fa5d3433a241f524$var$open,
    toggle: $fa5d3433a241f524$var$toggle,
    close: $fa5d3433a241f524$var$close,
    addCommands: $fa5d3433a241f524$var$addCommands,
    removeCommands: $fa5d3433a241f524$var$removeCommands,
    handleSearch: $fa5d3433a241f524$var$handleSearch,
    forceFocusSearch: $fa5d3433a241f524$var$forceFocusSearch,
    setActiveIndex: $fa5d3433a241f524$var$setActiveIndex,
    executeCommand: $fa5d3433a241f524$var$executeCommand,
    goBackLevel: $fa5d3433a241f524$var$goBackLevel,
    setChildCommands: $fa5d3433a241f524$var$setChildCommands,
    setLoadingList: $fa5d3433a241f524$var$setLoadingList,
    setFocusInput: $fa5d3433a241f524$var$setFocusInput,
    registerSections: $fa5d3433a241f524$var$registerSections,
    unregisterSections: $fa5d3433a241f524$var$unregisterSections,
    markAsLoaded: $fa5d3433a241f524$var$markAsLoaded,
    getAnalyticsAttributes: $fa5d3433a241f524$var$getAnalyticsAttributes,
    setIsDisabled: $fa5d3433a241f524$var$setIsDisabled,
    setRegistry: $fa5d3433a241f524$var$setRegistry,
    updateActiveRegistry: $fa5d3433a241f524$var$updateActiveRegistry,
    removeCommandsById: $fa5d3433a241f524$var$removeCommandsById,
    removeFromActiveRegistry: $fa5d3433a241f524$var$removeFromActiveRegistry,
    performDialogCloseCommand: $fa5d3433a241f524$var$performDialogCloseCommand,
    setAnalytics: $fa5d3433a241f524$var$setAnalytics,
    setFallbackOverride: $fa5d3433a241f524$var$setFallbackOverride,
    setHasPopupOverlay: $fa5d3433a241f524$var$setHasPopupOverlay,
    forceSearchValue: $fa5d3433a241f524$var$forceSearchValue,
    resetShouldForceSearchValue: $fa5d3433a241f524$var$resetShouldForceSearchValue
};

});
parcelRegister("1tIH1", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $494c53c0493f50d3$export$639b7f41b0b47a01);

var $hf4h9 = parcelRequire("hf4h9");
const $494c53c0493f50d3$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("aJbE4", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $8d0720613ed3e2cc$export$d75616d77443fe4e);

var $hf4h9 = parcelRequire("hf4h9");
const $8d0720613ed3e2cc$export$d75616d77443fe4e = (action)=>action?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});

parcelRegister("7RhQ7", function(module, exports) {

$parcel$export(module.exports, "setEventAttribute", () => $45c284350ab5fd95$export$7c0a9f4caaf7cfce);

var $814y1 = parcelRequire("814y1");

var $d2AGn = parcelRequire("d2AGn");
const $45c284350ab5fd95$var$ACTIONS_TO_WATCH = [
    'unassign',
    'assignToMe'
];
const $45c284350ab5fd95$export$7c0a9f4caaf7cfce = (attributes)=>{
    if (attributes.actionCategory === 'issueActions' && typeof attributes.action === 'string' && $45c284350ab5fd95$var$ACTIONS_TO_WATCH.includes(attributes.action)) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().setAttributes((0, $814y1.ASSIGNEE_TYPE), {
        isCommandPaletteEditing: true
    });
};

});
parcelRegister("814y1", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $1e0b34ed3288576a$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $1e0b34ed3288576a$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $1e0b34ed3288576a$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $1e0b34ed3288576a$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $1e0b34ed3288576a$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $1e0b34ed3288576a$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $1e0b34ed3288576a$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $1e0b34ed3288576a$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $1e0b34ed3288576a$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $1e0b34ed3288576a$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $1e0b34ed3288576a$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $1e0b34ed3288576a$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $1e0b34ed3288576a$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $1e0b34ed3288576a$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $1e0b34ed3288576a$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $1e0b34ed3288576a$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $1e0b34ed3288576a$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $1e0b34ed3288576a$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $1e0b34ed3288576a$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $1e0b34ed3288576a$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $1e0b34ed3288576a$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $1e0b34ed3288576a$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $1e0b34ed3288576a$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $1e0b34ed3288576a$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $1e0b34ed3288576a$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $1e0b34ed3288576a$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $1e0b34ed3288576a$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $1e0b34ed3288576a$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $1e0b34ed3288576a$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $1e0b34ed3288576a$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $1e0b34ed3288576a$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $1e0b34ed3288576a$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $1e0b34ed3288576a$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $1e0b34ed3288576a$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $1e0b34ed3288576a$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $1e0b34ed3288576a$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $1e0b34ed3288576a$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $1e0b34ed3288576a$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $1e0b34ed3288576a$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $1e0b34ed3288576a$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $1e0b34ed3288576a$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $1e0b34ed3288576a$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $1e0b34ed3288576a$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $1e0b34ed3288576a$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $1e0b34ed3288576a$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $1e0b34ed3288576a$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $1e0b34ed3288576a$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $1e0b34ed3288576a$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $1e0b34ed3288576a$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $1e0b34ed3288576a$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $1e0b34ed3288576a$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $1e0b34ed3288576a$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $1e0b34ed3288576a$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $1e0b34ed3288576a$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $1e0b34ed3288576a$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $1e0b34ed3288576a$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $1e0b34ed3288576a$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $1e0b34ed3288576a$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $1e0b34ed3288576a$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $1e0b34ed3288576a$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $1e0b34ed3288576a$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $1e0b34ed3288576a$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $1e0b34ed3288576a$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $1e0b34ed3288576a$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $1e0b34ed3288576a$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $1e0b34ed3288576a$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $1e0b34ed3288576a$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $1e0b34ed3288576a$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $1e0b34ed3288576a$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $1e0b34ed3288576a$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $1e0b34ed3288576a$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $1e0b34ed3288576a$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $1e0b34ed3288576a$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $1e0b34ed3288576a$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $1e0b34ed3288576a$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $1e0b34ed3288576a$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $1e0b34ed3288576a$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $1e0b34ed3288576a$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1e0b34ed3288576a$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $1e0b34ed3288576a$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $1e0b34ed3288576a$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $1e0b34ed3288576a$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $1e0b34ed3288576a$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $1e0b34ed3288576a$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $1e0b34ed3288576a$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $1e0b34ed3288576a$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $1e0b34ed3288576a$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $1e0b34ed3288576a$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $1e0b34ed3288576a$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $1e0b34ed3288576a$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $1e0b34ed3288576a$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $1e0b34ed3288576a$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $1e0b34ed3288576a$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $1e0b34ed3288576a$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $1e0b34ed3288576a$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $1e0b34ed3288576a$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $1e0b34ed3288576a$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $1e0b34ed3288576a$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $1e0b34ed3288576a$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $1e0b34ed3288576a$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $1e0b34ed3288576a$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $1e0b34ed3288576a$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $1e0b34ed3288576a$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $1e0b34ed3288576a$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $1e0b34ed3288576a$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $1e0b34ed3288576a$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $1e0b34ed3288576a$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $1e0b34ed3288576a$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $1e0b34ed3288576a$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $1e0b34ed3288576a$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $1e0b34ed3288576a$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $1e0b34ed3288576a$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $1e0b34ed3288576a$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $1e0b34ed3288576a$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $1e0b34ed3288576a$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $1e0b34ed3288576a$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $1e0b34ed3288576a$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $1e0b34ed3288576a$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $1e0b34ed3288576a$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $1e0b34ed3288576a$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $1e0b34ed3288576a$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $1e0b34ed3288576a$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $1e0b34ed3288576a$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $1e0b34ed3288576a$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $1e0b34ed3288576a$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $1e0b34ed3288576a$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $1e0b34ed3288576a$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $1e0b34ed3288576a$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $1e0b34ed3288576a$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $1e0b34ed3288576a$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $1e0b34ed3288576a$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $1e0b34ed3288576a$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $1e0b34ed3288576a$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $1e0b34ed3288576a$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $1e0b34ed3288576a$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $1e0b34ed3288576a$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $1e0b34ed3288576a$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $1e0b34ed3288576a$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $1e0b34ed3288576a$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $1e0b34ed3288576a$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $1e0b34ed3288576a$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $1e0b34ed3288576a$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $1e0b34ed3288576a$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $1e0b34ed3288576a$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $1e0b34ed3288576a$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $1e0b34ed3288576a$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $1e0b34ed3288576a$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $1e0b34ed3288576a$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $1e0b34ed3288576a$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ANY_CF_TYPE", () => $1e0b34ed3288576a$export$8c0f7dd088e5671d);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $1e0b34ed3288576a$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $1e0b34ed3288576a$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $1e0b34ed3288576a$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $1e0b34ed3288576a$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $1e0b34ed3288576a$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $1e0b34ed3288576a$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1e0b34ed3288576a$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $1e0b34ed3288576a$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $1e0b34ed3288576a$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $1e0b34ed3288576a$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $1e0b34ed3288576a$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $1e0b34ed3288576a$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $1e0b34ed3288576a$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $1e0b34ed3288576a$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $1e0b34ed3288576a$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $1e0b34ed3288576a$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $1e0b34ed3288576a$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $1e0b34ed3288576a$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $1e0b34ed3288576a$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $1e0b34ed3288576a$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $1e0b34ed3288576a$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $1e0b34ed3288576a$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $1e0b34ed3288576a$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $1e0b34ed3288576a$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $1e0b34ed3288576a$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $1e0b34ed3288576a$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $1e0b34ed3288576a$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $1e0b34ed3288576a$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $1e0b34ed3288576a$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $1e0b34ed3288576a$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $1e0b34ed3288576a$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $1e0b34ed3288576a$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1e0b34ed3288576a$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $1e0b34ed3288576a$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $1e0b34ed3288576a$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $1e0b34ed3288576a$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $1e0b34ed3288576a$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $1e0b34ed3288576a$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $1e0b34ed3288576a$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $1e0b34ed3288576a$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $1e0b34ed3288576a$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $1e0b34ed3288576a$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $1e0b34ed3288576a$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $1e0b34ed3288576a$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $1e0b34ed3288576a$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $1e0b34ed3288576a$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $1e0b34ed3288576a$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $1e0b34ed3288576a$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $1e0b34ed3288576a$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $1e0b34ed3288576a$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $1e0b34ed3288576a$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $1e0b34ed3288576a$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $1e0b34ed3288576a$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $1e0b34ed3288576a$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "WORKLOG", () => $1e0b34ed3288576a$export$df36fc05622c402);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $1e0b34ed3288576a$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $1e0b34ed3288576a$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $1e0b34ed3288576a$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "DETAILS_PANEL_IN_EDIT_MODE", () => $1e0b34ed3288576a$export$f4909db381566ce3);
$parcel$export(module.exports, "ARE_FIELDS_REORDERED", () => $1e0b34ed3288576a$export$6159d4eb69c78696);
$parcel$export(module.exports, "HIDE_EMPTY_FIELDS", () => $1e0b34ed3288576a$export$962c5b8782b7a233);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $1e0b34ed3288576a$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $1e0b34ed3288576a$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $1e0b34ed3288576a$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $1e0b34ed3288576a$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $1e0b34ed3288576a$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $1e0b34ed3288576a$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $1e0b34ed3288576a$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $1e0b34ed3288576a$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $1e0b34ed3288576a$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $1e0b34ed3288576a$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $1e0b34ed3288576a$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $1e0b34ed3288576a$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $1e0b34ed3288576a$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $1e0b34ed3288576a$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $1e0b34ed3288576a$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $1e0b34ed3288576a$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $1e0b34ed3288576a$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $1e0b34ed3288576a$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $1e0b34ed3288576a$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "AGGREGATE_TIME_ORIGINAL_ESTIMATE", () => $1e0b34ed3288576a$export$871661506c0a91ea);
$parcel$export(module.exports, "AGGREGATE_TIME_ESTIMATE", () => $1e0b34ed3288576a$export$4a7ecfe931ab6c07);
$parcel$export(module.exports, "PROGRESS", () => $1e0b34ed3288576a$export$fbc5ebe2e580bf8b);
$parcel$export(module.exports, "AGGREGATE_PROGRESS", () => $1e0b34ed3288576a$export$aa3b37e271efd578);
$parcel$export(module.exports, "WORKRATIO", () => $1e0b34ed3288576a$export$444bffe6526fb5f2);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $1e0b34ed3288576a$export$3c3e26aadbfa2c32);

var $LFmXM = parcelRequire("LFmXM");

var $7jTnu = parcelRequire("7jTnu");
const $1e0b34ed3288576a$export$b144116dae474c88 = 'issue-link-search';
const $1e0b34ed3288576a$export$bc917bc699b25f75 = 'number';
const $1e0b34ed3288576a$export$5f26ca419fdffbe7 = 'string';
const $1e0b34ed3288576a$export$ce9bfd823c7e1a6d = 'datetime';
const $1e0b34ed3288576a$export$346b72b1f7cd6d5a = 'date';
const $1e0b34ed3288576a$export$b20fbcacd7942c2a = 'option2';
const $1e0b34ed3288576a$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $1e0b34ed3288576a$export$a2e8554bffc61ece = 'any';
const $1e0b34ed3288576a$export$f25cd4907cbb25b9 = 'array';
const $1e0b34ed3288576a$export$5600354b43577e17 = 'user';
const $1e0b34ed3288576a$export$5dbc9917f72d0d2a = 'group';
const $1e0b34ed3288576a$export$253649f07fb55948 = 'object';
const $1e0b34ed3288576a$export$eb39592ba5247ee7 = 'group-list';
const $1e0b34ed3288576a$export$f48a9be226105736 = 'array-string';
const $1e0b34ed3288576a$export$42e2e93fc721df5d = 'version';
const $1e0b34ed3288576a$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $1e0b34ed3288576a$export$7773375e72c953ed = 'approval-panel';
const $1e0b34ed3288576a$export$80ad0037098f3919 = 'project';
const $1e0b34ed3288576a$export$82db8a26de491dd2 = 'array';
const $1e0b34ed3288576a$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $1e0b34ed3288576a$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $1e0b34ed3288576a$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $1e0b34ed3288576a$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $1e0b34ed3288576a$export$c979d9c548c05133 = 'JiraBooleanField';
const $1e0b34ed3288576a$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $1e0b34ed3288576a$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $1e0b34ed3288576a$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $1e0b34ed3288576a$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $1e0b34ed3288576a$export$b0deb225eed90fbd = 'JiraCMDBField';
const $1e0b34ed3288576a$export$add3775cfea8fde3 = 'JiraColorField';
const $1e0b34ed3288576a$export$9631d4098abab3eb = 'JiraComponentsField';
const $1e0b34ed3288576a$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $1e0b34ed3288576a$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $1e0b34ed3288576a$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $1e0b34ed3288576a$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $1e0b34ed3288576a$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $1e0b34ed3288576a$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $1e0b34ed3288576a$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $1e0b34ed3288576a$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $1e0b34ed3288576a$export$6d8da4497234455 = 'JiraEpicLinkField';
const $1e0b34ed3288576a$export$9bcfac568e4fa59c = 'JiraFlagField';
const $1e0b34ed3288576a$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $1e0b34ed3288576a$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $1e0b34ed3288576a$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $1e0b34ed3288576a$export$810709f0c5c2e9db = 'JiraLabelsField';
const $1e0b34ed3288576a$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $1e0b34ed3288576a$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $1e0b34ed3288576a$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $1e0b34ed3288576a$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $1e0b34ed3288576a$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $1e0b34ed3288576a$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $1e0b34ed3288576a$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $1e0b34ed3288576a$export$31aea7548807c6b5 = 'JiraPeopleField';
const $1e0b34ed3288576a$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $1e0b34ed3288576a$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $1e0b34ed3288576a$export$12f54499c6252188 = 'JiraProjectField';
const $1e0b34ed3288576a$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $1e0b34ed3288576a$export$c69486dd643dfb69 = 'JiraReporterField';
const $1e0b34ed3288576a$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $1e0b34ed3288576a$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $1e0b34ed3288576a$export$37f4daaa7b409554 = 'JiraRichTextField';
const $1e0b34ed3288576a$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $1e0b34ed3288576a$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $1e0b34ed3288576a$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $1e0b34ed3288576a$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $1e0b34ed3288576a$export$e40f819979b3881d = 'JiraStatusField';
const $1e0b34ed3288576a$export$6c243704a22baffe = 'JiraTeamField';
const $1e0b34ed3288576a$export$6c32429bac235203 = 'JiraTeamViewField';
const $1e0b34ed3288576a$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $1e0b34ed3288576a$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $1e0b34ed3288576a$export$37ccd11f08a93ccb = 'JiraUrlField';
const $1e0b34ed3288576a$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $1e0b34ed3288576a$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $1e0b34ed3288576a$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $1e0b34ed3288576a$export$aa815aaa741ae18 = 'JiraWatchesField';
const $1e0b34ed3288576a$export$e805f89b15d2abf4 = 'JiraAssetField';
const $1e0b34ed3288576a$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $1e0b34ed3288576a$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $1e0b34ed3288576a$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $1e0b34ed3288576a$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $1e0b34ed3288576a$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $1e0b34ed3288576a$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $1e0b34ed3288576a$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $1e0b34ed3288576a$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $1e0b34ed3288576a$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $1e0b34ed3288576a$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $1e0b34ed3288576a$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $1e0b34ed3288576a$export$c48132adab502d6b = 'JiraForgeUsersField';
const $1e0b34ed3288576a$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $1e0b34ed3288576a$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $1e0b34ed3288576a$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $1e0b34ed3288576a$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $1e0b34ed3288576a$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $1e0b34ed3288576a$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $1e0b34ed3288576a$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $1e0b34ed3288576a$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $1e0b34ed3288576a$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $1e0b34ed3288576a$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $1e0b34ed3288576a$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $1e0b34ed3288576a$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $1e0b34ed3288576a$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $1e0b34ed3288576a$export$bfcb1a91094f113a = 'JiraGoalsField';
const $1e0b34ed3288576a$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $1e0b34ed3288576a$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $1e0b34ed3288576a$export$798d2f5814884447 = 'forgeCustomField';
const $1e0b34ed3288576a$export$1e188101081be3f8 = 'forge/string';
const $1e0b34ed3288576a$export$caf3b3f20c0589b9 = 'forge/string-list';
const $1e0b34ed3288576a$export$9bdf08a1276e866c = 'forge/number';
const $1e0b34ed3288576a$export$996c3d3eb2880229 = 'forge/date';
const $1e0b34ed3288576a$export$578c5856bf684e2a = 'forge/datetime';
const $1e0b34ed3288576a$export$38791c0fdd0bcce = 'forge/user';
const $1e0b34ed3288576a$export$5c209e1debd6c274 = 'forge/user-list';
const $1e0b34ed3288576a$export$8646fecba9a8be61 = 'forge/group';
const $1e0b34ed3288576a$export$68b91cd2f2e6b810 = 'forge/group-list';
const $1e0b34ed3288576a$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $1e0b34ed3288576a$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $1e0b34ed3288576a$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $1e0b34ed3288576a$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $1e0b34ed3288576a$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $1e0b34ed3288576a$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $1e0b34ed3288576a$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $1e0b34ed3288576a$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $1e0b34ed3288576a$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $1e0b34ed3288576a$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $1e0b34ed3288576a$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $1e0b34ed3288576a$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $1e0b34ed3288576a$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $1e0b34ed3288576a$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $1e0b34ed3288576a$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $1e0b34ed3288576a$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $1e0b34ed3288576a$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $1e0b34ed3288576a$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $1e0b34ed3288576a$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $1e0b34ed3288576a$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $1e0b34ed3288576a$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $1e0b34ed3288576a$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $1e0b34ed3288576a$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $1e0b34ed3288576a$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $1e0b34ed3288576a$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $1e0b34ed3288576a$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $1e0b34ed3288576a$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $1e0b34ed3288576a$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $1e0b34ed3288576a$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $1e0b34ed3288576a$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $1e0b34ed3288576a$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $1e0b34ed3288576a$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $1e0b34ed3288576a$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $1e0b34ed3288576a$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $1e0b34ed3288576a$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $1e0b34ed3288576a$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $1e0b34ed3288576a$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $1e0b34ed3288576a$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $1e0b34ed3288576a$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $1e0b34ed3288576a$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $1e0b34ed3288576a$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $1e0b34ed3288576a$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $1e0b34ed3288576a$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $1e0b34ed3288576a$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $1e0b34ed3288576a$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $1e0b34ed3288576a$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $1e0b34ed3288576a$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $1e0b34ed3288576a$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $1e0b34ed3288576a$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $1e0b34ed3288576a$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $1e0b34ed3288576a$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $1e0b34ed3288576a$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $1e0b34ed3288576a$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $1e0b34ed3288576a$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $1e0b34ed3288576a$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $1e0b34ed3288576a$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $1e0b34ed3288576a$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $1e0b34ed3288576a$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $1e0b34ed3288576a$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $1e0b34ed3288576a$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $1e0b34ed3288576a$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $1e0b34ed3288576a$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $1e0b34ed3288576a$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $1e0b34ed3288576a$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $1e0b34ed3288576a$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $1e0b34ed3288576a$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $1e0b34ed3288576a$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $1e0b34ed3288576a$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $1e0b34ed3288576a$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $1e0b34ed3288576a$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $1e0b34ed3288576a$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $1e0b34ed3288576a$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $1e0b34ed3288576a$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $1e0b34ed3288576a$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $1e0b34ed3288576a$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $1e0b34ed3288576a$export$8c0f7dd088e5671d = 'any.custom.field.type';
const $1e0b34ed3288576a$export$fba8634fd401ba8b = 'assignee';
const $1e0b34ed3288576a$export$a91aea2438afcce8 = 'reporter';
const $1e0b34ed3288576a$export$b159f8b8f27aae4c = 'duedate';
const $1e0b34ed3288576a$export$34740f8d07d23ac0 = 'priority';
const $1e0b34ed3288576a$export$43b6e33ec70f2272 = 'labels';
const $1e0b34ed3288576a$export$ff39ebd4bb12b718 = 'created';
const $1e0b34ed3288576a$export$cd8e68094cb5c3cb = 'updated';
const $1e0b34ed3288576a$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $1e0b34ed3288576a$export$37abf56f13f61ec5 = 'components';
const $1e0b34ed3288576a$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $1e0b34ed3288576a$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $1e0b34ed3288576a$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $1e0b34ed3288576a$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $1e0b34ed3288576a$export$791007408faf42f4 = 'servicedesk-incident-management';
const $1e0b34ed3288576a$export$827a1c600bac12a3 = 'devSummary';
const $1e0b34ed3288576a$export$e9ba671d077969f8 = 'releases';
const $1e0b34ed3288576a$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $1e0b34ed3288576a$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $1e0b34ed3288576a$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $1e0b34ed3288576a$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $1e0b34ed3288576a$export$a5c9f63aadcb220 = 'fixVersions';
const $1e0b34ed3288576a$export$94009605902e4fe5 = 'versions';
const $1e0b34ed3288576a$export$5e7324042f1d6b31 = 'description';
const $1e0b34ed3288576a$export$113281d03e6830ef = 'environment';
const $1e0b34ed3288576a$export$5ff798870a3dffbf = 'watches';
const $1e0b34ed3288576a$export$907219511d14ba3d = 'summary';
const $1e0b34ed3288576a$export$d09aa6a4f3538063 = 'proforma-forms';
const $1e0b34ed3288576a$export$3aca8c91b58a42e2 = 'resolution';
const $1e0b34ed3288576a$export$ccb5ffefbf8b987c = 'timetracking';
const $1e0b34ed3288576a$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $1e0b34ed3288576a$export$358267065be1e = 'status';
const $1e0b34ed3288576a$export$dcaa788c7ada56de = 'statusCategory';
const $1e0b34ed3288576a$export$ebb48b08205007c5 = 'issuetype';
const $1e0b34ed3288576a$export$5e91047fe9955d0e = 'issuekey';
const $1e0b34ed3288576a$export$3b3d0889022c85b3 = 'children-issues';
const $1e0b34ed3288576a$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1e0b34ed3288576a$export$8fe3d5be8cb17459 = 'epic-issues';
const $1e0b34ed3288576a$export$335851d83a79891 = 'hierarchy-level-below';
const $1e0b34ed3288576a$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $1e0b34ed3288576a$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $1e0b34ed3288576a$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $1e0b34ed3288576a$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $1e0b34ed3288576a$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $1e0b34ed3288576a$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $1e0b34ed3288576a$export$7b3d247435a784fa = 'SLA_PANEL';
const $1e0b34ed3288576a$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $1e0b34ed3288576a$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $1e0b34ed3288576a$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $1e0b34ed3288576a$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $1e0b34ed3288576a$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $1e0b34ed3288576a$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $1e0b34ed3288576a$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $1e0b34ed3288576a$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $1e0b34ed3288576a$export$22f61ccc2730431f = 'similar-issues';
const $1e0b34ed3288576a$export$8bbb446f57294715 = 'subtasks';
const $1e0b34ed3288576a$export$34fcd7cb291a1e4d = 'votes';
const $1e0b34ed3288576a$export$5e93f2a57cc4ca3a = 'parent';
const $1e0b34ed3288576a$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $1e0b34ed3288576a$export$91a9dba2d38d9a6f = 'project';
const $1e0b34ed3288576a$export$df36fc05622c402 = 'worklog';
const $1e0b34ed3288576a$export$ede0a4c20124ec85 = 'timespent';
const $1e0b34ed3288576a$export$3eeb79d48fb5f667 = 'dataclassification';
const $1e0b34ed3288576a$export$45e72c9a63ab61ab = 'SENTIMENT';
const $1e0b34ed3288576a$export$f4909db381566ce3 = 'DETAILS_PANEL_IN_EDIT_MODE';
const $1e0b34ed3288576a$export$6159d4eb69c78696 = 'ARE_FIELDS_REORDERED';
const $1e0b34ed3288576a$export$962c5b8782b7a233 = 'HIDE_EMPTY_FIELDS';
const $1e0b34ed3288576a$export$99ad62164189f781 = 'ecosystemGlance';
const $1e0b34ed3288576a$export$7719ef6e9283671 = 'forgeGlance';
const $1e0b34ed3288576a$export$bfebea5ce2e1887a = 'ecosystemContext';
const $1e0b34ed3288576a$export$be8e68fb1aed253e = 'forgeContext';
const $1e0b34ed3288576a$export$84e5674890d55030 = 'issuerestriction';
const $1e0b34ed3288576a$export$326a5522a485e43d = 'security';
const $1e0b34ed3288576a$export$c9f3f01e2c535302 = 'securitylevel';
const $1e0b34ed3288576a$export$35e5652f764785bd = 'creator';
const $1e0b34ed3288576a$export$66519f3bbff1796a = 'team';
const $1e0b34ed3288576a$export$a4ee0bca77cc8463 = 'estimate';
const $1e0b34ed3288576a$export$fed53408e89e0497 = 'dueDate';
const $1e0b34ed3288576a$export$d53c26f9ce31f56b = 'targetStart';
const $1e0b34ed3288576a$export$48f82d653f85e459 = 'targetEnd';
const $1e0b34ed3288576a$export$ea5a888f39f722c7 = 'startDate';
const $1e0b34ed3288576a$export$f245bbec12cc0e40 = 'color';
const $1e0b34ed3288576a$export$aed630b4b7114a59 = 'attachment';
const $1e0b34ed3288576a$export$b50c1a8fef07104 = 'issuelinks';
const $1e0b34ed3288576a$export$ea3d72f4bb7738ba = 'timeestimate';
const $1e0b34ed3288576a$export$a4cab0124760d860 = 'comment';
const $1e0b34ed3288576a$export$734929aef118d7e2 = 'worklog';
const $1e0b34ed3288576a$export$ffbacacb07c1d46d = 'parent';
const $1e0b34ed3288576a$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $1e0b34ed3288576a$export$278c072e2f9176ab = 'aggregatetimespent';
const $1e0b34ed3288576a$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $1e0b34ed3288576a$export$fbc5ebe2e580bf8b = 'progress';
const $1e0b34ed3288576a$export$aa3b37e271efd578 = 'aggregateprogress';
const $1e0b34ed3288576a$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $1e0b34ed3288576a$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $1e0b34ed3288576a$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $1e0b34ed3288576a$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $1e0b34ed3288576a$export$34740f8d07d23ac0,
        REPORTER_TYPE: $1e0b34ed3288576a$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $1e0b34ed3288576a$export$5e7324042f1d6b31,
        LABELS_TYPE: $1e0b34ed3288576a$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $1e0b34ed3288576a$export$37abf56f13f61ec5,
        SPRINT_TYPE: $1e0b34ed3288576a$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $1e0b34ed3288576a$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $1e0b34ed3288576a$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $1e0b34ed3288576a$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $1e0b34ed3288576a$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $1e0b34ed3288576a$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $1e0b34ed3288576a$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $1e0b34ed3288576a$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $1e0b34ed3288576a$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $1e0b34ed3288576a$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $1e0b34ed3288576a$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $1e0b34ed3288576a$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $1e0b34ed3288576a$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $1e0b34ed3288576a$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $1e0b34ed3288576a$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $1e0b34ed3288576a$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $1e0b34ed3288576a$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $1e0b34ed3288576a$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $1e0b34ed3288576a$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $1e0b34ed3288576a$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $1e0b34ed3288576a$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $1e0b34ed3288576a$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $1e0b34ed3288576a$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $1e0b34ed3288576a$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $1e0b34ed3288576a$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $1e0b34ed3288576a$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $1e0b34ed3288576a$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $1e0b34ed3288576a$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $1e0b34ed3288576a$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $1e0b34ed3288576a$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $1e0b34ed3288576a$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $1e0b34ed3288576a$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $1e0b34ed3288576a$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $1e0b34ed3288576a$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $1e0b34ed3288576a$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $1e0b34ed3288576a$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $1e0b34ed3288576a$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $1e0b34ed3288576a$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $1e0b34ed3288576a$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $1e0b34ed3288576a$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $1e0b34ed3288576a$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $1e0b34ed3288576a$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $1e0b34ed3288576a$export$39866626496bbfc8,
        VERSION_CF_TYPE: $1e0b34ed3288576a$export$24382b4e8c58336b,
        DATE_CF_TYPE: $1e0b34ed3288576a$export$ff745f432984005d,
        GROUP_CF_TYPE: $1e0b34ed3288576a$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $1e0b34ed3288576a$export$b600addfa3355c57,
        USER_CF_TYPE: $1e0b34ed3288576a$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $1e0b34ed3288576a$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $1e0b34ed3288576a$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $1e0b34ed3288576a$export$65524be5675e57e6,
        TEAM_CF_TYPE: $1e0b34ed3288576a$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $1e0b34ed3288576a$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $1e0b34ed3288576a$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $1e0b34ed3288576a$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $1e0b34ed3288576a$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $1e0b34ed3288576a$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $1e0b34ed3288576a$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $1e0b34ed3288576a$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $1e0b34ed3288576a$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $1e0b34ed3288576a$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $1e0b34ed3288576a$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $1e0b34ed3288576a$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $1e0b34ed3288576a$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $1e0b34ed3288576a$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $1e0b34ed3288576a$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $1e0b34ed3288576a$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $1e0b34ed3288576a$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $1e0b34ed3288576a$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $1e0b34ed3288576a$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $1e0b34ed3288576a$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $1e0b34ed3288576a$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $1e0b34ed3288576a$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $1e0b34ed3288576a$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $1e0b34ed3288576a$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $1e0b34ed3288576a$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $1e0b34ed3288576a$export$2bbb7f69c97ea279,
        PARENT_TYPE: $1e0b34ed3288576a$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $1e0b34ed3288576a$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $1e0b34ed3288576a$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $1e0b34ed3288576a$export$45e72c9a63ab61ab
    });
    if ((0, $7jTnu.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $1e0b34ed3288576a$export$d2a475ff30e5bf97
    });
    return types;
};
const $1e0b34ed3288576a$export$3c3e26aadbfa2c32 = (0, $LFmXM.default)($1e0b34ed3288576a$var$getLayoutFieldTypesNonMemoized);

});

parcelRegister("d2AGn", function(module, exports) {

$parcel$export(module.exports, "eventFlowManager", () => $84369507dcd887ed$export$87846400a9b428fc);
$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $84369507dcd887ed$export$f3b2b77402b2631f);

var $aXKmr = parcelRequire("aXKmr");

var $eSnSE = parcelRequire("eSnSE");

var $gCeeo = parcelRequire("gCeeo");

var $3bSs8 = parcelRequire("3bSs8");

var $aW71L = parcelRequire("aW71L");
/**
 * A singleton class to provide a sessionId to track update of fields
 */ class $84369507dcd887ed$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, $aXKmr.v4)();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $84369507dcd887ed$export$87846400a9b428fc = new $84369507dcd887ed$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default attributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $84369507dcd887ed$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
    let fieldTypeValue = attributes.fieldType;
    const extraAttributes = $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
    const fieldType = fieldTypeValue && (0, $3bSs8.FIELD_TYPE_MAP)[fieldTypeValue] ? (0, $3bSs8.FIELD_TYPE_MAP)[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $3bSs8.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
const $84369507dcd887ed$var$hasError = (e)=>e instanceof Error;
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $84369507dcd887ed$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const { assigneeId: assigneeId, product: product } = (0, $aW71L.getContextAssigneeIdAndProduct)(params.analytics.context);
            if (product === 'serviceDesk') return;
            $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...params.attributes,
                assigneeId: assigneeId
            });
            const sessionid = $84369507dcd887ed$export$87846400a9b428fc.push(fieldKey);
            const attributes = $84369507dcd887ed$var$concatAttributes(fieldKey, sessionid, params.attributes);
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $gCeeo.fireUIAnalytics)(params.analytics, `${(0, $3bSs8.START_ACTION_SUBJECT)} ${(0, $3bSs8.START_ACTION)}`, (0, $3bSs8.START_ACTION_SUBJECT_ID), attributes);
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $84369507dcd887ed$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            if ((0, $aW71L.getContextProduct)(params.analytics.context) === 'serviceDesk') return;
            const sessionid = $84369507dcd887ed$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const isFieldKeyUnknown = (0, $3bSs8.UNKNOWN_FIELD_IDS).includes(fieldKey);
            const actualFieldKey = isFieldKeyUnknown && params.attributes.fieldKey && typeof params.attributes.fieldKey === 'string' ? params.attributes.fieldKey : fieldKey;
            const attributes = $84369507dcd887ed$var$concatAttributes(actualFieldKey, sessionid, params.attributes);
            if (isEndOfSession) {
                if (isFieldKeyUnknown) $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.delete(actualFieldKey);
            }
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $gCeeo.fireTrackAnalytics)(params.analytics, `${(0, $3bSs8.END_ACTION_SUBJECT)} ${(0, $3bSs8.END_ACTION)}`, (0, $3bSs8.END_ACTION_SUBJECT_ID), {
                ...attributes,
                is_new_1event: true
            });
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $84369507dcd887ed$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    setAttributes (fieldKey, attributes) {
        const currentAttributes = $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.get(fieldKey);
        $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
            ...currentAttributes,
            ...attributes
        });
    },
    setActionTakenAttributes (fieldKey, oldValId, newValId) {
        if (oldValId !== newValId) this.setAttributes(fieldKey, {
            oldValId: oldValId,
            newValId: newValId,
            actionTaken: (0, $aW71L.getActionTaken)(oldValId, newValId)
        });
    },
    // Use this to clean up session without firing analytics event. This happens for entity fields when
    // multiple end events can be fired after a start event
    endSession (fieldKey) {
        $84369507dcd887ed$export$87846400a9b428fc.pull(fieldKey);
        $84369507dcd887ed$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
    },
    reset () {
        $84369507dcd887ed$export$87846400a9b428fc.reset();
    }
};
const $84369507dcd887ed$export$f3b2b77402b2631f = ()=>$84369507dcd887ed$var$updateAnalyticsFlowHelper;

});
parcelRegister("3bSs8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $0694d3ffaf31cb5e$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $0694d3ffaf31cb5e$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $0694d3ffaf31cb5e$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $0694d3ffaf31cb5e$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $0694d3ffaf31cb5e$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $0694d3ffaf31cb5e$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $0694d3ffaf31cb5e$export$e3d957ccc2d46469);
$parcel$export(module.exports, "ACTION_TAKEN_ADD", () => $0694d3ffaf31cb5e$export$3b3e3ac6d7f6e219);
$parcel$export(module.exports, "ACTION_TAKEN_REMOVE", () => $0694d3ffaf31cb5e$export$6137e1b2fcde2333);
$parcel$export(module.exports, "DRAG_DROP_UNKNOWN_FIELD_ID", () => $0694d3ffaf31cb5e$export$6d8c364f9d389764);
$parcel$export(module.exports, "UNKNOWN_FIELD_IDS", () => $0694d3ffaf31cb5e$export$7d1d20ff891eeb26);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $0694d3ffaf31cb5e$export$d8ccf495ccc97a69);
$parcel$export(module.exports, "ENTITY_FIELD_KEYS", () => $0694d3ffaf31cb5e$export$7d9dd31e187cb2db);

var $814y1 = parcelRequire("814y1");
const $0694d3ffaf31cb5e$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false,
    isContextMenuEditing: false,
    isIssueViewEditing: false
};
const $0694d3ffaf31cb5e$export$c0a4673e0c78e972 = 'clicked';
const $0694d3ffaf31cb5e$export$34a5ae354a38cc7e = 'item';
const $0694d3ffaf31cb5e$export$bc373f59492dc6e2 = 'issue';
const $0694d3ffaf31cb5e$export$b19686c1fe99f85a = 'updated';
const $0694d3ffaf31cb5e$export$4ce67e80878d47ed = 'issue';
const $0694d3ffaf31cb5e$export$e3d957ccc2d46469 = 'ended';
const $0694d3ffaf31cb5e$export$3b3e3ac6d7f6e219 = 'add';
const $0694d3ffaf31cb5e$export$6137e1b2fcde2333 = 'remove';
const $0694d3ffaf31cb5e$export$6d8c364f9d389764 = 'unknown';
const $0694d3ffaf31cb5e$export$7d1d20ff891eeb26 = [
    $0694d3ffaf31cb5e$export$6d8c364f9d389764
];
const $0694d3ffaf31cb5e$export$403ea87111529de = {
    [(0, $814y1.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $814y1.FIX_VERSIONS_TYPE)]: 'versions',
    [(0, $814y1.VERSION_CF_TYPE)]: 'versions',
    [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $814y1.SPRINT_TYPE)]: 'link',
    [(0, $814y1.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $814y1.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $814y1.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $814y1.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $814y1.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $814y1.USER_CF_TYPE)]: 'singleUser',
    [(0, $814y1.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $814y1.URL_CF_TYPE)]: 'url',
    [(0, $814y1.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $814y1.MULTI_GROUP_CF_TYPE)]: 'multiGroup'
};
const $0694d3ffaf31cb5e$export$d8ccf495ccc97a69 = {
    [(0, $814y1.AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
    [(0, $814y1.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $814y1.ATTACHMENT_TYPE)]: 'attachment',
    [(0, $814y1.CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
    [(0, $814y1.COMPONENTS_TYPE)]: 'components',
    [(0, $814y1.DATE_CF_TYPE)]: 'date',
    [(0, $814y1.DATETIME_CF_TYPE)]: 'dateTime',
    [(0, $814y1.DESCRIPTION_TYPE)]: 'richText',
    [(0, $814y1.DUE_DATE_TYPE)]: 'date',
    [(0, $814y1.FIX_VERSIONS_TYPE)]: 'fixVersions',
    [(0, $814y1.FLAGGED_CF_TYPE)]: 'flag',
    [(0, $814y1.GOALS_CF_TYPE)]: 'goals',
    [(0, $814y1.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $814y1.ISSUE_TYPE)]: 'issuetype',
    [(0, $814y1.LABELS_CF_TYPE)]: 'labels',
    [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $814y1.MULTI_GROUP_CF_TYPE)]: 'multiGroup',
    [(0, $814y1.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $814y1.MULTI_USER_CF_TYPE)]: 'multiUser',
    [(0, $814y1.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $814y1.NUMBER_CF_TYPE)]: 'float',
    [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $814y1.PARENT_TYPE)]: 'parent',
    [(0, $814y1.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $814y1.PRIORITY_TYPE)]: 'priority',
    [(0, $814y1.PROJECT_PICKER_CF_TYPE)]: 'project',
    [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $814y1.RANK_CF_TYPE)]: 'rank',
    [(0, $814y1.START_DATE_TYPE)]: 'date',
    [(0, $814y1.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $814y1.SPRINT_TYPE)]: 'sprint',
    [(0, $814y1.STATUS_TYPE)]: 'status',
    [(0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
    [(0, $814y1.STORY_POINTS_TYPE)]: 'storyPointEstimate',
    [(0, $814y1.SUMMARY_TYPE)]: 'singleLineText',
    [(0, $814y1.TEAMS_PLATFORM_CF_TYPE)]: 'team',
    [(0, $814y1.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $814y1.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $814y1.TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
    [(0, $814y1.TIME_TRACKING_TYPE)]: 'timeTracking',
    [(0, $814y1.URL_CF_TYPE)]: 'url',
    [(0, $814y1.USER_CF_TYPE)]: 'singleUser',
    [(0, $814y1.VERSION_CF_TYPE)]: 'version',
    [(0, $814y1.VOTES_TYPE)]: 'votes',
    [(0, $814y1.WATCHES_TYPE)]: 'watchers'
};
const $0694d3ffaf31cb5e$export$7d9dd31e187cb2db = {
    WEB_LINK: 'weblink',
    ATTACHMENT: 'attachment',
    ISSUE_LINKS: 'linkIssue',
    PARENT: 'parent'
};

});

parcelRegister("aW71L", function(module, exports) {

$parcel$export(module.exports, "getActionTaken", () => $56306893bffbb0cd$export$9d814e3464362b48);
$parcel$export(module.exports, "getContextAssigneeIdAndProduct", () => $56306893bffbb0cd$export$e6dd41ec8f1794f6);
$parcel$export(module.exports, "getContextProduct", () => $56306893bffbb0cd$export$4cb0aa9574634a48);

var $3bSs8 = parcelRequire("3bSs8");
const $56306893bffbb0cd$export$9d814e3464362b48 = (oldValId, newValId)=>{
    if (oldValId !== newValId) {
        if (newValId === null) return 0, $3bSs8.ACTION_TAKEN_REMOVE;
        if (oldValId === null || oldValId === undefined) return 0, $3bSs8.ACTION_TAKEN_ADD;
    }
    return undefined;
};
const $56306893bffbb0cd$export$e6dd41ec8f1794f6 = (context)=>{
    let assigneeId;
    let product;
    for (const item of context){
        if (item?.attributes?.assigneeId) assigneeId = item.attributes.assigneeId;
        if (item?.attributes?.previousSubProduct) product = item.attributes.previousSubProduct;
        if (assigneeId && product) break;
    }
    return {
        assigneeId: assigneeId,
        product: product
    };
};
const $56306893bffbb0cd$export$4cb0aa9574634a48 = (context)=>{
    for (const item of context){
        if (item?.attributes?.previousSubProduct) return item.attributes.previousSubProduct;
    }
};

});










parcelRegister("6vkP1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d46e8f936de36b4f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d46e8f936de36b4f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    projectNavigation: {
        "id": "horizontal-nav-common.common.tab-shortcut-context.project-navigation",
        "defaultMessage": "Project navigation"
    },
    goTo: {
        "id": "horizontal-nav-common.common.tab-shortcut-context.go-to",
        "defaultMessage": "Go to {label}"
    },
    projectNavigationGalaxia: {
        "id": "horizontal-nav-common.common.tab-shortcut-context.project-navigation-galaxia",
        "defaultMessage": "Space navigation"
    }
});

});


parcelRegister("axSHs", function(module, exports) {

$parcel$export(module.exports, "useIsProjectPagesOptedIn", () => $c38599a26eaedc93$export$1cd6ee8ac95e08ef);

var $6V3Gv = parcelRequire("6V3Gv");

var $kEUB1 = parcelRequire("kEUB1");

var $8q7lT = parcelRequire("8q7lT");

var $b9nqM = parcelRequire("b9nqM");

var $7jTnu = parcelRequire("7jTnu");
const $c38599a26eaedc93$export$1cd6ee8ac95e08ef = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const hasConfluence = licensedProducts.confluence;
    const { optoutStatus: optoutStatus } = (0, $6V3Gv.useIsOptoutAllMessages)('jira-project-pages', cloudId, atlassianAccountId, {
        isDisabled: !(0, $7jTnu.fg)('optout_all_messages_project_pages')
    });
    const isOptedIn = hasConfluence || !(0, $7jTnu.fg)('optout_all_messages_project_pages') || optoutStatus === 'no-opt-out';
    return {
        isOptedIn: isOptedIn
    };
};

});
parcelRegister("8q7lT", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $1bd1fe7fb0bcdb0a$export$e72033e0f5baa3e);

var $lvKO5 = parcelRequire("lvKO5");
const $1bd1fe7fb0bcdb0a$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});


parcelRegister("991ot", function(module, exports) {

$parcel$export(module.exports, "useDroppableTabList", () => $e81aba88ee16f93c$export$ecea8c8c33275ef5);

var $eJOHy = parcelRequire("eJOHy");

var $3nrCN = parcelRequire("3nrCN");

var $5nIpU = parcelRequire("5nIpU");

var $bGx3v = parcelRequire("bGx3v");

var $bFY6o = parcelRequire("bFY6o");

var $8Uqf3 = parcelRequire("8Uqf3");

var $5EEmv = parcelRequire("5EEmv");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $e81aba88ee16f93c$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $e81aba88ee16f93c$export$f1e608dba99fa330 = {
    experience: 'reorderView'
};
const $e81aba88ee16f93c$var$BEFORE = 'before';
const $e81aba88ee16f93c$var$AFTER = 'after';
const $e81aba88ee16f93c$export$ecea8c8c33275ef5 = (tabs, containerNavigationId, scopeId)=>{
    const onStartExperience = (0, $8Uqf3.useExperienceStart)({
        ...$e81aba88ee16f93c$export$f1e608dba99fa330,
        analyticsSource: $e81aba88ee16f93c$export$b8b9d90f9e5bd72b
    });
    const onExperienceAbort = (0, $bFY6o.useExperienceAbort)($e81aba88ee16f93c$export$f1e608dba99fa330);
    const [rankNavigationItem] = (0, $5EEmv.useRankNavigationItem)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>(0, $bGx3v.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.type === 'tab';
            },
            onDrop ({ source: source, location: location }) {
                onStartExperience();
                const destination = location.current.dropTargets[0];
                if (!destination) {
                    onExperienceAbort('Dropped outside of drop targets');
                    return;
                }
                if (source.data.type === 'tab' && source.data.id !== destination.data.id) {
                    const sourceTabIndex = tabs.findIndex((tab)=>tab.id === source.data.id);
                    let targetTabIndex;
                    let closestEdgeOfTarget;
                    if (destination.data.isMoreMenu) {
                        // assume no pagination and move it to the bottom of the list
                        targetTabIndex = tabs.length - 1;
                        closestEdgeOfTarget = 'bottom';
                    } else {
                        targetTabIndex = tabs.findIndex((tab)=>tab.id === destination.data.id);
                        closestEdgeOfTarget = (0, $3nrCN.extractClosestEdge)(destination.data);
                    }
                    const reorderedTabs = (0, $5nIpU.reorderWithEdge)({
                        list: tabs,
                        startIndex: sourceTabIndex,
                        indexOfTarget: targetTabIndex,
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        axis: destination.data.isOverflowing ? 'vertical' : 'horizontal'
                    });
                    if (reorderedTabs && tabs.every((value, index)=>value === reorderedTabs[index])) return;
                    const placement = closestEdgeOfTarget === 'left' || closestEdgeOfTarget === 'top' ? $e81aba88ee16f93c$var$BEFORE : $e81aba88ee16f93c$var$AFTER;
                    const { id: id, typeKey: typeKey, appId: appId, dataId: dataId } = tabs[sourceTabIndex];
                    const beforeItemId = placement === $e81aba88ee16f93c$var$BEFORE ? tabs[targetTabIndex].id : null;
                    const afterItemId = placement === $e81aba88ee16f93c$var$AFTER ? tabs[targetTabIndex].id : null;
                    if (id.includes('optimisticId') || beforeItemId && beforeItemId.includes('optimisticId') || afterItemId && afterItemId.includes('optimisticId')) return;
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'navigationItem dragged', 'projectNavigationTab', {
                        itemType: typeKey && typeKey.toLowerCase(),
                        itemId: appId,
                        draggedFromMore: Boolean(source.data.isOverflowing),
                        draggedToMore: Boolean(destination.data.isOverflowing || destination.data.isMoreMenu)
                    });
                    rankNavigationItem({
                        placement: placement,
                        sourceTabIndex: sourceTabIndex,
                        targetTabIndex: targetTabIndex,
                        id: id,
                        beforeItemId: beforeItemId,
                        afterItemId: afterItemId,
                        dataId: dataId,
                        actionType: 'dragged',
                        containerNavigationId: containerNavigationId,
                        scopeId: scopeId
                    });
                }
            }
        }), [
        tabs,
        rankNavigationItem,
        onStartExperience,
        onExperienceAbort,
        containerNavigationId,
        scopeId,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("5nIpU", function(module, exports) {

$parcel$export(module.exports, "reorderWithEdge", () => $97725e2f4be5e437$export$d0bc664d2812b3ba);
parcelRequire("isfFo");
var $l0rlp = parcelRequire("l0rlp");

var $1l4lS = parcelRequire("1l4lS");
function $97725e2f4be5e437$export$d0bc664d2812b3ba({ list: list, startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    return (0, $l0rlp.reorder)({
        list: list,
        startIndex: startIndex,
        finishIndex: (0, $1l4lS.getReorderDestinationIndex)({
            closestEdgeOfTarget: closestEdgeOfTarget,
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            axis: axis
        })
    });
}

});
parcelRegister("isfFo", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("l0rlp")).reorder);

var $l0rlp = parcelRequire("l0rlp");

});
parcelRegister("l0rlp", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $f980499636215ef6$export$fc77a6137e3f91c);
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $f980499636215ef6$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("1l4lS", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $f0909d4a1662ae03$export$846f792f51b92b6e);
function $f0909d4a1662ae03$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});


parcelRegister("bFY6o", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $668c094dfa849c1f$export$cc92b7ce453f4403);

var $eJOHy = parcelRequire("eJOHy");

var $aSmR5 = parcelRequire("aSmR5");
const $668c094dfa849c1f$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const self = (0, $eJOHy.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eJOHy.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});

parcelRegister("5EEmv", function(module, exports) {

$parcel$export(module.exports, "useRankNavigationItem", () => $66b365f5b1e92e59$export$d474c994a9313e38);

var $1WZ7G = parcelRequire("1WZ7G");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5nIpU = parcelRequire("5nIpU");

var $ayBWV = parcelRequire("ayBWV");

var $gYnSx = parcelRequire("gYnSx");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $bILK0 = parcelRequire("bILK0");

var $4SjAP = parcelRequire("4SjAP");


var $2VUCc = parcelRequire("2VUCc");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kqd31 = parcelRequire("kqd31");

var $J4tbM = parcelRequire("J4tbM");
const $66b365f5b1e92e59$var$BEFORE = 'before';
const $66b365f5b1e92e59$var$AFTER = 'after';
const $66b365f5b1e92e59$var$HANDLED_STATUS_CODES = [
    401,
    403,
    404
];
const $66b365f5b1e92e59$var$ERROR_TYPE = 'error';
const $66b365f5b1e92e59$var$RANK_NAVIGATION_ERROR_FLAG = {
    type: $66b365f5b1e92e59$var$ERROR_TYPE,
    title: (0, $J4tbM.default).errorTitle,
    description: (0, $J4tbM.default).errorMessage,
    messageId: 'horizontal-nav-rank-item-service.services.rank-navigation-error-flag.flag.error',
    messageType: 'transactional'
};
const $66b365f5b1e92e59$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $66b365f5b1e92e59$export$111d365fc37d2de3 = 'reorderView';
const $66b365f5b1e92e59$export$d57b6b390e78d90f = 'Navigation';
const $66b365f5b1e92e59$export$f1e608dba99fa330 = {
    experience: $66b365f5b1e92e59$export$111d365fc37d2de3
};
const $66b365f5b1e92e59$var$getFlagDetails = (error)=>{
    const statusCode = error instanceof (0, $4SjAP.MutationError) ? error.extensions?.statusCode ?? null : error.extensions?.[0]?.statusCode ?? null;
    switch(statusCode){
        case 401:
            return {
                type: $66b365f5b1e92e59$var$ERROR_TYPE,
                title: (0, $J4tbM.default).unauthenticatedUserErrorTitle,
                description: (0, $J4tbM.default).unauthenticatedUserErrorMessage,
                messageId: 'horizontal-nav-rank-item-service.services.flag.unauthenticated-user-error',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: $66b365f5b1e92e59$var$ERROR_TYPE,
                title: (0, $J4tbM.default).authorisationErrorTitle,
                description: (0, $J4tbM.default).authorisationErrorMessage,
                messageId: 'horizontal-nav-rank-item-service.services.flag.authorisation-error',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: $66b365f5b1e92e59$var$ERROR_TYPE,
                title: (0, $J4tbM.default).viewNotFoundErrorTitle,
                description: (0, $J4tbM.default).viewNotFoundErrorMessage,
                messageId: 'horizontal-nav-rank-item-service.services.flag.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $66b365f5b1e92e59$export$d474c994a9313e38 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const [commitMutation, isLoading] = (0, $j4oe4.useMutation)((0, $1WZ7G.default));
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)($66b365f5b1e92e59$export$f1e608dba99fa330);
    const onExperienceFail = (0, $aqnJa.useExperienceFail)($66b365f5b1e92e59$export$f1e608dba99fa330);
    const sendErrorAnalytics = (0, $eJOHy.useCallback)((error)=>{
        onExperienceFail($66b365f5b1e92e59$export$b8b9d90f9e5bd72b, error);
        (0, $gYnSx.default)({
            meta: {
                id: $66b365f5b1e92e59$export$111d365fc37d2de3,
                packageName: $66b365f5b1e92e59$export$b8b9d90f9e5bd72b,
                teamName: $66b365f5b1e92e59$export$d57b6b390e78d90f
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail
    ]);
    const rankNavigationItem = (0, $eJOHy.useCallback)(({ placement: placement, sourceTabIndex: sourceTabIndex, targetTabIndex: targetTabIndex, id: id, beforeItemId: beforeItemId, afterItemId: afterItemId, dataId: dataId, actionType: actionType, containerNavigationId: containerNavigationId, scopeId: scopeId })=>{
        let initialTabOrder = [];
        commitMutation({
            variables: {
                input: {
                    id: id,
                    beforeItemId: beforeItemId,
                    afterItemId: afterItemId,
                    scopeId: scopeId
                },
                first: (0, $928056a84d2eedae$export$4653cda61a4943d6)
            },
            optimisticUpdater: (store)=>{
                const relayId = (0, $kqd31.default)({
                    id: containerNavigationId
                }, 'JiraContainerNavigation');
                const connection = relayId && store.get(relayId)?.getLinkedRecord('navigationItems', {
                    first: (0, $928056a84d2eedae$export$4653cda61a4943d6)
                });
                if (!connection) return;
                const existingEdges = connection?.getLinkedRecords('edges') || [];
                initialTabOrder = (0, $2VUCc.getAnalyticsTabOrder)(store, containerNavigationId);
                const tabs = Array.from(existingEdges || []);
                const reorderedTabs = (0, $5nIpU.reorderWithEdge)({
                    list: tabs,
                    startIndex: sourceTabIndex,
                    indexOfTarget: targetTabIndex,
                    closestEdgeOfTarget: placement === $66b365f5b1e92e59$var$BEFORE ? 'left' : 'right',
                    axis: 'horizontal'
                });
                const edges = reorderedTabs.map((tab)=>existingEdges.find((edge)=>tab?.getLinkedRecord('node')?.getDataID() === edge.getLinkedRecord('node')?.getDataID())).filter(Boolean);
                connection?.setLinkedRecords(edges, 'edges');
            },
            updater: (store, response)=>{
                if (!response?.jira?.rankNavigationItem?.success) return;
                const finalTabOrder = (0, $2VUCc.getAnalyticsTabOrder)(store, containerNavigationId);
                const itemType = dataId && store.get(dataId)?.getValue('typeKey');
                const itemId = dataId && store.get(dataId)?.getValue('appId');
                let finalTabIndex = targetTabIndex;
                if (placement === $66b365f5b1e92e59$var$AFTER && sourceTabIndex > targetTabIndex) // placing it after the tab which will keep the same index, hence the destination is the target + 1
                finalTabIndex += 1;
                else if (placement === $66b365f5b1e92e59$var$BEFORE && sourceTabIndex < targetTabIndex) // dropping it before the tab which will keep the same index, hence the destination is the target - 1
                finalTabIndex -= 1;
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectNavigationTabItem updated', {
                    originalItems: initialTabOrder,
                    updatedItems: finalTabOrder,
                    itemType: String(itemType).toLowerCase(),
                    itemId: itemId && String(itemId),
                    action: 'reordered',
                    method: actionType,
                    initialTabIndex: sourceTabIndex,
                    finalTabIndex: finalTabIndex
                });
            },
            onCompleted: (data)=>{
                const { errors: errors, success: success, containerNavigation: containerNavigation } = data?.jira?.rankNavigationItem ?? {};
                if (success && !errors) {
                    onExperienceSuccess();
                    return;
                }
                if (success && !errors) {
                    onExperienceSuccess();
                    return;
                }
                if (errors && errors?.length > 0 || containerNavigation?.__typename && containerNavigation.__typename === 'QueryError') {
                    const { ...queryError } = containerNavigation ?? {};
                    const error = errors ? new (0, $4SjAP.MutationError)(errors[0]) : new (0, $ayBWV.QueryError)(queryError);
                    const flagDetails = $66b365f5b1e92e59$var$getFlagDetails(error) ?? $66b365f5b1e92e59$var$RANK_NAVIGATION_ERROR_FLAG;
                    showFlag(flagDetails);
                    if ($66b365f5b1e92e59$var$HANDLED_STATUS_CODES.includes(error.statusCode ?? -1)) {
                        onExperienceSuccess();
                        return;
                    }
                    sendErrorAnalytics(error);
                    return;
                }
                showFlag($66b365f5b1e92e59$var$RANK_NAVIGATION_ERROR_FLAG);
            },
            onError: (error)=>{
                const err = new (0, $4SjAP.MutationError)(error);
                showFlag($66b365f5b1e92e59$var$RANK_NAVIGATION_ERROR_FLAG);
                sendErrorAnalytics(err);
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        showFlag,
        onExperienceSuccess,
        sendErrorAnalytics
    ]);
    return [
        rankNavigationItem,
        isLoading
    ];
};

});
parcelRegister("1WZ7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1313c3034acf2e97$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a94134f02495ac20f6a39bed337f7c2c>>
 * @relayHash 7dca2046022ad34e2d2a772b39ff5c6c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1565cb414d793dcea0c21b69eedabc92a4338f5a58284dd1c96386a0257aad86
const $1313c3034acf2e97$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "servicesRankNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRankNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "rankNavigationItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ContainerNavigationTabs_container"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v8 /*: any*/ ,
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "servicesRankNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRankNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "rankNavigationItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraContainerNavigationResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "scopeId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "first",
                                                            "variableName": "first"
                                                        }
                                                    ],
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraNavigationItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isDefault"
                                                                        },
                                                                        v10 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeKey"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRename"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRemove"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canSetAsDefault"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "appId"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraAppSection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "sections",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v13 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "envLabel"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v14 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraNavigationItem",
                                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                                }
                                                                            ],
                                                                            "type": "JiraAppNavigationItem"
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canEdit"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "scopeUrl"
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v8 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1565cb414d793dcea0c21b69eedabc92a4338f5a58284dd1c96386a0257aad86",
            "metadata": {},
            "name": "servicesRankNavigationItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$1313c3034acf2e97$var$node.hash = "34762fae8622a1c18cbdffa633de3226";
var $1313c3034acf2e97$export$2e2bcd8739ae039 = $1313c3034acf2e97$var$node;

});

parcelRegister("J4tbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d00b8bcb2b81dfa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1d00b8bcb2b81dfa$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "navigation-kit-rank-item-service.services.error-message",
        "defaultMessage": "Refresh the page and try again."
    },
    errorTitle: {
        "id": "navigation-kit-rank-item-service.services.error-title",
        "defaultMessage": "Something's gone wrong"
    },
    unauthenticatedUserErrorTitle: {
        "id": "navigation-kit-rank-item-service.services.unauthenticated-user-error-title",
        "defaultMessage": "You'll need to log in"
    },
    unauthenticatedUserErrorMessage: {
        "id": "navigation-kit-rank-item-service.services.unauthenticated-user-error-message",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    authorisationErrorTitle: {
        "id": "navigation-kit-rank-item-service.services.authorisation-error-title",
        "defaultMessage": "You don't have permission"
    },
    authorisationErrorMessage: {
        "id": "navigation-kit-rank-item-service.services.authorisation-error-message",
        "defaultMessage": "You are not allowed to manage the navigation."
    },
    viewNotFoundErrorTitle: {
        "id": "navigation-kit-rank-item-service.services.view-not-found-error-title",
        "defaultMessage": "This tab has been removed"
    },
    viewNotFoundErrorMessage: {
        "id": "navigation-kit-rank-item-service.services.view-not-found-error-message",
        "defaultMessage": "The tab you're trying to move can't be found"
    }
});

});



parcelRegister("2l4Rc", function(module, exports) {

$parcel$export(module.exports, "NavigationItemTab", () => $e7ae329d81a9d0be$export$8123409ae5ebd68);

var $1ydv8 = parcelRequire("1ydv8");

var $fSdve = parcelRequire("fSdve");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $14Esv = parcelRequire("14Esv");

var $7W7dr = parcelRequire("7W7dr");

var $39VdI = parcelRequire("39VdI");
const $e7ae329d81a9d0be$export$8123409ae5ebd68 = ({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, beforeItemId: beforeItemId, afterItemId: afterItemId, tabsDescriptor: tabsDescriptor, isRenaming: isRenaming, onRenamingChange: onRenamingChange })=>{
    const tabData = (0, $j4oe4.useFragment)((0, $fSdve.default), tabFragment);
    const containerData = (0, $j4oe4.useFragment)((0, $1ydv8.default), containerFragment);
    if (tabData.__typename === 'JiraAppNavigationItem') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7W7dr.AppTab), {
        tabFragment: tabData,
        containerFragment: containerData,
        position: position,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId
    });
    if (tabData.typeKey === 'SHORTCUTS') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $39VdI.ShortcutsTab), {
        tabFragment: tabData,
        containerFragment: containerData,
        position: position,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        isRenaming: isRenaming,
        onRenamingChange: onRenamingChange
    });
    if (tabData.url == null) return null;
    const Icon = tabsDescriptor[tabData.typeKey]?.Icon ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $14Esv.DefaultTab), {
        tabFragment: tabData,
        containerFragment: containerData,
        position: position,
        icon: Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            label: ""
        }),
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        isRenaming: isRenaming,
        onRenamingChange: onRenamingChange
    });
};

});
parcelRegister("1ydv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a1de8411340b93$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6618727869e83c51134b946cb67b705d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e4a1de8411340b93$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NavigationItemTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "DefaultTab_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "ShortcutsTab_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "AppTab_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$e4a1de8411340b93$var$node.hash = "9e2c189c40e4bc3dcbb1cf10c08a8bf2";
var $e4a1de8411340b93$export$2e2bcd8739ae039 = $e4a1de8411340b93$var$node;

});

parcelRegister("fSdve", function(module, exports) {

$parcel$export(module.exports, "default", () => $27237692018e31d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<23e2f2cef48b93aaf82f36ae99c85b7b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $27237692018e31d3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NavigationItemTab_tab",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "FragmentSpread",
            "name": "DefaultTab_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "ShortcutsTab_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "AppTab_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$27237692018e31d3$var$node.hash = "751fa7ab98212b17632e93d1c53dfc75";
var $27237692018e31d3$export$2e2bcd8739ae039 = $27237692018e31d3$var$node;

});

parcelRegister("14Esv", function(module, exports) {

$parcel$export(module.exports, "DefaultTab", () => $14bbf0f5429c964d$export$15a1012301673c71);

var $7Pwq9 = parcelRequire("7Pwq9");

var $boBv1 = parcelRequire("boBv1");

var $eJOHy = parcelRequire("eJOHy");

var $7mF43 = parcelRequire("7mF43");

var $j4oe4 = parcelRequire("j4oe4");

var $guChT = parcelRequire("guChT");

var $83DiZ = parcelRequire("83DiZ");

var $6fFb3 = parcelRequire("6fFb3");

var $iyTaR = parcelRequire("iyTaR");




var $l7wEr = parcelRequire("l7wEr");

var $fhrsC = parcelRequire("fhrsC");

var $aHvyO = parcelRequire("aHvyO");
const $14bbf0f5429c964d$export$15a1012301673c71 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, icon: icon, isRenaming: isRenaming, onRenamingChange: onRenamingChange, testId: testId, elemAfter: elemAfter, beforeItemId: beforeItemId, afterItemId: afterItemId }, ref)=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { isSelected: isSelected, hasOverflowed: hasOverflowed } = (0, $fhrsC.useTabContext)();
    const tabData = (0, $j4oe4.useFragment)((0, $boBv1.default), tabFragment);
    const containerData = (0, $j4oe4.useFragment)((0, $7Pwq9.default), containerFragment);
    const triggerAnalytics = (0, $l7wEr.useNavigationItemAnalytics)((0, $eJOHy.useMemo)(()=>({
            itemId: 'undefined',
            itemType: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(tabData.typeKey),
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage,
            navigationLayer: (0, $002870cfa80d64f4$export$33d8c916a600c5e9),
            navigationContainer: (0, $95eb6070d868c1b7$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), [
        tabData.typeKey
    ]));
    const { registerTab: registerTab } = (0, $6fFb3.useTabShortcuts)();
    (0, $eJOHy.useEffect)(()=>registerTab({
            index: position,
            callback: ()=>{
                if (!isSelected) push(tabData.url);
            },
            label: tabData.label
        }), [
        registerTab,
        tabData,
        position,
        push,
        isSelected
    ]);
    const tabWithMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aHvyO.TabWithMenu), {
        elemBefore: icon,
        elemAfter: elemAfter,
        href: tabData.url,
        tabFragment: tabData,
        containerFragment: containerData,
        onClick: triggerAnalytics,
        isRenaming: isRenaming,
        onRenamingChange: onRenamingChange,
        testId: testId,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        position: position,
        type: "router-link",
        ref: ref
    });
    return !hasOverflowed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: `horizontal-nav-tabs.${tabData.typeKey}`
    }, tabWithMenu) : tabWithMenu;
});

});
parcelRegister("7Pwq9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7594d89658bcff05$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<435ec6e3648eea9642eecd6b274b907f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7594d89658bcff05$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DefaultTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$7594d89658bcff05$var$node.hash = "f01c95b8f6d1cd80c4ac15d2546c116d";
var $7594d89658bcff05$export$2e2bcd8739ae039 = $7594d89658bcff05$var$node;

});

parcelRegister("boBv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $10ff354e76dfd96e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db91c26e263962bfce3a00f5c28af803>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $10ff354e76dfd96e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DefaultTab_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "label"
            },
            "action": "THROW",
            "path": "label"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "url"
            },
            "action": "THROW",
            "path": "url"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$10ff354e76dfd96e$var$node.hash = "9da2b497cf3cffcac56da38a0c7d758a";
var $10ff354e76dfd96e$export$2e2bcd8739ae039 = $10ff354e76dfd96e$var$node;

});

parcelRegister("aHvyO", function(module, exports) {

$parcel$export(module.exports, "TabWithMenu", () => $834c3cdd8897f6b6$export$be4d5a66758483a8);

var $hFOam = parcelRequire("hFOam");

var $iYUKP = parcelRequire("iYUKP");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2pPuG = parcelRequire("2pPuG");

var $5Ag6K = parcelRequire("5Ag6K");

var $krCQX = parcelRequire("krCQX");

var $7jTnu = parcelRequire("7jTnu");
const $834c3cdd8897f6b6$export$be4d5a66758483a8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ tabFragment: tabFragment, containerFragment: containerFragment, beforeItemId: beforeItemId, afterItemId: afterItemId, isRenaming: isRenaming, onRenamingChange: onRenamingChange, ...tabProps }, ref)=>{
    const renameNavigationItem = (0, $5Ag6K.useRenameNavigationItem)();
    const tabData = (0, $j4oe4.useFragment)((0, $iYUKP.default), tabFragment);
    const containerData = (0, $j4oe4.useFragment)((0, $hFOam.default), containerFragment);
    const canEdit = Boolean(containerData?.canEdit);
    const handleRenameComplete = (0, $eJOHy.useCallback)((newName)=>{
        renameNavigationItem?.({
            id: tabData.id,
            label: newName,
            scopeId: containerData.scopeId,
            typeKey: tabData.typeKey,
            __typename: tabData.__typename
        });
        onRenamingChange?.(false);
    }, [
        renameNavigationItem,
        tabData.id,
        tabData.typeKey,
        tabData.__typename,
        containerData.scopeId,
        onRenamingChange
    ]);
    const handleRenameClick = (0, $eJOHy.useCallback)(()=>{
        onRenamingChange?.(true);
    }, [
        onRenamingChange
    ]);
    const handleRenameCancel = (0, $eJOHy.useCallback)(()=>{
        onRenamingChange?.(false);
    }, [
        onRenamingChange
    ]);
    const renderMenu = (0, $eJOHy.useCallback)(({ isOverflowing: isOverflowing, isOpen: isMenuOpen, setIsOpen: setIsMenuOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pPuG.TabMenu), {
            tabFragment: tabData,
            containerFragment: containerData,
            beforeItemId: beforeItemId,
            afterItemId: afterItemId,
            position: tabProps.position,
            isOverflowing: isOverflowing,
            isOpen: isMenuOpen,
            setIsOpen: setIsMenuOpen,
            onRenameClick: handleRenameClick
        }), [
        tabData,
        containerData,
        beforeItemId,
        afterItemId,
        tabProps.position,
        handleRenameClick
    ]);
    if ((0, $7jTnu.fg)('jfp_a11y_team_board_missing_unordered_list_mark-up')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
        className: (0, $hcewu.default)([
            $834c3cdd8897f6b6$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $krCQX.default), {
        name: tabData.label,
        isDraggable: canEdit,
        renderMenu: canEdit ? renderMenu : undefined,
        onRenameComplete: handleRenameComplete,
        onRenameCancel: handleRenameCancel,
        isRenaming: isRenaming,
        ...tabProps,
        ref: ref
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $krCQX.default), {
        name: tabData.label,
        isDraggable: canEdit,
        renderMenu: canEdit ? renderMenu : undefined,
        onRenameComplete: handleRenameComplete,
        onRenameCancel: handleRenameCancel,
        isRenaming: isRenaming,
        ...tabProps,
        ref: ref
    });
});
const $834c3cdd8897f6b6$var$styles = {
    root: "_qtt8glyw _19pkidpf"
};

});
parcelRegister("hFOam", function(module, exports) {

$parcel$export(module.exports, "default", () => $0754684e2cfc0a1f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb585c529bab9cef4749ed2a03ab95a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0754684e2cfc0a1f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabWithMenu_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabMenu_container"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canEdit"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$0754684e2cfc0a1f$var$node.hash = "6224b42f30483a79a7b9e5f35d80a3f9";
var $0754684e2cfc0a1f$export$2e2bcd8739ae039 = $0754684e2cfc0a1f$var$node;

});

parcelRegister("iYUKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $103b0a63003ed2e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f73dd35edcd06ffbb07f82387da33bc8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $103b0a63003ed2e8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabWithMenu_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "label"
            },
            "action": "THROW",
            "path": "label"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "FragmentSpread",
            "name": "TabMenu_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$103b0a63003ed2e8$var$node.hash = "c2661c839237a566a5adce01990a7427";
var $103b0a63003ed2e8$export$2e2bcd8739ae039 = $103b0a63003ed2e8$var$node;

});

parcelRegister("2pPuG", function(module, exports) {

$parcel$export(module.exports, "TabMenu", () => $b16c1f2fb307c705$export$60204bfd6efac94c);

var $iQRAK = parcelRequire("iQRAK");

var $3WseR = parcelRequire("3WseR");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $Ay1uj = parcelRequire("Ay1uj");

var $aLJ1L = parcelRequire("aLJ1L");

var $aMdh8 = parcelRequire("aMdh8");

var $kJsb4 = parcelRequire("kJsb4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $1uv7v = parcelRequire("1uv7v");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $aMOdH = parcelRequire("aMOdH");

var $kGXQU = parcelRequire("kGXQU");

var $gPNjP = parcelRequire("gPNjP");

var $94tqz = parcelRequire("94tqz");

var $2ezIQ = parcelRequire("2ezIQ");

var $bdMqC = parcelRequire("bdMqC");
const $b16c1f2fb307c705$export$60204bfd6efac94c = /*#__PURE__*/ (0, $eJOHy.memo)(({ tabFragment: tabFragment, containerFragment: containerFragment, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, isOverflowing: isOverflowing, isOpen: isOpen, setIsOpen: setIsOpen, onRenameClick: onRenameClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const tabData = (0, $j4oe4.useFragment)((0, $3WseR.default), tabFragment);
    const canRename = Boolean(tabData?.canRename);
    const canRemove = Boolean(tabData?.canRemove);
    const canSetAsDefault = Boolean(tabData?.canSetAsDefault);
    const containerData = (0, $j4oe4.useFragment)((0, $iQRAK.default), containerFragment);
    const toggleMenuOpen = (0, $eJOHy.useCallback)(()=>{
        setIsOpen((isMenuOpen)=>!isMenuOpen);
    }, [
        setIsOpen
    ]);
    const closeMenu = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const handleHideClick = (0, $eJOHy.useCallback)(()=>{
        closeMenu();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'remove',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
    }, [
        closeMenu,
        createAnalyticsEvent,
        tabData.typeKey,
        tabData.appId,
        isOverflowing
    ]);
    const handleSetAsDefault = (0, $eJOHy.useCallback)(()=>{
        closeMenu();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'setAsDefault',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
    }, [
        closeMenu,
        createAnalyticsEvent,
        isOverflowing,
        tabData.appId,
        tabData.typeKey
    ]);
    const handleRenameNavigationItem = (0, $eJOHy.useCallback)(()=>{
        closeMenu();
        onRenameClick?.();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'rename',
            itemType: tabData.typeKey.toLowerCase(),
            isInMore: Boolean(isOverflowing)
        });
    }, [
        closeMenu,
        createAnalyticsEvent,
        isOverflowing,
        onRenameClick,
        tabData.typeKey
    ]);
    const trigger = (triggerProps)=>{
        if (isOverflowing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            ...triggerProps,
            label: formatMessage((0, $gPNjP.default).viewOptions),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))),
            isTooltipDisabled: false,
            tooltip: {
                hideTooltipOnClick: true,
                ...(0, $6XJko.isVisualRefreshEnabled)() && {
                    content: formatMessage((0, $gPNjP.default).moreActionsTooltip)
                }
            },
            onClick: toggleMenuOpen,
            appearance: "subtle",
            spacing: "compact",
            isSelected: isOpen
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMOdH.ThemedIconButton), {
            ...triggerProps,
            label: formatMessage((0, $gPNjP.default).viewOptions),
            icon: (iconProps)=>// @ts-expect-error - TS2322
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                    ...iconProps,
                    color: !isOpen ? (0, $1uv7v.Tokens).COLOR_LINK : undefined
                }),
            isTooltipDisabled: false,
            tooltip: {
                hideTooltipOnClick: true,
                ...(0, $6XJko.isVisualRefreshEnabled)() && {
                    content: formatMessage((0, $gPNjP.default).moreActionsTooltip)
                }
            },
            onClick: toggleMenuOpen,
            appearance: "subtle",
            spacing: "compact",
            isSelected: isOpen
        });
    };
    const hasTopGroup = canSetAsDefault || canRename;
    const hasMiddleGroup = position !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        trigger: trigger,
        isOpen: isOpen,
        onClose: closeMenu,
        placement: isOverflowing ? 'right-start' : 'bottom-start',
        shouldUseCaptureOnOutsideClick: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
                sourceType: (0, $466f60259c330878$export$d1123261ca8831d2),
                sourceName: "navigationKitTabMenu"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $b16c1f2fb307c705$var$containerStyles,
                testId: "navigation-kit-tab-menu.ui.tab-menu-options",
                role: "menu"
            }, hasTopGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, canSetAsDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bdMqC.SetAsDefaultItem), {
                onClick: handleSetAsDefault,
                tabFragment: tabData,
                containerFragment: containerData
            }), canRename && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ezIQ.RenameItem), {
                onClick: handleRenameNavigationItem
            })), hasMiddleGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $94tqz.MoveItem), {
                hasSeparator: hasTopGroup,
                id: tabData?.id,
                dataId: tabData?.__id,
                beforeItemId: beforeItemId,
                afterItemId: afterItemId,
                position: position,
                onClick: closeMenu,
                tabFragment: tabData,
                containerFragment: containerData,
                isOverflowing: isOverflowing
            }), canRemove && !tabData.isDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
                hasSeparator: hasTopGroup || hasMiddleGroup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGXQU.HideItem), {
                onClick: handleHideClick,
                tabFragment: tabData,
                containerFragment: containerData
            }))))
    });
});
const $b16c1f2fb307c705$var$containerStyles = (0, $1DXK0.xcss)({
    minWidth: '124px'
});

});
parcelRegister("iQRAK", function(module, exports) {

$parcel$export(module.exports, "default", () => $95b09e33c23c9f71$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0029a71db40a948fb3ab74f841092485>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95b09e33c23c9f71$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabMenu_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SetAsDefaultItem_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "MoveItem_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "HideItem_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$95b09e33c23c9f71$var$node.hash = "625543c1eef703b320bff9684648acce";
var $95b09e33c23c9f71$export$2e2bcd8739ae039 = $95b09e33c23c9f71$var$node;

});

parcelRegister("3WseR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa38ab1db5d06c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<072e5ef9938dc3c80fac065766eaf6ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8fa38ab1db5d06c6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabMenu_tab",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SetAsDefaultItem_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "MoveItem_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "HideItem_tab"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            "action": "THROW",
            "path": "isDefault"
        },
        {
            "kind": "ScalarField",
            "name": "canRename"
        },
        {
            "kind": "ScalarField",
            "name": "canRemove"
        },
        {
            "kind": "ScalarField",
            "name": "canSetAsDefault"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appId"
                }
            ],
            "type": "JiraAppNavigationItem"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$8fa38ab1db5d06c6$var$node.hash = "c39dc9c76de61cd2fa1248c73d2f808d";
var $8fa38ab1db5d06c6$export$2e2bcd8739ae039 = $8fa38ab1db5d06c6$var$node;

});

parcelRegister("kGXQU", function(module, exports) {

$parcel$export(module.exports, "HideItem", () => $d8ac08d637f44329$export$688a1e0eb1cb83e7);

var $gTDQG = parcelRequire("gTDQG");

var $cuVdf = parcelRequire("cuVdf");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jYYbf = parcelRequire("jYYbf");

var $lRq8t = parcelRequire("lRq8t");

var $31Z3i = parcelRequire("31Z3i");

var $83DiZ = parcelRequire("83DiZ");

var $fhrsC = parcelRequire("fhrsC");

var $gPNjP = parcelRequire("gPNjP");
const $d8ac08d637f44329$export$688a1e0eb1cb83e7 = /*#__PURE__*/ (0, $eJOHy.memo)(({ tabFragment: tabFragment, containerFragment: containerFragment, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hideNavigationItem = (0, $31Z3i.useHideNavigationItem)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { isSelected: isSelected } = (0, $fhrsC.useTabContext)();
    const tabData = (0, $j4oe4.useFragment)((0, $cuVdf.default), tabFragment);
    const containerData = (0, $j4oe4.useFragment)((0, $gTDQG.default), containerFragment);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        onClick();
        if (!containerData.id) return;
        const defaultTabUrl = containerData.navigationItems?.edges?.find((edge)=>edge?.node.isDefault)?.node.url;
        hideNavigationItem({
            id: tabData.id,
            relayId: tabData.__id,
            containerNavigationId: containerData.id,
            onCompleted: ()=>{
                if (defaultTabUrl && isSelected) push(defaultTabUrl);
            }
        });
    }, [
        containerData,
        hideNavigationItem,
        isSelected,
        onClick,
        push,
        tabData.__id,
        tabData.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: handleClick
    }, formatMessage((0, $gPNjP.default).hideItem));
});

});
parcelRegister("gTDQG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f7817f57f5c80ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f2af84d5adc0f9b927b2d6b399dc9e58>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3f7817f57f5c80ff$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "first"
        }
    ],
    "kind": "Fragment",
    "name": "HideItem_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "id"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "navigationItems",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraNavigationItemEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                "action": "THROW",
                                                "path": "navigationItems.edges.node.isDefault"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "navigationItems.edges.node"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$3f7817f57f5c80ff$var$node.hash = "74369dee0c0b32c1011fec3260d7a339";
var $3f7817f57f5c80ff$export$2e2bcd8739ae039 = $3f7817f57f5c80ff$var$node;

});

parcelRegister("cuVdf", function(module, exports) {

$parcel$export(module.exports, "default", () => $14238ee758f0a8d2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62dbb3ecb0a3c1d9aab1d0ea97ab3827>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $14238ee758f0a8d2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "HideItem_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                    },
                    "action": "THROW",
                    "path": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$14238ee758f0a8d2$var$node.hash = "2e58297399f7217bc7b0f7b7efcfd8cc";
var $14238ee758f0a8d2$export$2e2bcd8739ae039 = $14238ee758f0a8d2$var$node;

});

parcelRegister("31Z3i", function(module, exports) {

$parcel$export(module.exports, "useHideNavigationItem", () => $b5ef44e3dce16a41$export$f81bcd521f99d535);

var $9UODH = parcelRequire("9UODH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $4SjAP = parcelRequire("4SjAP");

var $2VUCc = parcelRequire("2VUCc");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8DDYy = parcelRequire("8DDYy");
const $b5ef44e3dce16a41$export$b8b9d90f9e5bd72b = 'jiraNavigationKitHideItemService';
const $b5ef44e3dce16a41$export$6d6eb6668e23e980 = 'hideView';
const $b5ef44e3dce16a41$export$d57b6b390e78d90f = 'Navigation';
const $b5ef44e3dce16a41$export$ab511d8a11c8295c = {
    experience: $b5ef44e3dce16a41$export$6d6eb6668e23e980
};
const $b5ef44e3dce16a41$var$NON_ADMIN_ERROR = 'User is not an admin';
const $b5ef44e3dce16a41$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 401:
            return {
                type: 'error',
                title: (0, $8DDYy.default).userNotLoggedInErrorFlagTitle,
                description: (0, $8DDYy.default).userNotLoggedInErrorFlagDescription,
                messageId: 'horizontal-nav-hide-item-service.services.flag.error.user-not-logged-in-error',
                messageType: 'transactional'
            };
        case 403:
            if (message === $b5ef44e3dce16a41$var$NON_ADMIN_ERROR) return {
                type: 'error',
                title: (0, $8DDYy.default).userNotAdminErrorFlagTitle,
                description: (0, $8DDYy.default).userNotAdminErrorFlagDescription,
                messageId: 'horizontal-nav-hide-item-service.services.flag.error.user-not-admin-error',
                messageType: 'transactional'
            };
            return null;
        case 404:
            return {
                type: 'error',
                title: (0, $8DDYy.default).viewNotFoundErrorFlagTitle,
                description: (0, $8DDYy.default).viewNotFoundErrorFlagDescription,
                messageId: 'horizontal-nav-hide-item-service.services.flag.error.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $b5ef44e3dce16a41$export$f81bcd521f99d535 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const onStartExperience = (0, $8Uqf3.useExperienceStart)({
        ...$b5ef44e3dce16a41$export$ab511d8a11c8295c,
        analyticsSource: $b5ef44e3dce16a41$export$b8b9d90f9e5bd72b
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)($b5ef44e3dce16a41$export$ab511d8a11c8295c);
    const onExperienceFail = (0, $aqnJa.useExperienceFail)($b5ef44e3dce16a41$export$ab511d8a11c8295c);
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $9UODH.default));
    const getAnalyticsTabPosition = (0, $eJOHy.useCallback)((store, response, containerNavigationId)=>{
        if (response?.jira?.deleteNavigationItem == null) return;
        const { success: success, navigationItem: navigationItem } = response.jira.deleteNavigationItem;
        if (!success || navigationItem == null) return;
        const edges = (0, $2VUCc.getStoreEdges)(store, containerNavigationId);
        if (!edges) return undefined;
        const index = edges.findIndex((edge)=>{
            const node = edge?.getLinkedRecord('node');
            return node?.getValue('id') === navigationItem;
        });
        return index === -1 ? undefined : index;
    }, []);
    const updater = (0, $eJOHy.useCallback)((store, response, navigationItemRelayId, containerNavigationId)=>{
        if (response?.jira?.deleteNavigationItem == null) return;
        const { success: success, navigationItem: navigationItem } = response.jira.deleteNavigationItem;
        if (!success || navigationItem == null) return;
        const connectionRecord = (0, $2VUCc.getConnection)(store, containerNavigationId);
        if (!connectionRecord || navigationItemRelayId == null) return;
        (0, $j4oe4.ConnectionHandler).deleteNode(connectionRecord, navigationItemRelayId);
    }, []);
    const onError = (0, $eJOHy.useCallback)((error)=>{
        showFlag({
            messageId: 'horizontal-nav-hide-item-service.services.show-flag.error.hide-navigation-item-default-error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $8DDYy.default).hideNavigationItemDefaultErrorFlagTitle),
            description: formatMessage((0, $8DDYy.default).hideNavigationItemDefaultErrorFlagDescription)
        });
        (0, $gYnSx.default)({
            meta: {
                id: $b5ef44e3dce16a41$export$6d6eb6668e23e980,
                packageName: $b5ef44e3dce16a41$export$b8b9d90f9e5bd72b,
                teamName: $b5ef44e3dce16a41$export$d57b6b390e78d90f
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($b5ef44e3dce16a41$export$b8b9d90f9e5bd72b, error);
    }, [
        formatMessage,
        onExperienceFail,
        showFlag
    ]);
    return (0, $eJOHy.useCallback)(({ id: id, relayId: relayId, onCompleted: onCompleted, containerNavigationId: containerNavigationId })=>{
        if (id == null) return;
        onStartExperience();
        commitMutation({
            variables: {
                input: {
                    id: id
                }
            },
            optimisticResponse: {
                jira: {
                    deleteNavigationItem: {
                        success: true,
                        navigationItem: id,
                        errors: null
                    }
                }
            },
            optimisticUpdater: (store, response)=>{
                updater(store, response, relayId, containerNavigationId);
            },
            updater: (store, response)=>{
                const initialTabOrder = (0, $2VUCc.getAnalyticsTabOrder)(store, containerNavigationId);
                const initialTabPosition = getAnalyticsTabPosition(store, response, containerNavigationId);
                updater(store, response, relayId, containerNavigationId);
                if (response?.jira?.deleteNavigationItem?.success) {
                    const finalTabOrder = (0, $2VUCc.getAnalyticsTabOrder)(store, containerNavigationId);
                    const item = store.get(String(relayId));
                    const itemId = item?.getValue('appId');
                    const itemType = String(item?.getValue('typeKey'));
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectNavigationTabItem updated', {
                        originalItems: initialTabOrder,
                        updatedItems: finalTabOrder,
                        itemType: itemType.toLowerCase(),
                        itemId: itemId && String(itemId),
                        initialTabIndex: initialTabPosition,
                        action: 'removed'
                    });
                }
            },
            onError: onError,
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.deleteNavigationItem ?? {};
                if (errors) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    if (statusCode != null) {
                        const flagDetails = $b5ef44e3dce16a41$var$getFlagDetails(error);
                        if (flagDetails) {
                            showFlag(flagDetails);
                            onExperienceSuccess();
                            return;
                        }
                    }
                    onError(error);
                    return;
                }
                onExperienceSuccess();
                onCompleted();
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        getAnalyticsTabPosition,
        onError,
        onExperienceSuccess,
        onStartExperience,
        showFlag,
        updater
    ]);
};

});
parcelRegister("9UODH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a96b39e280370e31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca421b53344a880082a01ef55ae3298d>>
 * @relayHash 5e42aa4760fa1cda0f65d32ab2e48395
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 414b6dd12c5dd4719aa01c278cbc93efd3c83934596c33f80b7ffc0a13230fdf
const $a96b39e280370e31$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "navigationItem"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesHideNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDeleteNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "deleteNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesHideNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDeleteNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "deleteNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "414b6dd12c5dd4719aa01c278cbc93efd3c83934596c33f80b7ffc0a13230fdf",
            "metadata": {},
            "name": "servicesHideNavigationItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a96b39e280370e31$var$node.hash = "4640fb5e180d56505dbc99767c68be10";
var $a96b39e280370e31$export$2e2bcd8739ae039 = $a96b39e280370e31$var$node;

});

parcelRegister("8DDYy", function(module, exports) {

$parcel$export(module.exports, "default", () => $34fed2114b127169$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $34fed2114b127169$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    hideNavigationItemDefaultErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.hide-navigation-item-default-error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    hideNavigationItemDefaultErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.hide-navigation-item-default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.user-not-admin-error-flag-description",
        "defaultMessage": "You are not allowed to manage the navigation."
    },
    viewNotFoundErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.view-not-found-error-flag-title",
        "defaultMessage": "This tab has been removed"
    },
    viewNotFoundErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.view-not-found-error-flag-description",
        "defaultMessage": "The tab you're trying to remove can't be found."
    }
});

});


parcelRegister("gPNjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $61182f7da054364f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $61182f7da054364f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewOptions: {
        "id": "navigation-kit-tab-menu.view-options",
        "defaultMessage": "Tab options"
    },
    setAsDefaultView: {
        "id": "navigation-kit-tab-menu.set-as-default-item.set-as-default-view",
        "defaultMessage": "Set as default"
    },
    selected: {
        "id": "navigation-kit-tab-menu.set-as-default-item.selected",
        "defaultMessage": "Selected"
    },
    renameItem: {
        "id": "navigation-kit-tab-menu.rename-item.rename-item",
        "defaultMessage": "Rename"
    },
    moveItemRight: {
        "id": "navigation-kit-tab-menu.move-item.move-item-right",
        "defaultMessage": "Move tab right"
    },
    moveItemDown: {
        "id": "navigation-kit-tab-menu.move-item.move-item-down",
        "defaultMessage": "Move tab down"
    },
    moveItemLeft: {
        "id": "navigation-kit-tab-menu.move-item.move-item-left",
        "defaultMessage": "Move tab left"
    },
    moveItemUp: {
        "id": "navigation-kit-tab-menu.move-item.move-item-up",
        "defaultMessage": "Move tab up"
    },
    hideItem: {
        "id": "navigation-kit-tab-menu.hide-item.hide-item",
        "defaultMessage": "Remove"
    },
    moreActionsTooltip: {
        "id": "navigation-kit-tab-menu.more-actions-tooltip",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("94tqz", function(module, exports) {

$parcel$export(module.exports, "MoveItem", () => $bc8e1989fbc9d557$export$c684f623a254a5c0);

var $8GAqf = parcelRequire("8GAqf");

var $h6WTo = parcelRequire("h6WTo");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $8Uqf3 = parcelRequire("8Uqf3");

var $lRq8t = parcelRequire("lRq8t");

var $5EEmv = parcelRequire("5EEmv");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $gPNjP = parcelRequire("gPNjP");
const $bc8e1989fbc9d557$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $bc8e1989fbc9d557$export$f1e608dba99fa330 = {
    experience: 'reorderView'
};
const $bc8e1989fbc9d557$export$c684f623a254a5c0 = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, dataId: dataId, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, hasSeparator: hasSeparator, onClick: onClick, isOverflowing: isOverflowing, tabFragment: tabFragment, containerFragment: containerFragment })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [rankNavigationItem] = (0, $5EEmv.useRankNavigationItem)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onStartExperience = (0, $8Uqf3.useExperienceStart)({
        ...$bc8e1989fbc9d557$export$f1e608dba99fa330,
        analyticsSource: $bc8e1989fbc9d557$export$b8b9d90f9e5bd72b
    });
    const tabData = (0, $j4oe4.useFragment)((0, $h6WTo.default), tabFragment);
    const containerData = (0, $j4oe4.useFragment)((0, $8GAqf.default), containerFragment);
    const handleMoveAfter = (0, $eJOHy.useCallback)(()=>{
        if (!containerData.id || !containerData.scopeId || id.includes('optimisticId') || afterItemId && afterItemId.includes('optimisticId')) return;
        onClick();
        onStartExperience();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'moveTabAfter',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
        rankNavigationItem({
            placement: 'after',
            sourceTabIndex: position,
            targetTabIndex: position + 1,
            id: id,
            afterItemId: afterItemId,
            dataId: dataId,
            actionType: 'clicked',
            containerNavigationId: containerData.id,
            scopeId: containerData.scopeId
        });
    }, [
        containerData.id,
        containerData.scopeId,
        id,
        afterItemId,
        onClick,
        onStartExperience,
        createAnalyticsEvent,
        tabData.typeKey,
        tabData.appId,
        isOverflowing,
        rankNavigationItem,
        position,
        dataId
    ]);
    const handleMoveBefore = (0, $eJOHy.useCallback)(()=>{
        if (!containerData.id || !containerData.scopeId || id.includes('optimisticId') || beforeItemId && beforeItemId.includes('optimisticId')) return;
        onClick();
        onStartExperience();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'moveTabBefore',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
        rankNavigationItem({
            placement: 'before',
            sourceTabIndex: position,
            targetTabIndex: position - 1,
            id: id,
            beforeItemId: beforeItemId,
            dataId: dataId,
            actionType: 'clicked',
            containerNavigationId: containerData.id,
            scopeId: containerData.scopeId
        });
    }, [
        containerData.id,
        containerData.scopeId,
        id,
        beforeItemId,
        onClick,
        onStartExperience,
        createAnalyticsEvent,
        tabData.typeKey,
        tabData.appId,
        isOverflowing,
        rankNavigationItem,
        position,
        dataId
    ]);
    if (!beforeItemId && !afterItemId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), {
        hasSeparator: hasSeparator
    }, beforeItemId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: handleMoveBefore
    }, formatMessage(isOverflowing ? (0, $gPNjP.default).moveItemUp : (0, $gPNjP.default).moveItemLeft)), afterItemId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: handleMoveAfter
    }, formatMessage(isOverflowing ? (0, $gPNjP.default).moveItemDown : (0, $gPNjP.default).moveItemRight)));
});

});
parcelRegister("8GAqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7623905dcdb3f5b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<796de95e3150e72ab27c741f11b1c768>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c7623905dcdb3f5b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "MoveItem_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$c7623905dcdb3f5b$var$node.hash = "f9f8b1902c6acb52496479dc02bba4da";
var $c7623905dcdb3f5b$export$2e2bcd8739ae039 = $c7623905dcdb3f5b$var$node;

});

parcelRegister("h6WTo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d69b03d0cd629ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2bb075609682cd75d024794aaeeb0bd3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2d69b03d0cd629ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "MoveItem_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appId"
                }
            ],
            "type": "JiraAppNavigationItem"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$2d69b03d0cd629ea$var$node.hash = "d80f30b8a83df095fbc3f7cdf31473c5";
var $2d69b03d0cd629ea$export$2e2bcd8739ae039 = $2d69b03d0cd629ea$var$node;

});


parcelRegister("2ezIQ", function(module, exports) {

$parcel$export(module.exports, "RenameItem", () => $ccb5e3576b4f8303$export$ee728c052485c654);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $lRq8t = parcelRequire("lRq8t");

var $gPNjP = parcelRequire("gPNjP");
const $ccb5e3576b4f8303$export$ee728c052485c654 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: onClick
    }, formatMessage((0, $gPNjP.default).renameItem));
});

});

parcelRegister("bdMqC", function(module, exports) {

$parcel$export(module.exports, "SetAsDefaultItem", () => $29681cf36df36a70$export$93c39ca6fde4b432);

var $awYd0 = parcelRequire("awYd0");

var $egMi9 = parcelRequire("egMi9");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jYYbf = parcelRequire("jYYbf");

var $entZ3 = parcelRequire("entZ3");

var $lRq8t = parcelRequire("lRq8t");

var $azusY = parcelRequire("azusY");

var $gPNjP = parcelRequire("gPNjP");
const $29681cf36df36a70$export$93c39ca6fde4b432 = /*#__PURE__*/ (0, $eJOHy.memo)(({ tabFragment: tabFragment, containerFragment: containerFragment, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { setAsDefault: setAsDefault } = (0, $azusY.useSetAsDefault)();
    const { id: id, __id: __id, isDefault: isDefault } = (0, $j4oe4.useFragment)((0, $egMi9.default), tabFragment);
    const containerData = (0, $j4oe4.useFragment)((0, $awYd0.default), containerFragment);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        if (containerData.id && !isDefault) {
            setAsDefault({
                id: id,
                __id: __id,
                containerNavigationId: containerData.id,
                scopeId: containerData?.scopeId
            });
            onClick?.();
        }
    }, [
        isDefault,
        setAsDefault,
        id,
        __id,
        containerData?.id,
        containerData?.scopeId,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: handleClick,
        elemAfter: isDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($entZ3))), {
            spacing: "spacious",
            label: formatMessage((0, $gPNjP.default).selected),
            color: "var(--ds-icon-selected, #0C66E4)"
        })
    }, formatMessage((0, $gPNjP.default).setAsDefaultView));
});

});
parcelRegister("awYd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3275ca3656190b6c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47d7fcf1f10547547ad3a73ed397c318>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3275ca3656190b6c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SetAsDefaultItem_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$3275ca3656190b6c$var$node.hash = "656aa8c184c3ae35259916ec5158b9d3";
var $3275ca3656190b6c$export$2e2bcd8739ae039 = $3275ca3656190b6c$var$node;

});

parcelRegister("egMi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bb66f8f0ccbce42$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f725fd96c7a7e106c21843ce289a0e68>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0bb66f8f0ccbce42$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SetAsDefaultItem_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            "action": "THROW",
            "path": "isDefault"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                    },
                    "action": "THROW",
                    "path": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$0bb66f8f0ccbce42$var$node.hash = "88982584cb03f7a8362df915df0c2838";
var $0bb66f8f0ccbce42$export$2e2bcd8739ae039 = $0bb66f8f0ccbce42$var$node;

});

parcelRegister("azusY", function(module, exports) {

$parcel$export(module.exports, "useSetAsDefault", () => $5094f1c86cbf89ca$export$5b2c06a7e56f39a8);

var $i9TCD = parcelRequire("i9TCD");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $kqd31 = parcelRequire("kqd31");

var $8oKDI = parcelRequire("8oKDI");

var $2VUCc = parcelRequire("2VUCc");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $4SjAP = parcelRequire("4SjAP");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");


var $2E1Ud = parcelRequire("2E1Ud");
const $5094f1c86cbf89ca$var$VIEW_NOT_DEFAULTABLE_ERROR = 'View type is not defaultable';
const $5094f1c86cbf89ca$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $2E1Ud.default).setAsDefaultErrorFlagTitle,
    description: (0, $2E1Ud.default).setAsDefaultErrorFlagDescription,
    messageId: 'horizontal-nav-tab-menu.services.set-as-default.default-error-flag.error.flag.default-error',
    messageType: 'transactional'
};
const $5094f1c86cbf89ca$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 400:
            if (message === $5094f1c86cbf89ca$var$VIEW_NOT_DEFAULTABLE_ERROR) return {
                type: 'error',
                title: (0, $2E1Ud.default).viewNotDefaultableErrorFlagTitle,
                description: (0, $2E1Ud.default).viewNotDefaultableErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.view-not-defaultable-error',
                messageType: 'transactional'
            };
            return null;
        case 401:
            return {
                type: 'error',
                title: (0, $2E1Ud.default).userNotLoggedInErrorFlagTitle,
                description: (0, $2E1Ud.default).userNotLoggedInErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.user-not-logged-in-error',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: 'error',
                title: (0, $2E1Ud.default).userNotAdminErrorFlagTitle,
                description: (0, $2E1Ud.default).userNotAdminErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.user-not-admin-error',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: 'error',
                title: (0, $2E1Ud.default).viewNotFoundErrorFlagTitle,
                description: (0, $2E1Ud.default).viewNotFoundErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $5094f1c86cbf89ca$export$b8b9d90f9e5bd72b = 'jiraNavigationKitTabMenu';
const $5094f1c86cbf89ca$export$c028e73dc12a34c5 = 'setAsDefaultView';
const $5094f1c86cbf89ca$export$f444706ea2b317f8 = {
    experience: $5094f1c86cbf89ca$export$c028e73dc12a34c5
};
const $5094f1c86cbf89ca$export$5b2c06a7e56f39a8 = ()=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onStartExperience = (0, $8Uqf3.useExperienceStart)({
        ...$5094f1c86cbf89ca$export$f444706ea2b317f8,
        analyticsSource: $5094f1c86cbf89ca$export$b8b9d90f9e5bd72b
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)($5094f1c86cbf89ca$export$f444706ea2b317f8);
    const onExperienceFail = (0, $aqnJa.useExperienceFail)($5094f1c86cbf89ca$export$f444706ea2b317f8);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $i9TCD.default));
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        showFlag($5094f1c86cbf89ca$var$DEFAULT_ERROR_FLAG);
        (0, $gYnSx.default)({
            meta: {
                id: $5094f1c86cbf89ca$export$c028e73dc12a34c5,
                packageName: $5094f1c86cbf89ca$export$b8b9d90f9e5bd72b,
                teamName: (0, $088421d32325967f$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($5094f1c86cbf89ca$export$b8b9d90f9e5bd72b, error);
    }, [
        onExperienceFail,
        showFlag
    ]);
    const setAsDefault = (0, $eJOHy.useCallback)(({ id: id, __id: __id, containerNavigationId: containerNavigationId, scopeId: scopeId })=>{
        let initialTabOrder = [];
        onStartExperience();
        commitMutation({
            variables: {
                input: {
                    id: id,
                    scopeId: scopeId
                }
            },
            optimisticUpdater: (store)=>{
                initialTabOrder = (0, $2VUCc.getAnalyticsTabOrder)(store, containerNavigationId);
                const edges = (0, $2VUCc.getStoreEdges)(store, containerNavigationId);
                if (!edges) return;
                edges.forEach((edge)=>{
                    const node = edge?.getLinkedRecord('node');
                    if (node?.getValue('isDefault') === true && node?.getValue('id') !== id) node.setValue(false, 'isDefault');
                    if (node?.getValue('id') === id) node?.setValue(true, 'isDefault');
                });
            },
            updater: (store, response)=>{
                const newDefaultRecord = store.get(__id);
                if (response?.jira?.setDefaultNavigationItem?.success) {
                    if (scopeId) {
                        const ariConfig = (0, $8oKDI.getAriConfig)(scopeId);
                        const scopeType = ariConfig.resourceType === 'board' ? 'JiraBoard' : 'JiraProject';
                        const scopeRelayId = (0, $kqd31.default)({
                            id: scopeId
                        }, scopeType);
                        if (scopeRelayId && newDefaultRecord) {
                            const scopeRecord = store.get(scopeRelayId);
                            scopeRecord?.setLinkedRecord(newDefaultRecord, 'defaultNavigationItem');
                        }
                    }
                    const finalTabOrder = (0, $2VUCc.getAnalyticsTabOrder)(store, containerNavigationId);
                    const itemId = newDefaultRecord?.getValue('appId');
                    (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectNavigationTabItem updated', {
                        originalItems: initialTabOrder,
                        updatedItems: finalTabOrder,
                        itemType: String(newDefaultRecord?.getValue('typeKey')).toLowerCase(),
                        itemId: itemId && String(itemId).toLowerCase(),
                        action: 'setAsDefault'
                    });
                }
            },
            onCompleted: (result)=>{
                const { success: success, newDefault: newDefault, errors: errors } = result?.jira?.setDefaultNavigationItem ?? {};
                if (success && newDefault && !errors) {
                    showFlag({
                        messageId: 'horizontal-nav-tab-menu.services.set-as-default.show-flag.success.flag.success',
                        messageType: 'transactional',
                        type: 'success',
                        title: formatMessage((0, $2E1Ud.default).setAsDefaultSuccessFlagTitle, {
                            viewName: newDefault.label
                        }),
                        description: formatMessage((0, $2E1Ud.default).setAsDefaultSuccessFlagDescription, {
                            viewName: newDefault.label
                        })
                    });
                    onExperienceSuccess();
                    return;
                }
                if (errors) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    if (statusCode != null) {
                        const flagDetails = $5094f1c86cbf89ca$var$getFlagDetails(error);
                        if (flagDetails) {
                            showFlag(flagDetails);
                            onExperienceSuccess();
                            return;
                        }
                    }
                    handleError(error);
                }
            },
            onError: (error)=>handleError(error)
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        formatMessage,
        handleError,
        onExperienceSuccess,
        onStartExperience,
        showFlag
    ]);
    return {
        setAsDefault: setAsDefault
    };
};

});
parcelRegister("i9TCD", function(module, exports) {

$parcel$export(module.exports, "default", () => $32ab1c807698b441$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d61d252896575ea2884d483ecd96119>>
 * @relayHash 1cdf55f994a6939963be94479cc21daf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 872712d044652e051fd8469f058c446a98f4a24a673c90d4f0a276d049ce2128
const $32ab1c807698b441$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isDefault"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setAsDefaultItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetDefaultNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "setDefaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "newDefault",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "previousDefault",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setAsDefaultItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetDefaultNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "setDefaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "newDefault",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "previousDefault",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "872712d044652e051fd8469f058c446a98f4a24a673c90d4f0a276d049ce2128",
            "metadata": {},
            "name": "setAsDefaultItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$32ab1c807698b441$var$node.hash = "bcaaa14d2f29d8020f8238f6031efdc3";
var $32ab1c807698b441$export$2e2bcd8739ae039 = $32ab1c807698b441$var$node;

});

const $088421d32325967f$export$d57b6b390e78d90f = 'Navigation';

parcelRegister("2E1Ud", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ae24f0445fd8ce$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f3ae24f0445fd8ce$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    setAsDefaultSuccessFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-success-flag-title",
        "defaultMessage": "{viewName} set as default view"
    },
    setAsDefaultSuccessFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-success-flag-description",
        "defaultMessage": "{viewName} will be the default view for everyone."
    },
    setAsDefaultErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    setAsDefaultErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to set this view as default. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-admin-error-flag-description",
        "defaultMessage": "You are not allowed to manage the navigation."
    },
    viewNotDefaultableErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-defaultable-error-flag-title",
        "defaultMessage": "Choose a different default view"
    },
    viewNotDefaultableErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-defaultable-error-flag-description",
        "defaultMessage": "You can only set the summary, board, list, calendar, or timeline as the default view."
    },
    viewNotFoundErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-found-error-flag-title",
        "defaultMessage": "This view tab been removed"
    },
    viewNotFoundErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-found-error-flag-description",
        "defaultMessage": "The tab you're trying to set as default can't be found."
    }
});

});




parcelRegister("5Ag6K", function(module, exports) {

$parcel$export(module.exports, "useRenameNavigationItem", () => $72c2bae31e358c5a$export$881d234560f027b5);

var $lhFVX = parcelRequire("lhFVX");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $bILK0 = parcelRequire("bILK0");

var $4SjAP = parcelRequire("4SjAP");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");


var $eTMmj = parcelRequire("eTMmj");
const $72c2bae31e358c5a$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $eTMmj.default).defaultErrorFlagTitle,
    description: (0, $eTMmj.default).defaultErrorFlagDescription,
    messageType: 'transactional',
    messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag.error.horizontal-nav-tab-menu-rename-navigation-item-default-error'
};
const $72c2bae31e358c5a$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 400:
        case 404:
            return {
                type: 'error',
                title: (0, $eTMmj.default).defaultErrorFlagTitle,
                description: message,
                messageType: 'transactional',
                messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.flag.error.horizontal-nav-tab-menu-rename-navigation-item-request-error'
            };
        case 401:
            return {
                type: 'error',
                title: (0, $eTMmj.default).userNotLoggedInErrorFlagTitle,
                description: (0, $eTMmj.default).userNotLoggedInErrorFlagDescription,
                messageType: 'transactional',
                messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.flag.error.horizontal-nav-tab-menu-rename-navigation-item-not-logged-in-error'
            };
        case 403:
            return {
                type: 'error',
                title: (0, $eTMmj.default).userNotAdminErrorFlagTitle,
                description: (0, $eTMmj.default).userNotAdminErrorFlagDescription,
                messageType: 'transactional',
                messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.flag.error.horizontal-nav-tab-menu-rename-navigation-item-not-admin-error'
            };
        default:
            return null;
    }
};
const $72c2bae31e358c5a$export$881d234560f027b5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $lhFVX.default));
    const onError = (0, $eJOHy.useCallback)((error)=>{
        showFlag($72c2bae31e358c5a$var$DEFAULT_ERROR_FLAG);
        (0, $gYnSx.default)({
            meta: {
                id: 'renameNavigationItem',
                packageName: 'jiraHorizontalNavTabMenu',
                teamName: (0, $088421d32325967f$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        showFlag
    ]);
    return (0, $eJOHy.useCallback)(({ id: id, label: label, scopeId: scopeId, typeKey: typeKey, __typename: __typename })=>{
        commitMutation({
            variables: {
                input: {
                    id: id,
                    label: label,
                    scopeId: scopeId
                }
            },
            optimisticResponse: {
                jira: {
                    renameNavigationItem: {
                        success: true,
                        errors: null,
                        navigationItem: {
                            __typename: __typename,
                            label: label,
                            id: id
                        }
                    }
                }
            },
            onError: onError,
            onCompleted: (response)=>{
                if (response?.jira?.renameNavigationItem?.success === true) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'navigationItem renamed', {
                    typeKey: typeKey
                });
                else {
                    const firstError = response?.jira?.renameNavigationItem?.errors?.[0] ?? new Error('Unknown error');
                    const error = new (0, $4SjAP.MutationError)(firstError);
                    const flagDetails = $72c2bae31e358c5a$var$getFlagDetails(error);
                    if (flagDetails) {
                        showFlag(flagDetails);
                        return;
                    }
                    onError(error);
                }
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        onError,
        showFlag
    ]);
};

});
parcelRegister("lhFVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc84cd278c0c6f7a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fac2ccbfb6948585efd00ec262359df8>>
 * @relayHash 08ee531ee69dd70fba8cb7fc363431a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 271fc93bc9fd489bc0676a5a66d01039bb9f930387ee55b1ad3f33ebcee271eb
const $dc84cd278c0c6f7a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "label"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "renameNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRenameNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "renameNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "navigationItem",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "renameNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRenameNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "renameNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "navigationItem",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "271fc93bc9fd489bc0676a5a66d01039bb9f930387ee55b1ad3f33ebcee271eb",
            "metadata": {},
            "name": "renameNavigationItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$dc84cd278c0c6f7a$var$node.hash = "89c71efe0597e03c9897cee5d89d8941";
var $dc84cd278c0c6f7a$export$2e2bcd8739ae039 = $dc84cd278c0c6f7a$var$node;

});

parcelRegister("eTMmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2134b0385f562121$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2134b0385f562121$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    defaultErrorFlagTitle: {
        "id": "jira-horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag-title",
        "defaultMessage": "We couldn't update the view name"
    },
    defaultErrorFlagDescription: {
        "id": "jira-horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to rename this view. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-admin-error-flag-description",
        "defaultMessage": "You are not allowed to rename views."
    }
});

});




parcelRegister("7W7dr", function(module, exports) {

$parcel$export(module.exports, "AppTab", () => $3c8664aa0985de2f$export$fca347df63cfad2c);

var $aCH9l = parcelRequire("aCH9l");

var $8sMU4 = parcelRequire("8sMU4");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cGvTS = parcelRequire("cGvTS");

var $l7wEr = parcelRequire("l7wEr");




var $iyTaR = parcelRequire("iyTaR");

var $dkxmE = parcelRequire("dkxmE");

var $cvetd = parcelRequire("cvetd");

var $hxMJd = parcelRequire("hxMJd");

var $aHvyO = parcelRequire("aHvyO");
const $3c8664aa0985de2f$export$fca347df63cfad2c = ({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, beforeItemId: beforeItemId, afterItemId: afterItemId })=>{
    const webItemRef = (0, $eJOHy.useRef)(null);
    const tabData = (0, $j4oe4.useFragment)((0, $8sMU4.default), tabFragment);
    const containerData = (0, $j4oe4.useFragment)((0, $aCH9l.default), containerFragment);
    const triggerAnalytics = (0, $l7wEr.useNavigationItemAnalytics)((0, $eJOHy.useMemo)(()=>({
            itemType: 'app',
            itemId: tabData.appId ?? '',
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage,
            navigationLayer: (0, $002870cfa80d64f4$export$33d8c916a600c5e9),
            navigationContainer: (0, $95eb6070d868c1b7$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), [
        tabData.appId
    ]));
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        if (tabData.styleClass) {
            (0, $cGvTS.withConnectHost)((connectHost)=>{
                if (webItemRef.current && tabData.url) connectHost.triggerWebItem(webItemRef.current, tabData.styleClass ?? '', tabData.url);
            });
            if ((0, $cGvTS.isConnectDialogWebItem)(tabData.styleClass)) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
        triggerAnalytics();
    }, [
        tabData.styleClass,
        tabData.url,
        triggerAnalytics
    ]);
    if (tabData.sections && tabData.sections.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cvetd.AppTabMenu), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dkxmE.default), {
            url: tabData.iconUrl || '',
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hxMJd.AppEnvLozenge), {
            label: tabData.envLabel || ''
        }),
        tabFragment: tabData,
        containerFragment: containerData,
        testId: `horizontal-nav.app-tab.${tabData.label}`,
        position: position,
        onClick: triggerAnalytics,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aHvyO.TabWithMenu), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dkxmE.default), {
            url: tabData.iconUrl || '',
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hxMJd.AppEnvLozenge), {
            label: tabData.envLabel || ''
        }),
        href: tabData.url,
        tabFragment: tabData,
        containerFragment: containerData,
        onClick: onClick,
        testId: `horizontal-nav.app-tab.${tabData.label}`,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        position: position,
        type: "router-link",
        ref: webItemRef
    });
};
var $3c8664aa0985de2f$export$2e2bcd8739ae039 = $3c8664aa0985de2f$export$fca347df63cfad2c;

});
parcelRegister("aCH9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $45825d74060d0154$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7f951b0c8c256682bae1d46d09e2cf2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45825d74060d0154$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "AppTabMenu_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$45825d74060d0154$var$node.hash = "8257e51a0537d2533d3cb266fbb85918";
var $45825d74060d0154$export$2e2bcd8739ae039 = $45825d74060d0154$var$node;

});

parcelRegister("8sMU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfd2f3b3c35ea6b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28152e0fd82463bb04d925e467b2c53c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bfd2f3b3c35ea6b8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "AppTab_tab",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "TabWithMenu_tab"
            },
            {
                "kind": "FragmentSpread",
                "name": "AppTabMenu_tab"
            },
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "label"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "url"
                },
                "action": "THROW",
                "path": "url"
            },
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            {
                "kind": "ScalarField",
                "name": "styleClass"
            },
            {
                "kind": "ScalarField",
                "name": "envLabel"
            },
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$bfd2f3b3c35ea6b8$var$node.hash = "93b2820577820b8e46d082f49f2dc9ff";
var $bfd2f3b3c35ea6b8$export$2e2bcd8739ae039 = $bfd2f3b3c35ea6b8$var$node;

});

parcelRegister("cGvTS", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $48374095cc5f91cb$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $48374095cc5f91cb$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $48374095cc5f91cb$export$920fb4b46d4f2eec);

var $tTBSc = parcelRequire("tTBSc");
const $48374095cc5f91cb$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $tTBSc.setupConnectJs)();
    action(connectHost);
};
const $48374095cc5f91cb$export$186d423c00af146c = ()=>window.connectHost;
const $48374095cc5f91cb$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("tTBSc", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $c81546dab89b45de$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
var $4T9yL = parcelRequire("4T9yL");

var $4ayON = parcelRequire("4ayON");

const $c81546dab89b45de$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $4T9yL.waitForHeritage)();
    await (0, $4ayON.waitForJQuery)();
    const loader = await (parcelRequire("gGHED"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $c81546dab89b45de$var$installConnectJsPromise = null;
const $c81546dab89b45de$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($c81546dab89b45de$var$installConnectJsPromise === null) $c81546dab89b45de$var$installConnectJsPromise = $c81546dab89b45de$var$installConnectJs();
        return $c81546dab89b45de$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $gjeS9.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("gjeS9", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $b5b36a00cf4f19d9$export$df8409da353bde5a);

var $ej5JA = parcelRequire("ej5JA");
var $1HTZw = parcelRequire("1HTZw");
var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");

var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");
var $ligZL = parcelRequire("ligZL");
var $jb3ni = parcelRequire("jb3ni");
const $b5b36a00cf4f19d9$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $ej5JA.MAX_RETRIES), timeout: timeout = (0, $ej5JA.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $97BGz.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $1HTZw.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $agkbU.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("ej5JA", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $98246445188fd0a7$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $98246445188fd0a7$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $98246445188fd0a7$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $98246445188fd0a7$export$37f20f0ff732fcd7);

var $eSnSE = parcelRequire("eSnSE");
const { safeErrorWithoutCustomerData: $98246445188fd0a7$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $98246445188fd0a7$export$ea810ce67e3c8eac } = (0, $eSnSE.default);
const $98246445188fd0a7$export$1f86472c1374185a = 40;
const $98246445188fd0a7$export$7bd623b29ec8e1eb = 500;
const $98246445188fd0a7$export$37f20f0ff732fcd7 = true;

});

parcelRegister("1HTZw", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $d7bbb28cab06ad5d$export$a036f92c2465504e);

var $4Uno7 = parcelRequire("4Uno7");

var $ej5JA = parcelRequire("ej5JA");
const $d7bbb28cab06ad5d$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $ej5JA.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $4Uno7.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $4Uno7.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("4Uno7", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $d05d3ad813870ea5$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d05d3ad813870ea5$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("agkbU", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $224e973e4c93da11$export$20c32b4579d78b92);

var $1HTZw = parcelRequire("1HTZw");

var $iyT45 = parcelRequire("iyT45");

var $ej5JA = parcelRequire("ej5JA");
const $224e973e4c93da11$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $ej5JA.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $iyT45.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $1HTZw.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("iyT45", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $f6004e9afa2128c3$export$3cefda82396756a1);

var $6M1XZ = parcelRequire("6M1XZ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $f6004e9afa2128c3$var$pollingSingleton = null;
const $f6004e9afa2128c3$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $f6004e9afa2128c3$var$pollingSingleton ?? (0, $6M1XZ.createPollingCollection)((v)=>window.require(v), 100);
    $f6004e9afa2128c3$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("6M1XZ", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $0a667df7ad6c937e$export$f163446a982a8077);

var $gRw8I = parcelRequire("gRw8I");

var $2oJXr = parcelRequire("2oJXr");
const $0a667df7ad6c937e$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gRw8I.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $2oJXr.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $2oJXr.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("2oJXr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7015c609345acf$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $3b7015c609345acf$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $3b7015c609345acf$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("97BGz", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $32e00fb40c944769$export$eba600d28decc4ac);

var $bXaxC = parcelRequire("bXaxC");

var $agkbU = parcelRequire("agkbU");

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $32e00fb40c944769$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR) })=>{
    (0, $bXaxC.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $7rBE0.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $agkbU.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("bXaxC", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $f1ca263307f66278$export$9ea3ff7978093559);
const $f1ca263307f66278$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $f1ca263307f66278$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $f1ca263307f66278$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $f1ca263307f66278$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $f1ca263307f66278$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f1ca263307f66278$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $f1ca263307f66278$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $f1ca263307f66278$var$initStats();
        // stop accumulating stats at TTI mark
        if ($f1ca263307f66278$var$isPageInteractive()) return;
        stats.requests += 1;
        $f1ca263307f66278$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$f1ca263307f66278$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $f1ca263307f66278$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("7rBE0", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $09f989d08b38b1cb$export$6cda16b6eff75f59);

var $4Uno7 = parcelRequire("4Uno7");

var $b6X3x = parcelRequire("b6X3x");

var $iyT45 = parcelRequire("iyT45");

var $ej5JA = parcelRequire("ej5JA");
const $09f989d08b38b1cb$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $iyT45.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $b6X3x.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $ej5JA.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $4Uno7.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("b6X3x", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $aa5ee41b24db8c96$export$93d9db5fbabad1b0);

var $avFP5 = parcelRequire("avFP5");
let $aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded = false;
const $aa5ee41b24db8c96$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $aa5ee41b24db8c96$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded || $aa5ee41b24db8c96$var$isOnRapidBoardsPage()) return wrmKeys;
    $aa5ee41b24db8c96$var$isSuperBatchDependenciesLoaded = true;
    return (0, $avFP5.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("avFP5", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $00f9be664c96bf5d$export$f14a6b583ce9e077);
const $00f9be664c96bf5d$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("4T9yL", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $ba1950b07a7f2989$export$c61060338d026f78);

var $hpZoI = parcelRequire("hpZoI");

var $2oJXr = parcelRequire("2oJXr");
const $ba1950b07a7f2989$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $2oJXr.default)();
        (0, $hpZoI.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("hpZoI", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $027e7c56f31b7541$export$d001f71dd306cb0c);

var $1Ozm9 = parcelRequire("1Ozm9");

var $4Uno7 = parcelRequire("4Uno7");

var $gYnSx = parcelRequire("gYnSx");
const $027e7c56f31b7541$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $027e7c56f31b7541$var$fetchSpaWrmContext = async ()=>{
    return (0, $1Ozm9.default)($027e7c56f31b7541$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $027e7c56f31b7541$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $027e7c56f31b7541$var$hasWrmInitialised;
const $027e7c56f31b7541$var$runBootstrap = ()=>{
    const spaWrmContext = $027e7c56f31b7541$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($027e7c56f31b7541$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $gYnSx.default)({
                error: new Error((0, $4Uno7.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $027e7c56f31b7541$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($027e7c56f31b7541$var$hasWrmInitialised) return $027e7c56f31b7541$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $027e7c56f31b7541$var$hasWrmInitialised = Promise.resolve();
    else $027e7c56f31b7541$var$hasWrmInitialised = $027e7c56f31b7541$var$runBootstrap();
    return $027e7c56f31b7541$var$hasWrmInitialised;
};

});


parcelRegister("ligZL", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $cfd4a2a9e13f6c24$export$cc9d8f51375ef66a);

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $cfd4a2a9e13f6c24$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR))=>(0, $7rBE0.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("jb3ni", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $4b0178a6bf26b876$export$e53a5db19a39ed2f);

var $7rBE0 = parcelRequire("7rBE0");

var $ej5JA = parcelRequire("ej5JA");
const $4b0178a6bf26b876$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $ej5JA.SHOULD_LOG_ERROR))=>(0, $7rBE0.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("4ayON", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $3de54a49c8727908$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $3de54a49c8727908$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $3de54a49c8727908$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $3de54a49c8727908$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $3de54a49c8727908$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $3de54a49c8727908$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $3de54a49c8727908$export$d690da9bc8146677);

var $gYnSx = parcelRequire("gYnSx");

const $3de54a49c8727908$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $3de54a49c8727908$export$7232a6dc780f9887 = ()=>AJS.$;
const $3de54a49c8727908$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public @atlassian/atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $3de54a49c8727908$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $3de54a49c8727908$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $3de54a49c8727908$var$FIVE_MINUTES = 300000;
const $3de54a49c8727908$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $gYnSx.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $3de54a49c8727908$var$FIVE_MINUTES);
    });
const $3de54a49c8727908$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $3de54a49c8727908$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $3de54a49c8727908$export$d690da9bc8146677 = [
    $3de54a49c8727908$export$cb954c21735b28e4,
    $3de54a49c8727908$export$7315c38dc71bd41f
];

});

parcelRegister("gGHED", function(module, exports) {

let $c2626e7263c90c87$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c2626e7263c90c87$var$load("kwvFG").then(()=>parcelRequire('jh0iZ'));

});



parcelRegister("dkxmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d6eba6bf3271873$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $f9wiC = parcelRequire("f9wiC");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9d6eba6bf3271873$var$AppIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.size === 'small' ? "_1bsbpxbi" : "_1bsbv47k",
            __cmplp.size === 'small' ? "_4t3ipxbi" : "_4t3iv47k",
            __cmplp.className
        ])
    });
});
const $9d6eba6bf3271873$var$AppItemIcon = ({ url: url, size: size })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9d6eba6bf3271873$var$AppIcon, {
        src: url,
        alt: "",
        size: size
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f9wiC))), {
        label: "",
        spacing: size === 'small' ? 'none' : 'spacious',
        color: "currentColor",
        LEGACY_size: size
    });
var $9d6eba6bf3271873$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($9d6eba6bf3271873$var$AppItemIcon);

});

parcelRegister("cvetd", function(module, exports) {

$parcel$export(module.exports, "AppTabMenu", () => $acb2619b4f7a40d7$export$ab6e213c275a503b);

var $dpBSe = parcelRequire("dpBSe");

var $hbNQU = parcelRequire("hbNQU");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $f58rc = parcelRequire("f58rc");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $cGvTS = parcelRequire("cGvTS");

var $l7wEr = parcelRequire("l7wEr");

var $6fFb3 = parcelRequire("6fFb3");




var $iyTaR = parcelRequire("iyTaR");

var $fhrsC = parcelRequire("fhrsC");

var $cNe2t = parcelRequire("cNe2t");

var $aHvyO = parcelRequire("aHvyO");
const $acb2619b4f7a40d7$export$ab6e213c275a503b = ({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, icon: icon, testId: testId, elemAfter: elemAfter, beforeItemId: beforeItemId, afterItemId: afterItemId, onClick: onClick })=>{
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $eJOHy.useState)(false);
    const { isOverflowing: isOverflowing } = (0, $fhrsC.useTabContext)();
    const { registerTab: registerTab } = (0, $6fFb3.useTabShortcuts)();
    const webItemRefs = (0, $eJOHy.useRef)([]);
    const tabData = (0, $j4oe4.useFragment)((0, $hbNQU.default), tabFragment);
    const containerData = (0, $j4oe4.useFragment)((0, $dpBSe.default), containerFragment);
    (0, $eJOHy.useEffect)(()=>{
        if (tabData.label) {
            const deregisterTab = registerTab({
                index: position,
                callback: ()=>{
                    setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent);
                },
                label: tabData.label
            });
            return deregisterTab;
        }
        return 0, (/*@__PURE__*/$parcel$interopDefault($12DRg));
    }, [
        registerTab,
        tabData.label,
        position
    ]);
    const triggerAnalytics = (0, $l7wEr.useNavigationItemAnalytics)((0, $eJOHy.useMemo)(()=>({
            itemType: 'appSubpage',
            itemId: tabData.appId ?? '',
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage,
            navigationLayer: (0, $002870cfa80d64f4$export$33d8c916a600c5e9),
            navigationContainer: (0, $95eb6070d868c1b7$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), [
        tabData.appId
    ]));
    if (!tabData.label) return null;
    const handleClick = ()=>{
        setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent);
        onClick?.();
    };
    const handleConnectItemClick = (className, href, sectionIndex, index)=>(e)=>{
            if (className && href) {
                (0, $cGvTS.withConnectHost)((connectHost)=>{
                    connectHost.triggerWebItem(webItemRefs.current[sectionIndex][index], className, href);
                });
                if ((0, $cGvTS.isConnectDialogWebItem)(className)) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            triggerAnalytics();
        };
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aHvyO.TabWithMenu), {
            ...triggerProps,
            type: "dropdown-trigger",
            isOpen: isDropdownMenuOpen,
            onClick: handleClick,
            elemBefore: icon,
            position: position,
            tabFragment: tabData,
            containerFragment: containerData,
            elemAfter: elemAfter,
            testId: testId,
            beforeItemId: beforeItemId,
            afterItemId: afterItemId
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        trigger: trigger,
        placement: isOverflowing ? 'left' : 'bottom-end',
        messageId: "horizontal-nav-tabs.ui.popup",
        messageType: "transactional",
        shouldFlip: false,
        isOpen: isDropdownMenuOpen,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "horizontal-nav-app-tab.ui.app-menu.dropdown-menu",
        onClose: ()=>setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, tabData?.sections && tabData?.sections.map((section, i)=>{
                if (!webItemRefs.current[i]) webItemRefs.current[i] = new Array(section?.links?.length ?? 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
                    key: section?.label ?? `section-${i}`,
                    title: section?.label ?? undefined,
                    hasSeparator: i !== 0
                }, (section?.links ?? []).filter((link)=>link && link.label).map((link, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
                        key: link?.label ?? `link-${j}`,
                        href: link?.url ?? '',
                        isDisabled: !link?.url,
                        iconBefore: link?.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
                            src: link.iconUrl,
                            size: "small"
                        }) : undefined,
                        onClick: handleConnectItemClick(link?.styleClass, link?.url, i, j),
                        ref: (ref)=>{
                            if (ref !== null) webItemRefs.current[i][j] = ref;
                        }
                    }, link?.label)));
            }))
    });
};

});
parcelRegister("dpBSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e033749659d85caf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2792c6bb12caa73c8e12008719c7617a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e033749659d85caf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppTabMenu_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$e033749659d85caf$var$node.hash = "687af9e59bccecfe4646886b7021170f";
var $e033749659d85caf$export$2e2bcd8739ae039 = $e033749659d85caf$var$node;

});

parcelRegister("hbNQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b461b03f3ff248$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5347f212c1326652ffb0a0988293a41e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $70b461b03f3ff248$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "AppTabMenu_tab",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "TabWithMenu_tab"
            },
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraAppNavigationItemNestedLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "iconUrl"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "styleClass"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$70b461b03f3ff248$var$node.hash = "0b52617895e2febba892c1e3d0914263";
var $70b461b03f3ff248$export$2e2bcd8739ae039 = $70b461b03f3ff248$var$node;

});


parcelRegister("hxMJd", function(module, exports) {

$parcel$export(module.exports, "AppEnvLozenge", () => $188c3143230c5db1$export$63905d23c4aa4c89);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");
const $188c3143230c5db1$export$63905d23c4aa4c89 = ({ label: label })=>label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: label === 'Dev' ? 'default' : 'moved'
    }, label) : null;

});


parcelRegister("39VdI", function(module, exports) {

$parcel$export(module.exports, "ShortcutsTab", () => $c175fa11794d4cb5$export$9bfb5d07e0d9a9ad);

var $ivrI3 = parcelRequire("ivrI3");

var $9Rhla = parcelRequire("9Rhla");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kJsb4 = parcelRequire("kJsb4");

var $9ucqS = parcelRequire("9ucqS");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $aHvyO = parcelRequire("aHvyO");




var $iyTaR = parcelRequire("iyTaR");

var $cAELL = parcelRequire("cAELL");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $kEUB1 = parcelRequire("kEUB1");

var $ciFJV = parcelRequire("ciFJV");

var $l7wEr = parcelRequire("l7wEr");

var $fhrsC = parcelRequire("fhrsC");

var $aMd82 = parcelRequire("aMd82");

var $2VUCc = parcelRequire("2VUCc");

var $fdaXW = parcelRequire("fdaXW");
const $c175fa11794d4cb5$export$9bfb5d07e0d9a9ad = ({ tabFragment: tabFragment, containerFragment: containerFragment, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, isRenaming: isRenaming, onRenamingChange: onRenamingChange })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const projectIdOrKey = (0, $2VUCc.useProjectIdOrKey)() ?? '';
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $eJOHy.useState)(false);
    const closePopup = (0, $eJOHy.useCallback)(()=>setIsDropdownMenuOpen(false), []);
    const itemRef = (0, $eJOHy.useRef)(null);
    const { data: shortcutsData, loading: loading } = (0, $aMd82.useShortcutsData)();
    const { isOverflowing: isOverflowing } = (0, $fhrsC.useTabContext)();
    const tabData = (0, $j4oe4.useFragment)((0, $9Rhla.default), tabFragment);
    const containerData = (0, $j4oe4.useFragment)((0, $ivrI3.default), containerFragment);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $fdaXW.shortcutMenuContentEntryPoint), (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey
        }), [
        cloudId,
        projectIdOrKey
    ]));
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isDropdownMenuOpen);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            canEdit: containerData.canEdit ?? false,
            onClosePopup: closePopup,
            itemRef: itemRef
        }), [
        containerData.canEdit,
        closePopup
    ]);
    const triggerAnalytics = (0, $l7wEr.useNavigationItemAnalytics)((0, $eJOHy.useMemo)(()=>({
            itemId: undefined,
            itemType: 'shortcuts',
            navState: (0, $107c403b1827dc68$export$2bd315ece9f68967),
            stage: (0, $iyTaR.getNav4Rollout)().stage,
            navigationLayer: (0, $002870cfa80d64f4$export$33d8c916a600c5e9),
            navigationContainer: (0, $95eb6070d868c1b7$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), []));
    const trigger = ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aHvyO.TabWithMenu), {
            tabFragment: tabData,
            containerFragment: containerData,
            type: "dropdown-trigger",
            isOpen: isDropdownMenuOpen,
            isRenaming: isRenaming,
            onRenamingChange: onRenamingChange,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ucqS))), {
                label: "",
                LEGACY_size: "small"
            }),
            onClick: ()=>{
                setIsDropdownMenuOpen((isOpen)=>!isOpen);
                triggerAnalytics();
            },
            position: position,
            ref: (element)=>{
                itemRef.current = element;
                triggerRef(element);
                typeof ref === 'function' && ref(element);
            },
            beforeItemId: beforeItemId,
            afterItemId: afterItemId,
            testId: "horizontal-nav-shortcuts-tab.dropdown-menu-trigger",
            ...triggerProps
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        trigger: trigger,
        placement: isOverflowing ? 'left' : 'bottom-end',
        shouldFlip: false,
        isOpen: isDropdownMenuOpen,
        onClose: closePopup,
        testId: "horizontal-nav-shortcuts-tab.dropdown-menu",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cAELL.ShortcutsContainer), {
                data: shortcutsData,
                loading: loading,
                isGlobal: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "shortcut.shortcuts-menu-content",
                packageName: "jiraHorizontalNavShortcutsTab",
                runtimeProps: runtimeProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                    xcss: $c175fa11794d4cb5$var$fallbackStyles
                })
            })),
        shouldRenderToParent: (0, $7jTnu.fg)('should-render-to-parent-should-be-true-navigation')
    });
};
const $c175fa11794d4cb5$var$fallbackStyles = (0, $1DXK0.xcss)({
    width: '360px',
    height: '200px'
});

});
parcelRegister("ivrI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa7d5c1b63b9b4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7604ac780c8d96764d7838fc785b06aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4fa7d5c1b63b9b4c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ShortcutsTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "canEdit"
                    },
                    "action": "THROW",
                    "path": "canEdit"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$4fa7d5c1b63b9b4c$var$node.hash = "68870b0a4c832d2519c1a0a32742229a";
var $4fa7d5c1b63b9b4c$export$2e2bcd8739ae039 = $4fa7d5c1b63b9b4c$var$node;

});

parcelRegister("9Rhla", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a10cf3eaf0e7da4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d1cf693bab9584542567abe8891c3e0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a10cf3eaf0e7da4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ShortcutsTab_tab",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$3a10cf3eaf0e7da4$var$node.hash = "44ec907f13fc9eea05e67f5b8c1abeae";
var $3a10cf3eaf0e7da4$export$2e2bcd8739ae039 = $3a10cf3eaf0e7da4$var$node;

});

parcelRegister("9ucqS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb119a22bda01c1dc796d8c652f466ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e808f42332e9d94$var$_react = $6e808f42332e9d94$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6e808f42332e9d94$var$_link = $6e808f42332e9d94$var$_interopRequireDefault((parcelRequire("cV8sz")));

var $6e808f42332e9d94$var$_link2 = $6e808f42332e9d94$var$_interopRequireDefault((parcelRequire("frcEo")));
function $6e808f42332e9d94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "EditorLinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e808f42332e9d94$var$LinkIcon = (props)=>/*#__PURE__*/ $6e808f42332e9d94$var$_react.default.createElement($6e808f42332e9d94$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $6e808f42332e9d94$var$_link2.default
    }, props));
$6e808f42332e9d94$var$LinkIcon.Name = 'LinkIconMigration';
var $6e808f42332e9d94$var$_default = module.exports.default = $6e808f42332e9d94$var$LinkIcon;

});
parcelRegister("cV8sz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96815ed7645c21ae$var$_react = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $96815ed7645c21ae$var$_baseNew = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $96815ed7645c21ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $96815ed7645c21ae$var$LinkIcon = (props)=>/*#__PURE__*/ $96815ed7645c21ae$var$_react.default.createElement($96815ed7645c21ae$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$96815ed7645c21ae$var$LinkIcon.displayName = 'LinkIcon';
var $96815ed7645c21ae$var$_default = module.exports.default = $96815ed7645c21ae$var$LinkIcon;

});

parcelRegister("frcEo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3d330c229d7652a$var$_react = $b3d330c229d7652a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $b3d330c229d7652a$var$_link = $b3d330c229d7652a$var$_interopRequireDefault((parcelRequire("cV8sz")));
function $b3d330c229d7652a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b3d330c229d7652a$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $b3d330c229d7652a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $b3d330c229d7652a$var$_link.default
    }));
$b3d330c229d7652a$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $b3d330c229d7652a$var$_default = module.exports.default = $b3d330c229d7652a$var$EditorLinkIcon;

});


parcelRegister("fdaXW", function(module, exports) {

$parcel$export(module.exports, "shortcutMenuContentEntryPoint", () => $3945842540ef982c$export$3b6d8ed8ad10a2e0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $asWLp = parcelRequire("asWLp");

const $3945842540ef982c$export$3b6d8ed8ad10a2e0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gsdxZ")), {
        moduleId: "cf565f5d",
        moduleName: "ShortcutsPopupContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectIdOrKey: projectIdOrKey })=>({
            queries: {
                mainQuery: {
                    parameters: (0, $asWLp.default),
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("asWLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb8a03ed1e1292d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c0a91e745996f53732022a7307f6d7d>>
 * @relayHash a6218fab775f20b2d64f2488618a1ee0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bbd38f006fb6a30be026af75e9185b1301cc9753e91e5f4bd37871d8143f0bc6
const $bfb8a03ed1e1292d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v4 = {
        "kind": "ScalarField",
        "name": "projectId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ShortcutsPopupContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "jira_projectByIdOrKey",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v2 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.key"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v3 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.projectType"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v4 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.projectId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira_projectByIdOrKey"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ShortcutsPopupContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bbd38f006fb6a30be026af75e9185b1301cc9753e91e5f4bd37871d8143f0bc6",
            "metadata": {},
            "name": "ShortcutsPopupContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bfb8a03ed1e1292d$var$node.hash = "6fa8881cba653e7f2ddc0665b57f7b00";
var $bfb8a03ed1e1292d$export$2e2bcd8739ae039 = $bfb8a03ed1e1292d$var$node;

});

parcelRegister("gsdxZ", function(module, exports) {

let $bfa9c511ee8adca1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $bfa9c511ee8adca1$var$load("ffQaD"),
    $bfa9c511ee8adca1$var$load("kvRbA"),
    $bfa9c511ee8adca1$var$load("7mIf9"),
    $bfa9c511ee8adca1$var$load("jXweD"),
    $bfa9c511ee8adca1$var$load("avmx1")
]).then(()=>parcelRequire('aKvLy'));

});





parcelRegister("6se2r", function(module, exports) {

$parcel$export(module.exports, "getFlagDetails", () => $dfb1627aa031e937$export$e0141c03826f0c2c);

var $epTsa = parcelRequire("epTsa");

var $64IPl = parcelRequire("64IPl");
const $dfb1627aa031e937$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $64IPl.default).defaultErrorTitle,
    description: (0, $64IPl.default).defaultErrorMessage,
    messageId: 'horizontal-nav-common.common.get-flag-details.default-error-flag.error.error.default-error-flag',
    messageType: 'transactional'
};
const $dfb1627aa031e937$export$e0141c03826f0c2c = (statusCode)=>{
    const projectNotFoundErrorTitleGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $64IPl.default).projectNotFoundErrorTitleGalaxia : (0, $64IPl.default).projectNotFoundErrorTitle;
    const unauthorizedUserErrorTitleGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $64IPl.default).unauthorizedUserErrorTitleGalaxia : (0, $64IPl.default).unauthorizedUserErrorTitle;
    const unauthorizedUserErrorMessageGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $64IPl.default).unauthorizedUserErrorMessageGalaxia : (0, $64IPl.default).unauthorizedUserErrorMessage;
    switch(statusCode){
        case 401:
            return {
                type: 'error',
                title: (0, $64IPl.default).unauthenticatedUserErrorTitle,
                description: (0, $64IPl.default).unauthenticatedUserErrorMessage,
                messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.401',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: 'error',
                title: unauthorizedUserErrorTitleGalaxia,
                description: unauthorizedUserErrorMessageGalaxia,
                messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.403',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: 'error',
                title: projectNotFoundErrorTitleGalaxia,
                description: (0, $64IPl.default).projectNotFoundErrorMessage,
                messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.404',
                messageType: 'transactional'
            };
        default:
            return $dfb1627aa031e937$var$DEFAULT_ERROR_FLAG;
    }
};

});
parcelRegister("64IPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e6b58a53cc50ddf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5e6b58a53cc50ddf$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    defaultViewRedirectFlagTitle: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-title",
        "defaultMessage": "We've taken you to the default view"
    },
    defaultViewRedirectFlagDescription: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-description",
        "defaultMessage": "The view you're trying to access has been removed."
    },
    defaultErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.default-error-message",
        "defaultMessage": "Try refreshing or navigating to another page."
    },
    defaultErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.default-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    unauthenticatedUserErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.unauthenticated-user-error-title",
        "defaultMessage": "You'll need to log in"
    },
    unauthenticatedUserErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.unauthenticated-user-error-message",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    unauthorizedUserErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.unauthorized-user-error-title",
        "defaultMessage": "You don't have permission"
    },
    unauthorizedUserErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.unauthorized-user-error-message",
        "defaultMessage": "You don't have permission to view this project."
    },
    projectNotFoundErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.project-not-found-error-title",
        "defaultMessage": "Project not found"
    },
    projectNotFoundErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.project-not-found-error-message",
        "defaultMessage": "The project might have been deleted or you don't have permission."
    },
    unauthorizedUserErrorMessageGalaxia: {
        "id": "business-horizontal-nav.project-navigation.unauthorized-user-error-message-galaxia",
        "defaultMessage": "You don't have permission to view this space."
    },
    unauthorizedUserErrorTitleGalaxia: {
        "id": "business-horizontal-nav.project-navigation.unauthorized-user-error-title-galaxia",
        "defaultMessage": "Space not found"
    },
    projectNotFoundErrorTitleGalaxia: {
        "id": "business-horizontal-nav.project-navigation.project-not-found-error-title-galaxia",
        "defaultMessage": "The space might have been deleted or you don't have permission."
    }
});

});


parcelRegister("8Km6P", function(module, exports) {

$parcel$export(module.exports, "PagesSpotlightEntrypointContainer", () => $58a99c18a2b2903d$export$44a256458bf80a84);

var $eJOHy = parcelRequire("eJOHy");

var $duWVD = parcelRequire("duWVD");

var $ea0Pc = parcelRequire("ea0Pc");

var $bbdV2 = parcelRequire("bbdV2");

var $7jTnu = parcelRequire("7jTnu");

var $cBavF = parcelRequire("cBavF");

var $aXlhA = parcelRequire("aXlhA");

var $kvSLe = parcelRequire("kvSLe");

var $hWwvC = parcelRequire("hWwvC");

const $58a99c18a2b2903d$var$entryPointParams = {};
const $58a99c18a2b2903d$export$91543d8c5805d455 = (props)=>{
    const isQuickstartDismissed = (0, $hWwvC.useIsQuickstartDismissed)();
    const [property] = (0, $aXlhA.useUserProperty)((0, $46da30843a0b64aa$export$fc1565c98db060f9));
    const { isEligible: isEligible } = (0, $hWwvC.useIsPagesSpotlightNav4Eligible)();
    const loadEntryPoint = (0, $eJOHy.useMemo)(()=>{
        return isQuickstartDismissed && property !== 'true' && isEligible && (0, $7jTnu.fg)('grw-1860_pages_horizontal_nav4_spotlight');
    }, [
        isQuickstartDismissed,
        property,
        isEligible
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $kvSLe.default), $58a99c18a2b2903d$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (loadEntryPoint) entryPointActions.load();
        return ()=>{
            if (loadEntryPoint) entryPointActions.unload();
        };
    }, [
        loadEntryPoint,
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira-pages-spotlight-nav4",
        packageName: "@atlassian/jira-pages-spotlight-nav4",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
const $58a99c18a2b2903d$export$44a256458bf80a84 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $duWVD.default), {
        // eslint-disable-next-line react-hooks/react-compiler
        conditions: (0, $ea0Pc.composeTraitsSelectors)([
            'SITE_USER'
        ], [
            (0, $hWwvC.useIsD0APOrMLAP)
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58a99c18a2b2903d$export$91543d8c5805d455, props));
};

});
parcelRegister("duWVD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d45d9a4d44e167d8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $g9Vr6 = parcelRequire("g9Vr6");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $ea0Pc = parcelRequire("ea0Pc");
const $d45d9a4d44e167d8$var$TraitsConditionalRenderer = ({ conditions: conditions, children: children })=>{
    const accountId = (0, $8q7lT.useAccountId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { fetchTraits: fetchTraits } = (0, $ea0Pc.useTraitsActions)();
    (0, $eJOHy.useEffect)(()=>{
        fetchTraits(conditions.traitTypes, {
            cloudId: cloudId,
            accountId: accountId,
            orgId: orgId
        });
    }, [
        accountId,
        cloudId,
        conditions.traitTypes,
        fetchTraits,
        orgId
    ]);
    const shouldRenderChildren = conditions.hooks.map((hook)=>hook()[0]).every((result)=>Boolean(result));
    return shouldRenderChildren ? children : null;
};
var $d45d9a4d44e167d8$export$2e2bcd8739ae039 = $d45d9a4d44e167d8$var$TraitsConditionalRenderer;

});
parcelRegister("ea0Pc", function(module, exports) {

$parcel$export(module.exports, "useTraits", () => $e2b3b7a3a420087e$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $e2b3b7a3a420087e$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $e2b3b7a3a420087e$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $e2b3b7a3a420087e$export$e653f602b87eec56);

var $jGzN3 = parcelRequire("jGzN3");

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $lctcw = parcelRequire("lctcw");

var $lFovQ = parcelRequire("lFovQ");

var $58aKG = parcelRequire("58aKG");

var $19QQ8 = parcelRequire("19QQ8");
const $e2b3b7a3a420087e$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $e2b3b7a3a420087e$var$fetchTraits = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $19QQ8.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $58aKG.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $58aKG.SITE) && cloudId) fetchedTraits = {
                    attributes: await (0, $lctcw.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $58aKG.SITE_USER) && cloudId && accountId) fetchedTraits = {
                    attributes: await (0, $lFovQ.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $jGzN3.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $e2b3b7a3a420087e$var$actions = {
    fetchTraits: $e2b3b7a3a420087e$var$fetchTraits,
    addTrait: $e2b3b7a3a420087e$var$addTrait
};
const $e2b3b7a3a420087e$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $e2b3b7a3a420087e$export$5b11e13f463f4eb = (0, $GtRbT.createStore)({
    initialState: $e2b3b7a3a420087e$var$initialState,
    actions: $e2b3b7a3a420087e$var$actions,
    name: 'TraitsStore'
});
const $e2b3b7a3a420087e$export$243330301a7ccf01 = (0, $iJq0l.createHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb);
const $e2b3b7a3a420087e$export$87f1d888def9d5a0 = (0, $iJq0l.createActionsHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb);
const $e2b3b7a3a420087e$var$defaultSelector = (traitsType, selector)=>(0, $4MchI.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $19QQ8.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $19QQ8.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $19QQ8.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $19QQ8.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $19QQ8.getTraitValue)(state, name) : null
        }), selector);
const $e2b3b7a3a420087e$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $iJq0l.createHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb, {
        selector: $e2b3b7a3a420087e$var$defaultSelector(traitsType, selector)
    });
const $e2b3b7a3a420087e$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("58aKG", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $6bc297d84ad0ac90$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $6bc297d84ad0ac90$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $6bc297d84ad0ac90$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $6bc297d84ad0ac90$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $6bc297d84ad0ac90$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $6bc297d84ad0ac90$export$ff5c5bd50c21e9a4);
const $6bc297d84ad0ac90$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $6bc297d84ad0ac90$export$1f4740cb59ea887e = 'SITE';
const $6bc297d84ad0ac90$export$2b629adc0b711448 = 'SITE_USER';
const $6bc297d84ad0ac90$export$c7bc89c720838974 = 'ORG';
const $6bc297d84ad0ac90$export$872e93425a929c06 = 'ORG_USER';
const $6bc297d84ad0ac90$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $6bc297d84ad0ac90$export$ab3e7784d2a104d4 = [
    $6bc297d84ad0ac90$export$eac8289d83d13c9e,
    $6bc297d84ad0ac90$export$1f4740cb59ea887e,
    $6bc297d84ad0ac90$export$2b629adc0b711448,
    $6bc297d84ad0ac90$export$c7bc89c720838974,
    $6bc297d84ad0ac90$export$872e93425a929c06
];

});

parcelRegister("19QQ8", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $487f20fc6a559fdc$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $487f20fc6a559fdc$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $487f20fc6a559fdc$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $487f20fc6a559fdc$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $487f20fc6a559fdc$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $487f20fc6a559fdc$export$da1e8ce191f01409);

var $58aKG = parcelRequire("58aKG");
const $487f20fc6a559fdc$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $487f20fc6a559fdc$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $58aKG.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $58aKG.SITE:
            return `site/${cloudId}`;
        case 0, $58aKG.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $58aKG.ORG:
            return `org/${orgId}`;
        case 0, $58aKG.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $487f20fc6a559fdc$export$252a469687875173(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $487f20fc6a559fdc$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $487f20fc6a559fdc$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $487f20fc6a559fdc$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $487f20fc6a559fdc$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});



parcelRegister("aXlhA", function(module, exports) {

$parcel$export(module.exports, "useUserProperty", () => $20e8460eaae2151e$export$fbe59e5a949d942d);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");

var $3Dkf3 = parcelRequire("3Dkf3");

var $3MbOI = parcelRequire("3MbOI");
const $20e8460eaae2151e$export$fbe59e5a949d942d = (property, userId)=>{
    const { data: currentUser } = (0, $3MbOI.useCurrentUser)();
    const user = userId || currentUser.user.accountId;
    const storageKey = `user-property-${user}-${property}`;
    const [value, setValue] = (0, $3Dkf3.usePersistentlyCachedRequest)(storageKey, undefined, (0, $eJOHy.useCallback)(()=>user ? (0, $FppkK.getUserProperty)(user, property).catch((error)=>{
            // user property is not found
            if (error instanceof (0, $1uIew.default) && error.statusCode === 404) return undefined;
            throw error;
        }) : undefined, [
        user,
        property
    ]));
    const setProperty = (0, $eJOHy.useCallback)((newValue)=>{
        if (!user) return Promise.reject(new Error('user is unknown'));
        setValue(newValue);
        const operation = (0, $FppkK.setUserProperties)(user, property, newValue);
        operation.catch(()=>{
            // do not report error, that's consumer's responsibility
            // restore old value
            setValue(value);
        });
        return operation;
    }, [
        setValue,
        user,
        property,
        value
    ]);
    return (0, $eJOHy.useMemo)(()=>[
            value,
            setProperty
        ], [
        value,
        setProperty
    ]);
};

});
parcelRegister("3Dkf3", function(module, exports) {

$parcel$export(module.exports, "usePersistentlyCachedRequest", () => $4c196a3c7c8c8984$export$984344f48cd049a);

var $eJOHy = parcelRequire("eJOHy");

var $aizIw = parcelRequire("aizIw");
const $4c196a3c7c8c8984$export$984344f48cd049a = (storageKey, defaultValue, reader)=>{
    const cachedValue = (0, $eJOHy.useMemo)(()=>(0, $aizIw.getSessionStorageData)(storageKey), [
        storageKey
    ]);
    const [{ value: value, storageKey: storedKey }, setStoredValue] = (0, $eJOHy.useState)(()=>({
            storageKey: storageKey,
            value: cachedValue
        }));
    if (storedKey !== storageKey) // yes, you can do it
    setStoredValue({
        storageKey: storageKey,
        value: cachedValue
    });
    const setNewValue = (0, $eJOHy.useCallback)((newValue)=>{
        (0, $aizIw.setSessionStorageData)(storageKey, newValue);
        (0, $aizIw.updateBus).emit(storageKey, newValue);
    }, [
        storageKey
    ]);
    // note - updating value is done via effect and affects all consumers
    (0, $eJOHy.useEffect)(()=>(0, $aizIw.updateBus).subscribe(storageKey, (newValue)=>setStoredValue({
                storageKey: storageKey,
                value: newValue
            })), [
        storageKey
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!reader) return;
        if (cachedValue === undefined) (0, $aizIw.handleDataRequest)(storageKey, reader);
    }, [
        reader,
        storageKey,
        cachedValue
    ]);
    return (0, $eJOHy.useMemo)(()=>[
            value ?? defaultValue,
            setNewValue
        ], [
        value,
        defaultValue,
        setNewValue
    ]);
};

});
parcelRegister("aizIw", function(module, exports) {

$parcel$export(module.exports, "getSessionStorageData", () => $0c4f902ec7d5af31$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $0c4f902ec7d5af31$export$be8cb7c8f1a1db6b);
$parcel$export(module.exports, "updateBus", () => $0c4f902ec7d5af31$export$6da4b0a5188cf0d7);
$parcel$export(module.exports, "handleDataRequest", () => $0c4f902ec7d5af31$export$d09b7eeb5e60cdd9);

var $4elgJ = parcelRequire("4elgJ");

var $gYnSx = parcelRequire("gYnSx");

var $4896p = parcelRequire("4896p");
const $0c4f902ec7d5af31$var$ONE_DAY = 86400000; // 1 day
const $0c4f902ec7d5af31$var$storage = (0, $4elgJ.createSessionExpirableStorageProvider)('jira-platform-persistent-cache');
const $0c4f902ec7d5af31$export$af84d82ff1eea56d = (key)=>{
    const data = $0c4f902ec7d5af31$var$storage.get(key);
    if (data) try {
        return JSON.parse(data);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getSessionStorageData', e);
        return undefined;
    }
    return undefined;
};
const $0c4f902ec7d5af31$export$be8cb7c8f1a1db6b = (key, value)=>{
    try {
        $0c4f902ec7d5af31$var$storage.set(key, JSON.stringify(value), Date.now() + $0c4f902ec7d5af31$var$ONE_DAY);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('setSessionStorageData', e);
    }
};
const $0c4f902ec7d5af31$export$6da4b0a5188cf0d7 = (0, $4896p.createEventBus)();
const $0c4f902ec7d5af31$export$9a4e04a3b0938221 = {};
const $0c4f902ec7d5af31$export$d09b7eeb5e60cdd9 = async (storageKey, // eslint-disable-next-line @typescript-eslint/no-explicit-any
request)=>{
    // If there's already a pending request for this storageKey, ignore this one
    if ($0c4f902ec7d5af31$export$9a4e04a3b0938221[storageKey]) return $0c4f902ec7d5af31$export$9a4e04a3b0938221[storageKey];
    // Otherwise, add this request to the list of pending requests
    try {
        const pending = request();
        $0c4f902ec7d5af31$export$9a4e04a3b0938221[storageKey] = pending;
        // Wait for the request to complete
        const newValue = await pending;
        // update store and inform consumers
        $0c4f902ec7d5af31$export$be8cb7c8f1a1db6b(storageKey, newValue);
        $0c4f902ec7d5af31$export$6da4b0a5188cf0d7.emit(storageKey, newValue);
    } catch (error) {
        if (error instanceof Error) (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'handleDataRequest',
                packageName: 'jiraPlatformPersistentCache',
                teamName: 'crocs'
            }
        });
        else throw error;
    } finally{
        // Remove this request from the list of pending requests
        delete $0c4f902ec7d5af31$export$9a4e04a3b0938221[storageKey];
    }
};

});
parcelRegister("4896p", function(module, exports) {

$parcel$export(module.exports, "createEventBus", () => $c8963504691d0169$export$f492882bd33cbb73);
const $c8963504691d0169$export$f492882bd33cbb73 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const listeners = new Map();
    const subscribe = (event, listener)=>{
        listeners.set(listener, event);
        return ()=>{
            listeners.delete(listener);
        };
    };
    const emit = (event, payload)=>{
        listeners.forEach((eventFilter, listener)=>{
            if (eventFilter === event) listener(payload);
        });
    };
    return {
        subscribe: subscribe,
        emit: emit,
        get length () {
            return listeners.size;
        }
    };
};

});



parcelRegister("3MbOI", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cea734a12424bed3$export$3901076af3749fa9);

var $eJOHy = parcelRequire("eJOHy");

var $4qiFT = parcelRequire("4qiFT");

var $lvKO5 = parcelRequire("lvKO5");

var $c9f6v = parcelRequire("c9f6v");
const $cea734a12424bed3$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return (0, $eJOHy.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $4qiFT.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cea734a12424bed3$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cea734a12424bed3$var$useCurrentUserBasic();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $c9f6v.useUserSubscriber)();
    (0, $eJOHy.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cea734a12424bed3$export$3901076af3749fa9 = ()=>// eslint-disable-next-line react-hooks/react-compiler
    (0, $lvKO5.useTenantContext)().isAnonymous ? $cea734a12424bed3$var$useCurrentUserBasic() : $cea734a12424bed3$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cea734a12424bed3$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cea734a12424bed3$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("c9f6v", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $76dd8ceef4c03a1e$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $76dd8ceef4c03a1e$export$4e61bbf568682a96);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $immvQ = parcelRequire("immvQ");
const $76dd8ceef4c03a1e$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $76dd8ceef4c03a1e$var$Store = (0, $GtRbT.createStore)({
    name: 'user',
    initialState: $76dd8ceef4c03a1e$var$initialState,
    actions: $immvQ
});
const $76dd8ceef4c03a1e$export$7ff085589970ee0a = (0, $6E16M.createContainer)($76dd8ceef4c03a1e$var$Store);
const $76dd8ceef4c03a1e$export$4e61bbf568682a96 = (0, $iJq0l.createHook)($76dd8ceef4c03a1e$var$Store);

});
parcelRegister("immvQ", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $10ab66dafa4344a0$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1s4Nl = parcelRequire("1s4Nl");
const $10ab66dafa4344a0$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $1s4Nl.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("1s4Nl", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $58aa135740e671a3$export$8134c072fddab6a5);

var $b5RwB = parcelRequire("b5RwB");

var $LFmXM = parcelRequire("LFmXM");

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $hbF3h = parcelRequire("hbF3h");

var $fsisP = parcelRequire("fsisP");
const $58aa135740e671a3$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $b5RwB.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $jGzN3.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $58aa135740e671a3$var$fetchDataNew = (0, $LFmXM.default)($58aa135740e671a3$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $fsisP.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $fsisP.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $58aa135740e671a3$export$8134c072fddab6a5 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('user-iv-llc-unnecessary-api'), $58aa135740e671a3$var$fetchDataNew, $58aa135740e671a3$export$5e5a6664039ed1cc);

});





parcelRegister("kvSLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $356a0e35dc604581$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $356a0e35dc604581$export$2e2bcd8739ae039 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("erXCJ")), {
        moduleId: "a8a2566c",
        moduleName: "PagesSpotlightMaybe",
        priority: "interaction"
    }),
    getPreloadProps () {
        return {};
    }
});

});
parcelRegister("erXCJ", function(module, exports) {

let $a851d65441cce221$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a851d65441cce221$var$load("azUNk").then(()=>parcelRequire('eyQ7o'));

});


parcelRegister("hWwvC", function(module, exports) {

$parcel$export(module.exports, "useIsD0APOrMLAP", () => $fb81f007b8d9d432$export$76b8bfeeb70eb5c1);
$parcel$export(module.exports, "useIsPagesSpotlightNav4Eligible", () => $fb81f007b8d9d432$export$ad6ee0f6723dfc62);
$parcel$export(module.exports, "useIsQuickstartDismissed", () => $fb81f007b8d9d432$export$b6803998caa91570);

var $eJOHy = parcelRequire("eJOHy");

var $ea0Pc = parcelRequire("ea0Pc");

var $gxP9D = parcelRequire("gxP9D");

var $9ycBx = parcelRequire("9ycBx");
const $fb81f007b8d9d432$export$76b8bfeeb70eb5c1 = (0, $ea0Pc.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
    const isD0AP = getTraitByName('segment_day0_auto-provisioned_confluence_not_active_siteuser');
    const isMLAP = getTraitByName('segment_4c7a215c-2ec8-441a-b7c1-441e78eaaa72');
    return isD0AP?.value === true || isMLAP?.value === true;
});
const $fb81f007b8d9d432$export$bc400196bb982723 = (0, $ea0Pc.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
    const isD0AP = getTraitByName('segment_day0_auto-provisioned_confluence_not_active_siteuser');
    return isD0AP?.value === true;
});
const $fb81f007b8d9d432$export$271dc25f1c17f051 = (0, $ea0Pc.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
    const isMLAP = getTraitByName('segment_4c7a215c-2ec8-441a-b7c1-441e78eaaa72');
    return isMLAP?.value === true;
});
function $fb81f007b8d9d432$export$ad6ee0f6723dfc62() {
    const [isD0AP] = $fb81f007b8d9d432$export$bc400196bb982723();
    const [isMLAP] = $fb81f007b8d9d432$export$271dc25f1c17f051();
    let audience = null;
    if (isD0AP) audience = 'D0';
    else if (isMLAP) audience = 'ML';
    return {
        isEligible: isD0AP || isMLAP,
        audience: audience
    };
}
const $fb81f007b8d9d432$var$statusDismissedSet = new Set([
    (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED,
    (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED
]);
function $fb81f007b8d9d432$export$b6803998caa91570() {
    const [quickstartStatus] = (0, $gxP9D.useQuickstartUiStatus)();
    const [hasQuickstartBeenOpened, setHasQuickstartBeenOpened] = (0, $eJOHy.useState)(false);
    const isOpen = quickstartStatus === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
    if (!hasQuickstartBeenOpened && isOpen) setHasQuickstartBeenOpened(true);
    return !hasQuickstartBeenOpened && $fb81f007b8d9d432$var$statusDismissedSet.has(quickstartStatus);
}

});
parcelRegister("gxP9D", function(module, exports) {

$parcel$export(module.exports, "useJswOnboarding", () => $ef5cbf2537a08e24$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $ef5cbf2537a08e24$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $ef5cbf2537a08e24$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $ef5cbf2537a08e24$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $ef5cbf2537a08e24$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $ef5cbf2537a08e24$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $ef5cbf2537a08e24$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $ef5cbf2537a08e24$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $ef5cbf2537a08e24$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $ef5cbf2537a08e24$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $ef5cbf2537a08e24$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $ef5cbf2537a08e24$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $ef5cbf2537a08e24$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $ef5cbf2537a08e24$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $ef5cbf2537a08e24$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $ef5cbf2537a08e24$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $ef5cbf2537a08e24$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $ef5cbf2537a08e24$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $ef5cbf2537a08e24$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $ef5cbf2537a08e24$export$521909e3dc7ab811);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("9ycBx")).QUICKSTART_UI_STATUS);

var $dhdXs = parcelRequire("dhdXs");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $9ycBx = parcelRequire("9ycBx");

var $4NsfZ = parcelRequire("4NsfZ");

var $1KmSm = parcelRequire("1KmSm");

var $6R6zv = parcelRequire("6R6zv");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");

const $ef5cbf2537a08e24$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $6R6zv.initialState,
    actions: $4NsfZ.actions
});
const $ef5cbf2537a08e24$export$1cbc60d8dd921852 = (0, $ht3nQ.createSubscriber)($ef5cbf2537a08e24$export$390f32400eaf98c9);
const $ef5cbf2537a08e24$export$7d91c0af4772787a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9);
const $ef5cbf2537a08e24$export$638bfcfce1254bb8 = (0, $6E16M.createContainer)($ef5cbf2537a08e24$export$390f32400eaf98c9, {});
const $ef5cbf2537a08e24$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $3XHRA.getQuickstartTypeSelector)(state)] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $ef5cbf2537a08e24$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $ef5cbf2537a08e24$export$594f006fa6a1b2e5 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$ea14030920a5d8e6
});
const $ef5cbf2537a08e24$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $ef5cbf2537a08e24$export$c5e63e44ad178ae8 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$a943afa434e9487a
});
const $ef5cbf2537a08e24$export$2c3cd14fff9d6e43 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: null
});
const $ef5cbf2537a08e24$export$b0db7e46e369e1d9 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: $ef5cbf2537a08e24$export$9d731f44f82af09f
});
const $ef5cbf2537a08e24$export$71de79653346a1ea = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $ef5cbf2537a08e24$export$61185a9266f1f57a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN || userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $ef5cbf2537a08e24$export$ef4747ba36826d6a = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $ef5cbf2537a08e24$export$522993b46d9f8266 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $uMSsJ.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $ef5cbf2537a08e24$export$aa4ba29241532382 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $ef5cbf2537a08e24$export$ed5c755b733bf2b1 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $ef5cbf2537a08e24$export$35fe0366802512dd = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $3XHRA.getQuickstartTypeSelector)(state)];
        return visibility === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $ef5cbf2537a08e24$export$a41ee0d3b6938099 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $ef5cbf2537a08e24$export$4ae7b465b076be9 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $ef5cbf2537a08e24$export$bf6e646c0476acad = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $ef5cbf2537a08e24$export$6b706bff94798d11 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $ef5cbf2537a08e24$export$c98db656edc5b3e1 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $ef5cbf2537a08e24$export$a823278ac9d1112b = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $dhdXs.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN)
});
const $ef5cbf2537a08e24$export$cb9e0e8fe4df8490 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $dhdXs.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $9ycBx.KANBAN_ONBOARDING_TASK)))
});
const $ef5cbf2537a08e24$export$521909e3dc7ab811 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $ef5cbf2537a08e24$export$f4a2be940259bf95 = (0, $iJq0l.createHook)($ef5cbf2537a08e24$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});

});
parcelRegister("dhdXs", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $d4b4552e4689d7b3$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$17a2f771efabf02f);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_OPERATIONS_TEMPLATE_KEY", () => $d4b4552e4689d7b3$export$df7d1440e0a80c03);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $d4b4552e4689d7b3$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $d4b4552e4689d7b3$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $d4b4552e4689d7b3$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $d4b4552e4689d7b3$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $d4b4552e4689d7b3$export$fd75f6abc7861439);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$2bc7db2da3df8313);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $d4b4552e4689d7b3$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $d4b4552e4689d7b3$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $d4b4552e4689d7b3$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $d4b4552e4689d7b3$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $d4b4552e4689d7b3$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $d4b4552e4689d7b3$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $d4b4552e4689d7b3$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $d4b4552e4689d7b3$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $d4b4552e4689d7b3$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $d4b4552e4689d7b3$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $d4b4552e4689d7b3$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $d4b4552e4689d7b3$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $d4b4552e4689d7b3$export$7d9a4e0ef5194fe1 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $d4b4552e4689d7b3$export$477ca3550da12e43 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $d4b4552e4689d7b3$export$7c0307155b744916 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $d4b4552e4689d7b3$export$b5ab111fb8825075 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $d4b4552e4689d7b3$export$14139f0ec41d437e = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $d4b4552e4689d7b3$export$ebf7af45376deb8b = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $d4b4552e4689d7b3$export$7b6945581ccdab4a = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $d4b4552e4689d7b3$export$310a9ac5c28d65f6 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $d4b4552e4689d7b3$export$136d17feb2f4285d = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $d4b4552e4689d7b3$export$e288f4758e94a8cc = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $d4b4552e4689d7b3$export$4e9ac1417ba54bba = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $d4b4552e4689d7b3$export$560c9f6765bf9af4 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $d4b4552e4689d7b3$export$14d4c6dbbb62a127 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $d4b4552e4689d7b3$export$1367ee12532c525f = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $d4b4552e4689d7b3$export$278632cc7ed9a312 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $d4b4552e4689d7b3$export$594d0d4f5ecbf4c7 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $d4b4552e4689d7b3$export$dda85c7a8278e495 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $d4b4552e4689d7b3$export$b92c431651f9ee91 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $d4b4552e4689d7b3$export$d72d75d9d0e071fc = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $d4b4552e4689d7b3$export$753322ed1c32ff89 = `${$d4b4552e4689d7b3$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $d4b4552e4689d7b3$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $d4b4552e4689d7b3$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $d4b4552e4689d7b3$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $d4b4552e4689d7b3$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $d4b4552e4689d7b3$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $d4b4552e4689d7b3$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $d4b4552e4689d7b3$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $d4b4552e4689d7b3$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $d4b4552e4689d7b3$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $d4b4552e4689d7b3$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $d4b4552e4689d7b3$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $d4b4552e4689d7b3$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $d4b4552e4689d7b3$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $d4b4552e4689d7b3$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $d4b4552e4689d7b3$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $d4b4552e4689d7b3$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $d4b4552e4689d7b3$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $d4b4552e4689d7b3$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $d4b4552e4689d7b3$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $d4b4552e4689d7b3$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $d4b4552e4689d7b3$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $d4b4552e4689d7b3$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $d4b4552e4689d7b3$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $d4b4552e4689d7b3$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $d4b4552e4689d7b3$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $d4b4552e4689d7b3$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $d4b4552e4689d7b3$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $d4b4552e4689d7b3$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $d4b4552e4689d7b3$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $d4b4552e4689d7b3$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $d4b4552e4689d7b3$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $d4b4552e4689d7b3$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $d4b4552e4689d7b3$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $d4b4552e4689d7b3$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $d4b4552e4689d7b3$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $d4b4552e4689d7b3$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $d4b4552e4689d7b3$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $d4b4552e4689d7b3$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $d4b4552e4689d7b3$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $d4b4552e4689d7b3$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $d4b4552e4689d7b3$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $d4b4552e4689d7b3$export$f9776303073903dd = 'jira.polaris:roadmap';
const $d4b4552e4689d7b3$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $d4b4552e4689d7b3$export$789332a2d3504754 = 'jira.polaris:portfolio';
const $d4b4552e4689d7b3$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $d4b4552e4689d7b3$export$e8df553a3f519284 || T4JTemplateKey === $d4b4552e4689d7b3$export$8eecdf6acea9494 || T4JTemplateKey === $d4b4552e4689d7b3$export$9e38ad41d19608ee;
const $d4b4552e4689d7b3$export$a062badd78c9993 = {
    [$d4b4552e4689d7b3$export$e82092c4fb277f9b]: $d4b4552e4689d7b3$export$b0928b02ffab3875,
    [$d4b4552e4689d7b3$export$fd75f6abc7861439]: $d4b4552e4689d7b3$export$b0928b02ffab3875,
    [$d4b4552e4689d7b3$export$5eddf3b31dd1858f]: $d4b4552e4689d7b3$export$50478ee5ecbf7a4d,
    [$d4b4552e4689d7b3$export$fb658bddae7f81bb]: $d4b4552e4689d7b3$export$50478ee5ecbf7a4d
};

});

parcelRegister("4NsfZ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $39220db316456429$export$e324594224ef24da);

var $9w2jV = parcelRequire("9w2jV");

var $9jCgU = parcelRequire("9jCgU");

var $bc2a8 = parcelRequire("bc2a8");

var $kpUPF = parcelRequire("kpUPF");

var $b6yo1 = parcelRequire("b6yo1");

var $iTkHr = parcelRequire("iTkHr");

var $VrLd0 = parcelRequire("VrLd0");

var $hc2fd = parcelRequire("hc2fd");

var $7BMTT = parcelRequire("7BMTT");

var $27SP3 = parcelRequire("27SP3");

var $DHvqm = parcelRequire("DHvqm");

var $gWAj1 = parcelRequire("gWAj1");

var $4u1bX = parcelRequire("4u1bX");

var $9Zwvs = parcelRequire("9Zwvs");

var $jIA25 = parcelRequire("jIA25");

var $4RIzA = parcelRequire("4RIzA");

var $1ntUB = parcelRequire("1ntUB");

var $hcEqM = parcelRequire("hcEqM");

var $4AM50 = parcelRequire("4AM50");

var $b1NgJ = parcelRequire("b1NgJ");

var $75ZOj = parcelRequire("75ZOj");

var $4ewzp = parcelRequire("4ewzp");

var $STfOf = parcelRequire("STfOf");

var $6wCHd = parcelRequire("6wCHd");
const $39220db316456429$export$e324594224ef24da = {
    changeTaskGroupParent: $9w2jV.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $9w2jV.nextGoBackToPreviousTaskGroup,
    setIsOpen: $9jCgU.setIsOpen,
    refreshAppState: $bc2a8.refreshAppState,
    setNudgeStep: $kpUPF.setNudgeStep,
    addMountedNudge: $b6yo1.addMountedNudge,
    removeMountedNudge: $b6yo1.removeMountedNudge,
    setShouldRenderComponent: $iTkHr.setShouldRenderComponent,
    setProjectState: $VrLd0.setProjectState,
    setHasNudgeActive: $hc2fd.setHasNudgeActive,
    forceHideNudge: $7BMTT.forceHideNudge,
    setHasEverSeenRoute: $27SP3.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $DHvqm.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $DHvqm.setRoadmapIsListEmpty,
    openNextTask: $gWAj1.openNextTask,
    resetIsQuickstartLoaded: $4u1bX.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $9Zwvs.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $jIA25.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $4RIzA.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $1ntUB.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $hcEqM.nextSetChecklistIsOpen,
    nextOpenTask: $4AM50.nextOpenTask,
    nextAutoExpand: $b1NgJ.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $75ZOj.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $4ewzp.nextGetTasks,
    syncVisibilityWithLocal: $STfOf.syncVisibilityWithLocal,
    universalDispatch: $6wCHd.universalDispatch
};

});
parcelRegister("9w2jV", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $c67ac35b88465cb8$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $c67ac35b88465cb8$export$57534cbc400a434c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $c67ac35b88465cb8$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $c67ac35b88465cb8$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup));
    };
const $c67ac35b88465cb8$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        if ((0, $7jTnu.fg)('jira_a11y_fix_returning_focus')) {
            const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
            const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $9ycBx.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
            const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
            const taskGroup = {
                previousTaskGroupParents: newPreviousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
        } else {
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $9ycBx.ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
            dispatch($c67ac35b88465cb8$var$setTaskGroup(taskGroup));
        }
    };

});
parcelRegister("6d5N9", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $968fd65112be9cd3$export$583b2d2422a6757f);

var $FppkK = parcelRequire("FppkK");

var $aYncF = parcelRequire("aYncF");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");
const $968fd65112be9cd3$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $968fd65112be9cd3$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $FppkK.setUserProperties)($968fd65112be9cd3$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $1uIew.default)(response.status, response.statusText);
    });
const $968fd65112be9cd3$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $968fd65112be9cd3$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $968fd65112be9cd3$export$583b2d2422a6757f = async (props)=>{
    const success = await $968fd65112be9cd3$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $968fd65112be9cd3$var$trySetUserProperties(props, 2);
};

});


parcelRegister("9jCgU", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $d6b89ce939fd1abc$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");
const $d6b89ce939fd1abc$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: isOpen
        });
    };
var $d6b89ce939fd1abc$export$2e2bcd8739ae039 = $d6b89ce939fd1abc$export$dcf23146e0a40195;

});
parcelRegister("3XHRA", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $5e767603cbb6a27b$export$eae834ce0286017a);

var $ln6Iy = parcelRequire("ln6Iy");

var $9ycBx = parcelRequire("9ycBx");
const $5e767603cbb6a27b$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
const $5e767603cbb6a27b$export$eae834ce0286017a = (state)=>{
    if ($5e767603cbb6a27b$export$6f17f2cb816105eb(state)) return (0, $9ycBx.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $9ycBx.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("bc2a8", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $f970723875566945$export$797c35e2e1d0d014);


var $z1I7k = parcelRequire("z1I7k");

var $gCeeo = parcelRequire("gCeeo");

var $31GRl = parcelRequire("31GRl");

var $a9ldn = parcelRequire("a9ldn");

var $9ycBx = parcelRequire("9ycBx");

var $79a1F = parcelRequire("79a1F");

var $6d5N9 = parcelRequire("6d5N9");

var $dELL6 = parcelRequire("dELL6");

var $8hqW7 = parcelRequire("8hqW7");

var $86LDA = parcelRequire("86LDA");

var $uMSsJ = parcelRequire("uMSsJ");

var $1ntUB = parcelRequire("1ntUB");

var $hcEqM = parcelRequire("hcEqM");

var $jIA25 = parcelRequire("jIA25");

var $9w2jV = parcelRequire("9w2jV");
const $f970723875566945$var$allTasks = [
    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
    ...(0, $9ycBx.JSM_BUSINESS_TASKS)
];
const $f970723875566945$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $9ycBx.convertToHaveSeenItTask)((0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $9ycBx.convertToHaveSeenItTask)((0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $9ycBx.convertToHaveSeenItTask)((0, $9ycBx.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $9ycBx.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $9ycBx.QUICKSTART_TYPE)).map((type)=>(0, $9ycBx.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $9ycBx.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $79a1F.pollBackend)({
            keys: [
                (0, $9ycBx.KEY_OPEN),
                (0, $9ycBx.KEY_DISMISSED),
                (0, $9ycBx.KEY_OPEN_TASK),
                (0, $9ycBx.KEY_TASK_GROUP),
                (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $9ycBx.KEY_JSW_ONBOARDING),
                (0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED),
                ...$f970723875566945$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $9ycBx.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $9ycBx.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $9ycBx.getBackendVisibilityKey)(type)];
                else if ((0, $9ycBx.KEY_DISMISSED) in backendState && backendState[0, $9ycBx.KEY_DISMISSED]) updatedState.visibility[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $9ycBx.KEY_OPEN] ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $uMSsJ.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $9ycBx.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $9ycBx.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $9ycBx.KEY_OPEN];
            if ((0, $9ycBx.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $9ycBx.KEY_OPEN_TASK];
            if ((0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $9ycBx.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $9ycBx.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $9ycBx.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $9ycBx.KEY_JSW_ONBOARDING] !== null && (0, $2b839a8453de5367$export$8a00ecf6498ee2fe) in backendState[0, $9ycBx.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $9ycBx.KEY_JSW_ONBOARDING][0, $2b839a8453de5367$export$8a00ecf6498ee2fe];
            }
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $a9ldn.PREMIUM_EDITION)) {
            dispatch((0, $9w2jV.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $9ycBx.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $86LDA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dELL6.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $z1I7k.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $9ycBx.PACKAGE_NAME),
            teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $8hqW7.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $a9ldn.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials) {
            const isOnboardingPremiumTrial = await (0, $31GRl.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!isReverseTrialForJSW && appEditions.software === (0, $a9ldn.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $hcEqM.nextSetChecklistIsOpen)(true));
            dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $jIA25.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $9w2jV.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $6d5N9.pushToBackend)({
                key: (0, $9ycBx.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $2b839a8453de5367$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $2b839a8453de5367$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $2b839a8453de5367$export$e3884212029f7bef = 'should-show-welcome-modal';
const $2b839a8453de5367$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $2b839a8453de5367$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $2b839a8453de5367$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $2b839a8453de5367$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $2b839a8453de5367$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $2b839a8453de5367$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $2b839a8453de5367$export$6e69f8dc03075ef8 = 'team-type';
const $2b839a8453de5367$export$c06666264cd35603 = 'team-type-shorthand';
const $2b839a8453de5367$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $2b839a8453de5367$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $2b839a8453de5367$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $2b839a8453de5367$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $2b839a8453de5367$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $2b839a8453de5367$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $2b839a8453de5367$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $2b839a8453de5367$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $2b839a8453de5367$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $2b839a8453de5367$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $2b839a8453de5367$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $2b839a8453de5367$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $2b839a8453de5367$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $2b839a8453de5367$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $2b839a8453de5367$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $2b839a8453de5367$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $2b839a8453de5367$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $2b839a8453de5367$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $2b839a8453de5367$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $2b839a8453de5367$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $2b839a8453de5367$export$468488291ccd988 = 'timelineAddItemNudge';
const $2b839a8453de5367$export$7a33548109ac931d = 'createFormNudge';
const $2b839a8453de5367$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $2b839a8453de5367$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $2b839a8453de5367$export$594d3436316492be = 'summaryViewNudge';
const $2b839a8453de5367$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $2b839a8453de5367$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $2b839a8453de5367$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $2b839a8453de5367$export$699265ec8ad9a740 = 'Software Development';
const $2b839a8453de5367$export$e07d1fa2da8ed874 = 'Customer Service';
const $2b839a8453de5367$export$76dcec3f438d9e56 = 'IT Support';
const $2b839a8453de5367$export$9a574c301f67ba30 = 'Human Resources';
const $2b839a8453de5367$export$363ec144a94029c8 = 'Finance';
const $2b839a8453de5367$export$df0fb32d68ae1e78 = 'Legal';
const $2b839a8453de5367$export$d9c0e3e59442fb4 = 'Marketing';
const $2b839a8453de5367$export$27dbc7d7ce66e6e3 = 'Operations';
const $2b839a8453de5367$export$a5dce388adf922bd = 'Sales';
const $2b839a8453de5367$export$e1473b31a257caff = 'Data Science';
const $2b839a8453de5367$export$85657457db93c2c2 = 'Product Management';
const $2b839a8453de5367$export$c0c2d1dfaeba89dd = 'Project Management';
const $2b839a8453de5367$export$2e6a7ad3ab9c82a3 = 'Design';
const $2b839a8453de5367$export$7b60378c3b4372e9 = 'Other or Personal';
const $2b839a8453de5367$export$572242e58bd07594 = 'CS';
const $2b839a8453de5367$export$d7de553940261eba = 'ITS';
const $2b839a8453de5367$export$4c29d0d04c15e55d = 'HR';
const $2b839a8453de5367$export$3950f7f841bf94b6 = 'FNC';
const $2b839a8453de5367$export$881249b988b6030f = 'LGL';
const $2b839a8453de5367$export$e4824f74b9879164 = 'MKT';
const $2b839a8453de5367$export$4f3cb0844009af52 = 'OPS';
const $2b839a8453de5367$export$1a65d50c4a641bb4 = 'SAL';
const $2b839a8453de5367$export$9ee64e8fbd8b03a2 = 'DS';
const $2b839a8453de5367$export$b8b1ac856ba1434b = 'DEV';
const $2b839a8453de5367$export$4f54a09a24fd1d74 = 'PDM';
const $2b839a8453de5367$export$79685802e8ff1098 = 'PJM';
const $2b839a8453de5367$export$e5c438b7501b5a24 = 'DES';
const $2b839a8453de5367$export$cbc0e551d91a692d = 'OTR';

parcelRegister("z1I7k", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $016ff2d2518db69d$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $016ff2d2518db69d$export$6da79f996c267010);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $016ff2d2518db69d$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $016ff2d2518db69d$var$SITE_PERSONALIZATION_ENDPOINT = `${$016ff2d2518db69d$var$PERSONALIZATION_ENDPOINT}/site/`;
const $016ff2d2518db69d$var$USER_PERSONALIZATION_ENDPOINT = `${$016ff2d2518db69d$var$PERSONALIZATION_ENDPOINT}/user/`;
const $016ff2d2518db69d$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $016ff2d2518db69d$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $016ff2d2518db69d$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $jGzN3.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $016ff2d2518db69d$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes?.find((att)=>att.name === traitName);
    };
const $016ff2d2518db69d$export$686752df505238be = $016ff2d2518db69d$var$getTraits($016ff2d2518db69d$var$fetchPersonalization($016ff2d2518db69d$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $016ff2d2518db69d$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $016ff2d2518db69d$export$6da79f996c267010 = $016ff2d2518db69d$var$getTraits($016ff2d2518db69d$var$fetchPersonalization($016ff2d2518db69d$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $016ff2d2518db69d$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

parcelRegister("31GRl", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $8ddabc55934459cc$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $8ddabc55934459cc$export$ef676f7f369f74fe);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $iCPdV = parcelRequire("iCPdV");
const $8ddabc55934459cc$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $8ddabc55934459cc$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $iCPdV.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $iCPdV.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $jGzN3.performGetRequestWithRetry)($8ddabc55934459cc$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $iCPdV.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $iCPdV.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $8ddabc55934459cc$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $8ddabc55934459cc$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("iCPdV", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $880bf1d3001e9a60$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $880bf1d3001e9a60$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $880bf1d3001e9a60$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $880bf1d3001e9a60$export$f389f8ca168b4a3a);

var $dnU6V = parcelRequire("dnU6V");

var $gYnSx = parcelRequire("gYnSx");
const $880bf1d3001e9a60$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $880bf1d3001e9a60$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $880bf1d3001e9a60$var$localStorage = (0, $dnU6V.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $880bf1d3001e9a60$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $880bf1d3001e9a60$var$localStorage.get($880bf1d3001e9a60$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $880bf1d3001e9a60$export$c3378895d06b5528 = ()=>{
    try {
        const value = $880bf1d3001e9a60$var$localStorage.get($880bf1d3001e9a60$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $880bf1d3001e9a60$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $880bf1d3001e9a60$var$localStorage.set($880bf1d3001e9a60$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $880bf1d3001e9a60$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $880bf1d3001e9a60$var$localStorage.set($880bf1d3001e9a60$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("79a1F", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $a820ac7275a95d77$export$8420ef0cee98de);

var $fnu0d = parcelRequire("fnu0d");

var $9ycBx = parcelRequire("9ycBx");
const $a820ac7275a95d77$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $fnu0d.get)({
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $9ycBx.PACKAGE_NAME),
            teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("fnu0d", function(module, exports) {

$parcel$export(module.exports, "get", () => $c086e1f54a79cb95$export$3988ae62b71be9a3);

var $5spib = parcelRequire("5spib");

var $4CEkC = parcelRequire("4CEkC");

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $jGzN3 = parcelRequire("jGzN3");

var $2Mqjh = parcelRequire("2Mqjh");

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
let $c086e1f54a79cb95$var$ufoExperiencesMap = {};
const $c086e1f54a79cb95$var$getUfoExperience = (key)=>{
    if (!$c086e1f54a79cb95$var$ufoExperiencesMap[key]) $c086e1f54a79cb95$var$ufoExperiencesMap[key] = new (0, $f39LL.UFOExperience)(key, {
        type: (0, $2lxLk.ExperienceTypes).Operation,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
    });
    return $c086e1f54a79cb95$var$ufoExperiencesMap[key];
};
const $c086e1f54a79cb95$export$c907f169d33b2e25 = ()=>{
    $c086e1f54a79cb95$var$ufoExperiencesMap = {};
};
const $c086e1f54a79cb95$export$a5b7a8c3b1c6e775 = ({ userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c086e1f54a79cb95$var$patchProperties = (response, propertiesPath)=>response && (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $c086e1f54a79cb95$export$3988ae62b71be9a3 = async (options)=>{
    const ufoExperience = $c086e1f54a79cb95$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $c086e1f54a79cb95$export$a5b7a8c3b1c6e775(options);
        const response = await (0, $jGzN3.performGetRequest)(url);
        if (response === null) (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $c086e1f54a79cb95$var$patchProperties(response, 'user');
        $c086e1f54a79cb95$var$patchProperties(response, 'instance');
        $c086e1f54a79cb95$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return response || {
            user: {},
            instance: {},
            project: {}
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $8KUFq.isClientFetchError)(error) && (0, $gYnSx.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("dELL6", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $c95fada5ff0e59fd$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $c95fada5ff0e59fd$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $c95fada5ff0e59fd$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $c95fada5ff0e59fd$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $c95fada5ff0e59fd$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $c95fada5ff0e59fd$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $c95fada5ff0e59fd$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $c95fada5ff0e59fd$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $c95fada5ff0e59fd$export$6c39ca65ca354e59);

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");

var $9ycBx = parcelRequire("9ycBx");

var $46NrI = parcelRequire("46NrI");
const $c95fada5ff0e59fd$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $9ycBx.ACTION_SUBJECT_ID), attributes);
};
const $c95fada5ff0e59fd$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $c95fada5ff0e59fd$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $c95fada5ff0e59fd$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $46NrI.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $c95fada5ff0e59fd$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $gYnSx.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $c95fada5ff0e59fd$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $c95fada5ff0e59fd$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $9ycBx.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("46NrI", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $220645f5a7e2c3df$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $220645f5a7e2c3df$export$3b914201960fa7a6);

var $7mF43 = parcelRequire("7mF43");

var $ln6Iy = parcelRequire("ln6Iy");
const $220645f5a7e2c3df$export$d64a7dd8c7cd80e0 = {
    [(0, $ln6Iy.CORE_PROJECT)]: 'workManagement',
    [(0, $ln6Iy.SOFTWARE_PROJECT)]: 'software',
    [(0, $ln6Iy.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $220645f5a7e2c3df$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $220645f5a7e2c3df$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(projectType);
    return null;
};
const $220645f5a7e2c3df$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(taskId.split('.').pop());
};

});


parcelRegister("8hqW7", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $53b23fbdedb29316$export$7f2186c37a3d095d);

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $gCeeo = parcelRequire("gCeeo");

var $9ycBx = parcelRequire("9ycBx");

var $cCGZI = parcelRequire("cCGZI");
const $53b23fbdedb29316$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $53b23fbdedb29316$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $53b23fbdedb29316$var$ONE_DAY = 86400000;
const $53b23fbdedb29316$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$53b23fbdedb29316$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $jGzN3.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $7jTnu.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $9ycBx.PACKAGE_NAME),
                teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $7jTnu.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $53b23fbdedb29316$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $cCGZI.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $53b23fbdedb29316$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $7jTnu.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $53b23fbdedb29316$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $53b23fbdedb29316$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("cCGZI", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $c5da128a7c764253$export$99f3e48748c2a8c3);

var $4elgJ = parcelRequire("4elgJ");

const $c5da128a7c764253$var$crossProjectBoardTraitSessionProvider = (0, $4elgJ.createSessionExpirableStorageProvider)((0, $70024ada6ee08235$export$fac14ff24e5b1e7a));
const $c5da128a7c764253$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $c5da128a7c764253$var$crossProjectBoardTraitSessionProvider.set((0, $70024ada6ee08235$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$c5da128a7c764253$var$crossProjectBoardTraitSessionProvider.get((0, $70024ada6ee08235$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $70024ada6ee08235$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("86LDA", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $d056ac553c2189c1$export$980c26b6f100081d);

var $jGzN3 = parcelRequire("jGzN3");
const $d056ac553c2189c1$export$980c26b6f100081d = ()=>(0, $jGzN3.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("uMSsJ", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $d41b9686fb79c7bc$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $d41b9686fb79c7bc$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $d41b9686fb79c7bc$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $d41b9686fb79c7bc$export$93d719890ad66653);

var $dnU6V = parcelRequire("dnU6V");

var $gZkaf = parcelRequire("gZkaf");
const $d41b9686fb79c7bc$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $gZkaf.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $d41b9686fb79c7bc$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $gZkaf.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $d41b9686fb79c7bc$var$store = (0, $dnU6V.createLocalStorageProvider)('quickstart');
const $d41b9686fb79c7bc$export$5aa524d86254b4f = (key, value)=>{
    $d41b9686fb79c7bc$var$store.set(key, value);
};
const $d41b9686fb79c7bc$export$93d719890ad66653 = (key)=>$d41b9686fb79c7bc$var$store.get(key);

});
parcelRegister("gZkaf", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $e5e0a63f9d11b989$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $e5e0a63f9d11b989$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $e5e0a63f9d11b989$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $e5e0a63f9d11b989$export$293f6b2affa6ea5a);

var $46NrI = parcelRequire("46NrI");







const $e5e0a63f9d11b989$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $e5e0a63f9d11b989$export$9711f11998d5795c = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $e5e0a63f9d11b989$export$995248f3b43d8505 = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $e5e0a63f9d11b989$export$293f6b2affa6ea5a = (taskId)=>`${(0, $46NrI.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("1ntUB", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $90c4f819f308a0de$export$f24c05f83b880547);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $90c4f819f308a0de$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED : (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $uMSsJ.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: false
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_DISMISSED),
            value: isDismissed
        });
    };

});

parcelRegister("hcEqM", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $4e92599f1808f020$export$4249eabbb34e2e69);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $4e92599f1808f020$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $uMSsJ.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("jIA25", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $53dc3dee14098ca0$export$d6628d41a3bec42d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6d5N9 = parcelRequire("6d5N9");
const $53dc3dee14098ca0$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $6d5N9.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});


parcelRegister("kpUPF", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $4ac0db746ee3e19c$export$4debc323813b6997);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4ac0db746ee3e19c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $4ac0db746ee3e19c$export$2e2bcd8739ae039 = $4ac0db746ee3e19c$export$4debc323813b6997;

});

parcelRegister("b6yo1", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $a7896299b4c2538c$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $a7896299b4c2538c$export$748f4cda8ab98c91);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a7896299b4c2538c$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $a7896299b4c2538c$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("iTkHr", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $9e529cdb63511cc5$export$1f9c6770ed938b6e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $9e529cdb63511cc5$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $9e529cdb63511cc5$export$2e2bcd8739ae039 = $9e529cdb63511cc5$export$1f9c6770ed938b6e;

});

parcelRegister("VrLd0", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $fb6d4843482b7a21$export$1ba498e440c0a1e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $fb6d4843482b7a21$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $fb6d4843482b7a21$export$2e2bcd8739ae039 = $fb6d4843482b7a21$export$1ba498e440c0a1e4;

});

parcelRegister("hc2fd", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $655ce5c27a1ef578$export$497c281e6eb0786e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $655ce5c27a1ef578$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $655ce5c27a1ef578$export$2e2bcd8739ae039 = $655ce5c27a1ef578$export$497c281e6eb0786e;

});

parcelRegister("7BMTT", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $748cd7120d515b8c$export$6d1ed97b83a62e8e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $748cd7120d515b8c$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("27SP3", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $8cdbd8bb590a918c$export$28e0a4314a1ce52f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $8cdbd8bb590a918c$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $8cdbd8bb590a918c$export$2e2bcd8739ae039 = $8cdbd8bb590a918c$export$28e0a4314a1ce52f;

});

parcelRegister("DHvqm", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $f78d96b92dcbe1de$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $f78d96b92dcbe1de$export$932967764e7a0b31);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f78d96b92dcbe1de$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $f78d96b92dcbe1de$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("gWAj1", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $163de5e21e24ce13$export$867dbb6d61569ae9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $uMSsJ = parcelRequire("uMSsJ");

var $4AM50 = parcelRequire("4AM50");
const $163de5e21e24ce13$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $uMSsJ.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $4AM50.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("4AM50", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $b3d3db0c7001002a$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $b3d3db0c7001002a$export$cc5f3544a6cb2922);


var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");

var $kpUPF = parcelRequire("kpUPF");

var $hc2fd = parcelRequire("hc2fd");
const $b3d3db0c7001002a$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $b3d3db0c7001002a$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($b3d3db0c7001002a$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $hc2fd.setHasNudgeActive)(false, taskId));
        else dispatch((0, $hc2fd.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $9ycBx.SCRUM_ONBOARDING_TASK)) dispatch((0, $kpUPF.setNudgeStep)((0, $2b839a8453de5367$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $9ycBx.KANBAN_ONBOARDING_TASK)) dispatch((0, $kpUPF.setNudgeStep)((0, $2b839a8453de5367$export$3366ddefe77d5112)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $9ycBx.ADD_COLUMNS_TASK)) dispatch((0, $kpUPF.setNudgeStep)((0, $2b839a8453de5367$export$3366ddefe77d5112)));
        else dispatch((0, $kpUPF.setNudgeStep)(''));
    };
const $b3d3db0c7001002a$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($b3d3db0c7001002a$var$openTask(taskId));
        dispatch((0, $hc2fd.setHasNudgeActive)(false, taskId));
        dispatch((0, $kpUPF.setNudgeStep)(''));
    };

});


parcelRegister("4u1bX", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $01d5b170ba597bd8$export$bda085a823763e5a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $3XHRA = parcelRequire("3XHRA");
const $01d5b170ba597bd8$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("9Zwvs", function(module, exports) {

$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $865d905b5ed9ce34$export$87fe8079a4ed9766);


var $9ycBx = parcelRequire("9ycBx");

var $79a1F = parcelRequire("79a1F");

var $dELL6 = parcelRequire("dELL6");

var $86LDA = parcelRequire("86LDA");

var $1ntUB = parcelRequire("1ntUB");
const $865d905b5ed9ce34$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $9ycBx.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $9ycBx.QUICKSTART_TYPE)).map((type)=>(0, $9ycBx.getBackendVisibilityKey)(type));
        const backendState = await (0, $79a1F.pollBackend)({
            keys: [
                (0, $9ycBx.KEY_OPEN),
                (0, $9ycBx.KEY_DISMISSED),
                (0, $9ycBx.KEY_OPEN_TASK),
                (0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $9ycBx.KEY_JSW_ONBOARDING),
                ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $9ycBx.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $9ycBx.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $9ycBx.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $9ycBx.getBackendVisibilityKey)(type)];
                else if ((0, $9ycBx.KEY_DISMISSED) in backendState && backendState[0, $9ycBx.KEY_DISMISSED]) updatedState.visibility[type] = (0, $9ycBx.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $9ycBx.KEY_OPEN] ? (0, $9ycBx.QUICKSTART_UI_STATUS).OPEN : (0, $9ycBx.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $9ycBx.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $9ycBx.KEY_DISMISSED];
            if ((0, $9ycBx.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $9ycBx.KEY_OPEN];
            if ((0, $9ycBx.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $9ycBx.KEY_OPEN_TASK];
            if ((0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $9ycBx.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $9ycBx.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $9ycBx.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $9ycBx.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $9ycBx.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $9ycBx.KEY_JSW_ONBOARDING] !== null && (0, $2b839a8453de5367$export$8a00ecf6498ee2fe) in backendState[0, $9ycBx.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $9ycBx.KEY_JSW_ONBOARDING][0, $2b839a8453de5367$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $9ycBx.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $86LDA.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $1ntUB.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dELL6.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("4RIzA", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $d99f03d4977e428c$export$4eac017dcde0be8f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $6d5N9 = parcelRequire("6d5N9");
const $d99f03d4977e428c$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $9ycBx.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $6d5N9.pushToBackend)({
            key: (0, $9ycBx.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("b1NgJ", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $940a31066334aca1$export$3d24e97d30cfd09e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7jTnu = parcelRequire("7jTnu");

var $9ycBx = parcelRequire("9ycBx");

var $5JVW2 = parcelRequire("5JVW2");

var $uMSsJ = parcelRequire("uMSsJ");

var $4AM50 = parcelRequire("4AM50");
const $940a31066334aca1$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $5JVW2.localStorageProvider)().get({
            accountId: (0, $9ycBx.ACCOUNT_ID),
            key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $uMSsJ.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if ((0, $7jTnu.fg)('jira_a11y_fix_returning_focus')) {
            if (openTask === currentTriggerForTaskGroupParent) return;
        }
        dispatch((0, $4AM50.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("5JVW2", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $8f126aa766b95c06$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $8f126aa766b95c06$export$f2666fae743fa5f);

var $4elgJ = parcelRequire("4elgJ");

var $gYnSx = parcelRequire("gYnSx");

var $9ycBx = parcelRequire("9ycBx");
const $8f126aa766b95c06$var$DAYS_BEFORE_EXPIRY = 1;
const $8f126aa766b95c06$var$DAY = 86400000;
const $8f126aa766b95c06$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $8f126aa766b95c06$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $8f126aa766b95c06$var$DAYS_BEFORE_EXPIRY * $8f126aa766b95c06$var$DAY;
};
let $8f126aa766b95c06$var$localStorage;
const $8f126aa766b95c06$export$aa821bfb3308a1f5 = ()=>{
    if ($8f126aa766b95c06$var$localStorage) return $8f126aa766b95c06$var$localStorage;
    const provider = (0, $4elgJ.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gYnSx.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }), value, $8f126aa766b95c06$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($8f126aa766b95c06$var$getKey({
            accountId: accountId,
            key: key
        }));
    $8f126aa766b95c06$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $8f126aa766b95c06$var$localStorage;
};
const $8f126aa766b95c06$export$f2666fae743fa5f = (value)=>{
    $8f126aa766b95c06$export$aa821bfb3308a1f5().set({
        accountId: (0, $9ycBx.ACCOUNT_ID),
        key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("75ZOj", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $ef47ceb0db6e67e3$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9ycBx = parcelRequire("9ycBx");

var $5JVW2 = parcelRequire("5JVW2");

var $hc2fd = parcelRequire("hc2fd");
const $ef47ceb0db6e67e3$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $9ycBx.ACCOUNT_ID),
            key: (0, $9ycBx.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $5JVW2.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $hc2fd.setHasNudgeActive)(true));
            (0, $5JVW2.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("4ewzp", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $58d7175ee2e35561$export$15d877e1f3abf489);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6P4lT = parcelRequire("6P4lT");
const $58d7175ee2e35561$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
        const { taskList: taskList } = getState();
        const tasks = (0, $6P4lT.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("6P4lT", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $888e4567977ab846$export$d1f442602a91e7cc);

var $epTsa = parcelRequire("epTsa");

var $lopBx = parcelRequire("lopBx");

var $7jTnu = parcelRequire("7jTnu");


var $a9ldn = parcelRequire("a9ldn");

var $LFsl3 = parcelRequire("LFsl3");

var $gYnSx = parcelRequire("gYnSx");

var $9ycBx = parcelRequire("9ycBx");

var $dt54n = parcelRequire("dt54n");

var $1KmSm = parcelRequire("1KmSm");

var $koyuo = parcelRequire("koyuo");

var $7y7co = parcelRequire("7y7co");

var $8rJAF = parcelRequire("8rJAF");

var $cYgSg = parcelRequire("cYgSg");

var $emLqf = parcelRequire("emLqf");

var $c4gw9 = parcelRequire("c4gw9");

var $eUvg6 = parcelRequire("eUvg6");

var $feWch = parcelRequire("feWch");

var $7A9H8 = parcelRequire("7A9H8");
const $888e4567977ab846$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    const [expConfig] = (0, $epTsa.UNSAFE_noExposureExp)('jira_rt_quickstart_m1');
    if (variants.includes((0, $7y7co.JSW).experiment.jswReverseTrial) && !expConfig.get('isEnabled', false)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $9ycBx.ROOT_TASK) ? (0, $9ycBx.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $9ycBx.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $cYgSg.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $9ycBx.ROOT_TASK];
    return {
        title: title,
        items: (0, $cYgSg.getTasks)(variants, taskVariants, items)
    };
};
const $888e4567977ab846$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $9ycBx.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $2b839a8453de5367$export$3366ddefe77d5112));
    if ((0, $lopBx.isFedRamp)()) variants.add((0, $7y7co.JSW).experience.fedRamp);
    if (premiumTrialOnSignup) {
        variants.add((0, $7y7co.JSW).experiment.jswReverseTrial);
        (0, $epTsa.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true) && variants.add((0, $7y7co.JSW).experiment.rtQuickstartM1);
    }
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $7y7co.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $7y7co.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $7y7co.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== 'software-boards') variants.add((0, $7y7co.JSW).experience.kanbanOnboarding);
    if (canCreateProject === false) variants.add((0, $7y7co.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $7y7co.JSW).projectStyle.teamManaged);
    else variants.add((0, $7y7co.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $7y7co.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $7y7co.JSW).userRole.jiraAdmin);
        variants.add((0, $7y7co.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $7y7co.JSW).userRole.siteAdmin);
        variants.add((0, $7y7co.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $a9ldn.FREE_EDITION)) variants.add((0, $7y7co.JSW).edition.free);
    else if (projectState?.edition === (0, $a9ldn.STANDARD_EDITION)) variants.add((0, $7y7co.JSW).edition.standard);
    else if (projectState?.edition === (0, $a9ldn.PREMIUM_EDITION)) variants.add((0, $7y7co.JSW).edition.premium);
    if ((0, $dt54n.isRoadmapRoute)(routeName)) variants.add((0, $7y7co.JSW).route.softwareRoadmap);
    else if (routeName === 'software-backlog') variants.add((0, $7y7co.JSW).route.softwareBacklog);
    else if (routeName === 'software-boards') variants.add((0, $7y7co.JSW).route.softwareBoard);
    else if (routeName === 'software-list' || routeName === 'software-list-classic') variants.add((0, $7y7co.JSW).route.softwareList);
    else if (routeName === 'project-settings-software-access') variants.add((0, $7y7co.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === 'issue') variants.add((0, $7y7co.JSW).route.issue);
    else if ((routeName === 'software-calendar' || routeName === 'software-calendar-classic') && (0, $7jTnu.fg)('software_calendar_quickstart_onboarding')) variants.add((0, $7y7co.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $7y7co.JSW).experiment.customizeSiteName);
    return $888e4567977ab846$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $7y7co.JSW).taskVariants,
        taskList: (0, $7y7co.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList = (0, $8rJAF.JWM).taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5 })=>{
    const variants = [];
    variants.push((0, $8rJAF.JWM).experiments.projectTheming);
    if (isEligibleForTailoredOnboardingM2P5) return $888e4567977ab846$export$e21b96de210942({
        taskGroupParent: taskGroupParent,
        teamType: teamType
    });
    if (projectState?.isProjectAdmin) variants.push((0, $8rJAF.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) variants.push((0, $8rJAF.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $8rJAF.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $8rJAF.JWM).experiments.isSampleProject);
    else variants.push((0, $8rJAF.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $8rJAF.JWM).experiments.trelloCrossflow);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $8rJAF.JWM).taskVariants,
        taskList: taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $koyuo.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $koyuo.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).JIRA_ADMIN) variants.push((0, $koyuo.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $1KmSm.USER_ROLE).SITE_ADMIN) variants.push((0, $koyuo.JSM).userRole.siteAdmin);
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $koyuo.JSM).taskVariants,
        taskList: (0, $koyuo.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, isEligibleForTailoredOnboardingScrumAndSoftwareKanban)=>{
    const variants = [];
    if (features?.hasBacklog) variants.push((0, $feWch.Feature).hasBacklog);
    if (features?.hasSprint) variants.push((0, $feWch.Feature).hasSprint);
    if (features?.hasSummaryPage && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasSummaryPage);
    if (features?.hasRoadmap && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasRoadmap);
    if (features?.hasList && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasList);
    if (features?.hasCalendar && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasCalendar);
    if (features?.hasCode && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasCode);
    if (features?.hasForms && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasForms);
    if (features?.hasPages && (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $feWch.Feature).hasPages);
    if (!(0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name') && isEligibleForTailoredOnboardingScrumAndSoftwareKanban) variants.push((0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible);
    if ((0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) variants.push((0, $eUvg6.FeatureGate).removeInitialProjectTemplateName);
    if (teamType && (0, $LFsl3.isTailoredOnboardingTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name') ? (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants : (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariantsOld,
        taskList: (0, $c4gw9.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$e21b96de210942 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $LFsl3.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(`teamType.${teamType}`);
    else variants.push('teamType.everythingElse');
    return $888e4567977ab846$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name') ? (0, $7A9H8.TAILORED_ONBOARDING_BUSINESS_CONFIG) : (0, $c4gw9.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $c4gw9.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $888e4567977ab846$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, isEligibleForTailoredOnboardingM3: isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban: isEligibleForTailoredOnboardingScrumAndSoftwareKanban, features: features })=>{
    if ((0, $emLqf.isJwmProject)(projectState)) return $888e4567977ab846$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $emLqf.isJsmProject)(projectState)) return $888e4567977ab846$var$createJsmTasks(projectState, taskGroupParent);
    // We cannot do these in the config itself as we need to fallback to createJswTasks for other users
    // And unlike previous QS experiments, we want to change the entire QS for these users so a new config makes sense over variants to the existing JSW one
    if (!(0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) {
        if (isEligibleForTailoredOnboardingM3 || isEligibleForTailoredOnboardingScrumAndSoftwareKanban) return $888e4567977ab846$export$d9d83c8e96505820(taskGroupParent, teamType, features, isEligibleForTailoredOnboardingScrumAndSoftwareKanban);
    }
    if ((0, $7jTnu.fg)('to-cleanup-remove-initial-project-template-name')) {
        const tailoredOnboardingTasks = $888e4567977ab846$export$d9d83c8e96505820(taskGroupParent, teamType, features);
        // TODO: Remove length check on cleanup of to-cleanup-remove-initial-project-template-name
        // It is just a safety fallback if tailored onboarding tasks are empty but this should never happen
        if (tailoredOnboardingTasks.items.length > 0) return tailoredOnboardingTasks;
        // TODO: Remove this error on cleanup of to-cleanup-remove-initial-project-template-name
        // This should never happen
        (0, $gYnSx.default)({
            error: new Error('tailored onboarding tasks are empty'),
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $9ycBx.PACKAGE_NAME),
                teamName: (0, $9ycBx.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: 'tailored onboarding tasks are empty',
                teamType: teamType,
                hasBacklog: features?.hasBacklog,
                hasSprint: features?.hasSprint,
                hasSummaryPage: features?.hasSummaryPage,
                hasRoadmap: features?.hasRoadmap,
                hasList: features?.hasList,
                hasCalendar: features?.hasCalendar,
                hasCode: features?.hasCode,
                hasForms: features?.hasForms,
                hasPages: features?.hasPages
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $888e4567977ab846$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("LFsl3", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingTeamType", () => $2b571464d35dbda4$export$b924c0b3ec4d268e);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $2b571464d35dbda4$export$26c385918d734203);

var $8IjPx = parcelRequire("8IjPx");
const $2b571464d35dbda4$export$b924c0b3ec4d268e = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8IjPx.tailoredTeamTypes).includes(teamType);
};
const $2b571464d35dbda4$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8IjPx.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("8IjPx", function(module, exports) {

$parcel$export(module.exports, "tailoredTeamTypes", () => $568d03b0884f9ed5$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $568d03b0884f9ed5$export$52c5394d6e6cfcf3);

const $568d03b0884f9ed5$export$a1fbb7d965e15a39 = [
    (0, $2b839a8453de5367$export$e5c438b7501b5a24),
    (0, $2b839a8453de5367$export$d7de553940261eba),
    (0, $2b839a8453de5367$export$e4824f74b9879164),
    (0, $2b839a8453de5367$export$4f3cb0844009af52),
    (0, $2b839a8453de5367$export$cbc0e551d91a692d),
    (0, $2b839a8453de5367$export$4f54a09a24fd1d74),
    (0, $2b839a8453de5367$export$79685802e8ff1098),
    (0, $2b839a8453de5367$export$b8b1ac856ba1434b)
];
const $568d03b0884f9ed5$export$52c5394d6e6cfcf3 = [
    (0, $2b839a8453de5367$export$e5c438b7501b5a24),
    (0, $2b839a8453de5367$export$d7de553940261eba),
    (0, $2b839a8453de5367$export$cbc0e551d91a692d),
    (0, $2b839a8453de5367$export$4f54a09a24fd1d74),
    (0, $2b839a8453de5367$export$79685802e8ff1098),
    (0, $2b839a8453de5367$export$b8b1ac856ba1434b)
];

});


parcelRegister("dt54n", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $dbcd2c9ba5e49677$export$d1fa67c1ffb68871);
const $dbcd2c9ba5e49677$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};

});

parcelRegister("1KmSm", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $2ef1b0f2207fd5ce$export$8eeb199b23203523);
const $2ef1b0f2207fd5ce$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("koyuo", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $2c85504c5ef985eb$export$63f289f2da861d35);

var $dmVCq = parcelRequire("dmVCq");
const $2c85504c5ef985eb$export$63f289f2da861d35 = {
    taskList: (0, $dmVCq.JSM_TASK_LIST),
    taskVariants: (0, $dmVCq.JSM_TASK_VARIANTS),
    userRole: (0, $dmVCq.UserRole),
    experiments: (0, $dmVCq.Experiments)
};

});
parcelRegister("dmVCq", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $39979c1b128d3c9a$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $39979c1b128d3c9a$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $39979c1b128d3c9a$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $39979c1b128d3c9a$export$5b68aef408c932d9);

var $9ycBx = parcelRequire("9ycBx");

var $8pEHr = parcelRequire("8pEHr");
const $39979c1b128d3c9a$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $8pEHr.messages).rootTitle,
        items: [
            (0, $9ycBx.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $9ycBx.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $9ycBx.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $39979c1b128d3c9a$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $39979c1b128d3c9a$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $39979c1b128d3c9a$export$5b68aef408c932d9 = {
    [(0, $9ycBx.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("8pEHr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ffaf571352a2cc1d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ffaf571352a2cc1d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("7y7co", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $69137b6bfd6791a4$export$4cfe6e52f2e72a54);

var $eUvg6 = parcelRequire("eUvg6");
const $69137b6bfd6791a4$export$4cfe6e52f2e72a54 = {
    taskList: (0, $eUvg6.TASK_LIST),
    taskVariants: (0, $eUvg6.TASK_VARIANTS),
    experiment: (0, $eUvg6.Experiment),
    experience: (0, $eUvg6.Experience),
    projectStyle: (0, $eUvg6.ProjectStyle),
    userRole: (0, $eUvg6.UserRole),
    edition: (0, $eUvg6.Edition),
    route: (0, $eUvg6.Route),
    permissions: (0, $eUvg6.Permissions),
    trait: (0, $eUvg6.Trait)
};

});
parcelRegister("eUvg6", function(module, exports) {

$parcel$export(module.exports, "FeatureGate", () => $b0c17d2eb7065ae3$export$d4ba9a3e7000cca8);
$parcel$export(module.exports, "Experiment", () => $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $b0c17d2eb7065ae3$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $b0c17d2eb7065ae3$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "UserRole", () => $b0c17d2eb7065ae3$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $b0c17d2eb7065ae3$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $b0c17d2eb7065ae3$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $b0c17d2eb7065ae3$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $b0c17d2eb7065ae3$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $b0c17d2eb7065ae3$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $b0c17d2eb7065ae3$export$36f4d47dfe11b613);

var $9ycBx = parcelRequire("9ycBx");

var $4J9Xs = parcelRequire("4J9Xs");
const $b0c17d2eb7065ae3$export$d4ba9a3e7000cca8 = {
    removeInitialProjectTemplateName: 'to-cleanup-remove-initial-project-template-name'
};
const $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    rtQuickstartM1: 'experiment.rtQuickstartM1',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $b0c17d2eb7065ae3$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $b0c17d2eb7065ae3$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $b0c17d2eb7065ae3$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $b0c17d2eb7065ae3$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $b0c17d2eb7065ae3$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $b0c17d2eb7065ae3$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $b0c17d2eb7065ae3$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST = [
    (0, $9ycBx.ADD_COLUMNS_TASK),
    (0, $9ycBx.CREATE_PROJECT_TASK),
    (0, $9ycBx.CREATE_ISSUE_TASK),
    (0, $9ycBx.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $9ycBx.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $9ycBx.INVITE_TEAMMATES_TASK),
    (0, $9ycBx.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $9ycBx.CAPTURE_INTEGRATIONS_TASK),
    (0, $9ycBx.FIND_HELP_TASK),
    (0, $9ycBx.SET_UP_BOARD_TASK),
    (0, $9ycBx.GET_MOBILE_APP_TASK),
    (0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $9ycBx.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $9ycBx.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $9ycBx.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $9ycBx.MONITOR_MANAGE_RISK_TASK),
    (0, $9ycBx.SCRUM_ONBOARDING_TASK),
    (0, $9ycBx.CUSTOMIZE_SITE_NAME_TASK),
    (0, $9ycBx.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $9ycBx.GET_STARTED_LIST_TASK),
    (0, $9ycBx.CALENDAR_VIEW_TASK)
];
const $b0c17d2eb7065ae3$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $4J9Xs.messages).rootTitle,
        items: $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $4J9Xs.messages).reverseTrialRootTitle,
        items: $b0c17d2eb7065ae3$var$DEFAULT_TASK_LIST
    },
    [(0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $4J9Xs.messages).reverseTrialCardTitle,
        items: [
            (0, $9ycBx.ADVANCED_ROADMAPS_TASK),
            (0, $9ycBx.CHANGE_CONTROL_TASK),
            (0, $9ycBx.AUTOMATIONS_TASK),
            (0, $9ycBx.SITE_ADMINISTRATIONS_TASK),
            (0, $9ycBx.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $4J9Xs.messages).premiumPlanTitle,
        items: [
            (0, $9ycBx.ADVANCED_ROADMAPS_TASK),
            (0, $9ycBx.CHANGE_CONTROL_TASK),
            (0, $9ycBx.AUTOMATIONS_TASK),
            (0, $9ycBx.SITE_ADMINISTRATIONS_TASK),
            (0, $9ycBx.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $4J9Xs.messages).premiumPlanTitle,
        items: [
            (0, $9ycBx.ADVANCED_ROADMAPS_TASK),
            (0, $9ycBx.AUTOMATIONS_TASK)
        ]
    },
    [(0, $9ycBx.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $4J9Xs.messages).standardPlanTitle,
        items: [
            (0, $9ycBx.AUTOMATIONS_TASK),
            (0, $9ycBx.USER_MANAGEMENT_TASK),
            (0, $9ycBx.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $b0c17d2eb7065ae3$var$PLAN_ONBOARDING_TASKS = {
    [(0, $9ycBx.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.rtQuickstartM1,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.premium,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$6f4a0f769e61929.standard,
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $b0c17d2eb7065ae3$export$36f4d47dfe11b613 = {
    ...$b0c17d2eb7065ae3$var$PLAN_ONBOARDING_TASKS,
    [(0, $9ycBx.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin,
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $9ycBx.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.siteAdmin,
                        $b0c17d2eb7065ae3$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.projectAdmin,
                        $b0c17d2eb7065ae3$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.projectAdmin,
                        $b0c17d2eb7065ae3$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin,
                        $b0c17d2eb7065ae3$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.projectAdmin,
                        $b0c17d2eb7065ae3$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$eb3485a690c2f0b8.admin,
                        $b0c17d2eb7065ae3$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $b0c17d2eb7065ae3$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $b0c17d2eb7065ae3$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("4J9Xs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3416e8428d224ccf$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3416e8428d224ccf$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("8rJAF", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $77b9f961c5c24ac0$export$3ff26c80cb588e12);

var $4PmHv = parcelRequire("4PmHv");

var $7BHaP = parcelRequire("7BHaP");

var $5ImmZ = parcelRequire("5ImmZ");
const $77b9f961c5c24ac0$export$3ff26c80cb588e12 = {
    taskList: (0, $4PmHv.TASK_LIST),
    taskVariants: (0, $4PmHv.TASK_VARIANTS),
    userRole: (0, $5ImmZ.UserRole),
    experiments: (0, $7BHaP.Experiments)
};

});
parcelRegister("4PmHv", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $a08aca66351aa30d$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $a08aca66351aa30d$export$36f4d47dfe11b613);

var $9ycBx = parcelRequire("9ycBx");

var $7BHaP = parcelRequire("7BHaP");

var $dj1vQ = parcelRequire("dj1vQ");

var $5ImmZ = parcelRequire("5ImmZ");
const $a08aca66351aa30d$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $dj1vQ.messages).rootTitle,
        items: [
            (0, $9ycBx.JWM_CREATE_PROJECT_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $9ycBx.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $9ycBx.JWM_PROJECT_SUMMARY_TASK),
            (0, $9ycBx.GET_STARTED_LIST_TASK),
            (0, $9ycBx.JWM_CALENDAR_TASK),
            (0, $9ycBx.JWM_TIMELINE_TASK),
            (0, $9ycBx.JWM_BUILD_FORM_TASK),
            (0, $9ycBx.JWM_BACKGROUND_COLOR_TASK),
            (0, $9ycBx.JWM_FEEDBACK_TASK),
            (0, $9ycBx.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $9ycBx.JWM_SHARE_PROJECT_TASK),
            (0, $9ycBx.JWM_CREATE_YOUR_OWN_PROJECT_TASK)
        ]
    }
});
const $a08aca66351aa30d$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $9ycBx.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $9ycBx.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $9ycBx.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $9ycBx.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $9ycBx.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $9ycBx.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $9ycBx.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $9ycBx.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $9ycBx.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $9ycBx.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $9ycBx.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $9ycBx.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $a08aca66351aa30d$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $9ycBx.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $9ycBx.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $9ycBx.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $9ycBx.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $9ycBx.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $9ycBx.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $9ycBx.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $9ycBx.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $9ycBx.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $9ycBx.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $9ycBx.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $9ycBx.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $9ycBx.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $a08aca66351aa30d$export$36f4d47dfe11b613 = {
    ...$a08aca66351aa30d$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS,
    ...$a08aca66351aa30d$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS,
    [(0, $9ycBx.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).projectTheming,
                        (0, $5ImmZ.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isNotSampleProject,
                        (0, $7BHaP.Experiments).trelloCrossflow,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $7BHaP.Experiments).isSampleProject,
                        (0, $5ImmZ.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("7BHaP", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $57326be2952b3617$export$c8d6ffd15214553a);
const $57326be2952b3617$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("dj1vQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6ba3f21c8d7d2fe3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6ba3f21c8d7d2fe3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("5ImmZ", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $0235b2ed52c10505$export$eb3485a690c2f0b8);
const $0235b2ed52c10505$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("cYgSg", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $298a0d20f3b1d08a$export$20b82b4a32771893);

var $iyRnt = parcelRequire("iyRnt");
const $298a0d20f3b1d08a$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $iyRnt.getConditional)(visibility, variants) : true;
const $298a0d20f3b1d08a$var$getTaskPosition = (variants, position)=>(0, $iyRnt.getConditional)(position, variants);
const $298a0d20f3b1d08a$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$298a0d20f3b1d08a$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$298a0d20f3b1d08a$var$getTaskPosition(variants, taskVariants[taskA].position) - $298a0d20f3b1d08a$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("iyRnt", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $80dfc494f4751e25$export$fe3161cde0106bba);
const $80dfc494f4751e25$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("emLqf", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $99044a2d2d5f79ec$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $99044a2d2d5f79ec$export$a972ed853ed1d469);

var $ln6Iy = parcelRequire("ln6Iy");
const $99044a2d2d5f79ec$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $ln6Iy.CORE_PROJECT);
const $99044a2d2d5f79ec$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);

});

parcelRegister("c4gw9", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $9c945d174f9c912a$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $9c945d174f9c912a$export$eb17ad7838835d2a);


var $9ycBx = parcelRequire("9ycBx");

var $iKhBT = parcelRequire("iKhBT");

var $8sWUb = parcelRequire("8sWUb");

var $5shRe = parcelRequire("5shRe");

var $a1b8c = parcelRequire("a1b8c");

var $mLM2w = parcelRequire("mLM2w");

var $i5ttL = parcelRequire("i5ttL");

var $e8Fhw = parcelRequire("e8Fhw");

var $fHbA0 = parcelRequire("fHbA0");

var $ifDp7 = parcelRequire("ifDp7");

var $7OyjZ = parcelRequire("7OyjZ");
const $9c945d174f9c912a$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD),
            (0, $9ycBx.TAILORED_ONBOARDING_BACKLOG),
            (0, $9ycBx.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $9c945d174f9c912a$export$83849aa73c0a20db = {
    taskList: $9c945d174f9c912a$export$2757f7b23d120b9b,
    taskVariants: (0, $ifDp7.TAILORED_ONBOARDING_SINGLE_CONFIG),
    // todo: remove this on `to-cleanup-remove-initial-project-template-name` cleanup
    taskVariantsOld: (0, $7OyjZ.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $9c945d174f9c912a$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: (0, $iKhBT.messages).rootTitle,
        items: [
            (0, $9ycBx.TAILORED_ONBOARDING_SUMMARY),
            (0, $9ycBx.TAILORED_ONBOARDING_CALENDAR),
            (0, $9ycBx.TAILORED_ONBOARDING_LIST),
            (0, $9ycBx.TAILORED_ONBOARDING_TIMELINE),
            (0, $9ycBx.TAILORED_ONBOARDING_PAGES),
            (0, $9ycBx.TAILORED_ONBOARDING_FORM),
            (0, $9ycBx.TAILORED_ONBOARDING_INVITE),
            (0, $9ycBx.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $9c945d174f9c912a$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $2b839a8453de5367$export$4f54a09a24fd1d74:
            return 0, $5shRe.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $2b839a8453de5367$export$79685802e8ff1098:
            return 0, $8sWUb.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $2b839a8453de5367$export$e5c438b7501b5a24:
            return 0, $a1b8c.DESIGN_VARIANTS;
        case 0, $2b839a8453de5367$export$d7de553940261eba:
            return 0, $mLM2w.IT_SUPPORT_VARIANTS;
        case 0, $2b839a8453de5367$export$cbc0e551d91a692d:
            return 0, $i5ttL.OTHER_PERSONAL_VARIANTS;
        case 0, $2b839a8453de5367$export$b8b1ac856ba1434b:
            return 0, $fHbA0.SOFTWARE_VARIANTS;
        default:
            return 0, $e8Fhw.EVERYTHING_ELSE_VARIANTS;
    }
};
const $9c945d174f9c912a$export$eb17ad7838835d2a = {
    taskList: $9c945d174f9c912a$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $9c945d174f9c912a$export$3c409334669aec75
};

});
parcelRegister("iKhBT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $47efb1049993f4e6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $47efb1049993f4e6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("8sWUb", function(module, exports) {

$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $d1467d7397e68eff$export$bdd338c80f8962df);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $d1467d7397e68eff$export$bdd338c80f8962df = {
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("feWch", function(module, exports) {

$parcel$export(module.exports, "TeamType", () => $404e322e3706479c$export$26bc40b960693765);
$parcel$export(module.exports, "Feature", () => $404e322e3706479c$export$6e91cf7616333d5);

const $404e322e3706479c$export$26bc40b960693765 = {
    productManagement: `teamType.${(0, $2b839a8453de5367$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $2b839a8453de5367$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $2b839a8453de5367$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $2b839a8453de5367$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $2b839a8453de5367$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $2b839a8453de5367$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $2b839a8453de5367$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $2b839a8453de5367$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $404e322e3706479c$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint',
    hasSummaryPage: 'feature.hasSummaryPage',
    hasRoadmap: 'feature.hasRoadmap',
    hasList: 'feature.hasList',
    hasCalendar: 'feature.hasCalendar',
    hasCode: 'feature.hasCode',
    hasForms: 'feature.hasForms',
    hasPages: 'feature.hasPages'
};

});


parcelRegister("5shRe", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $443b90c91e3360e2$export$b07ea6a2d29f9c08);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $443b90c91e3360e2$export$b07ea6a2d29f9c08 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("a1b8c", function(module, exports) {

$parcel$export(module.exports, "DESIGN_VARIANTS", () => $4acbe4cfde2344f9$export$a3c4cd8e420f13a);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $4acbe4cfde2344f9$export$a3c4cd8e420f13a = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("mLM2w", function(module, exports) {

$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $cf156d50ed1f640d$export$a25e809b52945082);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $cf156d50ed1f640d$export$a25e809b52945082 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("i5ttL", function(module, exports) {

$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $120d7baa5e5f9d4d$export$916be3c140ae8c0);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $120d7baa5e5f9d4d$export$916be3c140ae8c0 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("e8Fhw", function(module, exports) {

$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $7c6363b0cc97119f$export$7a0daeb069f34de3);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $7c6363b0cc97119f$export$7a0daeb069f34de3 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("fHbA0", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $9fc06aa003a906e0$export$76a143792cc73994);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $9fc06aa003a906e0$export$76a143792cc73994 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("ifDp7", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $e8b95d7a0e5bd991$export$64855550cee11b78);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $e8b95d7a0e5bd991$export$64855550cee11b78 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasSummaryPage,
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasList
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasCalendar
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasCode
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasPages
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse,
                        (0, $feWch.Feature).hasForms
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("7OyjZ", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $a2f5344c5d0d5ba3$export$64855550cee11b78);

var $9ycBx = parcelRequire("9ycBx");

var $eUvg6 = parcelRequire("eUvg6");

var $feWch = parcelRequire("feWch");
const $a2f5344c5d0d5ba3$export$64855550cee11b78 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.TeamType).software,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software,
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $eUvg6.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $feWch.Feature).hasBacklog,
                        (0, $feWch.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});


parcelRegister("7A9H8", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_BUSINESS_CONFIG", () => $e3c54a7acd454a57$export$474323a35aa36586);

var $9ycBx = parcelRequire("9ycBx");

var $feWch = parcelRequire("feWch");
const $e3c54a7acd454a57$export$474323a35aa36586 = {
    [(0, $9ycBx.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $9ycBx.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: -1,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $feWch.TeamType).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $feWch.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});



parcelRegister("STfOf", function(module, exports) {

$parcel$export(module.exports, "syncVisibilityWithLocal", () => $f389d77cde532ebe$export$4aab9a98fc53b894);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3XHRA = parcelRequire("3XHRA");

var $uMSsJ = parcelRequire("uMSsJ");
const $f389d77cde532ebe$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3XHRA.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $uMSsJ.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("6wCHd", function(module, exports) {

$parcel$export(module.exports, "universalDispatch", () => $2ed3eacefc81a47a$export$efe980271ca9cc08);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2ed3eacefc81a47a$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});


parcelRegister("6R6zv", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $59fafcb385977eac$export$d4c72bab9d6cc13a);

var $9ycBx = parcelRequire("9ycBx");
const $59fafcb385977eac$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $9ycBx.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $9ycBx.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $9ycBx.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $9ycBx.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});



const $46da30843a0b64aa$export$fc1565c98db060f9 = 'horizontal-nav-tabs-pages-spotlight-seen';


parcelRegister("IPH39", function(module, exports) {

$parcel$export(module.exports, "getProjectAttributes", () => $d979616f9502497e$export$9757eb2aedd2b2c1);
$parcel$export(module.exports, "useRelativeURLFromLocation", () => $d979616f9502497e$export$62201485b861ba06);
$parcel$export(module.exports, "getOriginAnalyticsAttributes", () => $d979616f9502497e$export$808a85fb729fa3c);

var $1kFb3 = parcelRequire("1kFb3");

var $ln6Iy = parcelRequire("ln6Iy");

var $2IUk2 = parcelRequire("2IUk2");

var $7jTnu = parcelRequire("7jTnu");

var $kfvK2 = parcelRequire("kfvK2");

const $d979616f9502497e$var$getProjectStyleFromPathname = (pathname)=>{
    // Only software projects have different routes for CMP and TMP. Most business routes
    // have 'classic' in the route name even though they're shared between CMP and TMP.
    if (pathname.startsWith((0, $c3f53f2c0d1c3828$export$17f0830375a54058))) return 0, $ln6Iy.COMPANY_MANAGED_PROJECT;
    if (pathname.startsWith((0, $c3f53f2c0d1c3828$export$39f328cd6dea8175))) return 0, $ln6Iy.TEAM_MANAGED_PROJECT;
    return undefined;
};
const $d979616f9502497e$var$getProjectTypeFromPathname = (pathname)=>{
    // Considered using:
    // 1. the route group, but there are some cases where that doesn't work e.g. the 'All work'
    // routes are all part of the 'issue-navigator' group, even though they do differ by project type
    // 2. the route name, but the naming convention is inconsistent between business routes e.g.
    // 'issue-navigator-core', 'classic-business-board'
    if (pathname.startsWith((0, $c3f53f2c0d1c3828$export$39f328cd6dea8175))) return 0, $ln6Iy.SOFTWARE_PROJECT;
    if (pathname.startsWith((0, $c3f53f2c0d1c3828$export$ddc38bc76c37750b))) return 0, $ln6Iy.CORE_PROJECT;
    return undefined;
};
const $d979616f9502497e$export$9757eb2aedd2b2c1 = (pathname)=>{
    return {
        projectStyle: $d979616f9502497e$var$getProjectStyleFromPathname(pathname),
        projectType: $d979616f9502497e$var$getProjectTypeFromPathname(pathname)
    };
};
const $d979616f9502497e$export$62201485b861ba06 = (0, $kfvK2.createRouterSelector)(({ location: location })=>{
    if ((0, $7jTnu.fg)('jira_client_side_error_handled_track_event')) return (0, $2IUk2.getRelativeURLFromLocation)(location);
    return '';
});
const $d979616f9502497e$export$808a85fb729fa3c = (url)=>{
    const origin = (0, $1kFb3.default).fromUrl(url);
    return origin.isEmpty() ? undefined : origin.toAnalyticsAttributes();
};

});
const $c3f53f2c0d1c3828$export$39f328cd6dea8175 = '/jira/software';
const $c3f53f2c0d1c3828$export$ddc38bc76c37750b = '/jira/core';
const $c3f53f2c0d1c3828$export$17f0830375a54058 = '/jira/software/c';


parcelRegister("aDktR", function(module, exports) {

$parcel$export(module.exports, "JIRA_TABS", () => $f9a9cfeea200d768$export$3345ebb003d7978a);

var $eJOHy = parcelRequire("eJOHy");

var $6ozsI = parcelRequire("6ozsI");

var $9AZkB = parcelRequire("9AZkB");

var $foykc = parcelRequire("foykc");

var $8NrV4 = parcelRequire("8NrV4");

var $iBgxn = parcelRequire("iBgxn");

var $9qes7 = parcelRequire("9qes7");

var $ljmsu = parcelRequire("ljmsu");

var $cV8sz = parcelRequire("cV8sz");

var $ka71P = parcelRequire("ka71P");

var $4KX56 = parcelRequire("4KX56");

var $azIHD = parcelRequire("azIHD");

var $aFAJl = parcelRequire("aFAJl");

var $3GKOL = parcelRequire("3GKOL");

var $3tum0 = parcelRequire("3tum0");

var $2PadD = parcelRequire("2PadD");

var $luDPF = parcelRequire("luDPF");

var $cajrN = parcelRequire("cajrN");

var $cdYRp = parcelRequire("cdYRp");

var $6aKac = parcelRequire("6aKac");

var $2gsxL = parcelRequire("2gsxL");

var $1x4MN = parcelRequire("1x4MN");

var $2HwUT = parcelRequire("2HwUT");

var $hUEbu = parcelRequire("hUEbu");

var $aDHzd = parcelRequire("aDHzd");

var $frcEo = parcelRequire("frcEo");

var $duLdC = parcelRequire("duLdC");

var $94MwS = parcelRequire("94MwS");

var $7jTnu = parcelRequire("7jTnu");

var $4ChcF = parcelRequire("4ChcF");

var $lmopN = parcelRequire("lmopN");

var $jOFFC = parcelRequire("jOFFC");

var $550Jy = parcelRequire("550Jy");

var $lLm5t = parcelRequire("lLm5t");

var $03GK2 = parcelRequire("03GK2");

var $erIGa = parcelRequire("erIGa");

var $lwlpq = parcelRequire("lwlpq");

var $4ZLNG = parcelRequire("4ZLNG");

var $ensOY = parcelRequire("ensOY");

var $b4fjO = parcelRequire("b4fjO");

var $g2YRc = parcelRequire("g2YRc");

var $efa8Z = parcelRequire("efa8Z");

var $iIzw7 = parcelRequire("iIzw7");

var $7Kocm = parcelRequire("7Kocm");

var $dfuCU = parcelRequire("dfuCU");

var $gV6s2 = parcelRequire("gV6s2");

var $3s7S6 = parcelRequire("3s7S6");

var $3MiI3 = parcelRequire("3MiI3");

var $rQBpY = parcelRequire("rQBpY");

var $9S8Dr = parcelRequire("9S8Dr");

var $8kn8M = parcelRequire("8kn8M");

var $7YaYY = parcelRequire("7YaYY");

var $g8Ily = parcelRequire("g8Ily");

var $epTsa = parcelRequire("epTsa");

var $3MOoS = parcelRequire("3MOoS");
const $f9a9cfeea200d768$export$3345ebb003d7978a = {
    APP: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($luDPF))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $4ChcF.default),
        description: ()=>(0, $3MOoS.default).appDescription
    },
    APPROVALS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4KX56))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $lmopN.default),
        description: ()=>(0, $3MOoS.default).approvalsDescription
    },
    ARCHIVED_ISSUES: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6ozsI))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $iIzw7.default),
        description: ()=>{
            if ((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3')) {
                if ((0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false)) return (0, $3MOoS.default).archivedIssuesDescriptionIssueTermRefreshGalaxia;
                return (0, $3MOoS.default).archivedIssuesDescriptionIssueTermRefresh;
            }
            return (0, $3MOoS.default).archivedIssuesDescription;
        }
    },
    ATTACHMENTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($azIHD))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $jOFFC.default),
        description: ()=>{
            if ((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3')) {
                if ((0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false)) return (0, $3MOoS.default).attachmentsDescriptionIssueTermRefreshGalaxia;
                return (0, $3MOoS.default).attachmentsDescriptionIssueTermRefresh;
            }
            return (0, $3MOoS.default).attachmentsDescription;
        }
    },
    BACKLOG: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($azIHD))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $550Jy.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).backlogDescriptionGalaxia : (0, $3MOoS.default).backlogDescription
    },
    BOARD: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aFAJl))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $lLm5t.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).boardDescriptionGalaxia : (0, $3MOoS.default).boardDescription
    },
    CALENDAR: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $03GK2.default),
        description: ()=>(0, $3MOoS.default).calendarDescription
    },
    CODE: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ka71P))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $erIGa.default),
        description: ()=>(0, $3MOoS.default).codeDescription
    },
    COMPONENTS: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9AZkB))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $lwlpq.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).componentsDescriptionGalaxia : (0, $3MOoS.default).componentsDescription
    },
    DEPLOYMENTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2PadD))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $4ZLNG.default),
        description: ()=>(0, $3MOoS.default).deploymentsDescription
    },
    DEVELOPMENT: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ka71P))), {
                label: "",
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $ensOY.default),
        description: ()=>(0, $3MOoS.default).developmentDescription
    },
    FORMS: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8NrV4))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $b4fjO.default),
        description: ()=>(0, $3MOoS.default).formsDescription
    },
    GOALS: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, $g8Ily.GoalIcon)
            }),
        Illustration: (0, $g2YRc.default),
        description: ()=>{
            if ((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3')) {
                if ((0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false)) return (0, $3MOoS.default).goalsDescriptionIssueTermRefreshGalaxia;
                return (0, $3MOoS.default).goalsDescriptionIssueTermRefresh;
            }
            return (0, $3MOoS.default).goalsDescription;
        }
    },
    INCIDENTS: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ljmsu))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($duLdC)))
            }),
        Illustration: (0, $efa8Z.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).incidentsDescriptionGalaxia : (0, $3MOoS.default).incidentsDescription
    },
    ISSUES: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cajrN))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $iIzw7.default),
        description: ()=>{
            if ((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3')) {
                if ((0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false)) return (0, $3MOoS.default).issuesDescriptionIssueTermRefreshGalaxia;
                return (0, $3MOoS.default).issuesDescriptionIssueTermRefresh;
            }
            return (0, $3MOoS.default).issuesDescription;
        }
    },
    LIST: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUEbu))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($aDHzd)))
            }),
        Illustration: (0, $7Kocm.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).listDescriptionGalaxia : (0, $3MOoS.default).listDescription
    },
    ON_CALL: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1x4MN))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($94MwS)))
            }),
        Illustration: (0, $dfuCU.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).onCallDescriptionGalaxia : (0, $3MOoS.default).onCallDescription
    },
    PAGES: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cdYRp))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $gV6s2.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).pagesDescriptionGalaxia : (0, $3MOoS.default).pagesDescription
    },
    RELEASES: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aKac))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $3s7S6.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).releasesDescriptionGalaxia : (0, $3MOoS.default).releasesDescription
    },
    REPORTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3tum0))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $3MiI3.default),
        description: ()=>{
            if ((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3')) {
                if ((0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false)) return (0, $3MOoS.default).reportsDescriptionIssueTermRefreshGalaxia;
                return (0, $3MOoS.default).reportsDescriptionIssueTermRefresh;
            }
            return (0, $3MOoS.default).reportsDescription;
        }
    },
    SECURITY: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2HwUT))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $rQBpY.default),
        description: ()=>(0, $3MOoS.default).securityDescription
    },
    SHORTCUTS: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($frcEo)))
            }),
        Illustration: (0, $9S8Dr.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).shortcutsDescriptionGalaxia : (0, $3MOoS.default).shortcutsDescription
    },
    SUMMARY: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iBgxn))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $8kn8M.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).summaryDescriptionNonFinalGalaxia : (0, $3MOoS.default).summaryDescriptionNonFinal
    },
    TIMELINE: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2gsxL))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $7YaYY.default),
        description: ()=>(0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).timelineDescriptionGalaxia : (0, $3MOoS.default).timelineDescription
    },
    INBOX: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($foykc))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $iIzw7.default),
        description: ()=>{
            return (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $3MOoS.default).inboxDescriptionGalaxia : (0, $3MOoS.default).inboxDescription;
        }
    }
};

});
parcelRegister("6ozsI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a807e0481065374$var$_react = $4a807e0481065374$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4a807e0481065374$var$_baseNew = $4a807e0481065374$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4a807e0481065374$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a807e0481065374$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $4a807e0481065374$var$_react.default.createElement($4a807e0481065374$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$4a807e0481065374$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $4a807e0481065374$var$_default = module.exports.default = $4a807e0481065374$var$ArchiveBoxIcon;

});

parcelRegister("9AZkB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b85e957a451f01111d5005fe7bfa754b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fc70cf4e64e329f$var$_react = $6fc70cf4e64e329f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6fc70cf4e64e329f$var$_baseNew = $6fc70cf4e64e329f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6fc70cf4e64e329f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fc70cf4e64e329f$var$ComponentIcon = (props)=>/*#__PURE__*/ $6fc70cf4e64e329f$var$_react.default.createElement($6fc70cf4e64e329f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.75A.75.75 0 0 1 2.75 2h3.5a.75.75 0 0 1 .75.75V4.5h2V2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75V4.5a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zM3.5 4.5h2v-1h-2zm9 0v-1h-2v1zM2 6a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 14 6z" clip-rule="evenodd"/>`
    }, props));
$6fc70cf4e64e329f$var$ComponentIcon.displayName = 'ComponentIcon';
var $6fc70cf4e64e329f$var$_default = module.exports.default = $6fc70cf4e64e329f$var$ComponentIcon;

});

parcelRegister("foykc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81177d596079c24ecbc8bf8bc933664f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b353b914afa5e499$var$_react = $b353b914afa5e499$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b353b914afa5e499$var$_baseNew = $b353b914afa5e499$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b353b914afa5e499$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b353b914afa5e499$var$InboxIcon = (props)=>/*#__PURE__*/ $b353b914afa5e499$var$_react.default.createElement($b353b914afa5e499$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$b353b914afa5e499$var$InboxIcon.displayName = 'InboxIcon';
var $b353b914afa5e499$var$_default = module.exports.default = $b353b914afa5e499$var$InboxIcon;

});

parcelRegister("8NrV4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66788e90e3918302$var$_react = $66788e90e3918302$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66788e90e3918302$var$_baseNew = $66788e90e3918302$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66788e90e3918302$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66788e90e3918302$var$FormIcon = (props)=>/*#__PURE__*/ $66788e90e3918302$var$_react.default.createElement($66788e90e3918302$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$66788e90e3918302$var$FormIcon.displayName = 'FormIcon';
var $66788e90e3918302$var$_default = module.exports.default = $66788e90e3918302$var$FormIcon;

});

parcelRegister("ljmsu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f83ccb209af59fed$var$_react = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f83ccb209af59fed$var$_baseNew = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f83ccb209af59fed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f83ccb209af59fed$var$IncidentIcon = (props)=>/*#__PURE__*/ $f83ccb209af59fed$var$_react.default.createElement($f83ccb209af59fed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$f83ccb209af59fed$var$IncidentIcon.displayName = 'IncidentIcon';
var $f83ccb209af59fed$var$_default = module.exports.default = $f83ccb209af59fed$var$IncidentIcon;

});

parcelRegister("ka71P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::892203c72b828429279b82b0b7182ba7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eada318613fa7d83$var$_react = $eada318613fa7d83$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $eada318613fa7d83$var$_angleBrackets = $eada318613fa7d83$var$_interopRequireDefault((parcelRequire("8lO5P")));

var $eada318613fa7d83$var$_code = $eada318613fa7d83$var$_interopRequireDefault((parcelRequire("8VBAo")));
function $eada318613fa7d83$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "CodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eada318613fa7d83$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $eada318613fa7d83$var$_react.default.createElement($eada318613fa7d83$var$_angleBrackets.default, Object.assign({
        LEGACY_fallbackIcon: $eada318613fa7d83$var$_code.default
    }, props));
$eada318613fa7d83$var$AngleBracketsIcon.Name = 'AngleBracketsIconMigration';
var $eada318613fa7d83$var$_default = module.exports.default = $eada318613fa7d83$var$AngleBracketsIcon;

});
parcelRegister("8VBAo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6800cd63152cf212$var$_react = $6800cd63152cf212$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $6800cd63152cf212$var$_angleBrackets = $6800cd63152cf212$var$_interopRequireDefault((parcelRequire("8lO5P")));
function $6800cd63152cf212$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6800cd63152cf212$var$CodeIcon = (props)=>/*#__PURE__*/ $6800cd63152cf212$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.16 4.06a1 1 0 0 0-1.27.62L8.06 18.73a1 1 0 0 0 1.89.65l4.83-14.04a1 1 0 0 0-.62-1.27m-6.14 8.2-2.58-2.5 2.8-2.72a1 1 0 1 0-1.39-1.44L3.31 9.04a1 1 0 0 0 0 1.44l3.32 3.22a1 1 0 1 0 1.39-1.44m12.22 1.57-3.32-3.22a1 1 0 1 0-1.39 1.44l2.58 2.5-2.8 2.72a1 1 0 1 0 1.39 1.44l3.54-3.43a1 1 0 0 0 0-1.44"/></svg>`
    }, props, {
        newIcon: $6800cd63152cf212$var$_angleBrackets.default
    }));
$6800cd63152cf212$var$CodeIcon.displayName = 'CodeIcon';
var $6800cd63152cf212$var$_default = module.exports.default = $6800cd63152cf212$var$CodeIcon;

});


parcelRegister("4KX56", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0ced1d960d5ffcbbe0ac5a90af7d239>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $376949a32e687f08$var$_react = $376949a32e687f08$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $376949a32e687f08$var$_attachment = $376949a32e687f08$var$_interopRequireDefault((parcelRequire("jjCK0")));

var $376949a32e687f08$var$_attachment2 = $376949a32e687f08$var$_interopRequireDefault((parcelRequire("m7bQa")));
function $376949a32e687f08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AttachmentIcon.
 * This component is AttachmentIcon, with `UNSAFE_fallbackIcon` set to "AttachmentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $376949a32e687f08$var$AttachmentIcon = (props)=>/*#__PURE__*/ $376949a32e687f08$var$_react.default.createElement($376949a32e687f08$var$_attachment.default, Object.assign({
        LEGACY_fallbackIcon: $376949a32e687f08$var$_attachment2.default
    }, props));
$376949a32e687f08$var$AttachmentIcon.Name = 'AttachmentIconMigration';
var $376949a32e687f08$var$_default = module.exports.default = $376949a32e687f08$var$AttachmentIcon;

});
parcelRegister("jjCK0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174ee51c60633f76b0dbf1c968e4afc5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0fdd7d84e8bb8da$var$_react = $e0fdd7d84e8bb8da$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e0fdd7d84e8bb8da$var$_baseNew = $e0fdd7d84e8bb8da$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e0fdd7d84e8bb8da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e0fdd7d84e8bb8da$var$AttachmentIcon = (props)=>/*#__PURE__*/ $e0fdd7d84e8bb8da$var$_react.default.createElement($e0fdd7d84e8bb8da$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.22 8.47 4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.492 3.492 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 0 1-7.06-7.06l4.5-4.5a3.578 3.578 0 0 1 5.06 5.06l-4.5 4.5a2.165 2.165 0 0 1-3.06-3.06"/>`
    }, props));
$e0fdd7d84e8bb8da$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $e0fdd7d84e8bb8da$var$_default = module.exports.default = $e0fdd7d84e8bb8da$var$AttachmentIcon;

});

parcelRegister("m7bQa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0427a1f7bc207ec5$var$_react = $0427a1f7bc207ec5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $0427a1f7bc207ec5$var$_attachment = $0427a1f7bc207ec5$var$_interopRequireDefault((parcelRequire("jjCK0")));
function $0427a1f7bc207ec5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0427a1f7bc207ec5$var$AttachmentIcon = (props)=>/*#__PURE__*/ $0427a1f7bc207ec5$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.643 17.965c-1.53 1.495-4.016 1.496-5.542.004a3.773 3.773 0 0 1 .002-5.412l7.147-6.985a2.316 2.316 0 0 1 3.233-.003c.893.873.895 2.282.004 3.153l-6.703 6.55a.653.653 0 0 1-.914-.008.62.62 0 0 1 0-.902l6.229-6.087a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0l-6.23 6.087a2.5 2.5 0 0 0 0 3.607 2.643 2.643 0 0 0 3.683.009l6.703-6.55a4.074 4.074 0 0 0-.003-5.859 4.306 4.306 0 0 0-6.002.003l-7.148 6.985a5.655 5.655 0 0 0-.001 8.118c2.29 2.239 6.015 2.238 8.31-.005l6.686-6.533a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0z"/></svg>`
    }, props, {
        newIcon: $0427a1f7bc207ec5$var$_attachment.default
    }));
$0427a1f7bc207ec5$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $0427a1f7bc207ec5$var$_default = module.exports.default = $0427a1f7bc207ec5$var$AttachmentIcon;

});


parcelRegister("azIHD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8757186054f9d759a1f776986ffd32d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b2fd95289d8d424$var$_react = $7b2fd95289d8d424$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7b2fd95289d8d424$var$_backlog = $7b2fd95289d8d424$var$_interopRequireDefault((parcelRequire("jtFRs")));

var $7b2fd95289d8d424$var$_backlog2 = $7b2fd95289d8d424$var$_interopRequireDefault((parcelRequire("eKycu")));
function $7b2fd95289d8d424$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BacklogIcon.
 * This component is BacklogIcon, with `UNSAFE_fallbackIcon` set to "BacklogIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b2fd95289d8d424$var$BacklogIcon = (props)=>/*#__PURE__*/ $7b2fd95289d8d424$var$_react.default.createElement($7b2fd95289d8d424$var$_backlog.default, Object.assign({
        LEGACY_fallbackIcon: $7b2fd95289d8d424$var$_backlog2.default
    }, props));
$7b2fd95289d8d424$var$BacklogIcon.Name = 'BacklogIconMigration';
var $7b2fd95289d8d424$var$_default = module.exports.default = $7b2fd95289d8d424$var$BacklogIcon;

});
parcelRegister("jtFRs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2e13280cb3fa5ae$var$_react = $e2e13280cb3fa5ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e2e13280cb3fa5ae$var$_baseNew = $e2e13280cb3fa5ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e2e13280cb3fa5ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2e13280cb3fa5ae$var$BacklogIcon = (props)=>/*#__PURE__*/ $e2e13280cb3fa5ae$var$_react.default.createElement($e2e13280cb3fa5ae$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$e2e13280cb3fa5ae$var$BacklogIcon.displayName = 'BacklogIcon';
var $e2e13280cb3fa5ae$var$_default = module.exports.default = $e2e13280cb3fa5ae$var$BacklogIcon;

});

parcelRegister("eKycu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abcfe41085ed6837$var$_react = $abcfe41085ed6837$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $abcfe41085ed6837$var$_backlog = $abcfe41085ed6837$var$_interopRequireDefault((parcelRequire("jtFRs")));
function $abcfe41085ed6837$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $abcfe41085ed6837$var$BacklogIcon = (props)=>/*#__PURE__*/ $abcfe41085ed6837$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $abcfe41085ed6837$var$_backlog.default
    }));
$abcfe41085ed6837$var$BacklogIcon.displayName = 'BacklogIcon';
var $abcfe41085ed6837$var$_default = module.exports.default = $abcfe41085ed6837$var$BacklogIcon;

});


parcelRegister("aFAJl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6de69f6e8d23d80c647d0a6d3ecd7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c4a399538fc5b54$var$_react = $7c4a399538fc5b54$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7c4a399538fc5b54$var$_board = $7c4a399538fc5b54$var$_interopRequireDefault((parcelRequire("Wdhjx")));

var $7c4a399538fc5b54$var$_board2 = $7c4a399538fc5b54$var$_interopRequireDefault((parcelRequire("g3o8b")));
function $7c4a399538fc5b54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BoardIcon.
 * This component is BoardIcon, with `UNSAFE_fallbackIcon` set to "BoardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c4a399538fc5b54$var$BoardIcon = (props)=>/*#__PURE__*/ $7c4a399538fc5b54$var$_react.default.createElement($7c4a399538fc5b54$var$_board.default, Object.assign({
        LEGACY_fallbackIcon: $7c4a399538fc5b54$var$_board2.default
    }, props));
$7c4a399538fc5b54$var$BoardIcon.Name = 'BoardIconMigration';
var $7c4a399538fc5b54$var$_default = module.exports.default = $7c4a399538fc5b54$var$BoardIcon;

});
parcelRegister("Wdhjx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0aefb7ae3bc1328f$var$_react = $0aefb7ae3bc1328f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0aefb7ae3bc1328f$var$_baseNew = $0aefb7ae3bc1328f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0aefb7ae3bc1328f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0aefb7ae3bc1328f$var$BoardIcon = (props)=>/*#__PURE__*/ $0aefb7ae3bc1328f$var$_react.default.createElement($0aefb7ae3bc1328f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$0aefb7ae3bc1328f$var$BoardIcon.displayName = 'BoardIcon';
var $0aefb7ae3bc1328f$var$_default = module.exports.default = $0aefb7ae3bc1328f$var$BoardIcon;

});

parcelRegister("g3o8b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $baffa5141480bfcd$var$_react = $baffa5141480bfcd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $baffa5141480bfcd$var$_board = $baffa5141480bfcd$var$_interopRequireDefault((parcelRequire("Wdhjx")));
function $baffa5141480bfcd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $baffa5141480bfcd$var$BoardIcon = (props)=>/*#__PURE__*/ $baffa5141480bfcd$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $baffa5141480bfcd$var$_board.default
    }));
$baffa5141480bfcd$var$BoardIcon.displayName = 'BoardIcon';
var $baffa5141480bfcd$var$_default = module.exports.default = $baffa5141480bfcd$var$BoardIcon;

});


parcelRegister("3GKOL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2af99c62070f9b2c$var$_react = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2af99c62070f9b2c$var$_calendar = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("btkTq")));

var $2af99c62070f9b2c$var$_calendar2 = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("76JV8")));
function $2af99c62070f9b2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2af99c62070f9b2c$var$CalendarIcon = (props)=>/*#__PURE__*/ $2af99c62070f9b2c$var$_react.default.createElement($2af99c62070f9b2c$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $2af99c62070f9b2c$var$_calendar2.default
    }, props));
$2af99c62070f9b2c$var$CalendarIcon.Name = 'CalendarIconMigration';
var $2af99c62070f9b2c$var$_default = module.exports.default = $2af99c62070f9b2c$var$CalendarIcon;

});
parcelRegister("btkTq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a29c08b1b7d658$var$_react = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $85a29c08b1b7d658$var$_baseNew = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $85a29c08b1b7d658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a29c08b1b7d658$var$CalendarIcon = (props)=>/*#__PURE__*/ $85a29c08b1b7d658$var$_react.default.createElement($85a29c08b1b7d658$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$85a29c08b1b7d658$var$CalendarIcon.displayName = 'CalendarIcon';
var $85a29c08b1b7d658$var$_default = module.exports.default = $85a29c08b1b7d658$var$CalendarIcon;

});

parcelRegister("76JV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52ccb6d3a2735d8d$var$_react = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $52ccb6d3a2735d8d$var$_calendar = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("btkTq")));
function $52ccb6d3a2735d8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $52ccb6d3a2735d8d$var$CalendarIcon = (props)=>/*#__PURE__*/ $52ccb6d3a2735d8d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $52ccb6d3a2735d8d$var$_calendar.default
    }));
$52ccb6d3a2735d8d$var$CalendarIcon.displayName = 'CalendarIcon';
var $52ccb6d3a2735d8d$var$_default = module.exports.default = $52ccb6d3a2735d8d$var$CalendarIcon;

});


parcelRegister("3tum0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82e1d157ecf30f62ef37497818841c29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $287ba02fe381c5a5$var$_react = $287ba02fe381c5a5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $287ba02fe381c5a5$var$_chartTrend = $287ba02fe381c5a5$var$_interopRequireDefault((parcelRequire("i2pAY")));

var $287ba02fe381c5a5$var$_graphLine = $287ba02fe381c5a5$var$_interopRequireDefault((parcelRequire("5loX9")));
function $287ba02fe381c5a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $287ba02fe381c5a5$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $287ba02fe381c5a5$var$_react.default.createElement($287ba02fe381c5a5$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $287ba02fe381c5a5$var$_graphLine.default
    }, props));
$287ba02fe381c5a5$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $287ba02fe381c5a5$var$_default = module.exports.default = $287ba02fe381c5a5$var$ChartTrendIcon;

});
parcelRegister("5loX9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e42450f7c818f6e$var$_react = $3e42450f7c818f6e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $3e42450f7c818f6e$var$_chartTrend = $3e42450f7c818f6e$var$_interopRequireDefault((parcelRequire("i2pAY")));
function $3e42450f7c818f6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e42450f7c818f6e$var$GraphLineIcon = (props)=>/*#__PURE__*/ $3e42450f7c818f6e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $3e42450f7c818f6e$var$_chartTrend.default
    }));
$3e42450f7c818f6e$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $3e42450f7c818f6e$var$_default = module.exports.default = $3e42450f7c818f6e$var$GraphLineIcon;

});


parcelRegister("2PadD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20e8457987a4b96b$var$_react = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $20e8457987a4b96b$var$_cloudArrowUp = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("bzGVj")));

var $20e8457987a4b96b$var$_upload = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("lmcPJ")));
function $20e8457987a4b96b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20e8457987a4b96b$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $20e8457987a4b96b$var$_react.default.createElement($20e8457987a4b96b$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $20e8457987a4b96b$var$_upload.default
    }, props));
$20e8457987a4b96b$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $20e8457987a4b96b$var$_default = module.exports.default = $20e8457987a4b96b$var$CloudArrowUpIcon;

});
parcelRegister("bzGVj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86d44242ca1c7b8f$var$_react = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $86d44242ca1c7b8f$var$_baseNew = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $86d44242ca1c7b8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86d44242ca1c7b8f$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $86d44242ca1c7b8f$var$_react.default.createElement($86d44242ca1c7b8f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$86d44242ca1c7b8f$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $86d44242ca1c7b8f$var$_default = module.exports.default = $86d44242ca1c7b8f$var$CloudArrowUpIcon;

});

parcelRegister("lmcPJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8c59b79ccf43c2a$var$_react = $f8c59b79ccf43c2a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f8c59b79ccf43c2a$var$_cloudArrowUp = $f8c59b79ccf43c2a$var$_interopRequireDefault((parcelRequire("bzGVj")));
function $f8c59b79ccf43c2a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8c59b79ccf43c2a$var$UploadIcon = (props)=>/*#__PURE__*/ $f8c59b79ccf43c2a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $f8c59b79ccf43c2a$var$_cloudArrowUp.default
    }));
$f8c59b79ccf43c2a$var$UploadIcon.displayName = 'UploadIcon';
var $f8c59b79ccf43c2a$var$_default = module.exports.default = $f8c59b79ccf43c2a$var$UploadIcon;

});


parcelRegister("luDPF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d9c2fe4153711de61c73f11b1bae070a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa5b4c2ffbdf39ba$var$_react = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fa5b4c2ffbdf39ba$var$_decision = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("kXFxs")));

var $fa5b4c2ffbdf39ba$var$_decision2 = $fa5b4c2ffbdf39ba$var$_interopRequireDefault((parcelRequire("fvh9f")));
function $fa5b4c2ffbdf39ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa5b4c2ffbdf39ba$var$DecisionIcon = (props)=>/*#__PURE__*/ $fa5b4c2ffbdf39ba$var$_react.default.createElement($fa5b4c2ffbdf39ba$var$_decision.default, Object.assign({
        LEGACY_fallbackIcon: $fa5b4c2ffbdf39ba$var$_decision2.default
    }, props));
$fa5b4c2ffbdf39ba$var$DecisionIcon.Name = 'DecisionIconMigration';
var $fa5b4c2ffbdf39ba$var$_default = module.exports.default = $fa5b4c2ffbdf39ba$var$DecisionIcon;

});
parcelRegister("kXFxs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4298a06d23defad$var$_react = $f4298a06d23defad$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f4298a06d23defad$var$_baseNew = $f4298a06d23defad$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f4298a06d23defad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4298a06d23defad$var$DecisionIcon = (props)=>/*#__PURE__*/ $f4298a06d23defad$var$_react.default.createElement($f4298a06d23defad$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$f4298a06d23defad$var$DecisionIcon.displayName = 'DecisionIcon';
var $f4298a06d23defad$var$_default = module.exports.default = $f4298a06d23defad$var$DecisionIcon;

});

parcelRegister("fvh9f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4970d82e75d8a32$var$_react = $b4970d82e75d8a32$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $b4970d82e75d8a32$var$_decision = $b4970d82e75d8a32$var$_interopRequireDefault((parcelRequire("kXFxs")));
function $b4970d82e75d8a32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b4970d82e75d8a32$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $b4970d82e75d8a32$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props, {
        newIcon: $b4970d82e75d8a32$var$_decision.default
    }));
$b4970d82e75d8a32$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $b4970d82e75d8a32$var$_default = module.exports.default = $b4970d82e75d8a32$var$EditorDecisionIcon;

});


parcelRegister("cajrN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb8f7b91262d340d7e94aafcc4e8657b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8db581082296795f$var$_react = $8db581082296795f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8db581082296795f$var$_workItems = $8db581082296795f$var$_interopRequireDefault((parcelRequire("9AYOJ")));

var $8db581082296795f$var$_issues = $8db581082296795f$var$_interopRequireDefault((parcelRequire("b5mgb")));
function $8db581082296795f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WorkItemsIcon.
 * This component is WorkItemsIcon, with `UNSAFE_fallbackIcon` set to "IssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8db581082296795f$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $8db581082296795f$var$_react.default.createElement($8db581082296795f$var$_workItems.default, Object.assign({
        LEGACY_fallbackIcon: $8db581082296795f$var$_issues.default
    }, props));
$8db581082296795f$var$WorkItemsIcon.Name = 'WorkItemsIconMigration';
var $8db581082296795f$var$_default = module.exports.default = $8db581082296795f$var$WorkItemsIcon;

});
parcelRegister("9AYOJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa0a7a20e9878c1f12b50feba4970dc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fc6a6e7024121bf$var$_react = $6fc6a6e7024121bf$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6fc6a6e7024121bf$var$_baseNew = $6fc6a6e7024121bf$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6fc6a6e7024121bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fc6a6e7024121bf$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $6fc6a6e7024121bf$var$_react.default.createElement($6fc6a6e7024121bf$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$6fc6a6e7024121bf$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $6fc6a6e7024121bf$var$_default = module.exports.default = $6fc6a6e7024121bf$var$WorkItemsIcon;

});

parcelRegister("b5mgb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81216dbab011b123$var$_react = $81216dbab011b123$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $81216dbab011b123$var$_workItems = $81216dbab011b123$var$_interopRequireDefault((parcelRequire("9AYOJ")));
function $81216dbab011b123$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $81216dbab011b123$var$IssuesIcon = (props)=>/*#__PURE__*/ $81216dbab011b123$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $81216dbab011b123$var$_workItems.default
    }));
$81216dbab011b123$var$IssuesIcon.displayName = 'IssuesIcon';
var $81216dbab011b123$var$_default = module.exports.default = $81216dbab011b123$var$IssuesIcon;

});


parcelRegister("cdYRp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::182e7300aed0f8931ea6d6a6afcdcbad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e65e8889a240d2d$var$_react = $8e65e8889a240d2d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8e65e8889a240d2d$var$_page = $8e65e8889a240d2d$var$_interopRequireDefault((parcelRequire("DtmfJ")));

var $8e65e8889a240d2d$var$_page2 = $8e65e8889a240d2d$var$_interopRequireDefault((parcelRequire("ho2si")));
function $8e65e8889a240d2d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "PageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e65e8889a240d2d$var$PageIcon = (props)=>/*#__PURE__*/ $8e65e8889a240d2d$var$_react.default.createElement($8e65e8889a240d2d$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $8e65e8889a240d2d$var$_page2.default
    }, props));
$8e65e8889a240d2d$var$PageIcon.Name = 'PageIconMigration';
var $8e65e8889a240d2d$var$_default = module.exports.default = $8e65e8889a240d2d$var$PageIcon;

});
parcelRegister("DtmfJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $076a6a80fa08401a$var$_react = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $076a6a80fa08401a$var$_baseNew = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $076a6a80fa08401a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $076a6a80fa08401a$var$PageIcon = (props)=>/*#__PURE__*/ $076a6a80fa08401a$var$_react.default.createElement($076a6a80fa08401a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$076a6a80fa08401a$var$PageIcon.displayName = 'PageIcon';
var $076a6a80fa08401a$var$_default = module.exports.default = $076a6a80fa08401a$var$PageIcon;

});

parcelRegister("ho2si", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca869528f1a19c55$var$_react = $ca869528f1a19c55$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $ca869528f1a19c55$var$_page = $ca869528f1a19c55$var$_interopRequireDefault((parcelRequire("DtmfJ")));
function $ca869528f1a19c55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ca869528f1a19c55$var$PageIcon = (props)=>/*#__PURE__*/ $ca869528f1a19c55$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $ca869528f1a19c55$var$_page.default
    }));
$ca869528f1a19c55$var$PageIcon.displayName = 'PageIcon';
var $ca869528f1a19c55$var$_default = module.exports.default = $ca869528f1a19c55$var$PageIcon;

});


parcelRegister("2gsxL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::478474977414af6f20354d0841ac3249>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a633790993c57f3$var$_react = $1a633790993c57f3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1a633790993c57f3$var$_roadmap = $1a633790993c57f3$var$_interopRequireDefault((parcelRequire("l5gdO")));

var $1a633790993c57f3$var$_roadmap2 = $1a633790993c57f3$var$_interopRequireDefault((parcelRequire("jzOmA")));
function $1a633790993c57f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RoadmapIcon.
 * This component is RoadmapIcon, with `UNSAFE_fallbackIcon` set to "RoadmapIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a633790993c57f3$var$RoadmapIcon = (props)=>/*#__PURE__*/ $1a633790993c57f3$var$_react.default.createElement($1a633790993c57f3$var$_roadmap.default, Object.assign({
        LEGACY_fallbackIcon: $1a633790993c57f3$var$_roadmap2.default
    }, props));
$1a633790993c57f3$var$RoadmapIcon.Name = 'RoadmapIconMigration';
var $1a633790993c57f3$var$_default = module.exports.default = $1a633790993c57f3$var$RoadmapIcon;

});
parcelRegister("jzOmA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4085a500b27a688$var$_react = $e4085a500b27a688$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $e4085a500b27a688$var$_roadmap = $e4085a500b27a688$var$_interopRequireDefault((parcelRequire("l5gdO")));
function $e4085a500b27a688$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e4085a500b27a688$var$RoadmapIcon = (props)=>/*#__PURE__*/ $e4085a500b27a688$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $e4085a500b27a688$var$_roadmap.default
    }));
$e4085a500b27a688$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $e4085a500b27a688$var$_default = module.exports.default = $e4085a500b27a688$var$RoadmapIcon;

});


parcelRegister("1x4MN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54d86c00219aaf0598bf3eec65b605b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11dc95e87d342d6e$var$_react = $11dc95e87d342d6e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $11dc95e87d342d6e$var$_baseNew = $11dc95e87d342d6e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $11dc95e87d342d6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OnCall".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing on-call across Atlassian products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $11dc95e87d342d6e$var$OnCallIcon = (props)=>/*#__PURE__*/ $11dc95e87d342d6e$var$_react.default.createElement($11dc95e87d342d6e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.75A.75.75 0 0 1 .75 2h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L3.29 8.86a12.3 12.3 0 0 0 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 0 2.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM2.56 7.516 4.27 6.09a.25.25 0 0 0 .08-.261L3.684 3.5H1.525A11.4 11.4 0 0 0 2.56 7.516" clip-rule="evenodd"/><path fill="currentcolor" d="M16 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2.5 2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$11dc95e87d342d6e$var$OnCallIcon.displayName = 'OnCallIcon';
var $11dc95e87d342d6e$var$_default = module.exports.default = $11dc95e87d342d6e$var$OnCallIcon;

});

parcelRegister("hUEbu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1fd96c5b3b13ee02dc5743b09d638d98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a6d6643d9986d0$var$_react = $d0a6d6643d9986d0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d0a6d6643d9986d0$var$_baseNew = $d0a6d6643d9986d0$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d0a6d6643d9986d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spreadsheet".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0a6d6643d9986d0$var$SpreadsheetIcon = (props)=>/*#__PURE__*/ $d0a6d6643d9986d0$var$_react.default.createElement($d0a6d6643d9986d0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3.25H5V3.5zm4.5 0v3.75h8V4a.5.5 0 0 0-.5-.5zm8 5.25h-8v3.75H14a.5.5 0 0 0 .5-.5zM5 12.5V8.75H1.5V12a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$d0a6d6643d9986d0$var$SpreadsheetIcon.displayName = 'SpreadsheetIcon';
var $d0a6d6643d9986d0$var$_default = module.exports.default = $d0a6d6643d9986d0$var$SpreadsheetIcon;

});

parcelRegister("aDHzd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bef5760a52e3d3a$var$_react = $7bef5760a52e3d3a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $7bef5760a52e3d3a$var$_listBulleted = $7bef5760a52e3d3a$var$_interopRequireDefault((parcelRequire("hJIkn")));
function $7bef5760a52e3d3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7bef5760a52e3d3a$var$BulletListIcon = (props)=>/*#__PURE__*/ $7bef5760a52e3d3a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $7bef5760a52e3d3a$var$_listBulleted.default
    }));
$7bef5760a52e3d3a$var$BulletListIcon.displayName = 'BulletListIcon';
var $7bef5760a52e3d3a$var$_default = module.exports.default = $7bef5760a52e3d3a$var$BulletListIcon;

});
parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});


parcelRegister("94MwS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01b48cee1f62853b$var$_react = $01b48cee1f62853b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $01b48cee1f62853b$var$_onCall = $01b48cee1f62853b$var$_interopRequireDefault((parcelRequire("1x4MN")));
function $01b48cee1f62853b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01b48cee1f62853b$var$HipchatDialOutIcon = (props)=>/*#__PURE__*/ $01b48cee1f62853b$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7.794 5.364c-1.726 2.133-.611 4.957.266 7.089.416 1.012 1.073 2.025 1.629 2.84.973 1.424 3.189 4.13 5.901 3.722 1.168-.176 2.527-1.555 1.597-2.436l-1.869-1.94s-.523-.436-1.171-.08l-1.048.613s-.428.202-.799-.275c-1.163-1.371-1.995-2.797-2.578-4.496-.227-.663.168-.828.168-.828l.767-.45c.637-.378.524-1.051.524-1.051l-.438-2.738c-.132-.568-.601-.803-1.145-.803-.648 0-1.4.334-1.804.833"/></svg>`
    }, props, {
        newIcon: $01b48cee1f62853b$var$_onCall.default
    }));
$01b48cee1f62853b$var$HipchatDialOutIcon.displayName = 'HipchatDialOutIcon';
var $01b48cee1f62853b$var$_default = module.exports.default = $01b48cee1f62853b$var$HipchatDialOutIcon;

});

parcelRegister("4ChcF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee720eb6951b463$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $hnmz0 = parcelRequire("hnmz0");

var $11OtF = parcelRequire("11OtF");
const $0ee720eb6951b463$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($11OtF)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hnmz0))
});
var $0ee720eb6951b463$export$2e2bcd8739ae039 = $0ee720eb6951b463$var$Illustration;
// for advanced use only
const $0ee720eb6951b463$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("hnmz0", function(module, exports) {
module.exports = new URL("app-preview-dark.692f3794.svg", import.meta.url).toString();

});

parcelRegister("11OtF", function(module, exports) {
module.exports = new URL("app-preview.701bd916.svg", import.meta.url).toString();

});


parcelRegister("lmopN", function(module, exports) {

$parcel$export(module.exports, "default", () => $724fbeda2821ec8b$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $8qNt7 = parcelRequire("8qNt7");

var $dgZBO = parcelRequire("dgZBO");
const $724fbeda2821ec8b$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dgZBO)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8qNt7))
});
var $724fbeda2821ec8b$export$2e2bcd8739ae039 = $724fbeda2821ec8b$var$Illustration;
// for advanced use only
const $724fbeda2821ec8b$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("8qNt7", function(module, exports) {
module.exports = new URL("approvals-preview-dark.6d3cc8df.svg", import.meta.url).toString();

});

parcelRegister("dgZBO", function(module, exports) {
module.exports = new URL("approvals-preview.ce5f015e.svg", import.meta.url).toString();

});


parcelRegister("jOFFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7422bf2cef1b87$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $ihDvd = parcelRequire("ihDvd");

var $i8UiQ = parcelRequire("i8UiQ");
const $cb7422bf2cef1b87$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($i8UiQ)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ihDvd))
});
var $cb7422bf2cef1b87$export$2e2bcd8739ae039 = $cb7422bf2cef1b87$var$Illustration;
// for advanced use only
const $cb7422bf2cef1b87$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("ihDvd", function(module, exports) {
module.exports = new URL("attachments-preview-dark.33a03e0d.svg", import.meta.url).toString();

});

parcelRegister("i8UiQ", function(module, exports) {
module.exports = new URL("attachments-preview.7bdfffc6.svg", import.meta.url).toString();

});


parcelRegister("550Jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff4c9b5254d4671d$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $srBib = parcelRequire("srBib");

var $gARIM = parcelRequire("gARIM");
const $ff4c9b5254d4671d$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gARIM)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($srBib))
});
var $ff4c9b5254d4671d$export$2e2bcd8739ae039 = $ff4c9b5254d4671d$var$Illustration;
// for advanced use only
const $ff4c9b5254d4671d$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("srBib", function(module, exports) {
module.exports = new URL("backlog-preview-dark.d971d34f.svg", import.meta.url).toString();

});

parcelRegister("gARIM", function(module, exports) {
module.exports = new URL("backlog-preview.286ce430.svg", import.meta.url).toString();

});


parcelRegister("lLm5t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9f393d14a272ff4$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $1bhoL = parcelRequire("1bhoL");

var $8hxnd = parcelRequire("8hxnd");
const $c9f393d14a272ff4$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8hxnd)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1bhoL))
});
var $c9f393d14a272ff4$export$2e2bcd8739ae039 = $c9f393d14a272ff4$var$Illustration;
// for advanced use only
const $c9f393d14a272ff4$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("1bhoL", function(module, exports) {
module.exports = new URL("board-preview-dark.ba6ae5d7.svg", import.meta.url).toString();

});

parcelRegister("8hxnd", function(module, exports) {
module.exports = new URL("board-preview.caf8f30f.svg", import.meta.url).toString();

});


parcelRegister("03GK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $904b0af3e47fd375$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $2Dnmq = parcelRequire("2Dnmq");

var $73Eye = parcelRequire("73Eye");
const $904b0af3e47fd375$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($73Eye)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2Dnmq))
});
var $904b0af3e47fd375$export$2e2bcd8739ae039 = $904b0af3e47fd375$var$Illustration;
// for advanced use only
const $904b0af3e47fd375$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2Dnmq", function(module, exports) {
module.exports = new URL("calendar-preview-dark.1428b9c3.svg", import.meta.url).toString();

});

parcelRegister("73Eye", function(module, exports) {
module.exports = new URL("calendar-preview.cff0b145.svg", import.meta.url).toString();

});


parcelRegister("erIGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9627f44e02d5aab$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $hAcb6 = parcelRequire("hAcb6");

var $dWPCA = parcelRequire("dWPCA");
const $e9627f44e02d5aab$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dWPCA)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hAcb6))
});
var $e9627f44e02d5aab$export$2e2bcd8739ae039 = $e9627f44e02d5aab$var$Illustration;
// for advanced use only
const $e9627f44e02d5aab$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("hAcb6", function(module, exports) {
module.exports = new URL("code-preview-dark.6f4d4989.svg", import.meta.url).toString();

});

parcelRegister("dWPCA", function(module, exports) {
module.exports = new URL("code-preview.15cf9a6e.svg", import.meta.url).toString();

});


parcelRegister("lwlpq", function(module, exports) {

$parcel$export(module.exports, "default", () => $57c902e3082fa19d$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $6GjD7 = parcelRequire("6GjD7");

var $6r8Ag = parcelRequire("6r8Ag");
const $57c902e3082fa19d$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6r8Ag)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6GjD7))
});
var $57c902e3082fa19d$export$2e2bcd8739ae039 = $57c902e3082fa19d$var$Illustration;
// for advanced use only
const $57c902e3082fa19d$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("6GjD7", function(module, exports) {
module.exports = new URL("component-preview-dark.ac5aacd0.svg", import.meta.url).toString();

});

parcelRegister("6r8Ag", function(module, exports) {
module.exports = new URL("component-preview.e6bd185f.svg", import.meta.url).toString();

});


parcelRegister("4ZLNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $dadf20b360b572f7$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $jIseR = parcelRequire("jIseR");

var $5YWWc = parcelRequire("5YWWc");
const $dadf20b360b572f7$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5YWWc)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jIseR))
});
var $dadf20b360b572f7$export$2e2bcd8739ae039 = $dadf20b360b572f7$var$Illustration;
// for advanced use only
const $dadf20b360b572f7$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("jIseR", function(module, exports) {
module.exports = new URL("deployments-preview-dark.0cf1d99c.svg", import.meta.url).toString();

});

parcelRegister("5YWWc", function(module, exports) {
module.exports = new URL("deployments-preview.78ac1bac.svg", import.meta.url).toString();

});


parcelRegister("ensOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d748344dbea2c3f0$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $lqGGi = parcelRequire("lqGGi");

var $hKLZM = parcelRequire("hKLZM");
const $d748344dbea2c3f0$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hKLZM)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lqGGi))
});
var $d748344dbea2c3f0$export$2e2bcd8739ae039 = $d748344dbea2c3f0$var$Illustration;
// for advanced use only
const $d748344dbea2c3f0$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("lqGGi", function(module, exports) {
module.exports = new URL("development-preview-dark.d26e9f57.svg", import.meta.url).toString();

});

parcelRegister("hKLZM", function(module, exports) {
module.exports = new URL("development-preview.bf178645.svg", import.meta.url).toString();

});


parcelRegister("b4fjO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c535976011b6700d$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $eumdH = parcelRequire("eumdH");

var $d3jpV = parcelRequire("d3jpV");
const $c535976011b6700d$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($d3jpV)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($eumdH))
});
var $c535976011b6700d$export$2e2bcd8739ae039 = $c535976011b6700d$var$Illustration;
// for advanced use only
const $c535976011b6700d$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("eumdH", function(module, exports) {
module.exports = new URL("forms-preview-dark.430156b1.svg", import.meta.url).toString();

});

parcelRegister("d3jpV", function(module, exports) {
module.exports = new URL("forms-preview.5e482c7a.svg", import.meta.url).toString();

});


parcelRegister("g2YRc", function(module, exports) {

$parcel$export(module.exports, "default", () => $39608f56471ddf18$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $gEGiR = parcelRequire("gEGiR");

var $gbh1Z = parcelRequire("gbh1Z");
const $39608f56471ddf18$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gbh1Z)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gEGiR))
});
var $39608f56471ddf18$export$2e2bcd8739ae039 = $39608f56471ddf18$var$Illustration;
// for advanced use only
const $39608f56471ddf18$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("gEGiR", function(module, exports) {
module.exports = new URL("goals-preview-dark.0421fbf5.svg", import.meta.url).toString();

});

parcelRegister("gbh1Z", function(module, exports) {
module.exports = new URL("goals-preview.8d233f18.svg", import.meta.url).toString();

});


parcelRegister("efa8Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1cffdb2403e372a$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $eHJWt = parcelRequire("eHJWt");

var $9s4ep = parcelRequire("9s4ep");
const $b1cffdb2403e372a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($9s4ep)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($eHJWt))
});
var $b1cffdb2403e372a$export$2e2bcd8739ae039 = $b1cffdb2403e372a$var$Illustration;
// for advanced use only
const $b1cffdb2403e372a$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("eHJWt", function(module, exports) {
module.exports = new URL("incidents-preview-dark.30e9470b.svg", import.meta.url).toString();

});

parcelRegister("9s4ep", function(module, exports) {
module.exports = new URL("incidents-preview.e6af1843.svg", import.meta.url).toString();

});


parcelRegister("iIzw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ad2c12011b0caea$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $hkAh7 = parcelRequire("hkAh7");

var $lqXVW = parcelRequire("lqXVW");
const $7ad2c12011b0caea$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($lqXVW)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hkAh7))
});
var $7ad2c12011b0caea$export$2e2bcd8739ae039 = $7ad2c12011b0caea$var$Illustration;
// for advanced use only
const $7ad2c12011b0caea$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("hkAh7", function(module, exports) {
module.exports = new URL("issues-preview-dark.5cdc89fc.svg", import.meta.url).toString();

});

parcelRegister("lqXVW", function(module, exports) {
module.exports = new URL("issues-preview.c08edc67.svg", import.meta.url).toString();

});


parcelRegister("7Kocm", function(module, exports) {

$parcel$export(module.exports, "default", () => $116f5a58a89a55b6$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $6vtKL = parcelRequire("6vtKL");

var $7vtSS = parcelRequire("7vtSS");
const $116f5a58a89a55b6$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7vtSS)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6vtKL))
});
var $116f5a58a89a55b6$export$2e2bcd8739ae039 = $116f5a58a89a55b6$var$Illustration;
// for advanced use only
const $116f5a58a89a55b6$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("6vtKL", function(module, exports) {
module.exports = new URL("list-preview-dark.e53f1bb5.svg", import.meta.url).toString();

});

parcelRegister("7vtSS", function(module, exports) {
module.exports = new URL("list-preview.9c8441b2.svg", import.meta.url).toString();

});


parcelRegister("dfuCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6e08918365ea7dc$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $hbvR6 = parcelRequire("hbvR6");

var $jnu6S = parcelRequire("jnu6S");
const $d6e08918365ea7dc$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jnu6S)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hbvR6))
});
var $d6e08918365ea7dc$export$2e2bcd8739ae039 = $d6e08918365ea7dc$var$Illustration;
// for advanced use only
const $d6e08918365ea7dc$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("hbvR6", function(module, exports) {
module.exports = new URL("oncall-preview-dark.44c69321.svg", import.meta.url).toString();

});

parcelRegister("jnu6S", function(module, exports) {
module.exports = new URL("oncall-preview.83fb7508.svg", import.meta.url).toString();

});


parcelRegister("gV6s2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c3eb529b3a0b593$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $jnnXa = parcelRequire("jnnXa");

var $c8tht = parcelRequire("c8tht");
const $5c3eb529b3a0b593$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($c8tht)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jnnXa))
});
var $5c3eb529b3a0b593$export$2e2bcd8739ae039 = $5c3eb529b3a0b593$var$Illustration;
// for advanced use only
const $5c3eb529b3a0b593$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("jnnXa", function(module, exports) {
module.exports = new URL("pages-preview-dark.db4817b0.svg", import.meta.url).toString();

});

parcelRegister("c8tht", function(module, exports) {
module.exports = new URL("pages-preview.fb1778e6.svg", import.meta.url).toString();

});


parcelRegister("3s7S6", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fa29ad9b028de1$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $1L5cN = parcelRequire("1L5cN");

var $jkFC2 = parcelRequire("jkFC2");
const $48fa29ad9b028de1$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jkFC2)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1L5cN))
});
var $48fa29ad9b028de1$export$2e2bcd8739ae039 = $48fa29ad9b028de1$var$Illustration;
// for advanced use only
const $48fa29ad9b028de1$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("1L5cN", function(module, exports) {
module.exports = new URL("releases-preview-dark.7aa6179c.svg", import.meta.url).toString();

});

parcelRegister("jkFC2", function(module, exports) {
module.exports = new URL("releases-preview.d6e2b061.svg", import.meta.url).toString();

});


parcelRegister("3MiI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb4d0f4158c09dd$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $1FN5o = parcelRequire("1FN5o");

var $hNN4M = parcelRequire("hNN4M");
const $7cb4d0f4158c09dd$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hNN4M)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1FN5o))
});
var $7cb4d0f4158c09dd$export$2e2bcd8739ae039 = $7cb4d0f4158c09dd$var$Illustration;
// for advanced use only
const $7cb4d0f4158c09dd$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("1FN5o", function(module, exports) {
module.exports = new URL("reports-preview-dark.c0a44511.svg", import.meta.url).toString();

});

parcelRegister("hNN4M", function(module, exports) {
module.exports = new URL("reports-preview.8bb5ca71.svg", import.meta.url).toString();

});


parcelRegister("rQBpY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a8b373a19b22f6d$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $2i2uT = parcelRequire("2i2uT");

var $36OSb = parcelRequire("36OSb");
const $1a8b373a19b22f6d$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($36OSb)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2i2uT))
});
var $1a8b373a19b22f6d$export$2e2bcd8739ae039 = $1a8b373a19b22f6d$var$Illustration;
// for advanced use only
const $1a8b373a19b22f6d$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("2i2uT", function(module, exports) {
module.exports = new URL("security-preview-dark.fe257a0b.svg", import.meta.url).toString();

});

parcelRegister("36OSb", function(module, exports) {
module.exports = new URL("security-preview.5dc5fb3a.svg", import.meta.url).toString();

});


parcelRegister("9S8Dr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dafa501d6ee8a28$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $D5GdN = parcelRequire("D5GdN");

var $6frck = parcelRequire("6frck");
const $7dafa501d6ee8a28$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6frck)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($D5GdN))
});
var $7dafa501d6ee8a28$export$2e2bcd8739ae039 = $7dafa501d6ee8a28$var$Illustration;
// for advanced use only
const $7dafa501d6ee8a28$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("D5GdN", function(module, exports) {
module.exports = new URL("shortcuts-preview-dark.ee547f9e.svg", import.meta.url).toString();

});

parcelRegister("6frck", function(module, exports) {
module.exports = new URL("shortcuts-preview.8780e9d0.svg", import.meta.url).toString();

});


parcelRegister("8kn8M", function(module, exports) {

$parcel$export(module.exports, "default", () => $02faf7b3696d48c6$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $iktcn = parcelRequire("iktcn");

var $iGTit = parcelRequire("iGTit");
const $02faf7b3696d48c6$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($iGTit)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($iktcn))
});
var $02faf7b3696d48c6$export$2e2bcd8739ae039 = $02faf7b3696d48c6$var$Illustration;
// for advanced use only
const $02faf7b3696d48c6$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("iktcn", function(module, exports) {
module.exports = new URL("summary-preview-dark.32dd4d90.svg", import.meta.url).toString();

});

parcelRegister("iGTit", function(module, exports) {
module.exports = new URL("summary-preview.10045d4f.svg", import.meta.url).toString();

});


parcelRegister("7YaYY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb06301ecee5184$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $19Wxu = parcelRequire("19Wxu");

var $47nb5 = parcelRequire("47nb5");
const $6cb06301ecee5184$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($47nb5)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($19Wxu))
});
var $6cb06301ecee5184$export$2e2bcd8739ae039 = $6cb06301ecee5184$var$Illustration;
// for advanced use only
const $6cb06301ecee5184$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("19Wxu", function(module, exports) {
module.exports = new URL("timeline-preview-dark.a8fbe72d.svg", import.meta.url).toString();

});

parcelRegister("47nb5", function(module, exports) {
module.exports = new URL("timeline-preview.cf56bfbb.svg", import.meta.url).toString();

});


parcelRegister("g8Ily", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $dac0b75155a35706$export$134cbcd70c6693b8);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $lRq8t = parcelRequire("lRq8t");

var $c5IQC = parcelRequire("c5IQC");
const $dac0b75155a35706$var$getGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $dac0b75155a35706$export$134cbcd70c6693b8 = ({ size: size, primaryColor: primaryColor })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $dac0b75155a35706$var$getGlyph,
        size: size,
        label: formatMessage((0, $c5IQC.default).goalIconLabel),
        primaryColor: primaryColor
    });
};

});
parcelRegister("c5IQC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2d917337cffaaf2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a2d917337cffaaf2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    goalIconLabel: {
        "id": "spa-apps-sidebar-common.goal-icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("3MOoS", function(module, exports) {

$parcel$export(module.exports, "default", () => $81491507fdf92bae$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $81491507fdf92bae$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    approvalsDescription: {
        "id": "horizontal-nav-add-tab-details.approvals-description",
        "defaultMessage": "Add approvals into your workflow to save you time following up."
    },
    attachmentsDescription: {
        "id": "horizontal-nav-add-tab-details.attachments-description",
        "defaultMessage": "View attachments that have been added to issues within your project."
    },
    archivedIssuesDescription: {
        "id": "horizontal-nav-add-tab-details.archived-issues-description",
        "defaultMessage": "View all the issues archived in your project here."
    },
    attachmentsDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.attachments-description-issue-term-refresh",
        "defaultMessage": "View attachments that have been added to work items within your project."
    },
    archivedIssuesDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.archived-issues-description-issue-term-refresh",
        "defaultMessage": "View all the work items archived in your project here."
    },
    issuesDescription: {
        "id": "horizontal-nav-add-tab-details.issues-description",
        "defaultMessage": "View all the issues in your project. Use built-in filters and text search to find issues."
    },
    backlogDescription: {
        "id": "horizontal-nav-add-tab-details.backlog-description",
        "defaultMessage": "Plan and prioritize your team's work in a dedicated space."
    },
    reportsDescription: {
        "id": "horizontal-nav-add-tab-details.reports-description",
        "defaultMessage": "View statistics for people, projects, versions, or information about issues."
    },
    securityDescription: {
        "id": "horizontal-nav-add-tab-details.security-description",
        "defaultMessage": "Connect security tools to triage and track vulnerabilities in Jira."
    },
    boardDescription: {
        "id": "horizontal-nav-add-tab-details.board-description",
        "defaultMessage": "Get a snapshot of the status of your team's work and easily drag your cards through a workflow."
    },
    codeDescription: {
        "id": "horizontal-nav-add-tab-details.code-description",
        "defaultMessage": "Connect Bitbucket, GitHub and other development tools to link your team's repositories to Jira."
    },
    componentsDescription: {
        "id": "horizontal-nav-add-tab-details.components-description",
        "defaultMessage": "Use components to create subsections of a project."
    },
    deploymentsDescription: {
        "id": "horizontal-nav-add-tab-details.deployments-description",
        "defaultMessage": "Easily manage and track deployments for a seamless software delivery experience."
    },
    developmentDescription: {
        "id": "horizontal-nav-add-tab-details.development-description",
        "defaultMessage": "Discover key technical insights and work suggestions for your software development journey in one place."
    },
    goalsDescription: {
        "id": "horizontal-nav-add-tab-details.goals-description",
        "defaultMessage": "View issues that are linked to goals in this project."
    },
    incidentsDescription: {
        "id": "horizontal-nav-add-tab-details.incidents-description",
        "defaultMessage": "Triage incidents and track PIR actions in your project by connecting incident management tools."
    },
    releasesDescription: {
        "id": "horizontal-nav-add-tab-details.releases-description",
        "defaultMessage": "Versions help you package and schedule project deliveries."
    },
    requestsDescription: {
        "id": "horizontal-nav-add-tab-details.requests-description",
        "defaultMessage": "Manage, prioritize, and track requests, and connect them to this project."
    },
    timelineDescription: {
        "id": "horizontal-nav-add-tab-details.timeline-description",
        "defaultMessage": "Plan and manage your project dependencies on a timeline and see when things are landing."
    },
    onCallDescription: {
        "id": "horizontal-nav-add-tab-details.on-call-description",
        "defaultMessage": "View on-call schedules in your project. Requires Opsgenie by Atlassian."
    },
    calendarDescription: {
        "id": "horizontal-nav-add-tab-details.calendar-description",
        "defaultMessage": "See when work is due and get a quick glance at what the next month looks like."
    },
    shortcutsDescription: {
        "id": "horizontal-nav-add-tab-details.shortcuts-description",
        "defaultMessage": "Add easily accessible links for your team to access from your project."
    },
    pagesDescription: {
        "id": "horizontal-nav-add-tab-details.pages-description",
        "defaultMessage": "Create and manage Confluence pages in your project."
    },
    listDescription: {
        "id": "horizontal-nav-add-tab-details.list-description",
        "defaultMessage": "Get a list of your project's work in spreadsheet-like table."
    },
    appDescription: {
        "id": "horizontal-nav-add-tab-details.app-description",
        "defaultMessage": "Supercharge your project by integrating third-party apps."
    },
    formsDescription: {
        "id": "horizontal-nav-add-tab-details.forms-description",
        "defaultMessage": "Collect information for your team with forms."
    },
    summaryDescriptionNonFinal: {
        "id": "horizontal-nav-add-tab-details.summary-description-non-final",
        "defaultMessage": "Get an overview of work progress, priorities, workload distribution, and other projects."
    },
    issuesDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.issues-description-issue-term-refresh",
        "defaultMessage": "View all the work items in your project. Use built-in filters and text search to find work items."
    },
    reportsDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.reports-description-issue-term-refresh",
        "defaultMessage": "View statistics for people, projects, versions, or information about work items."
    },
    goalsDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.goals-description-issue-term-refresh",
        "defaultMessage": "View work items that are linked to goals in this project."
    },
    inboxDescription: {
        "id": "horizontal-nav.inbox-description",
        "defaultMessage": "Enable customer service teams to forward work items to this project. Teams will see this project in their forwarding options and can forward work directly to your inbox."
    },
    attachmentsDescriptionIssueTermRefreshGalaxia: {
        "id": "horizontal-nav-add-tab-details.attachments-description-issue-term-refresh-galaxia",
        "defaultMessage": "View attachments that have been added to work items within your space."
    },
    archivedIssuesDescriptionIssueTermRefreshGalaxia: {
        "id": "horizontal-nav-add-tab-details.archived-issues-description-issue-term-refresh-galaxia",
        "defaultMessage": "View all the work items archived in your space here."
    },
    backlogDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.backlog-description-galaxia",
        "defaultMessage": "View statistics for people, spaces, versions, or information about issues."
    },
    boardDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.board-description-galaxia",
        "defaultMessage": "Use components to create subsections of a space."
    },
    incidentsDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.incidents-description-galaxia",
        "defaultMessage": "Triage incidents and track PIR actions in your space by connecting incident management tools."
    },
    releasesDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.releases-description-galaxia",
        "defaultMessage": "Versions help you package and schedule space deliveries."
    },
    requestsDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.requests-description-galaxia",
        "defaultMessage": "Manage, prioritize, and track requests, and connect them to this space."
    },
    timelineDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.timeline-description-galaxia",
        "defaultMessage": "Plan and manage your space dependencies on a timeline and see when things are landing."
    },
    onCallDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.on-call-description-galaxia",
        "defaultMessage": "View on-call schedules in your space. Requires Opsgenie by Atlassian."
    },
    shortcutsDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.shortcuts-description-galaxia",
        "defaultMessage": "Add easily accessible links for your team to access from your space."
    },
    pagesDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.pages-description-galaxia",
        "defaultMessage": "Create and manage Confluence pages in your space."
    },
    componentsDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.components-description-galaxia",
        "defaultMessage": "Get a list of your team's work in spreadsheet-like table."
    },
    listDescriptionGalaxia: {
        "id": "horizontal-nav-add-tab-details.list-description-galaxia",
        "defaultMessage": "Supercharge your space by integrating third-party apps."
    },
    summaryDescriptionNonFinalGalaxia: {
        "id": "horizontal-nav-add-tab-details.summary-description-non-final-galaxia",
        "defaultMessage": "Get an overview of work progress, priorities, workload distribution, and other spaces."
    },
    issuesDescriptionIssueTermRefreshGalaxia: {
        "id": "horizontal-nav-add-tab-details.issues-description-issue-term-refresh-galaxia",
        "defaultMessage": "View all the work items in your space. Use built-in filters and text search to find work items."
    },
    reportsDescriptionIssueTermRefreshGalaxia: {
        "id": "horizontal-nav-add-tab-details.reports-description-issue-term-refresh-galaxia",
        "defaultMessage": "View statistics for people, spaces, versions, or information about work items."
    },
    goalsDescriptionIssueTermRefreshGalaxia: {
        "id": "horizontal-nav-add-tab-details.goals-description-issue-term-refresh-galaxia",
        "defaultMessage": "View work items that are linked to goals in this space."
    },
    inboxDescriptionGalaxia: {
        "id": "horizontal-nav.inbox-description-galaxia",
        "defaultMessage": "Enable customer service teams to forward work items to this space. Teams will see this space in their forwarding options and can forward work directly to your inbox."
    }
});

});






//# sourceMappingURL=async-jira-horizontal-nav-entrypoint.10daf2b8.js.map
